var App = App || {};

const MATCH = 1;
const MATCH_PARTIAL = 2;
const MATCH_CHILD = 3;
const MATCH_MASS = 3;

const SEARCH_TYPING = 1;
const SEARCH_STARTED = 2;
const INVALIDATE = 3;
const ORDER_CHANGE = 4;
const DATA_UPDATE = 5;
const REGULAR_TERMS_CHECK = 6;
const PAGINAL = 7;
const CHANGE_VIEW = 8;

const SHOW_ALL = 0;
const SHOW_UNDONE = 1;
const SHOW_DONE = 2;

const CARD_BACKLOG = 0;
const CARD_DONE = 1;
const CARD_SOMETIME = 6;

const PRIOR0_HTML = '<ws-icon name="timer-pause"></ws-icon>';

const WIN_ST_OPENING = 'opening';
const WIN_ST_LOADING = 'loading';
const WIN_ST_LOAD_FAILED = 'load-failed';
const WIN_ST_LOADED = 'loaded';
const WIN_ST_UNLOADED = 'unloaded';
const WIN_ST_OPENED = 'opened';
const WIN_ST_CLOSING = 'closing';
const WIN_ST_MINIMIZING = 'minimizing';
const WIN_ST_CLOSED = 'closed';
const WIN_ST_ALREADY_OPENED = 'already-opened';
const WIN_ST_READY = 'ready';
const WIN_ST_UNREADY = 'unready';

const MUTE_1H = 60;
const MUTE_2H = 120;
const MUTE_OFF = 0;
const MUTE_UNTIL_TOMORROW = -1;
const MUTE_FOREVER = -99;

const NO_ASSIGNEE = 1;
const ANYONE = 2;

App.config = {
	upload_chunk_size: 10 * 1024 * 1024,
	upload_max_size: 400 * 1024 * 1024,
	upload_max_default: 100 * 1024 * 1024,
	archive_max_size: 30 * 1024 * 1024,
	title_event_count: false,
	ajax_html_divider: '#WS_TD_SPLIT#',
	ajax_html_error: 'ERROR',
	applause: {cnt: 3, tm0: 38, tm1: 675, tm2: 450},
	money_round: 2,
	loader_html: '<span class="loader_sm loadingimg"></span>',
	language: 2,
	real_user_id: 11,
	minimal_user_id: 2,
	date_launch_account: 0,
	date_launch_server: 0,
	date_sync_time: 0,
	date_sync_timestamp: 0,
	date_sync_offset: 0,
	date_timezone_offset: 0,
	date_timestamp_offset: 0,
	date_offset_user_hrs: 0,
	 day_end: 86400,
	day_start: 0,
	is_24h: true,
	time_separ: true,
	hotkeys: true,
	sound: true,
	websockets: false,
	reverse_user_names: false,
	id_project_inbox: 0,
	reverse_comments: false
}

// @see PageController.onlogout()
App.current_page = {
	class: '',
	where: '',
	page: '',
	subpage: '',
	project: 0,
	onload: '',
	js_load: []
}

App.me = {
	id: 0,
	email: '',
	debug: false,
	console: false,
}
App.team = {} // filled by page.phtml
App.team_groups = {}
App.team_special = {} // filled by page.phtml
App.team_exposed = {} // filled by page.phtml
App.projects = {} // filled by sidebar_projects
App.task_names = {} // filled on page / object_state.task
App.projects_order = null; // filled by sidebar_projects
App.custom_fields = {
	fields: {},
	types: {},
	INST_TASK: 0,
	INST_PROJECT: 1,
	is_task_inst(field) { return field.id_inst === App.custom_fields.INST_TASK; },
	is_project_inst(field) { return field.id_inst === App.custom_fields.INST_PROJECT; },
	type(id) { return App.custom_fields.types[id] ?? { icon: 'none', input: 'text', attributes: {} }; },
	is_task_value_key(key, id_task) { return key.startsWith(App.custom_fields.INST_TASK + ':' + id_task + ':'); },
};

App.state = {};

App.colors = {
	styles: null,
	css_var: function (variable) {
		if (!App.colors.styles) App.colors.styles = getComputedStyle(document.body);
		return App.colors.styles.getPropertyValue(variable);
	},
	add_alpha: function (color, opacity) {
		// coerce values so ti is between 0 and 1.
		let _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
		return color + _opacity.toString(16).toUpperCase();
	},
	add_alpha_rgba: function (color, opacity) {
		color = color.trim();

		const isHex = color.startsWith("#");
		const isRgb = color.startsWith("rgb");

		let rgbaValue = "";
		if (isHex) {
			const hexValue = color.slice(1);
			const rgbValue = hexValue.length === 3 ? hexValue.split('').map(c => parseInt(c + c, 16)) : hexValue.match(/.{2}/g).map(c => parseInt(c, 16));
			rgbaValue = `rgba(${rgbValue[0]}, ${rgbValue[1]}, ${rgbValue[2]}, ${opacity})`;
		} else if (isRgb) {
			const rgbValue = color.slice(4, -1).split(",");
			rgbaValue = `rgba(${rgbValue[0]}, ${rgbValue[1]}, ${rgbValue[2]}, ${opacity})`;
		}
		console.log(color + ' ' + rgbaValue + ' ' + isHex?'hex':'rgb');
		return rgbaValue;
	},
	adjust: function (color, amount) {
		return '#' + color.replace(/\s*/, '').replace(/^#/, '').replace(/../g, color => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
	}
}

App.keycode = {
	is_arrows: function (code) {
		return this.ArrowUp === code || this.ArrowRight === code || this.ArrowDown === code || this.ArrowLeft === code;
	},
	Backspace: 8,
	Tab: 9,
	Enter: 13,
	ShiftLeft: 16,
	ShiftRight: 16,
	ControlLeft: 17,
	ControlRight: 17,
	AltLeft: 18,
	AltRight: 18,
	Pause: 19,
	CapsLock: 20,
	Escape: 27,
	Space: 32,
	PageUp: 33,
	PageDown: 34,
	End: 35,
	Home: 36,
	ArrowLeft: 37,
	ArrowUp: 38,
	ArrowRight: 39,
	ArrowDown: 40,
	PrintScreen: 44,
	Insert: 45,
	Delete: 46,
	Digit0: 48,
	Digit1: 49,
	Digit2: 50,
	Digit3: 51,
	Digit4: 52,
	Digit5: 53,
	Digit6: 54,
	Digit7: 55,
	Digit8: 56,
	Digit9: 57,
	KeyA: 65,
	KeyB: 66,
	KeyC: 67,
	KeyD: 68,
	KeyE: 69,
	KeyF: 70,
	KeyG: 71,
	KeyH: 72,
	KeyI: 73,
	KeyJ: 74,
	KeyK: 75,
	KeyL: 76,
	KeyM: 77,
	KeyAltM: 192,
	KeyN: 78,
	KeyO: 79,
	KeyP: 80,
	KeyQ: 81,
	KeyR: 82,
	KeyS: 83,
	KeyT: 84,
	KeyU: 85,
	KeyV: 86,
	KeyW: 87,
	KeyX: 88,
	KeyY: 89,
	KeyZ: 90,
	MetaLeft: 91,
	MetaRight: 92,
	ContextMenu: 93,
	Numpad0: 96,
	Numpad1: 97,
	Numpad2: 98,
	Numpad3: 99,
	Numpad4: 100,
	Numpad5: 101,
	Numpad6: 102,
	Numpad7: 103,
	Numpad8: 104,
	Numpad9: 105,
	NumpadMultiply: 106,
	NumpadAdd: 107,
	NumpadSubtract: 109,
	NumpadDecimal: 110,
	NumpadDivide: 111,
	F1: 112,
	F2: 113,
	F3: 114,
	F4: 115,
	F5: 116,
	F6: 117,
	F7: 118,
	F8: 119,
	F9: 120,
	F10: 121,
	F11: 122,
	F12: 123,
	NumLock: 144,
	ScrollLock: 145,
	Semicolon: 186,
	SemicolonAlt: 59,
	Equal: 187,
	Comma: 188,
	Minus: 189,
	Period: 190,
	Slash: 191,
	Backquote: 192,
	BracketLeft: 219,
	Backslash: 220,
	BracketRight: 221,
	Quote: 222,
	Ampersand: 50,
	Dash: 51,

  // TODO: find on big keyboard

	SomeAdd: 43,
	SomeMultiply: 42,
	SomeDivide: 47,

}
App.collapse = {
	CUSTOM_SIDEBAR: 1
}

;var App = App || {};

(function () {
	let self = App.actions = {
		default_hash: '',
		timer_hash: '',
		action_hashes: {},
		scopes: {},

		register: function (action_hashes, scope) {
			scope ||= 'page'; // for future cleanup
			self.scopes[scope] ||= new Set();
			for (let i in action_hashes) {
				self.scopes[scope].add(i);
				self.action_hashes[i] = action_hashes[i];
			}
		},

		unregister: function (scope) {
			if (scope in self.scopes) {
				self.scopes[scope].forEach((action) => delete (self.action_hashes[action]));
				delete (self.scopes[scope]);
			}
		},

		get: function (action) {
			if (action in self.action_hashes) return self.action_hashes[action];
			if (self.except_list.some(a => a === action)) return 'action=' + action;

			// old engine fallback below

			if (self.timer_hash && action.indexOf('timer') !== -1) {
				return 'action=' + action + '&mda=' + self.timer_hash;
			}

			if (self.default_hash) {
				for (let i=0; i < self.def_list.length; i++) {
					if (action.indexOf(self.def_list[i]) !== -1) return 'action=' + action + '&mda=' + self.default_hash;
				}
			}

			App.core.error('actions', new Error('Unregistered action: ' + action));
			return 'action=' + action + '&mda=problem';
		},

		get_mda: function (action) {
			const action_hash = (App.actions.action_hashes[action] || '');
			const parsed = action_hash.split('&')
				.map(i => i.split('='))
				.reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});

			return parsed.mda || 'problem';
		},

		except_list: [
			'process:log_js','process:ping',
		],

		def_list: [
			'clipboard:show',
			'calendar_drag:do',
			'comment_fav:do',
			'comment_show_hide:do',
			'contact_edit_email:show',
			'contact_edit_group:apply',
			'user_edit_grid_team:apply',
			'user_edit_grid_department:apply',
			'user_grid_department_items:show',
			'contact_view:show',
			'log_delete:show',
			'process:collapse',
			'process:collapse_all',
			'process:collapse_applause',
			'process:noblur',
			'process:toggle',
			'process:save_lang',
			'process:help_status',
			'project_drag:do',
			'project_bookmark_drag:do',
			'project_folder_drag:do',
			'project_menu:show',
			'chat_menu:show',
			'project_edit_color:do',
			'chat_edit_color:do',
			'desktop_notifications:error',
			'desktop_notifications:register',
			'desktop_notifications:unregister',
			'menu_events_count:show',
			'menu_events:show',
			'menu_events:seen',
			'menu_search_content:show',
			'info_hotkey:show',
			'task_com_filt:do',
			'task_like:apply',
			'task_subscribe:do',
			'task_unsubscribe:do',
			'task_menu:show',
			'task_move_to:step2',
			'task_edit_stage:apply',
			'task_edit_user:apply',
			'telegram_register_verify:do',
			'viber_register_verify:do',
			'messenger_register_verify:do',
			'todo_done:do',
			'user_card:show',
			'search',
			'reload',
			'labels_reload',
			'presave',
			'expand',
			'check',
			'prolong',
			'upload'
		]
	}
})();

;var App = App || {};

(function() {
	let self = App.admin_menu = {

		obj_window: null,
		available: true,
		prev_page: '',
		no_effects: false,

		show_menu: function (anchor, options) {
			options ||= {};
			const url = App.helper.url.add_query(
				App.helper.endpoint.primary(),
				App.actions.get('sidebar_config_menu:show'),
			);
			App.menu.show({
				...options,
				anchor,
				url
			});
		},

		hide_mobile: function() {
			$('body').removeClass('mobileAdminMenu');
		},

		toggle: function(is_on, save) {
			if ($(window).width() <= MOBILE_SCREEN_THRESHOLD) {
				if (typeof is_on === 'undefined' || is_on === null) return;
				$('body').removeClass('withAdminMenu');
				$('body').toggleClass('mobileAdminMenu', is_on);
				if (is_on && App.task_view.is_shown()) App.task_view.hide();
				if (is_on && App.right_panel.is_shown()) App.right_panel.hide();
			} else {
				$('body').removeClass('mobileAdminMenu');
				$('body').toggleClass('withAdminMenu', is_on);
			}
		},
		leave: function(el) {
			let url = '/';
			if (self.prev_page && !self.prev_page.includes('/account/')) {
				url = self.prev_page;
			}
			$(el).addClass('selected');
			App.core.goto(url);
		},

		set_active_menu_item: function(url) {
			let o = $('.sidebar__menu__item');
			o.each(function() {
				$(this).toggleClass('sidebar__menu__item-active', url.indexOf($(this).attr('href')) === 0).removeClass('selected');
			});
		},

		update_visibility: function() {
			let is_available = App.current_page.page === 'account' && self.available;
			self.toggle(self.is_shown() && is_available);
		},

		update_sidebar: function(callback) {
			self.load_sidebar('sidebar_config:show', callback);
		},
		reload: function(callback) {
			self.obj_window = null;
			self.no_effects = true;
			self.load_sidebar('sidebar_config:show', callback);
		},
		load_sidebar: function(action, callback) {
			if (self.obj_window) {
				self.obj_window.detach();
				$('#adminMenu__wrapper').append(self.obj_window);
				self.set_active_menu_item(App.current_page.url ?? document.location.pathname);
				if (!$('#adminMenu').hasClass('sidebar-loaded')) {
					setTimeout(function () {
						$('#adminMenu').addClass('sidebar-loaded');
					});
				}
				if (callback) callback();
			} else {
				$.ajax({
					url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get(action)),
					success: function (html) {
						$('#adminMenu__wrapper').html(html);
						self.obj_window = $('#adminMenu');
						if (self.no_effects) {
							$('#adminMenu').addClass('sidebar-loaded');
							self.no_effects = false;
						} else {
							setTimeout(function () {
								$('#adminMenu').addClass('sidebar-loaded');
							});
						}
						self.set_active_menu_item(App.current_page.url ?? document.location.pathname);
						if (callback) callback();
					}
				});
			}

			self.helper.clear_on_load();
		},

		init: function() {
			if (!$('#adminMenu__wrapper').length) return;

			$('#adminMenuOverlay').click(function() {
				self.toggle(false);
			});
		},

		onload: function() {
			if (!App.me.id) return;
			if (!$('#adminMenu__wrapper').length) return;
			if (App.current_page.page !== 'account') {
				self.prev_page = App.current_page.url ?? '';
				return;
			}

			self.set_active_menu_item(App.current_page.url ?? document.location.pathname);
			self.update_sidebar();
		},

		onresize: function () {
			self.update_visibility();
		},

		is_shown: function() {
			if ($(window).width() <= MOBILE_SCREEN_THRESHOLD) {
				return $('body').hasClass('mobileAdminMenu');
			} else {
				return true;
			}
		},

		destructor: function() {
			if (self.obj_window) {
				self.obj_window.remove();
				self.obj_window = null;
			}
			self.prev_page = '';
			$('body').removeClass('withAdminMenu mobileAdminMenu');
		},
		helper: {
			clear_on_load: function () {
				$('.adminMenu__wrapper .selected').removeClass('selected');
			}
		},

		onLogin: function () {
			self.init();
			App.bus.window.on('resize', App.helper.just_throttle(self.onresize));
		},
		onLogout: function () {
			self.destructor();
		},
		onLoadPage: function () {
			self.onload();
		}
	};
})();

;var App = App || {};

App.anchor = {

	scroll_to: function (hash, el) {
		if (typeof hash == 'string' && !App.helper.validate.url_hash.test(hash)) return false;
		let target = $(hash);
		let view = { block: 'start', inline: 'nearest' };
		let comment_match = hash.match(/^#(com|after|obj-comment)(\d+)$/);
		let log_match = hash.match(/^#(log|obj-log)(\d+)$/);
		if (comment_match) {
			if (parseInt(comment_match[2]) === 0) target = $('#taskView__wrapper .commentList'); else {
				target = $('#obj-comment' + comment_match[2]);
				if (target.length) {

					if (target.is(':last-child')) {
						view.block = view.inline = 'end';
					} else {
						view.block = view.inline = 'center';
					}

					if (comment_match[1] === 'com' || comment_match[1] === 'obj-comment') {
						App.comments.set_active_comment(target);
					} else if (comment_match[1] === 'after') {
						target = target.next();
					}
				} else hash = '#last';
			}
		}
		if (log_match) {
			if (parseInt(log_match[2]) === 0) target = $('#taskView__wrapper .commentList'); else {
				target = $('#obj-log' + log_match[2]);
				if (target.length) {

					if (target.is(':last-child')) {
						view.block = view.inline = 'end';
					} else {
						view.block = view.inline = 'center';
					}

					if (log_match[1] === 'log' || log_match[1] === 'obj-log') {
						App.comments.set_active_comment(target);
					} else if (log_match[1] === 'after') {
						target = target.next();
					}
				} else hash = '#last';
			}
		}
		if (hash === '#last') {
			target = $('#taskView__wrapper .comment_unseen_line');
			if (target.length === 0) target = $('#taskView__wrapper .bottomAnchor');
			else view.block = 'center';
		}
		if (hash === '#subtasks') {
			target = $('#taskView__wrapper .taskView__subtasks');
		}
		if (hash === '#comments') {
			target = $('#taskView__wrapper .commentListPanel__wrapper');
		}
		if (!target.length) target = $('[name=' + hash.slice(1).replace(/[^a-zA-Z01-9_]+/g, '') + ']');
		if (target.length) {

			// if (App.task_view.is_shown()) {
			// 	view.behavior = 'smooth';
			// 	App.controls.js_scrollbars.waitSmoothScrolling(App.task_view.minibar);
			// }

			App.scroll_listener.stop_events();
			setTimeout(() => $(target).scrollIntoView(view), 99);
			setTimeout(() => {
				App.bus.app.emit('anchor_scroll_to', { target: target.get(0) });
				App.scroll_listener.resume_events();
			}, 350);

			if (el && $(el).attr('data-after-move')) setTimeout($(el).attr('data-after-move'), 350);

			return false;
		}
	},

	initial_scroll_to() {
		if (document.location.hash && App.helper.validate.url_hash.test(document.location.hash)) {
			let target = $(document.location.hash);
			if (!target.length) target = $(document.location.hash + '_alt');
			if (!target.length) target = $('[name=' + document.location.hash.slice(1) + ']');
			if (target.length) {
				App.scroll_listener.stop_events();
				$(target).scrollIntoView({behavior: 'smooth', block: 'start'});
				setTimeout(function () {
					App.scroll_listener.resume_events();
				}, 300);
			}
		}
	},

	onBoot: function () {
		setTimeout(() => this.initial_scroll_to(), 100);
	}
};

;var App = App || {}

if (!App.hybrid_app) App.auth = {

	reg_token: '',
	social_token: '',
	forgot_token: '',
	register_token: '',
	register_mass_token: '',
	pass_strength: ['strong', 'average', 'weak', 'Password', 'Pick a password'],
	email: '',
	password: '',

	register_by_email: function () {
		let email = App.auth.email = $('#auth .register form .input-email').val();
		$('#auth .register_success .text-email').text(email);
		if (App.helper.validate.email.test(App.auth.email)) {
			$.ajax({
				type: 'POST',
				url: App.helper.endpoint.auth(),
				data: $('#auth .register form').serialize(),
				dataType: 'json',
				crossDomain: true,
				success: App.auth.process_register_response
			});
		} else {
			$('#auth .register_success .btn').shake(3, 5, 300);
		}
		return false;
	},

	process_register_response: function (json) {
		if (json.status === 'ok') {
			$('#auth .register_success input[name=hash]').val(json.token);
			App.auth.set_tab('register_success');
		} else if (json.status === 'login') {
			$('#auth .login .auth_message').show().html(json.message);
			App.auth.set_tab('login');
		} else {
			$('#auth .register .auth_message').show().html(json.message);
			App.auth.fix_height();
		}
	},

	register_by_step_code: function () {
		let blink = false, form = $(this), code = '';
		form.find('.code_4digit .input').each(function () {
			if (!this.value) blink = true;
			code += this.value;
		});
		if (blink) {
			form.shake(3, 5, 300);
			form.find('.code_4digit').shortblink();
			setTimeout(function () {
				form.find('.code_4digit .input:first').focus();
			}, 500);
		} else {
			$.ajax({
				type: 'POST',
				url: App.helper.endpoint.auth(),
				data: $('#auth .register_success form').serialize(),
				dataType: 'json',
				success: (json) => App.auth.process_register_step_code_response(json, form)
			});
		}
		return false;
	},

	process_register_step_code_response: function(json, form) {
		if (json.status === 'ok') {
			// $('#auth .register_final input[name=hash]').val(json.token);
			App.auth.register_token = json.token;
			App.auth.set_tab('register_final');
		} else if (json.status === 'login') {
			$('#auth .login .auth_message').show().html(json.message);
			App.auth.set_tab('login');
		} else {
			form.find('.input').val('');
			form.find('.code_4digit').shortblink();
			setTimeout(function () {
				form.find('.code_4digit .input:first').focus();
			}, 500);
		}
	},

	register_by_step_final: function () {
		let j = $();
		let form = $(this);

		form.find('.input.req').each(function() {
			let val = this.value.trim();
			let is_spammer_check_passed = !/https?:/i.test(val);
			if ($(this).attr('name') === 'password') {
				if (val.length < 6 || !is_spammer_check_passed) j = j.add(this)
			} else {
				if (val.length < 2 || !is_spammer_check_passed) j = j.add(this)
			}
		});
		if (!this.is_confirm.checked) j = j.add('.reg_docs .title');
		if (j.length) {
			j.req_blink();
			return false;
		}

		$.ajax({
			type: 'POST',
			url: App.helper.endpoint.auth(),
			data: $('#auth .register_final form').serialize(),
			dataType: 'json',
			success: (json) => App.auth.process_register_step_final_response(json, form)
		});
		return false;
	},

	register_by_step_final_validation: function () {
		let err_cnt = 0;
		let form = $(this);

		form.find('.input.req').each(function() {
			let val = this.value.trim();
			let is_spammer_check_passed = !/https?:/i.test(val);
			if ($(this).attr('name') === 'password') {
				let matchedCase = [];
				matchedCase.push("[$@$!%*#?&]"); // Special Charector
				matchedCase.push("[A-ZА-Я]");      // Uppercase Alpabates
				matchedCase.push("[0-9]");      // Numbers
				matchedCase.push("[a-zа-я]");     // Lowercase Alphabates

				// Check the conditions
				let ctr = 0;
				for (let i = 0; i < matchedCase.length; i++) {
					if (new RegExp(matchedCase[i]).test(val)) ctr++;
				}
				if (ctr >= 3 && val.length >= 6 && is_spammer_check_passed) {
					form.find('.element-pass').attr('data-ok', 'yes').attr('data-password', 'strong').find('label').html(App.auth.pass_strength[3] + '<i> ~ ' +App.auth.pass_strength[0] +'</i>');
				} else if (val.length >= 6 && is_spammer_check_passed) {
					form.find('.element-pass').attr('data-ok', 'yes').attr('data-password', 'medium').find('label').html(App.auth.pass_strength[3] + '<i> ~ ' +App.auth.pass_strength[1] +'</i>');
				} else if (val.length >= 1) {
					form.find('.element-pass').removeAttr('data-ok').attr('data-password', 'week').find('label').html(App.auth.pass_strength[3] + '<i> ~ ' +App.auth.pass_strength[2] +'</i>');
					err_cnt++;
				} else {
					form.find('.element-pass').removeAttr('data-ok').attr('data-password', '').find('label').html(App.auth.pass_strength[4]);
					err_cnt++;
				}
			} else {
				if (val.length >= 2 && is_spammer_check_passed) {
					$(this).parent().attr('data-ok', 'yes');
				} else {
					$(this).parent().removeAttr('data-ok');
					err_cnt++;
				}
			}
		});
		if (!this.is_confirm.checked) {
			err_cnt++;
		}
		if (err_cnt) {
			form.find('.btn').removeClass('effect-green');
		} else {
			form.find('.btn').addClass('effect-green');
		}
	},

	process_register_step_final_response: function(json, form) {
		if (json.status === 'ok') {
			App.actions.register({'workspace_config:show': json.action}, 'auth');
			App.workspace.login();
		} else if (json.status === 'login') {
			$('#auth .login .auth_message').show().html(json.message);
			App.auth.set_tab('login');
		} else if (json.status === "required") {
			form.find('input[name='+json.field+']').req_blink();
			if (json.message) $('#auth .register_final .auth_message').show().text(json.message);
		} else {
			$('#auth .register_final .auth_message').show().html(json.message);
			App.auth.fix_height();
		}
	},

	login_by_email: function () {
		App.auth.email = $('#auth .login form .input-email').val();
		App.auth.password = $('#auth .login form #password').val();
		if (App.auth.email && App.auth.password) {

			const form = $('#auth .login form');
			if (form.hasClass('ws-loading')) return false;
			form.ws_loading('start');

			$.ajax({
				type: 'POST',
				url: App.helper.endpoint.auth(),
				data: $('#auth .login form').serialize(),
				dataType: 'json',
				crossDomain: true,
				success: this.process_login_response,
				complete: () => form.ws_loading('stop'),
			});
		} else {
			$('#auth .login .btn').shake(3, 5, 300);
		}
		return false;
	},

	process_login_response: function (json) {
		if (json.status === 'ok') {
			App.actions.register({'workspace_config:show': json.action}, 'auth');
			App.workspace.login();
		} else if (json.status === 'secure1') {
			App.auth.set_tab('secure1');
		} else if (json.status === 'secure2') {
			App.auth.set_tab('secure2');
		} else if (json.message) {
			$('#auth .login .auth_message').show().html(json.message);
			App.auth.fix_height(true);
		}
	},

	forgot_by_email: function () {

		const form = $('#auth .forgot form');
		if (form.hasClass('ws-loading')) return false;
		form.ws_loading('start');

		$.ajax({
			type: 'POST',
			url: App.helper.endpoint.auth(),
			data: $('#auth .forgot form').serialize(),
			dataType: 'json',
			success: App.auth.process_forgot_response,
			complete: () => form.ws_loading('stop'),
		});
		return false;
	},

	process_forgot_response: function (json) {
		if (json.status === 'ok') {
			$('#auth .forgot_success input[name=hash]').val(json.token);
			App.auth.set_tab('forgot_success');
		} else if (json.status === 'login') {
			$('#auth .login .auth_message').show().html(json.message);
			App.auth.set_tab('login');
		} else {
			$('#auth .forgot .auth_message').show().html(json.message);
			App.auth.fix_height();
		}
	},

	forgot_by_step_code: function () {
		let blink = false, form = $(this), code = '';
		form.find('.code_4digit .input').each(function () {
			if (!this.value) blink = true;
			code += this.value;
		});
		if (blink) {
			form.shake(3, 5, 300);
			form.find('.code_4digit').shortblink();
			$('#auth .forgot_final').one('transitionend', function () {
				setTimeout(function () {
					form.find('.code_4digit .input:first').focus();
				}, 50);
			}); // timeout 700
		} else {
			$.ajax({
				type: 'POST',
				url: App.helper.endpoint.auth(),
				data: $('#auth .forgot_success form').serialize(),
				dataType: 'json',
				success: (json) => App.auth.process_forgot_step_code_response(json, form)
			});
		}
		return false;
	},

	process_forgot_step_code_response: function(json, form) {
		if (json.status === 'ok') {
			$('#auth .forgot_final input[name=hash]').val(json.token);
			$('#auth .forgot_final input[name=email]').val($('#auth .forgot input[name=email]').val());
			App.auth.set_tab('forgot_final');
		} else if (json.status === 'login') {
			$('#auth .login .auth_message').show().html(json.message);
			App.auth.set_tab('login');
		} else {
			form.find('.input').val('');
			form.find('.code_4digit').shortblink();
			setTimeout(function () {
				form.find('.code_4digit .input:first').focus();
			}, 500);
		}
	},

	forgot_by_step_final: function () {
		let code = '', form = $(this);
		$('#auth .forgot_success .code_4digit .input').each(function () {
			code += this.value;
		});
		if (!form.find('.input-password').val()) {
			form.find('.input-password').shortblink().focus();
			return false;
		}
		if (form.find('.input-password').val() !== form.find('.input-password-verify').val()) {
			form.find('.input-password-verify').shortblink().focus();
			return false;
		}

		$.ajax({
			type: 'POST',
			url: App.helper.endpoint.auth(),
			data: $('#auth .forgot_final form').serialize(),
			dataType: 'json',
			success: (json) => App.auth.process_forgot_step_final_response(json, form)
		});
		return false;
	},

	process_forgot_step_final_response: function(json, form) {
		if (json.status === 'ok') {
			App.actions.register({'workspace_config:show': json.action}, 'auth');
			App.workspace.login();
		} else if (json.status === 'login') {
			$('#auth .login .auth_message').show().html(json.message);
			App.auth.set_tab('login');
		} else {
			$('#auth .forgot_final .auth_message').show().html(json.message);
			App.auth.fix_height();
		}
	},

	limit_ips: function () {
		$.ajax({
			type: 'POST',
			url: App.helper.endpoint.auth(),
			data: $('#auth .secure1 form').serialize(),
			dataType: 'json',
			success: App.auth.process_limit_ips_response
		});
		return false;
	},

	process_limit_ips_response: function (json) {
		if (json.status === 'login') {
			$('#auth .login .auth_message').show().html(json.message);
			App.auth.set_tab('login');
		} else {
			$('#auth .secure1 .auth_message').show().html(json.message);
			App.auth.fix_height();
		}
	},

	google_2fa: function () {
		let form = $(this);
		if (!App.helper.validate.digits6.test(form.find('input[name=code]').val())) {
			form.find('.ws-code-input').animate_css('head-shake');
			form.find('ws-code-input').get(0).focusIntelligent();
			return false;
		}

		if (form.hasClass('ws-loading')) return false;
		form.ws_loading('start');

		$.ajax({
			type: 'POST',
			url: App.helper.endpoint.auth(),
			data: $('#auth .secure2 form').serialize(),
			dataType: 'json',
			success: App.auth.process_google_2fa_response,
			complete: () => form.ws_loading('stop'),
		});
		return false;
	},

	process_google_2fa_response: function (json) {
		if (json.status === 'ok') {
			App.actions.register({'workspace_config:show': json.action}, 'auth');
			App.workspace.login();
		} else if (json.status === 'login') {
			$('#auth .login .auth_message').show().html(json.message);
			App.auth.set_tab('login');
		} else {
			$('#auth .secure2 .auth_message').show().html(json.message);
			$('#auth .secure2 ws-code-input').get(0).clearValue();
			$('#auth .secure2 .ws-code-input').animate_css('head-shake');
			App.auth.fix_height();
		}
	},

	last_tab: '',
	set_tab: function(tab, noani, loaded) {
		switch (tab)
		{
			case 'forgot_success':
				$('#auth .forgot_success .code_4digit .input').val('');
				$('#auth .forgot_success').one('transitionend', function () {
					$('#auth .forgot_success .code_4digit .input:first').focus();
				}); // timeout 700
				break;

			case 'register_success':
				$('#auth .register_success .code_4digit .input').val('');
				$('#auth .register_success').one('transitionend', function () {
					$('#auth .register_success .code_4digit .input:first').focus();
				}); // timeout 700
				break;

			case 'register':
				if (!loaded) {
					$.ajax({
						url: App.helper.endpoint.auth() + '?' + App.actions.get('mass_invite:show') + '&hash=' + App.auth.register_mass_token,
						success: function (data, status, xhr) {
							if ((xhr.getResponseHeader("Content-type") || '').startsWith('application/json')) {
								App.auth.process_tab_load_errors(data);
							} else {
								$('#auth .register .part-main').html(data);
								App.auth.set_tab(tab, noani, true);
							}
						},
					})
					return false;
				}
				break;

			case 'register_final':
				if (!loaded) {
					$.ajax({
						url: App.helper.endpoint.auth() + '?' + App.actions.get('invite:show') + '&hash=' + App.auth.register_token,
						success: function (data, status, xhr) {
							if ((xhr.getResponseHeader("Content-type") || '').startsWith('application/json')) {
								App.auth.process_tab_load_errors(data);
							} else {
								$('#auth .register_final .part-main').html(data);

								$('#auth .register_final .element .input[placeholder]').each(function () {
									$('<label>' + ($(this).attr('data-placeholder') ? $(this).attr('data-placeholder') : $(this).attr('placeholder')) + '</label>').bind('click', function () {
										$(this).prev().focus();
									}).insertAfter($(this));
								}).attr('placeholder', ' ');

								App.auth.set_tab(tab, noani, true);
							}
						},
					})
					return false;
				}
				break;

			case 'secure1':
				if (!loaded) {
					$.ajax({
						url: App.helper.endpoint.auth() + '?' + App.actions.get('limit_ips:show'),
						success: function (data, status, xhr) {
							if ((xhr.getResponseHeader("Content-type") || '').startsWith('application/json')) {
								App.auth.process_tab_load_errors(data);
							} else {
								$('#auth .secure1 .part-main').html(data);
								App.auth.set_tab(tab, noani, true);
							}
						}
					})
					return false;
				}
				break;

			case 'secure2':
				if (!loaded) {
					$.ajax({
						url: App.helper.endpoint.auth() + '?' + App.actions.get('google_2fa:show'),
						success: function (data, status, xhr) {
							if ((xhr.getResponseHeader("Content-type") || '').startsWith('application/json')) {
								App.auth.process_tab_load_errors(data);
							} else {
								$('#auth .secure2 .part-main').html(data);
								App.auth.set_tab(tab, noani, true);
							}
						}
					})
					return false;
				}
				break;
		}
		this.last_tab = tab;
		$('#auth').attr('class', tab + (noani ? ' noani' : '')).show().css({height: $('#auth .' + tab).outerHeight()});
		if (noani) setTimeout(function () {
			$('#auth').removeClass('noani');
		}, 0);
	},

	process_tab_load_errors: function (json) {
		if (json.status === 'login') {
			$('#auth .login .auth_message').show().html(json.message);
			App.auth.set_tab('login');
		}
	},

	fix_height: function(noani) {
		if (this.last_tab) {
			if (noani) {
				$('#auth').addClass('noani').css({height: $('#auth .' + this.last_tab).outerHeight()});
				if (noani) setTimeout(function () {
					$('#auth').removeClass('noani');
				}, 0);
			} else $('#auth').css({height: $('#auth .' + this.last_tab).outerHeight()});
		}
	},

	init: function () {

		$('#auth .login').on('submit', 'form', () => App.auth.login_by_email());
		$('#auth .register').on('submit', 'form', () => App.auth.register_by_email());
		$('#auth .forgot').on('submit', 'form', () => App.auth.forgot_by_email());

		$('#auth .secure1').on('submit', 'form', App.auth.limit_ips);
		$('#auth .secure2').on('submit', 'form', App.auth.google_2fa);

		$('#auth .secure2').on('ws-code-input', 'ws-code-input[name="code"]', function (e) {
			if (!e.detail.status || e.detail.source !== 'paste') return;
			App.auth.google_2fa.call($(this).closest('form').get(0));
		});


		$('#auth .register').on('keyup blur paste', '.input-email', function () {
			let email = $(this).val();
			if (email.match(App.helper.validate.email)) {
				if (!$('#auth .register .btn-default').hasClass('effect-green')) App.auth.showEffect();
				$('#auth .register .btn-default').addClass('effect-green').removeClass('effect-yellow');
			} else if (email) {
				$('#auth .register .btn-default').addClass('effect-yellow').removeClass('effect-green');
			} else {
				$('#auth .register .btn-default').removeClass('effect-yellow effect-green');
			}
		});

		$('#auth .login').on('click', '.remember', function () {
			$('#auth .forgot form .input-email').val($('#auth .login form .input-email').val());
			App.auth.set_tab('forgot');
		});

		$('#auth .register_success').on('submit', 'form', App.auth.register_by_step_code);

		$('#auth .forgot_success').on('submit', 'form', App.auth.forgot_by_step_code);

		$('#auth .register_final').on('submit', 'form.primary', App.auth.register_by_step_final)
			.on('change', 'form.primary', App.auth.register_by_step_final_validation)
			.on('keyup', 'form.primary .input', function() {	$(this.form).trigger('change');	});

		$('#auth .forgot_final').on('submit', 'form', App.auth.forgot_by_step_final);

		$('#auth').find('.code_4digit .input').bind('keydown', function (e) {
			let key = e.keyCode ? e.keyCode : e.charCode;
			if (key === 8 && this.value.length === 0) {
				$(this).prev().val('').focus();
			}
		}).bind('keyup', function(e) {
			let val = $(this).val();
			let o = $(this);
			while (val.length >= 1 && o.length) {
				o.val(val.substr(0, 1));
				val = val.substr(1, 3);
				o = o.next();
			}
			if (!o.length) $(this).parent().parent().find('input[type="submit"]').focus(); else o.focus();
		}).bind('paste', function () {
			setTimeout(function(el) {
				$(el).trigger('keyup');
			}, 50, this);
		}).bind('focus', function() {
			let o = $(this).prev();
			if (o.length && o.val() == '') {
				while (o.prev().length && o.prev().val() == '') { o = o.prev(); }
				o.focus().select();
			}
			else $(this).select();
		});

		$('#auth .back, #auth .back_inline').click(function () {
			App.auth.set_tab('login');
		});

		$('#auth .register').on('focus', '.input', function () {
			App.auth.showEffect();
		});

		$('#auth .login .part-bottom .btn').click(function () {
			$('#auth .register form .input-email').val($('#auth .login form .input-email').val());
			App.auth.set_tab('register');
		});

		$(document).off('click.auth_lang_sel').on('click.auth_lang_sel', function (e) {
			const $target = $(e.target);
			if ($target.closest('#auth_lang_sel b').length) {
				$('#auth_lang_sel').toggleClass('act');
				return;
			}
			App.helper.nextTick(() => {
				$('#auth_lang_sel').removeClass('act');
			})
		});
		$('#auth_lang_sel a').click(function() {
			$('#auth_lang_sel a').removeClass('act');
			$(this).addClass('act');
			App.workspace.show_auth_form(App.auth.last_tab, $(this).attr('data-lang'));
		});
	},

	showEffect: function () {
		$('#incline-right > div > div').removeClass('liner, liner2');
		$('#incline-left > div > div').removeClass('liner3, liner4');
		$('#incline-right > div > div').addClass('liner');
		$('#incline-left > div > div').addClass('liner3');
		setTimeout(function () {
			$('#incline-right > div > div').removeClass('liner');
			$('#incline-left > div > div').removeClass('liner3');
			$('#incline-right > div > div').addClass('liner2');
			$('#incline-left > div > div').addClass('liner4');
			setTimeout(function () {
				$('#incline-right > div > div').removeClass('liner, liner2');
				$('#incline-left > div > div').removeClass('liner3, liner4');
			}, 300);
		}, 300);
	},
}; else {
	Object.assign(App.auth, {

		process_login_response: function (json) {
			if (json.status === 'domen') {
				App.auth.social_token = '';
				$('#auth .login .auth_message').hide();
				let html = '';
				for (let key in json.data) {
					if (key > 0) html += '<div class="line"></div>';
					html += '<a class="param-acc" data-domen="' + json.data[key]['domen'] + '">' + json.data[key]['img'].replace('src="', 'src="' + json.data[key]['domen']).replace('href="/', 'href="') + '<i><svg><use xlink:href="#back_arrow"/></svg><b>' + json.data[key].name + '</b><span class="url">' + json.data[key]['domen'].replace(/https?:\/\//, '') + '</span></i></a>';
				}
				$('#auth .login_multy').find('.accounts').html(html);
				App.auth.set_tab('login_multy');
			} else if (json.status === 'ok') {
				App.db.set("email", App.hybrid_app.email);
				App.db.set("password", App.hybrid_app.password);
				App.db.set("token", App.hybrid_app.token = json.token);
				App.db.set("domen", App.hybrid_app.domen = json.domen);
				App.hybrid_app.current_tab = App.hybrid_app.start_tab;
				$('body').removeClass('body_login').removeClass('body_acc').addClass('body_' + App.hybrid_app.current_tab).find('.appFrame-' + App.hybrid_app.current_tab).addClass('appFrame-active');
				$('#load_overlay').show();
				App.workspace.init();
			} else if (json.status === 'secure1') {
				App.auth.set_tab('secure1');
			} else if (json.status === 'secure2') {
				App.auth.set_tab('secure2');
			} else if (json.message) {
				$('#auth .login .auth_message').show().text(json.message);
				App.auth.fix_height();
			}
		},

		limit_ips: function () {
			$.ajax({
				type: 'POST',
				url: App.helper.endpoint.auth(),
				data: $('#auth .secure1 form').serialize(),
				dataType: 'json',
				success: App.auth.process_limit_ips_response
			});
			return false;
		},

		process_limit_ips_response: function (json) {
			if (json.status === 'login') {
				$('#auth .login .auth_message').show().html(json.message);
				App.auth.set_tab('login');
			} else {
				$('#auth .secure1 .auth_message').show().html(json.message);
				App.auth.fix_height();
			}
		},

		google_2fa: function () {
			let form = $(this);
			if (!App.helper.validate.digits6.test(form.find('input[name=code]').val())) {
				form.find('.ws-code-input').animate_css('head-shake');
				form.find('ws-code-input').get(0).focusIntelligent();
				return false;
			}

			if (form.hasClass('ws-loading')) return false;
			form.ws_loading('start');

			$.ajax({
				type: 'POST',
				url: App.helper.endpoint.auth(),
				data: $('#auth .secure2 form').serialize(),
				dataType: 'json',
				success: App.auth.process_google_2fa_response,
				complete: () => form.ws_loading('stop'),
			});
			return false;
		},

		process_google_2fa_response: function (json) {
			if (json.status === 'ok') {
				App.actions.register({'workspace_config:show': json.action}, 'auth');
				App.workspace.login();
			} else if (json.status === 'login') {
				$('#auth .login .auth_message').show().html(json.message);
				App.auth.set_tab('login');
			} else {
				$('#auth .secure2 .auth_message').show().html(json.message);
				$('#auth .secure2 ws-code-input').get(0).clearValue();
				$('#auth .secure2 .ws-code-input').animate_css('head-shake');
				App.auth.fix_height();
			}
		},
		set_tab: function(tab, noani, loaded) {
			switch (tab)
			{
				case 'forgot_success':
					$('#auth .forgot_success .code_4digit .input').val('');
					setTimeout(function() {
						$('#auth .forgot_success .code_4digit .input').eq(0).focus();
					}, 500);
					break;
				case 'register_success':
					$('#auth .register_success .code_4digit .input').val('');
					setTimeout(function() {
						$('#auth .register_success .code_4digit .input').eq(0).focus();
					}, 500);
					break;

				case 'secure1':
					if (!loaded) {
						$.ajax({
							url: App.helper.endpoint.auth() + '?' + App.actions.get('limit_ips:show'),
							success: function (data, status, xhr) {
								if ((xhr.getResponseHeader("Content-type") || '').startsWith('application/json')) {
									App.auth.process_tab_load_errors(data);
								} else {
									$('#auth .secure1 .part-main').html(data);
									App.auth.set_tab(tab, noani, true);
								}
							}
						})
						return false;
					}
					break;

				case 'secure2':
					if (!loaded) {
						$.ajax({
							url: App.helper.endpoint.auth() + '?' + App.actions.get('google_2fa:show'),
							success: function (data, status, xhr) {
								if ((xhr.getResponseHeader("Content-type") || '').startsWith('application/json')) {
									App.auth.process_tab_load_errors(data);
								} else {
									$('#auth .secure2 .part-main').html(data);
									App.auth.set_tab(tab, noani, true);
								}
							}
						})
						return false;
					}
					break;
			}
			this.last_tab = tab;
			$('#auth').attr('class', tab + (noani ? ' noani' : '')).show().css({height: $('#auth .' + tab).outerHeight(), opacity: 1 });
			if (noani) setTimeout(function () {
				$('#auth').removeClass('noani');
			}, 0);
		},

		process_tab_load_errors: function (json) {
			if (json.status === 'login') {
				$('#auth .login .auth_message').show().html(json.message);
				App.auth.set_tab('login');
			}
		},


		init: function () {
			$('body').removeClass('init');
			$('#auth').css({ opacity: 0 });

			$('#auth .login').on('submit', 'form', () => App.auth.login_by_email());
			$('#auth .register').on('submit', 'form', () => App.auth.register_by_email());
			$('#auth .forgot').on('submit', 'form', () => App.auth.forgot_by_email());
			$('#auth .login a[data-social=google]').bind('click', App.auth.google_login);
			$('#auth .login a[data-social=apple]').bind('click', App.auth.apple_login);
			$('#auth .register a[data-social=google]').bind('click', App.auth.google_register);
			$('#auth .register a[data-social=apple]').bind('click', App.auth.apple_register);
			$('.app_menu_logout').bind('click', App.auth.logout);

			$('#auth .secure1').on('submit', 'form', App.auth.limit_ips);
			$('#auth .secure2').on('submit', 'form', App.auth.google_2fa);

			$('#auth .secure2').on('ws-code-input', 'ws-code-input[name="code"]', function (e) {
				if (!e.detail.status || e.detail.source !== 'paste') return;
				App.auth.google_2fa.call($(this).closest('form').get(0));
			});

			$('#auth').on('click', '.login_multy .accounts a.param-acc', function () {
				let domen = $(this).attr('data-domen');
				App.db.set("domen", App.hybrid_app.domen = domen);
				if (App.auth.social_token) {
					App.auth.login_by_social_token(domen);
				} else {
					App.auth.login_by_email_helper(domen);
				}
			});

			$('#auth').on('click', '.forgot_multy .accounts a.param-acc', function () {
				App.db.set("domen", App.hybrid_app.domen = $(this).attr('data-domen'));
				App.auth.forgot_by_email(App.hybrid_app.domen);
			});

			$('#auth').on('click', '.register_multy .accounts a.param-acc', function () {
				App.auth.set_tab('login');
				return false;
			});

			$('#auth').on('click', 'ws-icon[name*=wslogo]', function () {
				let dt = Date.now() - App.auth.wslogo_click_at;
				if (dt > 5000) App.auth.wslogo_click_counter = 0;
				App.auth.wslogo_click_counter++;
				App.auth.wslogo_click_at = Date.now();
				if (App.auth.wslogo_click_counter >= 5) App.hybrid_app.toggle_dev_env();
			});

			$('#auth .register_multy .part-bottom a.btn').click(function () {
				if ($(this).attr('data-url')) {
					App.core.open_browser($(this).attr('data-url'));
				} else $('#auth .register form').attr('data-force', 'yes').submit();
			});

			$('#auth .register .input-email').bind('keyup blur paste', function () {
				let email = $(this).val();
				if (email.match(/^[^@]+@[^@]+$/)) {
					if (!$('#auth .register .btn-default').hasClass('effect-green')) App.auth.showEffect();
					$('#auth .register .btn-default').addClass('effect-green').removeClass('effect-yellow');
				} else if (email) {
					$('#auth .register .btn-default').addClass('effect-yellow').removeClass('effect-green');
				} else {
					$('#auth .register .btn-default').removeClass('effect-yellow effect-green');
				}
			});

			$('#auth .login').on('click', '.remember', function () {
				$('#auth .forgot form .input-email').val($('#auth .login form .input-email').val());
				App.auth.set_tab('forgot');
			});

			$('#auth .register_success').on('submit', 'form', App.auth.register_by_step_code);

			$('#auth .forgot_success').on('submit', 'form', App.auth.forgot_by_step_code);

			$('#auth .register_final form')
				.submit(App.auth.register_by_step_final)
				.bind('change', App.auth.register_by_step_final_validation)
				.find('input').bind('keyup', function() {	$(this.form).trigger('change');	});

			$('#auth .forgot_final').on('submit', 'form', App.auth.forgot_by_step_final);

			$('#auth').find('.code_4digit .input').bind('keydown', function (e) {
				let key = e.keyCode ? e.keyCode : e.charCode;
				if (key === 8 && this.value.length === 0) {
					$(this).prev().val('').focus();
				}
			}).bind('keyup', function(e) {
				let val = $(this).val();
				let o = $(this);
				while (val.length >= 1 && o.length) {
					o.val(val.substr(0, 1));
					val = val.substr(1, 3);
					o = o.next();
				}
				if (!o.length) $(this).parent().parent().find('input[type="submit"]').focus(); else o.focus();
			}).bind('paste', function () {
				setTimeout(function(el) {
					$(el).trigger('keyup');
				}, 50, this);
			}).bind('focus', function() {
				let o = $(this).prev();
				if (o.length && o.val() == '') {
					while (o.prev().length && o.prev().val() == '') { o = o.prev(); }
					o.focus().select();
				}
				else $(this).select();
			});

			$('#auth .back, #auth .back_inline').click(function () {
				App.auth.set_tab('login');
			});

			$('#auth .register').on('focus', '.input', function () {
				App.auth.showEffect();
			});

			$('#auth .login .part-bottom .btn').click(function () {
				$('#auth .register form .input-email').val($('#auth .login form .input-email').val());
				App.auth.set_tab('register');
			});

			$('#auth .register_multy .accounts_invis .btn').click(function () {
				$('#auth .login form .input-email').val($('#auth .register form .input-email').val());
				App.auth.set_tab('login');
			});

			// setTimeout(function() {$('input').removeAttr('readonly');}, 100);
			$('#auth .register_final .element .input[placeholder]').each(function () {
				$('<label>' + ($(this).attr('data-placeholder') ? $(this).attr('data-placeholder') : $(this).attr('placeholder')) + '</label>').bind('click', function () {
					$(this).prev().focus();
				}).insertAfter($(this));
			}).attr('placeholder', ' ');
		},
	});
};

App.auth.social_login = function (url) {
	let win;
	if (!App.hybrid_app) win = App.core.popup('', '_popup', 800, 600);
	$.ajax({
		type: 'get',
		url,
		dataType: 'text',
		success: function (url) {
			if (url) {
				if (App.hybrid_app) window.open(url, '_blank');
				else win.location.href = url;
			}
		}
	});
};
;var App = App || {};

(function() {
	let self = App.bill_edit = {
		loaded: false,
		have_data: false,
		init: function () {
			App.mass.init(['all']);
			App.mass.range.start = 0;
			App.mass.range.end = 0;
		},
		id: 0,

		mass: {

			update_menu: function () {
				App.mass.count['all'] = $('input.mass:checked').length;
				if (!App.mass.count['all']) {
					App.mass.hide();
				} else {
					$('#massdo').find('i').html('<b></b>' + App.mass.count['all']);
					App.mass.show();
					App.mass.reset();
					$('input.mass:checked').each(function () {
						App.mass.ids['all'] += $(this).val() + ',';
					});

					if (App.mass.count['all'] > 1) $('#massdo .op_join').removeAttr('disabled'); else $('#massdo .op_join').toggleDisabled('disabled');
				}
			},

			hide_menu: function (forced) {
				App.mass.range.start = App.mass.range.end = 0;
				last_mass_sub_value = 0;
				if (!forced) App.mass.hide();
				$('input.mass:checked').prop('checked', false).parent().removeClass('act').parent().removeClass('pre_act');
				$('#mass_n_filt .mass_select_all').removeClass('act').find('input').prop('checked', false);
			},

			init_menu: function () {
				self.mass.update_menu();
				if (App.mass.count['all']) App.mass.action_done(); // mark action as done after success redirect
				$('#massdo a.ico_esc, #massdo i').bind('click', function () {
					self.mass.hide_menu();
					return false;
				})
				$('input.mass_group').bind('click ws_click', function (e) {
					if (e.type === 'ws_click') {
						this.checked = !this.checked;
					}
					if (App.mass.is_after_action()) {
						self.mass.update_menu(true);
						App.mass.clear_action();
					}
					if (this.checked) {
						$(this).parent().parent().parent().parent().parent().find('.item').not('.item_hid').find('input.mass').not(':checked').prop('checked', true).parent().addClass('act').parent().addClass('pre_act');
						self.mass.update_menu();
					} else {
						$(this).parent().parent().parent().parent().parent().find('.item').not('.item_hid').find('input.mass:checked').prop('checked', false).parent().removeClass('act').parent().removeClass('pre_act');
						self.mass.update_menu();
					}
				});
				$('#massdo [data-mass-action]').bind('mouseout', function () {
					$('#massdo').removeClass('masserr').find('.cnt').css('width', '').find('b').html(App.mass.count['all']);
				});
				$('#massdo .op_more').bind('click', function () {
					$(this).next().show();
					$(this).remove();
				});
				$('#massdo [data-mass-action]').bind('click', function () {
					let operation = $(this).attr('data-mass-action');
					if (operation === 'rate') {
						App.mass.validate_and_submit('rate', App.mass.ids['all'], function (json) {
							$('#massdo .ops').hide();
							$('#massdo .ops_rate').css({display: 'flex'});
							$('#massdo .op_rate_real').attr('data-hash', json.hash);
							$('#op_rate1, #op_rate2').val('');
						});
					} else if (operation === 'up') {
						App.mass.validate_and_submit(['shift', 'up'], App.mass.ids['all']);
					} else if (operation === 'dn') {
						App.mass.validate_and_submit(['shift', 'dn'], App.mass.ids['all']);
					} else if (operation === 'join') {
						App.mass.validate_and_submit('join', App.mass.ids['all']);
					} else if (operation === 'delete') {
						App.modal.show({
							url: App.helper.url.add_query(App.mass.action_url('delete'), 'ids=' + App.mass.ids['all']),
							width: 480,
							title: $(this).attr('data-modal-title') ? $(this).attr('data-modal-title') : $(this).attr('title'),
							group: 'delete'
						});
					} else {
					}
					return false;
				});
				$('#massdo .ops_mail .op_rate_cancel').bind('click', function () {
					$('#massdo .ops').show();
					$('#massdo .ops_mail').hide();
					return false;
				});
				$('#massdo .ops_mail .op_rate_real').bind('click', function () {
					if ($('#op_rate1').val() || $('#op_rate2').val()) $.getScript(App.helper.url.add_query(App.mass.action_url('rate').replace('master', 'master_step_do'), 'ids=' + App.mass.ids['all'] + '&mdb=' + $(this).attr('data-hash') + '&rate1=' + encodeURIComponent($('#op_rate1').val()) + '&rate2=' + encodeURIComponent($('#op_rate2').val())));
					$('#massdo .ops').show();
					$('#massdo .ops_mail').hide();
					return false;
				});

			},

		},


		init_items: function () {
			$('input.mass').bind('click ws_click', function (e) {
				if (App.mass.is_after_action()) {
					if (!e.shiftKey) {
						self.mass.update_menu(true);
						this.checked = true;
					}
					App.mass.clear_action();
				}
				if (!this.checked) {
					App.mass.range.start = 0;
				} else {
					if (e.shiftKey && App.mass.range.start) {
						App.mass.range.end = this.value;
						let in_range = false;
						$('.bill_out .time .it').not('.item_hid').find('input.mass').each(function () {
							if (this.value == App.mass.range.start || this.value == App.mass.range.end) in_range = !in_range;
							if (in_range) $(this).prop('checked', true).parent().addClass('act').parent().addClass('pre_act');
						});
					}
					App.mass.range.start = this.value;
				}
				self.mass.update_menu();
			});
			$('.bill_out .time .it').bind('click', function (e) {
				if (!App.custom_control.active_box && !self.input_focused && $(e.target).is('div, span, b') || ($(e.target).is('a.rate, a.delete') && $('#massdo').is(':visible'))) {
					if ($(window).width() <= 480) return false;
					if (App.mass.is_after_action()) {
						if (!e.shiftKey) self.mass.update_menu(true);
						App.mass.clear_action();
					}
					let el = $(this).find('input.mass');
					if (el.length) {
						if (el.prop('checked')) {
							el.prop('checked', false).parent().removeClass('act').parent().removeClass('pre_act');
							App.mass.range.start = 0;
						} else {
							if (e.shiftKey && App.mass.range.start) {
								App.mass.range.end = $(el).val();
								let in_range = false;
								$('.bill_out .time .it').not('.item_hid').find('input.mass').each(function () {
									if (this.value == App.mass.range.start || this.value == App.mass.range.end) in_range = !in_range;
									if (in_range) $(this).prop('checked', true).parent().addClass('act').parent().addClass('pre_act');
								});
							}
							App.helper.selection.clear();
							App.mass.range.start = $(el).val();
							el.prop('checked', true).parent().addClass('act').parent().addClass('pre_act');
						}
						self.mass.update_menu();
					}
					return false;
				}
			});

			$('.bill_out .time .input').bind('focus', function () {
				self.input_focused = true;
				if ($(this).val() == '—') $(this).val('0');
				$(this).trigger('select');
			}).bind('blur', function () {
				setTimeout(function () {
					self.input_focused = false;
				}, 100);
				let tk = $(this).val().replace(/\s+/g, '').replace(/,/g, '.');
				if (App.helper.validate.money_float.test(tk)) tk = 0.01 * Math.round(tk * 100); else tk = 0;
				$(this).val(tk ? tk : '—');
			}).bind('keyup', function (e) {
				if (e == null) { // ie
					keycode = event.keyCode;
				} else { // mozilla
					keycode = e.which;
				}
				if (keycode != App.keycode.Tab) self.save_onfly(this, keycode === App.keycode.Enter);
			});
			$('.bill_out .time .it_name a').bind('click', function () {
				$(this).parent().load(App.helper.url.add_query('/ajax/?id_bill=' + self.id, App.actions.get('bill_rename_item:show') + '&id_bt=' + $(this).attr('rel')));
				return false;
			});

			$('.it_blink').removeClass('it_blink').blink();

			// -------------------- actions -------------------
			this.init_new_items();
		},

		init_new_items: function () {
			$('.bill_out .time_edit').on('click', '.it .ico_delete2', function () {
				$(this).parent().remove();
				return false;
			});
			$('.bill_out .time_edit').on('focus', '.it .input', function () {
				let o = $(this).parent().parent();
				if (!o.hasClass('this_focused') && o.prev().length && !o.prev().hasClass('this_focused')) {
					o.prev().find('.it_name .inputmain').trigger('focus');
					return;
				}
				let o2 = null;
				if (o.hasClass('it_opac')) {
					let num_clone = 1;
					while (o.prev().hasClass('it_opac')) {
						o = o.prev();
						o.removeClass('it_opac');
						num_clone++;
					}
					o = $(this).parent().parent();
					o.removeClass('it_opac');
					for (let i = 0; i < num_clone; i++) {
						o2 = o.clone();
						o2.appendTo('.time_edit');
					}
					for (let i = 0; i <= 1; i++) o = o.next().addClass('it_opac');
				}
				o = $(this).parent().parent();
				o.addClass('this_focused');
				if (!o.hasClass('it_act')) {
					o.parent().find('.it').removeClass('it_act');
					o.addClass('it_act');
				}
			}).bind('keydown', function (e) {
				let key = e.keyCode ? e.keyCode : e.charCode;
				if (!e.ctrlKey && (key === App.keycode.Enter)) {
					$('.it_act').next().find('.it_name .inputmain').trigger('focus');
					return false;
				}
			});
		},

		init_controls: function () {
			$('.bill a.label_st').bind('click', function () {
				let pos = 1;
				if (/label_st(\d+)/.test($(this).attr('class'))) {
					pos = RegExp.$1;
				}
				$('#label_popup').show().css({
					left: ($(this).offset().left - 3) + 'px',
					top: ($(this).offset().top - 3 - 19 * (pos - 1)) + 'px'
				}).attr('rel', $(this).attr('rel'));
				App.custom_control.active_box = $('label_popup').get(0);
				return false;
			});
			$('#label_popup a').bind('click', function () {
				if ($('#label_popup').attr('rel')) {
					$.ajax({
						type: 'POST',
						url: '/ajax/?id_bill=' + $('#label_popup').attr('rel') + '&' + App.actions.get('bill_save_status:do') + '&status=' + $(this).attr('rel'),
						dataType: 'html',
						context: this,
						success: function (html) {
							if (html) {
								$('.bill .label_st').attr('class', 'label_st label_st' + $(this).attr('rel')).html($(this).html()).next().html(html == 'OK' ? '&nbsp;' : html);
							}
						}
					});
				} else {
					$('.bill .label_st').attr('class', 'label_st label_st' + $(this).attr('rel')).html($(this).html()).next().val($(this).attr('rel'));
				}
				$('#label_popup').hide();
				App.custom_control.active_box = null;
				return false;
			});
		},

		update_total: function () {
			let tk, ak;
			ak = 0;
			$('.bill_out .time .input').each(function () {
				tk = $(this).val();
				if (tk == '—') {
					tk = 0;
				} else {
					tk = Math.round(100 * tk / 1);
					ak += tk / 1;
				}
			});
			$('.bill_out .self .it_sum span').html(App.format.money(ak));
		},

		input_focused: false,
		save_onfly_timeout: {},
		save_onfly: function (el, now) {
			$(el).addClass('inp_load_pre');
			if (self.save_onfly_timeout[$(el).attr('rel')]) clearTimeout(self.save_onfly_timeout[$(el).attr('rel')]);
			if (now) $(el).trigger('blur');
			self.save_onfly_timeout[$(el).attr('rel')] = setTimeout(function (el) {
				$("#obj-bill-item" + $(el).attr('rel') + " .input").removeClass("inp_load_pre").addClass("inp_load");
				$.ajax({
					url: App.helper.url.add_query('/ajax/?id_bill=' + self.id, App.actions.get('bill_save_item:do') + '&id_bt=' + $(el).attr('rel') + "&money_bill=" + encodeURIComponent(el.value)),
					success: function () {
						$("#obj-bill-item" + $(el).attr('rel') + " .input").removeClass("inp_load");
					}
				});
			}, now ? 0 : 1000, el);
			self.update_total();
		},

		onload: function (id) {
			self.id = id || 0;
			this.mass.init_menu();
			this.init_items();
			this.init_controls();
		}
	};
})();

;var App = App || {};

(function() {
	let self = App.bookmark = {
		suggestedName() {
			const tab = $('#viewsList .viewsList__item-active .in').text().trim();
			const project = $('#headerGeneral project-name').first().text().trim();

			return (tab && project) ? tab + ' ← ' + project : (tab || project);
		},
		saveCurrentPage() {
			App.modal.show({
				type: 'events',
				url: App.helper.url.add_query(
					App.helper.endpoint.primary(),
					App.actions.get('bookmark:show'),
					`bookurl=${encodeURIComponent(window.location.pathname + window.location.search)}&bookname=${encodeURIComponent(self.suggestedName())}`,
				),
				width: 460,
			});
			return false;
		},
		controlMenu: function (anchor, params) {
			params ||= {}
			App.menu.show({
				anchor: anchor,
				type: params.type,
				replace: params.replace || false,
				backup: params.backup || false,
				profile: params.profile || false,
				width: 200,
				box: '#bookmarkMenu',
				force_dropdown: true,
				onshow: function () {

					const menu = $(this);

					menu.find('.menu__item[data-key=edit], .menu__item[data-key=delete]').toggleClass('menu__item-disabled', !params.id);

					menu.off().on('click', '.menu__item:not(.menu__item-disabled)', function(e) {
						switch ($(this).attr('data-key')) {
							case 'open':
								App.menu.hide()
								App.core.goto(params.url);
								break;
							case 'edit':
								App.menu.hide()
								self.editBookmark(params.id)
								break;
							case 'delete':
								self.deleteBookmark(this, params.id)
								break;
						}
					});
				}
			})
		},

		editBookmark(id) {
			App.modal.show({
				type: 'events',
				url: App.helper.url.add_query(
					App.helper.endpoint.primary(),
					App.actions.get('bookmark:show'),
					`bookmark_id=${id}`
				),
				width: 460,
			});
		},

		deleteBookmark(anchor, id) {
			App.controls.confirm.menu(anchor, {
				backup: true,
				onconfirm: () => {
					$.ajax({
						url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('bookmark:delete'), `id=${id}`),
						success: function () {
							App.mymenu.invalidate_window('bookmarks', () => {
								if (App.mymenu.is_shown()) {
									App.mymenu.obj_window.find('.sidePanel__tabs li[data-tab="pages"]').trigger('click')
								}
							})
						}
					});
				},
				message: $(anchor).data('confirm-text')
			});
		}
	};
})();

;var App = App || {};

(function() {
	let self = App.chat_info = {
		id: 0,
		locale: {},

		obj_wrapper: null,
		obj_menus: null,

		last_tab: 'about',
		content_loader: null,

		init: function(id_chat) {
			self.id = id_chat;
			self.obj_wrapper = App.modal.obj_window;
			self.obj_wrapper.attr('data-view-chat', self.id);

			self.obj_wrapper.find('.modal__tabs__item').bind('click', function() {
				let type = $(this).attr('data-type');
				let modalContentCap = self.obj_wrapper.find('.modal__content__cap').attr('data-type', type);

				self.last_tab = type;
				self.obj_wrapper.find('.modal__tabs__item:not([data-type='+type+'])').removeClass('active');
				self.obj_wrapper.find('.projectView').hide();
				$(this).addClass('active');

				let content = self.obj_wrapper.find('.projectView[data-type=' + type + ']');

				content.show();
				self.content_loader.abort();

				if (content.length === 0 || content.attr('data-reload') != null) {
					if (content.length === 0) modalContentCap.show();
					self.content_loader.ajax($(this).attr('data-url'))
						.then((html) => self.onload(type, html))
						.catch(() => {
							if (self.content_loader.is_idle()) modalContentCap.hide()
						});
				}
			});
			self.obj_wrapper.find('#chatNotificationsMenu a').bind('click', function() {
				let me = $(this),
					action = me.attr('data-action'),
					url = me.attr('data-url'),
				    iconName = me.attr('data-ws-icon'),
				    txt = me.attr('data-text'),
				    btn = self.obj_wrapper.find('#buttonChatNotifications');

				let menu = me.closest('.menu');
				menu.find('.menu__item-active').removeClass('menu__item-active');
				me.addClass('menu__item-active');
				btn.find('ws-icon:first').replaceWith('<ws-icon name="' + iconName + '"></ws-icon>');
				btn.find('span').html(txt);

				if (action === 'on') {
					App.subscribe.add_me(url);
				} else {
					App.subscribe.remove_me(url);
				}
			});
		},

		init_scroll_zones: function () {
			self.obj_wrapper.find('.scrollZone').not('.ps').each(function() {
				this.scrollBars = App.controls.js_scrollbars.init(this);
			});
		},

		is_shown: function () {
			return App.modal.is_shown() && self.obj_wrapper != null;
		},

		hide: function () {
			App.modal.hide();
		},

		show: function(id, tab) {
			App.bus.app.emit('chat_info_show', { id_chat: +id });
			self.content_loader.abort();
			tab ||= self.last_tab;
			App.modal.show({
				url: App.helper.endpoint.primary() + '?' + App.actions.get('chat_info:show') + '&id=' + id,
				tab
			});
		},

		toggle_tab: App.helper.debounce(function (type) {
			self.obj_wrapper.find('.modal__tabs__item[data-type='+type+']').click();
		}),

		reload: function() {
			App.menu.hide_all();
			self.show(self.id);
		},

		tab_reload: function(data) {
			if (!self.is_shown()) return;
			let arr = Array.from((new Set(data.split(','))).values()), reload_active_tab = null;

			arr.forEach(function(dataType) {
				let tab = self.obj_wrapper.find('.modal__tabs__item[data-type='+dataType+']'), content = self.obj_wrapper.find('.projectView[data-type=' + dataType + ']');

				if (tab.hasClass('active')) {
					content.attr('data-reload', 'yes');
					reload_active_tab = dataType;
				} else {
					content.remove();
				}
			});

			if (reload_active_tab) self.toggle_tab(reload_active_tab);
		},

		add_users: function (anchor, endpoint) {
			App.controls.chat_add_users.show(anchor, endpoint, {
				backup: true,
				type: 'submenu',
				onsuccess: function() {
					App.chat_info.tab_reload('members,about');
				}
			})
		},

		on_members_update: function(id_chat, ids_user) {
			let member_list = $('#obj-chat-modal-members'+id_chat);

			if (member_list.length) {
				let ids_existing = member_list.find('.membersList__user[data-id]').get().map(i => +i.getAttribute('data-id'));
				let ids_removed = ids_existing.filter(i => ids_user.indexOf(i) === -1);
				let ids_added = ids_user.filter(i => ids_existing.indexOf(i) === -1);

				if (ids_added.length) {
					App.chat_info.tab_reload('about,members');
				} else if (ids_removed.length) {
					App.chat_info.tab_reload('about');
					ids_removed.forEach(i => {
						member_list.find('.membersList__user[data-id='+i+']').remove();
					});
					member_list.find('.membersList__group').each(function () {
						if ($(this).children('.membersList__user').length) return;

						$(this).prev('.membersList__spacer').remove();
						$(this).remove();
					});
				}
			} else {
				App.chat_info.tab_reload('about');
			}
		},

		onload: function(type, html) {
			let content = self.obj_wrapper.find('.projectView[data-type='+type+']'),
				restore_scroll_top = content.length ? content.scrollTop() : -1;

			self.obj_wrapper.find('.modal__content__cap').hide();
			content.remove();
			self.obj_wrapper.find('.modal__content').append(html);

			self.init_scroll_zones();

			content = self.obj_wrapper.find('.projectView[data-type='+type+']');

			if (type === 'about') {
				App.controls.project_description.init();
			} else if (type === 'members') {
				App.controls.chat_members.init(content.attr('data-user-cnt'));
			}

			if (restore_scroll_top > 0) content.scrollTop(restore_scroll_top);
		},

		edit_inline: {
			obj: null,
			is_shown() {
				return !!self.edit_inline.obj;
			},
			show: function(type, endpoint) {
				$.ajax({
					url: endpoint,
					success: function(html) {
						if (type  === 'descr') {
							let obj_detach = self.obj_wrapper.find('.projectView__group-descr').addClass('projectView__group-editing').find('.projectView__group__content').hide();
							self.edit_inline.obj = $('<div />').attr('class', 'projectView__group__contentEdit').html(html).insertAfter(obj_detach);
							App.editor.init(self.edit_inline.obj);
						}
					}
				})
			},
			end: function() {
				self.edit_inline.obj.prev().show().parents('.projectView__group-editing').removeClass('projectView__group-editing projectView__group-preview');
				self.edit_inline.obj.remove();
				self.edit_inline.obj = null;
			}
		},

		helper: {
			descr: {
				changed_alert_toggle: function (state) {
					if (!self.is_shown()) return;
					if (state === undefined) throw new Error('`state` must be defined');

					self.obj_wrapper
						.find('.projectDescr .projectView__group__changedAlert')
						.toggleClass('projectView__group__changedAlert--shown', Boolean(state));
				},
				preview_toggle: function (state) {
					if (!self.is_shown()) return;
					if (state === undefined) throw new Error('`state` must be defined');

					self.obj_wrapper
						.find('.projectDescr .projectView__group')
						.toggleClass('projectView__group-preview', Boolean(state));
				},
				accept_current: function () {
					if (!self.is_shown()) return;

					App.controls.project_description.edit_inline_end();
					self.helper.descr.changed_alert_toggle(false);
					setTimeout(() => {
						self.helper.descr.preview_toggle(false);
					}, 401);
				},
				continue_editing: function () {
					if (!self.is_shown()) return;

					self.helper.descr.changed_alert_toggle(false);
					setTimeout(() => {
						self.helper.descr.preview_toggle(false);
					}, 401);
				},
			},
		},

		onBoot: function() {
			self.content_loader = App.core.async_task.context('chat_info');

			App.bus.app.on('modal_load', function () {
				if (+App.modal.obj_window.attr('data-view-chat') !== self.id) return;

				self.obj_wrapper.find('.modal__tabs__item.active').click();
				App.bus.app.emit('chat_info_load', { id_chat: self.id });
			}).on('modal_unload', function () {
				if (+App.modal.obj_window.attr('data-view-chat') !== self.id) return;

				App.bus.app.emit('chat_info_hide', { id_chat: self.id });
				self.content_loader.abort();
				self.id = null;
				self.obj_wrapper = null;
			});

			App.bus.state.on('task_user_from', function (payload) {
				if (self.id === payload.id && self.is_shown()) {
					App.chat_info.tab_reload('members,about');
				}
			});

			App.bus.state.on('task_descr task_attach', App.helper.debounce(function({ id: id_task }, { active_tab }) {

				if (active_tab) return;
				if (!self.is_shown()) return;
				if (+self.id !== +id_task) return;

				if (!active_tab) {
					const chat_o = self.obj_wrapper.find('.projectDescr .projectView__group__content');
					chat_o.load(App.helper.endpoint.task(id_task) + '?' + App.actions.get('task_data_reload:show') + '&field=chat_descr');
				}

				if (
					App.controls.project_description.objEdit
					&& $.contains(App.chat_info.obj_wrapper.get(0), App.controls.project_description.objEdit.get(0))
				) {
					self.helper.descr.changed_alert_toggle(true);
				}
			}));
		}
	};
})();

;var App = App || {};

(function() {
	let self = App.chat_view = {
		window: null,
		old_task_view: null,
		show_page: (data, exit_url) => {
			data.hash = data.hash || '#last';
			return App.task_view.show_page(data, exit_url)
		},

		show: function(data) {
			if (App.comment_form.is_submitting()) return;
			if (!App.windows.before_open(self.window, data)) return;

			if (App.modal.is_shown()) App.modal.hide();
			if (App.menu.is_shown()) App.menu.hide();
			if (App.task_view.is_shown() && !App.task_view.is_chat) self.old_task_view = App.task_view.remember();

			data.hash = data.hash || '#last';
			App.task_view.show(data);
		},

		is_shown: function () {
			return App.task_view.is_shown() && App.task_view.is_chat;
		},

		show_group: function(id, hash, params) {
			params ||= {};
			this.show({ url: '/chat/' + id + '/', hash: hash || '#last', ...params });
		},
		show_personal: function(id, hash, params) {
			params ||= {};
			this.show({ url: '/chat/user/' + id + '/', hash: hash || '#last', ...params });
		},
		team_chat: function(url) {
			App.core.async_task.ajax(url);
		},
		project_chat: function(url) {
			App.core.async_task.ajax(url);
		},

		fullscreen: () => App.task_view.fullscreen(),
		reload: (options) => App.task_view.reload(options),

		hide: () => App.task_view.hide(),
		minimize: () => App.task_view.minimize(),
		delete: () => App.task_view.delete(),
		detach: () => App.task_view.detach(),
		remove: () => App.task_view.remove(),

		remove_from_task_panel: (el) => App.task_view.remove_from_task_panel(el),

		show_comment_panel: function (search_focus) {
			App.task_view.obj_window.addClass('taskView-withCommentPanel');
			if (search_focus) App.comments.search.focus();
		},
		hide_comment_panel: function () {
			App.task_view.obj_window.removeClass('taskView-withCommentPanel');
		},

		scroller: {
			last_dir: 0,
			total_dist: 0,
			prev_top: 0,
			comment_dist_trigger: 0,
			calc_comment_dist_trigger: function () {
				return self.scroller.comment_dist_trigger = App.task_view.obj_window.height()/2;
			},
			onscroll: App.helper.debounce(function (e) {
				let dist = e.target.scrollTop - self.scroller.prev_top, dir = dist > 0 ? 1 : -1;

				if (self.scroller.last_dir !== dir) {
					self.scroller.total_dist = 0; // changed directions
					self.scroller.calc_comment_dist_trigger();
				}

				if (self.scroller.comment_dist_trigger) self.scroller.calc_comment_dist_trigger();

				self.scroller.total_dist += dist;
				self.scroller.last_dir = dir;

				let near_top = e.target.scrollTop < 200;

				if (near_top && dir < 0) {
					self.show_comment_panel();
				} else if (
					(!App.device.is_mobile() || App.task_view.obj_window.hasClass('taskView-withCommentFilter'))
					&& self.scroller.total_dist < self.scroller.comment_dist_trigger*-1
				) {
					self.show_comment_panel();
				} else if (self.scroller.total_dist > 200) {
					self.hide_comment_panel();
				}

				self.scroller.prev_top = e.target.scrollTop;

				App.task_view.obj_window.find('.taskView__head .chatView__users').toggleClass('chatView__users-withTeam', e.target.scrollTop > 200);
			}),
		},

		update_counter: App.helper.debounce(function() {
			let cnt = 0, cnt_active = 0;
			self.helper_get_container(true).find('.chatList__item task-unseen').each(function() {
				cnt += this.tpl_data?.count || 0;
				if (!$(this).parents('.chatList__item-muted').length) cnt_active += this.tpl_data?.count || 0;
			});
			$('#primaryMenu__chat__counter, #mobileMenu__chat__counter').html(cnt ? '<span class="cnt_new">' + cnt + '</span>' : '').toggleClass('primaryMenu__counter-muted', !cnt_active);

			App.mymenu.refresh_chat_counters();
		}, 1000, true),

		on_comment_add: function(id, data) {
			let o = this.helper_get_container().find('.chatList__item[data-chat=' + data.id_task + ']');

			if (!o.length && data.personal) {
				o = this.helper_get_container().find('.chatList__item[data-user=' + data.chat_id_user + '][data-chat=0]');

				if (o.length) {
					o.attr('data-chat', data.id_task);

					let data_unseen = JSON.stringify({
						count: App.me.id !== data.id_user ? 1 : 0,
						id_seen: App.me.id !== data.id_user ? 0 : id,
						id_max: id,
						dt_max: data.dt
					});
					let unseen = $('<task-unseen data-task="'+data.id_task+'" data-format="chat" data-data="'+App.helper.html.encode(data_unseen)+'"></task-unseen>'),
						pin = '<span class="pinned"><ws-icon name="pin-solid"></ws-icon></span>';

					o.find('.details task-unseen').add(o.find('.details .pinned')).remove();
					o.find('.details').append(unseen).append(pin);
					App.components.task_unseen.redraw(unseen.get(0));
				}
			}

			if (!o.length) return App.mymenu.invalidate_window('chats');

			o.removeClass('sidePanel__list__item-waste');

			switch (o.attr('data-type')) {
				case 'project-empty':
					o.attr('data-type', 'project');
					break;
				case 'private-inactive':
				case 'private-empty':
					o.attr('data-type', 'private');
					break;
			}

			o.attr('data-waste', null);
			o.attr('data-last', id);
			o.attr('data-dt', data.dt);
			o.find('.typing').remove();
			o.find('.time').text(
				App.format.date(new Date((+data.dt + App.config.date_timezone_offset) * 1000), DATE_CHAT)
			);
			o.find('.details .user').html(
				'<span class="name">' + App.helper.team(data.id_user, 'name') + '</span>'
				+ ' ' +
				'<span class="place">' + App.helper.team(data.id_user, 'avatar') + '</span>'
			);
			o.find('.details .text').html(data.text || (data.files + ' ' + App.format.quantity(data.files, App.object_state.locale.quantity.file)));

			App.mymenu.refresh_chat_items(this.helper_get_container());
			App.mymenu.sort_chats(this.helper_get_container());
		},

		on_comment_edit: function(id, data) {
			let o = this.helper_get_container().find('.chatList__item[data-chat=' + data.id_task + ']');
			if (o.length && o.attr('data-last') == id) {
				o.find('.details .text').html(data.text || (App.team[data.id_user].files + ' ' + App.format.quantity(App.team[data.id_user].text, App.object_state.locale.quantity.file)));
			}
		},

		on_comment_delete: function(id, data) {
			let o = this.helper_get_container().find('.chatList__item[data-chat=' + data.id_task + ']');
			if (o.length && o.attr('data-last') == id) {
				o.find('.details .text').html(App.object_state.locale['message_deleted']);
			}
		},

		on_comment_clear: function(id_task) {
			let o = this.helper_get_container().find('.chatList__item[data-chat=' + id_task + ']');
			if (o.length) {
				o.find('.details .text').html(App.object_state.locale['message_deleted']);
			}
		},

		on_chat_pin: function(id_task, is_pinned) {
			this.helper_get_container().find('.chatList__item[data-chat=' + id_task + ']').attr('data-pin', is_pinned ? 1 : 0);
			App.mymenu.sort_chats(this.helper_get_container());
		},

		on_chat_delete: function(id_task) {
			if (App.chat_info.is_shown() && +App.chat_info.id === +id_task) {
				App.menu.hide_all();
				App.chat_info.hide();
			}

			let o = this.helper_get_container().find('.chatList__item[data-chat=' + id_task + ']');
			if (o.length) {
				switch (o.attr('data-type')) {
					case 'private':
						o.attr('data-type', 'private-inactive').attr('data-chat', null).find('task-unseen').html('');
						break;
					default:
						o.remove();
				}

				App.mymenu.refresh_chat_items(this.helper_get_container());
				App.mymenu.sort_chats(this.helper_get_container());
			}
		},

		on_chat_members: function (id_task, ids_member) {
			App.chat_info.on_members_update(id_task, ids_member);
			App.task_view_cache.invalidate_chat_members_by_id(id_task);

			let o = this.helper_get_container(true).find('.chatList__item[data-chat=' + id_task + ']');
			if (!o.length) return App.mymenu.invalidate_window('chats');
		},

		on_chat_add: function(id_task, data) {
			let o = this.helper_get_container(true).find('.chatList__item[data-chat=' + id_task + ']');
			if (!o.length) return App.mymenu.invalidate_window('chats');
		},

		on_user_update: function (id, data) {
			let icon_el = $(data.icon);

			self.helper_get_container()
				.find('.chatList__item[data-user='+id+']')
				.find('.user-spec-icon')
				.html(data.icon);

			const update_name = (id_user) => {

				const user_name = App.format.user_name(data);

				// TODO flymod прокинути через task_panel.data + redraw_one?
				// TODO flymod + забули про меню More?
				$('.taskPanel__item-chat[data-href="'+App.helper.url.chat_personal(id_user)+'"] .in').text(user_name);

				for (let url in App.task_view_cache.data) {
					const cache_data = App.task_view_cache.data[url];
					if (cache_data.is_chat >= 0) continue;
					if (-cache_data.is_chat !== id_user) continue;
					const id = +cache_data.id;
					cache_data.obj_window.find('.ht[data-task=' + id + '], [data-task-name='+id+'], [data-role=title][data-task=' + id + ']').text(user_name);
					cache_data.obj_window.filter('.taskView-chat').find('.commentForm-chat[data-task='+id+'] #editor .placeholder').each(function (_, element) {
						const rawTemplate = $(element).attr('data-placeholder-template');
						if (rawTemplate) {
							const renderedTemplate = App.helper.template.fill(rawTemplate, { name: user_name })
							$(element).text(renderedTemplate);
						}
					});
					return;
				}
			};

			update_name(+id);
		},

		helper_get_container: function(strict) {
			let o = $();
			if (App.mymenu.cache['chats']) o = o.add(App.mymenu.cache['chats'].obj_window);
			if (!strict && ['account_dashboard', 'user_dashboard'].includes(App.page.where())) o = o.add('.dashboard__block[data-container=chats]');
			return o;
		},

		onBoot: function() {
			self.window = App.window.chat_view.bind(self);

			App.bus.app.on('task_view_closed', function() {
				if (self.old_task_view) App.helper.nextTick(function() {
					App.task_view.show(self.old_task_view);
					self.old_task_view = null;
				});
			});

			App.bus.state.on('task_read', function () {
				App.chat_view.update_counter();
			});
		},
	}
})();

;var App = App || {};

App.click_listener = {

	is_touching: false,

	is_context: function (e) {
		if (window.stop_click || App.state.drag.is_on) return false;

		if (e.type === 'contextmenu') return true;
		if (e.type === 'auxclick') return false;

		if (App.click_listener.is_moved(e)) return false;

		let key = App.device.is_ios_desktop() ? e.ctrlKey : e.altKey;

		return (e.type === 'click' && key) || (App.click_listener.is_longclick(e) && App.device.is_mobile());
	},
	is_open: function (e) {
		if (window.stop_click || App.state.drag.is_on) return false;

		if (App.click_listener.is_moved(e)) return false;
		if (App.click_listener.is_longclick(e)) return false;

		if (e.type === 'mouseup' && e.which === 2 && !e.altKey && !e.ctrlKey && !e.shiftKey && !e.metaKey) return true; // middle mouse click
		if (e.type === 'auxclick' && e.button === 1 && !e.altKey && !e.ctrlKey && !e.shiftKey && !e.metaKey) return true; // middle mouse click

		let key = App.device.is_ios_desktop()
			? e.metaKey && !e.altKey && !e.ctrlKey && !e.shiftKey
			: e.ctrlKey && !e.altKey && !e.shiftKey;

		return e.type === 'click' && key;
	},
	is_click: function (e) {
		if (window.stop_click || App.state.drag.is_on) return false;
		if (e.type === 'auxclick') return false;

		if (App.click_listener.is_moved(e)) return false;
		if (App.click_listener.is_longclick(e)) return false;

		return e.type === 'click' && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
	},
	is_dblclick: function (e) {
		if (window.stop_click || App.state.drag.is_on) return false;
		if (e.type === 'auxclick') return false;
		if (App.device.is_mobile()) return false;
		if (App.click_listener.is_longclick(e)) return false;

		return e.type === 'dblclick' && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
	},
	is_select: function (e) {
		if (window.stop_click || App.state.drag.is_on) return false;
		if (e.type === 'auxclick') return false;
		if (App.click_listener.is_moved(e)) return false;


		return (e.type === 'click' && e.shiftKey && !e.metaKey && !e.ctrlKey && !e.altKey) || (App.click_listener.is_longclick(e) && !App.device.is_mobile());
	},

	onclick: function (e) {
		try {
			e = (e) ? e : ((event) ? event : null);
			if (!e) return;
			let el = (e.target) ? e.target : ((e.srcElement) ? e.srcElement : null), e_target = el;
			if (!el) return;

			if (window.stop_click) return false;

			App.click_listener.pointer.track(e);

			let o_parents = $(el).parents().addBack();
			if (o_parents.filter('.editor__data').length) return o_parents.filter('.invite, .contact, .inline_task').length === 0;

			if (!App.click_listener.is_moved(e) && !o_parents.filter('input, textarea, .data, .content').length && App.helper.selection.is_not_empty() && e.type === 'click' && !o_parents.filter('.allow_select, [data-allow-select=true]').length) App.helper.selection.clear();
			if ($(el).closest('.menu').length && e.which === 3) return false;

			if (App.click_listener.is_click(e)) {
				if (el.closest('.thickbox') && App.ui.handle_thickbox_click(el)) return false;
				if (el.closest('.help') && App.ui.handle_help_click(el)) return false;
			}

			if (App.click_listener.is_context(e)) {
				return App.click_listener.process_contextmenu(e, e_target);
			}

			if (App.click_listener.is_open(e)) {
				return App.click_listener.process_open(e, e_target);
			}

			let a_el = o_parents.filter('a').get(0);
			if (App.click_listener.is_click(e) && a_el) {
				if (a_el.href) {
					if ($._data(a_el, 'events')?.click != null) {
						let res = $(a_el).triggerHandler('click');
						if (typeof res != 'undefined' && !res) return false;
					}
					if (App.click_listener.intercept_link(a_el)) return false;
				}
				return true;
			}
		} finally {
			App.click_listener.long = false;
		}
	},

	contextmenu_handlers: [
		// Main handlers:
		(t) => App.helper.dom.when_closest(t, '[data-right-click=click]', o => {
			o.click();
		}),
		(t) => App.helper.dom.when_closest(t, '[data-right-click=context]', o => {
			let href = o.attr('data-context-href') ? o.attr('data-context-href') : o.attr('href');

			if (App.helper.validate.task_url.test(href)) {
				App.keyboard_selection.select_by_click(o);
				App.controls.task_menu.show(o, href);
			} else if (o.attr('data-project')) {
				App.keyboard_selection.select_by_click(o);
				App.helper.context_menu.project(o.attr('data-project'), o);
			} else if (href && href.match(App.helper.validate.project_url)) {
				let id_project = RegExp.$1;
				App.keyboard_selection.select_by_click(o);
				App.helper.context_menu.project(id_project, o);
			}
		}),
		(t) => App.helper.dom.when_closest(t, '[data-right-click=none], .editor__toolbar', () => true),
		(t) => App.helper.dom.when_closest(t, '[data-right-click]', (el) => {
			let o = $(el.attr('data-right-click'));

			if (o.attr('data-drop')) {
				App.menu.show({anchor: el, box: '#' + o.attr('id').replace(/__.*/, '') + 'menu', type: el.attr('data-drop-params') || '', title: o.attr('data-drop-title')});
			} else {
				o.trigger('click');
			}
		}),
		// Other handlers:
		(t) => App.controls.user_menu.context_handler(t),
		(t) => App.helper.dom.when_closest(t, '[onclick*=project_view][data-project], a[data-project], .proj_color[data-project], .eventsList__item__projectSmall[data-project]', o => {
			let id_proj = +o.attr('data-project');
			if (!id_proj || isNaN(id_proj)) return false;
			App.helper.context_menu.project(id_proj);
		}),

		(t) => App.helper.dom.when_closest(t, '.viewsList__item[data-id], .viewsList__item[data-tmp-id]', o => {
			App.controls.view_list.show_menu(o);
		}),
		// (e, t) => App.helper.dom.when_closest(t, '.sidePanel__list__item-chat[data-href]', o => {
		// 	let url = o.attr('data-href');
		// 	if (o.attr('data-type').includes('inactive')) return true;
		//
		// 	App.menu.log_mouse_position(e);
		// 	App.keyboard_selection.select_by_click(o);
		// 	App.controls.chat_menu.show(o, url);
		// }),
		(t) => App.helper.dom.when_closest(t, '.taskPanel__item-task[data-href], .menu__item-task[data-href]', o => {
			App.controls.task_menu.show(o, o.attr('data-href'), {
				backup: true
			});
		}),
		(t) => App.helper.dom.when_closest(t, '.taskPanel__item-chat[data-href], .menu__item-chat[data-href]', o => {
			App.controls.chat_menu.show(o, o.attr('data-href'), {
				backup: true
			});
		}),
		(t) => App.helper.dom.when_closest(t, '.dataTable__item[id*=obj-task][data-id]', o => {
			let id_task = +o.attr('data-id');
			if (!id_task || isNaN(id_task)) return false;
			App.keyboard_selection.select_by_click(o);
			App.controls.task_menu.show(o, App.helper.url.task(id_task));
		}),
		(t) => App.helper.dom.when_closest(t, '.dataTable__item[id*=obj-project][data-id], .listing__item[id*=obj-project][data-target]', o => {
			let id = +o.attr('data-id') || +o.attr('data-target');
			if (!id || isNaN(id)) return false;
			App.keyboard_selection.select_by_click(o);
			App.controls.project_menu.show(o, App.helper.endpoint.ajax(id), {context_menu: true});
		}),

		(t) => App.helper.dom.when_closest(t, '.sidePanel__list__item-task[data-task], .subtaskList__item[data-task]', o => {
			let id_task = +o.attr('data-task');
			if (!id_task || isNaN(id_task)) return false;
			App.keyboard_selection.select_by_click(o);
			App.controls.task_menu.show(o, App.helper.url.task(id_task));
		}),

		(t) => App.helper.dom.when_closest(t, '.sidebar__projects__groups .sidebar__projects__group[data-group][data-key=folder]', o => {
			$(o).find('.but.more').addClass('menu_context').trigger('click');
		}),

		(t) => App.helper.dom.when_closest(t, '[data-href], a[href]', o => {
			if (!App.me?.id) return false;
			let url = o.attr('data-href') || o.attr('href'), match;


			if (o.closest('.fileItem__ico').length) return true;

			if (o.closest('.page_content').length) {
				App.controls.ext_link_quick_menu.show(o, url);
				return true;
			}

			match = App.helper.validate.match_account_url(url, App.helper.validate.project_url);
			if (match) {
				App.controls.project_menu.show(o, App.helper.endpoint.ajax(match), {context_menu: true});
				return true;
			}

			match = App.helper.validate.match_account_url(url, App.helper.validate.task_url_any);
			if (match) {
				App.controls.task_menu.show(o, App.helper.url.task(match));
				return true;
			}

			return false;
		}),
		(t) => App.helper.dom.when_closest(t, '[data-anchor]', o => {
			if (!App.me?.id) return false;
			App.anchor.scroll_to(o.attr('data-anchor'), o);
		}),
		//(e, t) => App.helper.dom.when_closest(t, '[onclick], [data-modal-url], button', o => true),
		(t) => App.helper.dom.when_closest(t, '.editor_summary', o => true),
		(t) => App.helper.dom.when_closest(t, '.fileItem', () => true),
		(t) => App.helper.dom.when_closest(t, '.taskView__params__item > .param, .taskView__params__item .value__wrapper, .taskView__params__item a, .commentList__log', o => true),
		// Fallback handlers:
		(t) => App.helper.dom.when_closest(t, 'th', o => {
			if (o.find('.columnChevron').length) {
				o.find('.columnChevron').click();
				return true;
			}

			return false;
		}),
		(t) => App.helper.dom.when_closest(t, '.commentList__item', o => {

			let el;

			if (o.find('.floatIcons.icons-waitPub [data-drop=on]').length) {
				el = o.find('.floatIcons.icons-waitPub [data-drop=on]').get(0);
			} else {
				el = o.find('.floatIcons [data-drop=on]').get(0);
			}

			if (el) App.click_listener.helpers.drop_on_show_menu(el);
		}),
		(t) => App.helper.dom.when_closest(t, '.sidePanel__list__item', o => {
			o.find('.floatIcons [data-action=menu]').click();
		}),
		(t) => App.helper.dom.when_closest(t, '.taskView', o => {
			if (t.closest('button, a').length) return;

			if (App.task_view.is_chat) {
				App.controls.chat_menu.show(o, App.task_view.url, {request: {full: 1}});
			} else {
				App.controls.task_menu.show(o, App.task_view.url, {request: {full: 1}});
			}
		}),
		(t) => App.helper.dom.when_closest(t, 'body [data-project]', o => {
			if (!+o.attr('data-project')) return false;
			let id_proj = +o.attr('data-project');
			if (!id_proj || isNaN(id_proj)) return false;
			if (App.me?.id) App.helper.context_menu.project(id_proj);
		}),
		(t) => App.helper.dom.when_closest(t, 'body[data-project] main', () => {
			let id_proj = +$('body').attr('data-project');
			if (!id_proj || isNaN(id_proj)) return false;
			if (App.me?.id) App.helper.context_menu.project(id_proj);
		}),
	],
	process_contextmenu: function (e, target) {
		let t = $(target);

		if (t.is('input') || t.is('textarea') || target.closest('.editable-value.editing')) return;
		if (t.is('#modal__previewImage')) return;
		if (t.is('.modal__overlay')) return false;
		if (App.device.is_mobile() && target.closest('.page_content')) {
			return;
		}
		if (App.helper.selection.is_not_empty() && target.closest('[data-allow-select=true], .allow_select')) {
			return;
		}
		if (App.device.is_mobile() && !App.click_listener.long) return !!App.core.devtools?.allowNativeContextmenu();

		App.menu.log_mouse_position(e);

		let handler_num = 0;
		App.click_listener.contextmenu_handlers.some(handler => {
			handler_num++;
			return handler(t) !== false;
		});
		App.core.log('process_contextmenu', handler_num);

		return !!App.core.devtools?.allowNativeContextmenu();
	},

	open_handlers: [
		t => App.helper.dom.when_closest(t, 'a[href]', o => {
			App.core.new_window(o.attr('href'));
		}),
		t => App.helper.dom.when_closest(t, '[data-href]', o => {
			App.core.new_window(o.attr('data-href'));
		}),
		t => App.helper.dom.when_closest(t, '[onclick*=project_view][data-project], a[data-project], .proj_color[data-project], .eventsList__item__projectSmall[data-project]', o => {
			let id_proj = +o.attr('data-project');
			if (!id_proj || isNaN(id_proj)) return false;
			App.core.new_window(App.helper.url.project(id_proj));
		})
	],
	process_open: function (e, target) {
		let t = $(target);
		let handler_num = 0;
		App.click_listener.open_handlers.some(handler => {
			handler_num++;
			return handler(t) !== false;
		});
		App.core.log('process_open', handler_num);

		return false;
	},

	intercept_link: function(el) {
		const is_account_url = el.href.match(/https:\/\/[^\/]+/) && App.helper.validate.is_account_url(el.href);

		if (el.target !== '_blank' && !el.hasAttribute('download') && el.href.match(/^(http|https|monaca|monaca-debugger):\/\/[^\/]+/)) {
			App.core.goto(el.href);
			return true;
		}

		if (is_account_url) {
			const url = new URL(el.href);
			let next_url = url.pathname + url.search + url.hash;

			let matched = next_url.match(App.helper.validate.short_file_url);
			if (matched && matched[1]) {
				next_url = '/file/'+matched[1]+'/view/';
			}

			App.core.goto(next_url);
			return true;
		}

		if (el.href.startsWith('otpauth://') || App.hybrid_app) {
			App.core.new_window(el.href);
			return true;
		}

		return false;
	},

	onmouseup: function (e) {
		App.click_listener.pointer.track(e);
	},

	onmousedown: function (e) {

		// waits longtouch
		if (App.click_listener.is_touching) return false;

		App.click_listener.x = e.clientX ?? e.touches?.item(0).clientX;
		App.click_listener.y = e.clientY ?? e.touches?.item(0).clientY;
		App.click_listener.pointer.track(e);

		// TODO: ref to components
		if ($('body').hasClass('login')) return true;
		e = (e) ? e : ((event) ? event : null);
		let el = (e.target) ? e.target : ((e.srcElement) ? e.srcElement : null);
		if ($('#float_edit_inline').length) {
			if (e && !$(e.target).is('#float_edit_inline') && !$(e.target).parents('#float_edit_inline').length) {
				$('#float_edit_inline').remove();
				$('.floatEditAppended').removeClass('floatEditAppended');
				return false;
			}
		}
		if ($('#form_edit_inline').length) {
			if (e && !$(e.target).is('#form_edit_inline') && !$(e.target).parents('#form_edit_inline').length) {
				App.controls.float_edit.delete();
				return false;
			}
		}
		if ($(el).parents().addBack().filter('.click_anyway, #ui-datepicker-div, .ui-timepicker-wrapper').length) return true;
		let o_plus_parents = $(e.target).parents().addBack();
		if (App.menu.is_shown()) {
			if (!o_plus_parents.filter(App.menu.active_box).length && !o_plus_parents.filter('.ignore_hide').length) {
				App.click_listener.helper_stop_click();
				if (App.device.is_mobile() && App.menu.active_box.menu_data.force_dropdown && !$(e.target).closest('.menu').length) {
					App.menu.hide_all();
				} else {
					App.menu.hide(true);
				}
				return false;
			}
		} else if (App.custom_control.active_box) {
			if (!o_plus_parents.filter(App.custom_control.active_box).length) {
				App.click_listener.helper_stop_click();
				App.custom_control.active_box.style.display = 'none';
				App.custom_control.active_box = null;
				return false;
			}
		} else if (App.mymenu.is_shown() && !App.modal.is_shown() && !App.task_view.is_shown()) {
			// if (!o_plus_parents.filter('.sidePanel__wrapper, .menu, .primaryMenu__item[data-custom-page], .timerView').length) {
			// 	App.click_listener.helper_stop_click();
			// 	App.mymenu.hide();
			// 	return false;
			// }
		} else if (App.right_panel.is_shown() && !App.modal.is_shown() && !App.task_view.is_shown()) {
			// if (!o_plus_parents.filter('.rightPanel__wrapper, .menu, .primaryMenu__item[data-custom-page]').length) {
			// 	App.click_listener.helper_stop_click();
			// 	App.right_panel.hide();
			// 	return false;
			// }
		}
		//return true;
	},

	onmouseover: function (e) {
		if (App.scroll_listener.is_scrolling) return;

		e = (e) ? e : ((event) ? event : null);
		if (!e) return;
		el = (e.target) ? e.target : ((e.srcElement) ? e.srcElement : null);
		if (!el) return;
		if ($(el).hasClass('hovLabel') && $(el).attr('for')) {
			let targetEl = $('#'+$(el).attr('for')).closest('.inputCheckbox, .inputRadio');
			targetEl.addClass('hoverFake');
			$(el).bind('mouseleave', ()=>{$(targetEl).removeClass('hoverFake')});
		}
	},

	helper_stop_click: function() {
		window.stop_click = true;
		setTimeout(function () {
			window.stop_click = false;
		}, 200);
	},

	onchange: function (e) {
		e = (e) ? e : ((event) ? event : null);
		if (!e) return;
		let el = (e.target) ? e.target : ((e.srcElement) ? e.srcElement : null);
		if (!el) return;
		if ((el.type === 'checkbox' || el.type === 'radio') && !$(el).hasClass('bind_change')) App.click_listener.onchange_checkbox_helper(el);
	},

	onchange_checkbox_helper: function (el) {
		if (el.type==='radio') $('input[name="'+$(el).attr('name')+'"]').each(function (){ $(this).closest('.act').removeClass('act').closest('.pre_act').removeClass('pre_act') });

		if ($(el).parent().parent().parent().hasClass('label_single')) {
			$(el).parent().parent().parent().parent().parent().find('.label_single').find('input[type=checkbox]').not(el).prop('checked', false).parent().removeClass('act').parent().removeClass('pre_act');
		}

		if ($(el).parent().parent().parent().parent().hasClass('projects__group__content')) {
			if ($(el).prop('checked')) $(el).parent().parent().filter('label, span, .listing__item').addClass('act').parent().addClass('pre_act');
			else $(el).parent().parent().filter('label, span, .listing__item').removeClass('act').parent().removeClass('pre_act');
		}

		// MASS handling ????
		// if ($(el).parent().hasClass('mass')) {
		// 	if ($(el).prop('checked') || $(el).data("indeterminate")) $(el).parent().addClass('mass_act').parent().addClass('mass_pre_act'); else $(el).parent().removeClass('mass_act').parent().removeClass('mass_pre_act');
		// } else if ($(el).parent().parent().hasClass('fileItem')) {
		// 	if ($(el).prop('checked')) $(el).parent().filter('label').addClass('act').parent().addClass('fileItem-active'); else $(el).parent().filter('label').removeClass('act').parent().removeClass('fileItem-active');
		// } else {
		// 	if ($(el).prop('checked') || $(el).data("indeterminate")) $(el).parent().filter('label, span, .listing__item').addClass('act').parent().addClass('pre_act'); else $(el).parent().filter('label, span, .listing__item').removeClass('act').parent().removeClass('pre_act');
		// }
	},

	timeout: null,
	x: 0,
	y: 0,
	long: false,
	pointer: {
		x: 0,
		y: 0,
		element() {
			return document.elementFromPoint(this.x, this.y);
		},
		closest(selector) {
			const el = this.element();
			return el && el.closest(selector) != null;
		},
		track(e) {
			const clientX = e.clientX ?? e.touches?.item(0).clientX;
			const clientY = e.clientY ?? e.touches?.item(0).clientY;
			if (clientX === undefined || clientY === undefined) return;
			this.x = clientX;
			this.y = clientY;
		}
	},

	wait_longstart: function (e) {

		App.click_listener.is_touching = true;

		App.click_listener.long = false;
		if (App.click_listener.timeout) clearTimeout(App.click_listener.timeout);
		App.click_listener.timeout = setTimeout(function () {
			App.click_listener.long = true;
			// App.haptics.contextmenu();
			// setTimeout(() => {
			// 	App.click_listener.onclick(e);
			// }, 40);
			App.click_listener.onclick(e);
			// дочекаємося відкриття меню/модалко/тощо, інакше вони будуть зразу закриватися
			App.click_listener.wait_longend_timeout = setTimeout(() => {
				App.click_listener.is_touching = false;

				if (App.click_listener.timeout) {
					clearTimeout(App.click_listener.timeout);
					App.click_listener.timeout = null;
				}

				App.click_listener.wait_longend_timeout = null;
			}, 250);
		}, 460);

		App.click_listener.x = e.clientX ?? e.touches?.item(0).clientX;
		App.click_listener.y = e.clientY ?? e.touches?.item(0).clientY;
		App.click_listener.pointer.track(e);
	},

	wait_longmove: function (e) {
		if (App.click_listener.timeout) {
			clearTimeout(App.click_listener.timeout);
			App.click_listener.timeout = null;
		}
		App.click_listener.pointer.track(e);
	},

	wait_longend_timeout: null,
	wait_longend: function (e) {

		if (App.click_listener.wait_longend_timeout) return;

		App.click_listener.is_touching = false;

		if (App.click_listener.timeout) {
			clearTimeout(App.click_listener.timeout);
			App.click_listener.timeout = null;
		}
	},

	is_longclick: function (e) {
		return e.originalEvent !== undefined && App.click_listener.long;
	},

	longclick: {
		timeout: null,
		call: function (callback, params) {
			if (window.click_tm) clearTimeout(window.click_tm);
			window.click_tm = setTimeout(callback, 300, params);
		},
		stop: function (e) {
			if (window.click_tm) clearTimeout(window.click_tm);
			e.stopPropagation();
		}
	},

	dblclick: {
		timer: null,
		delay: 200,
		saved_callback: null,
		saved_params: null,

		call: function(callback, params) {
			if (App.device.is_mobile()) { // We Dont Have DBL Click on mobile
				callback(params);
				return;
			}

			App.click_listener.dblclick.saved_callback = callback;
			App.click_listener.dblclick.saved_params = params;

			if (App.click_listener.dblclick.timer) clearTimeout(App.click_listener.dblclick.timer);

			App.click_listener.dblclick.timer = setTimeout(() => {
				App.click_listener.dblclick.timer = null;
				if (App.click_listener.dblclick.saved_callback) {
					App.click_listener.dblclick.saved_callback(App.click_listener.dblclick.saved_params);
					App.click_listener.dblclick.saved_callback = null;
					App.click_listener.dblclick.saved_params = null;
				}
			}, App.click_listener.dblclick.delay);
		},

		stop: function(executeClickFallback = false) {
			if (App.click_listener.dblclick.timer) {
				clearTimeout(App.click_listener.dblclick.timer);
				App.click_listener.dblclick.timer = null;
			}
			if (executeClickFallback && App.click_listener.dblclick.saved_callback) {
				App.click_listener.dblclick.saved_callback(App.click_listener.dblclick.saved_params);
			}
			App.click_listener.dblclick.saved_callback = null;
			App.click_listener.dblclick.saved_params = null;
		}
	},

	is_moved: function (e) {
		const clientX = e.clientX ?? e.touches?.item(0).clientX;
		const clientY = e.clientY ?? e.touches?.item(0).clientY;
		const is_moved = Math.pow(clientX - App.click_listener.x, 2) + Math.pow(clientY - App.click_listener.y, 2) >= 25;
		return is_moved;
	},

	stop_click_if: function(e, callback) {
		$(e.target).parents().addBack().filter('[onclick],[href]').each(function() {
			if (!this.original_attributes) {
				this.original_attributes = {
					onclick: $(this).attr('onclick'),
					href: $(this).attr('href'),
				}
			}
			if (callback(e)) {
				$(this).attr('onclick', '').removeAttr('href');
			} else {
				if (this.original_attributes.onclick) $(this).attr('onclick', this.original_attributes.onclick);
				if (this.original_attributes.href) $(this).attr('href', this.original_attributes.href);
			}
		});
	},

	helpers: {
		drop_on_show_menu: function (el) {
			App.menu.show({
				anchor: el,
				box: '',
				type: el.getAttribute('data-drop-params') || '',
				title: el.getAttribute('data-drop-title')
			});
		}
	},

	init_mouse: function () {
		App.ui.onMouse(document, '[data-drop=on]', {
			onBefore: (e) => {
				e.stop_drag();
				e.cancel = App.state.drag.is_on;
				e.data.menu = $('#' + e.el.id.replace(/__.*/, '') + 'menu').add($('#'+e.el.id+'__menu'));
			},
			click: function (e) {
				App.click_listener.helpers.drop_on_show_menu(e.el);
			},
			dblclick: function (e) {
				let target = e.data.menu.find('.ms_dbl').first();
				if (!target.length) target = e.data.menu.find('.menu__item').first();
				if (target.length) target.correct_click();
			},
			open: function (e) {
				let target = e.data.menu.find('.ms_sft').first();
				if (target.length) target.correct_click();
			},
			context: false
		});

		App.ui.onMouse(document, '.contact[rel]', {
			onBefore: (e) => {
				e.cancel = !!e.target.closest('ws-icon[name*=cancel]') || (e.click && !!e.target.closest('.editor__data'));
			},
			click: e => App.controls.contact_menu.show(e.el.getAttribute('rel')),
			context: e => App.controls.contact_menu.show(e.el.getAttribute('rel'))
		});
		App.ui.onMouse(document, '.invite[rel]', {
			onBefore: (e) => {
				e.cancel = !!e.target.closest('ws-icon[name*=cancel]') || (e.click && !!e.target.closest('.editor__data'));
			},
			click: e => App.controls.user_menu.show(e.el, e.el.getAttribute('rel')),
			context: e => App.controls.user_menu.show(e.el, e.el.getAttribute('rel'))
		});
		App.ui.onMouse(document, '.inline_task[rel]', {
			onBefore: (e) => {
				e.cancel = !!e.target.closest('ws-icon[name*=cancel]') || (e.click && !!e.target.closest('.editor__data'));
				e.data.id_task = e.el.getAttribute('rel');
			},
			click: e => App.core.goto(App.helper.url.task(e.data.id_task)),
			context: e => App.controls.ext_link_quick_menu.show(e.el, App.helper.url.task(e.data.id_task))
			// click: e => App.controls.task_quick_menu.show(e.el, e.data.id_task),
			// context: e => App.controls.task_menu.show(e.el, App.helper.url.task(e.data.id_task))
		});
	},

	onBoot: function () {
		$(document).bind('touchend', App.click_listener.wait_longend);
		$(document).bind('touchmove mousemove', App.click_listener.wait_longmove);
		$(document).bind('mousedown', App.click_listener.onmousedown);
		$(document).bind('mouseup', App.click_listener.onmouseup);
		$(document).bind('mouseover', App.click_listener.onmouseover);
		$(document).bind(App.device.is_mobile() ? 'contextmenu click' : 'click dblclick contextmenu', App.click_listener.onclick);
		$(document).bind('change', App.click_listener.onchange);
		$(document).bind('touchstart', App.click_listener.wait_longstart);
		App.click_listener.init_mouse();
	}
};

;var App = App || {};

(function () {

    const menu_fns = [
        'menu.show',

		'task_edit.visibility',
		'task_edit.assignee',
		'task_edit.author',
		'task_edit.user',
		'task_edit.priority',
		'task_edit.stage',
		'task_edit.tags',
		'task_edit.subscribers',

		'project_edit.user',
		'project_edit.stage',
		'project_edit.tags'
    ];

    let self = App.command_tool = {
        entrypoint: [],
        search_menu_group: null,
        prev_command: null,
        context: {},
        init: function () {
            self.init_search();

            App.modal.obj_window.find('.commandTool__back').on('click', function() {
                self.show(-1)
            });
            App.modal.obj_window.find('.menu-inModal').css('transition', 'all 300ms ease-in-out 0s').on('click', function(e) {
                const link = $(e.target).closest('a.menu__item');

                if (link.length === 0) return;

                if (link.attr('href') && link.attr('target') === '_blank') {
                    self.hide();
                    return App.core.new_window(link.attr('href'));
                }

                if (link.data('type') === 'next') return self.next(link.data('payload'));

                if (link.data('type') === 'script') {
                    return self.hide({
                        callback: function () {
                            if(link.data('payload') != null) $.getScript(link.data('payload'))
                        }
                    });
                }

                if (link.data('type') === 'fn') {
                    const js = link.data('payload');
                    const fn = js.fn.split('.').reduce(function (obj, prop) { return obj[prop] || null; }, window);

                    if (menu_fns.some(k => js.fn.indexOf(k) >= 0)) {
                        const menu_args = js.args.map(i => {

                            if (i === 'this') {
                                return $(e.target).closest('.menu__item').get(0);
                            } else if (i?.anchor === 'this') {
                                return {...i, anchor: $(e.target).closest('.menu__item').get(0)}
                            }

                            return i;
                        })

                        if (typeof fn === 'function') fn(...menu_args)

                        return
                    }

                    return self.hide({
                        callback: function () {
                            if (typeof fn === 'function') fn(...js.args)
                        }
                    })
                }
            })

            if (self.prev_command?.remember_scroll > 0) {
                self.scrollTop(self.prev_command.remember_scroll)
            }
        },
        is_shown: function() {
            return App.modal.is_shown() && App.modal.obj_window.data('group') === 'command_tool';
        },
        hide: function (config) {
            if (!self.is_shown()) return

            this.context = {};
            App.modal.hide(config);
        },
        next: function (id_command) {
            if(id_command == null || id_command.trim() === '') return;

            self.show(id_command);
        },
        back: function () {
            if (self.entrypoint.length === 0) {
                self.hide();
            } else {
                self.show(-1);
            }
        },
        translateX: function (value) {
            App.modal.obj_window.find('.menu-inModal')
                .css('overflow', 'hidden')
                .css('transform', 'translateX(' + value + 'px)')
        },
        scrollTop: function (value) {
            const scroll_zone = App.modal.obj_window.find('.commandTool__body')

            if (typeof value === 'number') {
                setTimeout(function () {
                    scroll_zone.scrollTop(value)
                }, 1)
            }

            return scroll_zone.scrollTop();
        },
        drop_context: function (key, key2) {
            if (!this.is_shown()) return;

            this.context[key] = null;
            if (key2 != null) this.context[key2] = null;

            this.show();
        },
        set_context: function (key, value) {
            if (!this.is_shown() || this.context[key] === value) return;

            this.context[key] = value;
            this.show();
        },
        show: function (next_id_command) {
            if (!this.is_shown()) {
                this.context.id_project = App.current_page.project || null;
                this.context.id_task = App.task_view.id || null;
            }

            let reload = false;

            if (next_id_command == null) {
                self.entrypoint = [];
                self.prev_command = null;
            } else if (next_id_command === -1 && self.entrypoint.length > 0) {
                reload = true;
                self.prev_command = self.entrypoint.pop();
                self.translateX(App.modal.obj_window.width())
            } else if (!self.entrypoint.includes(next_id_command)) {
                reload = true;
                self.entrypoint.push({ id: next_id_command, remember_scroll: self.scrollTop() })
                self.translateX(App.modal.obj_window.width() * -1)
            } else {
                return;
            }

            App.modal.show({
                url: App.helper.url.add_query('/ajax/', App.actions.get('cmd_entrypoint:show'), {
                    ...this.context,
                    page: App.current_page.page || '',
                    entrypoint: self.entrypoint.map(e => e.id).join(','),
                }),
                width: 550,
                group: 'command_tool',
                reload: reload
            });
        },
        init_search: function() {
            App.modal.obj_window.find('.modal__title__search input').bind('keyup', function() {
                App.context_search.menu.apply(this, App.modal.obj_window.find('.menu-inModal'), {
                    callback: self.search_callback
                });
            });

            self.search_group = App.modal.obj_window.find('.commandTool__body .menu__group[data-key=search]')
            self.no_results_group = App.modal.obj_window.find('.commandTool__body .menu__group[data-key=no_results]')
        },
        search_callback: function(has_results) {
            self.search_group.toggleClass('menu__group-hidden', !has_results)
            self.no_results_group.toggleClass('menu__group-hidden', has_results)

            if (has_results) return;

            const search_query = App.modal.obj_window.find('.modal__title__search input').val();

            self.no_results_group.find('.user_query').text('"' + search_query + '"')
            self.no_results_group.find('a').attr('href', '/search/?search=' + encodeURIComponent(search_query))
        }
    }
})()

;var App = App || {};

(function() {
	let self = App.comment_form = {
		obj_detached: null,
		edit_id: 0,
		obj: null,
		form: null,
		submit_by_enter: false,
		last_touch_timestamp: null,
		is_shown: function () {
			return !!self.obj;
		},
		is_submitting: function () {
			return App.core.async_task.is_loading('comment_form_submit');
		},
		init_scroll_zones: function() {
			if (self.obj == null) return;
			self.obj.find('.scrollZone').not('.ps').each(function() {
				this.scrollBars = App.controls.js_scrollbars.init(this);
			});
		},
		destroy_scroll_zones: function() {
			if (self.obj == null) return;
			self.obj.find('.scrollZone').each(function() {
				if (this.scrollBars) this.scrollBars.destroy();
			});
		},
		reinit_scroll_zones: function () {
			self.destroy_scroll_zones();
			self.init_scroll_zones();
		},
		scroll_to_cursor: function() {
			App.helper.nextTick(() => {
				self.obj.find('.scrollZone').scrollToCaret();
			});
		},
		init: function () {
			self.obj = App.task_view.obj_window.find('.commentForm');
			if (!self.obj.length) return;

			self.form = self.obj.get(0);
			App.draft.bind(self.form, 'task_view');
			App.upload.attach.update_counter(true);
			self.visibility.set();
			self.obj.find('.editor__data').bind('focus', function() {
				self.start();
			});
			self.obj.find('.editor_summary').bind('click', function() {
				// self.start();
				// self.focus();
				App.editor.focus(); // try to fix IOS focus bug
				// if (App.device.is_sm_width()) App.helper.nextTick(self.expand);
			});
			self.obj.find('.commentForm__content').once_by_criteria('comment_form_init').bind('click', function (e) {
				if (!App.device.is_mobile() && $(e.target).hasClass('commentForm__content')) {
					self.focus();
				}
			});
			self.obj.find('#post_button, #post_button-mobile').once_by_criteria('comment_form_init').bind('click', function (e) {
				if (App.comments.options.filter !== '') App.comments.filter_update('');
				if (App.comments.options.type === 'log') App.comments.type_update('comment');
				self.submit();
			});
			self.obj.find('.hidden, .hidden_remove').once_by_criteria('comment_form_init').bind('click', () => App.comment_form.visibility.show());

			self.obj.find('[name=ids_invite]').once_by_criteria('comment_form_init').bind('update', function () {
				self.update_invites();
			});

			App.ui.onMouse(self.obj.once_by_criteria('comment_form_init1'), '.commentForm__subscribers', {
				click: (e) => App.task_edit.subscribers(e.target),
			});
			App.ui.onMouse(self.obj.once_by_criteria('comment_form_init2'), '.commentForm__subscribers__item', {
				click: (e) => App.task_edit.subscribers(e.target),
				context: (e) => {
					if (self.show_subscriber_menu(e.el) === false) {
						App.controls.user_menu.context_handler(e.target)
					}
				},
				open: (e) => self.silence.toggle_subscriber(e.el)
			});

			self.init_mobile_blur_handler();
			self.init_mobile_toggle_notify();

			self.obj.toggleClass('commentForm-haveAnyData', self.check_have_data());

			if (self.obj.hasClass('commentForm-haveAnyData')) {
				$('#comment_closed').hide(); self.obj.show();
			} else if ($('#comment_closed').length === 1) {
				$('#comment_closed').show(); self.obj.hide();
			}

			App.comment_form.update_summary();
			self.stop();
			self.update_submit_option();
		},
		init_mobile_blur_handler: function () {
			if (!self.obj) return;

			self.obj.once_by_criteria('comment_form_init_blur').on('mousedown', function (e) {

				if (!App.device.is_mobile()) return;

				const $el = $(e.target);
				// input is file-preview-name
				if ($el.closest('[contenteditable=true], input', self.obj.get(0)).length) return;
				e.preventDefault();
				App.editor.set_skip_next_blur(true);
			});
		},
		init_mobile_toggle_notify: function () {
			if (!self.obj) return;

			self.obj.find('.commentForm__left .toggleCommentFormNotify').once_by_criteria('comment_form_init').on('mousedown', function (e) {

				if (!App.device.is_mobile()) return;
				if (self.is_expanded()) return;

				if (!self.is_started()) {
					App.comment_form.start();
					if (!App.task_view.is_chat) self.obj.addClass('commentForm-showNotify');
					return;
				}

				if (!App.task_view.is_chat) {
					e.preventDefault();
					// App.editor.set_skip_next_blur(true);
					self.obj.toggleClass('commentForm-showNotify');
				}
			});
		},
		show_subscriber_menu: function (el) {
			let sub = $(el).closest('.commentForm__subscribers__item:not([data-id="4"])');
			let sub_id = sub.length ? sub.attr('data-id').toInt() : null;
			let sub_is_hidden = sub.hasClass('commentForm__subscribers__item-hidden');

			if (!sub_id || sub_id === App.me.id) return false;

			App.menu.show({
				anchor: sub,
				box: '#commentForm_subscriber_menu',
				type: 'left',
				onshow: function () {
					let menu = $(this);

					menu.find('.menu__itemFake-userCard .av').html(App.helper.team(sub_id, 'avatar'));
					menu.find('.menu__itemFake-userCard .name').text(App.helper.team(sub_id, 'name'));
					menu.find('.menu__itemFake-userCard > ws-btn').attr('data-user-card', sub_id);

					menu.find('.menu__item').toggleClass('menu__item-hidden', sub_is_hidden);
					menu.find('.menu__item[data-key=unlock]').toggleClass('menu__item-hidden', !sub_is_hidden);

					menu.find('.menu__group').each(function () {
						let total = $(this).find('.menu__item').length;
						if (total > 0) $(this).toggleClass('menu__group-hidden', total === $(this).find('.menu__item.menu__item-hidden').length);
					});

					menu.find('.menu__item[data-key=remove]').off('click').on('click', function () {
						App.menu.hide();
						$.getScript(App.helper.url.add_query($(this).attr('data-url'), 'ids_user='+self.get_ids_subscriber().filter(i => i !== sub_id).join(',')));
					});
					menu.find('.menu__item[data-key=lock], .menu__item[data-key=unlock]').off('click').on('click', function () {
						App.menu.hide();
						self.visibility.toggle(sub_id);
					});
					menu.find('.menu__item[data-key=silent]').off('click').on('click', function () {
						App.menu.hide();
						self.silence.add(sub_id);
					});
				}
			});
		},
		update_submit_option: function () {
			if (self.obj == null) return;

			self.submit_by_enter = self.obj.hasClass('commentForm-chat') && App.config.send_chat_opt === '2';

			let o = self.obj.find('.commentForm__foot-keyInfo');
			o.children('.send').text(self.submit_by_enter ? o.attr('data-enter') : o.attr('data-ctrl-enter'));
			o.children('.nl').text(!self.submit_by_enter ? o.attr('data-enter') : o.attr('data-ctrl-enter'));

			$('#commentForm_send_menu .menu__item[data-key=send] .hot_key').text(self.submit_by_enter ? o.attr('data-enter') : o.attr('data-ctrl-enter'));
		},
		get_ids_subscriber: function () {
			let ids = [];
			self.obj.find('.commentForm__subscribers .commentForm__subscribers__item[data-id]').each(function() {
				ids.push($(this).attr('data-id').toInt());
			});
			return ids;
		},
		is_started: function () {
			return self.obj.hasClass('commentForm-start');
		},
		start: function () {
			if (self.form == null) return;
			// if (App.offline_mode.is_on()) return;

			self.obj.toggleClass('commentForm-haveAnyData', self.check_have_data());

			if (self.is_started()) return;

			self.obj.addClass('commentForm-start');
			self.init_scroll_zones();
			if (App.device.is_mobile()) self.scroll_to_cursor();
		},
		stop: function () {
			if (!self.is_started() || self.form == null) return;

			self.destroy_scroll_zones();
			self.update_summary();
			self.obj.removeClass('commentForm-start');
			self.obj.toggleClass('commentForm-haveAnyData', self.check_have_data());

			self.collapse();
		},
		check_stop: function (click_target) {
			if (App.device.is_mobile()) return;
			if (self.is_expanded()) return;
			if (self.obj.closest('.commentList__item').length > 0) return;
			if ($(click_target).closest('.commentForm, #ui-datepicker-div, .ui-timepicker-wrapper').length > 0) return;
			if ($(click_target).closest('.comment_unseen_popup, .commentList, .menu, ws-btn, #modalWindow_container, #menuOverlay, #modalContainer').length > 0) return;

			self.stop();
		},
		mobile_check_stop: function (click_target) {
			if (!App.device.is_mobile()) return;
			if (self.is_expanded()) return;
			if (self.obj.closest('.commentList__item').length > 0) return;
			if ($(click_target).closest('.commentForm, #ui-datepicker-div').length > 0) return;
			if ($(click_target).closest('.comment_unseen_popup, .menu, ws-btn, #modalWindow_container, #menuOverlay, #modalContainer').length > 0) return;

			// console.trace('click_target', click_target.tagName, click_target);
			self.stop();
		},
		update_invites: function (o) {
			o = o || self.obj;

			let ids_invite = o.find('[name=ids_invite]').val().toIntArray();

			ids_invite = ids_invite.filter((id, index) => ids_invite.indexOf(id) === index)

			let ids_user = [];

			o.find('.commentForm__subscribers .commentForm__subscribers__item[data-id]').each(function() {
				ids_user.push($(this).attr('data-id').toInt());
			});

			let items = ids_invite.filter(function (id) {
				if (id == null || isNaN(id)) return false;
				if (id == App.me.id || ids_user.includes(id)) return false;

				return true;
			}).map(function (id_user) {
				return App.helper.template.fill('task_view_subscriber', {
					name: App.helper.team(id_user, 'name'),
					avatar: App.helper.team(id_user, 'avatar'),
					id: id_user,
				})
			});

			o.find('.commentForm__invites .in').html(items.join(''));

			if (items.length > 3) {
				let titles = o.find('.commentForm__invites .commentForm__subscribers__item').get().slice(2).map(el => el.getAttribute('data-title'));
				let label = o.find('.commentForm__invites').attr('data-label');
				o.find('.commentForm__invites .in').append(
					$('<span>', {
						class: 'more',
						'data-title': ('%G' + label + ':G%\n' + (titles.length > 10 ? titles.slice(0, 10).join(', ') + '\n+ ' + (titles.length - 10) : titles.join(', '))),
						html: '<ws-icon name="more_sm-horiz"></ws-icon>'
					})
				);
			} else {
				o.find('.commentForm__invites .in .more').remove();
			}

			o.find('.commentForm__subscribers .commentForm__subscribers__item').each(function() {
				$(this).toggleClass('commentForm__subscribers__item-mention', ids_invite.includes($(this).attr('data-id').toInt()));
			});
		},
		update_summary: function () {
			let html = self.obj.find('.editor__data').html();
			let $dom = $('<div>').html(html);
			$dom.find('.invite span').remove();
			let text = $dom.text();
			self.obj.find('.editor_summary > div:first-child > span').text(text)
			let count_attachments = self.obj.find('.attachWrapper .fileItem').not('.fileItem-preDeleted').length;
			self.obj.find('.editor_summary > div:last-child ws-btn').attr('text', count_attachments);
			self.obj.find('.editor_summary > div:last-child').toggle(count_attachments>0);
			self.obj.toggleClass('commentForm__withAttachments', count_attachments>0);
		},
		fullscreen_helper: function() {
		},
		fullscreen: function (on) {
		},
		scroll_to_edit: function () {
			if (!self.edit_id) return;

			App.task_view.scroller.scrollto('comment_edit');
		},
		edit: function (id, action) {
			App.menu.hide(true);
			App.task_view.scroller.remember('comment_edit');
			if (!self.edit_id) {
				self.detach();
			} else {
				self.obj.remove();
				$('#obj-comment' + self.edit_id).removeClass('pre_edit').children('.in').show();
			}
			App.draft.unbind();
			self.edit_id = id;
			$.ajax({
				url: App.helper.url.add_query(App.comments.url, action + '&id_comment=' + id),
				type: 'GET',
				dataType: 'html',
				timeout: App.env === 'local' ? 60000 : 10000,
				context: this,
				success: function (html) {
					App.task_view.obj_window.addClass('taskView-withCommentEdit');
					App.comments.set_active_comment('#obj-comment' + self.edit_id);

					let obj_comment = $('#obj-comment' + self.edit_id);
					obj_comment.addClass('pre_edit').append(html).children('.in').hide();

					App.comment_form.editor_init(obj_comment);
					App.controls.wait_post.init();
					App.upload.attach.update_counter();
					self.init();
					self.start();
					// self.expand();
					App.helper.nextTick(self.expand);
					setTimeout(function () { App.editor.focus(false); }, 150);
					if (!App.device.is_mobile()) App.upload.init(self.obj.find('.drop_zone_body'));
				}
			});
			return true;
		},
		detach: function() {
			self.obj_detached = self.obj.detach();
			$('#comment_continue').show();
		},
		cancel_edit: function (force) {
			App.menu.hide_all();
			self.stop();

			if (self.edit_id) {
				self.obj.remove();
				App.controls.wait_post.remove();
				App.task_view.obj_window.removeClass('taskView-withCommentEdit');
				$('#obj-comment' + self.edit_id).removeClass('pre_edit').children('.in').show();
				App.task_view.scroller.restore('comment_edit');
				self.restore();
			}
			else if (force) self.restore();
		},
		restore: function () {
			if (self.obj_detached == null) return;
			if (App.task_view.edit_inline.is_shown()) return;
			self.stop();
			self.fullscreen(false);
			$('#comment_new').append(self.obj_detached);
			$('#comment_continue').hide();
			if (self.edit_id) {
				self.obj.remove();
				self.edit_id = 0;
				self.obj = self.obj_detached;
			}
			self.obj_detached = null;
			self.form = self.obj.get(0);
			$(self.form).removeClass('commentForm-haveAnyData').removeClass('commentForm-start');
			App.comment_form.editor_init(self.form);
			App.draft.bind(self.form, 'task_view');
		},
		reply: function (hidden, name, id) {
			App.menu.hide(true);
			self.visibility.set(hidden ? hidden.split(',') : [])

			self.goto();
			self.obj.find('.reply').addClass('reply_act');
			self.obj.find('.reply .in').html(name);
			self.obj.find('.reply_body').attr('data-anchor', "#com" + id).attr('onclick', "App.comments.set_active_comment('#obj-comment" + id + "'); return false");
			self.obj.find('.quote_reply').html($('#obj-comment'+id).attr('data-txt'));
			self.obj.find('input[name="id_reply"]').val(id);
			self.obj.find('.commentForm__reply').toggleClass('commentForm__reply-hidden', !!hidden).show();
			self.onresize();
		},
		cancel_reply: function (el) {
			self.obj.find('input[name="id_reply"]').val('0');
			self.obj.find('.quote_reply').html('');
			self.obj.find('.reply').removeClass('reply_act');
			self.obj.find('.commentForm__reply').hide();
			App.comment_form.onresize();
		},
		silence: {
			set: function(new_value) {
				if (new_value == null) return;

				new_value = new_value.map(Number).filter(isFinite);
				self.obj.find('input[name=ids_silent]').val(new_value.join(','));
				self.obj.trigger('change');

				let ids_user = [];
				self.obj.find('.commentForm__subscribers__item').not('[data-id=4]').each(function () {
					ids_user.push(Number($(this).attr('data-id')))
				});

				App.task_view.subscribers.update_html(self.obj, ids_user);
				self.visibility.set();
			},
			value: function () { return self.obj.find('input[name=ids_silent]').val().toIntArray(); },
			has_id: function (id) { return self.silence.value().includes(Number(id)); },
			add: function (id) {
				if (self.silence.has_id(id)) return;
				self.silence.set([...self.silence.value(), id]);
			},
			remove: function (id) {
				if (!self.silence.has_id(id)) return;
				self.silence.set(self.silence.value().filter(i=>i!==id));
			},
			reset: function () {
				self.silence.set([]);
			},
			toggle_subscriber: function (el) {
				let sub = $(el).closest('.commentForm__subscribers__item:not([data-id="4"])');
				let sub_id = sub.length ? sub.attr('data-id').toInt() : null;

				if (!sub_id || sub_id === App.me.id) return false;

				if (self.silence.has_id(sub_id)) {
					self.silence.remove(sub_id);
				} else {
					self.silence.add(sub_id);
				}
			}
		},
		visibility: {
			_visibility_snapshot: null,
			_visibility_menu_saved: false,
			set: function(hidden) {
				if (typeof hidden == 'undefined') {
					hidden = self.obj.find('input[name=hidden]').val().toIntArray();
				} else {
					hidden = hidden.map(Number);

					self.obj.find('input[name=is_hidden]').val(hidden.length ? 1 : 0);
					self.obj.find('input[name=hidden]').val(hidden.join(','));
					self.obj.trigger('change');
				}

				self.obj.find('.place_button .hidden').toggle(!hidden.length).next().toggle(!!hidden.length);
				self.obj.find('.commentForm__subscribers .commentForm__subscribers__item').each(function () {
					$(this).toggleClass('commentForm__subscribers__item-hidden', !!hidden.length && !hidden.includes($(this).attr('data-id').toInt()));
				});
			},
			toggle: function (id) {
				let is_hidden = self.obj.find('input[name=is_hidden]').val().toInt() === 1;
				let hidden = is_hidden ? self.obj.find('input[name=hidden]').val().toIntArray() : self.get_ids_subscriber();

				self.visibility.set(App.helper.array.toggle(hidden, Number(id)));
			},
			preset: function(type) {
				App.menu.hide(true);
				if (App.device.is_mobile()) self.expand();
				if (type === 'custom') {
					App.comment_form.visibility.show(false, true);
					return false;
				}
				if (type) App.controls.user_select_and_go.team(App.helper.url.add_query(App.task_view.url, App.actions.get('task_user_select_and_go:team')) + '&preset=' + type, function(ids) {
					ids = ids.map(Number);
					let ids_invite = App.comment_form.obj.find('[name=ids_invite]').val().toIntArray();
					ids_invite.forEach(function(id) {
						if (!ids.includes(id)) ids.push(id);
					});
					App.comment_form.visibility.set(ids);
				});
			},
			show: function (skip, force_show_context) {

				if (skip) {
					self.obj.addClass('commentForm-withHideDialog');
					return false;
				}
				let el = self.obj.find('.hidden, .hidden_remove').filter(':visible').get(0);
				let hidden = self.obj.find('input[name=hidden]').val().toIntArray();

				if (!hidden.length && force_show_context !== true) {
					App.menu.show({
						anchor: el,
						box: '#taskView__menu__visibility_preset'
					});
				} else {
					self.visibility._visibility_menu_saved = false;
					self.visibility._visibility_snapshot = {
						is_hidden: self.obj.find('input[name=is_hidden]').val(),
						hidden: self.obj.find('input[name=hidden]').val(),
					};
					App.controls.visibility_switch_and_go.show_context(el, App.helper.url.add_query(App.task_view.url, App.actions.get('task_user_select_and_go:show')), {
						request: {type: 'visibility'},
						cache_trigger: 'user,task' + App.task_view.id + ':visibility',
						onload: function () {
							let menu = $(this);
							menu.off('click.comment_visibility.done', '.menu__group-head ws-btn').on('click.comment_visibility.done', '.menu__group-head ws-btn', function () {
								let hidden = [];
								menu.find('.menu__item-active[data-id]').each(function () {
									hidden.push($(this).attr('data-id').toInt());
								});
								self.visibility._visibility_menu_saved = true;
								App.menu.hide();
								if (App.device.is_mobile()) self.expand();
								self.visibility.set(hidden);
							});
							menu.off('click.comment_visibility.clear', '.menu__group-bottom ws-btn').on('click.comment_visibility.clear', '.menu__group-bottom ws-btn', function () {
								self.visibility._visibility_menu_saved = true;
								App.menu.hide();
								if (App.device.is_mobile()) self.expand();
								self.visibility.set([]);
							});
						},
						onshow: function () {
							let menu = $(this);
							let hidden_defaults = App.comment_form.obj.find('[name=ids_invite]').val().toIntArray();
							hidden_defaults.push(App.me.id);

							menu.find('.menu__item[data-id]').each(function () {
								$(this).toggleClass('menu__item-active', hidden.includes($(this).attr('data-id').toInt()) || hidden_defaults.includes($(this).attr('data-id').toInt()));
								$(this).toggleClass('menu__item-default', hidden_defaults.includes($(this).attr('data-id').toInt()));
							});
						},
						onhide: function () {
							self.visibility.on_menu_hide();
						},
					});
				}
			},
			on_menu_hide: function () {
				if (self.visibility._visibility_menu_saved) {
					self.visibility._visibility_menu_saved = false;
					self.visibility._visibility_snapshot = null;
					return;
				}
				let snapshot = self.visibility._visibility_snapshot;
				if (!snapshot) return;
				self.obj.find('input[name=is_hidden]').val(snapshot.is_hidden);
				self.obj.find('input[name=hidden]').val(snapshot.hidden);
				self.visibility._visibility_snapshot = null;
				self.visibility.set();
			},
			apply: function () {
				self.obj.removeClass('commentForm-withHideDialog');
				let str = '';
				$('#member .hid').each(function () {
					str += (str ? ', ' : '') + $(this).justtext();
				});
				self.obj.find('.restrict2').addClass('restrict_act').find('font').html(str);
				self.onresize()
			},

		},
		is_expanded: function () {
			return self.obj && self.obj.closest('.taskView').hasClass('taskView-comment_expanded');
		},
		toggle_expand: function () {
			if (this.is_expanded()) {
				this.collapse();
			} else {
				this.expand();
			}
		},
		expand: function () {
			if (self.is_expanded()) return;
			let edit_id = self.obj.attr('data-comment');

			$('body').addClass('taskViewCommentExpanded');
			self.obj.closest('.taskView').addClass('taskView-comment_expanded');

			if (edit_id != null) {
				$('#comment_new').append(self.obj);
				App.comment_form.editor_init(self.obj);
			}

			let btn = self.obj.find('.input_expand');
			btn.attr('data-title', btn.attr('data-title2')).attr('right-icon', 'arrows/input_collapse');

			App.editor.show_toolbar();

			if (!self.is_started()) {
				App.helper.nextTick(function () {
					self.start();
					App.editor.focus();
					if (App.device.is_mobile()) self.scroll_to_cursor();
				});
			} else {
				if (App.device.is_mobile()) self.scroll_to_cursor();
			}
		},
		collapse: function () {
			if (!self.is_expanded()) return;
			let edit_id = self.obj.attr('data-comment');

			if (edit_id != null) {
				$('#obj-comment'+edit_id+' > .in').after(self.obj);
				App.comment_form.editor_init(self.obj);
			}

			$('body').removeClass('taskViewCommentExpanded');
			self.obj.closest('.taskView').removeClass('taskView-comment_expanded');

			// App.editor.auto_height = false;
			// App.editor.onresize()

			if (App.device.is_mobile()) {
				App.editor.toggle_toolbar(false);
			} else{
				App.editor.restore_toolbar_state();
			}

			if (App.device.is_mobile()) self.obj.css('height', '100%');

			let btn = self.obj.find('.input_expand');
			btn.attr('data-title', btn.attr('data-title1')).attr('right-icon', 'arrows/input_expand');

			if (!App.device.is_mobile() && self.is_started()) {
				App.helper.nextTick(function () {
					self.start();
					App.editor.focus();
				});
			}
		},
		goto: function goto() {
			if (self.edit_id) self.cancel_edit();
			self.focus();
		},
		check_have_data: function () {
			return !App.editor.is_empty_body() || $(self.form).find('.attachWrapper .fileItem').not('.fileItem-preDeleted').length > 0;
		},
		check_submit_allowed: function () {

			if (self.edit_id && App.controls.wait_post.calc_time_left() < 0) {
				App.message.warning(App.i18n.t('comment_already_published'));
				return false;
			}

			App.editor.save();
			if ($(self.form).find('.loadingimg').length) {
				alert($(self.form).attr('rel'));
				return false;
			}
			if ($(self.form).hasClass('sent')) {
			} else if (self.check_have_data()) {
				return true;
			}
		},
		submit_silently: function () {
			App.comment_form.obj.find('[name=skip_notify]').val('1');
			App.comment_form.submit();
		},
		submit_no_client: function () {
			App.comment_form.obj.find('[name=skip_notify_client]').val('1');
			App.comment_form.submit();
		},
		submit: function () {

			if (App.offline_mode.is_on()) return;

			if (self.check_submit_allowed(self.form)) {
				$(self.form).addClass('sent');
				let id = $(self.form).attr('data-comment');
				let post_button = $(self.form).find('#post_button'), post_button_mobile = $(self.form).find('#post_button-mobile');
				let post_button_inner = post_button.html(), post_button_mobile_inner = post_button_mobile.html();

				// на мобілі не прибираємо фокус, щоб не згорталася клавіатура, а то через це форма не відправляється, бо кнопка змінює позицію
				if (document.activeElement instanceof HTMLElement && !App.device.is_mobile()) document.activeElement.blur();

				post_button.html('<ws-icon name="input-circle-blank:stopwatch_parts-rotation" class="btn-left-icon ws-icon-spinner"></ws-icon>');
				post_button_mobile.html(post_button.html());

				const removeLoading = function () {
					App.task_view.obj_window.removeClass('taskView-withCommentEdit');
					post_button.html(post_button_inner);
					post_button_mobile.html(post_button_mobile_inner);
					$(self.form).removeClass('sent');
				};

				const after_submit = function () {
					self.cancel_reply();
					self.silence.reset();
					if (App.device.is_mobile()) self.stop();
					self.collapse();
				};

				App.core.async_task.ajax({
					id: 'comment_form_submit',
					url: $(self.form).attr('action'),
					type: 'POST',
					dataType: 'script',
					data: $(self.form).serialize(),
				}).then(function () {
					let id_comment = App.core.context.use('comment_save_id');

					if ($(self.form).attr('data-comment')) {
						removeLoading();
						$('#obj-comment' + id).removeClass('pre_edit');
						App.comments.set_active_comment('#obj-comment' + id);
						self.restore();
						after_submit();
						return;
					}

					App.draft.pre_delete();
					App.core.async_task.run('comment_form_submit', function wait_for_comment_show(signal) {
						return App.helper.promise.wait_for(() => $('#obj-comment'+id_comment).length !== 0, 5000, signal);
					}).finally(function () {
						App.draft.delete();
						removeLoading();
						after_submit();
					});

				}).catch(function () {
					removeLoading();
				});

				return true;
			}
			return false;
		},
		onkeydown: function (e) {
			if (!self.is_shown() || !self.is_started()) return false;

			const key = e.keyCode ? e.keyCode : e.charCode, alt = e.altKey, ctrl = e.metaKey || e.ctrlKey, shift = e.shiftKey;

			if (key === App.keycode.Enter && !App.menu.is_shown() && !App.modal.is_shown()) {
				if (alt && ctrl && !shift) {
					self.submit_silently(); return true;
				}
				if (ctrl && !alt && !shift && !self.submit_by_enter) {
					self.submit(); return true;
				}
				if (ctrl && !alt && !shift && self.submit_by_enter) {
					App.editor.button('new_line');
					return true;
				}
				if (!ctrl && !alt && !shift && self.submit_by_enter) {
					self.submit(); return true;
				}
			}

			return false;
		},
		update_file_counter: function (skip_resize) {
			self.update_summary();
			self.obj.toggleClass('commentForm-haveAnyData', self.check_have_data());
			if (!skip_resize) self.onresize();
		},
		onresize: function () {
		},
		focus: function (delay) {
			$('#comment_closed').hide();
			self.obj.show();
			setTimeout(App.editor.focus, delay ? delay : 50);
		},
		insert_link: function (text, href, just_text, stage) {
			text = text.trim();
			stage = stage || '';
			let taskId = 0;
			const match = href.match(/\/task\/(\d+)(?:\/|$)/);
			if (match) taskId = match[1];

			if (!text) return;
			if (!/^https?:\/\//.test(href)) href = document.location.protocol + '//' + document.location.host + href;
			let span;
			let ico_delete = '<ws-icon name="cancel_sm:cancel_sm-solid"></ws-icon>';
			if (just_text) {
				span = document.createTextNode(text);
			} else {
				span = $('<a></a>')
					.addClass('inline_task')
					.attr('spellcheck', false)
					.attr('contenteditable', false)
					.attr('href', href)
					.attr('rel', taskId)
					.html(stage + '<span>' + App.helper.html.encode(text) + '</span>' + ico_delete)
					.get(0);
			}
			App.editor.insert(span, true);
			if (App.menu.in_editor) {
				App.menu.hide();
				return false;
			}
		},
		get_selection: function (element, post) {
			let win = window, doc = document;
			let res = {
				text: '',
				start: 0,
				end: 0
			};
			if (win.getSelection) {
				res.start = element.selectionStart;
				res.end = element.selectionEnd;
				res.text = element.value.slice(res.start, res.end);
			} else if (doc.selection) {
				element.focus();
				let range = doc.selection.createRange(),
					range2 = doc.body.createTextRange();

				res.text = range.text;

				try {
					range2.moveToElementText(element);
					range2.setEndPoint('StartToStart', range);
				} catch (e) {
					range2 = element.createTextRange();
					range2.setEndPoint('StartToStart', range);
				}
				res.start = element.value.length - range2.text.length;
				res.end = res.start + range.text.length;
			}
			if (post && res.start > 0) res.start--;
			return res;
		},
		set_selection: function (element, toRange, caret) {
			let win = window, doc = document;
			if (caret === 'start') {
				toRange.end = toRange.start;
			} else if (caret === 'end') {
				toRange.start = toRange.end;
			}
			element.focus();
			try {
				if (element.createTextRange) {
					let range = element.createTextRange();

					if (win.navigator.userAgent.toLowerCase().indexOf("msie") >= 0) {
						toRange.start = element.value.substr(0, toRange.start).replace(/\r/g, '').length;
						toRange.end = element.value.substr(0, toRange.end).replace(/\r/g, '').length;
					}
					range.collapse(true);
					range.moveStart('character', toRange.start);
					range.moveEnd('character', toRange.end - toRange.start);
					range.select();
				} else if (element.setSelectionRange) {
					element.setSelectionRange(toRange.start, toRange.end);
				}
			} catch (e) {
				/* give up */
			}
		},
		cursor_at_word_begin: function (element, post) {
			let res = self.get_selection(element, post);
			return res.start === 0 || /\s/.test(element.value[res.start - 1]);
		},

		editor_init: function (obj) {
			App.editor.init(obj, {
				onkeydown: App.comment_form.onkeydown,
			});
		},

		// on_keyboard_state: function () {
		// 	if (!self.is_shown() || !self.obj || !self.is_expanded() || $(window).width() > APP_SCREEN_THRESHOLD) return;

		// 	self.obj.css('height', App.controls.keyboard_detect.last_state ? App.helper.viewport.height() : '100%');
		// 	self.reinit_scroll_zones();
		// },

		onBoot: function () {
			self.obj = $();
			$(document).bind('mousedown', function (e) {
				App.comment_form.check_stop(e.target);
			});
			$(document).bind('dragenter', function () {
				if (window.skip_dragupload || !App.core.active_window().is('#taskView')) return false;
				App.comment_form.start();
			});

			let touchStartY = 0;
			let touchStartX = 0;
			let touchMoved = false;
			$(document).on('touchstart', function (e) {

				self.last_touch_timestamp = new Date().getTime();

				const t = e.originalEvent.touches[0];
				touchStartY = t.clientY;
				touchStartX = t.clientX;
				touchMoved = false;
			});
			$(document).on('touchmove', function (e) {
				const t = e.originalEvent.touches[0];
				if (
					Math.abs(t.clientY - touchStartY) > 0 ||
					Math.abs(t.clientX - touchStartX) > 0
				) {
					touchMoved = true;
				}
			});
			$(document).on('touchend', function (e) {
				if (touchMoved) return; // це був scroll/swipe/etc
				App.comment_form.mobile_check_stop(e.target);
			});
		},

		onLogin: function() {
			// App.bus.window.on('keyboard_show keyboard_hide', self.on_keyboard_state);
			App.bus.app
				.on('task_view_ready', function () {
					App.comment_form.editor_init(App.task_view.obj_window);
					App.comment_form.init();
				})
				.on('task_view_unready', function () {
					App.core.async_task.abort('comment_form_submit');
					App.comment_form.cancel_edit();
					App.comment_form.editor_init(App.core.obj_window);
				});
		},
	};
})();

;var App = App || {};

(function() {
	let comment_show_type = App.helper.localStorage.value('comm_show_type', 'comment');

	let self = App.comments = {
		obj_window: null,
		obj_container: null,
		id_task: 0,
		url: '',
		init: function () {},
		locale: {}, // from template

		total_shown: 0,
		total_shown_previous: 0,
		total_days: 0,
		total_days_min: null,
		archive: {},
		data_by_task: {},
		added_comments_by_task: {},
		data: null,
		options: null,
		show_type: comment_show_type.get(),
		authors: {},
		id_focus_comment: 0,

		bind_references: function(id_task) {
			let data_by_task = self.init_data(id_task);

			self.id_task = id_task;
			self.data = data_by_task.data;
			self.options = data_by_task.options;
		},

		init_data: function(id_task) {
			if (!(id_task in self.data_by_task)) self.data_by_task[id_task] = {
				data: [],
				options: {
					is_admin: false,
					filter: '',
					type: '',
					id_seen_comment: 0,
					id_author: null,
					ids_filter: null,
				}
			}

			return self.data_by_task[id_task];
		},

		set_data: function(id_task, data, keys) { // incoming data should be mapped
			let data_by_task = self.init_data(id_task);
			for (let i in data) {
				data_by_task.data[i] = {};
				for (let j in keys) {
					data_by_task.data[i][keys[j]] = data[i][j];
				}
			}
			data_by_task.data.sort(self.order_func);
		},

		set_options: function(id_task, data) { // incoming data should be mapped
			let data_by_task = self.init_data(id_task);
			for (let i in data) {
				data_by_task.options[i] = data[i];
			}
		},

		set_reverse: function(is_on) {
			App.config.reverse_comments = is_on;
			if (App.task_view.is_shown()) self.draw();
		},

		sort_data: function() {
			self.data.sort(self.order_func);
		},

		exists_data: function(id, type, id_task) {
			let target_data = self.data_by_task[id_task]?.data || [];

			return target_data.findIndex((data) => data.type === type && data.id === id) !== -1;
		},

		update_data: function(id, type, data, id_task) {
			let target_data = self.data_by_task[id_task]?.data || [];

			let i = target_data.findIndex((data) => data.type === type && data.id === id);
			if (i === -1) return;

			for (let j in data) target_data[i][j] = data[j];

			if (self.helper_i_see_task(id_task)) App.core.call_queue.add('comments.update', self.draw, self, null, 0.01);
		},

		add_item: function(id, type, data, id_task, from_edit) {
			let target_data = self.data_by_task[id_task]?.data || [];

			let i = target_data.findIndex((data) => data.type === type && data.id === id);
			if (i === -1) {
				target_data.push(data);
				target_data.sort(self.order_func);
			}

			if (self.helper_i_see_task(id_task)) {
				if (!from_edit && type === 'comment' && !self.initial_scroll.hash && App.task_view.scroller.allow_scroll_to_new_comment()) {
					self.initial_scroll.set('#com' + id);
				} else {
					self.added_comments_by_task[id_task] = true;
				}
				App.core.call_queue.add('comments.update', self.draw, self, DATA_UPDATE, 0.01);
			}
		},

		delete_item: function(id, type, id_task) {
			let target_data = self.data_by_task[id_task]?.data || [];

			let i = target_data.findIndex((data) => data.type === type && data.id === id);
			if (i === -1) return;

			target_data.splice(i, 1);

			if (id in self.dom.data[type]) {
				if (self.dom.data[type][id]) self.dom.data[type][id].removeWithComponents();
				delete(self.dom.data[type][id]);
			}
			if (self.helper_i_see_task(id_task)) App.core.call_queue.add('comments.update', self.draw, self, null, 0.01);
		},

		clear_item: function (id_last, type, id_task) {
			let target_data = self.data_by_task[id_task]?.data || [];
			let ids_remove = [];

			target_data.forEach((data) => {
				if (data.type === type && data.id <= id_last) {
					ids_remove.push(data.id);

					if (data.id in self.dom.data[type]) {
						if (self.dom.data[type][data.id]) self.dom.data[type][data.id].removeWithComponents();
						delete(self.dom.data[type][data.id]);
					}
				}
			});

			target_data.splice(0, ids_remove.length);

			if (self.helper_i_see_task(id_task)) App.core.call_queue.add('comments.update', self.draw, self, null, 0.01);
		},

		order_func: function(a, b) {
			return App.helper.sort.compare(b["dateadd"], a["dateadd"]);
		},

		dom: {

			data: {
				log: {},
				comment: {},
			},

			invalidate_all: function() {
				if (!self.debug) App.core.warn('comments', 'For debug purposes only!');
				self.data.forEach(data => self.dom.invalidate(data.id, data.type, self.id_task));
			},

			invalidate: function(id, type, id_task) { // this = self.dom
				if (!(id in this.data[type])) return;
				delete(this.data[type][id]);
				if (id_task === self.id_task && document.visibilityState !== "hidden") App.core.call_queue.add('comments.update', self.draw, self, null, 0.01);
			},

			ready_to_load: true,
			load_items: function(o, items, callback, edit) { // o ~ self.obj_window
				let params = '';
				if ('log' in items && items.log.length) params += '&id_log=' + items.log.join(',');
				if ('comment' in items && items.comment.length) params += '&id_comment=' + items.comment.join(',');
				self.dom.ready_to_load = false;
				App.core.async_task.ajax({
					id: 'comments_load_items',
					url: App.helper.url.add_query(o.attr('data-url'), App.actions.get('comment_item:show') + params),
				}).then(function(html) {
					App.helper.dom.parse(html, function() {
						let id, match;
						$(this).addClass('commentList__item-appearStart');
						if (App.task_view.obj_menus) {
							const comment_obj_menus = $(this).find('.menu[id]').addClass('menu-alwaysRemain');
							comment_obj_menus.each(function () {
								// якщо ще не в колекції - додамо (зі збереженням посилання, щоб в task_view_cache теж оновилося)
								if (!App.task_view.obj_menus.is(this)) {
									App.task_view.obj_menus.push(this);
								}
							});
						}
						if ($(this).hasClass('commentList__item')) {
							match = $(this).attr('id').match(/^obj-comment(\d+)$/);
							id = parseInt(match[1]);
							if (id in self.dom.data.comment) self.dom.data.comment[id].removeWithComponents();
							App.controls.code_highlight.init($(this));
							self.dom.data.comment[id] = $(this).detach();
						} else if ($(this).hasClass('commentList__log')) {
							match = $(this).attr('id').match(/^obj-log(\d+)$/);
							id = parseInt(match[1]);
							if (id in self.dom.data.log) self.dom.data.log[id].removeWithComponents();
							self.dom.data.log[id] = $(this).detach();
						}
					});
					if ('log' in items && items.log.length) items.log.forEach(function(id) {
						if (!(id in self.dom.data.log)) self.dom.data.log[id] = null;
					});
					if ('comment' in items && items.comment.length) items.comment.forEach(function(id) {
						if (!(id in self.dom.data.comment)) self.dom.data.comment[id] = null;
					});
					if (callback) callback();
				}).finally(function() {
					self.dom.ready_to_load = true;
				});
			},

			is_loading: function() {
				return App.core.async_task.is_loading('comments_load_items');
			},

			destructor: function () {
				self.dom.data.log = {};
				self.dom.data.comment = {};
				self.dom.ready_to_load = true;
			},
		},

		search: {

			ids: null,
			last_value_processed: '',
			last_value_pressed: '',
			words: [],
			words_wrong_keyboard: [],

			get_container: function () {
				return self.obj_container.find('.commentListPanel__filter__search > .in');
			},

			onblur: App.helper.debounce(function (input) {
				if (input.value.trim() !== '' || self.options.filter !== '' || !App.task_view.is_shown()) return;
				self.search.exit();
			}, 150),
			apply: function (event) {
				self.search.onblur.reset();

				let search_val = event.target.value.trim(), is_backspace = (event.keyCode || event.which) === App.keycode.Backspace;

				if (search_val === '') {
					if (self.search.stop()) {
					} else if (self.options.filter !== '' && is_backspace) {
						App.comments.filter_update('');
					} else if (is_backspace) {
						self.search.exit();
					}
				} else {
					self.remember_scroll_before_filter();
					self.search.start();
					self.search.do(search_val);
				}
			},

			start: function () {
				if (self.search.is_started()) return false;

				self.navi.reset();
				self.search.get_container().addClass('search_started');
				self.obj_container.addClass('taskView-withCommentSearch');
				self.obj_container.find('.commentListPanel__filter__search').show();
				self.search.focus();

				return true;
			},

			stop: function () {
				if (!self.search.is_started()) return false;

				self.search.get_container().removeClass('search_started').find('input').val('');
				self.search.focus();
				this.last_value_pressed = '';
				this.do.reset();
				this.load();

				return true;
			},

			exit: function () {
				self.search.do_focus.reset();
				self.search.get_container().removeClass('search_started').find('input').val('');
				self.obj_container.removeClass('taskView-withCommentSearch');
				App.filter.search.words_wrong_keyboard = [];
				self.search.words = [];
				self.search.ids = null;
				self.draw();
			},

			clear: function () {
				if (this.last_value_pressed !== '') {
					self.search.get_container().find('input').val('');
					self.search.focus();
					this.last_value_pressed = '';
					this.do.reset();
					this.load();
				} else {
					self.search.exit();
				}
			},

			is_started: function () {
				return self.search.get_container().hasClass('search_started');
			},

			do_focus: App.helper.debounce(function () {
				self.obj_container.find('.commentListPanel__filter__search > .in input').focus();
			}, 250),

			focus: function () {
				self.search.onblur.reset();
				self.search.do_focus();
			},

			do: App.helper.debounce(function(value) {
				value = value.trim();
				if (value === self.search.last_value_pressed) return;

				self.search.last_value_pressed = value;
				self.search.load();
			}, 500, true),

			has_results: function () {
				return self.search.ids != null && self.search.ids.size > 0;
			},

			load: function() {
				if (self.search.last_value_processed === self.search.last_value_pressed) {
					return;
				}
				self.search.last_value_processed = self.search.last_value_pressed;
				if (self.search.last_value_processed) {
					let str = self.search.last_value_pressed.replace(/\s+/ig, ' ').toLowerCase().replace(/^\s+|\s+$/g, '');
					let str_tr = App.helper.keyboard.switch(str);
					App.comments.search.words = str.split(' '); // utf-recheck
					App.filter.search.words_wrong_keyboard = str_tr.split(' '); // utf-recheck
					App.core.async_task.ajax({
						id: 'comments_search',
						url: self.url + '?' + App.actions.get('task_comment_search:do'),
						data: { search: self.search.last_value_processed }
					}).then(function (json) {
						if (!App.device.is_mobile() && json.length > 0) {
							self.initial_scroll.set('#obj-comment'+json[json.length-1]);
						}

						if (json.length > 0) {
							self.navi.ids = json;
							self.navi.index = json.length - 1;
						} else {
							self.navi.ids = [];
							self.navi.index = 0;
						}

						self.search.ids = new Set(json);
						self.draw();
					});
				} else {
					App.comments.search.words = [];
					App.filter.search.words_wrong_keyboard = [];
					self.navi.ids = [];
					self.navi.index = 0;
					self.search.ids = null;
					self.draw();
				}
			},

			highlight: function(o) {
				o = o.find('.page_content');
				App.search.helper_remove_marks(o);
				if (App.comments.search.words.length) {
					let txt = o.text().toLowerCase();
					let j = 0, word = '';
					for (let i = 0; i < App.comments.search.words.length; i++) {
						word = App.comments.search.words[i];
						if (txt.indexOf(word) !== -1) {
							j++;
							o.textNodes().forEach(function(node) {
								App.helper.dom.mark_text(node, word, i%4);
							});
						}
					}
					if (j === 0) {
						for (let i = 0; i < App.filter.search.words_wrong_keyboard.length; i++) {
							word = App.filter.search.words_wrong_keyboard[i];
							if (txt.indexOf(word) !== -1) {
								j++;
								o.textNodes().forEach(function(node) {
									App.helper.dom.mark_text(node, word, i%4);
								});
							}
						}
					}
				}
			},

			draw: function() {
				if (self.search.is_started()) self.search.focus();
			},

			destructor: function () {
				self.search.ids = null;
				self.search.last_value_processed = '';
				self.search.last_value_pressed = '';
				self.search.words = [];
				self.search.words_wrong_keyboard = [];
			},
		},

		navi: {
			ids: [],
			index: 0,
			is_available: function () {
				return self.navi.ids.length > 0;
			},
			prev:  () => self.navi.go(-1),
			next: () => self.navi.go(1),
			go: function (dir) {
				if (!this.is_available()) return false;

				let i = self.navi.index + dir;

				if (i < 0) i = self.navi.ids.length-1;
				else if (i > self.navi.ids.length-1) i = 0;

				let id = self.navi.ids[i];

				if (id == null) return false;

				self.navi.index = i;
				self.jump_to_comment(id);
				self.navi.draw();
				return true;
			},
			reset: function() {
				this.index = 0;
			},
			draw: function () {
				let enabled = self.navi.ids.length > 1;

				let block = self.obj_container.find('.commentListPanel__filter__search .nav');

				if (enabled) {
					let has_prev = self.navi.index > 0, has_next = self.navi.index < self.navi.ids.length-1;

					block.find('[data-key=prev]').prop('disabled', !has_prev).setBtnVariant(has_prev ? 'a' : 'g');
					block.find('[data-key=next]').prop('disabled', !has_next).setBtnVariant(has_next ? 'a' : 'g');
				} else {
					block.find('ws-btn').prop('disabled', true).setBtnVariant('g');
				}
			},

			destructor: function () {
				self.ids = [];
				self.index = 0;
			},
		},

		init_items: function() {
			self.obj_window.on('click', '.commentList__item, .commentList__log', function (e) {
				if ($(window).width() > 480) {
					if (window.stop_event) return false;
					let o = $(e.target).parents().addBack();
					if (o.filter('input, label, a').length || o.attr('onclick')) return true;
					if (App.click_listener.is_moved(e)) return false;
					if (!self.mass.is_shown() && App.helper.selection.is_not_empty()) return false;
					if ($(window).width() <= 480) return false;
					if (App.task_view.obj_window.hasClass('taskView-withCommentEdit')) {}
					else if (self.mass.is_shown() || e.shiftKey || App.click_listener.is_longclick(e)) {
						self.mass.onClickItem(this, e);
						return false;
					}
					if ($(this).hasClass('commentList__item-collapseSaved')) {
						if ($(e.target).parents().addBack().filter('a, input, label').length || $(e.target).attr('onclick')) return false;
						$(this).toggleClass('commentList__item-collapsed');
						return false;
					}
				} else {
					if ($(this).hasClass('commentList__item-collapseSaved')) {
						if ($(e.target).parents().addBack().filter('a, input, label').length || $(e.target).attr('onclick')) return false;
						$(this).toggleClass('commentList__item-collapsed');
						return false;
					}
				}
			});

			self.obj_window.on('click', '.commentList__archiveItems', function (e) {
				if (self.mass.is_shown() || e.shiftKey || App.click_listener.is_longclick(e)) {
					self.mass.onClickItem(this, e);
					return false;
				} else {
					if (e && $(e.target).parents().addBack().filter('label, a').length) return true;

					if (e && $(e.target).closest('ws-btn[name*=todo]').length) {
						App.comments.filter_update('todo', App.comments.archive.todos.map(i => i.id));
						return false;
					}

					if ($(this).hasClass('clicked')) return false;
					$(this).addClass('clicked').find('.in').hide();
					self.saved_scroll.save($(this).next());
					// self.total_shown_previous = self.total_shown; -- no needed anymore
					self.paginal.per_page[self.id_task] = self.total_shown + self.paginal.per_page_default;
					self.draw();
				}
			});
			self.obj_window.on('click', '.commentList__collapsedItems', function (e) {
				if (self.mass.is_shown() || e.shiftKey || App.click_listener.is_longclick(e)) {
					self.mass.onClickItem(this, e);
					return false;
				} else {
					if (!$(e.target).parents().addBack().filter('label, a').length) {
						self.paginal.expanded[self.id_task].push($(this).attr('data-id').toInt());
						self.saved_scroll.save($(this).next());
						self.draw();
					}
				}
			});

			self.obj_window.on('click', '.comment_day_line .date', function (e) {
				self.show_filter_by_date(this, {
					offset: { top: -53 },
					title: App.object_state.locale.jump_to_date,
					type: 'center'
				});
			});
		},

		jump_to_context: function(id_comment) {
			self.search.exit();
			self.options.filter = '';
			self.initial_scroll.set('#obj-comment'+id_comment);
			self.draw();
		},
		jump_to_comment: function (id_comment) {
			this.jump_to_item('#obj-comment'+id_comment);
		},
		jump_to_item: function (hash) {
			self.initial_scroll.set(hash);

			if ($(hash).length) {
				requestAnimationFrame(() => self.initial_scroll.do());
			} else {
				self.draw();
			}
		},

		clear_filter: function () {
			self.options.id_author = null;
			self.filter_update('');
		},

		show_filter_by_author: function (anchor, params) {
			params ||= {}

			if (App.device.is_mobile()) {
				params.backup = false;
			}

			App.controls.user_select_and_go.show_context(anchor, App.helper.url.add_query(App.task_view.url, App.actions.get('task_user_select_and_go:show')), {
				...params,
				request: {
					type: 'author',
				},
				onload: function() {
					let menu = $(this);
					menu.on('click', '.menu__item[data-id]', function() {
						self.filter_by_author(+$(this).attr('data-id'));
						App.menu.hide_all();
					})
				},
				onshow: function () {
					let menu = $(this), matched = self.all_matched_filters['author'] || {}, ids_user_active = [];

					Object.keys(matched).forEach(function(key) {
						if (self.show_type !== 'all' && self.show_type !== key) return;
						ids_user_active.push(...Object.keys(matched[key]));
					})

					menu.find('.menu__item[data-id]').each(function () {
						$(this).toggleClass('menu__item-disabled', !ids_user_active.includes($(this).attr('data-id')));
					});

				}
			});
		},

		show_filter_by_date: function (anchor, params) {
			params ||= {}

			if (App.device.is_mobile()) {
				params.backup = false;
			}

			App.controls.datepicker.menu({
				anchor: anchor,
				offset: params.offset,
				title: params.title,
				type: params.type,
				backup: params.backup,
				datepicker: {
					rangeSelect: false,
					hideUnselectableDays: true,
					minDate: self.total_days_min,
					maxDate: new Date(),
					onSelect: params.onSelect || function (date_str) {
						App.menu.hide_all();
						if (date_str in self.total_days) {
							if ($(self.total_days[date_str].id).length) {
								setTimeout(() => self.jump_to_item(self.total_days[date_str].id), 300);
							} else {
								self.initial_scroll.set(self.total_days[date_str].id);
								self.paginal.per_page[self.id_task] = self.total_days[date_str].i;
								self.draw();
							}
						}
					},
					beforeShowDay: function (date) {
						let override_class = '';
						let override_title = '';
						let override_weekend = '';
						let override_available = false;
						let date_str = App.helper.date.to_input(date);
						if (date_str in self.total_days) {
							override_class = 'ui-datepicker-full ';
							override_title = self.total_days[date_str].cnt
							override_available = true;
						}
						return [override_available, override_class, override_title, override_weekend];
					}
				},
				onshow: function (datepicker) {
					datepicker.addClass('datepicker-commentsJumpTo');
				}
			})
		},

		saved_scroll: {
			id: '',
			pos: 0,

			save: function(o) {
				while (o.length && !o.is('.commentList__item, .commentList__log')) {
					o = o.next();
				}
				if (o.length) {
					self.saved_scroll.pos = o.position().top;
					self.saved_scroll.id = o.attr('id');
				}
			},

			destructor: function () {
				self.saved_scroll.id = '';
				self.saved_scroll.pos = 0;
			}
		},

		initial_scroll: {
			hash: '',
			validate: {
				comment_hash: /^#(obj-comment|com)(\d+)$/
			},
			init: function (hash, redraw) {
				this.set(hash);
				if (redraw === true) self.draw();
			},
			set: function(hash) {
				this.hash = hash;
				let match = hash.match(self.initial_scroll.validate.comment_hash);
				if (match) {
					self.id_focus_comment = parseInt(match[2]);
				}
			},
			do: function() {
				if (this.hash === '' || !self.ready) return false;

				App.anchor.scroll_to(this.hash);
				this.hash = '';

				return true;
			},

			destructor: function () {
				self.initial_scroll.hash = '';
			},
		},

		single_action: function (id, action) {
			let obj_id = `c${id}`;

			if (action === 'task') {
				App.modal.show({
					url: App.helper.url.add_query(self.url, App.actions.get('master') + '&obj_type=comment&operation=task&ids=' + obj_id),
					width: 500,
					title: self.obj_container.find('.commentListPanel__mass .op_task').attr('data-modal-title'),
					group: ''
				});
			} else if (action === 'move') {
				App.modal.show({
					url: App.helper.url.add_query(self.url, App.actions.get('master') + '&obj_type=comment&operation=move&ids=' + obj_id),
					width: 500,
					title: self.obj_container.find('.commentListPanel__mass .op_move').attr('data-modal-title'),
					group: ''
				});
			} else if (action === 'delete') {
				App.modal.show({
					url: App.helper.url.add_query(self.url, App.actions.get('master') + '&obj_type=comment&operation=delete&ids=' + obj_id),
					width: 500,
					title: self.obj_container.find('.commentListPanel__mass .op_delete').attr('data-modal-title'),
					group: 'delete'
				});
			}
			App.menu.hide();
		},

		filter_params: ['todo', 'file', 'star', 'mention'],
		type_params: ['all', 'comment', 'log'],
		was_comment_massInvisible: false,
		was_content_height: 0,

		remember_scroll_before_filter: function () {
			if (self.was_content_height !== 0) return false;

			App.task_view.scroller.remember('filter_update');

			if (!App.task_view.is_chat) {
				self.was_comment_massInvisible = self.obj_container.hasClass('taskView-comment_massInvisible');
				self.was_content_height = $('.taskView__content').height();
				self.obj_container.find('.commentList').css({ minHeight: self.was_content_height });
			}
		},

		filter_by_author: function (id_user) {
			self.options.id_author = id_user;
			if (id_user) {
				self.remember_scroll_before_filter();
			}
			self.draw();
		},

		start_search: function () {
			self.search.start();
		},
		clear_search: function () {
			self.search.do_focus.reset();
			self.search.onblur.reset();

			if (self.search.last_value_pressed === '' && self.options.id_author) {
				return self.filter_by_author(null);
			}
			if (self.search.last_value_pressed === '' && self.options.filter) {
				return self.filter_update('');
			}

			self.search.clear();
		},

		filter_update: function (filter, ids) {
			if (self.options.filter === filter && !ids) filter = '';

			if (self.options.filter === '' && filter !== '') {
				self.remember_scroll_before_filter();
			}

			self.options.filter = filter;
			self.options.ids_filter = ids || self.options.ids_filter;

			if (self.options.filter === '') {
				self.options.ids_filter = null;
			}

			self.navi.reset();
			self.obj_window.removeClass('commentList-withFilesOnly');
			if (self.show_type === 'log') self.set_option_type('comment');

			self.remember_task_filt();

			if (filter !== '') self.initial_scroll.set('#last');
			self.draw();
		},

		remember_task_filt: function () {
			App.core.async_task.ajax(self.url + '?' + App.actions.get('task_com_filt:do') + '&filt=' + self.options.filter);
		},

		set_option_type: function (type) {
			self.show_type = type;
			self.obj_window.attr('data-type', self.show_type);
			self.obj_container.find('.commentListPanel__filter__type ws-slider[name="type"]').attr('value', self.show_type)
		},

		type_update: function (type) {
			if (self.show_type === type) return;

			self.was_comment_massInvisible = self.obj_container.hasClass('taskView-comment_massInvisible');
			self.was_content_height = $('.taskView__content').height();
			self.obj_container.find('.commentList').css({ minHeight: self.was_content_height });

			self.navi.reset();
			self.set_option_type(type);
			if (type !== 'log') comment_show_type.set(type);
			self.draw();
		},

		helper_only_files: function (el) {
			let enabled = !self.obj_window.hasClass('commentList-withFilesOnly');

			self.obj_window.toggleClass('commentList-withFilesOnly', enabled);

			let btn = self.obj_container.find('.commentListPanel__filter ws-btn.btn-toggle-files')
			if (btn.length) {
				if (enabled) {
					btn.attr('name', btn.attr('name').replace('btn-plain', 'btn-fill').replace('btn-outline', 'btn-fill'));
				} else {
					btn.attr('name', btn.attr('name').replace('btn-fill', 'btn-plain'));
				}
			}
		},

		set_active_comment: function (el) {
			$(el).addClass('commentList__item-active');
			setTimeout(function () {
				$(el).addClass('commentList__item-activeEffect').removeClass('commentList__item-active');
			}, 2000);
			setTimeout(function () {
				$(el).removeClass('commentList__item-activeEffect');
			}, 3000);
		},

		get_all_listings: function() {
			return App.task_view_cache.get_all().find('.commentList');
		},

		collapse: function (id) {
			if (self.dom.data.comment[id].hasClass('commentList__item-collapseSaved')) {
				self.dom.data.comment[id].removeClass('commentList__item-collapsed commentList__item-collapseSaved');
				$('#drop' + id + 'menu').addClass('drop_v1').removeClass('drop_v2');
			} else {
				self.dom.data.comment[id].addClass('commentList__item-collapsed commentList__item-collapseSaved');
				$('#drop' + id + 'menu').addClass('drop_v2').removeClass('drop_v1');
			}
			App.core.async_task.ajax(App.helper.url.add_query(self.url, App.actions.get('comment_show_hide:do') + '&id_comment=' + id));
			window.stop_event = true;
			setTimeout(function () {
				window.stop_event = false;
			}, 100);
			self.draw();
		},

		/**
		 * @todo трохи допрацювати, бо якось воно "на соплях":
		 * 			1) краще, щоб response був зі статусом
		 * 			2) краще, щоб в request був статус, що встановлюємо
		 * 			3) чи треба синхронізація між своїми вкладками?
		 */
		bookmark_comment: function (el, link) {

			const params = new URLSearchParams(link.split('?')[1]);
			const id_comment = parseInt(params.get('id_comment'), 10);

			const comment_item = $(self.dom.data.comment[id_comment]);
			comment_item.toggleClass('commentList__item-withStar');

			const menu = $('#drop'+id_comment+'menu');
			menu.find('[data-cmd="comment_menu__bookmark"] .star-toggle').toggleClass('star-starred');
			menu.find('[data-cmd="comment_menu__bookmark"] .star-toggle').removeClass('star-initial')


			App.core.async_task.ajax(link + '&' + App.actions.get('comment_fav:do'));
		},

		show_reaction_menu: function (anchor, options) {

			options ||= {};

			const { id_comment } = options;
			const comment_item = $(self.dom.data.comment[id_comment]);

			// task_view.js on click .commentList__item task-reactions
			comment_item.find('task-reactions').trigger('click', [{ anchor }]);
		},

		scroll_to: App.helper.debounce(function(selector, bottom, smooth) {
			if (!App.task_view.is_shown()) return;

			let ps = App.task_view.minibar;

			App.controls.js_scrollbars.waitSmoothScrolling(ps);

			let target = self.obj_container.find(selector);
			let behavior = (smooth ?? true) ? 'smooth' : undefined;

			if (target.length) {
				let top = target.position().top + ps.scrollTarget.scrollTop;

				if (typeof bottom === 'number') top += bottom;
				else if (bottom) top -= $(ps.scrollTarget).height() - target.height();

				return ps.scrollTarget.scrollTo({ top: top, behavior: behavior });
			}

			switch(selector) {
				case '.2topAnchor': return ps.scrollTarget.scrollTo({ top: 0, behavior: behavior });
				case '.2bottomAnchor': return ps.scrollTarget.scrollTo({ top: ps.scrollTarget.scrollHeight, behavior: behavior });
			}
		}, 100),

		paginal: {
			per_page_default: 25,
			per_page: {},
			expanded: {}
		},

		all_matched_filters: {},

		draw_avatars: function (ids, max_size = 6) {
			let items = [];

			ids.forEach((id_user) => {
				if (id_user in App.team) items.push(App.helper.team(id_user, 'avatar'));
			});

			if (items.length > max_size) items.splice(max_size - 1, 1, '<span class="av_sm more">+'+(items.length - max_size + 1)+'</span>');

			return items.slice(0, max_size).join('');
		},

		draw: function(state) {
			let o_this, o_prev, last_date, this_date, this_date_type, day_anchor_shown = false, last_close_event = null;
			let ids_unseen_comment = [], ids_unseen_user = new Set(), ids_unseen_filter = { mention: [] }, unseen_text_length = {};

			if (state === DATA_UPDATE) self.sort_data();

			self.total_days = {};
			self.authors = {
				all: new Set()
			};

			if (self.data == null) return;

			/** Filter **/
			self.all_matched_filters = {};
			self.data.forEach((data, i) => {
				if (self.options.ids_filter != null && !self.options.ids_filter.includes(data.id)) {
					return;
				}

				if (data.type === 'comment' && data.filter) {
					data.filter.split(',').forEach(function(className) {
						if (!(className in self.all_matched_filters)) self.all_matched_filters[className] = 0;
						self.all_matched_filters[className]++;
					});
				}
				if (data.type === 'comment') {
					if (self.all_matched_filters['search'] == null) self.all_matched_filters['search'] = 0;
					self.all_matched_filters['search']++;
				}

				if (self.all_matched_filters['author'] == null) self.all_matched_filters['author'] = {};
				if (self.all_matched_filters['author'][data.type] == null) self.all_matched_filters['author'][data.type] = {};
				if (self.all_matched_filters['author'][data.type][data.id_user] == null) self.all_matched_filters['author'][data.type][data.id_user] = 0;
				self.all_matched_filters['author'][data.type][data.id_user]++;
			});

			self.filter_counter();

			//if (!self.data.length) return;

			if (!(self.id_task in self.paginal.per_page)) {
				self.paginal.per_page[self.id_task] = self.paginal.per_page_default;
				self.paginal.expanded[self.id_task] = [];
			}

			let i = 0, ids_vis = [], ids_load = {
				log: [],
				comment: []
			};
			self.archive = {
				cnt: 0,
				date_min: '',
				date_max: '',
				ids_user: new Set(),
				ids_comment: [],
				ids_log: [],
				todos: []
			}
			self.total_days_min = null;
			self.data.forEach((data) => {
				if (self.show_type !== 'all' && data.type !== self.show_type) return false;
				if (self.show_type === 'all' && data.type === 'log' && data.filter === '0') return false; // hide silent logs for ALL

				let match_filter = !self.options.filter || (data.type === 'comment' && data.filter.indexOf(self.options.filter) !== -1);

				if (match_filter && self.options.ids_filter != null) {
					match_filter = self.options.ids_filter.includes(data.id);
				}

				let match_search = self.search.ids == null || (data.type === 'comment' && self.search.ids.has(data.id));
				let match_author = !self.options.id_author || self.options.id_author === data.id_user;

				if ((!match_filter || !match_author || !match_search) && data.id !== self.id_focus_comment) return false;

				let dt = new Date((data.dateadd + App.config.date_timezone_offset) * 1000);
				self.total_days_min = self.total_days_min == null || self.total_days_min > dt ? dt : self.total_days_min;
				this_date = App.format.date(dt, DATE_INPUT);
				if (!(this_date in self.total_days)) self.total_days[this_date] = {
					cnt: 0,
					id: '',
					i: 0
				};
				self.total_days[this_date].cnt++;
				self.total_days[this_date].i = i;
				self.total_days[this_date].id = data.type === 'log' ? '#obj-log' + data.id : '#obj-comment' + data.id;

				this_date = App.format.date(dt, App.task_view.is_chat ? DATE_COMPACT : DATE_MONTH);
				if (i <= self.paginal.per_page[self.id_task] || this_date === last_date || data.id === self.id_focus_comment || data.id > self.options.id_seen_comment) { // Show complete month after paginal size reached
					ids_vis.push(data);
					if (!(data.id in self.dom.data[data.type])) ids_load[data.type].push(data.id);
				} else {
					self.archive.cnt++;
					if (!self.archive.date_max) self.archive.date_max = data.dateadd;
					self.archive.date_min = data.dateadd;
					self.archive.ids_user.add(data.id_user);
					if (data.filter && data.filter.indexOf('todo') !== -1) {
						self.archive.todos.push(data);
						// if (!(data.id in self.dom.data[data.type])) ids_load[data.type].push(data.id);
					}
					self.archive['ids_' + data.type].push(data.id);
				}
				i++;
				if (i === self.paginal.per_page[self.id_task]) last_date = this_date;
			});
			self.total_shown = ids_vis.length;

			if (ids_load.log.length || ids_load.comment.length) {
				self.ready = false;
				if (!self.dom.ready_to_load) {
					clearTimeout(self.draw_timer);
					self.draw_timer = setTimeout(() => {
						self.draw(state);
						self.mass.update_menu();
					}, 100);
					return false;
				}
				App.core.call_queue.delete('task_seen:' + self.id_task);
				self.dom.load_items(self.obj_window, ids_load, self.draw);
				return false;
			}
			self.ready = true;

			let old_scroll_height = App.task_view.scroller.calcScrollHeight();
			$('.commentList__log').detach();
			$('.commentList__item').detach();
			$('.commentList__collapsedItems').remove();
			$('.commentList__archiveItems, .commentList__archiveItems__tmpCounter').remove();
			$('.comment_day_line, .comment_unseen_line, .commentList a[name="today"], .commentList a[name="yesterday"]').remove();
			self.obj_container.find('.comment_unseen_anchor').hide();
			self.obj_container.find('.btn-comments').removeClass('unseen').attr('text', '');
			self.obj_container.find('.commentListPanel__filter .day_today').hide().next().hide().parent().removeClass('r_act');
			self.obj_container.find('.commentListPanel__filter__type ws-slider').attr('value', self.show_type);
			self.obj_window.attr('data-type', self.show_type);
			let is_really_reversed = App.config.reverse_comments && !App.task_view.is_chat;
			self.obj_container.toggleClass('taskView-reversed', is_really_reversed);

			let draw_archive_with_todos, draw_archive, draw_last_close_event;
			if (self.archive.cnt) {
				if (is_really_reversed) self.archive.todos = self.archive.todos.reverse();

				draw_archive_with_todos = function() {
					// self.archive.todos.forEach(function (data) {
					// 	o_this = self.dom.data[data.type][data.id];
					// 	if (!o_this) return;
					// 	self.obj_window.append(o_this);
					// });
				}
				draw_archive = function () {
					let mass_ids = '';
					if (self.archive.ids_comment.length > 0)
						mass_ids += `c${self.archive.ids_comment.join(',c')}`;
					if (self.archive.ids_log.length > 0)
						mass_ids += `e${self.archive.ids_log.join(',e')}`;

					self.obj_window.append(App.helper.template.fill('comment_archive', {
						is_admin: self.options.is_admin ? 1 : 0,
						mass_ids,
						cnt: self.archive.cnt,
						html_avatar: self.draw_avatars(self.archive.ids_user),
						dates: App.format.month_range(self.archive.date_min, self.archive.date_max, ' ... '),
						has_todo: self.archive.todos.length,
						cnt_todos: self.archive.todos.length
					}));
				}
			}

			/** Archive items **/
			if (self.archive.cnt && !is_really_reversed) {
				draw_archive_with_todos();
				draw_archive();
			}

			/** Log redo available **/
			let log_redo_types = new Set(), log_redo_ids = new Set();

			ids_vis.forEach((data, i) => {
				if (data.type === 'log') {
					o_this = self.dom.data[data.type][data.id];
					if (!o_this) return;
					let log_type = parseInt(o_this.attr('data-type'));
					if (log_type === 2) { // edit event disables all redo
						[2, 3, 4, 5].forEach((i) => log_redo_types.add(i));
					} else if (!log_redo_types.has(log_type)) {
						log_redo_types.add(log_type);
						log_redo_ids.add(data.id);
					}
				}
			});

			if (!is_really_reversed) ids_vis = ids_vis.reverse();
			this_date = '';

			self.all_matched_filters.count_today = 0;
			self.all_matched_filters.count_yesterday = 0;
			self.all_matched_filters.count_week = 0;

			/** Collapse consecutive comments (calculate) **/
			let id_collapse = 0, collapse = {};
			self.navi.ids = [];
			ids_vis.forEach((data, i) => {

				if (self.search.has_results() || App.comments.options.filter) {
					self.navi.ids.push(data.id);
				}

				let dt = new Date((data.dateadd + App.config.date_timezone_offset) * 1000);
				this_date = App.format.date(dt, DATE_DEFAULT);

				o_this = self.dom.data[data.type][data.id];
				if (!o_this) return;

				if (self.search.ids != null && self.search.ids.has(data.id)) {
					o_this.attr('data-highlight', '1');
					App.comments.search.highlight(o_this);
				} else if (o_this.attr('data-highlight') === '1') {
					App.search.helper_remove_marks(o_this);
				}

				o_this.find('.in .head .txt').html(o_this.attr('data-txt'));

				if (data.id !== self.id_focus_comment && (o_this.hasClass('commentList__item-collapsed'))) {
					if (!id_collapse) {
						id_collapse = data.id;
						collapse[id_collapse] = {
							cnt: 0,
							date_min: this_date,
							date_max: this_date,
							ids_user: new Set(),
							ids_comment: [],
							ids_log: [],
						}
					}
					collapse[id_collapse].cnt++;
					collapse[id_collapse].date_max = this_date;
					collapse[id_collapse].ids_user.add(data.id_user);
					collapse[id_collapse]['ids_' + data.type].push(data.id);
				} else {
					id_collapse = 0;
				}
			});

			id_collapse = 0;
			let should_draw_unseen = false, draw_unseen = false;
			ids_vis.forEach((data, i) => {
				let match_filter = !self.options.filter || (data.type === 'comment' && data.filter.indexOf(self.options.filter) !== -1);

				/** Collapse consecutive comments (draw) **/
				if (data.type === 'comment' && data.id in collapse && collapse[data.id].cnt > 1 && !self.paginal.expanded[self.id_task].includes(data.id)) {
					id_collapse = data.id;

					let mass_ids = '';
					if (collapse[id_collapse].ids_comment.length > 0)
						mass_ids += `c${collapse[id_collapse].ids_comment.join(',c')}`;
					if (collapse[id_collapse].ids_log.length > 0)
						mass_ids += `e${collapse[id_collapse].ids_log.join(',e')}`;

					self.obj_window.append(App.helper.template.fill('comment_collapse', {
						id: id_collapse,
						is_admin: self.options.is_admin ? 1 : 0,
						mass_ids,
						cnt: collapse[id_collapse].cnt,
						html_avatar: self.draw_avatars(collapse[id_collapse].ids_user),
						dates: collapse[id_collapse].date_min + (collapse[id_collapse].date_min !== collapse[id_collapse].date_max ? ' ... ' + collapse[id_collapse].date_max : '')
					}));
					o_prev = null;
					return;
				} else if (id_collapse && collapse[id_collapse]['ids_' + data.type].includes(data.id)) return;
				else id_collapse = 0;

				/** Month divider and normal items **/

				let dt = new Date((data.dateadd + App.config.date_timezone_offset) * 1000);
				if (dt.getTime() >= App.helper.date.today().getTime()) {
					this_date_type = 1;
					this_date = App.object_state.locale['today'];
					self.all_matched_filters.count_today++;
				} else if (dt.getTime() >= App.helper.date.today().getTime() - 86400 * 1000) {
					this_date_type = 2;
					this_date = App.object_state.locale['yesterday'];
					self.all_matched_filters.count_yesterday++;
				} else {
				  	this_date = App.format.date(dt, App.task_view.is_chat ? DATE_COMPACT : DATE_MONTH);
					this_date_type = 3;
				}
				if (dt.getTime() >= App.helper.date.today().getTime() - 7 * 86400 * 1000) {
					self.all_matched_filters.count_week++;
				}

				o_this = self.dom.data[data.type][data.id];
				if (!o_this) return;
				o_this.toggleClass('commentList__item-missFilter', !match_filter);

				if (data.type === 'log') {
					o_this.toggleClass('commentList__log-withRedo', log_redo_ids.has(data.id));

					if (o_this.hasClass('commentList__log-big')) {
						o_this.removeClass('commentList__log-big');
						o_this.find('.commentList__item').remove();
					}

					let o_log_type = +o_this.attr('data-type');
					if (o_log_type === 9) last_close_event = o_this;
					else if (o_log_type === 10) last_close_event = null;
				}

				if (data.type === 'comment' && data.id > self.options.id_seen_comment && data.id_user != App.me.id) {
					should_draw_unseen = true;
					ids_unseen_comment.push(data.id);
					unseen_text_length[data.id] = o_this.find('.page_content').text().length;
					ids_unseen_filter[data.filter]?.push(data.id);
					ids_unseen_user.add(data.id_user);
				}
				if (data.type === 'comment' && data.id > self.options.id_seen_comment && data.id_user != App.me.id && !is_really_reversed && !draw_unseen) {
					draw_unseen = true;
					self.obj_window.append('<div class="comment_unseen_line"><span class="badge"><ws-icon name="arrows/arrow_circle_sm-down"></ws-icon>' + App.object_state.locale['unread'] + '<span class="avs"></span></span><i></i><i></i></div>');
					last_date = this_date;
				} else if (data.type === 'comment' && data.id <= self.options.id_seen_comment && is_really_reversed && should_draw_unseen) {
					draw_unseen = true;
					should_draw_unseen = false;
					self.obj_window.append('<div class="comment_unseen_line"><span class="badge"><ws-icon name="arrows/arrow_circle_sm-up"></ws-icon>' + App.object_state.locale['unread'] + '<span class="avs"></span></span><i></i><i></i></div>');
					last_date = this_date;
				} else if (this_date !== last_date || i === 0) {
					self.obj_window.append('<div class="comment_day_line"><span class="date date' + this_date_type + '">' + this_date + '</span><span class="dot"></span><i></i><i></i></div>');
					last_date = this_date;
					if (this_date_type === 1) {
						self.obj_container.find('.commentListPanel__filter .day_today').show().next().hide().parent().addClass('r_act');
						self.obj_window.append('<a name="today"></a>');
					}
					if (this_date_type === 2) {
						self.obj_container.find('.commentListPanel__filter .day_yesterday').show().parent().addClass('r_act');
						self.obj_window.append('<a name="yesterday"></a>');
					}
				}

				o_this.toggleClass('commentList__item-collapsed', o_this.hasClass('commentList__item-collapseSaved'));

				self.obj_window.append(o_this);

				o_this.find('a').each(function () {
					let href = $(this).attr('href');
					if (href != null && href.indexOf(window.location.href) === 0) {
						let [, rest_url] = href.split(window.location.href);
						if (rest_url.startsWith('#com')) {
							$(this).attr('href', 'javascript:void(0);').attr('target', null).attr('onclick', "App.comments.jump_to_item('"+rest_url+"');");
						}
					}
				})

				o_this.find('span.invite').each(function () {
					let rel = $(this).attr('rel');
					if (rel == App.me.id) $(this).addClass('invite_me');
				})

				if (o_this.hasClass('commentList__item-appearEnd')) o_this.removeClass('commentList__item-appearStart commentList__item-appearEnd');

				/** mark same authors **/

				let prev_pub_wait = o_prev ? parseInt(o_prev.find('.head task-wait').attr('data-wait') || 0) : 0;
				let this_pub_wait = parseInt(o_this.find('.head task-wait').attr('data-wait') || 0);
				let max_pub_wait = Math.max(prev_pub_wait, this_pub_wait);

				if (!o_prev) {
					o_this.removeClass('commentList__item-same'); // commentList__item-collapsed
				} else if (
					o_prev.hasClass('commentList__item')
					&& !o_this.hasClass('commentList__item-withHidden') && !o_prev.hasClass('commentList__item-withHidden')
					&& !o_this.hasClass('commentList__item-collapsed') && !o_prev.hasClass('commentList__item-collapsed')
					&& o_prev.attr('data-author') === o_this.attr('data-author')
					&& o_this.attr('data-dt') - o_prev.attr('data-dt') < 600
					&& max_pub_wait < 600
				) {
					o_this.toggleClass('commentList__item-sameDate', o_prev.attr('data-date') === o_this.attr('data-date'));
					o_this.addClass('commentList__item-same');
					o_prev.addClass('commentList__item-preSame');
				} else {
					o_this.removeClass('commentList__item-sameDate');
					o_this.removeClass('commentList__item-same');
					o_prev.removeClass('commentList__item-preSame');
				}
				o_prev = self.dom.data[data.type][data.id];

				/** Archive opened -- @deprecated ?? **/

				if (self.total_shown_previous && i === self.total_shown - self.total_shown_previous - 1) {
					self.obj_window.append(App.helper.template.fill('comment_archive_loaded', {
						cnt_formatted: App.format.quantity(i, App.object_state.locale['comments'], QTY_WITH_TEXT)
					}));
				}

			});

			/** Archive items **/
			if (self.archive.cnt && is_really_reversed) {
				draw_archive();
				draw_archive_with_todos();
			}

			if (last_close_event && !last_close_event.hasClass('commentList__log-big')) {
				last_close_event.addClass('commentList__log-big');
				let modal_url = App.helper.url.add_query(App.helper.endpoint.task(self.id_task), App.actions.get('task_workflow:show'));
				let a = $('<div>', {
					class: 'commentList__item revor commentList__item-appearStart commentList__item-sameDate commentList__item-same commentList__item-appearEnd',
					html: '<div class="in"><ws-btn name="btn btn-24 btn-b btn-outline thickbox" data-modal-url="'+modal_url+'" text="'+App.object_state.locale.workflow_path+'"></ws-btn></div>',
				})
				last_close_event.append(a);
			}

			self.obj_container.find('.commentListPanel__filter .day_today').attr('text', self.all_matched_filters.count_today);
			self.obj_container.find('.commentListPanel__filter .day_yesterday').attr('text', self.all_matched_filters.count_yesterday);

			clearTimeout(self.draw_timer);
			self.draw_timer = setTimeout(() => {
				self.obj_window.find('.commentList__item-appearStart').addClass('commentList__item-appearEnd');
			}, 100);

			/** Detect scroll position **/

			self.id_focus_comment = 0;
			self.total_shown_previous = 0;

			let is_empty = self.obj_window.find('.commentList__item, .commentList__archiveItems, .commentList__log, .commentList__collapsedItems').length === 0;

			if (is_empty) {
				if (self.obj_container.find('.commentList .empty_placeholder').length === 0) self.obj_container.find('.commentList').append('<div class="empty_placeholder"></div>');
				let message = App.comments.locale['no_' + self.show_type] || App.comments.locale['no_items'];
				if ((self.options.filter !== '' || self.search.last_value_processed !== '') && self.search.is_started()) message = App.comments.locale['no_' + self.show_type + '_found'] || App.comments.locale['no_items_found'];
				self.obj_container.find('.commentList .empty_placeholder').text(message);
			} else {
				self.obj_container.find('.commentList .commentList__item, .commentList .commentList__log').eq(0).addClass('first_item');
				self.obj_container.find('.commentList .empty_placeholder').remove();
			}

			if (ids_unseen_user.size > 0) {
				let avs_html = self.draw_avatars(Array.from(ids_unseen_user.values()), 3);
				self.obj_window.find('.comment_unseen_line .avs').html(avs_html);
				if (avs_html === '') self.obj_window.find('.comment_unseen_line .avs').remove();
			}

			if (!self.obj_container.hasClass('taskView-withCommentMass')) {
				self.obj_container.find('.commentListPanel__filter').show();
			}

			if (!App.task_view.is_chat) {
				let list = self.obj_container.find('.commentList');
				list.css(
					self.was_comment_massInvisible
						? { minHeight: self.was_content_height-48-24 }
						: { minHeight: self.was_content_height-Math.max(list.offset().top, 99)+99 }
				);
			} else {
				if (self.data.length > 0) {
					self.obj_container.find('.commentListPanel__wrapper').show();
					App.task_view.obj_window.addClass('taskView-withCommentPanel');
				} else {
					self.obj_container.find('.commentListPanel__wrapper').hide();
					App.task_view.obj_window.removeClass('taskView-withCommentPanel');
				}
			}

			self.navi.draw();
			self.search.draw();
			self.unseen.draw({
				ids_comment: is_really_reversed ? ids_unseen_comment.reverse() : ids_unseen_comment,
				ids_mention: ids_unseen_filter.mention,
				text_length: unseen_text_length,
			});

			if (!self.initial_scroll.do()) {
				App.task_view.scroller.restore('filter_update'+self.options.filter);
			}

			/** prevent scroll jump for reversed feed **/
			if (self.added_comments_by_task[self.id_task]) {
				delete self.added_comments_by_task[self.id_task];
				if (App.config.reverse_comments && !App.task_view.is_chat && $('.commentList').position().top < 0) {
					let scroll_diff = App.task_view.scroller.calcScrollHeight() - old_scroll_height;
					if (scroll_diff > 1) App.task_view.scroller.scrollmove(scroll_diff);
				}
			}

			App.task_view.scroller.initial_read_comments(self.id_focus_comment);
		},

		unseen: {
			ids_comment: [],
			ids_mention: [],
			text_length: {},
			el: null,
			shown: false,
			reverse: false,
			allow_read: function () {
				return !self.options.filter;
			},
			save: function (id_seen) {
				if (!id_seen || id_seen <= self.options.id_seen_comment) return;

				this.ids_comment = this.ids_comment.filter(i => i > id_seen);
				this.ids_mention = this.ids_mention.filter(i => i > id_seen);

				Object.keys(this.text_length).forEach(i => {
					if (!this.ids_comment.includes(+i)) delete this.text_length[i];
				});

				this.draw();
				self.mark_seen(self.url, id_seen);
			},
			popup_toggle: function (is_shown) {
				if (is_shown) this.popup_show(); else this.popup_hide();
			},
			popup_show: function () {
				if (this.shown) return;

				this.shown = true;
				this.draw();
			},
			popup_hide: function () {
				if (!this.shown) return;

				this.shown = false;
				this.draw();
			},
			reverse_toggle: function (state) {
				this.reverse = !!state;
				this.draw();
			},
			draw: function (state) {
				this.ids_comment = state?.ids_comment ?? this.ids_comment;
				this.ids_mention = state?.ids_mention ?? this.ids_mention;
				this.text_length = state?.text_length ?? this.text_length;

				if (this.el == null) this.el = self.obj_container.find('.comment_unseen_popup');

				let unseen_cnt = this.ids_comment.length, mention_cnt = this.ids_mention.length, total_text_length = 0;

				this.ids_comment.forEach(i => {
					total_text_length+= this.text_length[i] || 0;
				});

				let badge = this.el.find('.floater .badge'),
					icon = this.el.find('.floater ws-icon'),
					txt = mention_cnt > 0 ? '@' : (unseen_cnt > 0 ? (unseen_cnt > 99 ? '99+' : unseen_cnt) : '');

				badge
					.toggleClass('badge-w', mention_cnt > 0)
					.toggleClass('badge-a', mention_cnt === 0 && unseen_cnt > 0)
					.children('.in')
					.text(txt);

				icon.attr('name', unseen_cnt > 0 ? 'comment_bubble' : 'arrows/arrow_sm-down');

				this.el
					.toggleClass('hide', !this.shown)
					.toggleClass('has_unseen', unseen_cnt > 0)
					// .toggleClass('has_summarize', total_text_length > 200)
					.toggleClass('has_summarize', self.data.length > 2)
					.toggleClass('arrow', unseen_cnt === 0)
					.toggleClass('arrow-reverse', this.reverse);
			},

			destructor: function () {
				self.unseen.ids_comment = [];
				self.unseen.ids_mention = [];
				self.unseen.text_length = {};
				self.unseen.el = null;
				self.unseen.shown = false;
				self.unseen.reverse = false;
			},
		},

		filter_menu: function (anchor, options) {

			options ||= {};

			App.menu.show({
				...options,
				force_dropdown: true,
				anchor: anchor,
				box: '#commentListPanel__filter__menu',
				onshow: function () {
					let menu = $(this);

					menu.find('.menu__item[data-filter]').removeClass('menu__item-active');
					if (self.options.filter) menu.find('.menu__item[data-filter='+self.options.filter+']').addClass('menu__item-active');
				}
			});
		},

		filter_counter: function () {
			self.obj_container.find('.commentListPanel__filter__item').hide();
			$('#commentListPanel__filter__menu .menu__item .cnt').html('');
			self.filter_params.forEach(function (param) {
				let menu_item = $('#commentListPanel__filter__menu .menu__item[data-filter=' + param + ']');
				menu_item.toggleClass('menu__item-disabled', self.all_matched_filters[param] == null);
				if (self.all_matched_filters[param] == null) return;
				let o = self.obj_container.find('.commentListPanel__filter__item[data-filter=' + param + ']').show();
				menu_item.find('.cnt').text(self.all_matched_filters[param]);
				o.find('span').html(self.all_matched_filters[param]);
				o.attr('data-title', '%G' + o.attr('data-title-sm') + 'G% ' + self.all_matched_filters[param]);
			});

			if (self.all_matched_filters.search > 3 && !App.task_view.is_chat) {
				self.obj_container.find('.commentListPanel__filter__item[data-filter=search]').show();
			} else {
				self.obj_container.find('.commentListPanel__filter__item[data-filter=search]').hide();
			}

			let counter = self.options.filter ? self.all_matched_filters[self.options.filter] : '';
			//self.obj_container.find('.commentListPanel__filter .cnt').html(self.options.filter ? self.all_matched_filters[self.options.filter] : '');
			let btn = self.obj_container.find('.commentListPanel__filter__active .btn-double button').eq(0);
			let btn_files = btn.parent().next();
			let is_chat = App.task_view.is_chat;

			if (!self.options.filter && !self.options.id_author) {
				self.obj_container.removeClass('taskView-withCommentFilter');
				// App.task_view.scroller.helper_link_comment_wrapper();
				// App.task_view.scroller.helper_link_subtask_wrapper();
				self.obj_container.find('.commentListPanel__filter__item').removeClass('commentListPanel__filter__item-active');
				self.obj_container.find('.commentListPanel__filter__active').hide();
				self.obj_container.find('.commentListPanel__filter__author').hide();
				self.obj_container.find('.commentListPanel__filter__search').removeClass('filter_started');
				self.obj_container.find('.commentListPanel__filter__possible').show();
				self.obj_container.find('.commentListPanel__filter__actions ws-btn[data-action="clear"]').hide();
				self.obj_container.find('.commentListPanel__filter__actions ws-btn[data-action="menu"]').attr('name', 'btn btn-24 btn-g btn-plain');
				if (is_chat) {
					self.obj_container.find('.commentListPanel__filter__search').show();
				} else if (self.obj_container.hasClass('taskView-withCommentSearch')) {
					self.obj_container.find('.commentListPanel__filter__search').show();
					self.obj_container.find('.commentListPanel__filter__type').hide();
				} else {
					self.was_content_height = 0;
					self.obj_container.find('.commentListPanel__filter__search').hide();
					self.obj_container.find('.commentListPanel__filter__type').show();
				}
				btn_files.hide();
				//App.task_view.scroller.restore();
			} else {
				//App.task_view.scroller.remember();
				self.obj_container.addClass('taskView-withCommentFilter');
				// App.task_view.scroller.helper_link_comment_wrapper();
				// App.task_view.scroller.helper_link_subtask_wrapper();
				self.obj_container.find('.commentListPanel__filter__search').addClass('filter_started');
				self.obj_container.find('.commentListPanel__filter__possible').hide();
				self.obj_container.find('.commentListPanel__filter__actions ws-btn[data-action="clear"]').show();
				self.obj_container.find('.commentListPanel__filter__actions ws-btn[data-action="menu"]').attr('name', 'btn btn-24 btn-b btn-fill');

				self.obj_container.find('.commentListPanel__filter__search').show();
				self.obj_container.find('.commentListPanel__filter__type').hide();


				self.obj_container.find('.commentListPanel__filter__active').hide();
				self.obj_container.find('.commentListPanel__filter__author').hide();

				if (self.options.filter) {
					self.obj_container.find('.commentListPanel__filter__active').css('display', 'flex');

					let o = self.obj_container.find('.commentListPanel__filter__item').removeClass('commentListPanel__filter__item-active').filter('[data-filter=' + self.options.filter + ']').addClass('commentListPanel__filter__item-active');
					btn_files.toggle(self.options.filter === 'file');
					btn.find('span').html(($(window).width() > 480 && counter ? o.attr('data-title-full') + ' (' + counter + ')' : o.attr('data-title-sm')));
					btn.find('span').prev().remove();
					btn.find('span').before('<ws-icon name="' + o.attr('left-icon') + '" class="btn-left-icon"></ws-icon>');
				}

				if (self.options.id_author && App.team[self.options.id_author]) {
					self.obj_container.find('.commentListPanel__filter__author ws-chip').html(
						'<div class="chip chip-fill chip-rounded">' +
							App.team[self.options.id_author].avatar +
							'<span>' + App.team[self.options.id_author].name + '</span>' +
							'<ws-icon name="close_sm" class="delete cross-attr" onclick="return false"></ws-icon>' +
						'</div>'
					).children('.chip').on('click', function (e) {
						if ($(e.target).hasClass('delete')) {
							self.filter_by_author(null);
						} else {
							self.show_filter_by_author(this);
						}
					});
					self.obj_container.find('.commentListPanel__filter__author').show();
				}
			}
		},

		helper_i_see_task: function (id_task) {
			return App.task_view.is_shown && App.task_view.id == id_task && document.visibilityState !== "hidden"
		},

		on_tab_active: function () {
			if (App.task_view.is_shown()) {
				App.task_view.clear_counter(App.task_view.id);
				self.draw();
			}
		},

		seen_state: new Map(),
		seen_state_ids_comment: new Map(),
		send_timer: null,
		send_interval: 10 * 1000,
		mark_seen: function (url, id_comment) {
			self.options.id_seen_comment = id_comment;

			const has_mention = self.unseen.ids_mention.length > 0;

			const id_comment_mention_last = self.unseen.ids_mention[self.unseen.ids_mention.length - 1];
			let id_user_mention = 0;
			if (has_mention && self.exists_data(id_comment_mention_last, 'comment', self.id_task)) {
				let target_data = self.data_by_task[self.id_task]?.data || [];
				let res = target_data.find((data) => data.type === 'comment' && data.id === id_comment_mention_last);
				id_user_mention = res.id_user;
			}

			const obj_data = {
				id_seen: id_comment,
				cnt_new: self.unseen.ids_comment.length,
				has_mention,
				id_user_mention
			};

			App.object_state.update('task', self.id_task, { read: obj_data }, MY_DIRECT_ACTION);

			const ids_seen = self.seen_state_ids_comment.get(url) ?? [];
			ids_seen.push(id_comment);
			self.seen_state_ids_comment.set(url, ids_seen);

			App.mymenu.mark_task_comment_as_seen(self.id_task, id_comment);

			this.seen_state.set(url, { id_task: self.id_task, obj_data, ts: Date.now() });
			self.update_server_seen_job();
		},

		update_server_seen_job: function () {
			if (self.seen_state.size === 0) return;

			for (let [url, st] of self.seen_state.entries()) {
				if (Date.now() - st.ts < self.send_interval) continue;

				const ids_seen = self.seen_state_ids_comment.get(url) ?? [];

				self.seen_state.delete(url);
				self.seen_state_ids_comment.delete(url);

				App.core.send_message_to_other_devices({
					command: 'object_state',
					data: {
						obj_type: 'task',
						obj_id: st.id_task,
						obj_data: { read: { ...st.obj_data, ids_seen } }
					},
				}, 'task_read' + st.id_task);

				$.getScript(App.helper.url.add_query(url, App.actions.get('task_read_comment:apply'), {
					id_comment: st.obj_data.id_seen,
				}));

				break;
			}

			clearTimeout(self.send_timer);
			self.send_timer = setTimeout(self.update_server_seen_job, Math.round(self.send_interval/3));
		},

		mass_hide_comments_draw: function (ids) {
			let items = App.comments.get_all_listings().find('#obj-comment'+ids.join(',#obj-comment'));

			items
				.removeClass('commentList__item-same commentList__item-preSame')
				.addClass('commentList__item-collapsed commentList__item-collapseSaved')
				.find('.ico_noview').removeClass('ico_noview').addClass('ico_view');

			items.each(function () {
				$(this).prev().removeClass('commentList__item-preSame');
				$(this).next().removeClass('commentList__item-same');
			});

			$('#drop'+ids.join('menu, #drop')+'menu').addClass('drop_v2').removeClass('drop_v1');
		},
		mass_show_comments_draw: function (ids) {
			$('#drop'+ids.join('menu, #drop')+'menu').removeClass('drop_v2').addClass('drop_v1');

			App.comments.get_all_listings().find('#obj-comment'+ids.join(',#obj-comment'))
				.removeClass('commentList__item-collapsed commentList__item-collapseSaved')
				.find('.ico_view').removeClass('ico_view').addClass('ico_noview');
		},

		onkeydown: function (key, alt, ctrl, meta, shift, in_input, in_input_strict) {

			if (!self.obj_window) return false;

			const resolve_item = () => {
				if (App.keyboard_selection.is_mouse_moved) {
					let item_el =  document.elementFromPoint(App.controls.mouse.pageX, App.controls.mouse.pageY);
					return self.obj_window.find(item_el).closest('.commentList__item');
				} else {
					return self.obj_window.find('.commentList__item.selected').first();
				}
			};

			const item = resolve_item();
			if (!item.length) return false;
			if (!item.is('[data-can-hide]')) return false;

			if (key === App.keycode.KeyH && !alt && !ctrl && !meta && !shift && !in_input && !in_input_strict) {
				self.collapse(item.attr('data-id'))
				return true;
			}
		},

		destructor: function () {
			clearTimeout(self.send_timer);
			App.helper.localStorage.del('comments.update_server_seen_job');
			comment_show_type.del();

			self.obj_window = null;
			self.obj_container = null;
			self.id_task = 0;
			self.url = '';
			self.locale = {};
			self.total_shown = 0;
			self.total_shown_previous = 0;
			self.total_days = 0;
			self.total_days_min = null;
			self.archive = {};
			self.data_by_task = {};
			self.added_comments_by_task = {};
			self.data = null;
			self.options = null;
			self.show_type = null;
			self.authors = {};
			self.id_focus_comment = 0;

			self.seen_state = new Map();
			self.seen_state_ids_comment = new Map();
			self.send_timer = null;

			self.all_matched_filters = {};

			self.dom.destructor();
			self.mass.destructor();
			self.search.destructor();
			self.navi.destructor();
			self.saved_scroll.destructor();
			self.initial_scroll.destructor();
			self.unseen.destructor();
		},

		onBoot: function () {
			const mass = App.helper.object.clone(App.mass);

			mass.show = function() {
				if (this.shown) return;

				this.shown = true;
				// App.task_view.scroller.remember();
				App.comments.obj_container.addClass('taskView-withCommentMass');
				App.task_view.scroller.helper_link_comment_wrapper();
				App.task_view.scroller.helper_link_subtask_wrapper();
			}
			mass.hide = function() {
				if (!this.shown) return;

				this.shown = false;
				App.comments.obj_container.removeClass('taskView-withCommentMass');
				// App.task_view.scroller.restore();

				App.task_view.scroller.helper_link_comment_wrapper();
				App.task_view.scroller.helper_link_subtask_wrapper();
			};

			self.mass = mass.initController({
				config: {
					obj_type: 'comment'
				},
				autofit: true,
				click_enabled: true,
				panel: () => self.obj_container.find('.commentListPanel__mass'),
				container: () => self.obj_container.find('.commentList'),
				process_checkbox(mass, { input, val, rels }) {
					if ($(input).hasClass('mass-collapsed')) {
						const vals = val.split(','),
							ids_comment = vals.filter(v => v.indexOf('c') === 0).join(','),
							ids_log = vals.filter(v => v.indexOf('e') === 0).join(',');

						mass.add_id('com', ids_comment);
						mass.add_id('log', ids_log);

						rels.forEach((r) => {
							if (ids_comment.length) mass.add_id(`com_${r}`, ids_comment);
							if (ids_log.length) mass.add_id(`log_${r}`, ids_log);
						});
					} else if (rels.includes('com_act')) {
						const is_collapsed = $(input).parent().parent().hasClass('commentList__item-collapsed');
						mass.add_id(is_collapsed ? 'com_show' : 'com_hide', val);
					}
				}
			});
		},

		onLogin: function () {
			const update_server_seen_job = App.helper.localStorage.get('comments.update_server_seen_job');
			App.helper.localStorage.del('comments.update_server_seen_job');
			if (update_server_seen_job) {
				self.seen_state = update_server_seen_job[0];
				self.seen_state_ids_comment = update_server_seen_job[1];
				self.update_server_seen_job();
			}

			App.bus.window.on('resize', self.mass.fit_menu);
			App.bus.app.on('task_view_fullscreen task_view_resize_end', self.mass.fit_menu);

			App.bus.app
				.on('task_view_ready', function () {
					self.obj_container = App.task_view.obj_window;
					self.obj_window = self.obj_container.find('.commentList');

					if (self.obj_window.attr('data-init') !== 'yes') {
						self.obj_window.attr('data-init', 'yes');
						self.init();
						self.init_items();
						self.mass.init_menu();
					}

					self.url = self.mass.config.url = App.task_view.url;
					self.unseen.shown = self.unseen.reverse = false;
					self.unseen.el = null;
					self.show_type = App.task_view.is_chat ? 'comment' : comment_show_type.get();
					if (self.show_type === 'log' && self.id_focus_comment) self.set_option_type('comment');

					self.bind_references(App.task_view.id);

					if (App.task_view.context.use('mass_ids_cnt', 0) > 0) {
						self.mass.update_menu();
						self.mass.action_done();
					}

					self.draw();
				})
				.on('task_view_unready', function () {
					clearTimeout(self.draw_timer);

					self.ready = false;
					self.bind_references(0);
					self.mass.hide_menu();
					App.core.async_task.abort('comments_load_items');
					App.core.async_task.abort('comments_search');
				});

			App.bus.window.on('active', self.on_tab_active);
			App.bus.window.on('beforeunload', function () {
				App.helper.localStorage.set('comments.update_server_seen_job', [self.seen_state, self.seen_state_ids_comment], 30);
			});
		},
		onLogout: () => self.destructor(),
	};
})();

;// communication_widget.js
(function () {
	let self = App.communication_widget = {
		scripts: ['intercom', 'clarity'],
		log_enabled: false,
		run_local: false,

		_ran: Object.create(null),

		_log(category, message) {
			if (self.log_enabled) App.core.log(category, message);
		},

		_initOne(name) {
			const fnName = name + '_init';
			const fn = this[fnName];

			// hack for clarity only
			if (name === 'clarity' && Number(App?.account?.is_trial) !== 1) return;

			if (typeof fn !== 'function') {
				self._log('comm', `init function "${fnName}" not found`);
				return;
			}
			if (self._ran[name]) {
				self._log('comm', `"${name}" already initialized — skipping`);
				return;
			}

			try {
				fn.call(this);                // параметри беремо всередині конкретного _init
				self._ran[name] = true;
				self._log('comm', `"${name}" initialized`);
			} catch (e) {
				self._log('comm', {message: `"${name}" init failed`, error: e && e.message});
			}
		},

		onLoadPage() {
			if (!Array.isArray(self.scripts) || App.hybrid_app || (App.env === 'local' && self.run_local === false) || App.config.third_party_off === true) return;
			self._log('comm', `onLoadPage: initializing scripts ${JSON.stringify(self.scripts)}`);
			self.scripts.forEach((name) => self._initOne(String(name)));
		},

		onLogout() {
			window.Intercom && typeof window.Intercom==='function' && window.Intercom('hide');
		},

		// Ybug
		ybug_init: function () {
			const cfg = {
				id: '6s2c725gmkv4xqfcayt0',
				hide_launcher: true,
				language_override: App.config['language_symbol'],
				user: {
					id_account: App.account.id,
					user_email: App.me.email
				},
				onopen: function () {
					let btn = $('#primaryMenu .primaryMenu__item[data-config="bug"]');
					if (btn.length && btn.is(':visible')) {
						btn.removeClass('wait').addClass('primaryMenu__item-active');
					}
				},
				onclose: function() {
					let btn = $('#primaryMenu .primaryMenu__item[data-config="bug"]');
					if (btn.length && btn.is(':visible')) {
						btn.removeClass('wait').removeClass('primaryMenu__item-active');
					}
				},
			};

			if (!cfg.id) {
				self._log('ybug', '"id" is missing');
				return;
			}

			if (window.ybug) {
				window.ybug_settings = {...(window.ybug_settings || {}), ...cfg};
				self._log('ybug', 'settings updated');
				return;
			}

			window.ybug_settings = {...cfg};

			if (!document.querySelector('script[data-comm="ybug"]')) {
				const s = document.createElement('script');
				s.type = 'text/javascript';
				s.async = true;
				s.src = 'https://widget.ybug.io/button/' + encodeURIComponent(cfg.id) + '.js';
				s.dataset.comm = 'ybug';
				s.onload = () => self._log('ybug', 'script loaded');
				s.onerror = () => self._log('ybug', 'script failed to load');
				(document.head || document.documentElement).appendChild(s);
				self._log('ybug', 'script tag injected');
			} else {
				self._log('ybug', 'script already present — skipping inject');
			}
		},

		ybug_show: function () {
			if (window.ybug_settings) Ybug.open();
		},

		// Intercom counter
		_wireIntercomUnreadCounter: function(selector = '#primaryMenu__support__counter') {
			const host = document.querySelector(selector);
			if (!host) { App.core.log('intercom', `counter element not found: ${selector}`); return; }

			let badge = host.querySelector('.cnt_new');
			if (!badge) {
				badge = document.createElement('span');
				badge.className = 'cnt_new';
				host.appendChild(badge);
			}

			// спочатку сховаємо
			host.setAttribute('hidden', '');

			// підписка (викличеться одразу і при кожній зміні)
			window.Intercom('onUnreadCountChange', (count) => {
				badge.textContent = count > 99 ? '99+' : String(count);
				if (count > 0) host.removeAttribute('hidden');
				else host.setAttribute('hidden', '');
			});

			App.core.log('intercom', 'unread counter wired');
		},

		// Intercom
		intercom_init: function() {
			try {
				const hex = App?.config?.intercom;
				if (typeof hex !== 'string' || hex.length === 0) {
					self._log('intercom', 'hex payload missing');
					return;
				}

				const jsonStr = decodeURIComponent(hex.replace(/([0-9A-F]{2})/gi, '%$1'));
				const cfg = JSON.parse(jsonStr);

				if (!cfg.app_id) { self._log('intercom', '"app_id" is missing'); return; }

				cfg.alignment = 'left';
				cfg.horizontal_padding = 50;
				cfg.vertical_padding = 30;
				cfg.z_index = 1030;

				window.intercomSettings = cfg;

				const wire = () => self._wireIntercomUnreadCounter('#primaryMenu__support__counter');

				const toggle = () => {
					Intercom('onShow', function() {
						let btn = $('#primaryMenu .primaryMenu__item[data-config="support"]');
						if (btn.length && btn.is(':visible')) {
							btn.removeClass('wait').addClass('primaryMenu__item-active');
						}
						$('#menuOverlay').show().on('click', ()=>{window.Intercom('hide')});
					});
					Intercom('onHide', function(){
						let btn = $('#primaryMenu .primaryMenu__item[data-config="support"]');
						if (btn.length && btn.is(':visible')) {
							btn.removeClass('wait').removeClass('primaryMenu__item-active');
						}
						$('#menuOverlay').hide().off('click');
					});
				};

				if (typeof window.Intercom === 'function') {
					window.Intercom('update', window.intercomSettings);
					self._log('intercom', 'updated existing instance');
					wire();
					return;
				}

				if (!document.querySelector('script[data-comm="intercom"]')) {
					const s = document.createElement('script');
					s.async = true;
					s.src = 'https://widget.intercom.io/widget/' + encodeURIComponent(cfg.app_id); // <-- було appId
					s.dataset.comm = 'intercom';
					s.onload = () => {
						self._log('intercom', 'script loaded, booting');
						window.Intercom('boot', window.intercomSettings);
						wire();
						toggle();
					};
					s.onerror = () => self._log('intercom', 'script failed to load');
					(document.head || document.documentElement).appendChild(s);
					self._log('intercom', 'script tag injected');
				} else {
					self._log('intercom', 'script already present — skipping inject');
					const t = setInterval(() => {
						if (typeof window.Intercom === 'function') {
							clearInterval(t);
							wire();
						}
					}, 300);
					setTimeout(() => clearInterval(t), 5000);
				}
			} catch (e) {
				self._log('intercom', `init failed: ${e && e.message}`);
			}
		},

		intercom_show: function () {
			window.Intercom && typeof window.Intercom==='function' && window.Intercom('show');
		},

		// Clarity
		clarity_init: function () {
			const id = 'ufrctmj1jy';

			if (!id) {
				self._log('clarity', '"id" is missing');
				return;
			}

			if (typeof window.clarity === 'function') {
				self._log('clarity', 'already present — skipping');
				return;
			}

			window.clarity = window.clarity || function () {
				(window.clarity.q = window.clarity.q || []).push(arguments);
			};

			if (!document.querySelector('script[data-comm="clarity"]')) {
				const s = document.createElement('script');
				s.type = 'text/javascript';
				s.async = true;
				s.src = 'https://www.clarity.ms/tag/' + encodeURIComponent(id);
				s.dataset.comm = 'clarity';
				s.onload = () => self._log('clarity', 'script loaded');
				s.onerror = () => self._log('clarity', 'script failed to load');
				(document.head || document.documentElement).appendChild(s);
				self._log('clarity', 'script tag injected');
			} else {
				self._log('clarity', 'script already present — skipping inject');
			}
		}
	};
})();
;(function() {
	let self = App.contacts = {
		current_scope: 'def',
		// from template
		locale: {
			required: '',
			email_confirm: '',
			email_invalid: '',
			email_empty: '',
			phone_invalid: '',
		},
		is_global_ok: true,

		init: function (scope, readonly) {

			if (readonly) {
				self.readonly.init();
			}

			self.current_scope = scope ? scope : 'def';
			App.modal.obj_window.attr('data-height', App.modal.obj_window.height());
			$('.blank .input[name=name]').bind('keyup', function () {
				let a = this.value.split(' ')
				let str = a[0].substr(0, 1);
				if (a[1]) str += a[1].substr(0, 1);
				if (str.length) $('.blank .ava_place .av_nm').removeClass('av_def5').html(str.toUpperCase());
				else $('.blank .ava_place .av_nm').addClass('av_def5').html('');
			});
			self.search.init_duplicate_search();

			$('.blank input').bind('focus', function () {
				const input_block = $(this).closest('.inputBlock');

				// залишимо інформаційне повідомлення, якщо немає помилки
				if (input_block.hasClass('req_error')) {
					input_block.removeClass('req_error');
					input_block.find('.inputBlock__alert').hide(50);
				}
			});
			$('.blank .input + label').bind('click', function () {
				if ($(this).prev().attr('data-fld') == 'tags') $('#dropmlabel').trigger('click'); else $(this).prev().focus();
			});
			$('.blank .input').bind('keydown', function (e) {

				if (self.is_rotated) {
					self.is_rotated = false;
					App.modal.obj_window.find('.button_grad').show().next().hide().next().next().show();
				}
				let key = e.keyCode ? e.keyCode : e.charCode;
				if (key === App.keycode.Enter) { // Enter
					o = $(this).parent().nextAll('.itm:visible:first');
					if (o.length) o.find('.input').focus(); else {
						$(this).blur();
						App.modal.obj_window.find('.modal__content .buttons .button_grad').focus();
					}
				}
			}).bind('keyup paste blur', function () {
				const data_def = $(this).attr('data-def');
				const value = $(this).val();
				if (!data_def) {
					return;
				}

				if (data_def.toLowerCase() === value.toLowerCase()) {
					$(this).closest('.inputBlock').find('.inputBlock__alert').hide(50);
					$(this).closest('.inputBlock').removeClass('req_error');
					return;
				}

				if ($(this).attr('name') === 'email') {
					const input = $(this);
					const is_email_confirmation = $(this).attr('data-email-confirmation') == 1;
					const is_waits_invite = $(this).attr('data-email-confirmation') == 2;
					const toggle_error = (is_error, error_text) => {
						input.closest('.inputBlock').toggleClass('req_error', is_error);

						const alert_block = $(this).closest('.inputBlock').find('.inputBlock__alert');
						if (!error_text) {
							alert_block.hide(50);
							return;
						}

						alert_block.show(50)
							.find('.in').text(error_text);
					};

					if (input.hasClass('req')) {
						const { is_error, error_text } = self.validate_required(input);

						toggle_error(is_error, error_text);
					}

					const { is_error, error_text } = self.validate_email(input);
					const alert_text = error_text || (is_waits_invite ? self.locale.email_reinvite : (is_email_confirmation ? self.locale.email_confirm : null));

					toggle_error(is_error, alert_text);
				}
			});

			self.bind_form_change();

			$('.blank .ava_place:not([onclick])').bind('click', function () {
				App.helper.selection.clear();
				let av_color = 1 * $(this).find('input').val();
				if (av_color == 0 || av_color >= 3000) {
					av_color = (av_color - 3000 + 1) % 10;
					$(this).find('input').val(3000 + av_color);
					$(this).closest('form').trigger('change');
					$(this).find('.av_nm').attr('class', 'av_nm av_let av_let' + av_color + ($(this).find('.av_nm').hasClass('av_def5') ? ' av_def5' : ''));
				}
			});

			let form = App.modal.obj_window.find('form[name=invite_frm]').eq(0);
			if (form.attr('data-highlight') !== '') {
				let hlt = form.find('#fld_'+form.attr('data-highlight'));
				if (hlt.length) {
					setTimeout(function(){
						let moreItms = hlt.closest('.more_itms');
						if (moreItms.length && !moreItms.is(':visible')) {
							form.find('.blank .show-more').trigger('click');
						}
						hlt.scrollIntoViewIfNeeded(self.get_highlight_scroll_options(hlt, form.attr('data-highlight')));
						hlt.focus().select();
					}, 300);
				}
			}
		},

		get_highlight_scroll_options: function(hlt, highlight) {
			if (highlight === 'addr') {
				let nextBlock = hlt.closest('.inputBlock').next('.inputBlock');
				return {
					offset_top: 20,
					offset_bottom: 20 + (nextBlock.length && nextBlock.is(':visible') ? nextBlock.outerHeight() : 0),
				};
			}
			return { offset_block: 20 };
		},

		readonly: {
			init: function () {
				App.modal.obj_window.find('.inputBlock input[type="text"], .inputBlock textarea')
					.prop('readonly', true)
					.each(function () {
						if (this.value.trim() != '') return;
						$(this).closest('.inputBlock').remove();
					});
				if (App.modal.obj_window.find('.editBlock__picker-tags input').val() === '') {
					App.modal.obj_window.find('.editBlock__picker-tags').remove();
				} else {
					App.modal.obj_window.find('.editBlock__picker-tags')
						.removeAttr('onclick')
						.find('.editBlock__picker__add').remove();
				}
				App.modal.obj_window.find('.drop_select').removeAttr('onclick')
					.find('> ws-icon').remove();
				App.modal.obj_window.find('.ava_place').attr('onclick', 'return false;');
				App.modal.obj_window.find('.inputBlock__icons').find('.alwaysOn').remove();
				App.modal.obj_window.find('.show-more').click();
				App.modal.obj_window.find('.label-has-drop').each(function () {
					const label = $(this).find('.in').text();
					$(this)
						.removeClass('label-has-drop')
						.addClass('label')
						.text(label);
				});
				App.modal.obj_window.find('.button-submit').remove();
			}
		},

		submit: function () {
			self.is_global_ok = true;
			const toggle_error = (input, is_error, error_text) => {
				self.is_global_ok = self.is_global_ok && !is_error;
				const input_block = input.closest('.inputBlock');
				const alert_block = input_block.find('.inputBlock__alert');
				input_block.toggleClass('req_error', is_error);
				if (error_text) {
					alert_block.find('.in').text(error_text);
				}
				if (is_error || error_text) {
					alert_block.show(50);
				} else {
					alert_block.hide(50);
				}
			};
			if (!document.invite_frm.is_mass || !document.invite_frm.is_mass.value) {
				$('.blank .inputBlock').removeClass('req_error');
				$('.blank .req').each(function () {
					let is_ok = false;
					if (this.value.trim()) is_ok = true;
					if ($(this).attr('data-reserve')) $($(this).attr('data-reserve')).each(function () {
						if ($(this).val().trim()) is_ok = true;
					});

					toggle_error($(this), !is_ok, !is_ok ? self.locale.required : null);
				});
				$('.blank .valid_email').each(function () {
					const value = $(this).val().trim();
					if (!value) return;

					const {is_error, error_text} = self.validate_email($(this));
					toggle_error($(this), is_error, error_text);
				});
				$('.blank .valid_phone').each(function () {
					const value = $(this).val().trim();
					if (!value) return;

					const {is_error, error_text} = self.validate_phone($(this));
					toggle_error($(this), is_error, error_text);
				});
				if ($('.blank .input_error').length) {
					self.is_global_ok = false;
				}
			}
			const submit_buttons_selector = '.button-submit, .modal__header .buttons button';
			const shake_submit_button = () => {
				App.modal.obj_window.find(submit_buttons_selector)
					.animate_css('head-shake');
			};
			if (self.is_global_ok) {
				$(document.invite_frm).attr('data-submitted', 'yes');
				App.modal.obj_window.find(submit_buttons_selector)
					.toggleDisabled(true);
				$.ajax({
					type: 'POST',
					dataType: 'text',
					url: $(document.invite_frm).attr('action'),
					data: 'is_ajax=' + self.current_scope + '&' + $(document.invite_frm).serialize(),
					success: function (response, status, xhr) {
						$(document.invite_frm).removeAttr('data-submitted');
						const content_type = xhr.getResponseHeader('Content-Type');

						if (content_type && (content_type.includes('application/javascript') || content_type.includes('text/javascript'))) {

							App.controls.editblock.set_updated_state(false);
							$.globalEval(response);
						} else {
							console.error('Error: response is not javascript');
							debugger;
						}
					},
					error: App.core.create_jq_ajax_error(function () {
						$(document.invite_frm).removeAttr('data-submitted');
						shake_submit_button();
						App.modal.obj_window.find(submit_buttons_selector).toggleDisabled(false);
					})
				});
				return true;
			} else {
				// false - плавний скролл не працює в модалці!
				App.modal.obj_window.find('.req_error').first().scrollIntoView(false);
				shake_submit_button();
				return false;
			}
		},

		is_rotated: false,
		rotate: function () {
			App.controls.editblock.set_updated_state(false);
			App.modal.obj_window.addClass('step1');
			App.modal.obj_window.css({height: App.modal.obj_window.height()});
			App.modal.obj_window.addClass('item_ania');
			setTimeout(function () {
				App.modal.obj_window.addClass('step2');
				App.modal.obj_window.css({height: App.modal.obj_window.attr('data-height')});
			}, 500);
			setTimeout(function () {
				App.modal.obj_window.addClass('step3');
				$('.blank .input, .blank .textarea').val('');
				self.is_rotated = true;
				App.modal.obj_window.find('.button_grad').hide().next().show().focus().next().next().hide(); //.html(App.modal.obj_window.find('.button_grad').attr('data-txt1'))
				$('.blank .itm_hid_def').addClass('itm_hid');
				$('.blank .more').show().next().hide();
				$('.blank .itm_clone').remove();
				$('.blank .ava_place .av_nm').addClass('av_def5').html('');
			}, 550);
			setTimeout(function () {
				$(document.invite_frm).trigger('change');
			}, 600)
			setTimeout(function () {
				App.modal.obj_window.addClass('item_ania');
				App.modal.obj_window.css({height: ''});
				App.modal.obj_window.removeClass('step1 step2 step3');
			}, 1050);
		},

		clone_field: function (el) {
			let o = $(el).closest('.inputBlock').clone();
			let rel = o.attr('rel');
			o.addClass('itm_clone').find('input[type=text]').val('');
			$('#drop' + rel + 'menu a[rel=' + o.find('.in').next().val() + ']').each(function () {
				let o2 = $(this).next().filter(':not(.menu__item-hidden)');
				if (!o2.length) o2 = $(this).parent().find('a[rel]:not(.menu__item-hidden):first');
				if (!o2.length) return;
				o.find('.in').text(o2.find('.in').text()).next().val(o2.attr('rel'));
				o.find('input[data-fld]').attr('data-fld', rel + o2.attr('rel'));
				o2.addClass('menu__item-hidden');
			});
			if (!$('#drop' + rel + 'menu a[rel]:not(.menu__item-hidden)').length) {
				$('#drop' + rel + 'menu .menu__group:first').addClass('menu__group-hidden');
				o.find('ws-btn.clone_field').hide();
			}
			$(el).closest('.inputBlock').after(o);
			$(el).hide();
			$('#drop' + rel + 'menu .menu__item-delete').parent().removeClass('menu__group-hidden');
			o.find('input').focus();
			o.closest('form').trigger('change');
		},

		set_field_name: function (el) {
			let rel;
			let menu_rel = el.closest('.menu').attr('id').match(/drop(.*?)menu/);
			if (menu_rel && menu_rel[1]) rel = menu_rel[1];
			$(App.menu.active_anchor).find('.in').text(el.text()).next().val(el.attr('rel'));
			$(App.menu.active_anchor).parent().prev().attr('data-fld', rel + el.attr('rel'));
			el.parent().find('a[rel]').removeClass('menu__item-hidden');
			$('input[data-fld^=' + rel + ']').each(function () {
				let relNum = $(this).attr('data-fld').replace(rel, '');
				el.parent().find('a[rel=' + relNum + ']').addClass('menu__item-hidden');
			});
			App.menu.hide(true);
			return false;
		},

		delele_field: function () {
			let el = $(App.menu.active_anchor).closest('.inputBlock');
			let form = el.closest('form');
			let el2 = el.prev();
			let rel = el.attr('rel');
			let relNum = el.find('input[data-fld^=' + rel + ']').attr('data-fld').replace(rel, '');
			$('#drop' + rel + 'menu').find('a[rel=' + relNum + ']').removeClass('menu__item-hidden').parent().removeClass('menu__group-hidden');
			el.remove();
			el2.find('ws-btn.clone_field').show();
			if ($('.inputBlock[rel=' + rel + ']').length == 1) $('#drop' + rel + 'menu .menu__group:last').addClass('menu__group-hidden');
			App.menu.hide(true);
			form.trigger('change');
		},

		show_field: function (el) {
			let o = el.closest('.inputBlock');
			o.find('input').blur();
			o.next().removeClass('itm_hid').find('input').focus();
			el.remove();
		},

		copy_field: function (el) {
			el.shortblink();
			let o = $(el).closest('.inputBlock__label').find('input, textarea');
			App.core.clipboard(o);
		},

		/**
		 * @param {*} el
		 * @returns {{is_error: boolean, error_text: ?string}}
		 */
		validate_required: function (el) {
			const value = el.val().trim();

			const is_error = value === '';

			return {
				is_error,
				error_text: null,
				// тут без тексту
				// error_text: is_error ? self.locale.required : null,
			};
		},

		/**
		 * @param {*} el
		 * @returns {{is_error: boolean, error_text: ?string}}
		 */
		validate_email: function (el) {
			const value = el.val().trim();

			const addition_regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/

			const is_error = !App.helper.validate.email.test(value) || !addition_regex.test(value) || !value.length;

			return {
				is_error,
				error_text: is_error ? (value.length ? self.locale.email_invalid : self.locale.email_empty) : null,
			};
		},

		/**
		 * @param {*} el
		 * @returns {{is_error: boolean, error_text: ?string}}
		 */
		validate_phone: function (el) {
			const value = el.val().trim();

			const is_error = !App.helper.validate.phone.test(value);

			return {
				is_error,
				error_text: is_error ? self.locale.phone_invalid : null,
			};
		},

		search: {

			init_duplicate_search: function () {
				let menu = $('#search_contact');
				if (menu.length) {
					$('.blank .input[data-search]').bind('keyup', function (e) {
						let input = $(this);
						let key = e.keyCode ? e.keyCode : e.charCode;
						if (key === App.keycode.Escape) { // Esc
							if (!menu.is(':hidden')) App.menu.hide(true);
						} else {
							App.core.call_queue.add('editor_contact_search', self.search.helper_server_search, menu, input, key === App.keycode.Enter ? 0 : 0.5);
						}
					});
					menu.on('click', '.menu__item', function () {
						if (menu.attr('data-url').indexOf('type=account_contacts') !== -1) {
							App.modal.hide({ force: true });
							App.controls.account_phone_update.menu.contact.apply(this, App.controls.account_phone_update.CONTACT_TYPE_PAYMENT, $(this).attr('data-id'));
							return;
						}
						App.modal.show({
							url: menu.attr('data-modal-url').replace(/%id%/g, $(this).attr('data-id')),
							title: menu.attr('data-modal-title'),
							group: 'contact',
							width: 560
						});
					});
				}
			},

			helper_server_search: function (input) {
				let menu = $(this);
				let this_search = input.val().trim();
				let this_field = input.attr('name') || 'all';
				if (this_search !== input.attr('data-last-value')?.trim()) {
					if (this_search.length >= 3) {
							menu.load(menu.attr('data-url') + '&search=' + encodeURIComponent(this_search) + '&search_field=' + encodeURIComponent(this_field), function () {
								if ($(this).find('.menu__item').length) {
									if (menu.is(':hidden')) App.menu.show({
										anchor: input.closest('.inputBlock').get(0),
										box: '#search_contact',
										type: 'width text'
									});
								} else {
									if (menu.length && !menu.is(':hidden')) App.menu.hide(true);
								}
							});
					} else {
						if (!menu.is(':hidden')) App.menu.hide(true);
					}
					input.attr('data-last-value', this_search);
				}
			}
		},

		team_slider_switch: (option) => {
			const bool_value = $(option).attr('data-value') == 0;
			$(option).closest('ws-slider').toggleClass('violet', bool_value).toggleClass('blue', !bool_value);
			$('#mygroup_hint .setupBlock__info:first-child')
				.toggleClass('ws-utility-hidden', bool_value)
				.next().toggleClass('ws-utility-hidden', !bool_value);
		},

		bind_form_change: () => {
			const modal = App.modal.obj_window;
			const button_close = modal.find('.button-close');
			const button_submit = modal.find('.button-submit');

			button_submit.each(function () {
				$(this).attr('data-default-hidden', $(this).hasClass('ws-utility-hidden'));
			});

			const form_changed_callback = () => {
				button_close.addClass('ws-utility-hidden');
				button_submit
					.removeClass('ws-utility-hidden')
					.toggleDisabled(false);
			};
			const form_unchanged_callback = () => {
				button_close.removeClass('ws-utility-hidden');
				button_submit
					.toggleDisabled(true)
					.filter('[data-default-hidden="true"]')
					.addClass('ws-utility-hidden');
			};

			modal.find('form').form_change_tracker(form_changed_callback, form_unchanged_callback);
		}
	}
})();

;var App = App || {};

(function() {
	let self = App.contact_edit = {
		tags: function(menu_anchor) {
			App.controls.project_task_labels_and_go.show_context(menu_anchor, $(menu_anchor).attr('data-url'), {
				onload: function() {
					let menu = $(this);
					menu.on('click', '.menu__group-head .btn-primary', function() {
						let ids = [];
						menu.find('.menu__item-picked').each(function() {
							ids.push($(this).attr('data-id').toInt());
						});
						menu.find('input[name=tags]').val(ids.join(','))
						App.core.form_submit(menu.find('form'), function () {
							App.menu.hide();
						});
					});
				},
				onshow: function() {
					$(this).find('ws-btn input[name=skip_notify]').val('');
					$(this).find('.editBlock__picker__item').remove();
					let ids = $(this).find('input[name=tags]').length ? $(this).find('input[name=tags]').val().split(',').map(Number) : [];
					$(this).find('.menu__item[data-id]').removeClass('menu__item-picked').filter(function() {
						return ids.includes($(this).attr('data-id').toInt());
					}).trigger('preset');
				}
			});
		},
		tags_update: function(id_user, data) {
			App.menu.hide();
			$('[data-contact="'+id_user+'"] .dot_tags').replaceWith(data.tags);
		},
		tags_on_create: function(menu_anchor) {
			App.controls.project_task_labels_and_go.show_context(menu_anchor, $(menu_anchor).attr('data-url'), {
				type: 'picker',
				onload: function() {

					const menu = $(this);

					menu.bind('after_interaction', function() {
						const picker = App.modal.obj_window.find('[data-container=labels]');
						const selected_items = menu.closest('.menu').find('.menu__item-picked');
						picker.find('.editBlock__picker__item').remove();

						const ids = [];
						selected_items.each(function(index, item) {

							const id_tag = $(item).attr('data-id');
							ids.push(id_tag);

							picker.find('.editBlock__picker__add').before(App.helper.template.fill('editBlock_picker_tag', {
								'data-id': id_tag,
								name: App.tags[id_tag].name,
								color: App.tags[id_tag].color,
								hidden: App.tags_group[App.tags[id_tag].id_group].hidden ? 1 : 0,
								delete: false
							}));
						});
						picker.find('input').val(ids.join(','))
						picker.closest('form').trigger('change');
						return false;
					})
				},
				onshow: function() {
					let menu = $(this);
					let picker = App.modal.obj_window.find('[data-container=labels]');
					menu.find('.editBlock__picker__item').remove();
					let ids = picker.find('input').val().split(',').map(Number);
					menu.find('.menu__item[data-id]').removeClass('menu__item-picked').filter(function() {
						return ids.includes($(this).attr('data-id').toInt());
					}).trigger('preset');
				}
			});
		},
	}
})();
;var App = App || {};

App.costs_list = {
	locale: {}, // from template
	config: {}, // from template

	save_onfly: {
		timeout: {},
		apply: function (el, now) {
			$(el).addClass('inp_load_pre');
			let j = $(el).closest('.modal__dataTable__item');
			if ($(el).attr('rel').indexOf('time') !== -1) {
				j.removeClass('ttimer').find('.timer_place').remove();
			}
			if (el.id in App.costs_list.save_onfly.timeout) clearTimeout(App.costs_list.save_onfly.timeout[el.id]);
			App.costs_list.save_onfly.timeout[el.id] = setTimeout(function (el) {
				$("#" + el.id).removeClass("inp_load_pre").addClass("inp_load");
				$.ajax({
					url: '/ajax/time/?' + App.actions.get('costs_save:do'),
					method: 'GET',
					dataType: 'script',
					data: {
						field: el.id,
						note: el.value,
						rate: $(el).parent().parent().find('.sw_act').attr('rel')
					},
				});
			}, now ? 0 : 1000, el);
			App.costs_list.update_total();
		},
	},

	update_total: function () {
		let tk, k, ak;
		ak = 0;// xx
		let obj_window = $('.modal');
		obj_window.find('.modal__dataTable-costs input[rel=time]').each(function () {
			tk = $(this).val().replace(/\s+/g, '').replace(/-/g, ':').replace(/,/g, '.');
			if (!App.helper.validate.time_readable.test(tk) && !App.helper.validate.time_float.test(tk)) tk = '—';
			if (tk == '—') {
				tk = 0;
			} else if (App.helper.validate.time_readable.test(tk)) {
				tk = 60 * RegExp.$1 / 1 + RegExp.$2 / 1;
			} else if (App.helper.validate.time_int.test(tk)) {
				tk = Math.round(60 * tk);
			} else {
				tk = 0;
			}
			ak += tk;
		});
		obj_window.find('.sum_progress .td_time span').html(App.format.time(ak, 1));
		let bar = obj_window.find('.bar_max_time');
		if (bar.length) {
			bar.find('.b_fl span').html(App.format.time(ak, 1));
			ak = 100 * ak / (60 * bar.attr('rel'));
			bar.find('.b_br').html(Math.floor(ak) + '%');
			if (ak > 100) {
				bar.find('.progress').addClass('progress_time_over').removeClass('progress_time');
				bar.find('.progress div').addClass('over').css({width: Math.floor(100 * (1 - 100 / ak)) + '%'});
			} else {
				bar.find('.progress').addClass('progress_time').removeClass('progress_time_over');
				bar.find('.progress div').removeClass('over').css({width: Math.floor(ak) + '%'});
			}
		}
		ak = 0;
		obj_window.find('.modal__dataTable-costs input[rel=money]').each(function () {
			tk = $(this).val().replace(/\s+/g, '').replace(/,/g, '.');
			if (App.helper.validate.money_float.test(tk)) tk = 0.01 * Math.round(tk * 100); else tk = 0;
			if (tk == '—') {
				tk = 0;
			} else {
				tk = Math.round(100 * tk);
			}
			ak += tk;
		});
		obj_window.find('.sum_progress .td_money span').html(App.format.money(ak, 1, true));
		bar = obj_window.find('.bar_max_money');
		if (bar.length) {
			bar.find('.b_fl span').html(App.format.money(ak, 1));
			ak = 100 * ak / (100 * bar.attr('rel'));
			bar.find('.b_br').html(Math.floor(ak) + '%');
			if (ak > 100) {
				bar.find('.progress').addClass('progress_money_over').removeClass('progress_money');
				bar.find('.progress div').addClass('over').css({width: Math.floor(100 * (1 - 100 / ak)) + '%'});
			} else {
				bar.find('.progress').addClass('progress_money').removeClass('progress_money_over');
				bar.find('.progress div').removeClass('over').css({width: Math.floor(ak) + '%'});
			}
		}
	},

	load_item: function(id) {
		let o = $('#time_list');
		if (o.length) $.ajax({
			url: o.attr('data-endpoint') + '?' + App.actions.get('task_costs_item:show') + '&id_time=' + id + '&type=list',
			success: function(html) {
				if (o.find('.modal__dataTable__head').length) o.find('.modal__dataTable__head').after(html); else o.prepend(html);
				App.costs_list.update_total();
			}
		});
	},

	init_items: function () {
		$('.td_rate a').bind('click', function () {
			if (!$(this).hasClass('sw_act')) {
				$(this).addClass('sw_act').attr('data-title', '');
				let ri = $(this).closest('.modal__dataTable__item').find('.td_time .input');
				let time = ri.val().replace(/ /g, '').replace(/,/g, '.');
				if (App.helper.validate.time_readable.test(time)) {
					time = 1 * RegExp.$1 + RegExp.$2 / 60;
				} else if (App.helper.validate.time_int.test(time)) {
					time = 1 * time;
				} else {
					time = 0;
				}
				let rate = 1 * $(this).attr('rel').replace(/ /g, '').replace(/,/g, '.');
				let money = Math.round(time * rate * Math.pow(10, App.config.round_money)) / Math.pow(10, App.config.round_money);
				if (money) {
					$(this).closest('.modal__dataTable__item').find('.td_money .input').val(money);
				} else {
					$(this).closest('.modal__dataTable__item').find('.td_money .input').val('—');
				}
				App.costs_list.save_onfly.apply(ri.get(0), 1);
			}
			return false;
		});
		$('.td_time .input').bind('focus', function () {
			if ($(this).val() == '—') $(this).val('0:00');
			if (!App.device.is_mobile()) $(this).trigger('select');
		}).bind('blur', function () {
			let time = $(this).val().replace(/\s+/g, '').replace(/-/g, ':').replace(/,/g, '.');
			if (!App.helper.validate.time_readable.test(time) && !App.helper.validate.time_float.test(time)) time = '—';
			if (time == '0' || time == '0:00') time = '—';
			$(this).val(time);
		}).bind('keyup paste', function (e) {
			let me = this;
			let delay = event.type === 'paste' ? 50 : 0;
			let keycode = e.which || e.keyCode || e.charCode;
			setTimeout(function () {
				let rt = $(me).closest('.modal__dataTable__item').find('.sw_act');
				if (rt.length) {
					let time = $(me).val().replace(/ /g, '').replace(/,/g, '.');
					if (App.helper.validate.time_readable.test(time)) {
						time = 1 * RegExp.$1 + RegExp.$2 / 60;
					} else if (App.helper.validate.time_int.test(time)) {
						time = 1 * time;
					} else {
						time = 0;
					}
					time = Math.round(time * 60) / 60;
					let rate = 1 * rt.attr('rel').replace(/ /g, '').replace(/,/g, '.');
					let money = Math.round(time * rate * Math.pow(10, App.config.round_money)) / Math.pow(10, App.config.round_money);
					if (money) {
						$(me).closest('.modal__dataTable__item').find('.td_money .input').val(money);
					} else {
						$(me).closest('.modal__dataTable__item').find('.td_money .input').val('—');
					}
				}
				App.costs_list.save_onfly.apply(me, keycode === App.keycode.Enter);
				App.costs_list.update_total(App.modal.obj_window)
			}, delay);

		});
		$('.td_money .input').bind('focus', function () {
			if ($(this).val() == '—') $(this).val('0');
			if (!App.device.is_mobile()) $(this).trigger('select');
		}).bind('blur', function () {
			let money = $(this).val().replace(/\s+/g, '').replace(/,/g, '.');
			if (App.helper.validate.money_float.test(money)) money = 0.01 * Math.round(money * 100); else money = 0;
			$(this).val(money ? money : '—');
		}).bind('keyup', function (e) {
			let keycode = e.which || e.keyCode || e.charCode;
			$(this).closest('.modal__dataTable__item').find('.td_rate a').removeClass('sw_act').attr('data-title', App.costs_list.locale['hint_calc']);
			App.costs_list.save_onfly.apply(this, keycode === App.keycode.Enter);
		});
		this.init_costs_inputs();
	},

	init_costs_inputs: function() {
		$('.modal__dataTable-costs').on('blur', '.td_name textarea', function () {
			let a = $(this).closest('.td_name').find('a.costs_comment');
			$.ajax({
				url: '/ajax/time/?'+App.actions.get('costs_save_inline:do')+'&field=name' + '&id_time=' + $(this).attr('data-id') + '&value=' + encodeURIComponent($(this).val())
			});
			$(this).addClass('hide');
			if ($(this).val() === '') {
				a.html('<i>' + $(this).attr('placeholder') + '</i>');
			} else {
				a.html(App.helper.html.encode($(this).val()));
			}
			a.removeClass('hide');
			a.closest('.costs_comment_block').removeClass('hide');

			// треба затримка, бо через зміну розміра модалки клік приходиться в оверлей і модалка випадково закривається
			if (App.device.is_mobile() || $(this).css('position') === 'absolute') $(this).closest('.td_name').removeClass('editing');
			else setTimeout(() => $(this).closest('.td_name').removeClass('editing'), 200);
		})
		.on('focus', '.td_name textarea', function () {
			$(this).closest('.td_name').addClass('editing');
			App.helper.input.auto_grow($(this), 40);
		})
		.on('click', '.td_name a.costs_comment.onch', function () {
			$(this).addClass('hide');
			$(this).closest('.costs_comment_block').addClass('hide');
			let textarea = $(this).closest('.td_name').find('textarea');
			textarea.removeClass('hide');
			textarea.focus();
		})
		.on('mouseover', '.join_but', function() {
			if (App.scroll_listener.is_scrolling) return;
			let a = $(this).attr('data-join').split(',');
			$('#obj-costs-modal' + a.join(',#obj-costs-modal')).addClass('modal__dataTable__item-joinPossible');
		})
		.on('mouseout', '.join_but', function() {
			if (App.scroll_listener.is_scrolling) return;
			let a = $(this).attr('data-join').split(',');
			$('#obj-costs-modal' + a.join(',#obj-costs-modal')).removeClass('modal__dataTable__item-joinPossible');
		})
		.on('keyup', '.td_time input, .td_money input', function (e) {
			if (e.keyCode === App.keycode.Enter) $(this).blur();
		});
	},

	helper_onload_size: function() {
		setTimeout(function () {
			let win = App.modal.obj_window;
			let win_mh = parseInt(win.css('max-height'), 10);
			win.find('#time_list').attr('style', '');
			let visibleSize = win.find('.modal__header').outerHeight(true) + win.find('.sum_progress').outerHeight(true) + win.find('.btns-row').outerHeight(true);
			if (visibleSize <150) visibleSize = 150;
			if (win.height() > win_mh) App.modal.obj_window.find('#time_list').css({maxHeight: (win.height() - visibleSize - 48) + 'px'});
		}, 100);
	},

	onresize: function() {
		setTimeout(function () {
			$('.modal__dataTable-costs .td_name textarea').each(function () {
					App.helper.input.auto_grow($(this), 40)
			});
			App.costs_list.helper_onload_size();
		}, 100);
	},

	init: function () {
		App.costs_list.init_items();
		App.costs_list.helper_onload_size();
		$(window).resize(() => this.onresize());
		App.modal.obj_window.on('resize.modal', () => this.onresize());
	}
}

;var App = App || {};

(function() {
	// ! закос под мобільну модалку, розраховано, що працюватиме тіки на мобілі
	let self = App.dashboard_view = {
		shown: false,
		obj_wrapper: null,
		obj_overlay: null,
		obj_window: null,
		obj_menus: null,

		template: `
		<div class="dashboardView__overlay">
			<div id="dashboardView" class="dashboardView">
				<div class="dashboardView__swipe"></div>
				<div class="dashboardView__header flex_row">
					<div class="in flex_row"></div>
				</div>
				<div class="dashboardView__content flex_column"></div>
			</div>
		</div>
		`,

		is_shown: function () {
			return self.shown;
		},

		show: function(params) {
			if (!App.windows.before_open(self.window)) return;

			if (self.is_shown()) {
				self.window.alreadyOpened();
				return false;
			}

			params||= {};
			const url = params.url;

			$('body').addClass('withDashboardView');

			self.window.opening();
			App.controls.loader.start();
			App.core.async_task.abort('dashboard_view_show');
			self.window.loading();
			App.core.async_task.ajax({
				id: 'dashboard_view_show',
				url: url,
				success: function (html) {
					self.shown = true;

					const content = $(html);

					if (content.is('#dashboardView')) {
						self.obj_wrapper.append(content);
					} else {
						self.obj_wrapper.html(self.template).find('#dashboardView .dashboardView__content').append(content);
					}

					self.obj_menus = self.obj_wrapper.find('.menu');
					self.obj_overlay = self.obj_wrapper.find('.dashboardView__overlay');
					self.obj_window = self.obj_wrapper.find('.dashboardView');

					self.modal_adapter.init();

					if (params.onhide) self.obj_window.get(0).onhide = params.onhide;

					self.obj_overlay.on('click', (e) => self.on_overlay_click(e));

					if (params.onload) params.onload.call(self.obj_window, self.obj_window[0]);
					if ("ResizeObserver" in window && params.resized || params.resizedObserve) {
						let observer_handler = App.helper.debounce((entries) => {
							for (const entry of entries) {
								let el = entry.target;
								let w = el.clientWidth;
								let h = el.clientHeight;
								if (!el.observed_size || el.observed_size.w !== h || el.observed_size.w !== h) {
									el.observed_size = {w, h};
									params.resized?.call(self.obj_window, self.obj_window[0]);
									params.resizedObserve?.call(self.obj_window, self.obj_window[0]);
								}
							}
						});
						let observer = new ResizeObserver(observer_handler);
						observer.observe(self.obj_window.get(0));
						self.obj_window.data('observer', observer);
					}

					self.animate_show();
					self.init_scroll_zones();
					self.window.opened();
				},
				error: App.core.create_jq_ajax_error(function () {
					self.window.loadFailed();
					if (!self.is_shown()) $('body').removeClass('withDashboardView');
				}),
				complete: function () {
					App.controls.loader.stop();
				}
			});
		},

		hide: function() {
			App.core.async_task.abort('dashboard_view_show');
			if (self.obj_window) self.obj_window.get(0).onhide.call(self.obj_window, self.obj_window[0]);
			$('body').removeClass('withDashboardView');

			self.delete();
		},

		delete: function() {
			self.window.closing();
			self.destroy_scroll_zones();
			self.animate_hide(function() {
				self.window.closed();
				self.shown = false;
				self.remove();
			});
		},

		animate_show: function() {
			if (App.device.is_mobile()) {
				$('body').addClass('mobileDashboardView');
			} else {
				self.obj_wrapper.addClass('dashboardView__wrapper-active');
			}
		},

		animate_hide: function(callback) {
			if (App.device.is_mobile()) {
				$('body').removeClass('mobileDashboardView');
				callback();
			} else {
				self.obj_wrapper.removeClass('dashboardView__wrapper-active');
				setTimeout(function() {
					callback.call(self);
				}, 300);
			}
		},

		on_overlay_click: function(e) {
			if ($(e.target).hasClass('dashboardView__overlay') && !App.helper.selection.is_not_empty() && !App.click_listener.is_moved(e)) {
				self.hide();
			}
		},

		init_scroll_zones: function() {
			self.obj_window.find('.scrollZone').not('.ps').each(function() {
				this.scrollBars = App.controls.js_scrollbars.init(this);
				App.helper.nextTick(() => {
					this.scrollBars.update();
					$(this).trigger('ps-ready');
				});
			});
		},

		destroy_scroll_zones: function() {
			self.obj_window.find('.scrollZone').filter(function() {
				return !$(this).closest('.menu').length;
			}).each(function() {
				if (this.scrollBars) this.scrollBars.destroy();
			});
		},

		detach: function() {
			self.obj_overlay.detach();
			self.obj_window.detach();
			self.obj_menus.detach();
		},

		remove: function() {
			self.obj_overlay.removeWithComponents();
			if (self.obj_window.data('observer')) {
				self.obj_window.data('observer').disconnect();
				self.obj_window.removeData('observer');
			}
			self.obj_window.removeWithComponents();
			self.obj_menus.removeWithComponents();
		},

		modal_adapter: {
			init: function () {
				let h_content = self.obj_window.find("#modal__headerContent");
				if (h_content.length) {
					self.obj_window.find('.dashboardView__header > .in').html('').append(h_content.contents());
					// self.obj_window.find('.dashboardView__header > .in .tree').prependTo(self.obj_window.find('.dashboardView__header'));
					// if (h_content.is('[data-has-tabs]')) self.obj_window.find('.dashboardView__header').addClass('dashboardView__header-withTabs');
					// if (h_content.is('[data-has-bottom-shadow]')) self.obj_window.find('.dashboardView__header').addClass('dashboardView__header-withShadow');
					// if (h_content.is('[data-has-search]')) self.obj_window.find('.dashboardView__header').addClass('dashboardView__header-withSearch');
					// if (h_content.is('[data-center]')) self.obj_window.find('.dashboardView__header').addClass('dashboardView__header-center');
					// if (h_content.is('[data-force-center]')) self.obj_window.find('.dashboardView__header').addClass('dashboardView__header-forceCenter');
					// if (h_content.is('[data-mobile-wrap]')) self.obj_window.find('.dashboardView__header').addClass('dashboardView__header-mobileWrap');
					// if (h_content.is('[data-mobile-center]')) self.obj_window.find('.dashboardView__header').addClass('dashboardView__header-mobileCenter');
					h_content.remove();
				}
			}
		},

		onBoot: function () {
			self.window = App.window.dashboard_view.bind(self);

			if (!$('#dashboardView__wrapper').length) {
				$('#taskView__wrapper').before('<div id="dashboardView__wrapper" class="dashboardView__wrapper"></div>');
			}
		},
		onLogin: function () {
			self.obj_wrapper = $('#dashboardView__wrapper');
		},
		onLogout: function () {
			$('body').removeClass('withDashboardView');
			if (self.is_shown()) {
				self.destroy_scroll_zones();
				self.remove();
			}

			self.shown = false;
			self.window.closed();
			self.obj_wrapper = null;
			self.obj_overlay = null;
			self.obj_window = null;
			self.obj_menus = null;
		}
	}
})();

;var App = App || {};

const MOBILE_SCREEN_THRESHOLD = 1080; // TODO check css/js <=/>
const APP_SCREEN_THRESHOLD = 480;
const PROFILE_THRESHOLD = 900;

App.device = {

	window_width: $(window).width(),

	is_sm_width: function () {
		return App.device.window_width <= APP_SCREEN_THRESHOLD;
	},
	is_lg_width: function () {
		return App.device.window_width > APP_SCREEN_THRESHOLD;
	},

	is_mobile: function () {
		return App.device.is_sm_width() || $('body').hasClass('mobile');
	},

	is_app: function () {
		return !!App.hybrid_app;
	},
	is_ipad: function () {
		return navigator.userAgent.match(/iPad/i) && !navigator.userAgent.match(/Chrome/i);
	},
	is_android: function () {
		return /android/i.test(navigator.userAgent || navigator.vendor || window.opera);
	},
	is_ios: function () {
		return /(iPad|iPhone|iPod)/i.test(navigator.userAgent || navigator.vendor || window.opera) && !window.MSStream;
	},
	is_ios_desktop: function () {
		return /(os x|mac os)/i.test(navigator.userAgent || navigator.vendor || window.opera) && !window.MSStream;
	},
	is_preview_on: function () {
		return !App.device.is_ipad();
	},

	is_ie: function () {
		return $.browser.msie;
	},

	is_retina: function () {
		return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches)) || (window.devicePixelRatio && window.devicePixelRatio >= 2));// && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
	},

	is_touch_screen: function () {
		return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
	},

	onresize: function () {
		App.device.window_width = $(window).width();
	},

	onBoot: function () {
		App.bus.window
				.on('resize', App.helper.throttle(App.device.onresize));
	}
}

;var App = App || {};

(function() {
	let self = App.draft = {
		state_noticed: null,
		state_saved: null,
		timeout_to_save: null,
		xhr: null,
		modal_xhr: null,

		allow_events: true,

		form: null,
		forms_by_type: {},

		bind: function(form, type) {
			if ($(form).attr('data-presave')) {
				self.form = form;
				self.onform_load();
				$(form).once_by_criteria('draft_form_change').bind('change', () => self.onform_update());
				if ($(form).find('.editor').attr('data-draft')) self.save_state();
			} else {
				self.form = null;
			}
			self.forms_by_type[type] = self.form;
		},

		unbind: function() {
			self.form = null;
			if (self.xhr) self.xhr.abort();
		},

		restore_by_type: function (type) {
			self.form = self.forms_by_type[type] || null;
		},

		onform_update: function() {
			let this_state = self.get_state();
			App.comment_form.obj.toggleClass('commentForm-haveAnyData', App.comment_form.check_have_data(self.form));
			if (self.state_saved !== this_state) {
				App.comment_form.obj.addClass('commentForm-inputStarted');
				$('#draft_save').addClass('draft_act');
				if (self.state_noticed !== this_state) {
					if (self.allow_events && App.comment_form.is_shown() && !App.comment_form.obj.hasClass('commentForm-edit')) App.controls.typing.send_event(App.task_view.id);
					self.state_noticed = this_state;
					if (self.timeout_to_save) clearTimeout(self.timeout_to_save);
					self.timeout_to_save = setTimeout(self.save, 5000);
				}
				self.show_draft_exists(true);
			} else {
				self.show_draft_exists(false);
				$('#draft_save').removeClass('draft_act');
				if (self.timeout_to_save) clearTimeout(self.timeout_to_save);
			}
		},

		onform_load: function() {
			let this_state = self.get_state();
			if (this_state !== self.state_saved) {
				$('#draft_save').addClass('draft_act');
				self.show_draft_exists(true);
			} else {
				$('#draft_save').removeClass('draft_act');
				self.show_draft_exists(false);
			}
		},

		pre_delete: function () {
			if (!$(self.form).attr('data-comment')) localStorage.removeItem('draft_com_' + $(self.form).attr('data-task'));
		},

		delete: function (el) {
			self.allow_events = false;
			$(self.form).find('.attachWrapper .fileItem').remove();
			if (!$(self.form).attr('data-comment')) localStorage.removeItem('draft_com_' + $(self.form).attr('data-task'));
			if (el && $(el).hasClass('draft_del_act')) $.ajax({url: $(el).attr('data-action')});
			if ($(self.form).find('.com_reply').is(':visible')) $(self.form).find('.com_reply a.ico_delete').trigger('click');
			App.comment_form.visibility.set([]);

			['descr', 'ids_contact', 'ids_invite', 'skip_notify', 'skip_notify_client', 'is_wait_pub', 'pub_dd', 'pub_dt'].forEach(function(param) {
				if (self.form.elements[param]) self.form.elements[param].value = '';
			});

			App.comment_form.update_invites()
			App.upload.attach.update_counter();

			$('#draft_del').removeClass('draft_del_act');
			$('#draft_del_').hide();
			if (App.editor && App.editor.obj) App.editor.init_from_html('');
			self.save_state();
			$('#draft_load').removeClass('doing');
			$('#draft_save').removeClass('draft_act');
			if (!App.device.is_mobile()) App.comment_form.focus();
			self.allow_events = true;
		},

		save: function (force) {
			if (App.offline_mode.is_on()) return;
			App.editor.save();
			if (App.task_create.is_shown()) {
				App.task_create.force_save();
				return false;
			}
			if (!self.form || !App.editor.body.attr('data-draft') || $(self.form).hasClass('sent')) return;
			let this_state = self.get_state(), act;
			if (this_state !== self.state_saved) {
				if (App.core.skip_request_after_error) {
					App.core.skip_request_after_error--;
				} else {
					$('#draft_load').addClass('doing');
					$('#draft_error').removeClass('doing');
					act = {
						draft: 'comment_save_draft:do',
						main: 'comment_save:do'
					};
					self.form.elements['action'].value = act.draft;
					self.xhr = $.ajax({
						url: $(self.form).attr('action'),
						type: 'POST',
						dataType: 'html',
						data: $(self.form).serialize(),
						timeout: App.env === 'local' ? 60000 : 10000,
						error: App.core.create_jq_ajax_error(function(xhr) {
							$('#draft_load').removeClass('doing');
							if (xhr.textStatus === 'abort') return;
							$('#draft_error').addClass('doing');
							App.core.skip_request_after_error=10;
						}),
						success: function(html){
							if (html === App.config.ajax_html_error) {
								App.core.skip_request_after_error=10;
								$('#draft_load').removeClass('doing');
								$('#draft_error').addClass('doing');
							} else {
								$('#draft_del').addClass('draft_del_act');
								if (App.editor) {
									App.editor.obj.find('.toolbar .draft').addClass('btn_act');
									App.editor.obj.find('.toolbar .sv_status, .editor__toolbar .sv_status').addClass('sv_status_preact');
									setTimeout(function(){
										App.editor.obj.find('.toolbar .sv_status, .editor__toolbar .sv_status').addClass('sv_status_act');
									}, 0);
									setTimeout(function(){
										App.editor.obj.find('.toolbar .sv_status, .editor__toolbar .sv_status').removeClass('sv_status_act sv_status_preact');
									}, 1500);
								}
								$('#draft_del_').hide();
								$('#draft_load').removeClass('doing');
								$('#draft_save').removeClass('draft_act');
								self.show_draft_exists(false);
								self.save_state();
								if ($(self.form).attr('data-task')) localStorage.removeItem('draft_com_' + $(self.form).attr('data-task'));
							}
						}
					});
					self.form.elements['action'].value = act.main;
				}
			} else if (force && App.editor) {
				App.editor.obj.find('.toolbar .sv_status, .editor__toolbar .sv_status').addClass('sv_status_preact');
				setTimeout(function(){
					App.editor.obj.find('.toolbar .sv_status, .editor__toolbar .sv_status').addClass('sv_status_act');
				}, 0);
				setTimeout(function(){
					App.editor.obj.find('.toolbar .sv_status, .editor__toolbar .sv_status').removeClass('sv_status_act sv_status_preact');
				}, 1500);
			}
		},

		get_state: function() {
			return $(self.form).find('input, textarea').not('[name=search]').serialize();
		},

		is_saved: function() {
			return self.state_saved === self.get_state();
		},

		save_state: function() {
			self.state_noticed = self.state_saved = self.get_state();
		},

		common_page_tick_function: function() {
			if (self.state_saved !== self.get_state()) {
				self.show_draft_exists(true);
			} else {
				self.show_draft_exists(false);
			}
		},

		show_draft_exists: function(exists) {
			if (exists) {
				$('#back_title').addClass('alt');
				if (!$('#buttons_floating').hasClass('buttons_floating_alw')) $('#buttons_floating').addClass('buttons_floating_a');
				$('.delete_me .buttons_center').hide();
			} else {
				$('#back_title').removeClass('alt');
				if (!$('#buttons_floating').hasClass('buttons_floating_alw')) $('#buttons_floating').removeClass('buttons_floating_a');
				$('.delete_me .buttons_center').show();
			}
		},
	}
})();

;var App = App || {};

(function () {
	let self = App.easybusy_widget = {

		last_theme: null,

		is_shown: function() {
			return Boolean(
				App.modal.is_shown()
				&& App.modal.obj_window.find('#easybusy_modal').length
			);
		},

		get_url: function() {
			return App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('easybusy:show'));
		},

		init_once: function() {
			if ($('#easybusy_widget').length) return;

			self.last_theme = App.core.theme.dark;

			$('body').append(`
				<div id="easybusy_widget">
					<ws-btn id="easybusy_closeBtn" name="btn btn-g btn-fill" right-icon="close"></ws-btn>
					<div class="mobile-head">
						<div class="mobile-head__left">
							<div class="mobile-head__icon-btn">
								<ws-btn name="btn btn-g btn-36 btn-plain btn-ripple" right-icon="arrows/chevron_lg-left" onclick="App.modal.hide({force: true, by_user: true})" class="close"></ws-btn>
							</div>
						</div>
						<div class="mobile-head__content mobile-head__content">
							<div class="mobile-head__title">
								<span class="in">${App.i18n.t('easybusy.modal_title')}</span>
							</div>
						</div>
						<div class="mobile-head__right"></div>
					</div>
					<iframe src="${self.get_url()}" frameborder="0"></iframe>
				</div>
			`);

			App.ui.onMouse('#easybusy_widget', '#easybusy_closeBtn', {
				click: function() {
					App.modal.hide();
				}
			});
		},

		show: function() {

			self.init_once();

			// Перевіряємо, чи змінилася тема з моменту останнього рендеру iframe
			if (self.last_theme !== App.core.theme.dark) {
				$('#easybusy_widget iframe').attr('src', self.get_url());
				self.last_theme = App.core.theme.dark;
			}

			$('.primaryMenu__item[data-config=easybusy]').addClass('primaryMenu__item-active');

			App.modal.show({
				html: '<div id="easybusy_modal"></div>',
				width: $(window).width() - 144,
				fullpage: true,
				onload: function() {

					const modal = $(this);

					modal.find('.modal__header').hide();
					modal.addClass('loading');
					modal.css({
						height: $(window).height(),
					});

					modal.one('transitionend', function() {
						self.update_size();
					});
				},
				onhide: function() {
					$('#easybusy_widget').hide();
					$('.primaryMenu__item[data-config=easybusy]').removeClass('primaryMenu__item-active');
				}
			});
		},

		update_size: function() {

			const modal = App.modal.obj_window;
			const offset = modal.offset();

			$('#easybusy_widget').css({
				top: offset.top,
				left: offset.left,
				width: modal.width(),
				height: modal.height(),
				borderRadius: modal.css('border-radius'),
				display: 'flex'
			});
		},

		reload: function() {
			$('#easybusy_widget').removeWithComponents();
			self.init_once();
			self.update_size();
		},

		show_menu: function(el) {
			App.classes.ui.menu.show({
				anchor: el,
				type: 'fixed right',
				items: [
					{
						title: App.i18n.t('easybusy.refresh_widget'),
						click: () => {
							$('#easybusy_widget').removeWithComponents();
							self.show();
						},
					}
				]
			});
		},

		onBoot: function() {

			App.bus.window
				.on('resize', App.helper.throttle(() => {
					if (!self.is_shown()) return;
					self.update_size();
				}))
		},
	};
})();
;var App = App || {};

App.effects = {
	applause: function (next) {
		App.modal.applause_onhide = false;

		const hide_applause = function () {
			$('#applause').hide();
			App.modal.hide_overlay();
		};

		$('#applause')
			.off('click.button')
			.on('click.button', 'button', function (e) {
				e.stopPropagation();
				$.ajax({
					url: App.helper.endpoint.primary() + '?' + App.actions.get('process:collapse_applause'),
					success: function () {
						hide_applause();
					}
				});
			})
			.off('click.overlay')
			.on('click.overlay', function (e) {
				if (!$(e.target).closest('button').length) {
					hide_applause();
				}
			});

		$('#applause .applause-btn-text').text(App.locale_general.applause_hide);
		$('#applause').attr('class', '').show();

		App.modal.obj_overlay.addClass('modal__overlay-custom-preApplause');
		setTimeout(() => App.modal.obj_overlay.addClass('modal__overlay-custom-applause'), App.config.applause.tm0);
		setTimeout(() => {
			$('.modal__overlay-custom-applause')
				.off('click.overlay')
				.on('click.overlay', function () {
					hide_applause();
				});
		}, App.config.applause.tm0);

		for (let tmi = 0; tmi < App.config.applause.cnt; tmi++) {
			setTimeout(() => $('#applause i').attr('class', 'appl' + tmi), tmi * App.config.applause.tm2 + 0);
			setTimeout(() => $('#applause').attr('class', 'appl1'),        tmi * App.config.applause.tm1 + 0);
			setTimeout(() => $('#applause').attr('class', 'appl1 appl1a'), tmi * App.config.applause.tm1 + 2 * App.config.applause.tm0);
			setTimeout(() => $('#applause').attr('class', 'appl1 appl1b'), tmi * App.config.applause.tm1 + 4 * App.config.applause.tm0);
			setTimeout(() => $('#applause').attr('class', 'appl2'),        tmi * App.config.applause.tm1 + 6 * App.config.applause.tm0);
			setTimeout(() => $('#applause').attr('class', 'appl2 appl2a'), tmi * App.config.applause.tm1 + 8 * App.config.applause.tm0);
			setTimeout(() => $('#applause').attr('class', 'appl2 appl2b'), tmi * App.config.applause.tm1 + 10 * App.config.applause.tm0);
			setTimeout(() => $('#applause').attr('class', 'appl3'),        tmi * App.config.applause.tm1 + 12 * App.config.applause.tm0);
			setTimeout(() => $('#applause').attr('class', 'appl3 appl3a'), tmi * App.config.applause.tm1 + 14 * App.config.applause.tm0);
			setTimeout(() => $('#applause').attr('class', 'appl3 appl3b'), tmi * App.config.applause.tm1 + 16 * App.config.applause.tm0);
			setTimeout(() => $('#applause').attr('class', ''),             tmi * App.config.applause.tm1 + App.config.applause.tm1);
		}
		setTimeout(() => $('#applause i').attr('class', 'appl4'), (App.config.applause.cnt + 1) * App.config.applause.tm2);
		setTimeout(function () {
			$('#applause').attr('class', 'appl_fin1');
			App.modal.obj_overlay?.addClass('modal__overlay-custom-postApplause');
		}, App.config.applause.cnt * App.config.applause.tm1 + App.config.applause.tm0);
		setTimeout(() => $('#applause').attr('class', 'appl_fin1 appl_fin2'), App.config.applause.cnt * App.config.applause.tm1 + 2 * App.config.applause.tm0);
		setTimeout(function () {
			$('#applause').hide();
			if (next) next();
		}, (App.config.applause.cnt + 1) * App.config.applause.tm1);
	},


	fly_to: function (o, o_to) {
		if (!$('#fly').length) $('<div></div>').appendTo('body').attr('id', 'fly');
		$('#fly').removeClass('fly_animate fly_animate2 fly_animate3').show().css({
			top: o.offset().top,
			left: o.offset().left,
			width: o.outerWidth(),
			height: o.outerHeight()
		});
		if (window.fly_tm) clearTimeout(window.fly_tm);
		setTimeout(function () {
			$('#fly').addClass('fly_animate2').css({
				top: !o_to.length ? 0 : o_to.offset().top - 15 + o_to.outerHeight() / 2,
				left: !o_to.length ? $(window).width() : o_to.offset().left - 15 + o_to.outerWidth() / 2,
				width: 30,
				height: 30
			});
		}, 10);
		window.fly_tm = setTimeout(function () {
			$('#fly').addClass('fly_animate3');
		}, 1000);
		window.fly_tm = setTimeout(function () {
			$('#fly').removeClass('fly_animate2 fly_animate3').hide();
		}, 2500);
	},

	fly_to_mass: function (o) {
		if (!$('#massdo').length) return;
		if (!$('#fly').length) $('<div></div>').appendTo('body').attr('id', 'fly');
		const rect = o[0].getBoundingClientRect();
		$('#fly').removeClass('fly_animate fly_animate2 fly_animate3').css({
			top: rect.top + window.scrollY,
			left: rect.left + window.scrollX,
			width: Math.min(rect.width, window.innerWidth - rect.left),
			height: rect.height
		}).show();
		if (window.fly_tm) clearTimeout(window.fly_tm);
		$('#massdo i').addClass('i_big');
		setTimeout(function () {
			let offset_to = $('#mass_n_filt, .commentListPanel').offset();
			$('#fly').addClass('fly_animate').css({
				top: offset_to.top,
				left: offset_to.left + 20,
				width: 48,
				height: 48
			});
			window.fly_tm = setTimeout(function () {
				$('#fly').removeClass('fly_animate').hide();
				$('#massdo i').removeClass('i_big');
			}, 300);
		}, 10);
	},

	highlight_dots: function () {
		const el = $('#filterButton__more').length ? $('#filterButton__more button') : $('.primaryMenu__foot');
		el.addClass('focus-visible').animate_css('blink').then(() => {
			setTimeout(function () {
				el.removeClass('focus-visible');
			}, 300);
		});
	},

	fly_to_dots: function (o) {
		if (!$('#fly').length) $('<div></div>').appendTo('body').attr('id', 'fly');
		$('#fly').removeClass('fly_animate fly_animate2 fly_animate3').show().css({
			top: o.offset().top,
			left: o.offset().left,
			width: o.outerWidth(),
			height: o.outerHeight()
		});
		if (window.fly_tm) clearTimeout(window.fly_tm);
		$('#massdo i').addClass('i_big');
		setTimeout(function () {
			if ($('#filterButton__more').length) {
				$('#fly').addClass('fly_animate2').css({
					top: $('#filterButton__more').offset().top - 5,
					left: $('#filterButton__more').offset().left - 5,
					width: 30,
					height: 30
				});
			} else {
				$('#fly').addClass('fly_animate2').css({
					top: $('.primaryMenu__foot').offset().top - 3,
					left: $('.primaryMenu__foot').offset().left - 3,
					width: 30,
					height: 30
				});
			}
		}, 10);
		window.fly_tm = setTimeout(function () {
			$('#fly').addClass('fly_animate3');
		}, 1000);
		window.fly_tm = setTimeout(function () {
			$('#fly').removeClass('fly_animate2 fly_animate3').hide();
		}, 2500);
	},

	animate_checkbox: function(el, status) {
		if (status) {
			$(el).addClass('ani_on');
			setTimeout(function(el) { $(el).removeClass('ani_on'); }, 1500, el);
		}
		else {
			$(el).addClass('ani_off');
			setTimeout(function(el) { $(el).removeClass('ani_off'); }, 1500, el);
		}
	},
}

;App.core.favicon = (() => {
	let originalHref = null;

	function ensureLink() {
		let link = document.querySelector('link[rel="icon"]');
		if (!link) {
			link = document.createElement('link');
			link.rel = 'icon';
			link.href = '/assets/img/favicon/favicon.ico';
			document.head.appendChild(link);
		}
		return link;
	}

	function loadImage(src) {
		return new Promise((resolve, reject) => {
			const img = new Image();
			img.crossOrigin = 'anonymous';
			img.onload = () => resolve(img);
			img.onerror = reject;
			img.src = src;
		});
	}

	async function set(count, opts = {}) {
		const link = ensureLink();
		if (!link) return;

		if (originalHref === null) originalHref = link.href || '/assets/img/favicon/favicon.ico';
		if (count <= 0) return clear();

    const {
      size = 64,               // робоче полотно
      cap = 999,               // 999+
      pillColor = '#E53935',   // червона пігулка
      textColor = '#FFFFFF',
      borderColor = '#FFFFFF', // біла обводка
      shadow = true,
      fontFamily = 'system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif',
      // відступ від правого/верхнього краю
    } = opts;

    const base = await loadImage(originalHref);

    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = size;
    const ctx = canvas.getContext('2d');

    // База
    ctx.clearRect(0, 0, size, size);
    ctx.drawImage(base, 0, 0, size, size);

    // Текст бейджа
    const label = count > cap ? `${cap}+` : String(count);
    // Розміри пігулки — агресивні, щоб було видно на 16×16
    const padX = Math.round(size * 0.10); // внутрішній горизонтальний відступ
    const padY = Math.round(size * 0.04);
    const pillH = Math.round(size * 0.48); // ~половина висоти favicon
    const radius = Math.round(pillH / 2);

    // Шрифт: товстий, великий
    // Підігнати під довжину: 1–2–3+ символи
    const fontPx = label.length === 1 ? Math.round(pillH * 0.75)
                  : label.length === 2 ? Math.round(pillH * 0.68)
                  : Math.round(pillH * 0.60);
    ctx.font = `800 ${fontPx}px ${fontFamily}`;
    ctx.textBaseline = 'middle';

    // Обчислити ширину тексту
    const metrics = ctx.measureText(label);
    const textW = Math.ceil(metrics.width);
    const pillW = Math.max(pillH, textW + padX * 2);

    // Позиція (праворуч-угорі, з невеликим відступом від країв)
    const margin = Math.round(size * 0.06);
    const xRight = size - margin;
    const yTop = margin;

    const x = xRight - pillW;     // лівий край пігулки
    const y = yTop;               // верхній край

    // Тінь для контрасту на світлих іконках
    if (shadow) {
      ctx.save();
      ctx.shadowColor = 'rgba(0,0,0,0.35)';
      ctx.shadowBlur = Math.round(size * 0.06);
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = Math.round(size * 0.02);
      roundedRect(ctx, x, y, pillW, pillH, radius);
      ctx.fillStyle = pillColor;
      ctx.fill();
      ctx.restore();
    } else {
      roundedRect(ctx, x, y, pillW, pillH, radius);
      ctx.fillStyle = pillColor;
      ctx.fill();
    }

    // Біла обводка (товста)
    ctx.lineWidth = Math.max(2, Math.round(size * 0.06));
    ctx.strokeStyle = borderColor;
    roundedRect(ctx, x, y, pillW, pillH, radius);
    ctx.stroke();

    // Текст
    ctx.fillStyle = textColor;
    ctx.textAlign = 'center';
    const cx = x + pillW / 2;
    const cy = y + pillH / 2 + Math.round(size * 0.01); // легкий оптичний зсув
    ctx.fillText(label, cx, cy);

		link.href = canvas.toDataURL('image/png');
	}

	function clear() {
		const link = document.querySelector('link[rel="icon"]');
		if (link && originalHref) {
			link.href = originalHref;
		}
	}

	// Утиліта: скруглений прямокутник
	function roundedRect(ctx, x, y, w, h, r) {
		const rr = Math.min(r, h / 2, w / 2);
		ctx.beginPath();
		ctx.moveTo(x + rr, y);
		ctx.lineTo(x + w - rr, y);
		ctx.quadraticCurveTo(x + w, y, x + w, y + rr);
		ctx.lineTo(x + w, y + h - rr);
		ctx.quadraticCurveTo(x + w, y + h, x + w - rr, y + h);
		ctx.lineTo(x + rr, y + h);
		ctx.quadraticCurveTo(x, y + h, x, y + h - rr);
		ctx.lineTo(x, y + rr);
		ctx.quadraticCurveTo(x, y, x + rr, y);
		ctx.closePath();
	}

	return { set, clear };
})();

/**
 * App.core.favicon.set(12, { badgeColor: '#ff3b30', textColor: '#fff', size: 96 });
 */

;var App = App || {};

App.favs = {

	init: function () {
		$('body').on('click', '.bookmark:not(.bookmark-noClick)', function () {
			$(this).addClass('clicked');
			let is_on = !$(this).hasClass('bookmark-active') ? 1 : 0;
			if ($(this).attr('data-project')) {
				$.ajax({url: App.helper.url.add_query(App.helper.endpoint.ajax($(this).attr('data-project')), App.actions.get('project_bookmark:do') + '&is_on=' + is_on)});
				return false;
			} else if ($(this).attr('data-task')) {
				$.ajax({url: App.helper.url.add_query(App.helper.endpoint.task($(this).attr('data-task')), App.actions.get('task_bookmark:do') + '&is_on=' + is_on)});
				return false;
			} else if ($(this).attr('data-user')) {
				$.ajax({url: App.helper.url.add_query(App.helper.endpoint.user($(this).attr('data-user')), App.actions.get('user_favorite:do') + '&is_on=' + is_on)});
				$(this).toggleClass('bookmark-active', is_on);
				return false;
			}
		}).on('mouseout', '.bookmark', function () {
			$(this).removeClass('clicked');
		});
	},

	onBoot: function () {
		App.bus.state.on('user_bookmark', function (payload, context) {
			let data_obj = payload.data;
			if (!data_obj) return;
			$(`.bookmark[data-user="${payload.id}"]`).toggleClass('bookmark-active', Boolean(data_obj.on));
		});
		this.init();
	}
};

;var App = App || {};

(function() {
	let self = App.file_create = {
		shown: false,
		id: 0,
		id_tmp: 0,
		title: '',
		locale: {},

		obj_wrapper: null,
		obj_window: null,
		obj_menus: null,
		window: null,

		state_saved: null,
		state_noticed: null,

		is_shown: function () {
			return self.shown;
		},

		new: function(params, callback) {
			params ||= '';
			if (App.task_view.is_shown()) App.task_view.minimize();
			while (App.menu.is_shown()) App.menu.hide();
			self.show(0, 0, params, callback);
		},

		show: function(id, id_tmp, params, callback) {
			if (!App.windows.before_open(self.window, {id, id_tmp, params})) return;

			if (id != null) id = Number(id);
			if (self.is_shown() && self.id === id && params?.reload !== true) {
				self.window.alreadyOpened();
				return false;
			}

			if (self.is_shown()) {
				self.task_panel_update();
			}

			params = params || {};
			self.id = id || 0;
			self.id_tmp = id_tmp || App.helper.time.now();

			self.window.opening();
			let cache_data = App.file_create_cache.pop(id);
			if (cache_data) {
				if (self.is_shown()) {
					self.detach();
				}
				self.shown = true;
				self.obj_wrapper.html('').append(cache_data.obj_window).append(cache_data.obj_menus);
				self.animate_show();
				self.obj_window = self.obj_wrapper.find('.fileCreate');
				self.title = cache_data.title;
				self.state_saved = self.state_noticed = self.get_state();
				self.window.opened();
			} else {
				self.window.loading();
				$.ajax({
					url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('file_draft:show') + (self.id ? '&id=' + self.id : (params.indexOf('id_project') !== -1 ? '' : '&id_project=' + App.current_page.project) + (params ? '&' + params : ''))),
					success: function (html) {
						if (self.is_shown()) {
							self.detach();
						}
						self.shown = true;
						self.obj_wrapper.html(html);
						self.animate_show();
						self.obj_menus = self.obj_wrapper.find('.menu').not('.menu-level2').appendTo('#fileCreate__wrapper');
						self.obj_window = self.obj_wrapper.find('.fileCreate');
						self.obj_window.attr('data-id', ); // for Queue
						self.state_saved = self.state_noticed = self.get_state();
						self.init();
						App.file_create_cache.push(self.id || self.id_tmp, self);
						self.window.opened();
						if (callback) callback.call(self.obj_window);
					},
					error: App.core.create_jq_ajax_error(function () {
						self.window.loadFailed();
					})
				});
			}
		},

		init_scroll_zones: function() {
			self.obj_window.find('.scrollZone').not('.ps').each(function() {
				this.scrollBars = App.controls.js_scrollbars.init(this);
			});
		},

		destroy_scroll_zones: function() {
			self.obj_window.find('.scrollZone').filter(function() {
				return !$(this).closest('.menu').length;
			}).each(function() {
				if (this.scrollBars) this.scrollBars.destroy();
			});
		},

		reload: function(options) {
			self.show(self.id, null, { reload: true });
		},

		fullscreen: function() {
			self.obj_wrapper.toggleClass('fileCreate__wrapper-fullscreen');
		},

		hide: function() {
			if (self.id || self.state_noticed !== self.state_saved) {
				App.controls.confirm.menu(self.obj_window.find('.fileCreate__head .close'), {
					message: App.object_state.locale['draft_will_delete'],
					ok_label: App.object_state.locale['yes_delete'],
					cancel_label: App.object_state.locale['no_cancel'],
					onconfirm: function () {
						self.delete();
					}
				});
			} else {
				self.delete();
			}
		},

		delete: function(options) {
			options = {
				need_delete: true,
				...options
			};
			self.window.closing();
			if (self.id && options.need_delete) {
				let queue_id = 'file_create' + self.id_tmp;
				App.core.call_queue.add(queue_id, self.request_delete, self, {
					id: self.id,
				});
			}
			App.file_create_cache.delete(self.id || self.id_tmp);
			self.animate_hide(function() {
				const is_shown = self.shown;
				self.shown = false;
				self.window.closed();
				self.id = self.id_tmp = 0;
				if (is_shown) self.remove();
			});
		},

		remove_from_task_panel: function(el) {
			const id = $(el).attr('data-file-draft');
			if (self.is_shown() && self.id == id) {
				self.hide(el);
				return;
			}

			if (!id) {
				App.task_panel.item.remove_by_item($(el));
				return;
			}

			App.controls.confirm.menu(el, {
				message: App.object_state.locale['draft_will_delete'],
				ok_label: App.object_state.locale['yes_delete'],
				cancel_label: App.object_state.locale['no_cancel'],
				onconfirm: function () {
					const queue_id = 'file_create' + id;
					App.core.call_queue.add(queue_id, self.request_delete, self, { id });
					App.file_create_cache.delete(id);
					App.task_panel.item.remove_by_item($(el));
				}
			});
		},

		animate_show: function() {
			if (App.device.is_mobile()) {
				$('body').addClass('mobilefileCreate');
			} else {
				self.obj_wrapper.addClass('fileCreate__wrapper-active');
			}
		},

		animate_hide: function(callback) {
			if (App.device.is_mobile()) {
				$('body').removeClass('mobilefileCreate');
				callback();
			} else {
				self.obj_wrapper.removeClass('fileCreate__wrapper-active');
				setTimeout(function() {
					callback.call(self);
				}, 300);
			}
		},

		minimize: function() {
			if (self.id === 0 && self.state_noticed === self.state_saved) return self.hide();

			self.window.minimizing();
			self.task_panel_update();
			self.animate_hide(function() {
				self.window.closed();
				self.shown = false;
				self.id = self.id_tmp = 0;
				self.detach();
			});
		},

		task_panel_update: function() {
			let name = self.obj_window.get(0).elements.name.value.trim()
				|| self.obj_window.find('.fileCreate__head .in').html()
				|| App.object_state.locale.task_panel.file_create_default_title;
			const { panel_item: task_panel_item } = App.task_panel.item.find(self);

			const update = (id, name, task_panel_item) => {
				if (task_panel_item.length) {
					App.task_panel.item.update_by_item(task_panel_item, (item) => {
						item.children('.flex_content').html(name);
					});
				} else {
					App.task_panel.append({
						type: 'file_draft',
						id: id,
						name: name
					});
				}
			};

			if (self.id) {
				update(self.id, name, task_panel_item);
				return;
			}

			let queue_id = 'file_create' + self.id_tmp;
			let this_state = self.get_state();
			App.core.call_queue.delete(queue_id);
			self.request_save({
				id: self.id,
				id_tmp: self.id_tmp,
				data: this_state,
			}, (res) => {
				update(res.id, name, task_panel_item);
			});
		},

		detach: function() {
			self.obj_window.detach();
			self.obj_menus.detach();
		},

		remove: function() {
			self.destroy_scroll_zones();
			self.obj_window.removeWithComponents();
			self.obj_menus.removeWithComponents();
		},

		form_validate: function() { // this = <form>
			let valid = true;

			if (!self.components.project.get_ids().length || !$(this).find('.fileItem').length) {
				valid = false;
			}

			self.components.project.validate();

			$(this).find('.mobile-head__btn .btn-primary, .fileCreate__buttons .btn-primary, .fileCreate__buttons .btn-delay').toggleDisabled(!valid);
			return valid;
		},

		request_publish: function (params, onsuccess, onerror) {
			let btn = self.obj_window.find('.mobile-head__btn .btn-primary, .fileCreate__buttons .btn-primary, .fileCreate__buttons .btn-delay');
			btn.toggleDisabled(true);
			$.ajax({
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('file_draft:publish') + '&id=' + params.id + '&next_action=' + params.next_action),
				type: 'POST',
				dataType: 'script',
				data: params.data,
				timeout: App.env === 'local' ? 60000 : 10000,
				error: App.core.create_jq_ajax_error(function () {
					btn.toggleDisabled(false);
					if (onerror) onerror();
				}),
				success: function () {
					self.delete({ need_delete: false }); // фактично бек вже видалив
					if (onsuccess) onsuccess();
				}
			});
		},

		request_delete: function (params, onsuccess, onerror) {
			$.ajax({
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('file_draft:delete') + '&id=' + params.id),
				dataType: 'json',
				timeout: App.env === 'local' ? 60000 : 10000,
				error: App.core.create_jq_ajax_error(onerror),
				success: function (json) {
					if (json.status !== 'ok') {
						if (onerror) onerror();
					} else {
						if (onsuccess) onsuccess();
					}
				}
			});
		},

		request_save: function (params, onsuccess, onerror) {
			$.ajax({
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('file_draft:save') + '&id=' + params.id),
				type: 'POST',
				dataType: 'json',
				data: params.data,
				timeout: App.env === 'local' ? 60000 : 10000,
				error: App.core.create_jq_ajax_error(onerror),
				success: function (json) {
					if (json.status !== 'ok') {
						if (onerror) onerror();
					} else {
						if (!self.id_tmp) return false; // already deleted
						if (!params.id) App.file_create_cache.replace(params.id_tmp, json.id);
						if (self.id_tmp === params.id_tmp) {
							self.id = json.id;
							self.state_saved = params.data;
						}
						if (onsuccess) onsuccess({
							id_tmp: params.id_tmp,
							id: json.id
						});
					}
				}
			});
		},

		get_state: function() {
			return self.obj_window.serialize();
		},

		is_saved: function() {
			return self.state_saved === self.get_state();
		},

		onform_update: function() {
			self.form_validate.call(self.obj_window.get(0));
			let queue_id = 'file_create' + self.id_tmp;
			let this_state = self.get_state();
			if (self.state_saved !== this_state) {
				if (self.state_noticed !== this_state) {
					self.state_noticed = this_state;
					App.core.call_queue.add(queue_id, self.request_save, this, {
						id: self.id,
						id_tmp: self.id_tmp,
						data: this_state,
					}, 5);
				}
			} else {
				App.core.call_queue.delete(queue_id);
			}
		},

		onform_submit: function(next_action) {
			let is_valid = self.form_validate.call(self.obj_window.get(0));
			if (!is_valid) return;

			let queue_id = 'file_create' + self.id_tmp;
			let this_state = self.get_state();
			App.core.call_queue.add(queue_id, self.request_publish, this, {
				id: self.id,
				id_tmp: self.id_tmp,
				next_action: next_action,
				data: this_state,
			}, 0);
		},

		init: function() {
			self.obj_window.bind('change update', () => self.onform_update());
			self.obj_window.find('.mobile-head__btn .btn-primary, .fileCreate__buttons .btn-primary').bind('click', () => self.onform_submit());
			self.obj_window.find('.fileCreate__buttons .btn-delay').bind('click', function() {
				App.menu.show({anchor: this, box: '#fileCreate_send_menu', type: 'bottom',});
			});
			self.obj_window.find('.fileCreate__content__title textarea').bind('input paste', function() {
				this.value = this.value.replace(/[\n\r]+/ig, ' ');
				$(this).height(0);
				$(this).height(this.scrollHeight);
				$(this).parents('form').trigger('change');
			}).bind('keydown', function(e) {
				let key = e.keyCode ? e.keyCode : e.charCode;

				if (e.shiftKey && (e.ctrlKey || e.metaKey) && key === App.keycode.Enter) return self.onform_submit('new');

				if (key === App.keycode.Enter) return false;
			});
			App.editor.init(self.obj_window);
			App.upload.init(self.obj_window.find('.drop_zone_body'));

			let title_text = self.obj_window.find('.fileCreate__content__title textarea');
			title_text.height(title_text.get(0).scrollHeight);

			self.components.init();
			self.init_scroll_zones();
		},

		components: {
			init: function() {
				for (let i in self.components) {
					if ('init' in self.components[i]) self.components[i].init();
				}
			},

			project: {
				init: function() {
					self.obj_window.find('[data-container=project]').on('click', function (e, data) {
						data ||= {};
						if ($(e.target).parents().addBack().filter('.delete').length) {
							self.components.project.callback_delete();
						} else {
							let ids = $(this).find('input').length ? $(this).find('input').val().split(',').map(Number) : [];
							App.controls.project_select_and_go.show_context(this, null, {
								request: {multiple_enabled: 0},
								onload: function () {
									$(this).on('click', '.menu__item', function() {
										self.components.project.callback.call(this);
										App.menu.hide();
									});
								},
								onshow: function() {
									$(this).find('.menu__item').each(function() {
										$(this).toggleClass('menu__item-active', ids.includes($(this).attr('data-id').toInt()));
									});
								}
							});
						}
					});
					this.validate();
				},
				validate: function () {
					self.obj_window.find('[data-container=project] ws-chip').attr('name', this.get_ids().length ? 'chip chip-outline' : 'chip chip-alert');
				},
				callback: function () { // this = menu__item
					let id = $(this).attr('data-id');
					self.obj_window.find('[data-container=project]').html(App.helper.template.fill('file_create_project', {
						name: $(this).find('.in').text(),
						id,
						icon: $(this).find('span:first-child').html(),
					}));
					self.obj_window.find('[data-container=parent]').show().html(App.helper.template.fill('file_create_parent_empty'));
					self.obj_window.attr('action', App.helper.endpoint.project(id)).trigger('change');
					self.obj_window.attr('ajax-action', App.helper.endpoint.ajax(id)).trigger('change');
					$('#fileCreateFileMenu .recent_files').attr('data-modal-url', App.helper.url.add_query(App.helper.endpoint.project(id), $('#fileCreateFileMenu .recent_files').attr('data-action')))
					App.controls.user_select_and_go.team(self.helper_user_endpoint('team'), self.components.team.callback);
					return false;
				},
				callback_multiple: function () { // this = menu
					let o = $(this).find('.menu__item-active');
					if (o.length === 0) { // none selected fallback
						self.components.project.callback_delete();
						return false;
					}
					if (o.length === 1) { // single selected fallback
						self.components.project.callback.call(o.get(0));
						return false;
					}
					let ids = [];
					o.each(function() {
						ids.push($(this).attr('data-id'));
					});
					self.obj_window.find('[data-container=project]').html(App.helper.template.fill('file_create_project_multiple', {
						name: App.format.quantity(ids.length, App.object_state.locale['projects'], QTY_WITH_TEXT),
						ids: ids.join(','),
					}));
					self.obj_window.find('[data-container=parent]').hide().html(App.helper.template.fill('file_create_parent_empty'));
					self.obj_window.find('[data-container=user]').html(App.helper.template.fill('file_create_assignee_empty'));
					self.obj_window.attr('action', self.obj_window.attr('data-def-action')).trigger('change');
					self.obj_window.attr('ajax-action', self.obj_window.attr('data-def-ajax-action')).trigger('change');
					return false;
				},
				callback_delete: function() {
					self.obj_window.find('[data-container=project]').html(App.helper.template.fill('file_create_project_empty'));
					self.obj_window.find('[data-container=parent]').hide().html(App.helper.template.fill('file_create_parent_empty'));
					self.obj_window.attr('action', self.obj_window.attr('data-def-action')).trigger('change');
					self.obj_window.attr('ajax-action', self.obj_window.attr('data-def-ajax-action')).trigger('change');
				},

				get_ids: function() {
					return self.obj_window.find('[data-container=project]').find('input').length ? self.obj_window.find('[data-container=project]').find('input').val().split(',').map(Number) : [];
				}
			},

			team: {
				callback: function(ids) {
					let id_user_to = self.obj_window.get(0).elements.id_user_to?.value.toInt() || 0;
					if (id_user_to>= App.config.real_user_id && !ids.includes(id_user_to)) self.obj_window.find('[data-container=user]').html(App.helper.template.fill('file_create_assignee_empty'));
					let ids_subscribe = self.obj_window.find('input[name=ids_subscribe]').val().toIntArray();
					self.obj_window.find('[data-container=subscribers]').find('.fileCreate__subscribers__item').each(function() {
						if (!ids.includes($(this).attr('data-id').toInt())) $(this).remove();
					}).end().trigger('draw_more');
					ids_subscribe = ids_subscribe.filter((id) => ids.includes(id));
					self.obj_window.find('input[name=ids_subscribe]').val(ids_subscribe.join(','));
				},
			},

			labels: {
				init: function() {
					self.obj_window.find('[data-container=labels]').on('click', function(e, data) {
						data ||= {}
						if ($(e.target).parents().addBack().filter('.delete').length) {
							self.components.labels.callback_delete();
						} else {
							App.controls.project_task_labels_and_go.show_context(data.anchor || this, App.helper.url.add_query(self.obj_window.attr('ajax-action'), App.actions.get('project_task_labels_and_go:show')), {
								onload: function() {
								},
								onshow: function() {
									let menu = $(this);
									menu.off('after_interaction.unique').on('after_interaction.unique', function() {
										self.components.labels.callback.call(menu);
									});
									$(this).find('.editBlock__picker__item').remove();
									let ids = self.obj_window.find('[data-container=labels]').find('input').length ? self.obj_window.find('[data-container=labels]').find('input').val().split(',').map(Number) : []
									$(this).find('.menu__item[data-id]').removeClass('menu__item-picked').filter(function() {
										return ids.includes($(this).attr('data-id').toInt());
									}).trigger('preset');
								},
							});
						}
					});
					$('#fileCreate__menu__more .menu__item[data-more=labels]').on('click', function() {
						App.menu.hide();
						self.obj_window.find('[data-container=labels]').trigger('click', [{anchor: self.obj_window.find('[data-container=more]').get(0)}]);
					});
				},
				callback: function() { // this = menu
					let o = $(this).closest('.menu').find('.menu__item-picked');
					if (o.length === 0) { // none selected fallback
						self.components.labels.callback_delete();
						return false;
					}
					let ids = [], tags = [];
					o.each(function() {
						let id_tag = $(this).attr('data-id');
						ids.push(id_tag);
						tags.push({
							name: App.tags[id_tag].name,
							color: App.tags[id_tag].color,
						});
					});
					self.obj_window.find('[data-container=labels]').html(App.helper.template.fill('file_create_labels', {
						name: App.format.quantity(ids.length, App.object_state.locale['labels'], QTY_WITH_TEXT),
						ids: ids.join(','),
						tags
					}));
					self.obj_window.trigger('change');
					return false;
				},
				callback_delete: function() {
					self.obj_window.find('[data-container=labels]').html(App.helper.template.fill('file_create_labels_empty'));
				},
			},

			subscribers: {
				init: function() {
					self.obj_window.find('[data-container=subscribers]').on('click', function(e) {
						let ids_project = self.components.project.get_ids();
						let ids = self.obj_window.find('input[name=ids_subscribe]').val().toIntArray();
						let request = {type: 'recipients'}
						if (ids_project.length > 1) request.ids_project = ids_project.join(',');
						let hidden = self.obj_window.find('input[name=hidden]').val().toIntArray();
						if (hidden.length) request.hidden = hidden.join(',');
						App.controls.user_select_and_go.show_context(this, self.helper_user_endpoint(), {
							request,
							type: 'left',
							last_value_target: self.obj_window.find('[data-container=subscribers]'),
							onload: function () {
								let menu = $(this);
								App.controls.menu.init(menu);
								menu.on('click', '.menu__group-head ws-btn', () => {
									self.components.subscribers.callback.call(menu);
									App.menu.hide();
								});
							},
							onshow: function() {
								$(this).find('.menu__item[data-id]').each(function() {
									$(this).toggleClass('menu__item-active', ids.includes($(this).attr('data-id').toInt()));
								});
								$(this).trigger('after_interaction');
							}
						});
					}).bind('draw_more', function() {
						$(this).find('.more, .button_more').remove();
						let cnt = $(this).find('.fileCreate__subscribers__item').length;
						if (cnt > 6) $(this).find('.in').append('<span class="more">+' + (cnt - 5) + '</span>');
						else $(this).find('.in').append('<span class="more">+</span>');
					});
				},
				callback: function () { // this = menu
					let o = $(this).find('.menu__item-active');
					let ids = [], html = [];
					o.each(function() {
						ids.push($(this).attr('data-id'));
						html.push(App.helper.template.fill('file_create_subscriber', {
							name: $(this).find('.in').text(),
							avatar: $(this).find('.av_sm').get(0).outerHTML,
							id: $(this).attr('data-id'),
						}));
					});
					self.obj_window.find('[data-container=subscribers]').find('.in').html(html.join('')).end().trigger('draw_more');
					self.obj_window.find('input[name=ids_subscribe]').val(ids.join(','));
					self.obj_window.trigger('change');
					return false;
				},
			},

			visibility: {
				init: function() {
					self.obj_window.find('ws-btn.hidden, ws-btn.hidden_remove').on('click', function(e, data) {
						if (!self.obj_window.find('input[name=hidden]').val() && !self.obj_window.find('input[name=guests]').val()) {
							App.menu.show({
								anchor: this,
								box: '#fileCreate__menu__visibility_preset'
							});
						} else {
							let ids_project = self.components.project.get_ids();
							let request = {type: 'visibility'};
							if (ids_project.length > 1) request.ids_project = ids_project.join(',');
							App.controls.visibility_switch_and_go.show_context(this, self.helper_user_endpoint(), {
								request,
								onload: function () {
									let menu = $(this);
									menu.on('click', '.menu__group-head ws-btn', () => self.components.visibility.callback.call(menu));
									menu.on('click', '.menu__group-buttons ws-btn',function() {
										App.menu.hide();
										self.components.visibility.callback_delete();
									});
								},
								onshow: function () {
									let hidden = self.obj_window.find('input[name=hidden]').val().toIntArray();
									let guests = [];//self.obj_window.find('input[name=guests]').val().toIntArray();
									let hidden_defaults = [App.me.id, self.obj_window.get(0).elements.id_user_to?.value.toInt() || 0];
									$(this).find('.menu__group[data-group]').each(function () {
										let id_group = $(this).attr('data-group').toInt();
										$(this).find('.menu__item[data-id]').each(function () {
											let id_user = $(this).attr('data-id').toInt();
											let is_active;
											if (hidden.length) {
												is_active = hidden_defaults.includes(id_user) || hidden.includes(id_user) || (hidden.includes(-id_group) && (!$(this).hasClass('menu__item-guest') || guests.includes(id_user)))
											} else {
												is_active = !$(this).hasClass('menu__item-guest') || guests.includes(id_user) || hidden_defaults.includes(id_user)
											}
											$(this).toggleClass('menu__item-active', is_active).toggleClass('menu__item-default', hidden_defaults.includes(id_user));
										});
									});
								}
							});
						}
					});
				},
				preset: function(type) {
					App.menu.hide();
					if (type === 'custom') {
						const id_subscribe = self.obj_window.find('input[name=ids_subscribe]').val();
						let ids_subscribe = id_subscribe.length ? id_subscribe.split(',').map(Number) : [];
						if (!ids_subscribe.includes(App.me.id)) {
							ids_subscribe.push(App.me.id);
						}
						self.obj_window.find('input[name=hidden]').val(ids_subscribe.join(','));
						self.obj_window.find('ws-btn.hidden').click();
						return;
					}

					let hidden = [];
					let id_user_to = self.obj_window.get(0).elements.id_user_to?.value.toInt() || 0;
					switch (type) {
						case 'department':
							App.controls.user_select_and_go.team(self.helper_user_endpoint('team') + '&preset=department', function(ids) {
								hidden = ids;
								if (id_user_to>= App.config.real_user_id && !ids.includes(id_user_to)) {
									hidden.push(id_user_to);
									ids.push(id_user_to);
								}
								self.components.team.callback(ids);
								self.components.visibility.set(hidden, []);
							});
							break;
						case 'team':
							hidden.push(-App.me.id_group);
							App.controls.user_select_and_go.team(self.helper_user_endpoint('team') + '&preset=team', function(ids) {
								if (id_user_to>= App.config.real_user_id && !ids.includes(id_user_to)) {
									hidden.push(id_user_to);
									ids.push(id_user_to);
								}
								self.components.team.callback(ids);
								self.components.visibility.set(hidden, []);
							});
							break;
						case 'me':
						default:
							hidden.push(App.me.id);
							if (id_user_to>= App.config.real_user_id && id_user_to !== App.me.id) hidden.push(id_user_to);
							self.components.team.callback(hidden);
							self.components.visibility.set(hidden, []);
					}
				},
				callback: function() { // this = menu
					let hidden = [];
					let guests = [];
					if ($(this).find('.menu__item[data-id]').not('.menu__item-guest').not('.menu__item-active').length) {
						$(this).find('.menu__group[data-group]').each(function () {
							let id_group = $(this).attr('data-group').toInt();
							if (!$(this).find('.menu__item[data-id]').not('.menu__item-guest').not('.menu__item-active').length) {
								hidden.push(-id_group);
								$(this).find('.menu__item-guest[data-id].menu__item-active').each(function () {
									hidden.push($(this).attr('data-id').toInt());
								});
							} else {
								$(this).find('.menu__item-active[data-id]').each(function () {
									hidden.push($(this).attr('data-id').toInt());
								})
							}
						});
					}
					$(this).find('.menu__item-guest.menu__item-active').each(function() {
						guests.push($(this).attr('data-id').toInt());
					});

					self.components.visibility.set(hidden, guests);
					App.menu.hide();
				},
				callback_delete: function() {
					self.components.visibility.set([], []);
				},
				set: function(hidden, guests) {
					self.obj_window.find('input[name=hidden]').val(hidden.join(','));
					//self.obj_window.find('input[name=guests]').val(guests.join(','));
					if (hidden.length) self.obj_window.find('ws-btn.hidden').hide().next().show();
					else self.obj_window.find('ws-btn.hidden').show().next().hide();
					self.obj_window.find('input[name=is_hidden]').val(hidden.length ? 1 : 0);
					self.obj_window.trigger('change');
				}
			},
		},

		helper_user_endpoint: function(type) {
			type ||= 'show';
			if (self.obj_window.find('[data-container=parent]').find('input').length) { // no parent
				return App.helper.url.add_query(self.obj_window.find('[data-container=parent]').find('input').attr('data-url'), App.actions.get('task_user_select_and_go:' + type));
			} else {
				return App.helper.url.add_query(self.obj_window.attr('action'), App.actions.get('user_select_and_go:' + type));
			}
		},

		onload: function() {
			self.obj_wrapper = $('#fileCreate__wrapper');
		},

		destructor: function() {

			self.obj_window?.removeWithComponents()

			self.shown = false;
			self.window.closed();
			self.id = 0;
			self.id_tmp = 0;
			self.title = '';
			self.locale = {};
			self.obj_window = null;
			self.obj_menus = null;
			self.state_saved = null;
			self.state_noticed = null;
		},

		onBoot: function () {
			self.window = App.window.file_create.bind(self);
			self.onload();
		},
		onLogout: () => self.destructor(),
	}
})();

App.file_create_cache = {

	data: {},

	exists: function(id) {
		return id in this.data
	},

	pop: function(id) {
		if (id in this.data) return this.data[id];
		return null;
	},

	delete: function(id) {
		if (!this.data[id]) return;
		this.data[id].obj_window.removeWithComponents();
		this.data[id].obj_menus.removeWithComponents();
		delete(this.data[id]);
	},

	push: function(id, file_create) {
		this.data[id] = {
			obj_window: file_create.obj_window,
			obj_menus: file_create.obj_menus,
			id: file_create.id,
			title: file_create.title,
			state: 'open',
			dt_added: new Date()
		}
	},

	replace: function(id_tmp, id) {
		this.data[id] = this.data[id_tmp];
		this.data[id].id = id;
		delete(this.data[id_tmp]);
	},

	set_state(id, state) {
		this.data[id].state = 'state';
	},

	get_all: function(state) {
		let o = $();
		for (let id in this.data) {
			o = o.add(this.data[id].obj_window);
		}
		return o;
	},

	destructor: function() {
		for (let id in this.data) {
			this.delete(id);
		}
	},

	onLogout: () => App.file_create_cache.destructor(),
}

;var App = App || {};

App.filter = {

	init: function (params) {
		for (let i in params) {
			App.filter.data[params[i]] = 0;
			App.filter.data_saved[params[i]] = 0;
			App.filter.start[params[i]] = 0;
		}
	},

	set_data: function (data) {
		for (let param in data) {
			if (param === 'search') {
				$('#headerGeneral .headerGeneral__search input').val(data[param]).next().show();
			} else {
				App.filter.data[param] = data[param];
				App.filter.data_saved[param] = data[param];
				App.filter.start[param] = 1;
			}
		}
	},

	set_active(el) {
		let o = $(el);

		if (o.attr('data-group')) {
			$('.filter__item[data-group='+o.attr('data-group')+']').each(function () {
				App.filter.set_inactive(this);
			})
		}

		o.addClass('filter__item-active');
		$('#' + o.attr('id') + '-dup').addClass('filter__menuItem-active');
	},

	set_active_and_return_container(el) {
		$(el + '-dup').addClass('filter__menuItem-active')
		return $(el).addClass('filter__item-active').find('.btn-double span[data-container]');
	},

	set_inactive: function (el) {
		let o = $(el);
		if (!o.hasClass('filter__item')) o = o.closest('.filter__item');
		o.removeClass('filter__item-active').find('.btn-double span[data-container]').html('');
		$('#' + o.attr('id') + '-dup').removeClass('filter__menuItem-active');
		if (o.is('[data-controls="checkboxes"]')) {
			$('#' + o.attr('id') + '__menu').find('.menu__item-active').removeClass('menu__item-active');
		}
	},

	mark_empty_filter_items: function () {
		if (App.page.filter_available_ids && App.page.filter_available_ids !== 'skip') {
			$('.menu-withZeroes a').not('.a_noempty').addClass('menu__item-zero');
			if (App.page.filter_available_ids) $(App.page.filter_available_ids).removeClass('menu__item-zero');

			let available_filter_items = App.page.filter_available_ids.replaceAll('#sls', '').split(',')
				.map((flt) => '.filter__menuItem[data-flt='+flt+'] > ws-btn:first-child').join(',');

			$('.filter__menuItem[data-flt] > ws-btn:first-child').prop('disabled', true);
			$(available_filter_items).prop('disabled', false);
		}
	},

	init_page: function (params) {
		if (params.order != null) App.filter.order = params.order;
		if (params.desc != null) App.filter.desc = Boolean(+params.desc);
		if (params.data != null) App.filter.set_data(params.data);
	},
	init_params: function (params) {
		App.filter.init(params);
	},

	init_order: function (order, desc) {
		App.filter.order = order;
		App.filter.desc = desc;
	},

	have_data: function () {
		for (let i in App.filter.data)
			if (App.filter.data[i]) return true;
		return false;
	},

	// TODO: refactor to content load
	filter_update_and_submit: function (data) {
		if (App.device.is_mobile()) {
			const t = new Date();
			const ty = t.getFullYear();
			const tm = t.getMonth() + 1;
			if (data?.dy == ty && data?.dm == tm) {
				const el = document.querySelector('#calendar td.today');
				if (el) {
					el.scrollIntoView({ behavior: 'smooth', block: 'center' });
					return;
				}
				App.filter._scrollToday = true;
			}
		}
		for (let i in data) {
			if (document.flt_frm.elements[i]) document.flt_frm.elements[i].value = data[i]; else $('.filter input[data-flt=' + i + ']').val(data[i]);
		}
		App.filter.submit_form();
	},

	submit_form: function() {
		App.controls.views.save_filter($(document.flt_frm).serialize());
	},

	onclick_item: function (el) {
		$(el).closest('.menu, .menuFake').find('.menu__item-active').removeClass('menu__item-active');
		$(el).addClass('menu__item-active');
	},

	need_save: false,
	save: function (need_reload) {
		let data = [];
		let need_save = false;
		App.page.filter_params.forEach(param => {
			if (App.filter.data[param]) data.push('sel_' + param + '=' + App.filter.data[param]);
			if (App.filter.data[param] !== App.filter.data_saved[param]) {
				App.filter.data_saved[param] = App.filter.data[param];
				if (App.page.loaded) need_save = true;
			}
		});
		if (need_reload) {
			App.controls.views.save_filter(data.join('&'));
		}
		else if (need_save) {
			if (App.page.loaded) App.controls.views.save_filter(data.join('&'), true);
		}
	},

	search: {
		words: [],
		words_wrong_keyboard: [],
		words_translit: [],
		dig_children: false,
	},
	search_user: {
		words: [],
		words_wrong_keyboard: [],
		words_translit: [],
	},
	search_task: {
		words: [],
		words_wrong_keyboard: [],
		words_translit: [],
	},
	search_project: {
		words: [],
		words_wrong_keyboard: [],
		words_translit: [],
	},

	search_init: function () {
		App.filter.search.words = [];
		App.filter.search.words_wrong_keyboard = [];
		App.filter.search.words_translit = [];

		App.filter.search_task.words = [];
		App.filter.search_task.words_wrong_keyboard = [];
		App.filter.search_task.words_translit = [];

		App.filter.search_user.words = [];
		App.filter.search_user.words_wrong_keyboard = [];
		App.filter.search_user.words_translit = [];

		App.filter.search_project.words = [];
		App.filter.search_project.words_wrong_keyboard = [];
		App.filter.search_project.words_translit = [];

		let str = App.search.obj_search_input.val() || '';
		if (!str.trim()) return;

		App.filter.search.dig_children = false;
		if (str.endsWith(' ')) {
			App.filter.search.dig_children = true;
		}
		str = str.trim();

		str = str.replace(/\s+/g, ' ').toLowerCase().trim();

		let wrong = App.helper.keyboard.switch(str);
		let translit_lat = App.helper.translit.cyr_to_lat(str);
		let translit_cyr = App.helper.translit.lat_to_cyr(str);

		const split_normalized = (s) => s.split(' ');

		App.filter.search.words = split_normalized(str);
		App.filter.search.words_wrong_keyboard = split_normalized(wrong);
		App.filter.search.words_translit = split_normalized(translit_lat).concat(split_normalized(translit_cyr));

		const distribute = (target, original) => {
			for (let i = 0; i < original.length; i++) {
				const w = original[i];
				if (w.startsWith('@')) {
					target.search_user.words.push(w.substring(1));
				} else {
					target.search_task.words.push(w);
				}
			}
		};

		distribute(App.filter, App.filter.search.words);
		distribute(App.filter, App.filter.search.words_wrong_keyboard);
		distribute(App.filter, App.filter.search.words_translit);
	},

	all_matched_filters: {
	},

	helper_counter_clear: function(className) {
		this.all_matched_filters = {}
	},

	helper_count_plus: function(className) {
		if (!(className in App.filter.all_matched_filters)) App.filter.all_matched_filters[className] = 0;
		App.filter.all_matched_filters[className]++;
	},

	helper_count_minus: function(className) {
		if (className in App.filter.all_matched_filters) App.filter.all_matched_filters[className]--;
	},

	helper_clear_menu: function(el) {
		let data = [
			{
				left_icon: 'filter_circle-off',
				text: App['locale_general']['filter_clear'],
				anchor_class: 'menu__item-delete',
				callback: function () {
					App.page.filter_clear();
					App.menu.hide();
				},
			}
		];

		let protected_tab = $('#viewsList__wrapper').find('span.viewsList__item-protected').attr('data-href');

		if (protected_tab.length && App.page.url.base !== protected_tab) {
			data.push({
				right_icon: 'spark',
				text: App['locale_general']['tasks_all'],
				callback: function () {
					App.core.goto(protected_tab);
					App.menu.hide();
				}
			});
		}

		App.controls.confirm.ask(el, data);
	},

	mark_empty_filter_items_new: function() {
		App.core.call_queue.add('mark_empty_filter_items', function() {
			$('.filter__menuItem[data-flt]').each(function() {
				$(this).find('> ws-btn:first-child').prop('disabled', !App.filter.all_matched_filters[$(this).attr('data-flt')]);
			});
			$('.menu-withZeroes a[data-class]').not('.a_noempty').each(function() {
				$(this).toggleClass('menu__item-zero', !App.filter.all_matched_filters[$(this).attr('data-class')]);
			});
			$('.menu-withZeroes-user .user[data-id]').not('.a_noempty, .user_gr, .user_gr_sub').each(function() {
				$(this).toggleClass('menu__item-zero', !App.filter.all_matched_filters[(App.filter.data['role'] == 3 ? 's' : (App.filter.data['role'] == 2 ? 'a' : 'u')) + $(this).attr('data-id')]);
			});
			$('.menu-withZeroes-tags a').not('.a_noempty').each(function() {
				$(this).toggleClass('menu__item-zero', !App.filter.all_matched_filters['t' + $(this).attr('data-id')] && !App.filter.all_matched_filters['st' + $(this).attr('data-id')]);
			});
			$('.menu-withZeroes-role a[data-id]').not('.a_noempty').each(function() {
				$(this).toggleClass('menu__item-zero', !App.filter.all_matched_filters[($(this).attr('data-id') == 3 ? 's' : ($(this).attr('data-id') == 2 ? 'a' : 'u')) + (App.filter.data['user'] ? App.filter.data['user'] : App.me.id)]);
			});
		}, App.filter, null, 0.01);
	},

	order: '',
	desc: false,
	data: {},
	start: {},
	data_saved: {},

	check_match_tasks: function(data, reverse) {
		let classNames = data['class'].trim().split(' ');

		let match_costs_filters = {}
		let used_time = App.page.costs.get_time(data.id);
		let used_money = App.page.costs.get_money(data.id);
		match_costs_filters[App.filter.special_filters['costs_add']] = (App.page.costs.feature('time') && used_time)
			|| (App.page.costs.feature('money') && used_money);
		match_costs_filters[App.filter.special_filters['costs_free']] = !match_costs_filters[App.filter.special_filters['costs_add']];
		match_costs_filters[App.filter.special_filters['costs_over']] = (App.page.costs.feature('time') && 'max_time' in data && data['max_time'] && used_time > data['max_time'])
			|| (App.page.costs.feature('money') && 'max_money' in data && data['max_money'] && used_money > data['max_money']);
		match_costs_filters[App.filter.special_filters['with_planned']] = ('max_time' in data && data['max_time'])
			|| ('max_money' in data && data['max_money']);

		if (reverse) {
			classNames.forEach(App.filter.helper_count_minus);
			for (let filterId in match_costs_filters) {
				if (match_costs_filters[filterId]) App.filter.helper_count_minus('p' + filterId);
			}
			if (App.team_timers.task_data[data.id]) App.filter.helper_count_minus('p' + App.components.task_timers.list_task_classes.active_timers);
			return false;
		} else {
			classNames.forEach(App.filter.helper_count_plus);
			for (let filterId in match_costs_filters) {
				if (match_costs_filters[filterId]) App.filter.helper_count_plus('p' + filterId);
			}
			if (App.team_timers.task_data[data.id]) App.filter.helper_count_plus('p' + App.components.task_timers.list_task_classes.active_timers);
		}

		if (App.page.is_task_filter) {
			if (data.id != App.page.is_task_filter && data.id_parent != App.page.is_task_filter && data.id_parent_top != App.page.is_task_filter) return false;
		}

		if (App.filter.data['no_subs'] && data['id_parent']) return false;

		if (App.filter.data['role']) {
			if (!classNames.includes((App.filter.data['role'] == 3 ? 's' : (App.filter.data['role'] == 2 ? 'a' : 'u')) + (App.page.is_personal || App.me.id))) return false;
		}
		if (App.filter.data['assignee']) {
			if (!classNames.includes('u' + App.filter.data['assignee'])) return false;
		}
		if (App.filter.data['author']) {
			if (!classNames.includes('a'  + App.filter.data['author'])) return false;
		}
		if (App.filter.data['subscriber']) {
			if (!classNames.includes('s' + App.filter.data['subscriber'])) return false;
		}
		if (App.filter.data['group']) {
			if (!classNames.includes((App.filter.data['group_sub'] ? 'ugs' + App.filter.data['group'] + '_' + App.filter.data['group_sub'] : 'ug' + App.filter.data['group']))) return false;
		}
		//if (App.filter.data['stage'] && !classNames.includes('st' + (App.filter.data['stage'] < 3 ? 0 : App.filter.data['stage']))) return false; // why ???

		if (App.filter.data['stage'] && data['id_stage'] != (App.filter.data['stage'] < 3 ? 0 : App.filter.data['stage'])) return false;
		if (App.filter.data['tag']) {
			if (App.filter.data['tag'] < 3) { // Без меток
				if (data['class'].match(App.components.task_tags.regex_remove_class)) return false;
			} else if (!classNames.includes('t' + App.filter.data['tag'])) return false;
		}
		if (App.filter.data['contact']) {
			if (!classNames.includes('c' + App.filter.data['contact'])) return false;
		}
		if (App.filter.data['type']) {
			let tmp_match = true;
			App.filter.data['type'].split(',').map(Number).forEach(function(type) {
				if (!classNames.includes('p' + type)) tmp_match = false;
			});
			if (!tmp_match) return false;
		}
		if (App.filter.data['costs']) {
			if (!match_costs_filters[App.filter.data['costs']]) return false;
		}
		// if (App.filter.data['priority']) {
		// 	if (!classNames.includes('p' + App.filter.data['priority'])) return false;
		// }
		if (Array.isArray(App.filter.data['priority']) && App.filter.data['priority'].length) {
			if (!App.filter.data['priority'].some(item => classNames.includes('p' + item))) return false;
		}
		if (App.filter.data['starred'] && !classNames.includes('p15')) return false;

		if (App.filter.data['with_todos']) {
			if (!classNames.includes('p' + App.filter.data['with_todos'])) return false;
		}
		if (App.filter.data['with_files']) {
			if (!classNames.includes('p' + App.filter.data['with_files'])) return false;
		}
		if (App.filter.data['with_mentions']) {
			if (!classNames.includes('p' + App.filter.data['with_mentions'])) return false;
		}
		if (App.filter.data['new_comments']) {
			if (!classNames.includes('p' + App.filter.data['new_comments'])) return false;
		}
		if (App.filter.data['active_timers']) {
			if (!App.team_timers.task_data[data.id]) return false;
		}
		if (App.filter.data['recent_tasks']) {
			if (!classNames.includes('p' + App.filter.data['recent_tasks'])) return false;
		}
		if (App.filter.data['term'] && !classNames.includes('p' + App.filter.data['term'])) return false;
		if (App.filter.data['project']) {
			if (!classNames.includes('pr' + App.filter.data['project'])) return false;
		}
		if (App.filter.data['pstage']) {
			if (!classNames.includes('pst' + App.filter.data['pstage'])) return false;
		}
		if (App.filter.data['ptag']) {
			if (!classNames.includes('pt' + App.filter.data['ptag'])) return false;
		}
		if (App.filter.data['contact']) {
			if (!classNames.includes('c' + App.filter.data['contact'])) return false;
		}
		return true;
	},

	check_match_projects: function(o) {
		if (App.filter.data['role'] == 3) {
			if (o.hasClass('u' + (App.filter.data['user'] ? App.filter.data['user'] : App.me.id))) return false;
		} else if (App.filter.data['role'] && !o.hasClass((App.filter.data['role'] == 2 ? 'u' : 'm') + (App.filter.data['user'] ? App.filter.data['user'] : App.me.id))) return false;
		if (App.filter.data['type'] && !o.hasClass('p' + App.filter.data['type'])) return false;
		if (App.filter.data['starred'] && !o.hasClass('p15')) return false;
		if (App.filter.data['status'] === 10 && !o.hasClass('p1')) return false;
		if (App.filter.data['status'] === 20 && !o.hasClass('p2')) return false;
		if (App.filter.data['no_activity'] && !o.hasClass('p20')) return false;
		if (App.filter.data['no_deadline'] && !o.hasClass('p24')) return false;
		if (App.filter.data['no_manager'] && !o.hasClass('p25')) return false;
		if (App.filter.data['over_deadline'] && !o.hasClass('p23')) return false;
		if (App.filter.data['over_costs'] && !o.hasClass('p21')) return false;
		if (App.filter.data['with_hot_tasks'] && !o.hasClass('p22')) return false;
		if (App.filter.data['color'] && !o.hasClass('p' + App.filter.data['color'])) return false;
		if (App.filter.data['stage'] && !o.hasClass('st' + (App.filter.data['stage'] < 3 ? 0 : App.filter.data['stage']))) return false;
		if (App.filter.data['tag']) {
			if (App.filter.data['tag'] < 3) { // Без меток
				if (o.attr('class').match(App.components.task_tags.regex_remove_class)) return false;
			} else if (!o.hasClass('t' + App.filter.data['tag'])) return false;
		}
		if (App.filter.data['group'] && !o.hasClass('' + (App.filter.data['group_sub'] ? 'ugs' + App.filter.data['group'] + '_' + (App.filter.data['group_sub'] == -2 ? 0 : App.filter.data['group_sub']) : 'ug' + App.filter.data['group']))) return false;
		if (App.filter.data['folder'] && !o.hasClass('g' + App.filter.data['folder'])) return false;
		if (App.filter.data['workflow'] && !o.hasClass('wf' + App.filter.data['workflow'])) return false;
		return true;
	},

	check_match_files: function(o) {
		if (App.filter.data['user'] && !o.hasClass('u' + App.filter.data['user'])) return false;
		if (App.filter.data['tag'] && !o.hasClass('t' + App.filter.data['tag'])) return false;
		if (App.filter.data['type'] && !o.hasClass('f' + App.filter.data['type'])) return false;
		return true;
	},

	check_match_users: function(o) {
		if (App.filter.data['role'] && !o.hasClass('u' + App.filter.data['role'])) return false;
		if (App.filter.data['tag'] && !o.hasClass('t' + App.filter.data['tag'])) return false;
		if (App.filter.data['group'] && !o.hasClass('g' + App.filter.data['group'])) return false;
		if (App.filter.data['group_sub'] && !o.hasClass('gs' + App.filter.data['group_sub'])) return false;
		if (App.filter.data['starred'] && !o.hasClass('str' + App.filter.data['starred'])) return false;
		return true;
	},

	special_filters: {
		'costs_free': 21,
		'costs_add': 22,
		'costs_over': 23,
		'with_planned': 24,
	},
	special_filters_keys: [21, 22, 23, 24],

	params_tasks: ['group', 'group_sub', 'tag', 'ptag', 'stage', 'pstage', 'type', 'priority', 'term', 'costs', 'contact', 'project', 'role', 'assignee', 'author', 'subscriber', 'no_subs', 'starred', 'with_todos', 'with_files', 'with_mentions', 'new_comments', 'active_timers', 'recent_tasks', 'user_costs', 'task_status', 'birthdays', 'holidays', 'task'],
	params_report: ['group', 'group_sub', 'tag', 'ptag', 'stage', 'pstage', 'type', 'user', 'task', 'parent'],
	params_projects: ['user', 'role', 'tag', 'stage', 'type', 'folder', 'color', 'group', 'group_sub', 'starred', 'status', 'no_activity', 'no_deadline', 'no_manager', 'over_deadline', 'overrun_costs', 'burning_tasks', 'workflow'],

	interfere_data_tasks: function(data) {

		for (let i in data) {
			let match = i.match(/type(\d+)/);
			if (match) {
				data['type'] = App.filter.data['type'] ? App.filter.data['type'].split(',').map(Number) : [];
				if (data[i]) {
					data['type'].push(match[1]);
				} else {
					data['type'] = data['type'].filter((j) => j !== match[1]);
				}
				data['type'] = data['type'].join(',');
				delete(data[i]);
			}
		}

		if ('assignee' in data) {
			data['group'] = data['group_sub'] = 0;
		} else if ('group' in data) {
			data['assignee'] = 0;
		}
	},

	interfere_data_report: function(data) {
		if ('user' in data) {
			data['group'] = data['group_sub'] = 0;
		} else if ('group' in data) {
			data['user'] = 0;
		}
	},

	interfere_data_projects: function(data) {
		if ('role' in data) {
			data['group'] = data['group_sub'] = 0;
		} else if ('group' in data) {
			data['role'] = data['user'] = 0;
		}
	},

	helper_onload: function(type, dom_id, variable) {
		let dom_id2 = dom_id;
		switch (type) {
			case 'project':
				variable ||= 'project';
				$('#' + dom_id + '__menu').on('click', '.menu__item', function () {
					App.controls.menu.item_set_active(this);
					let span = App.filter.set_active_and_return_container('#' + dom_id);
					span.text($(this).find('.flex_content').text().trim()).prev().remove();
					App.menu.hide_all();
					App.page.filter_update({[variable]: $(this).attr('data-id')});
					return false
				});
				break;
			case 'stage':
				variable ||= 'stage';
				$('#' + dom_id2 + '__menu').on('click', '.menu__item', function () {
					App.controls.menu.item_set_active(this);
					let span = App.filter.set_active_and_return_container('#' + dom_id);
					span.text($(this).find('.flex_content').text().trim()).prev().remove();
				if ($(this).attr('data-id') > 3 || $(this).attr('data-id') == 1) {
						span.before($(this).find('.flex_content').prev().clone());
					}
					App.menu.hide_all();
					App.page.filter_update({[variable]: $(this).attr('data-id')});
					return false
				});
				break;
			case 'tags':
				variable ||= 'tag';
				$('#' + dom_id2 + '__menu').on('click', '.menu__item', function () {
					App.controls.menu.item_set_active(this);
					let span = App.filter.set_active_and_return_container('#' + dom_id);
					span.text($(this).find('.flex_content').text().trim()).prev().remove();
					if ($(this).attr('data-id') > 3) {
						span.before('<ws-icon name="labels_dot" class="'+$(this).attr('data-class')+'"></ws-icon>');
					}
					App.menu.hide_all();
					App.page.filter_update({[variable]: $(this).attr('data-id')});
					return false
				});
				break;
			case 'users':
				variable ||= 'user';
				$('#' + dom_id + '__menu').on('click', '.menu__item', function () {
					if ($(this).is('[data-id]')) {
						if ($(this).attr('data-id') == App.me.id) { // Imitate Role click
							let role_link = $('#filterItem__role__menu .menu__item[data-var='+variable+']');
							if (role_link.length) {
								App.filter.set_inactive($('#' + dom_id));
								App.page.filter_update({[variable]: 0});
								App.menu.hide_all();
								role_link.click();
								return false;
							}
						}
						App.controls.menu.item_set_active(this);
						let span = App.filter.set_active_and_return_container('#' + dom_id);
						if (span.prev().length) {  // Role defined
							span.prev().remove();
						}
						span.html($('#' + dom_id + '__menu').attr('data-def-txt')).before($(this).find('.space').html());
						$('#' + dom_id + 'menu__item').removeClass('menu__item-zero').not('.' + $(this).attr('class').replace(/\s+/g, ',.')).addClass('menu__item-zero');
						App.menu.hide_all();
						App.page.filter_update({[variable]: $(this).attr('data-id')});
					} else if (variable == 'assignee') {
						let span = App.filter.set_active_and_return_container('#' + dom_id);
						span.html($(this).attr('data-name')).prev().remove();
						App.menu.hide_all();
						let group = $(this).attr('data-group');
						let group_sub = $(this).is('[data-group-sub]') ? ($(this).attr('data-group-sub').toInt() || -2) : 0;
						App.page.filter_update({
							group: group,
							group_sub: group_sub
						});
						if (group_sub) App.filter.helper_split_group_button(span, group);
					}
					return false
				});
				break;
		}
	},

	helper_split_group_button: function (span, group) {
		if (App.filter.data['group'] && App.filter.data['group_sub']) {
			let dom_id = 'filterItem__assignee';
			if ($('.filter #'+dom_id+'.filter__item-active').length) {
				let flt_el = $('#' + dom_id), flt_el2;
				group ||= App.filter.data_saved['group'];
				span ||= flt_el.find('.btn-double span[data-container]');
				let title = span.text().split(' / ');
				span.text(title[0]);
				if (!$('.filter #'+dom_id+'2').length) {
					flt_el2 = flt_el.clone().attr('id', dom_id + '2');
					flt_el.after(flt_el2);
				} else {
					flt_el2 = $('#'+dom_id+'2');
				}
				flt_el2.addClass('filter__item-active').find('span[data-container]').html(title[1]);
				flt_el2.find('.btn-double button:last').attr('onclick', '').off('click').on('click', function() {
					App.filter.set_inactive(this);
					App.page.filter_update({group: group, group_sub: 0});
				});
			}
		}
	},

	clear_filters_tasks: function() {
		App.filter.set_inactive('#filterItem__role');
		App.filter.set_inactive('#filterItem__project');
		App.filter.set_inactive('#filterItem__ptag');
		App.filter.set_inactive('#filterItem__pstage');
		App.filter.set_inactive('#filterItem__tag');
		App.filter.set_inactive('#filterItem__stage');
		App.filter.set_inactive('#filterItem__type');
		App.filter.set_inactive('#filterItem__terms');
		App.filter.set_inactive('#filterItem__assignee__menu');
		App.filter.set_inactive('#filterItem__author__menu');
		App.filter.set_inactive('#filterItem__subscriber__menu');
		App.filter.set_inactive('#filterItem__priority');
		App.filter.set_inactive('#filterItem__starred');
		App.filter.set_inactive('#filterItem__with_todos');
		App.filter.set_inactive('#filterItem__with_files');
		App.filter.set_inactive('#filterItem__with_mentions');
		App.filter.set_inactive('#filterItem__new_comments');
		App.filter.set_inactive('#filterItem__active_timers');
		App.filter.set_inactive('#filterItem__contact');
		App.filter.set_inactive('#filterItem__costs');
		App.filter.set_inactive('#filterItem__noSubtasks');
		App.filter.set_inactive('#filterItem__assignee2');
	},
	clear_filters_projects: function() {
		App.filter.set_inactive('#filterItem__role');
		App.filter.set_inactive('#filterItem__group');
		App.filter.set_inactive('#filterItem__type');
		App.filter.set_inactive('#filterItem__idColor');
		App.filter.set_inactive('#filterItem__starred');
		App.filter.set_inactive('#filterItem__statusInProgress');
		App.filter.set_inactive('#filterItem__statusSilent');
		App.filter.set_inactive('#filterItem__noActivity');
		App.filter.set_inactive('#filterItem__noDeadline');
		App.filter.set_inactive('#filterItem__noManager');
		App.filter.set_inactive('#filterItem__overDeadline');
		App.filter.set_inactive('#filterItem__overCosts');
		App.filter.set_inactive('#filterItem__withHotTasks');

	},

	onLoadPage: function () {
		// shake filter on mobile
		if ($(window).width() <= 480 && $('.filter').length && document.cookie.indexOf('ani_filter') === -1) {
			App.core.set_cookie('ani_filter', 1, 0);
			$('.filter .in').animate({scrollLeft: 50}, 500, function () {
				$('.filter .in').animate({scrollLeft: 0}, 500);
			});
		}
		App.filter.helper_split_group_button();
		App.filter.definitions.init();
		if (App.device.is_mobile() && App.filter._scrollToday) {
			const el = document.querySelector('#calendar td.today');
			if (el) el.scrollIntoView({behavior: 'auto', block: 'center'});
		}
	},

	register: function (dom_id, name, params) {
		this.definitions.items.set(dom_id, { name, dom_id, params});
	},

	definitions: {
		items: new Map(),
		init: function () {
			let definitions = App.filter.definitions;

			for (let item of definitions.items.values()) {
				if (item.name in definitions) {
					definitions[item.name].init(item.dom_id, item.params);
				}
			}

			definitions.items.clear();
		},
		priority: {
			init: function (dom_id, params) {
				$('#'+dom_id+'__menu').find('.menu__item').not('[onclick]').bind('click', function () {
					App.controls.menu.item_set_active(this);

					let priorities = [];
					$('#'+dom_id+'__menu .menu__item-active').each(function () {
						let data_id = $(this).data('id');
						priorities.push(data_id);
					});

					if (priorities.length > 0) {
						let span = App.filter.set_active_and_return_container('#'+dom_id);
						if (priorities.length > 1) {
							span.removeAttr('class').html(App.helper.html.encode(params.priority_label + ': ' + priorities.map(prio_id => prio_id - 100).join(','))).prev().remove();
						} else {
							let pval = priorities[0] - 100;
							span.toggleClass('priorb prior' + (pval), true).html(pval===0?PRIOR0_HTML:pval);
						}
					}

					App.menu.hide_all();
					App.page.filter_update({priority: priorities});

					return false
				});
			}
		},
		group: {
			init: function (dom_id, params) {
				$('#'+dom_id+'__menu').find('.menu__item').not('[onclick]').bind('click', function () {
					App.controls.menu.item_set_active(this);
					App.filter.set_active_and_return_container('#'+dom_id).html($(this).clone().find('.ava_group, .cnt').remove().end().text().trim());
					App.menu.hide_all();
					App.page.filter_update({[params.variable]: $(this).attr('data-id')});
					$('.filter__menuItem_subgroup')?.css('display', '');
					$('.filter__menuItem_subgroup:not(#filterItem__group_sub'+$(this).attr('data-id')+')')?.hide();
					$('#filterItem__group_sub'+$(this).attr('data-id')+'-dup')?.show();

					return false
				});
			}
		}
	},

	// new filter:
	match(data, value, handlers) {
		if (!value || !handlers) return true;

		let match = App.filter.match, result = true;

		if (value.type === FilterConditionTypeEnum.GROUP) {
			result = value.conditions.length === 0 ? true : (
				value.operator === FilterOperatorEnum.AND
					? value.conditions.every(i => match(data, i, handlers))
					: value.conditions.some(i => match(data, i, handlers))
			);
		} else if (value.type === FilterConditionTypeEnum.FIELD && handlers[value.filter]) {
			result = handlers[value.filter](data, value.operator, value.operand);
		}

		return result;
	},

	matchDate(value, operator, operand) {
		let dt = 0, customDate = App.helper.customDate;

		if (operand === 1)
			return App.filter.matchOperand(value, operator, 0);

		if (operand === 2 ) dt = customDate.today;
		else if (operand === 3 ) dt = customDate.tomorrow;
		else if (operand === 4 ) dt = customDate.yesterday;
		else if (operand === 10) dt = customDate.week;
		else if (operand === 11) dt = customDate.week_next;
		else if (operand === 20) dt = customDate.month;
		else if (operand === 21) dt = customDate.month_next;
		else if (typeof operand === 'string') dt = App.helper.date.to_timestamp(App.helper.date.from_input(operand));
		else return true;

		return value > 0 && App.filter.matchOperand(value, operator, dt);
	},

	matchOperand(value, operator, operand) {
		if (Array.isArray(value))
			return value.some(i => App.filter.matchOperand(i, operator, operand));

		const isArr = Array.isArray(operand);

		if (operator === FilterOperatorEnum.IS || operator === FilterOperatorEnum.IN)
			return isArr ? operand.some(i => i === value) : value === operand;

		if (operator === FilterOperatorEnum.NOT_IS || operator === FilterOperatorEnum.NOT_IN)
			return isArr ? !operand.some(i => i === value) : value !== operand;

		if (operator === FilterOperatorEnum.LTE && !isArr)
			return value <= operand;

		if (operator === FilterOperatorEnum.GTE && !isArr)
			return value >= operand;

		if (operator === FilterOperatorEnum.LT && !isArr)
			return value < operand;

		if (operator === FilterOperatorEnum.GT && !isArr)
			return value > operand;

		return false;
	},

	model2text(model, filters, level = 0) {
		if (model.type === FilterConditionTypeEnum.GROUP) {
			let group = model.value.conditions.map(i => App.filter.model2text(i, filters, level+1))
				.filter(i => i !== '')
				.join(` ${FilterOperatorEnum.short(model.value.operator)} `);

			return level > 0 && model.value.conditions.length > 1 ? `(${group})\n` : group;
		}

		if (model.type === FilterConditionTypeEnum.FIELD) {
			const filter = filters[model.value.filter];
			if (!filter) return '';

			let filterName = String(filter.name).toLowerCase(),
				operatorName = FilterOperatorEnum.short(model.value.operator),
				operandText = '';

			if (filter.operator.hidden || model.value.operator === FilterOperatorEnum.IS || model.value.operator === FilterOperatorEnum.IN) {
				operatorName = ' ';
			} else if (model.value.operator === FilterOperatorEnum.NOT_IS || model.value.operator === FilterOperatorEnum.NOT_IN) {
				operatorName = ` ${FilterOperatorEnum.short(FilterOperatorEnum.NOT)} `;
			} else {
				operatorName = ` ${operatorName} `;
			}

			if (filter.operand.hidden) {}
			else if (filter.operand.type === FilerOperandTypeEnum.NUMBER) {
				operatorName = FilterOperatorEnum.symbol(model.value.operator);
				operatorName = ` ${operatorName} `;
				operandText = model.value.operand?.text ?? '';
			} else if (filter.operand.type === FilerOperandTypeEnum.CONST) {
				filterName = operatorName = '';
				operandText = model.value.operator === FilterOperatorEnum.IS ? filter.operand.config.is : filter.operand.config.not;
			} else if (model.value.operand && Array.isArray(model.value.operand)) {
				operandText = model.value.operand.slice(0, 9).map(i => `"${i.text}"`).join(', ')
				if (model.value.operand.length > 9) operandText = `${operandText} +${model.value.operand.length - 9}`;
			} else if (model.value.operand) {
				operandText = model.value.operand.text ? `"${model.value.operand.text}"` : '';
			} else {
				return '';
			}

			return `${filterName}${operatorName}${operandText}`.trim();
		}

		return '';
	},

	model2value(model) {
		if (model.type === FilterConditionTypeEnum.GROUP) {
			const conditions = model.value.conditions.map(App.filter.model2value);

			return { type: FilterConditionTypeEnum.GROUP, ...model.value, conditions }
		}

		if (model.type === FilterConditionTypeEnum.FIELD) {
			let operand = null;

			if (Array.isArray(model.value.operand)) {
				operand = model.value.operand.map(i => i.value);
			} else if (model.value.operand) {
				operand = model.value.operand.value;
			}

			return { type: FilterConditionTypeEnum.FIELD, ...model.value, operand: operand };
		}

		throw new Error('unknown condition type');
	},

	matchCustomValue(values, field, oper, operand) {
		if (operand == null) return true;

		if (field.id_type === CustomFieldTypeEnum.BOOL) {
			const data = values[field.id] !== undefined ? Number(values[field.id]) : '-';
			return App.filter.matchOperand(data, oper, operand);
		}

		if (CustomFieldTypeEnum.isNumber(field.id_type)) {
			const data = values[field.id] !== undefined ? Number(values[field.id]) : '-';
			return App.filter.matchOperand(data, oper, operand);
		}

		if (field.id_type === CustomFieldTypeEnum.DATE) {
			const data = values[field.id] ? App.helper.date.to_timestamp(App.helper.date.from_input(values[field.id])) : 0;
			return App.filter.matchDate(data, oper, operand);
		}

		if (CustomFieldTypeEnum.isSelect(field.id_type)) {
			const data = values[field.id] !== undefined ? values[field.id].split(',').map(Number) : '-';
			return App.filter.matchOperand(data, oper, operand);
		}

		if (CustomFieldTypeEnum.isUser(field.id_type)) {
			const data = values[field.id] !== undefined ? values[field.id].split(',').map(Number) : '-';

			if (Array.isArray(data)) {
				data.push(2); // add anyone
				if (data.includes(App.me.id)) data.push('iam');
			}

			return App.filter.matchOperand(data, oper, operand);
		}

		return true;
	},

	helper: {
		contain_word: function (haystack, needle) {
			if (Array.isArray(needle))
				return needle.some(i => App.filter.helper.contain_word(haystack, i));

			return haystack.indexOf(' ' + needle + ' ') !== -1
				|| haystack.endsWith(' ' + needle)
				|| haystack.startsWith(needle + ' ');
		},
		contain_prefixed_word: function (haystack, prefix, needle) {
			if (Array.isArray(needle))
				return needle.some(i => App.filter.helper.contain_word(haystack, `${prefix}${i}`));

			return App.filter.helper.contain_word(haystack, `${prefix}${needle}`)
		},
		number_from_class: function(className, name) {
			const [,ts] = className.split(` ${name}`);
			return ts ? parseInt(ts) : 0;
		},
		user_operand_value: function(val) {
			if (Array.isArray(val)) return val.map(v => App.filter.helper.user_operand_value(v))
			return val === 'iam' ? App.me.id : val;
		},
		contact_operand_value: function(val) {
			if (Array.isArray(val)) return val.map(v => App.filter.helper.contact_operand_value(v))
			return val === 'any' ? 2 : val;
		},
	}
};

App.filter.menu = {
	show: function(anchor, data) {
		data ||= {};
		App.menu.show({
			anchor: anchor,
			type: data.type || 'left fixed',
			onload: function() {
				let menu = $(this), items = menu.find('.menu__group-wrapButtons');

				items.find('.filter__menuItem[data-secondary]').each(function () { items.append(this); });

				menu.find('ws-btn[name*=reset]').once_by_criteria('reset').on('click', function () {
					App.filter.menu.refresh(anchor, menu);
				});
			},
			onshow: function() {
				let menu = $(this),
					items = menu.find('.menu__group-wrapButtons'),
					toggle_secondary = items.find('.filter__menuItem-secondaryToggle');

				if (toggle_secondary.length === 0) {
					toggle_secondary = $('<div>', {
						class: 'filter__menuItem-secondaryToggle',
						html: '<ws-btn name="btn btn-28 btn-g btn-skeleton" text="'+App.i18n.t('flt_more')+'"></ws-btn>'
					}).on('click', function () {
						toggle_secondary.addClass('hiddenBlock');
						items.find('.filter__menuItem[data-secondary]').removeClass('hiddenBlock');
						App.filter.menu.refresh(anchor, menu);
					});
					items.append(toggle_secondary);
				}

				toggle_secondary.toggleClass('hiddenBlock', items.find('.filter__menuItem[data-secondary]:not(.filter__menuItem-active)').length === 0);
				items.find('.filter__menuItem[data-secondary]:not(.filter__menuItem-active)').addClass('hiddenBlock');
				items.find('.filter__menuItem.filter__menuItem-active[data-secondary]').removeClass('hiddenBlock');

				App.filter.menu.refresh(anchor, $(this));
			}
		});
	},
	refresh: function(anchor, menu) {
		if (!App.menu.is_shown()) return;

		let items = menu.find('.menu__group-wrapButtons'),
			footer = menu.find('.menu__group-buttons'),
			reset_btn = menu.find('ws-btn[name*=reset]');

		let have_data = $(anchor).closest('.filter').hasClass('filter-haveData'),
			footer_btn_count = footer.find('> ws-btn').length;

		reset_btn.toggleClass('hiddenBlock', !have_data);

		let show_footer = have_data || footer_btn_count > 1;
		footer.toggleClass('hiddenBlock', !show_footer);
	},
};

App.search = {
	timeout: null,
	done: function () {
		$('#search').removeClass('search_loading');
	},
	init_page_search() {
		// $('#headerGeneral .headerGeneral__search input').bind('keyup', function () {
		// 	if (App.search.timeout) clearTimeout(App.search.timeout);
		// 	App.search.timeout = setTimeout(() => App.page.process_search(), 500);
		// });
	},
	clear: function () {
		$('#headerGeneral .headerGeneral__search input').val('').next().hide();
		$('.filter__item-search input').val('');
	},

	open_mymenu: function () {
		App.mymenu.start_search();
		App.search.done();
	},

	helper_remove_marks: function(o) {
		o.find('mark').each(function() {
			let parent = this.parentNode;
			let mark = this;
			this.childNodes.forEach(function(el) {
				parent.insertBefore(el, mark);
			});
			this.remove();
			parent.normalize();
		});
	},

	helper_count_matches: function(o, words, words_wrong_keyboard, mark_matches, words_translit = []) {
		let txt = o.text().toLowerCase();
		let j = 0, word = '';
		const process = (word_list) => {
			for (let i = 0; i < word_list.length; i++) {
				word = word_list[i];
				if (txt.indexOf(word) !== -1) {
					j++;
					if (mark_matches) {
						o.textNodes().forEach(function(node) {
							let t = node.nodeValue;
							let pos = t.toLowerCase().indexOf(word);
							if (pos !== -1) {
								$(node).replaceWith(t.substr(0, pos) + '<mark class="mark'+(i%4)+'">' + App.helper.html.encode(t.substr(pos, word.length)) + '</mark>' + t.substr(pos + word.length));
							}
						});
					}
				}
			}
		};
		process(words);
		if (j === 0) process(words_wrong_keyboard);
		if (j === 0 && words_translit.length) process(words_translit);
		return j;
	},

	is_keydown: false,
	timeout2: null,
	obj_search_input: null,
	onLoadPage: function () {
		App.search.obj_search_input = $('#headerGeneral .headerGeneral__search input, .filter__item-search input');
		App.search.obj_search_input.bind('keyup afterpaste', function() {
			if (this.value) {
				$(this).closest('.in').addClass('search_started');
			} else {
				$(this).closest('.in').removeClass('search_started');
			}
			App.core.call_queue.add('header_search', function() {
				App.page.process_search(SEARCH_TYPING);
			}, App.page, null, 0.05);

			return false;
		}).bind('focus', function (e) {
			if (e.originalEvent !== undefined) $(this).focus_to_end();
		}).bind('paste', function () {
			setTimeout(function () {
				App.search.obj_search_input.trigger('afterpaste');
			}, 50);
		});
	}
};

class FilterOperatorEnum {

	static IS = 1;
	static NOT_IS = 2;
	static IN = 3;
	static NOT_IN = 4;

	static LT = 7;
	static GT = 8;
	static LTE = 9;
	static GTE = 10;

	static AND = 50;
	static OR = 51;
	static NOT = 52;

	static keys = {
		1: 'is',
		2: 'not_is',
		3: 'in',
		4: 'not_in',
		7: 'lt',
		8: 'gt',
		9: 'lte',
		10: 'gte',
		50: 'and',
		51: 'or',
		52: 'not',
	};

	static symbols = {
		1:  '=',
		2:  '≠',
		3:  '∈',
		4:  '∉',
		10: '≥',
		9:  '≤',
		7:  '<',
		8:  '>',
		50: '&',
		51: '|',
		52: '!',
	};

	static icons = {
		1: 'props/equal',
		2: 'props/not-equal',
		3: 'props/belong',
		4: 'props/not-belong',
		7: 'props/less-than',
		8: 'props/greater-than',
		9: 'props/less-than-or-equal',
		10:'props/greater-than-or-equal',
	}

	static isMulti(val) {
		return [FilterOperatorEnum.IN, FilterOperatorEnum.NOT_IN].includes(val);
	}

	static isLogic(val) {
		return [FilterOperatorEnum.AND, FilterOperatorEnum.OR, FilterOperatorEnum.NOT].includes(val);
	}

	static key(val) {
		return FilterOperatorEnum.keys[val] || '';
	}

	static name(val) {
		const key = FilterOperatorEnum.key(val);
		return App.i18n.t(`filters.name_${key}`);
	}

	static short(val) {
		const key = FilterOperatorEnum.keys[val] || '';
		return App.i18n.t(`filters.short_${key}`);
	}

	static symbol(val) {
		return FilterOperatorEnum.symbols[val] || '';
	}

	static icon(val) {
		return FilterOperatorEnum.icons[val] || null;
	}

	static create(val) {
		if (FilterOperatorEnum.keys[val] == null) throw new Error(`Unknown operator: ${val}`);
		return new FilterOperatorEnum(val);
	}

	constructor(val) {
		this.val = val;
	}

	get isMulti()   { return FilterOperatorEnum.isMulti(this.val); }
	get isLogic()   { return FilterOperatorEnum.isLogic(this.val); }
	get name()      { return FilterOperatorEnum.name(this.val); }
	get short()     { return FilterOperatorEnum.short(this.val); }
	get symbol()    { return FilterOperatorEnum.symbol(this.val); }
	get icon()      { return FilterOperatorEnum.icon(this.val); }
	get key()       { return FilterOperatorEnum.key(this.val); }
}

class FilerOperandTypeEnum {
	static MENU = 'menu';
	static TOGGLE = 'toggle';
	static CONST = 'const';
	static NUMBER = 'num';
	static STATIC = 'static';
}

class FilterConditionTypeEnum {
	static FIELD = 'field';
	static GROUP = 'group';

	static createGroupModel(operator, conditions) {
		return { type: FilterConditionTypeEnum.GROUP, value: { operator, conditions } };
	}

	static createFieldModel(filter, operator, operand) {
		return { type: FilterConditionTypeEnum.FIELD, value: { filter, operator, operand } };
	}

	static createGroupValue(operator, conditions) {
		return { type: FilterConditionTypeEnum.GROUP, operator, conditions };
	}

	static createFieldValue(filter, operator, operand) {
		return { type: FilterConditionTypeEnum.FIELD, filter, operator, operand };
	}
}

class BaseFilterContext {

	static nextKey = 1;

	constructor() {
		this.operand_configs = new Map();
	}

	clearOperandConfig(...key) {
		key.forEach(k => this.operand_configs.delete(k));
	}

	loadOperandConfig(key, operand, params) {
		return App.core.async_task.ajax({
			id: `filter_load_operand_config:${key}`,
			url: operand.url + '&params=' + encodeURIComponent(JSON.stringify(params)),
		}).then(config => {
			return config;
		});
	}

	resolveOperandConfig(key, operand) {
		if (!operand.async) return Promise.resolve(operand.config);

		const config = this.operand_configs.get(key);
		if (config) return Promise.resolve(config);

		return App.core.async_task.ajax({
			id: `filter_resolve_operand_config:${key}`,
			url: operand.url,
		}).then(config => {
			this.operand_configs.set(key, config);
			return config;
		});
	}

	createOperandMenu(menuConfig) {
		const operands = new Map();
		const processMenuItems = (it) => {
			if (it.items) {
				it.items.forEach(processMenuItems);
			} else if (it.id != null) {
				operands.set(String(it.id), {
					value: it.id,
					text: it.name || it.title,
					icon: it.icon?.only_menu ? null : it.icon
				});
			}
		}

		const config = { ...menuConfig, groups: [...menuConfig.groups] };

		config.groups.forEach(processMenuItems);
		config.groups.push({
			bottom: true,
			checkbox: false,
			dataset: {
				'hide-on-search-empty': true
			},
			items: [
				{
					id: 'clear',
					title: App.i18n.t('filters.clear_field'),
					icon: 'editor/clear_broom',
				}
			]
		});

		const menu = App.controls.menu.create_menu({
			...config,
			button: true,
			checkbox: true,
		});

		menu.operands = operands;

		menu.isActive = () => menu.el.hasClass('menu-active');

		return menu;
	}

	processInput(type, el, filter, onOperandValue) {
		if (type === 'date') {
			App.controls.datepicker.menu({
				anchor: el,
				backup: true,
				title: filter.operand.config.name || filter.name || '',
				type: filter.operand.type !== FilerOperandTypeEnum.MENU ? 'left' : 'submenu',
				datepicker: {
					rangeSelect: false,
					// minDate: self.total_days_min,
					// maxDate: new Date(),
					onSelect: function (date_str) {
						App.menu.hide();
						onOperandValue({
							text: date_str,
							value: date_str,
							icon: { type: 'icon', name: 'calendar_date' },
						});
					}
				},
				onshow: function (datepicker) {
					// datepicker.addClass('datepicker-commentsJumpTo');
				}
			});
		}
	}

	showOperandNumberMenu(params) {
		const filter = params.filter;

		App.menu.show({
			anchor: params.anchor,
			box: '#filterOperandNumberMenu',
			type: params.type ?? 'left',
			backup: params.backup ?? false,
			replace: params.replace ?? false,
			onshow(m) {
				const input = $(m).find('input'),
					editBlock = $(m).find('.editBlock__input'),
					conf = filter.operand.config;

				input.val(typeof params.value === 'number' ? params.value : '');
				input.attr('placeholder', conf.step);

				editBlock.find('.space-prefix')
					.toggleClass('hiddenBlock', conf.prefix.trim() === '').text(conf.prefix);
				editBlock.find('.space-suffix')
					.toggleClass('hiddenBlock', conf.suffix.trim() === '').text(conf.suffix);

				$(m).find('.menu__title-in-reg').text(filter.name);

				$(m).find('.menu__item[data-id=notset]').off('click').on('click', (e) => {
					const item = e.target.closest('.menu__item[data-id=notset]');
					params.onvalue({ value: '-', text: $(item).attr('data-text') }, FilterOperatorEnum.IS);
				});
				$(m).find('.menu__title ws-btn[name*=primary]').off('click').on('click', () => {
					const value = Number(input.val());
					if (isNaN(value) || !isFinite(value)) return;
					params.onvalue({ value, text: `${conf.prefix} ${value} ${conf.suffix}`.trim() });
				});
			}
		});
	}

	showOperandSelectMenu(params) {
		const menuId = 'filter-condition-field-select-menu',
			context = this,
			anchor = params.anchor,
			filter = params.filter,
			operand = params.operand || null,
			onvalue = params.onvalue;

		let operator = params.operator;

		const allowIn = filter.operators.includes(FilterOperatorEnum.IN),
			allowNotIn = filter.operators.includes(FilterOperatorEnum.NOT_IN),
			allowMulti = allowIn || allowNotIn;

		const selectedIds = operand ? (Array.isArray(operand) ? operand.map(i => String(i.value)) : [String(operand.value)]) : [];

		$(`#${menuId}`).remove();
		this.resolveOperandConfig(filter.id, filter.operand).then(menuConfig => {
			const operandMenu = context.createOperandMenu({
				id: menuId,
				...menuConfig,
				title: menuConfig.title || filter.name,
			});

			const initMenu = (el) => {
				el.find('.menu__item[data-id]').each(function () {
					$(this).toggleClass('menu__item-active', selectedIds.includes(this.dataset.id));
				});

				const clearItem = el.find('.menu__item[data-id=clear]'),
					primary_btn = el.find('.menu__group-search ws-btn[name*=primary]');

				if (FilterOperatorEnum.isMulti(operator)) {
					el.removeClass('menu--no_checkboxes');
					clearItem.parent().removeClass('hiddenBlock');
				} else {
					el.addClass('menu--no_checkboxes');
					clearItem.parent().addClass('hiddenBlock');
					primary_btn
						.toggleClass('hiddenBlock', !allowMulti)
						.attr('name', 'btn btn-28 btn-g btn-outline btn-primary')
						.attr('text', '')
						.attr('data-title', App.i18n.t('filters.select_multi'))
						.attr('left-icon', 'editor/checklist');
				}
			}

			const updateMenu = (config) => {
				if (!operandMenu.isActive()) return;

				const updatedOperandMenu = context.createOperandMenu({ ...config, title: menuConfig.title || filter.name });

				operandMenu.operands = updatedOperandMenu.operands;
				operandMenu.el.html(updatedOperandMenu.el.html());
				initMenu(operandMenu.el);
			}

			operandMenu.show({
				anchor,
				type: params.type ?? 'submenu',
				replace: params.replace ?? true,
				backup: params.backup ?? false,
				onload(m) {
					initMenu($(m));
					App.controls.menu.init(m);

					let last_search = '', search_loaded = false, do_search = App.helper.debounce(function (search) {
						if (!operandMenu.isActive()) return;
						context.loadOperandConfig(filter.id, filter.operand, { search }).then(newMenuConfig => {
							if (!operandMenu.isActive()) return;

							search_loaded = true;
							updateMenu(newMenuConfig);
							$(m).find('.menu__group-search input').val(last_search);
							$(m).find('.menu__group-search input').focus();
							App.context_search.menu.apply(this, m);
						});
					}, 333);
					m.addDelegatedEventListener('keyup', '.menu__group-search input', (e) => {
						if (filter.operand.async_search !== true || last_search === e.target.value) return;
						last_search = e.target.value;
						if (last_search.length < 3 && search_loaded) {
							search_loaded = false;
							updateMenu(menuConfig);
						} else if (last_search.length > 2) {
							do_search(last_search);
						}
					});

					// Multi-select:
					m.addDelegatedEventListener('click', '.menu__group-search ws-btn[name*=primary]', () => {
						if (FilterOperatorEnum.isMulti(operator)) {
							const values = $(m).find('.menu__item-active[data-id]').get().map(i => i.dataset.id).filter(i => !String(i).startsWith('input:'));
							let operand = values.map(i => operandMenu.operands.get(i)).filter(i => i != null);
							if (operand.length > 0) onvalue(operand, operator);
							else onvalue(null, operator);
						} else if (allowIn || allowNotIn) {
							$(m).find('.menu__item[data-id=clear]').parent().removeClass('hiddenBlock');
							$(m).removeClass('menu--no_checkboxes');
							operator = allowIn ? FilterOperatorEnum.IN : FilterOperatorEnum.NOT_IN;
							$(m).find('.menu__group-search ws-btn[name*=primary]')
								.attr('name', 'btn btn-28 btn-a btn-solid btn-primary')
								.attr('text', 'OK')
								.attr('data-title', '')
								.attr('left-icon', '');
						}
					});
					// Single-select:
					m.addDelegatedEventListener('click', '.menu__item[data-id]', (e) => {
						const item = e.target.closest('.menu__item[data-id]'), id = item.dataset.id;

						if (FilterOperatorEnum.isMulti(operator)) {
							if (id === 'clear') $(m).find('.menu__item[data-id].menu__item-active').removeClass('menu__item-active');
							return;
						}

						if (id.startsWith('input:')) {
							const [, type] = id.split(':');
							context.processInput(type, item, filter, (operandValue) => {
								onvalue(operandValue, operator);
							});
						} else if (operandMenu.operands.has(id)) {
							onvalue(operandMenu.operands.get(id), operator);
						}

					});
				},
				onshow(m) {
					if (filter.operand.available) {
						const availableIds = filter.operand.available.map(i => String(i));
						$(m).find('.menu__item[data-id]').each(function () {
							$(this).toggleClass('menu__item-zero', !availableIds.includes(this.dataset.id));
						});
					}
				}
			});
		});
	}

	showConditionAddMenu({ anchor, filters, addedFilters, allowConditionGroup, onAddCondition }) {
		const context = this,
			menuId = 'filter-condition-field-add-menu';

		const filterIds = Object.keys(filters).sort((a, b) => filters[a].order - filters[b].order).filter(id => {
			const { hidden, distinct } = filters[id];

			if (hidden === true) return false;

			return !(distinct === true && addedFilters?.has(id));
		});
		const groupIds = Array.from(new Set(filterIds.map((id) => filters[id].group)));

		const groups = groupIds.map(group => ({
			search: true,
			items: filterIds.filter(id => filters[id].group === group).map(id => {
				const filter = filters[id];
				return {
					title: filter.name,
					left_icon: filter.icon || 'none',
					dataset: { id },
					disabled: filter.zero === true,
					zero: filter.zero === true,
				};
			}).map(opt => App.controls.menu.create_item(opt)),
		}));

		if (allowConditionGroup) {
			groups.push({
				// classes: ['menu__group-unsearchable'],
				bottom: true,
				items: [
					{
						title: App.i18n.t('filters.add_group'),
						left_icon: 'editor/blockquote',
						dataset: { id: 0, type: FilterConditionTypeEnum.GROUP },
					}
				]
			})
		}

		const menu = App.controls.menu.create_menu({
			id: menuId,
			search: true,
			groups: groups,
		});

		const onSelectCondition = (item) => {
			const filterId = item.dataset.id;
			const filter = filters[filterId];
			if (!filter) return;

			const fieldConfig = {
				filter: filterId,
				operator: filter.operator?.default || filter.operators?.[0] || null,
				operand: filter.operand?.default || null,
			};

			if (fieldConfig.operand != null) {
				App.menu.hide();
				onAddCondition(FilterConditionTypeEnum.FIELD, fieldConfig);
			} else if (filter.operand.type === FilerOperandTypeEnum.MENU) {
				context.showOperandSelectMenu({
					anchor: item,
					filter,
					operand: fieldConfig.operand,
					operator: fieldConfig.operator,
					onvalue(val, oper) {
						fieldConfig.operand = val;
						fieldConfig.operator = oper || fieldConfig.operator;
						App.menu.hide();
						onAddCondition(FilterConditionTypeEnum.FIELD, fieldConfig);
					}
				});
			} else if (filter.operand.type === FilerOperandTypeEnum.NUMBER) {
				context.showOperandNumberMenu({
					anchor: item,
					filter,
					operand: fieldConfig.operand,
					replace: true,
					onvalue(val, oper) {
						fieldConfig.operand = val;
						fieldConfig.operator = oper || fieldConfig.operator;
						App.menu.hide();
						onAddCondition(FilterConditionTypeEnum.FIELD, fieldConfig);
					}
				});
			}
		}

		$(`#${menuId}`).remove();
		menu.show({
			anchor: anchor,
			type: 'left',
			backup: true,
			onload: (m) => {
				App.controls.menu.init(m);
				m.addDelegatedEventListener('click', '.menu__item[data-id]', (e) => {
					const item = e.target.closest('.menu__item[data-id]');
					if (item) {
						if (item.dataset.id === '0' && item.dataset.type === FilterConditionTypeEnum.GROUP) {
							onAddCondition(FilterConditionTypeEnum.GROUP, {
								operator: FilterOperatorEnum.AND,
								conditions: []
							});
						} else {
							$(m).addClass('menu-unloading');
							$(item).addClass('menu__item-active');
							onSelectCondition(item);
						}
					}
				});
			}
		});
	}

	static helperAddConditionModel(group, type, value) {
		if (type === FilterConditionTypeEnum.FIELD && value.operand == null) return group;

		const condition = { key: `c${BaseFilterContext.nextKey++}`, type, value };

		return {
			...(group || { type: FilterConditionTypeEnum.GROUP }),
			value: {
				...(group?.value || { operator: FilterOperatorEnum.AND }),
				conditions: [
					...(group?.value?.conditions || []),
					condition
				]
			}
		};
	}
}

class BaseFilterComponent extends RenderableComponent {

	constructor() {
		super();
		this._context = new BaseFilterContext();
	}

	provides() {
		return {
			context: () => this._context,
		}
	}

	get context() {
		return this._context;
	}

	get filters() {
		return this.prop('filters', {});
	}

	get model() {
		return this.prop('model', {});
	}

	get isActive() {
		return this.model.fields?.value?.conditions?.length > 0;
	}

	reload() {
		const url = this.prop('url', null);
		if (!url) return;

		App.core.async_task.ajax(url).then((res) => {
			if (this.isConnected) {
				this.setProps(res);
				this.emitEvent('reloaded')
			}
		});
	}

	invalidate() {
		clearTimeout(this._invalidate_timer);
		this._invalidate_timer = setTimeout(() => {
			if (this.isConnected) this.reload();
		}, 999);
	}

	setConditionAvailable(id, available) {
		const filter = this.filters[id];
		if (!filter) return;
		this.setProp('filters', {
			...this.filters,
			[id]: { ...filter, operand: { ...filter.operand, available } }
		});
	}

	setConditionZero(id, zero = true) {
		const filter = this.filters[id];
		if (filter) this.setProp('filters', { ...this.filters, [id]: { ...filter, zero } });
	}

	setConditionHidden(id, hidden = true) {
		const filter = this.filters[id];
		if (filter) this.setProp('filters', { ...this.filters, [id]: { ...filter, hidden } });
	}

	/**
	 * @returns {string}
	 * @abstract
	 */
	template() {
		throw new Error('Implement template() in subclass');
	}
}

;var App = App || {};

(function() {
	let self = App.filter_advanced = {

		data: {},
		have_data: false,
		shown: false,

		url_params: function() {
			if (!this.data['fs_ok']) return '';
			let filter = this.data;
			let url_parts = [];
			url_parts.push('fs_ok=1');
			if (filter['fs_by']) url_parts.push('fs_by='.filter['fs_by']);
			url_parts.push('fs_pt[]=' + filter['fs_pt'].join('&fs_pt[]='));
			url_parts.push('fs_st[]=' + filter['fs_st'].join('&fs_st[]='));
			if (filter['fs_prt'].length) {
				url_parts.push('fs_prt[]=' + filter['fs_prt'].join('&fs_prt[]='));
			}
			if ($('body').hasClass('data-project') && filter['fs_pr'].length) {
				url_parts.push('fs_pr[]=' + filter['fs_pr'].join('&fs_pr[]='));
			}
			if (filter['fs_dc1']) {
				url_parts.push('fs_dc1=' + App.helper.date.to_input(filter['fs_dc1']));
			}
			if (filter['fs_dc2']) {
				url_parts.push('fs_dc2=' + App.helper.date.to_input(filter['fs_dc2']));
			}
			if (filter['fs_ds0']) {
				url_parts.push('fs_ds0=1');
			}
			if (!filter['fs_ds0'] && filter['fs_ds1']) {
				url_parts.push('fs_ds1=' + App.helper.date.to_input(filter['fs_ds1']));
			}
			if (!filter['fs_ds0'] && filter['fs_ds2']) {
				url_parts.push('fs_ds2=' + App.helper.date.to_input(filter['fs_ds2']));
			}
			if (filter['fs_dd1']) {
				url_parts.push('fs_dd1=' + App.helper.date.to_input(filter['fs_dd1']));
			}
			if (filter['fs_dd2']) {
				url_parts.push('fs_dd2=' + App.helper.date.to_input(filter['fs_dd2']));
			}
			if (filter['fs_de0']) {
				url_parts.push('fs_ds0=1');
			}
			if (!filter['fs_de0'] && filter['fs_de1']) {
				url_parts.push('fs_de1=' + App.helper.date.to_input(filter['fs_de1']));
			}
			if (!filter['fs_de0'] && filter['fs_de2']) {
				url_parts.push('fs_de2=' + App.helper.date.to_input(filter['fs_de2']));
			}
			if (filter['fs_ut'].length) {
				url_parts.push('fs_ut[]=' + filter['fs_ut'].join('&fs_ut[]='));
			}
			if (filter['fs_us'].length) {
				url_parts.push('fs_us[]=' + filter['fs_us'].join('&fs_us[]='));
			}
			if (filter['fs_uf'].length) {
				url_parts.push('fs_uf[]=' + filter['fs_uf'].join('&fs_uf[]='));
			}
			if (filter['fs_ts'].length) {
				url_parts.push('fs_ts[]=' + filter['fs_ts'].join('&fs_ts[]='));
			}
			if (filter['fs_tg'].length) {
				url_parts.push('fs_tg[]=' + filter['fs_tg'].join('&fs_tg[]='));
			}
			if (filter['fs_tg2'].length) {
				url_parts.push('fs_tg2[]=' + filter['fs_tg2'].join('&fs_tg2[]='));
			}
			if (filter['fs_st2'].length) {
				url_parts.push('fs_st2[]=' + filter['fs_st2'].join('&fs_st2[]='));
			}
			if (filter['fs_tg'].length) {
				if (filter['fs_tg_sub']) url_parts.push('fs_tg_sub=1');
				if (filter['fs_tg_add']) url_parts.push('fs_tg_add=1');
			}
			return url_parts.join('');
		},

		check_match_tasks: function (data) {
			if (!this.data['fs_ok']) return true;
			let filter = this.data;
			let match, match_all;
			let classNames = data['class'].trim().split(' ');

			/** Task priority **/

			if (filter['fs_prt']?.length) {
				match = false;
				filter['fs_prt'].forEach(function (priority) {
					if (data['important'] == priority) match = true;
				});
				if (!match) return false;
			}

			/** Task projects **/


			if (!$('body').hasClass('data-project') && filter['fs_pr']?.length) {
				match = false;
				filter['fs_pr'].forEach(function (id_project) {
					if (id_project < 0) {
						if (filter['fs_by']) {
							if (classNames.includes('prm' + (-id_project))) match = true;
						} else {
							if (classNames.includes('prg' + (-id_project))) match = true;
						}
					} else {
						if (classNames.includes('pr' + id_project)) match = true; // project
					}
				});
				if (!match) return false;
			}

			/** Task dates **/

			if (filter['fs_dc1']) {
				if (data['dateadd'] < filter['fs_dc1'] - App.config.date_timezone_offset) return false; // TODO: here and below - check sign
			}
			if (filter['fs_dc2']) {
				if (data['dateadd'] >= filter['fs_dc2'] - App.config.date_timezone_offset + 86400) return false;
			}
			if (filter['fs_dd1']) {
				if (!data['status'] || !data['dateclose'] || data['dateclose'] < filter['fs_dd1'] - App.config.date_timezone_offset) return false;
			}
			if (filter['fs_dd2']) {
				if (!data['status'] || !data['dateclose'] || data['dateclose'] >= filter['fs_dd2'] - App.config.date_timezone_offset + 86400) return false;
			}

			if (!filter['fs_dw_add'] || data['dateend'] || data['datestart']) {
				if (filter['fs_ds0']) {
					if (data['datestart']) return false;
				}
				if (!filter['fs_ds0'] && filter['fs_ds1']) {
					if (!data['datestart'] || data['datestart'] < filter['fs_ds1']) return false;
				}
				if (!filter['fs_ds0'] && filter['fs_ds2']) {
					if (!data['datestart'] || data['datestart'] >= filter['fs_ds2'] + 86400) return false;
				}
				if (filter['fs_de0']) {
					if (data['dateend']) return false;
				}
				if (!filter['fs_de0'] && filter['fs_de1']) {
					if (!data['dateend']) return false;
					if (!data['dateend']) return false;
					if (App.config.date_offset_user_hrs == 0) {
						if (data['dateend'] < filter['fs_de1']) return false;
					} else {
						if (
							data['dateend'] > filter['fs_de1']
							|| (data['dateend'] == filter['fs_de1'] && (data['timeend'] == 0 || data['timeend'] > -4 * App.config.date_offset_user_hrs))
							|| (data['dateend'] >= filter['fs_de1'] - 86400 - 3600 && data['timeend'] > 96 - 4 * App.config.date_offset_user_hrs) // FYI: 1hr for possible daylight switch
						) {
						} else return false;
					}
				}
				if (!filter['fs_de0'] && filter['fs_de2']) {
					if (!data['dateend']) return false;
					if (App.config.date_offset_user_hrs == 0) {
						if (data['dateend'] > filter['fs_de2']) return false;
					} else {
						if (
							data['dateend'] < filter['fs_de2']
							|| (data['dateend'] == filter['fs_de2'] && (data['timeend'] == 0 || data['timeend'] < 96 - 4 * App.config.date_offset_user_hrs))
							|| (data['dateend'] <= filter['fs_de2'] + 86400 + 3600 && data['timeend'] < 4 * App.config.date_offset_user_hrs) // FYI: 1hr for possible daylight switch
						) {
						} else return false;
					}
				}
			}

			/** Task level **/

			if (filter['fs_pt']) {
				if (!filter['fs_pt'].includes(0) && !data['id_parent']) return false;
				if (!filter['fs_pt'].includes(1) && !filter['fs_pt'].includes(2) && data['id_parent'] && data['id_parent'] == data['id_parent_top']) return false;
				if (!filter['fs_pt'].includes(1) && !filter['fs_pt'].includes(3) && data['id_parent'] && data['id_parent'] != data['id_parent_top']) return false;
			}

			/** Task status **/

			if (filter['fs_st']) {
				if (!filter['fs_st'].includes(0)) {
					if (!data['status']) return false;
				} else {
					switch (filter['fs_st0']) {
						case 1: // hot
							if (!classNames.includes('p' + App.components.task_terms.list_task_classes['burning'])) return false;
							break;
						case 2: // ends
							if (!classNames.includes('p' + App.components.task_terms.list_task_classes['deadline'])) return false;
							break;
						default:
					}
				}

				if (!filter['fs_st'].includes(1)) {
					if (data['status']) return false;
				} else {
					switch (filter['fs_st1']) {
						case 1:
							if (!data['dateend']) return false;
							if (!classNames.includes('p' + App.components.task_terms.list_task_classes['on_time'])) return false;
							break;
						case 2:
							if (!data['dateend']) return false;
							if (!classNames.includes('p' + App.components.task_terms.list_task_classes['with_delay'])) return false;
							break;
						default:
					}
				}
			}

			/** Task assignee **/

			if (filter['fs_ut']?.length) {
				match = false;
				filter['fs_ut'].forEach(function (id_user) {
					if (id_user < 0) {
						if (classNames.includes('ug' + (-id_user))) match = true; // user_group
					} else {
						if (classNames.includes('u' + id_user)) match = true; // user
					}
				});
				if (!match) return false;
			}

			/** Task author **/

			if (filter['fs_uf']?.length) {
				match = false;
				filter['fs_uf'].forEach(function (id_user) {
					if (id_user < 0) {
						if (classNames.includes('ag' + (-id_user))) match = true; // user_group
					} else {
						if (classNames.includes('a' + id_user)) match = true; // user
					}
				});
				if (!match) return false;
			}

			/** Task subscriber **/

			if (filter['fs_us']?.length) {
				match = false;
				filter['fs_us'].forEach(function (id_user) {
					if (id_user < 0) { // user_group
						const id_group = -id_user;
						for (let id_user in App.team) {
							if (App.team[id_user].id_group == id_group && classNames.includes('s' + id_user)) {
								match = true;
								break;
							}
						}

					} else {
						if (classNames.includes('s' + id_user)) match = true; // user
					}
				});
				if (!match) return false;
			}

			/** Task statuses **/

			if (filter['fs_ts']?.length) {
				match = false;
				filter['fs_ts'].forEach(function (id_tag) {
					if (data['id_stage'] == (id_tag < 3 ? 0 : id_tag)) match = true; // exact status
				});
				if (!match) return false;
			}

			/** Task tags **/

			if (filter['fs_tg']?.length) {
				match = false;
				match_all = true;
				filter['fs_tg'].forEach(function (id_tag) {
					if (id_tag < 3) {
						if (!data['class'].match(App.components.task_tags.regex_remove_class)) match = true;
					} else {
						if (classNames.includes('t' + id_tag)) match = true; // exact tag
						else if (filter['fs_tg_sub'] && data['id_parent'] && App.page.data.task[data['id_parent']]['class'].trim().split(' ').includes('t' + id_tag)) match = true; // match by parent
						else if (filter['fs_tg_sub'] && data['id_parent'] && data['id_parent'] != data['id_parent_top'] && App.page.data.task[data['id_parent_top']]['class'].trim().split(' ').includes('t' + id_tag)) match = true; // match by parent
						else match_all = false;
					}
				});
				if (!match) return false;
				if (filter['fs_tg_and'] && !match_all) return false;
			}

			/** Project stages **/

			if (filter['fs_st2']?.length) {
				match = false;
				filter['fs_st2'].forEach(function (id_tag) {
					if (classNames.includes('pst' + (id_tag < 3 ? 0 : id_tag))) match = true; // exact status
				});
				if (!match) return false;
			}

			/** Project tags **/

			if (filter['fs_tg2']?.length) {
				match = false;
				filter['fs_tg2'].forEach(function (id_tag) {
					if (id_tag < 3) {
						if (data['class'].match(/\bpt\d/)) match = true; // no tags
					} else {
						if (classNames.includes('pt' + id_tag)) match = true; // exact tag
					}
				});
				if (!match) return false;
			}

			return true;
		},

		set: function(have_data, filter) {
			this.have_data = have_data;
			if (have_data) {
				this.data = filter;
				['fs_dc1', 'fs_ds1', 'fs_de1', 'fs_dd1', 'fs_dc2', 'fs_ds2', 'fs_de2', 'fs_dd2'].forEach((param) => {
					if (this.data[param]) {
						if (!/^\d+\.\d+\.\d+$/.test(this.data[param])) delete this.data[param];
						else this.data[param] = App.helper.date.to_timestamp(App.helper.date.from_input(this.data[param]));
					}
				})
			} else {
				this.data = {};
			}
		},

		apply: function(filter, onload) {
			this.data = filter;
			this.have_data = true;
			['fs_dc1', 'fs_ds1', 'fs_de1', 'fs_dd1', 'fs_dc2', 'fs_ds2', 'fs_de2', 'fs_dd2'].forEach((param) => {
				if (this.data[param]) {
					if (!/^\d+\.\d+\.\d+$/.test(this.data[param])) delete this.data[param];
					else this.data[param] = App.helper.date.to_timestamp(App.helper.date.from_input(this.data[param]));
				}
			})
			if (!onload) {
				// $('#filterItem__advancedFilter').click();
				App.filter_advanced.hide();
				App.page.process_filter_and_search();
			}
			$('#filterItem__advancedFilter').addClass('filter__item-active');
		},

		clear: function(clear_all) {
			this.data = {};
			this.have_data = false;
			$('#filterItem__advancedFilter').removeClass('filter__item-active');
			$('body').removeClass('withAdvancedFilter');
			$('#filter_more').hide();

			// reset to default
			$('.filter_new .empty').click();
			$('.filter_new .fil_task .ft2 input[type=checkbox]').parent().parent().removeClass('act');
			$('.filter_new .fil_task input').prop('checked', false).parent().removeClass('act');
			$('.filter_new .fil_task input[default]').prop('checked', true).parent().addClass('act');
			$('.filter_new .fil_task .ft2 input[type=checkbox][default]').parent().parent().removeClass('act');

			self.shown = false;
			App.controls.views.clear_filter_advanced(true);
			if (!clear_all) {
				if ('process_filter_and_search' in App.page) App.page.process_filter_and_search();
				else if ('process_search' in App.page) App.page.process_search();
			}
		},

		show: function(el) {
			if ($(el).attr('data-href')) {
				$('body').addClass('withAdvancedFilter');
				$('#filter_more').show().load($(el).attr('data-href'), self.init);
				$('#filter_more').scrollIntoView();
				$(el).removeAttr('data-href');
			} else {
				$('body').toggleClass('withAdvancedFilter');
				$('#filter_more').toggle();
				if ($('body').hasClass('withAdvancedFilter')) $('#filter_more').scrollIntoView();
			}
			self.shown = $('body').hasClass('withAdvancedFilter');
			return false
		},

		hide: function(el) {
			$('body').removeClass('withAdvancedFilter');
			$('#filter_more').hide();
			self.shown = false;
			return false
		},

		init: function () {
			self.filter_options_by_project_selected();
			self.show_reset_buttons();
			self.init_inputs();
			self.init_scroll_zones();
			self.container_swipe.init();
		},

		init_inputs: function () {
			$('#fil_pr input, #fil_ptg label input, #fil_pst label input').bind('click', self.filter_options_by_project_selected);
			$('.filter_new input').bind('click', self.show_reset_buttons);
			$('.filter_new input:checked').parent().addClass('act');
			$('.filter_new .ft2 input[type=checkbox]:checked').parent().parent().addClass('act');
			$('.filter_new .ft2 input[type=checkbox]').bind('click', function () {
				if (this.checked) {
					$(this).parent().parent().addClass('act');
				} else {
					$(this).parent().parent().removeClass('act');
				}
			});
			$('.filter_new .ft2 input[type=radio]').bind('click', function () {
				$('.filter_new .ft2 input').each(function () {
					if (this.checked) {
						$(this).parent().addClass('act');
					} else {
						$(this).parent().removeClass('act');
					}
				});
			});
			$('.filter_new label.tl input').bind('click', function () {
				if (this.checked) {
					$(this).parent().next().addClass('flt_h0');
				} else {
					$(this).parent().next().removeClass('flt_h0');
				}
			});
			$('#fil_dt input[type=checkbox]').bind('click', function () {
				$(this).parent().parent().toggleClass('unset', this.checked).find('.datepick').val('');
				$('#fil_dt .empty').addClass('empty_ect');
			});
			$('#fil_dt .datepick').not('.ws_init').addClass('ws_init').datepicker({
				rangeSelect: false,
				numberOfMonths: 1,
				monthPicker: true,
				firstDay: App.datepicker_firstDay,
				onSelect: function (date) {
					$('#fil_dt .empty').addClass('empty_ect');
				}
			});
			$('.filter_new .empty').bind('click', function () {
				$(this).removeClass('empty_act');
				if ($(this).parent().attr('id') == 'fil_dt') {
					$('#fil_dt .datepick').val('');
					$('#fil_dt input[type=checkbox]').prop('checked', false).parent().removeClass('act').parent().removeClass('unset');
				} else {
					$(this).next().next().find('input').prop('checked', false).parent().removeClass('act').filter('.tl').next().removeClass('flt_h0');
					if ($(this).hasClass('empty_pr')) {
						$('.fil_pr .fil_ label, .fil_pr .fil_ div').removeClass('flt_h1');
						$('.tagsAdvFilterSelect-status, .tagsAdvFilterSelect-label').find('label').not('.p_all').removeClass('flt_h1').parent().removeClass('flt_h1').parent().removeClass('flt_h1');
					}
				}
				return false;
			});
		},

		init_scroll_zones: function () {
			$('#filter_more .fil_.scrollZone').each(function () {
				if (this.scrollBars) return;
				this.scrollBars = App.controls.js_scrollbars.init(this, {suppressScrollX: true});
			});
		},

		show_reset_buttons: function () {
			$('.filter_new .fil').each(function () {
				$(this).find('.empty').toggleClass('empty_act', $(this).find('input:checked').length != 0 || $(this).find('input.datepick').filter(function () {
					return this.value != "";
				}).length != 0);
			});
		},

		filter_options_by_project_selected: function () {
			if ($('#fil_pst input:checked').length) {
				let p = {};
				$('#fil_pst input:checked').each(function () {
					let arr = $(this).parent().attr('class').replace('p_all', '').replace(/p/g, '').trim().split(' ');
					for (let i = 0; i < arr.length; i++) p[arr[i]] = 1;
				});
				$('.fil_pr .fil_ label, .fil_pr .fil_ div').addClass('flt_h1');
				$('.tagsAdvFilterSelect-status, .tagsAdvFilterSelect-label').find('label').not('.p_all').addClass('flt_h1').parent().addClass('flt_h1').parent().addClass('flt_h1');
				for (let i in p) {
					$('.fil_pr .fil_ .p' + i).removeClass('flt_h1').parent().removeClass('flt_h1').parent().removeClass('flt_h1').prev().removeClass('flt_h1');
					$('.tagsAdvFilterSelect-status, .tagsAdvFilterSelect-label').find('.p' + i).removeClass('flt_h1').parent().removeClass('flt_h1').parent().removeClass('flt_h1');
				}
			} else if ($('#fil_ptg input:checked').length) {
				let p = {};
				$('#fil_ptg input:checked').each(function () {
					let arr = $(this).parent().attr('class').replace('p_all', '').replace(/p/g, '').trim().split(' ');
					for (let i = 0; i < arr.length; i++) p[arr[i]] = 1;
				});
				$('.fil_pr .fil_ label, .fil_pr .fil_ div').addClass('flt_h1');
				$('.tagsAdvFilterSelect-status, .tagsAdvFilterSelect-label').find('label').not('.p_all').addClass('flt_h1').parent().addClass('flt_h1').parent().addClass('flt_h1');
				for (let i in p) {
					$('.fil_pr .fil_ .p' + i).removeClass('flt_h1').parent().removeClass('flt_h1').parent().removeClass('flt_h1').prev().removeClass('flt_h1');
					$('.tagsAdvFilterSelect-status, .tagsAdvFilterSelect-label').find('.p' + i).removeClass('flt_h1').parent().removeClass('flt_h1').parent().removeClass('flt_h1');
				}
			} else if ($('#fil_pr input:checked').length) {
				$('.fil_pr .fil_ label, .fil_pr .fil_ div').addClass('flt_h1');
				$('.tagsAdvFilterSelect-status, .tagsAdvFilterSelect-label').find('label').not('.p_all').addClass('flt_h1').parent().addClass('flt_h1').parent().addClass('flt_h1');
				$('#fil_pr label.tl input:checked').each(function () {
					$(this).parent().next().find('input').each(function () {
						$('.fil_pr .fil_ .p' + this.value).removeClass('flt_h1').parent().removeClass('flt_h1').parent().removeClass('flt_h1').prev().removeClass('flt_h1');
						$('.tagsAdvFilterSelect-status, .tagsAdvFilterSelect-label').find('.p' + this.value).removeClass('flt_h1').parent().removeClass('flt_h1').parent().removeClass('flt_h1');
					});
				});
				$('#fil_pr div input:checked').each(function () {
					$('.fil_pr .fil_ .p' + this.value).removeClass('flt_h1').parent().removeClass('flt_h1').parent().removeClass('flt_h1').prev().removeClass('flt_h1');
					$('.tagsAdvFilterSelect-status, .tagsAdvFilterSelect-label').find('.p' + this.value).removeClass('flt_h1').parent().removeClass('flt_h1').parent().removeClass('flt_h1');
				});
			} else {
				$('.fil_pr .fil_ label, .fil_pr .fil_ div').removeClass('flt_h1');
				$('.tagsAdvFilterSelect-status, .tagsAdvFilterSelect-label').find('label').not('.p_all').removeClass('flt_h1').parent().removeClass('flt_h1').parent().removeClass('flt_h1');
			}
		},

		helper_project_tab(selector) {
			$('.filter_new .fil-withTabs').hide().find('.empty').click();
			$('.filter_new .fil').filter(selector).show();
		},

		is_shown: function () {
			return self.shown;
		},

		container_swipe: {
			x: -1,
			y: -1,
			type: -1,
			timeout: null,

			init: function () {
				$('#filter_more').bind('mousedown.page touchstart.page', function (e) {
					if (e.which != 1 && e.type != 'touchstart') return true;
					let touch = e;
					if (e.type == 'touchstart') {
						touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
					}
					self.container_swipe.x = touch.screenX;
					self.container_swipe.y = touch.screenY;
					self.container_swipe.type = 1;
				}).bind('mousemove.page touchmove.page', function (e) {
					if (self.container_swipe.type === -1) return;
					let touch = e;
					if (e.type == 'touchmove') touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
					if (Math.abs(self.container_swipe.x - touch.screenX) < 10) return true;
					if (self.container_swipe.x != touch.screenX) $('#filter_more .filter_new').scrollLeft($('#filter_more .filter_new').scrollLeft() + 4 * (self.container_swipe.x - touch.screenX));

					self.container_swipe.x = touch.screenX;
					self.container_swipe.y = touch.screenY;
					App.helper.selection.clear();
					App.state.drag.start();
				}).bind('click.page mouseup.page touchend.page', function () {
					if (self.container_swipe.timeout) clearTimeout(self.container_swipe.timeout);
					if (self.container_swipe.type === -1) return;
					self.container_swipe.x = -1;
					self.container_swipe.y = -1;
					self.container_swipe.type = -1;
					setTimeout(App.state.drag.stop, 100);
				});
			},

			onend: function () {
			}
		},

		validate: function(form) {
			let error = false;
			$(form).find('input.datepick').each(function () {
				if (this.value && !/^\d+\.\d+\.\d+$/.test(this.value)) {
					if (!error) $(this).focus();
					$(this).blink();
					error = true;
				}
			});
			if ($('.filter_new .ft1 input:checked').length == 0) {
				$('.filter_new .ft1 input').prop('checked', true).parent().addClass('act');
			}

			return !error;
		},

		submit: function(form) {
			if (self.validate(form)) App.controls.views.save_filter_advanced($(form).serialize(), true);
		},

		onload: function() {
			$('body').removeClass('withAdvancedFilter');
			if ($('.filter_new').length) {
				this.init();
			}
		},

		onLoadPage: function() {
			self.onload();
		}
	};
})();

;(function () {
	let self = App.foreground_message = {
		time_left: 0,
		container: null,
		is_shown: false,
		default_icon: 'notifications_alt',
		cron: null,
		current_url: null,
		el: null,
		progress: {
			el: null,
			size: 0,
			init: function (el, size) {
				self.progress.el = el;
				self.progress.size = size;
			},
			set_left: function (val) {
				if (self.progress.el == null) return;

				let width = val/self.progress.size*100;
				if (width < 1) width = 0;

				self.progress.el.css('width', width + '%');
			}
		},
		add: function (body) {

		},
		show: function (params) {
			let title = params.title || '', body = params.body || '', icon = params.icon ?? self.default_icon;

			if (self.el) self.el.remove();
			self.el = self.create_el();

			self.time_left = 9;
			self.current_url = params.url;
			self.is_shown = true;
			self.el.css('animation', 'none').html(
				(icon ? `<div class="icon"><ws-icon name="${icon}"></ws-icon></div>` : '')
				+ `<div class="in flex_content"><div class="title">${title}</div><div class="body">${body}</div></div>`
				+ `<div class="progress" style="width: 100%"></div>`
			);

			self.progress.init(self.el.find('.progress'), self.time_left);
			self.cron.add(self.on_tick);

			if (App.hybrid_app) App.haptics.notification();

			self.animate_show();
		},
		animate_show: App.helper.debounce(function () {
			if (self.el.hasClass('shown')) {
				self.el.css('animation', 'ws-pulse .5s ease normal both');
				self.progress.set_left(self.time_left-1);
			} else {
				self.el.addClass('shown');
				self.progress.set_left(self.time_left-1);
			}
		}, 99),
		hide: function () {
			self.cron.remove();
			self.el.removeClass('shown');
			self.is_shown = false;
			self.el = null;
		},
		on_click: function () {
			self.hide();
			if (self.current_url) App.core.goto(self.current_url);
			self.current_url = null;
		},
		on_tick: function () {
			if (self.time_left <= 0) return self.hide();

			self.time_left--;
			if (self.time_left > 0) self.progress.set_left(self.time_left-1);
		},
		create_el: function () {
			let el = $('.foreground-message');

			if (el.length === 0) {
				el = $('<div />').addClass('foreground-message').on('mouseover', self.cron.pause).on('mouseleave', self.cron.resume).on('click touchstart', self.on_click);
				el.appendTo('#fixed_container');
			}

			return el;
		},
		onBoot: function () {
			self.cron = App.helper.cron.create('foreground_message', 1);

			App.bus.app.on('notification', function (payload) {
				if (App.core.is_active()) self.show({
					title: payload.title,
					body: payload.body,
					url: payload.url || null
				});
			});
		}
	};
})();

;var App = App || {};

const DATE_EDIT_SHORT = 32;
const DATE_EDIT_LONG = 33;
const DATE_DEFAULT = 1;
const DATE_MINI = 55;
const DATE_COMPACT = 50;
const DATE_INPUT = 60;
const DATE_MONTH = 61;
const DATE_SCHEDULE_COMPACT = 54;
const DATE_FULL = 57;
const DATE_DASHBOARD_HEADER = 58;
const DATE_WEEK = 59;
const DATE_YEAR = 63;
const DATE_LAST_ACTIVITY = 64;
const DATE_LAST_ACTIVITY_NO_TIME = 65;
const DATE_CHAT = 56;
const DATE_TIME_ONLY = 66;
const DATE_SCHEDULE_HEADER = 67; // TODO: PHP-only (task_schedule thead), port formatter if JS starts assembling this string
const QTY_WITH_TEXT = true;

const USR_FF = 2;
const USR_LL = 3;
const USR_LL_F = 1;
const USR_LET = 5;
const USR_FF_LL = 10;
const USR_LL_FF = 11;
const USR_BFF_LL = 6;
const USR_SFF_BLL = 12;
const USR_BLL_SFF = 13;
const USR_SFF_BLL_TRUNC = 14;
const USR_BLL_SFF_TRUNC = 15;
const USR_FORCE_FULL = 20;

App.format = {

	quantity: function (q, modifier, add_number) {
		let x = modifier.split('|');
		let y = add_number ? q + ' ' : '';
		if (q % 100 >= 11 && q % 100 <= 20) {
			return y + x[2];
		}
		switch (q % 10) {
			case 1:
				return y + x[0];
			case 2:
			case 3:
			case 4:
				return y + x[1];
			default:
				return y + x[2];
		}
	},

	digits_2: function (s) {
		s = s.toString();
		if (s.length < 2) return '0' + s; else return '' + s;
	},

	digits_n: function (s, n) {
		s = s.toString();
		while (s.length < n) s = '0' + s;
		return s;
	},

	time_to_HHMMSS: function (sec) {
		let sec_num = parseInt(sec, 10);
		let hours = Math.floor(sec_num / 3600);
		let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
		let seconds = sec_num - (hours*3600 + minutes*60);

		if (hours < 10) hours = "0" + hours;
		if (minutes < 10) minutes = "0" + minutes;
		if (seconds < 10) seconds = "0" + seconds;

		return hours + ':' + minutes + ':' + seconds;
	},

	time_to_HHMM: function (sec) {
		let sec_num = parseInt(sec, 10);
		let hours = Math.floor(sec_num / 3600);
		let minutes = Math.floor((sec_num - (hours * 3600)) / 60);

		if (hours < 10) {
			hours = "0" + hours;
		}
		if (minutes < 10) {
			minutes = "0" + minutes;
		}
		return hours + ':' + minutes;
	},

	time_to_MMSS: function (sec) {
		if (sec % 60 < 10) {
			return parseInt(sec / 60) + ':0' + (sec % 60);
		} else {
			return parseInt(sec / 60) + ':' + (sec % 60);
		}
	},

	HHMM_to_time: function (timeStr) {
		if (!timeStr || !timeStr.includes(':')) return null;
		let [hours, minutes] = timeStr.split(':').map(Number);
		if (isNaN(hours) || isNaN(minutes) || hours < 0 || minutes < 0 || minutes >= 60) return null;
		return (hours * 3600) + (minutes * 60);
	},

	no_zero: function (cnt) {
		return cnt ? cnt : '';
	},

	get_month_name_long: function (month_index) {
		month_index = month_index instanceof Date ? month_index.getMonth() : month_index;
		return App.object_state.locale.month.long[month_index] || '';
	},
	get_month_name_short: function (month_index) {
		month_index = month_index instanceof Date ? month_index.getMonth() : month_index;
		return App.object_state.locale.month.short[month_index] || '';
	},

	should_capitalize_month: function () {
		return ['en','de'].includes(App.config.locale);
	},
	month_name_full: function (month_index) {
		month_index = month_index instanceof Date ? month_index.getMonth() : month_index;
		let str = $.datepicker._defaults.monthNamesL[month_index] || $.datepicker._defaults.monthNames[month_index] || App.format.get_month_name_long(month_index) || '';

		return App.format.should_capitalize_month() ? str.charAt(0).toUpperCase() + str.slice(1) : str.toLowerCase();
	},
	month_name_short: function (month_index) {
		month_index = month_index instanceof Date ? month_index.getMonth() : month_index;
		let str = $.datepicker._defaults.monthNamesShort[month_index] || '';

		return App.format.should_capitalize_month() ? str.charAt(0).toUpperCase() + str.slice(1) : str.toLowerCase();
	},

	day_name_full: function (day_index) {
		day_index = day_index instanceof Date ? day_index.getDay() : day_index;
		return $.datepicker._defaults.dayNames[day_index] || '';
	},
	day_name_short: function (day_index) {
		day_index = day_index instanceof Date ? day_index.getDay() : day_index;
		return $.datepicker._defaults.dayNamesMin[day_index] || '';
	},

	date: function (dt, fmt) {
		let self = App.format, this_year = (new Date()).getFullYear() === dt.getFullYear(), lang = App.config.locale;

		switch (fmt) {

			case DATE_INPUT:
				return App.helper.date.to_input(dt);
				break;

			case DATE_FULL:

				if (lang === 'en') return self.month_name_full(dt) + ' ' + dt.getDate() + ', ' + dt.getFullYear();
				if (lang === 'de') return dt.getDate() + '. ' + self.month_name_full(dt) + ' ' + dt.getFullYear();
				if (lang === 'kk') return dt.getFullYear() + ' жылғы ' + dt.getDate() + ' ' + self.month_name_full(dt);

				return dt.getDate() + ' ' + self.month_name_full(dt).toLowerCase() + ' ' + dt.getFullYear();

			case DATE_DEFAULT:
				return this_year ? dt.getDate() + ' ' + self.month_name_full(dt) : dt.getDate() + ' ' + self.month_name_short(dt) + ' ' + dt.getFullYear();

			case DATE_MONTH:
				return this_year ? self.get_month_name_long(dt) : self.get_month_name_long(dt) + ' ' + dt.getFullYear();

			case DATE_MINI:
				return dt.getDate() + ' ' + self.month_name_short(dt) + self.year_if_needed(dt);

			case DATE_CHAT:
				if (dt.getTime() >= App.helper.date.today().getTime())
					return self.time(Math.floor((dt.getTime() - App.helper.date.today().getTime())/60000));

				if (dt.getTime()/1000 >= App.helper.customDate.get('week')) return self.day_name_short(dt);

				return dt.getDate() + ' ' + self.month_name_short(dt) + self.year_if_needed(dt);

			case DATE_WEEK:
				return self.day_name_full(dt);

			case DATE_YEAR:
				return dt.getFullYear();

			case DATE_EDIT_SHORT:
				return '<font class="w360">' + self.day_name_short(dt) + ' </font><b>' + dt.getDate() + ' ' + self.month_name_short(dt) + '</b>' + self.year_if_needed(dt);

			case DATE_EDIT_LONG:
				return '<font class="w360">' + self.day_name_full(dt) + ' </font><b>' + dt.getDate() + ' ' + self.month_name_full(dt) + '</b>' + self.year_if_needed(dt);

			case DATE_COMPACT:
				if (dt.getTime() >= App.helper.date.today().getTime()) return App.object_state.locale.today;
				if (dt.getTime() >= App.helper.date.today().getTime() - 86400 * 1000) return App.object_state.locale.yesterday;
				return dt.getDate() + ' ' + self.month_name_short(dt) + self.year_if_needed(dt);

			case DATE_SCHEDULE_COMPACT:
				let res = '';
				if (dt.getTime() >= App.helper.date.today().getTime() + 3 * 86400 * 1000) {}
				else if (dt.getTime() >= App.helper.date.today().getTime() + 2 * 86400 * 1000) res = App.object_state.locale.day_after_tomorrow;
				else if (dt.getTime() >= App.helper.date.today().getTime() + 86400 * 1000) res = App.object_state.locale.tomorrow;
				else if (dt.getTime() >= App.helper.date.today().getTime()) res = App.object_state.locale.today;
				else if (dt.getTime() >= App.helper.date.today().getTime() - 86400 * 1000) res = App.object_state.locale.yesterday;
				if (res) return res;
				return dt.getDate() + ' ' + self.month_name_short(dt) + self.year_if_needed(dt);

			case DATE_DASHBOARD_HEADER:
				{
					const my_formatter = function (dt) {
					// Отримання скороченого імені дня тижня (наприклад, Sun, Mon, Tue, ...)
					const dayOfWeek = App.object_state.locale.day['long'][dt.getDay()];
					const dayOfMonth = dt.getDate(); // День місяця
					const month = App.format.month_name_full(dt); // Повне ім'я місяця
					const timeString = App.helper.date.to_format(dt, App.config.is_24h ? 'H:i' : 'g:ia'); // Час у форматі 24/12 годин
					const weekNumber = App.helper.date.get_week_number(dt);

						return dayOfWeek
							+ ' • ' + dayOfMonth + ' ' + month + ' ' + timeString
							+ ' • ' + App.object_state.locale.time_diff.week.split('|')[0] + ' ' + weekNumber;
					};
					return my_formatter(dt);
				}

			case DATE_TIME_ONLY:
				return App.helper.date.to_format(dt, App.config.is_24h ? 'H:i' : 'g:ia');

			case DATE_LAST_ACTIVITY:
			case DATE_LAST_ACTIVITY_NO_TIME:
				{
					const my_formatter = function (dt, with_time) {
						// Отримання скороченого імені дня тижня (наприклад, Sun, Mon, Tue, ...)
						const dayOfWeekShort = App.object_state.locale.day['short'][dt.getDay()];
						const dayOfMonth = dt.getDate(); // День місяця
						const month = self.month_name_short(dt); // Скорочене ім'я місяця
						const yearIfNeeded = self.year_if_needed(dt); // Рік, якщо не поточний
						const timeString = with_time ? App.helper.date.to_format(dt, App.config.is_24h ? 'H:i' : 'g:ia') : ''; // Час у форматі 24/12 годин

						return dayOfWeekShort
							+ ' ' + dayOfMonth + ' ' + month
							+ yearIfNeeded
							+ ' ' + timeString;
					};
					return my_formatter(dt, fmt === DATE_LAST_ACTIVITY);
				}

			default:
				return Math.floor(dt.getDate() / 1000); // PHP timestamp
		}
	},

	year_if_needed: function(dt) {
		return (new Date()).getFullYear() === dt.getFullYear() ? '' : ' ' + dt.getFullYear();
	},

	timer_seconds: function(seconds)
	{
		return Math.floor(seconds/3600) + ':' + App.format.digits_2(Math.floor(seconds/60)%60) + '<i>:' + App.format.digits_2(seconds%60) + '</i>';
	},

	timer_minutes: function(minutes)
	{
		minutes = Math.round(minutes);
		return App.format.digits_2(Math.floor(minutes/60)) + ':' + App.format.digits_2(minutes%60);
	},

	compact_number: function (num) {
		const formatter = new Intl.NumberFormat(App.config.locale, {
			notation: 'compact',
			compactDisplay: 'short',
		});

		return formatter.format(num);
	},

	// TODO: ref from minutes to seconds
	time: function (minutes, ignore, compact_number) {
		if (!minutes && !ignore) return '—';
		minutes = Math.round(minutes);
		let hours = Math.floor(minutes / 60);
		if (compact_number && hours > 1000) return App.format.compact_number(hours);
		return hours + ':' + App.format.digits_2(minutes % 60);
	},

	// TODO: ref from cents to dollars
	money: function (cents, ignore, split, compact_number, force_cents) {
		if (!cents && !ignore) return '—';
		cents = cents / 100;
		if (!cents) return '0';

		if (compact_number && cents > 1000) return App.format.compact_number(cents);

		if (Math.round(cents) === Number(cents)) return Math.round(cents).toFixed(force_cents ? 2 : 0)

		let output = cents.toFixed(2);
		if (split && output.toString().includes('.')) {
			if (typeof split === 'string' && split === 'small') {
				output = output.toString().substring(0, output.toString().indexOf('.')) + '<small>' + output.toString().substring(output.toString().indexOf('.')) + '</small>';
			} else {
				output = output.toString().substring(0, output.toString().indexOf('.')) + '<span class="cents">' + output.toString().substring(output.toString().indexOf('.')) + '</span>';
			}
		}
		return output;
	},
	money_spaced(cents, ignore) {
		let money_str = App.format.money(cents, ignore);
		if (money_str === '—') return money_str;
		return money_str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "\u202F");
	},
	compact_time: function (minutes, ignore) {
		return App.format.time(minutes, ignore, true);
	},

	compact_money: function(cents, ignore, split) {
		return App.format.money(cents, ignore, split, true);
	},

	money_abbr: function (num, ignore) {
		if (num >= 1000) {
			if (num >= 1000000) {
				return parseFloat((num / 1000000).toFixed(2)) + 'M';
			} else if (num >= 1000) {
				return parseFloat((num / 1000).toFixed(1)) + 'K';
			}
		} else {
			num = App.format.money(num*100, ignore);
		}
		return num;
	},

	term_time: function(i) {
		i += App.config.date_offset_user_hrs * 4;
		let d1 = Math.floor(i / 4);
		let d2 = 15 * (i % 4);
		if (App.config.is_24h) return App.format.digits_2(d1) + ':' + App.format.digits_2(d2);
		if (d1 > 12) return (d1 == 12 ? 12 : d1 - 12) + ':' + App.format.digits_2(d2) + 'pm';
		return (d1 ? d1 : 12) + ':' + App.format.digits_2(d2) + 'am';
	},

	time_diff: function (diff, with_text) {
		if (with_text) with_text = diff < 0 ? 'overdue' : 'remain';
		else with_text = '';
		diff = Math.abs(diff);
		let is_cyrillic = App.config.language === 1 || App.config.language === 4;
		let fem = false;
		let val, format;
		if (diff >= 365 * 86400) {
			val = Math.floor(diff / 86400 / 365);
			format = 'year';
		} else if (diff >= 30 * 86400) {
			val = Math.floor(diff / 86400 / 30);
			format = with_text ? 'month' : 'month_sm';
		} else if (diff >= 14 * 86400) {
			fem = true;
			val = Math.floor(diff / 86400 / 7);
			format = with_text ? 'week' : 'week_sm';
		} else if (diff >= 86400) {
			val = Math.floor(diff / 86400);
			format = 'day';
		} else if (diff > 3600) {
			val = Math.floor(diff / 3600);
			format = 'hour';
		} else {
			fem = true;
			val = Math.floor(diff / 60);
			format = with_text ? 'min' : 'min_sm';
		}
		let add = with_text ? App.object_state.locale.time_diff[fem ? with_text + '_fem' : with_text] : '';
		let result = App.format.quantity(val, App.object_state.locale.time_diff[format], QTY_WITH_TEXT);
		if (add) {
			if (is_cyrillic) result = App.format.quantity(val, add) + ' ' + result;
			else result += ' ' + App.format.quantity(val, add);
		}
		return result;
	},

	time_diff_short: function (diff, days_only) {
		diff = Math.abs(diff);
		if (days_only) return Math.floor(diff / 86400) + '&thinsp;' + App.object_state.locale.time_diff['day_xs'];
		else if (diff >= 365 * 86400) return Math.floor(diff / 86400 / 365) + '&thinsp;' + App.object_state.locale.time_diff['year_xs'];
		else if (diff >= 30 * 86400) return Math.floor(diff / 86400 / 30) + '&thinsp;' + App.object_state.locale.time_diff['month_xs'];
		else if (diff >= 14 * 86400)  return Math.floor(diff / 86400 / 7) + '&thinsp;' + App.object_state.locale.time_diff['week_xs'];
		else if (diff >= 86400) return Math.floor(diff / 86400) + '&thinsp;' + App.object_state.locale.time_diff['day_xs'];
		else if (diff > 3600) return Math.floor(diff / 3600) + '&thinsp;' + App.object_state.locale.time_diff['hour_xs'];
		else if (diff < 3600 && diff > 60) return Math.floor(diff / 60) + '&thinsp;' + App.object_state.locale.time_diff['min_xs'];
		else return '';
	},

	time_diff_supershort: function (diff, days_only) {
		diff = Math.abs(diff);
		if (days_only) return Math.floor(diff / 86400) + App.object_state.locale.time_diff['day_xs'].charAt(0).toUpperCase();
		else if (diff >= 365 * 86400) return Math.floor(diff / 86400 / 365) + App.object_state.locale.time_diff['year_xs'].charAt(0).toUpperCase();
		else if (diff >= 30 * 86400) return Math.floor(diff / 86400 / 30) + App.object_state.locale.time_diff['month_xs'].charAt(0).toUpperCase();
		else if (diff >= 14 * 86400)  return Math.floor(diff / 86400 / 7) + App.object_state.locale.time_diff['week_xs'].charAt(0).toUpperCase();
		else if (diff >= 86400) return Math.floor(diff / 86400) + App.object_state.locale.time_diff['day_xs'].charAt(0).toUpperCase();
		else if (diff > 3600) return Math.floor(diff / 3600) + App.object_state.locale.time_diff['hour_xs'].charAt(0).toLowerCase();
		else if (diff < 3600 && diff > 60) return Math.floor(diff / 60) + App.object_state.locale.time_diff['min_xs'].charAt(0).toLowerCase();
		else return '';
	},

	terms_from_inputs_data: function(data) {
		let dt_end = data.dateend instanceof Date ? data.dateend : App.helper.date.from_input(data.dateend);
		let str = App.format.date(dt_end, DATE_MINI);
		if (data.datestart && data.dateend) {
			if (data.dateend !== data.datestart) {
				let dt_start = data.datestart instanceof Date ? data.datestart : App.helper.date.from_input(data.datestart);
				if (dt_start.getFullYear() !== dt_end.getFullYear()) {
					str = App.format.date(dt_start, DATE_MINI) + ' &mdash; ' + str;
				} else if (dt_start.getMonth() !== dt_end.getMonth() || data.timeend) {
					str = dt_start.getDate() + ' ' + $.datepicker._defaults.monthNamesShort[dt_start.getMonth()] + ' &mdash; ' + str;
				} else {
					str = dt_start.getDate() + ' &mdash; ' + str;
				}
			} else if (data.timestart) {
				str += ' ' + data.timestart + ' &mdash;';
			}
		}
		if (data.timeend) str += ' ' + data.timeend;
		return str;
	},

	terms_from_range: function(range) {
		if (range == null) return '';

		return this.terms_from_inputs_data({
			datestart: range.start,
			dateend: range.end,
		});
	},

	user_name: function (params, format) {
		let is_names = true;
		if (!params.fname && !params.lname) is_names = false;

		if (!is_names && format != USR_LET && format != USR_BFF_LL && format != USR_FORCE_FULL) return params.login;

		switch (parseInt(format)) {
			case USR_LL_F:
				if (!params.fname) return params.lname;
				if (!params.lname) return params.fname;
				return params.lname + ' ' + params.fname.substring(0, 1) + '.';

			case USR_FF:
				return params.fname;

			case USR_LL:
				return params.lname;

			case USR_FF_LL:
				return (params.fname + ' ' + params.lname).trim();

			case USR_LL_FF:
				return (params.lname + ' ' + params.fname).trim();

			case USR_LET:
				if (!is_names) return params.login.substring(0, 2);
				if (!params.fname) return params.lname.substring(0, 2);
				if (!params.lname) return params.fname.substring(0, 2);
				if (App.config.reverse_user_names) return params.lname.substring(0, 1).params.fname.substring(0, 1);
				return params.fname.substring(0, 1).params.lname.substring(0, 1);
			case USR_BFF_LL:
				if (!is_names) return '<b>' + App.helper.html.encode(params.login, {encode_ampersands: true}) + '</b>';
				if (!params.fname) return '<b>' + App.helper.html.encode(params.lname, {encode_ampersands: true}) + '</b>';
				if (!params.lname) return '<b>' + App.helper.html.encode(params.fname, {encode_ampersands: true}) + '</b>';
				if (App.config.reverse_user_names) return '<b>' + App.helper.html.encode(params.lname, {encode_ampersands: true}) + '</b> ' + App.helper.html.encode(params.fname, {encode_ampersands: true});
				return '<b>' + App.helper.html.encode(params.fname, {encode_ampersands: true}) + '</b> ' + App.helper.html.encode(params.lname, {encode_ampersands: true});
			case USR_SFF_BLL:
				if (!params.fname) return App.helper.html.encode(params.lname, {encode_ampersands: true});
				if (!params.lname) return App.helper.html.encode(params.fname, {encode_ampersands: true});
				return '<span>' + App.helper.html.encode(params.fname, {encode_ampersands: true}) + ' </span><b>' + App.helper.html.encode(params.lname, {encode_ampersands: true}) + ' </b>';
			case USR_BLL_SFF:
				if (!params.fname) return App.helper.html.encode(params.lname, {encode_ampersands: true});
				if (!params.lname) return App.helper.html.encode(params.fname, {encode_ampersands: true});
				return '<b>' + App.helper.html.encode(params.lname, {encode_ampersands: true}) + ' </b><span>' + App.helper.html.encode(params.fname, {encode_ampersands: true}) + ' </span>';
			case USR_SFF_BLL_TRUNC:
				if (!params.fname) return App.helper.html.encode(App.helper.string.truncate(params.lname, 20), {encode_ampersands: true});
				if (!params.lname) return App.helper.html.encode(App.helper.string.truncate(params.fname, 20), {encode_ampersands: true});
				return '<span>' + App.helper.html.encode(App.helper.string.truncate(params.fname, 20), {encode_ampersands: true}) + ' </span><b>' + App.helper.html.encode(App.helper.string.truncate(params.lname, 20), {encode_ampersands: true}) + ' </b>';
			case USR_BLL_SFF_TRUNC:
				if (!params.fname) return App.helper.html.encode(App.helper.string.truncate(params.lname, 20), {encode_ampersands: true});
				if (!params.lname) return App.helper.html.encode(App.helper.string.truncate(params.fname, 20), {encode_ampersands: true});
				return '<b>' + App.helper.html.encode(App.helper.string.truncate(params.lname, 20), {encode_ampersands: true}) + ' </b><span>' + App.helper.html.encode(App.helper.string.truncate(params.fname, 20), {encode_ampersands: true}) + ' </span>';
		}

		return App.config.reverse_user_names ? (params.lname + ' ' + params.fname).trim() : (params.fname + ' ' + params.lname).trim();
	},

	costs_progress_hint: function(type, used, max, real_label, max_label) {
		if (!used || !max) return '';
		let progress = Math.floor(100 * used / max);
		let hint_color = progress > 100 ? 'R' : (type === 'time' ? 'TI' : 'MO');
		if (!max_label) {
			max_label = App.object_state.locale['s_of_s'].replace('%s', '').replace('%s',
				type === 'time'
					? App.format.quantity(Math.round(max), App.object_state.locale['hrs'], QTY_WITH_TEXT)
					: Math.round(max)
			).trim();
		}
		if (type === 'time') {
			return '%B%' + hint_color + progress + '%' + hint_color + '%B%%G — G%' + (real_label || App.format.time(60 * used, true)) + ' %G' + max_label + 'G%';
		}
		let used_label = real_label != null && real_label !== '' ? real_label : (Math.round(used * 100) / 100);
		let currency = App.object_state.locale['currency'] ? ' ' + App.object_state.locale['currency'] : '';
		return '%B%' + hint_color + progress + '%' + hint_color + '%B%%G — G%' + used_label + ' %G' + max_label + currency + 'G%';
	},

	month_range: function(a, b, separator) {
		const self = App.format;
		separator||= ' - ';
		const min = a instanceof Date ? a : new Date((a + App.config.date_timezone_offset) * 1000);
		const max = a instanceof Date ? b : new Date((b + App.config.date_timezone_offset) * 1000);
		const is_same_y = min.getFullYear() === max.getFullYear();
		const is_same_ym = is_same_y && min.getMonth() === max.getMonth();
		const month_fmt = App.device.is_lg_width() ? self.get_month_name_long : self.get_month_name_short;

		if (is_same_ym) return month_fmt(min) + self.year_if_needed(min);
		if (is_same_y) return month_fmt(min) + separator + month_fmt(max) + self.year_if_needed(min);

		if (Math.abs(min.getFullYear() - max.getFullYear()) > 2) return min.getFullYear() + separator + max.getFullYear();

		return month_fmt(min) + self.year_if_needed(min) + separator + month_fmt(max) + self.year_if_needed(max);
	}
}

;var App = App || {};

App.forms = {

	init_itm_inputs: function () {
		$('.itm input[type=text], .itm input[type=password]').not('.ws_init').addClass('ws_init').bind('focus', function () {
			$(this).next().hide();
		}).bind('blur', function () {
			$(this).next().show();
		}).next().bind('click', function () {
			$(this).prev().trigger('focus');
		});
	},

	init_setup_forms: function () {
		$('.form_wbutton').not('.ws_init_wb').addClass('ws_init_wb').each(function () {
			$(this).find('input[type=text], input[type=password], textarea').bind('keyup', function () {
				$(this.form).addClass('form_active').find('.button_dis').removeClass('button_dis').toggleDisabled(false);
			});
			$(this).find('input[type=checkbox], input[type=radio]').bind('click', function () {
				$(this.form).addClass('form_active').find('.button_dis').removeClass('button_dis').toggleDisabled(false);
			});
			$(this).find('select').bind('change', function () {
				$(this.form).addClass('form_active').find('.button_dis').removeClass('button_dis').toggleDisabled(false);
			});
		});
	},

	check_defaults: function (frm) {
		let form_default = true;

		if (!frm || !frm.elements) {
			console.load('wrong form');
			return false;
		}

		$(frm).find('input[type=checkbox], input[type=radio]').each(function () {
			if ($(this).attr('data-checked')) {
				if (
					($(this).attr('data-checked') === 'yes' && !this.checked) ||
					($(this).attr('data-checked') !== 'yes' && this.checked)
				) form_default = false;
			}
		});
		$(frm).find('[data-class]').each(function () {
			if ($(this).attr('class') !== $(this).attr('data-class')) form_default = false;
		});
		if ($(frm).find('.eye_line a.def').not('.act').length) form_default = false;
		// deprecated user <ws-slider ... data-def=""> instead
		if ($(frm).find('ws-slider a.def').not('.act').length) form_default = false;
		$(frm).find('[data-def]').each(function () {
			if ($(this).val().toString() !== $(this).attr('data-def').toString()) form_default = false;
		});
		$(frm).find('[data-stored]').each(function () {
			if ($(this).html() !== $(this).attr('data-stored')) form_default = false;
		});

		return form_default;
	},

	validate_form: function (frm, arr, mes) {
		if (!frm || !frm.elements) {
			console.load('wrong form');
			return false;
		}
		el = null;
		err = '';
		let j = '';
		let m = '';
		for (let i in arr) {
			j = '';
			m = arr[i];
			if (/^([a-zA-Z01-9_]+)\|([a-zA-Z01-9_]+)$/.test(i)) {
				i = RegExp.$1;
				j = RegExp.$2;
			}
			if (frm.elements[i])
				switch (frm.elements[i].type) {
					case 'text':
					case 'textarea':
					case 'password':
					case 'hidden':
					case 'file':
						if ((!/\S/.test(frm.elements[i].value) || frm.elements[i].value === '0') && (!j || frm.elements[j].value === '' || frm.elements[j].value === '0')) {
							if (!el) el = frm.elements[i];
							err += m + "\n";
							$(el).addClass('input_error').bind('keyup.error', function () {
								$(this).removeClass('input_error');
								$(this).unbind('keyup.error');
							});
						} else if ((i === 'email') && (!App.helper.validate.email.test(frm.elements[i].value))) {
							if (!el) el = frm.elements[i];
							err += m + ' | Формат: email@somethere.org' + "\n";
							$(el).addClass('input_error').bind('keyup.error', function () {
								$(this).removeClass('input_error');
								$(this).unbind('keyup.error');
							});
						}
						break;
					case 'select-one':
						if ((frm.elements[i].value === '' || frm.elements[i].value === '0') && (!j || frm.elements[j].value === '' || frm.elements[j].value === '0')) {
							if (!el) el = frm.elements[i];
							err += m + "\n";
							$(el).addClass('input_error').bind('change.error', function () {
								$(this).removeClass('input_error');
								$(this).unbind('change.error');
							});
						}
						break;
				}
		}
		if (err === '') {
			// App.forms.disable_form(frm);
			return true;
		} else {
			try {
				el.focus();
			} catch (e) {
			}
			if (!App.modal.is_shown()) $(window).scrollTop($(el).offset().top - 120);
			return false;
		}
	},

	disable_form: function (frm) {
		frm.onsubmit = function () {
			return false;
		}
		App.draft.unbind();
	},

	onLoadPage: function () {
		this.init_itm_inputs();
		this.init_setup_forms();
	}
};

;var App = App || {};

(function () {
	let self = App.guide_tour = {

		_state: {
			el: null,
			prev: null,
		},

		_tour: null,
		_bindOnce: false,

		_wait: {
			timer: null,
			token: 0
		},

		_action: {
			on: false,
			token: 0,
			type: '',
			el: null,
			captureHandler: null,
		},

		// ------------------------------
		// watch modal/menu close -> hide hint
		// ------------------------------
		_mmWatch: {
			timer: null,
			hadModal: false,
			hadMenu: false,

			// контекст на момент показу хінта
			inModal: false,
			onMenu: false,
		},

		// ------------------------------
		// tuning
		// ------------------------------
		_WAIT_TIMEOUT: 30000,
		_WAIT_INTERVAL: 150,

		_isModalShown: function () {
			try {
				return App.modal && typeof App.modal.is_shown === 'function' && App.modal.is_shown() === true;
			} catch (e) {}
			return false;
		},

		_isMenuShown: function () {
			try {
				return App.menu && typeof App.menu.is_shown === 'function' && App.menu.is_shown() === true;
			} catch (e) {}
			return false;
		},

		_isElInsideMenu: function (el) {
			el = self._resolveEl(el);
			if (!el) return false;
			try {
				return $(el).closest('.menu').length > 0;
			} catch (e) {}
			return false;
		},

		_mmWatchStop: function () {
			if (self._mmWatch.timer) {
				clearInterval(self._mmWatch.timer);
				self._mmWatch.timer = null;
			}
			self._mmWatch.hadModal = false;
			self._mmWatch.hadMenu = false;
			self._mmWatch.inModal = false;
			self._mmWatch.onMenu = false;
		},

		_mmWatchStart: function () {
			if (self._mmWatch.timer) {
				clearInterval(self._mmWatch.timer);
				self._mmWatch.timer = null;
			}

			self._mmWatch.hadModal = false;
			self._mmWatch.hadMenu = false;

			self._mmWatch.timer = setInterval(function () {
				if (!self._state.el) {
					self._mmWatchStop();
					return;
				}

				const m = self._isModalShown();
				const n = self._isMenuShown();

				// ---- Case 1: елемент у модалці (в т.ч. може бути в меню всередині модалки)
				if (self._mmWatch.inModal === true) {
					if (m) self._mmWatch.hadModal = true;

					// якщо елемент ще й у меню — стежимо за меню теж
					if (self._mmWatch.onMenu === true) {
						if (n) self._mmWatch.hadMenu = true;

						if (self._mmWatch.hadMenu && !n) {
							self._mmWatchStop();
							self.hint.hide();
							return;
						}
					}

					if (self._mmWatch.hadModal && !m) {
						self._mmWatchStop();
						self.hint.hide();
					}
					return;
				}

				// ---- Case 2: елемент у меню (і точно не в модалці)
				if (self._mmWatch.onMenu === true) {
					if (n) self._mmWatch.hadMenu = true;

					if (self._mmWatch.hadMenu && !n) {
						self._mmWatchStop();
						self.hint.hide();
					}
					return;
				}

				// ---- Case 3: елемент ніде — нічого не робимо
			}, 150);
		},

		// ------------------------------
		// per-step callback_js
		// ------------------------------
		_getCallbackForCurrentStep: function () {
			const t = self._tour;
			if (!t || !t.steps || !t.steps[t.i]) return null;
			const cb = t.steps[t.i].callback_js;
			const s = (cb != null ? String(cb) : '').trim();
			return s ? s : null;
		},

		_runCallbackForCurrentStep: function () {
			const src = self._getCallbackForCurrentStep();
			if (!src) return;

			const looksLikeFn =
				/^\s*function\b/.test(src) ||
				/^\s*\(\s*[^)]*\s*\)\s*=>/.test(src) ||
				/^\s*[^=\s]+\s*=>/.test(src); // x => ...

			try {
				if (looksLikeFn) {
					const fn = (new Function('return (' + src + ');'))();
					if (typeof fn === 'function') {
						fn.call(window);
						return;
					}
				}

				const res = (new Function(src))();
				if (typeof res === 'function') {
					try { res.call(window); } catch (e2) {}
				}
			} catch (e) {
			}
		},

		/**
		 * Обгортка над App.hint
		 */
		hint: {

			show: function (opt) {
				opt = opt || {};

				self._origHide = App.hint.hide;
				App.hint.hide = function () {};

				const el = self._resolveEl(opt.el);
				if (!el) return;

				if (self._state.el && self._state.el !== el) {
					self.hint.hide();
				}

				if (!self._state.el) {
					self._state.el = el;
					self._state.prev = self._snapshot(el);
				}

				$(el).attr('data-title', opt.html != null ? String(opt.html) : '');

				let cfg = (opt.config || '').trim();

				if (opt.dir) {
					cfg = self._stripHintDirs(cfg);
					cfg = (cfg ? cfg + ' ' : '') + String(opt.dir);
				}

				if (opt.arrow === true && cfg.indexOf('arrow') === -1) {
					cfg = (cfg ? cfg + ' ' : '') + 'arrow';
				}
				if (opt.floating === true && cfg.indexOf('float') === -1) {
					cfg = (cfg ? cfg + ' ' : '') + 'float';
				}

				if (opt.color) {
					const c = String(opt.color).trim();
					if (c && cfg.indexOf(c) === -1) {
						cfg = (cfg ? cfg + ' ' : '') + c;
					}
				}

				if (opt.parent) {
					const p = String(opt.parent).trim();
					if (p && cfg.indexOf(p) === -1) {
						cfg = (cfg ? cfg + ' ' : '') + p;
					}
				}

				if (cfg) $(el).attr('data-title-config', cfg);
				else $(el).removeAttr('data-title-config');

				if (opt.offset != null) {
					let off = opt.offset;
					if (typeof off === 'object' && off) {
						const x = Number(off.x || 0);
						const y = Number(off.y || 0);
						off = `${x} ${y}`;
					}
					$(el).attr('data-title-offset', String(off).trim());
				} else {
					$(el).removeAttr('data-title-offset');
				}

				if (opt.delay != null) {
					const d = parseInt(opt.delay, 10);
					if (!isNaN(d) && d >= 0) $(el).attr('data-title-delay', String(d));
				} else {
					$(el).removeAttr('data-title-delay');
				}

				App.hint.el = el;
				App.hint.type = 0;

				try {
					const r = el.getBoundingClientRect();
					App.hint.last_mouse_position.x = Math.round(r.left + r.width / 2);
					App.hint.last_mouse_position.y = Math.round(r.top + r.height / 2);
				} catch (e) {}

				App.hint.show();
				$('#hint').addClass('hint_tour');

				self._mmWatch.inModal = self._isElInsideModal(el);
				self._mmWatch.onMenu = self._isElInsideMenu(el);
				self._mmWatchStart();
			},

			hide: function () {
				self._mmWatchStop();

				if (self._origHide) {
					App.hint.hide = self._origHide;
					self._origHide = null;
				}

				try { App.hint.hide(); } catch (e) {}

				const el = self._state.el;
				const prev = self._state.prev;

				if (el && prev) {
					self._restore(el, prev);
				}

				self._state.el = null;
				self._state.prev = null;
			},
		},

		// ------------------------------
		// UI template
		// ------------------------------

		_ui: {
			_dotsHtml: function (count, activeIndex) {
				count = Math.max(0, parseInt(count, 10) || 0);
				activeIndex = Math.max(0, parseInt(activeIndex, 10) || 0);

				let out = '<div class="hint_dots">';
				for (let i = 0; i < count; i++) {
					const cls = (i <= activeIndex) ? 'dot' : 'dot opa';
					out += '<div class="' + cls + '"></div>';
				}
				out += '</div>';
				return out;
			},

			_html: function (opt) {
				opt = opt || {};
				const title = opt.title != null ? String(opt.title) : '';
				const text = opt.text != null ? String(opt.text) : '';

				const dotsCount = opt.dotsCount != null ? opt.dotsCount : 0;
				const dotsIndex = opt.dotsIndex != null ? opt.dotsIndex : 0;

				const btnSkip = opt.btnSkipText != null
					? String(opt.btnSkipText)
					: App.locale_general['guide_tour']['skip'];

				const btnStart = opt.btnStartText != null
					? String(opt.btnStartText)
					: App.locale_general['guide_tour']['start'];

				const showSkip = (opt.showSkip === true);
				const disableNext = (opt.disableNext === true);

				return '' +
					'<div class="hint__html" data-guide-tour="1">' +
					'<div class="hint_close">' +
					'<ws-icon class="js_tour_close" name="close"></ws-icon>' +
					'</div>' +
					'<div class="hint__title">' +
					'<div class="hint__title-in">' + title + '</div>' +
					'</div>' +
					'<div class="hint_gap"></div>' +
					'<div class="hint__text">' + text + '</div>' +
					'<div class="hint_buttons">' +
					self._ui._dotsHtml(dotsCount, dotsIndex) +
					(showSkip ? '<ws-btn class="js_tour_skip" name="btn btn-28 btn-l btn-fill" text="' + btnSkip + '"></ws-btn>' : '') +
					'<ws-btn class="js_tour_next" name="btn btn-28 btn-l btn-solid" text="' + btnStart + '"' + (disableNext ? ' disabled="disabled"' : '') + '></ws-btn>' +
					'</div>' +
					'</div>';
			}
		},

		// ------------------------------
		// wait helpers (per-step)
		// ------------------------------

		_cancelWait: function () {
			if (self._wait.timer) {
				clearTimeout(self._wait.timer);
				self._wait.timer = null;
			}
			self._wait.token++;
		},

		_isReadyEl: function (el) {
			const domEl = self._resolveEl(el);
			if (!domEl) return null;

			if (!$(domEl).is(':visible')) return null;

			try {
				const r = domEl.getBoundingClientRect();
				if (!r || r.width <= 0 || r.height <= 0) return null;
			} catch (e) {
				return null;
			}

			return domEl;
		},

		_waitForEl: function (el, opt, cb) {
			opt = opt || {};
			const timeout = (opt.timeout != null ? opt.timeout : self._WAIT_TIMEOUT);
			const interval = (opt.interval != null ? opt.interval : self._WAIT_INTERVAL);

			self._cancelWait();

			const token = self._wait.token;
			const started = Date.now();

			const tick = function () {
				if (token !== self._wait.token) return;

				const domEl = self._isReadyEl(el);
				if (domEl) {
					self._wait.timer = null;
					cb(domEl);
					return;
				}

				if (Date.now() - started >= timeout) {
					self._wait.timer = null;
					cb(null);
					return;
				}

				self._wait.timer = setTimeout(tick, interval);
			};

			tick();
		},

		// ------------------------------
		// action helpers (click/input) - CAPTURE phase
		// ------------------------------

		_offAction: function () {
			if (!self._action.on) return;

			try {
				if (self._action.captureHandler) {
					document.removeEventListener('click', self._action.captureHandler, true);
					document.removeEventListener('input', self._action.captureHandler, true);
					document.removeEventListener('change', self._action.captureHandler, true);
				}
			} catch (e) {}

			self._action.on = false;
			self._action.captureHandler = null;
			self._action.type = '';
			self._action.el = null;
		},

		_armActionForStep: function (step, stepEl) {
			self._offAction();

			const t = self._tour;
			if (!t) return;

			const action = (step && step.action != null ? String(step.action).toLowerCase().trim() : '');
			if (!action) return;
			if (action !== 'click' && action !== 'input' && action !== 'watch') return;

			const el = stepEl || self._resolveEl(step.selector);
			if (!el) return;

			const token = ++self._action.token;

			const done = function () {
				if (!self._tour || self._tour.i !== t.i) return;
				if (token !== self._action.token) return;

				setTimeout(function () {
					self.hint.hide();
					self.next();
				}, 0);
			};

			self._action.on = true;
			self._action.type = action;
			self._action.el = el;

			self._action.captureHandler = function (e) {
				if (!self._action.el) return;
				if (e.target !== self._action.el && !self._action.el.contains(e.target)) return;

				if (self._action.type === 'click') {
					if (e.type === 'click') done();
				} else if (self._action.type === 'watch') {
					if (e.type === 'click') done();
				} else if (self._action.type === 'input') {
					if (e.type === 'input' || e.type === 'change') done();
				}
			};

			if (action === 'click' || action === 'watch') {
				document.addEventListener('click', self._action.captureHandler, true);
			} else if (action === 'input') {
				document.addEventListener('input', self._action.captureHandler, true);
				document.addEventListener('change', self._action.captureHandler, true);
			}
		},

		// ------------------------------
		// public API (tour)
		// ------------------------------

		bind: function () {
			if (self._bindOnce) return;
			self._bindOnce = true;

			$(document)
				.on('click', '.js_tour_close', function (e) {
					e.preventDefault();

					self._runCallbackForCurrentStep();

					self.stop();
				})
				.on('click', '.js_tour_skip', function (e) {
					e.preventDefault();

					self._runCallbackForCurrentStep();

					// skip = next without action
					self.hint.hide();
					self.next();
				})
				.on('click', '.js_tour_next', function (e) {
					e.preventDefault();

					self._runCallbackForCurrentStep();

					// якщо disabled — ігноруємо
					if ($(this).is('[disabled]')) return;

					// якщо є action — кнопка виконує її
					const did = self._doActionForCurrentStep();
					if (did) return;

					// інакше просто next
					self.hint.hide();
					self.next();
				});
		},

		_doActionForCurrentStep: function () {
			const t = self._tour;
			if (!t || !t.steps || !t.steps[t.i]) return false;

			const step = t.steps[t.i];
			const action = (step && step.action != null ? String(step.action).toLowerCase().trim() : '');

			if (action === 'click') {
				self.hint.hide();

				const el = self._resolveEl(step.selector);
				if (el) {
					try { el.click(); } catch (e) { try { $(el).trigger('click'); } catch (e2) {} }
					return true;
				}

				self._waitForEl(step.selector, {timeout: self._WAIT_TIMEOUT, interval: self._WAIT_INTERVAL}, function (readyEl) {
					if (!readyEl) { self.stop(); return; }
					try { readyEl.click(); } catch (e) { try { $(readyEl).trigger('click'); } catch (e2) {} }
				});
				return true;
			}

			if (action === 'input') {
				self.hint.hide();

				const el = self._resolveEl(step.selector);
				if (el) {
					try { el.focus(); } catch (e) {}
					return true;
				}

				self._waitForEl(step.selector, {timeout: self._WAIT_TIMEOUT, interval: self._WAIT_INTERVAL}, function (readyEl) {
					if (!readyEl) { self.stop(); return; }
					try { readyEl.focus(); } catch (e) {}
				});
				return true;
			}

			return false;
		},

		_isElInsideModal: function (el) {
			el = self._resolveEl(el);
			if (!el) return false;

			if (!App.modal.is_shown()) return false;

			const $w = $(App.modal.obj_window);
			if (!$w.length) return false;

			if (!$w.closest('html').length) return false;

			return $w.is(el) || $w.has(el).length > 0;
		},

		start: function (data) {
			self.bind();

			if (!data || !data.steps || !data.steps.length) return;

			self._tour = {
				id_flow: data.id_flow || 0,
				steps: data.steps,
				i: 0
			};

			setTimeout(function () {
				if (!self._tour) return;
				self.show_step(0, true);
			}, 1500);
		},

		stop: function () {
			self._cancelWait();
			self._offAction();
			self._mmWatchStop();
			self.hint.hide();
		},

		show_step: function (i, isFirst) {
			i = parseInt(i, 10) || 0;

			const t = self._tour;
			if (!t || !t.steps || !t.steps[i]) return;

			t.i = i;
			const step = t.steps[i];
			const btnText = (isFirst === true)
				? App.locale_general['guide_tour']['start']
				: App.locale_general['guide_tour']['next'];

			self._waitForEl(step.selector, {timeout: self._WAIT_TIMEOUT, interval: self._WAIT_INTERVAL}, function (el) {
				if (!el) {
					self.stop();
					return;
				}

				self._armActionForStep(step, el);

				const isLast = (i === t.steps.length - 1);

				const act = String(step.action || '').toLowerCase().trim();

				self.hint.show({
					el: el,
					html: self._ui._html({
						title: step.title,
						text: step.text,
						disableNext: (act === 'input'),
						showSkip: ((act === 'click' || act === 'input') && Number(step.is_skip_btn || 0) === 1),
						dotsCount: t.steps.length,
						dotsIndex: i,
						btnSkipText: App.locale_general.guide_tour.skip,
						btnStartText: isLast ? App.locale_general.guide_tour.end : btnText,
					}),
					dir: step.position || 'right',
					arrow: true,
					floating: false,
					offset: {x: 0, y: 0},
				});
			});
		},

		next: function () {
			self._cancelWait();
			self._offAction();
			self._mmWatchStop();

			const t = self._tour;
			if (!t) return;

			const ni = t.i + 1;
			if (ni >= t.steps.length) {
				self.stop();
				return;
			}

			self.show_step(ni, false);
		},

		// ------------------------------
		// helpers
		// ------------------------------

		_resolveEl: function (el) {
			if (!el) return null;
			if (typeof el === 'string') return $(el).get(0) || null;
			if (el.jquery) return el.get(0) || null;
			if (el.nodeType === 1) return el;
			return null;
		},

		_snapshot: function (el) {
			const $el = $(el);
			return {
				attr: {
					'data-title': $el.attr('data-title'),
					'data-title-config': $el.attr('data-title-config'),
					'data-title-offset': $el.attr('data-title-offset'),
					'data-title-delay': $el.attr('data-title-delay'),
				},
			};
		},

		_restore: function (el, snap) {
			const $el = $(el);
			const a = (snap && snap.attr) ? snap.attr : {};

			const setOrRemove = (name, val) => {
				if (val == null) $el.removeAttr(name);
				else $el.attr(name, val);
			};

			setOrRemove('data-title', a['data-title']);
			setOrRemove('data-title-config', a['data-title-config']);
			setOrRemove('data-title-offset', a['data-title-offset']);
			setOrRemove('data-title-delay', a['data-title-delay']);
		},

		_stripHintDirs: function (cfg) {
			const dirs = [
				'top', 'right', 'bottom', 'left',
				'top_left', 'top_right', 'bottom_left', 'bottom_right',
				'center'
			];
			let out = String(cfg || '');

			dirs.forEach(d => {
				out = out.replace(new RegExp('(^|\\s)' + d.replace('_','\\_') + '(?=\\s|$)', 'g'), ' ');
			});

			return out.replace(/\s+/g, ' ').trim();
		},

	};

})();
;App.helper.handle_multiline_paste = {
	register(selector, callback, fallback = null) {
		$(selector).on('paste', function (e) {
			let clipboardData = e.originalEvent.clipboardData || window.clipboardData;
			let pastedData = clipboardData.getData('Text');

			if (pastedData) {
				let rows = App.helper.handle_multiline_paste.splitToRows(pastedData);
				if (rows.length === 1 && fallback) {
					fallback(rows[0]);
				} else {
					e.preventDefault();
					callback(rows);
				}
			}
		});
	},
	splitToRows(text) {
		const MAX_ROWS = 32;
		text = text.trim();

		if (text === '') return [];

		const rows = text.split('\n');

		return rows.map(row => row.trim()).filter(row => row !== '').slice(0, MAX_ROWS);
	}
}
;var App = App || {};

App.haptics = (function () {

	const SHORT = 50;
	const MEDIUM = 125;
	const LONG = 300;

	let self = {

		debug: false,

		vibrateOptionsDuration: {
			SHORT,
			MEDIUM,
			LONG,
		},

		/**
		 * Vibrate the device for the specified duration.
		 *
		 * @param {object} options - Options for the vibration.
		 * @param {number} options.duration - The duration of the vibration in milliseconds. Defaults to 300.
		 */
		vibrate: function (options = { duration: LONG }) {

			if (this.debug) console.warn(this, 'vibrate', options);

			if (navigator.vibrate) {
				navigator.vibrate(options.duration);
			} else {
				document.querySelector('#hapticsHack')?.click();
			}
		},

		notification: function () {
			self.vibrate({ duration: LONG });
		},

		swipe_to_reload: function () {
			self.vibrate({ duration: SHORT });
		},

		contextmenu: function () {
			// console.log('%cBZZZZ', 'color:lime;background:black;');
			self.vibrate({ duration: SHORT });
		},

		onBoot: function () {
			$('#fixed_container_common').append('<label id="hapticsHack" style="display: none;"><input type="checkbox" switch></label>');
		},
	};

	return self;
})();

;var App = App || {};

(function () {

	let has_overflown_width = function (el) {
		return el && el.scrollWidth > el.offsetWidth;
	}

	let calc_overflow = function (target_rect, container_rect) {
		return {
			top: target_rect.y1 - container_rect.y1,
			left: target_rect.x1 - container_rect.x1,
			right: target_rect.x2 - container_rect.x2,
			bottom: target_rect.y2 - container_rect.y2,
			has_intersection: function () {
				return this.top < 0 || this.left < 0 || this.right > 0 || this.bottom > 0;
			}
		};
	};
	let move_rect = function (target_rect, vector, factor) {
		let f = factor == null ? 1 : factor;
		target_rect.x1 = target_rect.x1 + vector.x*f;
		target_rect.x2 = target_rect.x2 + vector.x*f;
		target_rect.y1 = target_rect.y1 + vector.y*f;
		target_rect.y2 = target_rect.y2 + vector.y*f;
	};
	let get_target_text = function(target) {
		let a = $(target).text().trim().replaceAll(/\t+/gi, '').replaceAll(/\n+/gi, ' ');
		return a;
	};

	let timeout = {};
	let show_delay = 333;
	let max_auto_size = 60;
	let window_safe_space = 6;
	let DIRECTIONS = {
		top: 1, right: 2, bottom: 3, left: 4, top_left: 5, top_right: 6, bottom_left: 7, bottom_right: 8,
		inner_top: 9,
		auto: function (mouse, origin, size, offset, view) {
			let r = { arrow: '', x1: 0, y1: 0, x2: 0, y2: 0 };
			let p = { x: mouse.x, y: mouse.y };
			let space = 5;

			let dy = p.y - origin.y;
			let dx = p.x - origin.x;

			if (origin.h <= max_auto_size) {
				r.y1 = dy > origin.h/2 ? origin.y + origin.h + space : origin.y - size.h - space;
			} else {
				r.y1 = dy > origin.h/2 ? p.y + space*2 : p.y - space*2 - size.h;
			}

			let sp = origin.h <= max_auto_size ? space*-2 : space*2;
			r.x1 = dx > origin.w/2 ? p.x + sp : p.x - sp - size.w;

			r.x2 = r.x1 + size.w;
			r.y2 = r.y1 + size.h;

			if (offset) move_rect(r, offset)

			let overflow = calc_overflow(r, view);

			if (overflow.has_intersection()) {

				if (overflow.left < 0 && overflow.top < 0) {
					r.x1+= overflow.left*-1;
					r.y1 = origin.h <= max_auto_size ? origin.y + origin.h + space : origin.y + max_auto_size;
				} else if (overflow.right > 0 && overflow.top < 0) {
					r.x1-= overflow.right;
					r.y1 = origin.h <= max_auto_size ? origin.y + origin.h + space : origin.y + max_auto_size;
				} else if (overflow.right > 0 && overflow.bottom > 0) {
					r.x1-= overflow.right;
					r.y1 = origin.h <= max_auto_size ? origin.y - size.h - space : origin.y - size.h;
				} else if (overflow.left < 0 && overflow.bottom > 0) {
					r.x1+= overflow.left*-1;
					r.y1 = origin.h <= max_auto_size ? origin.y - size.h - space : origin.y - size.h;
				} else if (overflow.left < 0) {
					move_rect(r, { x: overflow.left*-1, y: 0 })
				} else if (overflow.top < 0) {
					if (origin.h <= max_auto_size) {
						r.y1 = origin.y + origin.h + space;
					} else {
						move_rect(r, { x: 0, y: overflow.top*-1 })
					}
				} else if (overflow.right > 0) {
					move_rect(r, { x: overflow.right*-1, y: 0 })
				} else if (overflow.bottom > 0) {
					if (origin.h <= max_auto_size) {
						r.y1 = origin.y - size.h - space;
					} else {
						move_rect(r, { x: 0, y: overflow.bottom*-1 })
					}
				}

				r.x2 = r.x1 + size.w;
				r.y2 = r.y1 + size.h;
			}

			return r;
		},
		calc: function (mouse, origin, size, offset, view, dir, floating, with_arrow) {
			let r = { arrow: '', x1: 0, y1: 0, x2: 0, y2: 0 };
			let p = { x: origin.x, y: origin.y };

			// ===== INNER TOP (inside element, centered) =====
			if (dir === this.inner_top) {

				const pad_x = 9;
				const pad_bottom = 9;

				r.x1 = origin.x + origin.w / 2 - (size.w + pad_x * 2) / 2;
				r.y1 = origin.y;

				r.x2 = r.x1 + size.w + pad_x * 2;
				r.y2 = r.y1 + size.h + pad_bottom;

				if (offset) move_rect(r, offset);

				// arrow не використовується
				r.arrow = '';

				return r;
			}

			let f = floating === true || dir == null ? 0 : 1;
			let space = 5;

			if (floating) {
				f = 0;
				if ([this.top, this.top_left, this.top_right, this.bottom, this.bottom_left, this.bottom_right].includes(dir)) {
					p.x = mouse.x;
				}
				if ([this.left, this.right].includes(dir)) {
					p.y = mouse.y;
				}
			}

			if ([this.top, this.top_left, this.top_right].includes(dir)) {
				r.y1 = p.y - size.h - space;
			} else if ([this.bottom, this.bottom_left, this.bottom_right].includes(dir)) {
				r.y1 = p.y + origin.h + space;
			} else if ([this.left, this.right].includes(dir)) {
				r.y1 = p.y + origin.h/2*f - size.h/2;
			}

			if ([this.top, this.bottom].includes(dir)) {
				r.x1 = p.x + origin.w/2*f - size.w/2
			} else if ([this.top_left, this.bottom_left].includes(dir)) {
				r.x1 = p.x - size.w + origin.w * f;
			} else if (this.left === dir) {
				r.x1 = p.x - size.w - space;
			} else if ([this.top_right, this.bottom_right].includes(dir)) {
				r.x1 = p.x;
			} else if (this.right === dir) {
				r.x1 = p.x + origin.w + space;
			}

			let arrow_offset = { x: 0, y: 0 };

			if (with_arrow) {
				if (this.right === dir) {
					arrow_offset.x+= space;
					r.arrow = 'ar_l';
				} else if (this.left === dir) {
					arrow_offset.x-= space;
					r.arrow = 'ar_r';
				} else if (this.top === dir) {
					arrow_offset.y-= space;
					r.arrow = 'ar_b';
				} else if (this.bottom === dir) {
					arrow_offset.y+= space;
					r.arrow = 'ar_t';
				} else if (this.top_right === dir) {
					r.arrow = 'ar_b ar_s';
					arrow_offset.y-= space;
					r.x1 = p.x + origin.w/2*f;
					arrow_offset.x-= 14;
				} else if (this.bottom_right === dir) {
					r.arrow = 'ar_t ar_s';
					r.x1 = p.x + origin.w/2*f;
					arrow_offset.y+= space;
					arrow_offset.x-= 14;
				} else if (this.top_left === dir) {
					r.arrow = 'ar_b ar_e';
					r.x1 = p.x + origin.w/2*f - size.w;
					arrow_offset.y-= space;
					arrow_offset.x+= 14;
				} else if (this.bottom_left === dir) {
					r.arrow = 'ar_t ar_e';
					r.x1 = p.x + origin.w/2*f - size.w;
					arrow_offset.y+= space;
					arrow_offset.x+= 14;
				}
			}

			move_rect(r, arrow_offset);

			r.x2 = r.x1 + size.w;
			r.y2 = r.y1 + size.h;

			if (offset) move_rect(r, offset)

			let overflow = calc_overflow(r, view);

			if (overflow.has_intersection()) {

				if ([this.left, this.right].includes(dir)) {
					if (overflow.top < 0) move_rect(r, { x: 0, y: overflow.top * -1 });
					if (overflow.bottom > 0) move_rect(r, { x: 0, y: overflow.bottom * -1 });
				}

				if ([this.top, this.bottom].includes(dir)) {
					if (overflow.left < 0) move_rect(r, { x: overflow.left * -1, y: 0 });
					if (overflow.right > 0) move_rect(r, { x: overflow.right * -1, y: 0 });
				}

				if ([this.top_left, this.top_right, this.bottom_left, this.bottom_right].includes(dir)) {
					if (overflow.left < 0) move_rect(r, { x: overflow.left * -1, y: 0 });
					if (overflow.right > 0) move_rect(r, { x: overflow.right * -1, y: 0 });
					if (overflow.top < 0) move_rect(r, { x: 0, y: overflow.top * -1 });
					if (overflow.bottom > 0) move_rect(r, { x: 0, y: overflow.bottom * -1 });
				}
			}

			r.x2 = r.x1 + size.w;
			r.y2 = r.y1 + size.h;

			if (with_arrow) {
				const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

				const cx = origin.x + origin.w / 2;
				const cy = origin.y + origin.h / 2;

				const localX = cx - r.x1;
				const localY = cy - r.y1;

				const pad = 14;

				r.arrow_x = clamp(localX, pad, size.w - pad);
				r.arrow_y = clamp(localY, pad, size.h - pad);
			}

			return r;
		}
	};

	let reset_debouncer = function (id_timer) {
		clearTimeout(timeout[id_timer])
	}

	let create_debouncer = function (id_timer, action, delay, throttle) {
		let last_at = 0;
		return function (t, e) {
			reset_debouncer(id_timer)

			if (throttle > 0 && Date.now() - last_at > throttle) {
				last_at = Date.now();
				action(t, e);
				return;
			}

			timeout[id_timer] = setTimeout(function () {
				last_at = Date.now();
				action(t, e)
			}, delay)
		}
	}

	let get_hint_width = function(target, body, hint_style) {
		let val = target.attr('data-title-width')
			|| hint_style.getPropertyValue('--hint-width');

		if (!val) return null;

		val = val.trim();

		// число
		if (/^\d+$/.test(val)) {
			return parseInt(val);
		}

		// батько
		if (val === 'parent') {
			return $(target).parent().outerWidth();
		}

		// дідо
		if (val === 'parent2') {
			return $(target).parent().parent().outerWidth();
		}

		// меню
		if (val === 'menu') {
			return $(target).closest('.menu').outerWidth();
		}

		if (val === 'menu__item') {
			return $(target).closest('.menu__item').outerWidth();
		}

		return null;
	}

	let get_hint_text = function(target, hint_style) {

		let default_text = target.attr('data-title');
		let mode = hint_style.getPropertyValue('--hint-text-mode').trim();

		if (mode) {
			return target.attr('data-title-text-'+mode) ?? default_text;
		}

		return default_text;
	}

	let self = App.hint = {

		el: null,
		timeout: {},
		type: 0,
		last_mouse_position: {
			x: 0, y: 0
		},
		lock_until: 0,
		last_click_target: null,
		debug: false,
		listen_on: 'ws-btn, [data-preview], [data-title], .menu__item, .help, .text_overflow',

		is_shown: function() {
			return this.el !== null;
		},

		show: function() {
			let txt, ds, dc, dp;
			if (self.el == null) return;
			if ($('body').hasClass('drag_do')) return;
			if (self.el.style.display === "none") return;
			if (self.el.style.visibility === "hidden") return;

			let target = $(self.el);
			let delayAttr = parseInt(target.attr('data-title-delay'), 10);
			self.lock_until = Number.isFinite(delayAttr) && delayAttr > 0 ? Date.now() + delayAttr : 0;
			let hint_style = getComputedStyle(self.el);

			if (hint_style.getPropertyValue('--hint-enabled') === 'no') return;

			if (target.attr('data-title-load') && target.attr('data-task')) {
				$.ajax({
					url: App.helper.endpoint.task(target.attr('data-task')) + '?' + App.actions.get(target.attr('data-title-load')),
					type: 'GET',
					success: function(json) {
						target.removeAttr('data-title-load');
						if (json.title) {
							target.attr('data-title', json.title);
							if (self.is_shown()) {
								let container = $('#hint');
								let body = container.find('.in');
								container.css({width: '', height: ''});
								body.css({width: '', height: ''});
								self.show();
							}
						}
					}
				})
			}

			if (self.type === 1) {
				$('#preview_place').removeClass('ava_right ava_big preview_place_bot');
				let img = document.createElement('img');
				if (target.is('[data-preview-size]')) {
					let size = target.attr('data-preview-size').split('x');
					img.width = size[0];
					img.height = size[1];
				}
				img.src = target.attr('data-preview');
				if (target.attr('data-ava') === '1') {
					if (target.parents('.commentForm').length) return;
					if (!App.modal.is_shown() && $('#listing').hasClass('listing-cardView')) $('#preview_place').addClass('ava_big').css({
						top: target.offset().top,
						left: target.offset().left
					}).show().html('').append(img);
					else $('#preview_place').addClass('ava_big ava_right').css({
						top: target.offset().top,
						left: target.offset().left + target.outerWidth()
					}).show().html('').append(img);
				} else {
					if (target.offset().top < $(window).scrollTop() + 200) $('#preview_place').addClass('preview_place_bot').css({
						top: target.offset().top + target.outerHeight() + 5,
						left: target.offset().left
					}).show().html('').append(img);
					else $('#preview_place').css({
						top: target.offset().top - 5,
						left: target.offset().left
					}).show().html('').append(img);
				}
				return;
			}

			ds = {}
			dc = '';
			dp = target.attr('data-title-config') || '';

			/**
			 * TODO: Check places with <ws-icon name="hint" data-title="text...">
			 *     to be sure that formatted strings like '%G...G%' don't broke anything
			 */
			if (target.hasClass('help') && !target.attr('data-title')) {
				txt = target.find('font').html();
				dc = ' hint_hp';
				if (target.hasClass('help_big')) dc += ' hint_hpb';
				if (target.hasClass('help_t') && target.hasClass('help_l')) dp = 'top_left';
				else if (target.hasClass('help_t')) dp = 'top';
				else if (target.hasClass('help_l')) dp = '';
				else dp = 'right';
			} else {
				txt = get_hint_text(target, hint_style);

				if (target.attr('data-title') == null && target.hasClass('menu__item')) txt = get_target_text(target.find('> .in, > .flex_content').first());
				else if (target.attr('data-title') == null && target.hasClass('text_overflow')) txt = get_target_text(target);
				else if(target.attr('data-title') == null || target.attr('data-title') === '') txt = get_target_text(target);

				if (target.hasClass('data-title-help')) dc += ' hint_hp';
				if (target.hasClass('data-title-big')) dc += ' hint_hpb';
				if (target.attr('data-title-add')) txt += target.attr('data-title-add');
				if (target.attr('data-title-add2')) txt += target.attr('data-title-add2');
				txt = self.resolve_placeholders(txt);

				if (!/<[^>]*>/.test(txt)) txt = App.helper.html.encode(txt);

				txt = txt
					.replace(/%ICO\[(.*?)\]ICO%/gm, '<ws-icon name="$1" class="inline_ico"></ws-icon>')
					.replace(/\[T(.*?):(\d+)T\]/gm, '<span class="tag tag$2">$1</span>')
					.replace(/%C:(\S+):(.*?)C%/gm, '<span class="$1">$2</span>')

					// 1. Структурні та блочні розділювачі (NL2 обов'язково перед NL)
					.replace(/%NL2%/gm, '<div class="hint_nline"></div>')
					.replace(/(\\n|%NL%)/gm, '\n')
					.replace(/%LN%(\n|\\n)?/gm, '<div class="hint_line"></div>')
					.replace(/%NBSP%/gm, '<span class="nbsp"></span>')
					.replace(/%UP%/gm, '<span class="ico ico_levelupw"></span>')
					.replace(/%AV%/gm, target.parent().find('.av_sm').length ? target.parent().find('.av_sm').get(0).outerHTML : App.controls?.datepicker?.config?.user_avatar || '')

					// 2. Дволітерні теги (ОБОВ'ЯЗКОВО перед однолітерними G, R, B, S)
					.replace(/%GR(.*?)GR%/gm, '<span class="green">$1</span>')
					.replace(/%RO(.*?)RO%/gm, '<span class="red_opacity">$1</span>')
					.replace(/%BL(.*?)BL%/gm, '<span class="blue">$1</span>')
					.replace(/%XS(.*?)XS%/gm, '<span class="xs">$1</span>')
					.replace(/%TI(.*?)TI%/gm, '<span class="time">$1</span>')
					.replace(/%MO(.*?)MO%/gm, '<span class="money">$1</span>')

					// 3. Однолітерні теги
					.replace(/%G(.*?)G%/gm, '<span class="gray">$1</span>')
					.replace(/%R(.*?)R%/gm, '<span class="red">$1</span>')
					.replace(/%B(.*?)B%/gm, '<b>$1</b>')
					.replace(/%S(.*?)S%/gm, '<small>$1</small>')
					.replace(/%I(.*?)I%/gm, '<span><i>$1</i></span>')
					.replace(/%H(.*?)H%/gm, '<font class="h">$1</font>')
					.replace(/%Y(.*?)Y%/gm, '<span class="yellow">$1</span>')
					.replace(/%V(.*?)V%/gm, '<span class="violet">$1</span>')
					.replace(/%K(.*?)K%/gm, '<span class="hkey">$1</span>')
					.replace(/%D(.*?)D%/gm, '<span class="date">$1</span>')
				;

				if (txt.substring(0, 1) === '#') {
					txt = $(txt).html();
				} else {
					let auto_txt = target.attr('data-title') === '';
					auto_txt ||= target.attr('data-title') == null && target.hasClass('text_overflow');
					auto_txt ||= target.attr('data-title') == null && target.hasClass('menu__item');

					if (auto_txt) {
						let auto_target = target;

						if (target.hasClass('menu__item')) {
							auto_target = target.find('> .in, > .flex_content').first();
						}

						// Previous overflow detection logic
						//
						// const temp_tag = document.createElement('div')
						// temp_tag.style.position = 'absolute'
						// temp_tag.style.visibility = 'hidden'
						// temp_tag.style.left = '-99in'
						// temp_tag.style.whiteSpace = 'nowrap'
						// temp_tag.style.font = auto_target.css('font')
						// temp_tag.innerHTML = txt
						//
						// document.body.appendChild(temp_tag)
						// const textWidth = temp_tag.clientWidth
						// document.body.removeChild(temp_tag)
						//
						// if (textWidth <= auto_target.innerWidth()) txt = '';

						if (!has_overflown_width(auto_target.get(0))) {
							txt = '';
						}
					}
				}
			}

			if (!txt) return;

			if (!$('#hint').length) $('body').append('<div id="hint"><div class="in"></div></div>');
			let container = $('#hint');
			let body = container.find('.in');

			body.html(App.helper.html.encode(txt.trim(), {only_tags: ['script'], escape_quotes: false, encode_ampersands: false}));

			if (dp.indexOf('gray') !== -1 || dp.indexOf('hint_gr') !== -1 || target.hasClass('data-title-gr')) {
				dc += (dc ? ' ' : '') + ' hint_gr';
			}
			if (dp.indexOf('white') !== -1 || target.hasClass('data-title-l') || target.hasClass('data-title-rw')) {
				dc += (dc ? ' ' : '') + ' hint_w';
			}

			let hint_offset = { x: 0, y: 0 };

			let parent_value = dp.indexOf('parent') !== -1 ? dp : hint_style.getPropertyValue('--hint-parent') || '';
			let offset_value = (target.attr('data-title-offset') || hint_style.getPropertyValue('--hint-offset') || '').trim().split(' ')

			if (offset_value.length === 1) {
				hint_offset.x = parseInt(offset_value[0].trim())
				hint_offset.y = parseInt(offset_value[0].trim())
			} else if (offset_value.length === 2) {
				hint_offset.x = parseInt(offset_value[0].trim())
				hint_offset.y = parseInt(offset_value[1].trim())
			}

			hint_offset.x = isNaN(hint_offset.x) ? 0 : hint_offset.x;
			hint_offset.y = isNaN(hint_offset.y) ? 0 : hint_offset.y;

			let el = target;

			let dock_to = target.attr('data-title-dock-to');

			if (dock_to) {
				let dock_el = $(dock_to).get(0);
				if (dock_el) {
					el = $(dock_el);
				}
			}

			if (parent_value.indexOf('parent') !== -1) {
				el = el.parent(); if (el.is('ws-btn')) el = el.parent();
			}
			if (parent_value.indexOf('parent2') !== -1) {
				el = el.parent(); if (el.is('ws-btn')) el = el.parent();
			}
			if (parent_value.indexOf('parent-td') !== -1) {
				el = target.closest('td');
			}
			if (parent_value.indexOf('parent-th') !== -1) {
				el = target.closest('th');
			}

			if (dp.indexOf('parent2') !== -1) {
				el = el.parent();
				if (el.is('ws-btn')) el = el.parent();
			}

			let el_bounding_rect = el.get(0).getBoundingClientRect();
			let dir = null;
			let with_arrow = dp.indexOf('arrow') !== -1 || hint_style.getPropertyValue('--hint-arrow') === 'yes';
			let floating = dp.indexOf('float') !== -1 || hint_style.getPropertyValue('--hint-float') === 'yes';

			if (dp.indexOf('inner_top') !== -1) {
				dir = DIRECTIONS.inner_top;
			} else if (dp.indexOf('top_left') !== -1) {
				dir = DIRECTIONS.top_left;
			} else if (dp.indexOf('top_right') !== -1) {
				dir = DIRECTIONS.top_right;
			} else if (dp.indexOf('bottom_left') !== -1) {
				dir = DIRECTIONS.bottom_left;
			} else if (dp.indexOf('bottom_right') !== -1) {
				dir = DIRECTIONS.bottom_right;
			} else if (dp.indexOf('left') !== -1 || el.hasClass('data-title-l') || el.hasClass('data-title-a') || el.hasClass('data-title-b') || el.hasClass('data-title-l2')) {
				dir = DIRECTIONS.left;
			} else if (dp.indexOf('right') !== -1 || el.hasClass('data-title-rw') || el.hasClass('data-title-r') || dp.indexOf('right_arrow') !== -1) {
				dir = DIRECTIONS.right;
			} else if (dp.indexOf('top') !== -1 || el.hasClass('data-title-t')) {
				dir = DIRECTIONS.top;
			} else if (el.hasClass('data-title-xt')) {
				dir = DIRECTIONS.top;
				floating = true;
			} else if (dp.indexOf('center') !== -1 || dp.indexOf('bottom_arrow') !== -1 || dp.indexOf('bottom') !== -1) {
				dir = DIRECTIONS.bottom;
			}

			if (dir == null && hint_style.getPropertyValue('--hint-dir') != null) {
				dir = DIRECTIONS[hint_style.getPropertyValue('--hint-dir')];
				dir = isNaN(dir) ? null : dir;
			}

			if (dc.indexOf('hint_w') === -1 && dc.indexOf('hint_gr') === -1 && hint_style.getPropertyValue('--hint-color')) {
				if (hint_style.getPropertyValue('--hint-color') === 'gray') {
					dc += (dc ? ' ' : '') + ' hint_gr';
				} else if (hint_style.getPropertyValue('--hint-color') === 'white') {
					dc += (dc ? ' ' : '') + ' hint_w';
				}
			}

			if (dir === DIRECTIONS.inner_top) {
				dc += ' inner_top';
			}

			if (App.modal.is_shown()) dc += (dc ? ' ' : '') + ' hint_wm';

			container.attr('class', dc);

			let view_rect = { x1: window_safe_space, y1: window_safe_space, x2: window.innerWidth - window_safe_space, y2: window.innerHeight - window_safe_space };
			let el_bounds = { x: el_bounding_rect.left, y: el_bounding_rect.top, w: el_bounding_rect.width, h: el_bounding_rect.height};
			let forced_width = get_hint_width(target, body, hint_style);
			if (forced_width != null) {
				body.css({
					maxWidth: forced_width + 'px',
					whiteSpace: '' // `normal` - breaks %NL%
				});
			}
			let hint_size = { w: body.outerWidth(), h: body.outerHeight() };

			let dr = dir != null
				? DIRECTIONS.calc(self.last_mouse_position, el_bounds, hint_size, hint_offset, view_rect, dir, floating, with_arrow)
				: DIRECTIONS.auto(self.last_mouse_position, el_bounds, hint_size, hint_offset, view_rect);

			if (dp.indexOf('inner') === -1 && calc_overflow(dr, view_rect).has_intersection()) {
				dr = DIRECTIONS.auto(self.last_mouse_position, el_bounds, hint_size, hint_offset, view_rect);
			}

			dc += ' ' + dr.arrow;
			ds.left = dr.x1;
			ds.top = dr.y1;
			ds.width = dr.x2 - dr.x1;
			ds.height = dr.y2 - dr.y1;

			container.attr('class', dc);
			container.css(ds).css({pointerEvents:'all'});

			if (dr && (dr.arrow_x != null || dr.arrow_y != null)) {
				container.css({
					'--hint-arrow-x': (dr.arrow_x != null ? dr.arrow_x + 'px' : ''),
					'--hint-arrow-y': (dr.arrow_y != null ? dr.arrow_y + 'px' : ''),
				});
			} else {
				container.css({'--hint-arrow-x':'', '--hint-arrow-y':''});
			}

			body.css({ width: (hint_size.w+1)+'px' });
			if (dir === DIRECTIONS.inner_top) {
				setTimeout(() => {
					container.addClass('show');
				}, 50);
			} else {
				body.css({ opacity: 1 });
			}
		},

		hide: function() {
			reset_debouncer('mousemove');
			reset_debouncer('show');

			if (self.debug) return;
			if (self.el == null) return;

			self.lock_until = 0;

			$('#preview_place').hide();
			// $('#hint').css({pointerEvents:'none'});
			// $('#hint .in').css({opacity: 0});
			self.el = null;
			if ($('#hint').hasClass('show')) {
				$('#hint').removeClass('show');
				setTimeout(() => {
					$('#hint').remove();
				}, 50);
			} else {
				$('#hint').remove();
			}
		},

		helper_user_wrapper: function(id) {
			return '[U' +id + ']';
		},

		helper_project_wrapper: function(id) {
			return '[P' + id + ']';
		},

		helper_task_wrapper: function(id, name) {
			if (name) return '[T' + id + ':' + name + ']';
			return '[T' + id + ']';
		},

		resolve_placeholders: function(txt) {
			if (!txt) return txt;

			txt = txt.replace(/\[U(\d+)\]/gm, function(match, id_user) {
				return App.helper.team(id_user, 'name') || 'Unknown';
			});
			txt = txt.replace(/\[P(\d+)\]/gm, function(match, id_project) {
				return App.helper.project(id_project, 'name');
			});
			txt = txt.replace(/\[T(\d+)(?::([^\]]*))?\]/gm, function(match, id_task, fallback) {
				return App.helper.task_name(id_task) || fallback || match;
			});

			return txt;
		},

		show_by_target: function(target, replace) {
			if (!replace && (self.el === target || self.el != null)) return;

			if (self.el && replace) self.hide();

			const el = $(target);

			if (el.attr('data-preview') || el.attr('data-title') != null || el.hasClass('help') || el.hasClass('menu__item') || el.hasClass('text_overflow')) {
				self.el = target;
			} else if (el.is('ws-btn') && el.attr('data-title') == null && has_overflown_width(el.find('span:not([class])').get(0))) {
				self.el = target;
			}

			if (self.el == null) return;

			self.type = el.attr('data-preview') ? 1 : 0;
			self.show();
			self.last_click_target = null;
		},

		force_show: function(el) {
			let elr = $(el).get(0).getBoundingClientRect();
			App.hint.last_mouse_position = {x: elr.left, y: elr.top};
			App.hint.show_by_target(el, true);
		},

		handle_show: create_debouncer('show', function (target) {
			self.show_by_target(target);
		}, show_delay),
		handle_mousemove: create_debouncer('mousemove', function (target, event) {
			if (self.el && !self.el.isConnected) {
				self.hide();
			}

			const hint_target = $(target).closest(self.listen_on).get(0);
			const isLocked = !!(self.lock_until && Date.now() < self.lock_until);

			if (hint_target == null) {
				self.last_click_target = null;

				if (self.el && !isLocked) {
					self.hide();
				}

				if (!isLocked) reset_debouncer('show');
				return;
			}

			if (self.last_click_target != null && self.last_click_target === hint_target) {
				return;
			}

			// різні елементи, але викликають "однаковий" тултіп
			const isSame = self.el && self.el.dataset.titleId && hint_target.dataset.titleId == self.el.dataset.titleId;

			if (self.el && hint_target !== self.el && !isSame) {
				if (isLocked) {
					return;
				} else {
					self.hide();
				}
			}

			self.last_mouse_position.x = event.clientX;
			self.last_mouse_position.y = event.clientY;

			if (!isLocked && !isSame) {
				self.handle_show(hint_target, event);
			}
		}, 200, 100),
		handle_click: function (target, event) {
			let hint = target.closest('ws-icon[name=hint]');
			if (hint) {
				event.stopImmediatePropagation();
				event.preventDefault();

				if (self.el === hint) return;
				if (self.el && hint !== self.el) {
					self.hide();
				}

				self.last_mouse_position.x = event.clientX;
				self.last_mouse_position.y = event.clientY;
				App.helper.nextTick(() => self.show_by_target(hint));
				return
			}

			self.hide();

			const hint_target = $(target).closest(self.listen_on).get(0)
			if (hint_target == null) return;

			self.last_click_target = hint_target;
		},

		onBoot: function () {

			if (App.device.is_mobile() || App.device.is_touch_screen()) {
				let skip_next = false;
				window.addEventListener('contextmenu', function () {
					skip_next = true;
				}, true);
				window.addEventListener('touchend', function (event) {
					if (skip_next) {
						skip_next = false;
						return;
					}
					self.handle_click(event.target, event);
				}, true);
				window.addEventListener('touchmove', function () {
					self.hide();
				}, true);
			} else {
				window.addEventListener('mousemove', function (event) {
					self.handle_mousemove(event.target, event)
				}, true);
				window.addEventListener('wheel', function () {
					self.hide();
				}, true);
				window.addEventListener('contextmenu', function () {
					self.hide();
				}, true);
				window.addEventListener('mousedown', function (event) {
					self.handle_click(event.target, event);
				}, true);
			}

		}
	};
})();

;(function() {
	let self = App.in_app_notifications = {

		types: {
			task: {new: 't', upd: 'u', close: 'd'},
			comment: {new: 'c', upd: 'x'},
			message: {new: 'm'},
			file: {new: 'f'},
			proj: {invite: 'p'},
			misc: {birthday: 'b',reminder:'a',reaction:'r',mention:'m'},
		},

		show_chat_messages: function(items) {
			if (items == null || items.length === 0) return;

			let data = items.pop(),
				text_add = items.length > 0 ? '\n+' + App.format.quantity(items.length, App.object_state.locale['quantity']['message'], true) : '';

			App.message.show(data.text + text_add, MSG_VARIANT_B, {
				title: data.chat_name,
				url: data.chat_id_user ? App.helper.url.chat_personal(data.chat_id_user) : App.helper.url.chat(data.id_task),
				icon: data.chat_ico
			});
		},
		show_task_comments: function(items) {
			if (items == null || items.length === 0) return;

			let data = items.pop(),
				text_add = items.length > 0 ? '\n+' + App.format.quantity(items.length, App.object_state.locale['comments'], true) : '';

			App.message.show(data.text + text_add, MSG_VARIANT_B, {
				title: data.task_name,
				url:  App.helper.url.task(data.id_task),
				icon: data.author_ico,
				icon_name: 'comment_bubble'
			});
		},

		el: null,
		total_events: 0,
		el_timer: null,
		show_events: function(type, events) {
			if (App.device.is_mobile()) return;

			this.total_events += events.length;

			if (this.el == null) {
				this.el = $('<div />').addClass('foreground-message bell');
				this.el.html(
					`<div class="icon"><ws-icon name="notifications_alt"></ws-icon></div><div class="in flex_content"><div class="title"></div><div class="body"></div></div>`
				);
				this.el.on('mouseover', () => App.in_app_notifications.hide_events());
				this.el.appendTo('#fixed_container');
			}

			let type_name = App.object_state.locale['notification_names'][type] || App.object_state.locale['notification_names']['other'];
			let show_group = type_name.hashCode();

			this.el.find('.in .title').text('+ ' + App.format.quantity(this.total_events, App.object_state.locale['quantity']['notify'], true));

			let target_group = this.el.find(`.in .body [data-group=${show_group}]`);
			if (target_group.length > 0) {
				target_group.text(type_name + ' ' + (parseInt(target_group.attr('data-cnt'))+events.length));
			} else {
				if (this.el.find('.in .body div').length > 0) {
					this.el.find('.in .body').append('<div> • </div>');
				}
				this.el.find('.in .body').append(`<div data-group="${show_group}" data-cnt="${events.length}">${type_name} ${events.length}</div>`);
			}

			App.helper.nextTick(() => this.el.addClass('shown'));
		},

		hide_events: function() {
			this.total_events = 0;
			this.el.find('.in .body').html('');
			this.el.removeClass('shown');
		},

		event: {
			queue: {},
			task_data: {},
			add_task_data: function (bell, id_task, data) {
				if (+data.id_user === +App.me.id || !id_task) return;

				this.task_data[bell] ||= {};
				this.task_data[bell][id_task] ||= [];
				this.task_data[bell][id_task].push({ ...data, __added: Date.now() });

				if (bell === self.types.message.new) this.process(0, { type: 'chat', id_task, bell });
			},
			process: function(id, data) {
				if (data.id_task && App.task_view.is_show_by_id(data.id_task) && data.type !== 'alarm') {
					if (this.task_data[data.bell] && data.id_task in this.task_data[data.bell]) delete this.task_data[data.bell][data.id_task];
					return;
				}

				this.queue[data.bell] ||= [];
				this.queue[data.bell].push(data);

				if (App.core.is_active()) this.show();
			},
			show_bell: function (type) {
				const events = this.queue[type] || [];
				const task_data = this.task_data[type] || {};

				if (events.length === 0) {
					return;
				}

				if (type === self.types.message.new) {
					App.helper.array.group_by(events, 'id_task').keys().forEach(id_task => self.show_chat_messages(task_data[id_task]));
				} else if (type === self.types.comment.new) {
					App.helper.array.group_by(events, 'id_task').keys().forEach(id_task => self.show_task_comments(task_data[id_task]));
				} else {
					self.show_events(type, events);
				}

				this.clear_bell(type);
				self.publish_clear_bell(type);
			},
			show: App.helper.debounce(function() {
				if (App.core.is_active()) Object.keys(self.event.queue).forEach((type) => self.event.show_bell(type));
			}, 99),
			clear_task: function(id_task) {
				Object.keys(this.task_data).forEach(i => {
					if (id_task in this.task_data[i]) delete this.task_data[i][id_task]
				});
				Object.keys(this.queue).forEach(i => {
					this.queue[i] = this.queue[i].filter(i => i.id_task !== id_task);
				});
			},
			clear_bell: function (type) {
				if (type in this.queue) delete this.queue[type];
				if (type in this.task_data) delete this.task_data[type];
			}
		},

		on_active: function() {
			self.event.show();
		},
		on_task_seen: function (id_task) {
			self.event.clear_task(id_task);
		},
		on_clear_bell: function (type) {
			self.event.clear_bell(type);
		},

		publish_clear_bell: function(type) {
			App.core.send_message_to_other_tabs({ command: 'in_app_notify_clear_bell', data: { type } });
		},

		onLogin: function() {
			App.helper.cron.add('in_app_notify_clear_task_data', function () {
				const td = App.in_app_notifications.event.task_data,
					delta_added = 180 * 1000;

				Object.keys(td).forEach(bell => {
					Object.keys(td[bell]).forEach(id_task => {
						td[bell][id_task] = td[bell][id_task].filter(i => (Date.now() - (i.__added || 0)) < delta_added);
						if (td[bell][id_task].length === 0) delete td[bell][id_task];
					});
				});
			}, 90);
		},
		onLogout: function() {
			App.in_app_notifications.event.task_data = {};
			App.in_app_notifications.event.queue = {};
			App.in_app_notifications.event.show.reset();
			App.helper.cron.remove('in_app_notify_clear_task_data');
		},

		onBoot: function() {
			App.bus.window.on('active', () => self.on_active());
			App.bus.msg.on('in_app_notify_clear_bell', (payload) => self.on_clear_bell(payload.type));
			App.bus.state
				.on('comment_add', function (payload) {
					if (payload.data.chat_name) {
						self.event.add_task_data(self.types.message.new, payload.data.id_task, payload.data);
					} else {
						self.event.add_task_data(self.types.comment.new, payload.data.id_task, payload.data);
					}
				})
				.on('event_add', (payload) => self.event.process(payload.id, payload.data))
				.on('task_seen', (payload) => self.on_task_seen(payload.id));
		},
	};
})();

;var App = App || {};

App.integration = {

	onBoot: function () {
		this.desktop.onBoot();
		this.test.init();
		App.bus.app.on('profile_loading', function () {
			App.integration.viber.destructor();
			App.integration.telegram.destructor();
		});
	},
	onLogin: function () {
		this.desktop.onLogin();
	},
	onLogout: function () {
		this.desktop.onLogout();
	},

	test: {
		request: null,
		init: function () {
			this.request = App.core.async_task.context('integration.test');
		},
		desktop: App.helper.debounce(function (endpoint) {
			App.integration.test.request.ajax(endpoint);
		}, 1000),
		mobile: App.helper.debounce(function (endpoint) {
			App.integration.test.request.ajax(endpoint);
		}, 1000),
	},

	desktop: {
		doing: false,
		config: null,
		provider: null,
		locale: {},
		asking: false,
		asked: false,
		is_supported: function() {
			return this.provider != null && this.provider.isActive && "Notification" in window && this.config?.is_supported;
		},
		is_denied: function() {
			return "Notification" in window && Notification.permission === 'denied';
		},
		is_granted: function() {
			return "Notification" in window && Notification.permission === 'granted';
		},
		ready: function(data) {
			if (!this.is_supported()) return;
			if (this.config.should_show_offer) return this.show_offer();
			if (this.config.disabled_at) return;

			if (this.config.is_enabled && this.is_denied() && this.config.subscribed_at) {
				this.show_denied_msg();
				this.config.subscribed_at = 0;
				App.core.async_task.ajax(App.helper.endpoint.primary() + '?' + App.actions.get('desktop_notifications:error'));
			} else if (this.config.is_enabled && this.is_granted() && (App.helper.time.now() - this.config.subscribed_at > this.config.refresh_period || !data.has_service_worker || !this.config.subscribed_at)) {
				this.subscribe();
			} else if (this.config.is_enabled && !this.is_denied() && !this.is_granted() && App.helper.localStorage.get('dsk_allow_reask', true)) {
				App.helper.localStorage.set('dsk_allow_reask', false, 30*24*3600);
				this.subscribe();
			}
		},
		show_offer: App.helper.debounce(function () {
			let dsk = App.integration.desktop;

			if (dsk.is_supported() && !dsk.is_denied()) dsk.show_ask();
		}, 5000),
		show_denied_msg: App.helper.debounce(function () {
			App.message.info(App.integration.desktop.locale.enable_instructions);
		}, 5000),
		show_ask: function () {
			if (this.asking) return;

			this.show_offer.clear();
			this.show_denied_msg.clear();

			if (!this.is_supported()) {
				App.message.warning(this.locale.not_supported);
				return;
			}

			if (this.is_denied()) {
				App.message.warning(this.locale.enable_instructions);
				return;
			}

			this.asking = true;
			App.modal.show(this.config.offer_modal);
		},
		subscribe: function(next) {
			if (this.doing) return;

			this.show_offer.clear();
			this.show_denied_msg.clear();

			this.doing = true;
			this.provider.subscribe().then((token) => {
				this.config.subscribed_at = App.helper.time.now();
				this.config.disabled_at = 0;
				App.bus.app.emit('desktop_push_updated');
				return App.core.async_task.ajax(App.helper.endpoint.primary() + '?' + App.actions.get('desktop_notifications:register')+'&code='+encodeURIComponent(token));
			}).then(next).catch((err) => {
				App.core.error('desktop:subscribe', err);
				this.config.subscribed_at = 0;
				App.core.async_task.ajax(App.helper.endpoint.primary() + '?' + App.actions.get('desktop_notifications:error'));
			}).finally(() => this.doing = false);
		},
		unsubscribe: function() {
			if (this.doing || !this.is_supported()) return;

			this.doing = true;
			this.provider.unsubscribe().then(token => {
				this.config.subscribed_at = 0;
				this.config.disabled_at = App.helper.time.now();
				App.bus.app.emit('desktop_push_updated');
				return App.core.async_task.ajax(App.helper.endpoint.primary() + '?' + App.actions.get('desktop_notifications:unregister')+'&code='+encodeURIComponent(token || ''));
			}).catch((err) => {
				App.core.error('desktop:unsubscribe', err);
			}).finally(() => this.doing = false);
		},
		decline_offer: function () {
			this.on_decline_offer();
			App.modal.hide();
		},
		accept_offer: function () {
			this.asking = false;
			this.subscribe(() => {
				if (!this.config.is_enabled) App.core.async_task.ajax(this.config.accept_endpoint);
			});
			App.modal.hide();
		},
		is_enabled_changed: function () {
			if (!App.core.is_active() || !this.config.is_enabled || this.config.disabled_at) return;

			if (this.is_granted() && App.helper.time.now() - this.config.subscribed_at >= this.config.refresh_period) {
				this.subscribe();
			} else if (!this.config.subscribed_at) {
				this.show_ask();
			} else if (!this.is_granted() && !this.is_denied()) {
				this.show_ask();
			} else if (this.is_denied()) {
				this.show_denied_msg();
			}
		},
		on_decline_offer: function () {
			this.asking = false;
			App.core.async_task.ajax(App.helper.endpoint.primary() + '?' + App.actions.get('desktop_notifications:error'));
		},
		onBoot: function () {
			let self = this;
			self.provider = App.core.desktop_firebase_message;
			App.bus.desktop_firebase_message.on('active', (data) => this.ready(data));
			App.bus.state.on('user', (user) => {
				if (user.id === App.me.id && user.data.notify && self.config.is_enabled !== user.data.notify.is_desktop) {
					self.config.is_enabled = user.data.notify.is_desktop;
					self.is_enabled_changed();
				}
			});
			App.bus.app.on('modal_unload modal_closing', function () {
				if (self.asking) self.on_decline_offer();
			});

			// const push_on_foreground = false;
			// if (push_on_foreground) App.bus.desktop_firebase_message.on('message', function (payload) { // foreground (when has active tab) messages only! (background processing in workers/firebase-messaging-sw.js)
			//
			// 	if (window.location.href !== payload.data.url) {
			// 		const notification = new Notification(payload.data.title, { body: payload.data.body, icon: window.location.origin + '/assets/img/favicon/favicon.ico' });
			// 		notification.onclick = function() {
			// 			App.core.goto(payload.data.url);
			// 			notification.close();
			// 		};
			// 	}
			//
			// 	// App.bus.app.emit('notification', {
			// 	// 	id: payload.messageId,
			// 	// 	body: payload.data.body,
			// 	// 	title: payload.data.title,
			// 	// 	url: payload.data.url,
			// 	// }, { desktop_firebase: true });
			// }).on('notification_click', function (payload) {
			// 	if (payload.data.url) {
			// 		App.core.goto(payload.data.url);
			// 	}
			// });
		},
		onLogin: function() {
			this.locale = App.object_state.locale.desktop_notifications;
			this.config = App.core.context.use('desktop_notifications', { subscribed_at: false, allow_offer: false, offer_modal: null, refresh_period: 0, is_enabled: false, accept_endpoint: '', });
		},
		onLogout: function () {
			this.show_offer.clear();
			this.show_denied_msg.clear();
			App.helper.localStorage.del('dsk_allow_reask');
		}
	},

	telegram: {
		request: null,
		timeout: null,
		timeout_max: null,
		verify: function() {
			App.integration.telegram.request = $.getScript(App.helper.endpoint.primary() + '?' + App.actions.get('telegram_register_verify:do'));
		},
		repeat_verify: function()
		{
			if (App.integration.telegram.timeout) clearTimeout(App.integration.telegram.timeout);
			if (App.integration.telegram.timeout_max) clearTimeout(App.integration.telegram.timeout_max);
			App.integration.telegram.timeout_max = setTimeout(function() {
				clearTimeout(App.integration.telegram.timeout);
			}, 120000);
			App.integration.telegram.timeout = setTimeout(App.integration.telegram.verify, 3000);
		},
		destructor: function() {
			if (App.integration.telegram.timeout) clearTimeout(App.integration.telegram.timeout);
			if (App.integration.telegram.timeout_max) clearTimeout(App.integration.telegram.timeout_max);

			if (!App.integration.telegram.request) return;
			App.integration.telegram.request.abort();
			App.integration.telegram.request = null;
		},
	},

	viber: {
		request: null,
		timeout: null,
		timeout_max: null,
		verify: function() {
			App.integration.viber.request = $.getScript(App.helper.endpoint.primary() + '?' + App.actions.get('viber_register_verify:do'));
		},
		repeat_verify: function()
		{
			if (App.integration.viber.timeout) clearTimeout(App.integration.viber.timeout);
			if (App.integration.viber.timeout_max) clearTimeout(App.integration.viber.timeout_max);
			App.integration.viber.timeout_max = setTimeout(function() {
				clearTimeout(App.integration.viber.timeout);
			}, 120000);
			App.integration.viber.timeout = setTimeout(App.integration.viber.verify, 3000);
		},
		destructor: function() {
			if (App.integration.viber.timeout) clearTimeout(App.integration.viber.timeout);
			if (App.integration.viber.timeout_max) clearTimeout(App.integration.viber.timeout_max);

			if (!App.integration.viber.request) return;
			App.integration.viber.request.abort();
			App.integration.viber.request = null;
		},
	},

	messenger: {
		timeout: null,
		timeout_max: null,
		verify: function() {
			$.getScript(App.helper.endpoint.primary() + '?' + App.actions.get('messenger_register_verify:do'));
		},
		repeat_verify: function()
		{
			if (App.integration.messenger.timeout) clearTimeout(App.integration.messenger.timeout);
			if (App.integration.messenger.timeout_max) clearTimeout(App.integration.messenger.timeout_max);
			App.integration.messenger.timeout_max = setTimeout(function() {
				clearTimeout(App.integration.messenger.timeout);
			}, 120000);
			App.integration.messenger.timeout = setTimeout(App.integration.messenger.verify, 3000);
		}
	}
}

;var App = App || {};

const ROLE_READER = 2;
const ROLE_ADMIN_DEP = 10;

(function () {
	let self = App.invite = {

		locale: {},
		is_ajax: '',

		quota_users: 0,
		quota_readers: 0,

		default_project: 0,

		callback: null,

		show: function(endpoint, options = {}) {

			if (typeof options === 'function') {
				self.callback = options;
				options = {};
			}

			App.modal.show({ url: endpoint, group: 'invite', backup: true, ...options });
		},

		projects: {
			init: function() {
				let input = App.modal.obj_window.find('input[name="ids_project"]');
				App.controls.editBlock_picker.init(App.modal.obj_window.find('#menuInviteProjects'), App.modal.obj_window.find('.editBlock__picker-fake.editBlock__picker-projects'), function(ids) {
					input.val(ids.join(',')).attr('data-ids-min', ids.join(','));
					App.invite.update_counter();
					if (!$('#menuInviteProjects .menu__item:not(.menu__item-picked)').length) {
						$('#menuInviteProjects .editBlock__picker__item').trigger('click', [{delete: true}]);
						App.menu.hide();
						App.modal.obj_window.find('.select-all').click();
					}
				}, {
					templates: {
						item: 'editBlock_picker_project',
						group: 'editBlock_picker_folder'
					},
					search_selector: '.menu__item[data-id]',
				});
				App.modal.obj_window.find('.editBlock__bigSwitch').click(function () {
					if (input.attr('data-ids-min')) $(this).hide().next().show();
					else $(this).hide().next().show().click();
					input.val(input.attr('data-ids-min'));
					App.invite.update_counter();
				});
				App.modal.obj_window.find('.select-all').click(function () {
					App.modal.obj_window.find('.editBlock__bigSwitch').show().next().hide();
					input.attr('data-ids-min', input.val());
					input.val(input.attr('data-ids-max'));
					App.invite.update_counter();
					return false;
				});
			},

			_render_label: function (count) {
				if (App.device.is_mobile()) {
					$('#invite > .editBlock__picker-projects .editBlock__picker__header .label')
						.replaceWith(App.helper.template.fill('editBlock_picker_label', {
							label: self.locale.project_picker_label,
							count: count
						}));
					$('#menuInviteProjects .editBlock__picker-projects .editBlock__picker__header .label')
						.replaceWith(App.helper.template.fill('editBlock_picker_label', {
							label: self.locale.project_picker_label_short,
							count: count
						}));
				} else {
					$('#invite > .editBlock__picker-projects .editBlock__picker__header .label')
						.add('#menuInviteProjects .editBlock__picker-projects .editBlock__picker__header .label')
						.replaceWith(App.helper.template.fill('editBlock_picker_label', {
							label: self.locale.project_picker_label,
							count: count
						}));
				}
			},

			_render_label_empty: function () {
				$('#invite > .editBlock__picker-projects .editBlock__picker__header .label')
					.add('#menuInviteProjects .editBlock__picker-projects .editBlock__picker__header .label')
					.replaceWith(App.helper.template.fill('editBlock_picker_label_error', {
						label: self.locale.project_picker_label_empty
					}));
			},
		},

		emails: {
			list: new Set(),
			allowed_domains: null,
			count: 0,
			validate: function (email) {
				if (App.invite.emails.allowed_domains && !App.invite.emails.allowed_domains.test(email)) return false;
				return App.helper.validate.email.test(email);
			},

			normalize: function (email) {
				return email.trim().toLowerCase();
			},

			add: function (email) {

				const email_normalized = self.emails.normalize(email);
				if (this.list.has(email_normalized)) return false;
				this.list.add(email_normalized);

				$('#invite > .editBlock__picker-emails .editBlock__picker__search').before(App.helper.template.fill('editBlock_picker_email', {
					name: email,
					email: email,
					class: App.invite.emails.validate(email) ? '' : 'editBlock__picker__item-error',
				}));
				App.invite.update_counter();
			},

			add_html: function (html) {

				if (html.trim() === '') {
					App.message.error(App.invite.locale.error_empty_file);
					return;
				}

				const items = $(html);
				const unique_items = items.filter(function () {
					const email = $(this).find('input[name="email[]"]').val();
					const email_normalized = self.emails.normalize(email);
					if (self.emails.list.has(email_normalized)) return false;
					self.emails.list.add(email_normalized);
					return true;
				});

				$('#invite .editBlock__picker-emails .editBlock__picker__search').before(unique_items);
			},

			init: function () {
				const picker = $('#invite > .editBlock__picker-emails');
				const picker_keyboardZone = picker;
				const picker_scrollZone = picker.find('.scrollZone');

				if (!picker.attr('data-focus')) picker.attr('data-focus', '#invite > .editBlock__picker-emails .editBlock__picker__search input');

				picker.bind('click', function (e) {
					if ($(e.target).closest('.ps__rail-y, .ps__rail-x').length) return true;
					if ($(e.target).closest('ws-btn').length) return true;
					App.keyboard_selection.set_active_container(picker_keyboardZone);
					$('#invite > .editBlock__picker-emails .editBlock__picker__search input').focus();
				});

				picker.on('click', '.editBlock__picker__item', function(e, data) {
					data ||= {};
					const is_mobile_delete = App.device.is_mobile() && $(this).hasClass('selected'); // на мобілці видаляється при дабл тапі (якщо не в хрестик)
					const is_button_delete = $(e.target).closest('.delete').length > 0;
					if (!data.delete && !data.enter && !is_button_delete && !is_mobile_delete) {
						if ($(this).hasClass('selected')) $(this).toggleSelected(false);
						else {
							// треба щоб фокус ставився в поле, але не скролило до нього
							$('#invite > .editBlock__picker-emails .editBlock__picker__search input').focus_enhanced({
								desktop_only: true,
								restore_scroll: true,
								callback: () => {
									picker.find('.selected').toggleSelected(false);
									$(this).toggleSelected(true);
								}
							});
						}
						return false;
					}

					// обирати щось взамін, тільки якщо це дія з клавіатури
					let closest_sibling_item;
					if (data.delete || data.enter) {
						closest_sibling_item = App.keyboard_selection.find_closest_sibling(picker_keyboardZone, data.backward || false);
					}

					const email = $(this).find('input[name="email[]"]').val();
					const email_normalized = self.emails.normalize(email);
					self.emails.list.delete(email_normalized);
					$(this).remove();

					App.invite.update_counter();
					if (closest_sibling_item && closest_sibling_item.length) {
						closest_sibling_item.toggleSelected(true);
					}
					$('#invite > .editBlock__picker-emails .editBlock__picker__search input').focus_enhanced({
						desktop_only: true,
						restore_scroll: true
					});
					picker_scrollZone.scrollUpdate();

					// щоб не прокидувалась подія далі (де ставиться фокус в поле, що заважає на мобілці)
					return false;
				})

				picker.find('.editBlock__picker__search input').once_by_criteria('invite_init').bind('keydown', function (e) {
					let keyCode = e.which || e.keyCode || e.charCode;
					if (!this.value && keyCode === App.keycode.Backspace) {
						if (picker.find('.selected').length) {
							picker.find('.selected').trigger('click', [{delete: true, backward: true}]);
						} else if (!picker.find('.selected').length) {
							$('#invite > .editBlock__picker-emails .editBlock__picker__body').children('.editBlock__picker__item').eq(-1).toggleSelected(true);
						}
					} else if (!this.value && keyCode === App.keycode.Delete && !$(this).closest('.search_started').length) {
						if (picker.find('.selected').length) {
							picker.find('.selected').trigger('click', [{delete: true}]);
						}
					} else if (keyCode !== App.keycode.ArrowLeft && keyCode !== App.keycode.ArrowRight && keyCode !== App.keycode.ArrowUp && keyCode !== App.keycode.ArrowDown && keyCode !== App.keycode.Enter) {
						picker.find('.selected').toggleSelected(false);
						if (keyCode == App.keycode.Tab) {
							$(this).blur();
						}
					}
					if (this.value && keyCode === App.keycode.Enter) { // enter
						if (App.helper.validate.email.test(this.value)) {
							App.invite.emails.add(this.value);
							this.value = '';
						}
					}
				})
				.bind('keyup paste blur', function () {
					let is_ok = false;
					while (/^([^\s;,]+)[\s;,]/i.test(this.value)) {
						let email = RegExp.$1;
						App.invite.emails.add(email);
						this.value = this.value.replace(/^([^\s;,]+)[\s;,]/i, '');
						is_ok = true;
					}
					if (is_ok && App.helper.validate.email.test(this.value)) {
						App.invite.emails.add(this.value);
						this.value = '';
					}
				})
				.bind('blur', function () {
					if (App.helper.validate.email.test(this.value)) {
						App.invite.emails.add(this.value);
						this.value = '';
					}
				})
				.bind('input', function () {
					picker_scrollZone.scrollBottom();
				})
				.bind('focus', function () {
					picker.addClass('focus');
					picker_scrollZone.scrollBottom();
				})
				.bind('blur', function () {
					picker.removeClass('focus');
				});

				setTimeout(function () {
					$('#invite > .editBlock__picker-emails .editBlock__picker__search input').focus();
				}, 50);

				picker.on('onselect', '.editBlock__picker__item', function () {

					// з клавіатури там своя система
					if (!App.keyboard_selection.is_mouse_moved) return true;

					$(this).scrollIntoViewIfNeeded({
						offset_top: 8 + (parseFloat(picker_scrollZone.css('padding-top')) || 0),
						offset_bottom: parseFloat(picker_scrollZone.css('padding-bottom')) || 0,
					});
				});
			},

			_render_label: function (count) {
				$('#invite > .editBlock__picker-emails .editBlock__picker__header .label')
					.add('#menuInviteProjects .editBlock__picker-emails .editBlock__picker__header .label')
					.replaceWith(App.helper.template.fill('editBlock_picker_label', {
						label: self.locale.email_picker_label,
						count: count
					}));
			},

			_render_label_empty: function () {
				$('#invite > .editBlock__picker-emails .editBlock__picker__header .label')
					.add('#menuInviteProjects .editBlock__picker-emails .editBlock__picker__header .label')
					.replaceWith(App.helper.template.fill('editBlock_picker_label_error', {
						label: self.locale.email_picker_label_empty
					}));
			},

			_render_label_error: function (error_message) {
				$('#invite > .editBlock__picker-emails .editBlock__picker__header .label')
					.add('#menuInviteProjects .editBlock__picker-emails .editBlock__picker__header .label')
					.replaceWith(App.helper.template.fill('editBlock_picker_label_error', {
						label: error_message
					}));
			},

			destructor: function () {
				self.emails.list = new Set();
			}
		},

		contacts: {
			init: function () {
				const picker = $('#invite > .editBlock__picker-emails');
				const picker_scrollZone = picker.find('.scrollZone');

				picker.on('click', '.editBlock__picker__item', function(e) {
					const is_mobile_delete = App.device.is_mobile() && $(this).hasClass('selected'); // на мобілці видаляється при дабл тапі (якщо не в хрестик)
					const is_button_delete = $(e.target).closest('.delete').length > 0;
					if (!is_button_delete && !is_mobile_delete) {
						if ($(this).hasClass('selected')) $(this).toggleSelected(false);
						else {
							picker.find('.selected').toggleSelected(false);
							$(this).toggleSelected(true);
						}
						return false;
					}
					App.invite.contacts.remove(this);
					picker.find('.editBlock__picker__counter').text(
						picker.find('.editBlock__picker__body').find('.editBlock__picker__item').length
					);
					picker_scrollZone.scrollUpdate();
				});

				picker.on('onselect', '.editBlock__picker__item', function () {
					$(this).scrollIntoViewIfNeeded({
						offset_top: 8 + (parseFloat(picker_scrollZone.css('padding-top')) || 0),
						offset_bottom: parseFloat(picker_scrollZone.css('padding-bottom')) || 0,
					});
				});

				App.modal.obj_window.find('#vcard2CSV').on('click', function () {
					const content = 'E-mail;First Name;Last Name;Title;Phone;Mobile Phone;Business Phone;Home Phone;Web Page';
					const encoded_uri = encodeURI('data:text/csv;charset=utf-8,' + content);
					$(this).attr('href', encoded_uri);
					$(this).attr('download', 'contacts_template.csv');
				});
			},
			remove: function (el) {
				$(el).remove();
				if (!$('#invite > .editBlock__picker-emails .editBlock__picker__body').find('.editBlock__picker__item').length) {
					App.modal.obj_window.find('.inputBlock__wrapper > div').removeClass('ws-utility-hidden');
					const ava_place_el = App.modal.obj_window.find('.inputBlock__wrapper .contacts-img-input-row').find('.ava_place');
					if (ava_place_el.length && ava_place_el.data('original')) {
						ava_place_el.replaceWith(ava_place_el.data('original'));
					}
					$('#invite').addClass('ws-utility-hidden');
					document.activeElement.blur();
					document.invite_frm.is_mass.value='';
					$('.blank').removeClass('blank_mass');
					$('#invite_csv2').val('');
				}
				$('#invite').closest('form').trigger('change');
			},
			add_html: function (html) {
				if (html.trim() === '') {
					App.message.error(App.invite.locale.error_empty_file);
					return;
				}

				document.activeElement.blur();
				document.invite_frm.is_mass.value='1';
				$('.blank').addClass('blank_mass');
				$('#invite').removeClass('ws-utility-hidden');
				App.modal.obj_window.find('.inputBlock__wrapper > div:not(.contacts-img-input-row)').addClass('ws-utility-hidden');
				const ava_place_el = App.modal.obj_window.find('.inputBlock__wrapper .contacts-img-input-row').find('.ava_place');
				if (ava_place_el.length && !ava_place_el.data('original')) {
					const container = ava_place_el.parent();
					const new_ava_place_el = $(App.helper.template.fill('contact_add_mass_avatar'));
					new_ava_place_el.data('original', ava_place_el.detach());
					container.prepend(new_ava_place_el);
				}
				$('#invite > .editBlock__picker-emails .editBlock__picker__body').append(html);
				$('#invite > .editBlock__picker-emails .editBlock__picker__counter').text(
					$('#invite > .editBlock__picker-emails .editBlock__picker__body').find('.editBlock__picker__item').length
				);
				$('#invite').closest('form').trigger('change');
			},
		},

		recalc_pickers_height: function () {

			if (!App.device.is_mobile()) return;

			const $invite = $('#invite');
			if (!$invite.length) return;
			const $pickers = $invite.find('.editBlock__picker:visible');
			if (!$pickers.length) return;

			try {
				// Скидаємо обмеження
				$pickers.css('max-height', '');

				const $modal_content = App.modal.obj_window.find('.modal__content__block');
				const win_height = $modal_content.height();
				const win_scroll_height = $modal_content.get(0).scrollHeight;

				// Якщо нічого не переповнено — нічого не робимо
				if (win_scroll_height <= win_height) return;

				// Тимчасово ховаємо пікери, щоб дізнатись висоту іншого контенту
				$pickers.hide();
				const fixed_height = $invite.height();
				$pickers.show();

				// Доступна висота для пікерів
				let available_height = win_height - fixed_height;

				// Враховуємо вертикальні марджіни
				let total_margins = 0;
				const margins = new WeakMap();
				$pickers.each(function () {
					const $el = $(this);
					let this_margins = parseFloat($el.css('margin-top')) || 0;
					this_margins += parseFloat($el.css('margin-bottom')) || 0;
					total_margins += this_margins;
					margins.set($el.get(0), this_margins);
				});
				available_height -= total_margins;

				// Мінімальна комфортна висота, навіть якщо вилізе за межі ~3.5 рядки
				const MIN_PICKER_HEIGHT = 156;
				const min_total_height = MIN_PICKER_HEIGHT * $pickers.length + total_margins;

				if (available_height < min_total_height) {
					available_height = min_total_height;
				}

				// Якщо відкрита клавіатура — розширюємо лише пікер, що в фокусі
				if ($('body').hasClass('w_keyboard')) {
					const $focused_picker = $(document.activeElement).closest('.editBlock__picker').filter($pickers);
					if ($focused_picker.length) {
						const target_height = Math.max(win_height - margins.get($focused_picker.get(0)), MIN_PICKER_HEIGHT);
						$focused_picker.css('max-height', target_height)
							.find('.scrollZone').scrollBottom();
					}
					return;
				}

				// Отримуємо натуральну (внутрішню) висоту кожного пікера
				const picker_data = $pickers.map(function () {
					return {
						el: this,
						$el: $(this),
						natural: this.scrollHeight
					};
				}).get();

				// Сумарна "природна" висота
				const total_natural = picker_data.reduce((sum, p) => sum + p.natural, 0);

				// Якщо все вміщається — нічого не обмежуємо
				if (total_natural <= available_height) return;

				// Визначаємо, хто не переповнений
				const not_overfilled = picker_data.filter(p => p.natural <= available_height / $pickers.length);
				const overfilled = picker_data.filter(p => p.natural > available_height / $pickers.length);

				// Рахуємо, скільки місця вже "зайняли" не переповнені
				let used_height = not_overfilled.reduce((sum, p) => sum + p.natural, 0);
				let remaining_height = available_height - used_height;

				// Якщо всі переповнені — ділимо порівну
				if (!not_overfilled.length) {
					const equal_height = available_height / $pickers.length;
					$pickers.css('max-height', equal_height)
						.find('.scrollZone').scrollBottom();
					return;
				}

				// Якщо частина переповнена — ділимо залишок між ними
				const per_overfilled_height = remaining_height / overfilled.length;
				overfilled.forEach(
					p => p.$el.css('max-height', per_overfilled_height)
						.find('.scrollZone').scrollBottom()
				);
			} finally {
				$invite.closest('.scrollZone').scrollUpdate();
			}
		},

		update_counter: function (on_start) {

			self.recalc_pickers_height();

			if (!on_start) App.controls.editblock.set_updated_state();
			$('#upgr_text').hide().next().show()
			$('#upgr_link').hide();
			let cnt_email = $('#invite > .editBlock__picker-emails .editBlock__picker__body .editBlock__picker__item').not('.editBlock__picker__item-error').length;
			let cnt_project = App.modal.obj_window.find('input[name="ids_project"]').val().split(',').filter(Number).length;
			let is_project_available = $('#invite > .editBlock__picker-projects').length;
			self.projects._render_label(cnt_project);
			if (self.emails.count != cnt_email) {
				self.emails._render_label(cnt_email);
			}
			$('#inv_but1_1, #inv_but1_2').toggleClass('button_dis2', !( cnt_email && (cnt_project || !is_project_available) ));
			$('#inv_but2_1, #inv_but2_2').toggleClass('button_dis2', !( cnt_project || !is_project_available ));
			if (cnt_email) {
				App.modal.obj_window.find('.only_inv_email').show();
			}
			App.invite.quota_users = +App.invite.quota_users;
			App.invite.quota_readers = +App.invite.quota_readers;
			let cnt_invite = Math.min(cnt_email, App.invite.quota_users + App.invite.quota_readers)
			if (cnt_invite) $('#inv_but1_1 span').html(($('#inv_role_').val() == 1 ? App.invite.locale['button_add_contact'] : App.invite.locale['button_invite_user']).replace('%1%', cnt_invite ? App.format.quantity(cnt_invite, App.invite.locale['cnt_user'], QTY_WITH_TEXT) : '').replace('%2%', cnt_project ? App.format.quantity(cnt_project, App.invite.locale['cnt_project'], QTY_WITH_TEXT) : App.invite.locale['account']));
			else $('#inv_but1_1 span').html($('#inv_role_').val() == 1 ? App.invite.locale['need_email'] : App.invite.locale['invite_to_account']);
			if ($('#user_limit').length) {
				let o = $('#invite > .editBlock__picker-emails .editBlock__picker__body .editBlock__picker__item:not(.editBlock__picker__item-error)');
				o.find('ws-icon[name*=roles]').remove();
				if ($('#inv_role_').val() == ROLE_READER) {
					o.slice(0, App.invite.quota_readers).removeClass('editBlock__picker__item-error2');
					o.slice(App.invite.quota_readers).addClass('editBlock__picker__item-error2').find('.chip').prepend('<ws-icon name="roles/contact" data-title="' + App.invite.locale['contact'] + '"></ws-icon>');
					if (App.invite.quota_users) $('#user_limit').next().hide();
					if (o.length > App.invite.quota_readers) {
						self.emails._render_label_error(App.invite.locale['upgrade_readers']);
						$('#upgr_link').show().attr('data-title', App.invite.locale['quota_reach_readers']);
					} else if (App.invite.quota_readers === 0) {
						self.emails._render_label_error(App.invite.locale['upgrade_readers']);
						$('#upgr_link').show().attr('data-title', App.invite.locale['quota_reach_readers']);
					}
				} else {
					o.slice(0, App.invite.quota_users).removeClass('editBlock__picker__item-error2');
					o.slice(App.invite.quota_users, App.invite.quota_users + App.invite.quota_readers).addClass('editBlock__picker__item-error2').find('.chip').prepend('<ws-icon name="roles/reader" data-title="' + App.invite.locale['reader'] + '"></ws-icon>');
					o.slice(App.invite.quota_users + App.invite.quota_readers).addClass('editBlock__picker__item-error2').find('.chip').prepend('<ws-icon name="roles/contact" data-title="' + App.invite.locale['contact'] + '"></ws-icon>');
					if (o.length > App.invite.quota_users) {
						self.emails._render_label_error(App.invite.locale['upgrade_users']);
						$('#upgr_link').show().attr('data-title', App.invite.locale['quota_reach_users']);
					} else if (App.invite.quota_users === 0) {
						self.emails._render_label_error(App.invite.locale['upgrade_users']);
						$('#upgr_link').show().attr('data-title', App.invite.locale['quota_reach_users']);
					}
				}
			}
			if (App.invite.emails.count != cnt_email) {
				App.invite.emails.count = cnt_email;
			}
		},

		submit: function (el) {
			if ($(el).hasClass('button_dis2') || $(el).hasClass('button_dis3')) {
				$(el).animate_css('head-shake');

				let cnt_email = $('#invite > .editBlock__picker-emails .editBlock__picker__body .editBlock__picker__item').not('.editBlock__picker__item-error').length;
				let cnt_project = App.modal.obj_window.find('input[name="ids_project"]').val().split(',').filter(Number).length;
				let error_showed = false;
				if (!cnt_email) {
					self.emails._render_label_empty();
					if (App.device.is_mobile()) {
						$('#invite > .editBlock__picker-emails').scrollIntoViewIfNeeded({ offset_block: 8 });
					} else {
						$('#invite > .editBlock__picker-emails .editBlock__picker__search input').focus();
					}
					error_showed = true;
				}
				if (!cnt_project) {
					self.projects._render_label_empty();
					if (!error_showed) {
						$('#invite > .editBlock__picker-projects').scrollIntoViewIfNeeded({ offset_block: 8 });
						error_showed = true;
					}
				}
				return false;
			}
			if (!$(el).hasClass('button_dis')) {
				$(el).addClass('button_dis');
				let inm_hash = '';
				App.modal.obj_window.find('form.primary').find('input[name^=email]').each(function () {
					this.value = this.value.trim();
					if (this.value) inm_hash += this.value.substring(0, 1) + this.value.length;
				});
				$('#inm_hash').val(inm_hash);
				if (!inm_hash) return false;
				App.controls.editblock.set_updated_state(false);
				$.ajax({
					type: 'POST',
					url: App.modal.obj_window.find('form.primary').attr('action'),
					data: 'is_ajax=' + App.invite.is_ajax + '&is_project=' + $('#invite > .editBlock__picker-projects .editBlock__picker__body .editBlock__picker__item[rel='+ App.invite.default_project +']').length+ '&' + App.modal.obj_window.find('form.primary').serialize(),
					dataType: 'script',
					success: function() {
						if (self.callback) self.callback.call();
						// TODO якщо десь треба закриття, то в response має бути App.modal.hide();
						// if (App.env === 'local' && App.modal.is_shown()) debugger;
						// App.modal.hide();
					}
				});
			}
		},

		create_invite_link: function (el) {
			if ($(el).hasClass('button_dis2') || $(el).hasClass('button_dis3')) {
				let has_project = App.modal.obj_window.find('input[name="ids_project"]').val() != '';
				if (!has_project) self.projects._render_label_empty();
				$(el).animate_css('head-shake');
				$('#invite > .editBlock__picker-projects .editBlock__picker__search input').focus();
				return false;
			}
			App.modal.show({
				url: App.helper.url.add_query(App.modal.obj_window.find('form.primary').attr('action')) + 'is_ajax=invite_link&' + App.modal.obj_window.find('form.primary').serialize(),
				width: 450,
				title: App.invite.locale['invite_to_account'] + '...',
				group: 'invite'
			});
		},

		role: {
			init: function () {
				$('#inv_rolemenu .menu__item[data-id]').bind('click', function () {
					App.controls.menu.item_set_active(this);
					$('#inv_role .in').text($(this).find('.in').text()).next().val($(this).attr('data-id'));
					$('#inv_role').prev().replaceWith($(this).find('.space').html());
					App.menu.hide();
					App.invite.update_counter();
					self.role.validate();
					return false;
				});
			},

			validate: function () {
				if (!$('#inv_rolemenu').length) return;

				const role_input = $('#inv_role input');
				const form = role_input.closest('form');
				const id_group_sub = form.find('input[name=id_group_sub]').val();
				const add_group_sub = form.find('input[name=add_group_sub]').val();
				const role = role_input.val();
				const admin_dept_menu_item = $('#inv_rolemenu').find('.menu__item[data-id='+ROLE_ADMIN_DEP+']');
				const has_sub_group = add_group_sub || (id_group_sub && Number.parseInt(id_group_sub));
				const submit_buttons = $('#inv_but1_1, #inv_but1_2, #inv_but2_1, #inv_but2_2');

				if (has_sub_group) {
					admin_dept_menu_item.removeClass('menu__item-notPossible');
					role_input.removeClass('input_error');
					submit_buttons.removeClass('button_dis3');
				} else {
					admin_dept_menu_item.addClass('menu__item-notPossible');
					if (role == ROLE_ADMIN_DEP) {
						role_input.addClass('input_error').closest('.inputBlock__label').animate_css('head-shake');
						submit_buttons.addClass('button_dis3');
					} else {
						role_input.removeClass('input_error');
						submit_buttons.removeClass('button_dis3');
					}
				}
			}
		},

		init: function (options) {

			options ||= {};

			self.is_ajax = options.is_ajax ?? '';

			self.emails.init();
			self.projects.init();
			App.controls.editblock.init();
			self.role.init();

			self.update_counter(true);
		},

		destructor: function () {
			self.emails.destructor();
		},

		onBoot: function () {

			const recalc_pickers_height_debounced = App.helper.debounce(self.recalc_pickers_height, 100);

			App.bus.app.on('modal_unload modal_closing', function () {
				if (!App.modal.obj_window.find('#invite').length) return;
				self.destructor();
			});

			App.bus.window
				.on('resize', recalc_pickers_height_debounced)
				.on('resize_viewport', recalc_pickers_height_debounced)
				.on('keyboard_show', recalc_pickers_height_debounced)
				.on('keyboard_hide', recalc_pickers_height_debounced);
		},
	}
})();

;var App = App || {};

(function () {
	let self = App.invite_again = {

		show: function(anchor, options) {

			options ||= {};

			if (!options.id_user) throw new Error('id_user is required');

			const url = App.helper.url.add_query(App.helper.endpoint.user(options.id_user), App.actions.get('user_reinvite:show'));

			App.modal.show({ url, backup: true });
		},

		init: function () {
			const form = $('#reinvite_frm');
			const input = form.find('input[name=email]');
			let mode = form.attr('mode');

			let btn_loading = null;
			const start_loading = () => {
				if (btn_loading) btn_loading.ws_loading('start');
				input.prop('readonly', true);
			};
			const stop_loading = () => {
				if (btn_loading) {
					btn_loading.ws_loading('stop');
					btn_loading = null;
				}
				input.prop('readonly', false);
			};
			App.controls.editblock.init({
				btn_ok_selector: '.btn-apply',
				btn_cancel_selector: '.btn-cancel',
				onsubmit: function (btn) {

					if (!self.form_validate(input.val())) {
						App.controls.editblock.process_input_error('email', App.object_state.locale.validation_messages.email);
						return false;
					};

					btn_loading = $(btn);
					start_loading();
				},
				onsuccess: function () {
					try {
						if (mode === 'update') {
							input.data('initial-value', input.val());
							set_mode('send');
						} else {
							App.modal.hide();
						}
					} finally {
						stop_loading();
					}
				},
				onerror: function (xhr, body) {
					try {
						if (xhr.status === 422) {
							const validation_errors = JSON.parse(body)?.errors ?? {};
							(
								validation_errors?.email
								? App.controls.editblock.process_input_error('email', validation_errors.email)
								: null
							) || App.controls.editblock.process_form_error();
							return true;
						}
					} finally {
						stop_loading();
					}
				}
			});

			const form_action_container = form.find('.form_action_container');
			const form_action_templates = new Map();
			form.find('.form_action_template').each(function () {
				form_action_templates.set($(this).attr('data-mode'), this);
			});

			const set_mode = (new_mode) => {
				mode = new_mode;
				const template = form_action_templates.get(new_mode);
				if (template) {
					form_action_container.html(document.importNode(template.content, true));
				}
				form.attr('data-mode', new_mode);
			};

			input.data('initial-value', input.val());
			input.on('input', function () {
				const initial_value = $(this).data('initial-value');
				const current_value = $(this).val().trim();
				if (initial_value === current_value) {
					set_mode('send');
				} else {
					set_mode('update');
				}
			});
		},

		form_validate: function (email) {
			return App.invite.emails.validate(email);
		},

		// можна через масові - без редагування email
		/* apply: function(anchor, options) {

			options ||= {};

			App.mass.ids['resend'] = options.id_user;
			App.mass.validate_and_submit('resend', App.mass.ids['resend'], null, '/users/?noreturn=1');

			App.menu.hide();
		}, */
	}
})();

;/**
 *
 * @type {*[]}
 */

String.prototype.toInt = function() {
	return parseInt(this);
}
String.prototype.toIntArray = function() {
	return this.split(',').filter(Number).map(Number);
}
Number.prototype.clamp = function(min, max) {
	return Math.min(Math.max(this, min), max);
};
String.prototype.hashCode = function() {
	let hash = 0,	i, chr;
	if (this.length === 0) return hash;
	for (i = 0; i < this.length; i++) {
		chr = this.charCodeAt(i);
		hash = ((hash << 5) - hash) + chr;
		hash |= 0; // Convert to 32bit integer
	}
	return hash;
}
$.extend($.easing, {
	def: 'easeOutQuad',
	swing: function (x, t, b, c, d) {
		return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
	},
	easeInQuad: function (x, t, b, c, d) {
		return c * (t /= d) * t + b;
	},
	easeOutQuad: function (x, t, b, c, d) {
		return -c * (t /= d) * (t - 2) + b;
	},
	easeInOutExpo: function (x, t, b, c, d) {
		if (t == 0) return b;
		if (t == d) return b + c;
		if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
		return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
	}
});

$.fn.scrollIntoView = function (args) {
	if (this.length) {
		this[0].scrollIntoView(args ?? {behavior: 'smooth', block: 'start'});
	}
	return this;
};

$.fn.once_by_criteria = function (criteria) {
	return this.filter(function() {
		if ('bind_' + criteria in this) return false;
		this['bind_' + criteria] = true;
		return true;
	});
};

/**
 * костиль для меню, коли очистли всі події, але деякі треба повторно навішати
 * краще цей метод не використовувати, а правильно очищати лише ті події, котрі треба
*/
$.fn.clear_once_by_criteria = function(criteria) {
	return this.each(function() {
		delete this['bind_' + criteria];
	});
};

$.fn.scroll_to_this = function () {
	if (App.scroll_listener.stop_scroll_events) return;
	if (this.length) {
		let o = $($(this).get(0));
		pos = o.offset().top - 200;
		if (pos < 0) pos = 0;
		if (Math.abs($(window).scrollTop() - pos) < 100) {
			$(window).scrollTop(pos);
		} else {
			App.scroll_listener.stop_events();
			$('html, body').animate({scrollTop: pos}, 500, function () {
				App.scroll_listener.resume_events();
			});
		}
	}
	return this;
};

$.fn.reverseOrder = function () {
	return this.each(function () {
		$(this).prependTo($(this).parent());
	});
};

$.fn.hoverIntent = function (f, g) {
	let cfg = {sensitivity: 7, interval: 100, timeout: 0};
	cfg = $.extend(cfg, g ? {over: f, out: g} : f);
	let cX, cY, pX, pY;
	let track = function (e) {
		cX = e.pageX;
		cY = e.pageY
	};
	let compare = function (e, ob) {
		ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
		if ((Math.abs(pX - cX) + Math.abs(pY - cY)) < cfg.sensitivity) {
			$(ob).unbind("mousemove", track);
			ob.hoverIntent_s = 1;
			return cfg.over.apply(ob, [e])
		} else {
			pX = cX;
			pY = cY;
			ob.hoverIntent_t = setTimeout(function () {
				compare(e, ob)
			}, cfg.interval)
		}
	};
	let delay = function (e, ob) {
		ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
		ob.hoverIntent_s = 0;
		return cfg.out.apply(ob, [e])
	};
	let handleHover = function (e) {
		let ev = jQuery.extend({}, e);
		let ob = this;
		if (ob.hoverIntent_t) {
			ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t)
		}
		if (e.type == "mouseenter") {
			pX = ev.pageX;
			pY = ev.pageY;
			$(ob).bind("mousemove", track);
			if (ob.hoverIntent_s != 1) {
				ob.hoverIntent_t = setTimeout(function () {
					compare(ev, ob)
				}, cfg.interval)
			}
		} else {
			$(ob).unbind("mousemove", track);
			if (ob.hoverIntent_s == 1) {
				ob.hoverIntent_t = setTimeout(function () {
					delay(ev, ob)
				}, cfg.timeout)
			}
		}
	};
	return this.bind('mouseenter', handleHover).bind('mouseleave', handleHover)
}
$.fn.dp_class = function () {
	this.each(function () {
		if ($(this).attr('data-parent-class')) $(this).parent().attr('data-class', $(this).attr('data-parent-class'));
		else if ($(this).parent().attr('data-class')) $(this).parent().attr('data-class', '');
	});
	return this;
};

/**
 * Animates the CSS of the selected elements using the specified animation.
 * Find available animations in /css/inc/addon_animate.css
 *
 * @param {string} animation - The name of the animation to apply.
 * @param {object} options - The animation options.
 * @return {Promise<string[]>} A promise that resolves when all animations have ended. The resolved value is an array of strings indicating the completion of each animation.
 */
$.fn.animate_css = function(animation, options) {
	const prefix = 'worksection__';
	const {
		infinite = false,
		speed = null
	} = options || {};
	const classes = [
		`${prefix}${animation}`,
		`${prefix}animated`
	];
	if (speed) {
		classes.push(`${prefix}${speed}`);
	}
	if (infinite) {
		classes.push(`${prefix}infinite`);
	}
	const promises = this.map(function() {
		const node = this;
		node.animate_css = {
			stop: function() {
				node.classList.remove(...classes);
				delete node.animate_css;
			}
		};
		return new Promise((resolve) => {
			node.classList.add(...classes);

			// When the animation ends, we clean the classes and resolve the Promise
			function handle_animation_end(event) {
				event.stopPropagation();
				node.classList.remove(...classes);
				resolve('Animation ended');
			}

			node.addEventListener('animationend', handle_animation_end, { once: true });
		});
	}).get();

	return Promise.all(promises);
};

$.fn.shake = function (intShakes, intDistance, intDuration) {
	this.each(function () {
		$(this).css("position", "relative");
		for (let x = 1; x <= intShakes; x++) {
			$(this).animate({marginLeft: (intDistance * -1)}, (((intDuration / intShakes) / 4))).animate({marginLeft: intDistance}, ((intDuration / intShakes) / 2)).animate({marginLeft: 0}, (((intDuration / intShakes) / 4)));
		}
	});
	return this;
};

$.fn.shakeRight = function (intShakes, intDistance, intDuration) {
	this.each(function () {
		$(this).css("position", "relative");
		for (let x = 1; x <= intShakes; x++) {
			$(this).animate({marginRight: (intDistance * -1)}, (((intDuration / intShakes) / 4))).animate({marginRight: intDistance}, ((intDuration / intShakes) / 2)).animate({marginRight: 0}, (((intDuration / intShakes) / 4)));
		}
	});
	return this;
};

$.fn.ws_blue_off = function () {
	$(this).addClass('blue_on');
	setTimeout(function () {
		$(this).addClass('blue_off');
	}.bind(this), 200);
	setTimeout(function () {
		$(this).removeClass('blue_on blue_off');
	}.bind(this), 1500);
	return this;
}

$.fn.ws_fadeIn = function (prepared) {
	if (prepared && !$(this).hasClass('faded')) return false;
	$(this).removeClass('faded').addClass('pre_pulse');
	setTimeout(function () {
		$(this).addClass('pre_pulse2');
	}.bind(this), 0);
	setTimeout(function () {
		$(this).removeClass('pre_pulse pre_pulse2');
	}.bind(this), 1500);
	return this;
}

$.fn.pulse = function (nodelay) {
	$(this).removeClass('faded').addClass('pre_pulse');
	setTimeout(function () {
		$(this).addClass('pre_pulse2');
	}.bind(this), 0);
	setTimeout(function () {
		$(this).addClass('pulse').removeClass('pre_pulse pre_pulse2');
	}.bind(this), nodelay ? 10 : 1500);
	setTimeout(function () {
		$(this).removeClass('pulse');
	}.bind(this), nodelay ? 5500 : 7000);
	return this;
}

$.fn.blink = function () {
	this.stop().css({opacity: ''}).animate({opacity: 0.1}, function () {
		$(this).animate({opacity: 1}, function () {
			$(this).animate({opacity: 0.1}, function () {
				$(this).animate({opacity: 1}, function () {
					$(this).animate({opacity: 0.1}, function () {
						$(this).animate({opacity: 1}, function () {
							$(this).css({opacity: ''});
						});
					});
				});
			});
		});
	});
	return this;
};
$.fn.shortblink = function () {
	this.each(function () {
		$(this).animate({opacity: 0.1}, function () {
			$(this).animate({opacity: 1}, function () {
			});
		});
	});
	return this;
};

$.fn.copySuccessIcon = function (timeout = 500) {
	let icon = this.find('ws-icon').first();
	let icon_name = icon.attr('name');

	if (icon_name === 'check') return this;

	icon.attr('name', 'check');
	setTimeout(() => icon.attr('name', icon_name), timeout);

	return this;
};

$.fn.justtext = function () {
	return $(this).clone().children(':not(.qkey)').remove().end().text().trim();
};
$.fn.justtext2 = function () {
	return $(this).find('.av_sm').get(0).outerHTML + '<font>' + App.helper.html.encode($(this).justtext()) + '</font>'
};
$.fn.reverse = [].reverse;
$.fn.focus_enhanced = function (options) {

	options = typeof options === 'object' ? options : { keyup: options };
	const desktop_only = options.desktop_only ?? false;
	const keyup = options.keyup;
	const restore_scroll = options.restore_scroll; // бо якогось фіга не працює {preventScroll: true}
	const callback = () => {
		if (typeof options.callback !== 'function') return;
		options.callback.call(this);
	};

	if ((desktop_only && !App.device.is_mobile()) || !desktop_only) {

		let prev_scrollTop;
		let scrollZone;
		if (restore_scroll) {
			scrollZone = this.closest('.scrollZone');
			prev_scrollTop = scrollZone.scrollTop();
		}

		this.focus();
		if (keyup) {
			this.trigger('keyup');
		}

		if (restore_scroll && scrollZone) {
			requestAnimationFrame(() => {
				scrollZone.scrollTop(prev_scrollTop);
				callback.call(this);
			});
			return this;
		}
	}

	callback.call(this);
	return this;
};
$.fn.focus_desktop = function (keyup) {
	if (!App.device.is_mobile()) {
		this.focus();
		if (keyup) this.trigger('keyup');
	}
	return this;
};
$.fn.focus_select = function (keyup) {
	this.focus().select();
};
$.fn.focus_select_desktop = function (keyup) {
	if (!App.device.is_mobile()) {
		this.focus().select();
	}
};
$.fn.scrollAni = function (top) {
	this.animate({scrollTop: top}, 300);
};

$.fn.scrollDelay = function (top) {
	setTimeout((function (el) {
		return function () {
			el.scrollTop(top);
		};
	})(this), 10);
};

$.fn.removeInvite = function () {
	return this.each(function () {
		if ($(this).hasClass('it_invite')) {
			$(this).removeClass('it_invite');
			if (App.editor && App.editor.body) App.editor.body.find('.invite[rel=' + $(this).attr('rel') + ']').remove(); //.each(function() { $(this).replaceWith($(this).html()); });
		}
	});
};

$.fn.ws_reset = function () {
	return this.each(function () {
		this.reset();
		$(this).find('input[type=checkbox], input[type=radio]').each(function () {
			if ($(this).attr('data-checked')) this.checked = $(this).attr('data-checked') === 'yes';
			if (this.checked) $(this).parent().addClass('act').parent().addClass('pre_act');
			else $(this).parent().removeClass('act').parent().removeClass('pre_act');
		});
		$(this).find('[data-class]').each(function () {
			$(this).attr('class', $(this).attr('data-class'))
		});
		$(this).find('.eye_line a.def').not('act').trigger('click');
		// deprecated user <ws-slider ... data-def=""> instead
		$(this).find('ws-slider a.def').not('act').trigger('click');
		$(this).find('[data-def]').each(function () {
			$(this).val($(this).attr('data-def'))
		});
		$(this).find('[data-stored]').each(function () {
			$(this).html($(this).attr('data-stored'))
		});
		$(this).trigger('change');
	});
};

$.fn.ws_store_html = function () {
	return this.each(function () {
		if (!$(this).attr('data-stored')) {
			$(this).attr('data-stored', $(this).html());
		}
	});
};

$.fn.hasScrollBar = function (horizontal) {
	if (horizontal) return this.get(0).scrollWidth > this.outerWidth();
	return this.get(0).scrollHeight > this.outerHeight();
}

$.fn.canScrollToDirection = function (dir, horizontal) {
	if (!this.hasScrollBar(horizontal)) return false;
	let el = this.get(0);

	let roundedScrollTop = Math.floor(el.scrollTop);
	let isTop = el.scrollTop === 0;
	let isBottom = roundedScrollTop + el.offsetHeight === el.scrollHeight;
	let isLeft = el.scrollLeft === 0;
	let isRight =	el.scrollLeft + el.offsetWidth === el.scrollWidth;

	if (horizontal) {
		return dir === 1 ? !isRight : !isLeft;
	} else {
		return dir === 1 ? !isBottom : !isTop;
	}
}

$.fn.focus_to_end_desktop = function (keyup) {
	if (App.device.is_mobile()) return;

	this.first().focus().each(function () {
		this.setSelectionRange(this.value.length, this.value.length);
		if (keyup) $(this).trigger('keyup');
	});
};

$.fn.focus_to_end = function () {
	return this.focus().each(function () {
		this.setSelectionRange(this.value.length, this.value.length);
	})
}
$.fn.focus_and_select = function () {
	return this.focus().each(function () {
		this.setSelectionRange(0, this.value.length);
	})
}

$.fn.correct_click = function () {
	if (this.get(0).onclick || (this.data('events') && this.data('events').click && this.data('events').click.length)) {
		this.trigger('click');
	}
	if (this.attr('href') && this.attr('href').substr(0, 1) != '#') {
		if (this.attr('target') == '_blank') App.core.new_window(this.attr('href')); else App.core.goto(this.attr('href'));
	}
	return this;
}

$.fn.bind_active = function (events, callback) {
	events = events.split(' ');
	return this.each(function () {
		for (let i = 0; i < events.length; i++) if (events[i]) {
			if (App.core.passive_supported) this.addEventListener(events[i], callback, {passive: false}, false); else this.addEventListener(events[i], callback, false);
		}
	});
};

$.fn.inputFilter = function (inputFilter) {
	return this.on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
		if (inputFilter(this.value)) {
			this.oldValue = this.value;
			this.oldSelectionStart = this.selectionStart;
			this.oldSelectionEnd = this.selectionEnd;
		} else if (this.hasOwnProperty("oldValue")) {
			this.value = this.oldValue;
			this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
		} else {
			this.value = "";
		}
	});
};

$.fn.removeClassRegex = function(regex) {
	return $(this).removeClass(function(index, classes) {
		return classes.split(/\s+/).filter(function(c) {
			return regex.test(c);
		}).join(' ');
	});
};
$.fn.req_blink = function () {
	$('html, body').animate({
		scrollTop: this.filter(':first').offset().top
	}, 1000);
	this.addClass('incomplete').bind('keyup, click, focus', function () {
		$(this).removeClass('incomplete');
	}).animate({opacity: 0.1}, 300, function () {
		$(this).animate({opacity: 1}, 300, function () {
			$(this).animate({opacity: 0.1}, 300, function () {
				$(this).animate({opacity: 1}, 300, function () {
				});
			});
		});
	}).filter('div').find('input').bind('click', function () {
		$(this).parent().removeClass('incomplete');
	});
	return false;
}

$.fn.toggleAlt = function(...args) {
	this.each(function() {
		let element = $(this);
		args.forEach((attr) => {
			attr = attr.trim();
			let originalValue = element.attr(attr);
			let altValue = element.attr('alt-' + attr);
			if (originalValue !== undefined && altValue !== undefined) {
				element.attr(attr, altValue);
				element.attr('alt-' + attr, originalValue);
			}
		});
	});
	return this;
};
$.fn.toggleChecked = function(state) {
	if (state === 'indeterminate') {
		this.prop("indeterminate", true).data("indeterminate", true).prop('checked', false);
	} else if (state === 'determinate') {
		this.prop("indeterminate", false).data("indeterminate", false);
	} else if (state === true) {
		this.prop("indeterminate", false).data("indeterminate", false).prop('checked', true);
	} else {
		this.prop("indeterminate", false).data("indeterminate", false).prop('checked', false);
	}
	return this;
};
$.fn.toggleDisabled = function(state) {
	if (state) {
		this.prop('disabled', true).attr('disabled', 'disabled');
	} else {
		this.prop('disabled', false).removeAttr('disabled');
	}
	return this;
};
$.fn.toggleSelected = function(state) {
	if (state) {
		if (!this.hasClass('selected')) this.addClass('selected').removeClass('ign_hover').dp_class().trigger('onselect');
	} else {
		if (this.hasClass('selected')) this.removeClass('selected').addClass('ign_hover').trigger('onunselect');
	}
	return this;
};
$.fn.toggleFocus = function(state) {
	if (state) {
		this.focus();
	} else {
		this.blur();
	}
	return this;
};
$.fn.textNodes = function() {
	const children = [] // Type: Node[]
	if ('createTreeWalker' in document) {
		this.each(function() {
			const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT)
			while (walker.nextNode()) {
				children.push(walker.currentNode)
			}
		});
	}
	return children
};
$.fn.switchAttrValues = function (attr1, attr2) {
	const val1 = this.attr(attr1);
	this.attr(attr1, this.attr(attr2));
	this.attr(attr2, val1);
	return this;
};
$.fn.setBtnVariant = function(value) {
	this.filter('ws-btn').each(function() {
		let el = $(this);
		let name = el.attr('name');
		if (name == null) return;

		let new_val = 'btn-'+value;
		el.attr('name', name
			.replace('btn-a', new_val)
			.replace('btn-b', new_val)
			.replace('btn-g', new_val)
			.replace('btn-w', new_val));
	});
	return this;
};
$.fn.setBtnRightIndicator = function(value) {
	this.filter('ws-btn').each(function() {
		let el = $(this), name = el.attr('name') || '';
		name = name.split(' ').filter(i => i.indexOf('right-indicator') === -1).join(' ');
		el.attr('name', name + ( value ? ' btn-right-indicator-'+value : ''));
	});
	return this;
};
$.fn.setBtnLeftIndicator = function(value) {
	this.filter('ws-btn').each(function() {
		let el = $(this), name = el.attr('name') || '';
		name = name.split(' ').filter(i => i.indexOf('left-indicator') === -1).join(' ');
		el.attr('name', name + ( value ? ' btn-left-indicator-'+value : ''));
	});
	return this;
};
/**
 * Adds form change tracking functionality to the selected elements.
 *
 * @param {function} changed_callback - The callback function to be called when the form is changed.
 * @param {function} unchanged_callback - The callback function to be called when the form is not changed.
 * @throws {Error} Throws an error if changed_callback or unchanged_callback is not a function.
 * @return {jQuery} Returns the jQuery object for chaining.
 */
$.fn.form_change_tracker = function(changed_callback, unchanged_callback) {
	if (typeof changed_callback !== 'function') {
		throw new Error('changed_callback is not defined');
	}
	if (typeof unchanged_callback !== 'function') {
		throw new Error('unchanged_callback is not defined');
	}

	return this.each(function() {
		const $form = $(this);
		const form_serialize = () => {
			return $form.find(':input').filter(function() {
				// менюшки змінюють позицію в DOM при кліку, не враховуємо їх
				return !$(this).closest('.menu__submenuWrapper').length;
			}).serialize();
		};
		const initial_form_state = form_serialize();

		function check_form_changes() {
			const current_form_state = form_serialize();
			const is_state_changed = initial_form_state !== current_form_state;

			if (is_state_changed) {
				changed_callback.call($form);
			} else {
				unchanged_callback.call($form);
			}
		}

		$form.on('input change', check_form_changes);
		check_form_changes();
	});
};
$.fn.numberRoller = function (options) {
	let settings = $.extend({
		start: null,
		end: 999,
		duration: 2000,
		easing: 'swing',
		stepSize: null,
		stepCount: 100,
	}, options);

	return this.each(function () {
		let $element = $(this);

		$element.attr('data-end', settings.end.toString())

		if (settings.start === null) {
			let parsedStart = parseInt($element.html(), 10);
			settings.start = isNaN(parsedStart) ? 0 : parsedStart;
		}

		let endStr = settings.end.toString();
		let endParts = endStr.split('.');
		let endIntPart = parseInt(endParts[0], 10);
		let endDecPart = endParts[1] ? parseFloat('0.' + endParts[1]) : 0;

		let currentNumber = settings.start;
		let stepCount = settings.stepSize ? Math.ceil(Math.abs(endIntPart - settings.start) / settings.stepSize) : settings.stepCount;
		let stepDuration = settings.duration / stepCount;
		let stepSize = settings.stepSize ? settings.stepSize : Math.abs(endIntPart - settings.start) / stepCount;

		function updateNumber() {
			if (settings.start < endIntPart && currentNumber < endIntPart) {
				currentNumber = Math.min(currentNumber + stepSize, endIntPart);
				$element.text(Number.isInteger(currentNumber) ? currentNumber : currentNumber.toFixed(2));
				if (currentNumber < endIntPart) {
					setTimeout(updateNumber, stepDuration);
				} else if (endDecPart) {
					$element.text((currentNumber + endDecPart).toFixed(2));
				}
			} else if (settings.start > endIntPart && currentNumber > endIntPart) {
				currentNumber = Math.max(currentNumber - stepSize, endIntPart);
				$element.text(Number.isInteger(currentNumber) ? currentNumber : currentNumber.toFixed(2));
				if (currentNumber > endIntPart) {
					setTimeout(updateNumber, stepDuration);
				} else if (endDecPart) {
					$element.text((currentNumber + endDecPart).toFixed(2));
				}
			}
		}

		$element.text(Number.isInteger(settings.start) ? settings.start : settings.start.toFixed(2));
		setTimeout(updateNumber, stepDuration);
	});
};

$.fn.integerRoller = function (options) {

	let settings = $.extend({
		start: null,
		end: 100,

		// mode 1 (time-based)
		duration: null, // ms

		// mode 2 (step-based)
		step: null, // integer step
		step_duration: 100, // ms per step

	}, options);

	return this.each(function () {

		let $el = $(this);

		let start = settings.start;
		if (start === null) {
			let parsed = parseInt($el.text(), 10);
			start = isNaN(parsed) ? 0 : parsed;
		}

		start = parseInt(start, 10);
		let end = parseInt(settings.end, 10);

		if (start === end) {
			$el.text(end);
			return;
		}

		let diff = end - start;
		let direction = diff > 0 ? 1 : -1;

		$el.text(start);

		// =====================================================
		// STEP MODE (має пріоритет)
		// =====================================================

		if (settings.step !== null) {

			let step = Math.abs(parseInt(settings.step, 10)) || 1;
			step *= direction;

			let current = start;

			function tick() {

				let next = current + step;

				if (
					(direction > 0 && next >= end) ||
					(direction < 0 && next <= end)
				) {
					$el.text(end);
					return;
				}

				current = next;
				$el.text(current);

				setTimeout(tick, settings.step_duration);
			}

			setTimeout(tick, settings.step_duration);
			return;
		}

		// =====================================================
		// TIME MODE
		// =====================================================

		if (settings.duration !== null) {

			let startTime = null;

			function animate(timestamp) {

				if (!startTime) startTime = timestamp;

				let progress = (timestamp - startTime) / settings.duration;
				progress = Math.min(progress, 1);

				let current = Math.round(start + diff * progress);
				$el.text(current);

				if (progress < 1) {
					requestAnimationFrame(animate);
				} else {
					$el.text(end);
				}
			}

			requestAnimationFrame(animate);
			return;
		}

		// якщо нічого не передано
		console.warn('integerRoller: specify either duration or step');

	});
};

$.fn.eachDelayed = function(callback, timeout) {
	let o = $().add(this);
	setTimeout(function() {
		o.each(callback);
	}, timeout || 0);
	return this;
}

// custom events?
$.fn.on_longtouch = function(callback, duration) {
	duration = duration || 1000;
	return this.each(function() {
		let timer;
		$(this).on('touchstart', function() {
			timer = setTimeout(function() {
				callback.call(this);
			}, duration);
		});
		$(this).on('touchend touchmove', function() {
			clearTimeout(timer);
		});
	});
};

$.fn.scrollBounce = function(direction, options) {
	let settings = $.extend({
		bounceSpeed: 300,
		scrollSpeed: 600,
		bounceDistance: 50
	}, options);

	return this.each(function() {
		let $scrollZone = $(this);

		let zoneWidth = $scrollZone.width();
		let zoneHeight = $scrollZone.height();

		let maxScrollX = $scrollZone[0].scrollWidth - zoneWidth;
		let maxScrollY = $scrollZone[0].scrollHeight - zoneHeight;

		let bounceScroll = function(direction) {
			let bounceDistance = settings.bounceDistance;

			if (direction === 'left' || direction === 'right') {
				let scrollLeft = $scrollZone.scrollLeft();
				let targetScroll = (direction === 'left') ? scrollLeft - zoneWidth : scrollLeft + zoneWidth;

				if (targetScroll < 0) {
					targetScroll = 0;
				} else if (targetScroll > maxScrollX) {
					targetScroll = maxScrollX;
				}

				$scrollZone.animate({
					scrollLeft: targetScroll
				}, settings.scrollSpeed, function() {
					if (targetScroll === 0 || targetScroll === maxScrollX) {
						if (direction === 'left') {
							const bounceDistanceHalf = settings.bounceDistance / 2;
						} else {
							const bounceDistanceHalf = settings.bounceDistance / 2;
						}
					}
				});
			} else if (direction === 'up' || direction === 'down') {
				let scrollTop = $scrollZone.scrollTop();
				let targetScroll = (direction === 'up') ? scrollTop - zoneHeight : scrollTop + zoneHeight;

				if (targetScroll < 0) {
					targetScroll = 0;
				} else if (targetScroll > maxScrollY) {
					targetScroll = maxScrollY;
				}

				$scrollZone.animate({
					scrollTop: targetScroll
				}, settings.scrollSpeed, function() {
					if (targetScroll === 0 || targetScroll === maxScrollY) {
						$scrollZone.animate({
							scrollTop: targetScroll + (direction === 'up' ? bounceDistance : -bounceDistance)
						}, settings.bounceSpeed).animate({
							scrollTop: targetScroll
						}, settings.bounceSpeed);
					}
				});
			}
		};

		bounceScroll(direction);
	});
};

$.fn.dragScroll = function(options) {
	let settings = $.extend({
		inertia: 0, // Інерція після відпускання миші (від 0 до 1)
		bounceSpeed: 300, // Тривалість баунс ефекту
		scrollSpeed: 1, // Швидкість скролу під час перетягування
		bounceDistance: 50, // Відстань баунсу при від'ємному витягуванні
		dragThreshold: 50 // Мінімальна відстань, щоб вважати рух перетягуванням
	}, options);

	return this.each(function() {
		let $scrollZone = $(this);
		let isDragging = false;
		let startX, startY, scrollLeft, scrollTop, lastMoveX, lastMoveY, lastTime, velocityX, velocityY;
		let isHorizontal = false, isVertical = false;
		let hasDragged = false; // Прапорець для відстеження, чи дійсно був рух миші

		$scrollZone.on('mousedown', function(e) {
			// Перевіряємо чи є активний горизонтальний або вертикальний скрол
			if ($scrollZone.hasClass('ps--active-x')) {
				isHorizontal = true;
				isVertical = false;
			} else if ($scrollZone.hasClass('ps--active-y')) {
				isHorizontal = false;
				isVertical = true;
			} else {
				return; // Якщо немає активного скролу, виходимо
			}

			$scrollZone.css('cursor', 'grabbing');
			$scrollZone.find('.ps__rail-x, .ps__rail-y').css('cursor', 'auto');

			const elementUnderCursor = document.elementFromPoint(e.clientX, e.clientY);
			const cursorStyle = window.getComputedStyle(elementUnderCursor).cursor;

			// Ігноруємо кліки по елементах з курсором "pointer" або "text"
			if (cursorStyle === 'pointer' || cursorStyle === 'text') {
				return;
			}

			isDragging = true;
			hasDragged = false; // Скидаємо прапорець при початку нового кліку

			startX = e.pageX - $scrollZone.offset().left;
			startY = e.pageY - $scrollZone.offset().top;
			scrollLeft = $scrollZone.scrollLeft();
			scrollTop = $scrollZone.scrollTop();

			lastMoveX = e.pageX;
			lastMoveY = e.pageY;
			lastTime = Date.now();

			$(document).on('mousemove', mouseMoveHandler);
			$(document).on('mouseup', stopDragging);
		});

		function mouseMoveHandler(e) {
			if (!isDragging) return;
			e.preventDefault();

			let x = e.pageX - $scrollZone.offset().left;
			let y = e.pageY - $scrollZone.offset().top;

			let distanceX = Math.abs(e.pageX - startX);
			let distanceY = Math.abs(e.pageY - startY);

			// Якщо відстань переміщення більша за поріг, вважаємо, що це драг
			if (distanceX > settings.dragThreshold || distanceY > settings.dragThreshold) {
				hasDragged = true;
			} else {
				return; // Якщо не перевищує поріг, не вважаємо це перетягуванням
			}

			let now = Date.now();
			let timeDiff = now - lastTime;

			// Якщо активний горизонтальний скрол, ігноруємо вертикальний рух
			if (isHorizontal) {
				let walkX = (x - startX) * settings.scrollSpeed;
				$scrollZone.scrollLeft(scrollLeft - walkX);
				velocityX = (e.pageX - lastMoveX) / timeDiff;

				// Від'ємне витягування
				if ($scrollZone.scrollLeft() <= 0 || $scrollZone.scrollLeft() >= $scrollZone[0].scrollWidth - $scrollZone.outerWidth()) {
					$scrollZone.css('transform', `translateX(${(x - startX) / 5}px)`);
				}
			}

			// Якщо активний вертикальний скрол, ігноруємо горизонтальний рух
			if (isVertical) {
				let walkY = (y - startY) * settings.scrollSpeed;
				$scrollZone.scrollTop(scrollTop - walkY);
				velocityY = (e.pageY - lastMoveY) / timeDiff;

				// Від'ємне витягування
				if ($scrollZone.scrollTop() <= 0 || $scrollZone.scrollTop() >= $scrollZone[0].scrollHeight - $scrollZone.outerHeight()) {
					$scrollZone.css('transform', `translateY(${(y - startY) / 5}px)`);
				}
			}

			lastMoveX = e.pageX;
			lastMoveY = e.pageY;
			lastTime = now;
		}

		function stopDragging() {
			if (!hasDragged) {
				// Якщо не було перетягування, вважаємо це просто кліком
				isDragging = false;
				$scrollZone.css('cursor', 'grab');
				$(document).off('mousemove', mouseMoveHandler);
				$(document).off('mouseup', stopDragging);
				return;
			}

			isDragging = false;
			$scrollZone.css('cursor', 'grab');
			$(document).off('mousemove', mouseMoveHandler);
			$(document).off('mouseup', stopDragging);

			// Повертаємо блок після від'ємного витягування
			$scrollZone.css('transform', 'none');

			if (isHorizontal && Math.abs(velocityX) > 0.1) {
				applyInertia('horizontal');
			}

			if (isVertical && Math.abs(velocityY) > 0.1) {
				applyInertia('vertical');
			}

			// Додаємо баунс після від'ємного витягування
			if (isHorizontal) {
				applyBounce('horizontal');
			}
			if (isVertical) {
				applyBounce('vertical');
			}
		}

		function applyInertia(axis) {
			let scrollStep = axis === 'horizontal' ? $scrollZone.scrollLeft() : $scrollZone.scrollTop();
			let velocity = axis === 'horizontal' ? velocityX : velocityY;

			function inertiaStep() {
				scrollStep -= velocity * 100;
				velocity *= settings.inertia;

				if (axis === 'horizontal') {
					$scrollZone.scrollLeft(scrollStep);
				} else {
					$scrollZone.scrollTop(scrollStep);
				}

				if (Math.abs(velocity) > 0.1) {
					requestAnimationFrame(inertiaStep);
				}
			}

			inertiaStep();
		}

		function applyBounce(axis) {
			const maxScrollLeft = $scrollZone[0].scrollWidth - $scrollZone.outerWidth();
			const maxScrollTop = $scrollZone[0].scrollHeight - $scrollZone.outerHeight();

			// Для горизонтального скролу
			if (axis === 'horizontal') {
				if ($scrollZone.scrollLeft() <= 0) {
					// Натягнули вліво, досягли лівого краю
					const bounceDistanceHalf = settings.bounceDistance / 2;
					$scrollZone
						.animate({ left:  '+='+bounceDistanceHalf }, settings.bounceSpeed) // Відскок на половину відстані
						.animate({ left: 0 }, settings.bounceSpeed / 2); // Повернення до початкового положення
				} else if ($scrollZone.scrollLeft() >= maxScrollLeft) {
					// Натягнули вправо, досягли правого краю
					const bounceDistanceHalf = settings.bounceDistance / 2;
					$scrollZone
						.animate({ right:  '+='+bounceDistanceHalf }, settings.bounceSpeed) // Відскок на половину відстані
						.animate({ right: 0 }, settings.bounceSpeed / 2); // Повернення до початкового положення
				}
			}

			// Для вертикального скролу
			if (axis === 'vertical') {
				if ($scrollZone.scrollTop() <= 0) {
					// Натягнули вгору, досягли верхнього краю
					const bounceDistanceHalf = settings.bounceDistance / 2;
					$scrollZone.animate({ scrollTop: settings.bounceDistance }, settings.bounceSpeed) // Відскок на повну відстань
						.animate({ scrollTop: 0 }, settings.bounceSpeed) // Повернення до початкового положення
						.animate({ scrollTop: bounceDistanceHalf }, settings.bounceSpeed / 2) // Відскок на половину відстані
						.animate({ scrollTop: 0 }, settings.bounceSpeed / 2); // Повернення до початкового положення
				} else if ($scrollZone.scrollTop() >= maxScrollTop) {
					// Натягнули вниз, досягли нижнього краю
					const bounceDistanceHalf = settings.bounceDistance / 2;
					$scrollZone.animate({ scrollTop: maxScrollTop - settings.bounceDistance }, settings.bounceSpeed) // Відскок на повну відстань
						.animate({ scrollTop: maxScrollTop }, settings.bounceSpeed) // Повернення до початкового положення
						.animate({ scrollTop: maxScrollTop - bounceDistanceHalf }, settings.bounceSpeed / 2) // Відскок на половину відстані
						.animate({ scrollTop: maxScrollTop }, settings.bounceSpeed / 2); // Повернення до початкового положення
				}
			}
		}
	});
}
$.fn.cssDelayed = function (element, css) {
	if (!this.delayed_css) this.delayed_css = [];
	this.delayed_css.push([element, css]);
	return this;
}
$.fn.applyCssDelayed = function (noDetach) {
	let prev = this.prev();
	let parent = this.parent();
	if (this.delayed_css) {
		if (!noDetach) this.detach();
		this.delayed_css.forEach(function(pair) {
			pair[0].css(pair[1]);
		});
		if (!noDetach) {
			if (prev.length) this.insertAfter(prev);
			else this.prependTo(parent);
		}
		this.delayed_css = null;
	}
	return this;
}

function jquery_check_duplicate_binds() {
	let errors = [];
	document.querySelectorAll('*').forEach(function(node) {
		let events = $._data(node, "events");
		if (events) {
			for (let event in events) if (events[event].length > 1) {
				let hashes = {};
				events[event].forEach(function(data) {
					let hash = data.selector + ' ' + data.handler.toString();
					hash = hash.hashCode();
					if (hash in hashes) {
						errors.push([node.parentNode, node, event, data.selector || 'self', data.handler.toString()]);
					} else hashes[hash] = 1;
				});
			}
		}
	});
	if (errors.length) {
		console.log('Duplicate binds');
		console.table(errors);
	}
}
$.fn.ava_recalc_bg = function(size) {
	if (!Number.isInteger(size)) {
		throw new Error('`size` must be Integer');
	}
	return this.each(function() {
		const $ava = $(this);

		if (!$ava.hasClass('av_sm') && !$ava.hasClass('av_nm') && !$ava.hasClass('av') && !$ava.hasClass('av_s')) return;

		if ($ava.data('original-x') === undefined || $ava.data('original-y') === undefined) {
			const original_x = parseInt($ava.css('background-position-x')) || 0;
			const original_y = parseInt($ava.css('background-position-y')) || 0;
			$ava.data('original-x', original_x);
			$ava.data('original-y', original_y);
		}

		let base_size = 24;
		let original_x = $ava.data('original-x');
		let original_y = $ava.data('original-y');

		if ($ava.hasClass('av_nm')) {
			if (size < 48) {
				$ava.css('background-size', '120px 336px');
				original_x = original_x / 2;
				original_y = original_y / 2;
			} else {
				base_size = 48;
				$ava.css('background-size', '');
			}
		}

		const offset = (size - base_size) / 2;
		$ava.css({
			backgroundPositionX: original_x + offset + 'px',
			backgroundPositionY: original_y + offset + 'px'
		});
	});
};

$.fn.scrollBottom = function() {
	return this.each(function() {
		this.scrollTop = this.scrollHeight;
	});
};

$.fn.scrollUpdate = function() {
	return this.each(function() {
		if (this.scrollBars) this.scrollBars.update();
		App.scroll_listener.onDivScroll.call(this);
	});
};

$.fn.scrollPreserveStart = function () {
	const el = this[0]; // each?
	if (!el) return this;

	this.data('_ps_beforeHeight', el.scrollHeight);
	this.data('_ps_beforeTop', el.scrollTop);

	return this;
};

$.fn.scrollPreserveEnd = function () {
	const el = this[0]; // each?
	if (!el) return this;

	const beforeHeight = this.data('_ps_beforeHeight') || 0;
	const beforeTop = this.data('_ps_beforeTop') || 0;
	const afterHeight = el.scrollHeight;

	el.scrollTop = beforeTop + (afterHeight - beforeHeight);

	return this;
};

$.fn.scrollIntoViewIfNeeded = function (options = {}) {
	const {
		container = this.closest('.scrollZone, .ps'),
		offset_top = 0, // Висота фіксованої шапки
		offset_bottom = 0, // Відступ знизу (наприклад, padding)
		offset_block = 0, // відразу top і bottom
	} = options;

	if (!this.length || !container.length) return this;

	const el = this.get(0);
	const cont = container.get(0);

	const el_rect = el.getBoundingClientRect();
	const cont_rect = cont.getBoundingClientRect();

	const top_limit = cont_rect.top + (offset_block || offset_top);
	const bottom_limit = cont_rect.bottom - (offset_block || offset_bottom);

	const visibleHeight = bottom_limit - top_limit;

	// Якщо елемент більший за видиму область
	if (el_rect.height > visibleHeight) {
		if (el_rect.top < top_limit || el_rect.top > top_limit) {
			// Скролимо вгору
			cont.scrollTop -= (top_limit - el_rect.top);
		}
	} else {
		if (el_rect.top < top_limit) {
			// Скролимо вгору
			cont.scrollTop -= (top_limit - el_rect.top);
		} else if (el_rect.bottom > bottom_limit) {
			// Скролимо вниз
			cont.scrollTop += (el_rect.bottom - bottom_limit);
		}
	}

	return this;
};

$.fn.scrollIntoViewIfNeededX = function (options = {}) {
	const {
		container = this.closest('.scrollZone'),
		offset_left = 0,   // відступ зліва (наприклад, іконки)
		offset_right = 0,  // відступ справа
		offset_inline = 0, // одночасно left і right
	} = options;

	if (!this.length || !container.length) return this;

	const el = this.get(0);
	const cont = container.get(0);

	const el_rect = el.getBoundingClientRect();
	const cont_rect = cont.getBoundingClientRect();

	const left_limit = cont_rect.left + (offset_inline || offset_left);
	const right_limit = cont_rect.right - (offset_inline || offset_right);

	if (el_rect.left < left_limit) {
		// Скролимо вліво
		cont.scrollLeft -= (left_limit - el_rect.left);

	} else if (el_rect.right > right_limit) {
		// Скролимо вправо
		cont.scrollLeft += (el_rect.right - right_limit);
	}

	return this;
};

// 1) Виклик на формі, кнопки беруться з форми
// $('form.my-form').ws_loading('start');
// 2) Виклик на формі, явно передано кнопки
// $('form.my-form').ws_loading('start', { buttons: 'form.my-form :submit, .not-form .btn_custom' });
// 3) Виклик напряму на кнопці (або кількох)
// $('.btn_ajax').ws_loading('start');
// 4) Зупинка
// $el.ws_loading('stop');
$.fn.ws_loading = function(action, params = {}) {

	if (action === 'is_loading') {
		// або перевіряти тільки перший.. хз як краще буде
		if (this.length !== 1) throw new Error('Error ws_loading: this.length === ' + this.length + ', expected 1');
		return this.hasClass('ws-loading');
	}

	return this.each(function() {

		const $el = $(this);
		let startTime = $el.data('ws-loading-start-time');

		// Визначаємо цільові кнопки
		// Якщо $el - форма, то кнопки з параметрів або з форми
		// Якщо $el - кнопка/кнопки, то працюємо тільки з ними
		let $buttons;
		if ($el.is('form')) {
			$buttons = params.buttons ? $(params.buttons) : $el.find(':submit');
		} else {
			$buttons = $el; // $el - кнопка чи кнопки
		}

		// V1 коли лоадер замість контенту
		if (action === 'start') {

			if ($el.hasClass('ws-loading')) return;

			$el.data('ws-loading-start-time', Date.now());

			// Додаємо loading клас формі (якщо це форма)
			if ($el.is('form')) $el.addClass('ws-loading');

			$buttons.each(function(_, button) {
				const $btn = $(button);
				$btn.addClass('ws-loading');
				$btn.css('width', $btn.outerWidth());
				$btn.attr('disabled', true); // може конфліктувати з валідаціями
				if (!$btn.find('.ws-loading__loader').length) {

					$content = $btn.contents().detach();
					$btn.data('ws-loading-original-content', $content);

					$btn.prepend('<span class="ws-loading__loader"><i class="loader loader--sm loader--curling"></i></span>');
				}
			});
		}

		if (action === 'stop') {

			if (!$el.hasClass('ws-loading')) return;

			const prevTimer = $el.data('ws-loading-stop-timer');
			if (prevTimer) clearTimeout(prevTimer);

			const minTime = params.min_display_time || 0;
			const elapsed = Date.now() - startTime;
			const delay = Math.max(0, minTime - elapsed);

			if ($el.is('form')) $el.removeClass('ws-loading');

			const timerId = setTimeout(() => {

				$buttons.each(function(_, button) {
					const $btn = $(button);
					$btn.find('.ws-loading__loader').remove();
					$btn.append($btn.data('ws-loading-original-content'));
					$btn.css('width', '');
					$btn.removeClass('ws-loading');
					$btn.removeAttr('disabled'); // може конфліктувати з валідаціями
				});

				$el.removeData('ws-loading-stop-timer');
				if (typeof params.callback === 'function') {
					params.callback.call($el[0]);
				}
			}, delay);

			$el.data('ws-loading-stop-timer', timerId);
		}
	});
};

$.fn.showAndHide = function(ttl) {
	return this.each(function() {
		$(this).show();
		setTimeout(() => {
			$(this).hide();
		}, ttl || 333);
	});
};

$.fn.setActiveEl = function(el, className) {
	if ($(el).hasClass(className)) return this;
	$(this).find('.'+className).removeClass(className);
	$(el).addClass(className);
	return this;
};

$.fn.scrollToCaret = function () {
	return this.each(function () {
		const scrollContainer = this;

		const sel = window.getSelection();
		if (!sel || !sel.rangeCount) return;

		const range = sel.getRangeAt(0);

		// перевірка, що selection всередині контейнера
		const isInside =
			scrollContainer.contains(range.commonAncestorContainer) ||
			(sel.anchorNode && scrollContainer.contains(sel.anchorNode));

		if (!isInside) return;

		const clonedRange = range.cloneRange();

		const marker = document.createElement('span');
		marker.textContent = '\u200b';
		clonedRange.collapse(true);
		clonedRange.insertNode(marker);

		// нативний скрол з урахуванням scroll-padding
		marker.scrollIntoView({
			block: 'nearest',
			inline: 'nearest'
		});

		marker.remove();
	});
};

$.fn.horizontalWheelScroll = function(options) {

	const config = {
		container: null, // .scrollZone, .flex_row-forceScrollable, etc
		...options
	};

	return this.each(function() {

		const $el = $(this);

		$el.on('wheel.horizontalWheelScroll', function(event) {

			const e = event.originalEvent;

			if (!e.deltaY) return;
			if (e.shiftKey) return;

			const scroll_container = config.container ? $(e.target).closest(config.container).get(0) : $el.get(0);

			if (!scroll_container) return;
			if (scroll_container.scrollWidth <= scroll_container.clientWidth) return;

			event.preventDefault();

			scroll_container.scrollBy({
				left: e.deltaY,
				behavior: 'auto'
			});
		});

	});

};

$.fn.getCaretCoordinates = function(options) {

	const { debug } = {
		debug: false,
		...options,
	}

	const el = $(this).get(0);

	const isTextArea = el.tagName === 'TEXTAREA';
	const isInput = el.tagName === 'INPUT' && ['text', 'search', 'tel', 'url', 'password'].includes(el.type);

	if (!isTextArea && !isInput) {
		const res = {
			rect: el.getBoundingClientRect(),
			cleanup: () => {},
		};
		if (!debug) {
			delete res.cleanup;
		}
		return res;
	};

	const style = window.getComputedStyle(el);

	const div = document.createElement('div');
	const span = document.createElement('span');

	// COPY LAYOUT
	const props = [
		'fontFamily','fontSize','fontWeight','fontStyle',
		'letterSpacing','textTransform',
		'wordSpacing','textIndent',
		'whiteSpace','lineHeight',
		'padding','border','boxSizing',
		'width','height'
	];

	props.forEach(prop => {
		div.style[prop] = style[prop];
	});

	div.style.position = 'absolute';
	div.style.top = el.getBoundingClientRect().top + window.scrollY + 'px';
	div.style.left = el.getBoundingClientRect().left + window.scrollX + 'px';

	// Inputs do not wrap text and shouldn't scroll vertically
	div.style.whiteSpace = isInput ? 'pre' : 'pre-wrap';
	div.style.wordWrap = isInput ? 'normal' : 'break-word';
	div.style.overflow = isInput ? 'hidden' : 'auto';

	if (debug) {
		div.style.visibility = 'visible';
		div.style.background = 'rgba(255,0,0,0.08)';
		div.style.zIndex = 9999;
	}

	if (debug) {
		span.style.background = 'blue';
	}
	span.textContent = '|';

	const value = el.value;
	const pos = el.selectionStart;

	div.textContent = value.substring(0, pos);
	div.appendChild(span);
	div.appendChild(document.createTextNode(value.substring(pos)));

	document.body.appendChild(div);

	span.scrollIntoView();

	const res = {
		rect: span.getBoundingClientRect(),
		cleanup: () => div.remove(),
	};

	if (!debug) {
		res.cleanup();
		delete res.cleanup;
	}

	return res;
}

$.fn.fairShrink = function (selector) {
	const $container = this.first();
	const container = $container[0];
	const items = $container.find(selector).toArray();

	if (!items.length) return this;

	const styles = getComputedStyle(container);
	const isColumn = styles.flexDirection.startsWith('column');

	// Властивості залежно від осі
	const sizeProp   = isColumn ? 'height' : 'width';
	const minProp    = isColumn ? 'minHeight' : 'minWidth';
	const padStart   = isColumn ? 'paddingTop' : 'paddingLeft';
	const padEnd     = isColumn ? 'paddingBottom' : 'paddingRight';
	const gapProp    = isColumn ? 'rowGap' : 'columnGap';

	// Скидаємо стилі один раз для замірів
	items.forEach(el => {
		el.style.setProperty('flex', '0 0 auto', 'important');
		el.style[sizeProp] = 'auto';
		el.style[minProp] = '0';
	});

	const containerRect = container.getBoundingClientRect();
	const gap = parseFloat(styles[gapProp] || styles.gap || 0);

	const layoutChildren = [...container.children].filter(el => {
		const display = getComputedStyle(el).display;
		return display !== 'none' && !['SCRIPT', 'STYLE', 'TEMPLATE'].includes(el.tagName);
	});

	let occupied = 0;
	const naturalSizes = items.map(el => el.getBoundingClientRect()[sizeProp]);
	layoutChildren.forEach(el => {
		if (!items.includes(el)) occupied += el.getBoundingClientRect()[sizeProp];
	});

	const totalGap = gap * Math.max(0, layoutChildren.length - 1);
	const padding = parseFloat(styles[padStart]) + parseFloat(styles[padEnd]);
	const available = Math.max(0, containerRect[sizeProp] - padding - occupied - totalGap);

	// Розрахунок "справедливого" розміру (water-filling)
	let remaining = available;
	let itemsToShrink = naturalSizes.map((w, i) => ({ w, i })).sort((a, b) => a.w - b.w);
	let results = new Array(items.length);
	for (let i = 0; i < itemsToShrink.length; i++) {
		let count = itemsToShrink.length - i;
		let fairShare = remaining / count;
		if (itemsToShrink[i].w <= fairShare) {
			results[itemsToShrink[i].i] = { size: itemsToShrink[i].w, isNatural: true };
			remaining -= itemsToShrink[i].w;
		} else {
			for (let j = i; j < itemsToShrink.length; j++) {
				results[itemsToShrink[j].i] = { size: remaining / (itemsToShrink.length - i), isNatural: false };
			}
			break;
		}
	}

	// Фінальне застосування стилів
	items.forEach((el, i) => {
		const res = results[i];
		if (res.isNatural) {
			el.style.flex = '0 0 auto';
		} else {
			el.style.flex = `0 1 ${res.size}px`;
			el.style[minProp] = '0';
		}
		el.style[sizeProp] = '';
	});

	return this;
};

$.fn.stickyFocus = function(methodOrOptions, options = {}) {

	const method = typeof methodOrOptions === 'string' ? methodOrOptions : 'init';
	const settings = {
		...(typeof methodOrOptions === 'string' ? options : methodOrOptions),
	};

	if (method === 'destroy') {

		return this.each(function() {

			$(document).off('.stickyFocus-' + this.dataset.stickyFocusId);

			delete this.dataset.stickyFocusId;
		});
	}

	return this.each(function() {

		const input = this;
		const $input = $(input);

		$input.stickyFocus('destroy');

		const uid = Date.now() + '-' + Math.random().toString(36).slice(2);

		input.dataset.stickyFocusId = uid;

		$(document).on(`touchend.stickyFocus-${uid}`, (e) => {

			if (document.activeElement !== input) {
				return;
			}

			if (App.swipe.type !== null && App.swipe.type !== 'detect') {
				return;
			}

			if (App.scroll_listener.is_scrolling) {
				return;
			}

			let action = e.target
				.closest('[data-sticky-focus]')
				?.dataset.stickyFocus;

			if (!action && settings.keep && e.target.closest(settings.keep)) {
				action = 'keep';
			}

			switch (action) {

				case 'keep':

					e.preventDefault();
					e.stopImmediatePropagation();
					$(e.target).trigger('click');
					return false;

				case 'off':
					return;

				default:

					if (!$(e.target).closest(input).get(0)) {
						e.preventDefault();
						e.stopImmediatePropagation();
						return false;
					}
			}
		});
	});
};

$.fn.run_async = function(callback, delay = 300) {
	let $el = this.first();
	let el = $el.get(0);

	if (!el || $el.hasClass('is-loading')) return;

	$el.addClass('is-loading');

	let timer = null;
	let isAnimated = false;

	const startAnimation = () => {
		isAnimated = true;
		$el.animate_css?.('fade-pulse', { infinite: true });
	};

	if (delay > 0) {
		timer = setTimeout(startAnimation, delay);
	} else {
		startAnimation();
	}

	const cleanup = () => {
		clearTimeout(timer);
		if (isAnimated) {
			el?.animate_css?.stop?.();
		}
		$el.removeClass('is-loading');
	};

	let result;
	try {
		result = callback.call($el, $el);
	} catch (err) {
		cleanup();
		throw err;
	}

	if (result && typeof result.always === 'function') {
		result.always(cleanup);
	} else if (result && typeof result.then === 'function') {
		Promise.resolve(result).finally(cleanup);
	} else {
		cleanup();
	}

	return result;
};

;var App = App || {};

App.keyboard_listener = {

	process_key: function (key, alt, ctrl, meta, shift, in_input, in_input_strict, in_editor) { // Hotkeys
		if ((alt || ctrl) && !App.config.hotkeys) return false;
		// -------------------------------------
		$('#log_keyboard').show().append((alt ? 'ALT+' : '') + (ctrl ? 'CTRL+' : '') + (meta ? 'COMMAND+' : '') + (shift ? 'SHIFT+' : '') + key + ' ');

		/** Moving modal windows for better screenshots **/
		if ((ctrl || meta) && shift && !in_input) {
			let dx = 0, dy = 0;
			if (key === App.keycode.ArrowLeft) dx = -1;
			if (key === App.keycode.ArrowRight) dx = 1;
			if (key === App.keycode.ArrowUp) dy = -1;
			if (key === App.keycode.ArrowDown) dy = 1;
			if (dx || dy) {
				if (App.menu.is_shown()) {
					$('#menuContainer').css('top', 1 * $('#menuContainer').css('top').replace('px', '') + 25 * dy);
					$('#menuContainer').css('left', 1 * $('#menuContainer').css('left').replace('px', '') + 25 * dx);
					$('#menuOverlay').hide();
					return true;
				} else if (App.modal.is_shown()) {
					App.modal.obj_window.css('top', 1 * App.modal.obj_window.css('top').replace('px', '') + 25 * dy);
					App.modal.obj_window.css('left', 1 * App.modal.obj_window.css('left').replace('px', '') + 25 * dx);
					return true;
				}
			}
		}

		if (key === App.keycode.F1) { // F1
			if ($('#mouse_help').length && !$('#mouse_help').hasClass('help_single')) {
				$('#mouse_help').toggleClass('help_hidden');
			} else {
				App.menu.log_mouse_position();
				App.menu.show({box: '#sidebarHelpMenu'});
			}
			return true;
		}

		/** History **/
		if ((ctrl || meta) && !shift && !alt && !in_input && [
			App.keycode.BracketRight,
			App.keycode.ArrowRight
		].includes(key)) {
			history.go(1);
		}
		if ((ctrl || meta) && !shift && !alt && !in_input && [
			App.keycode.BracketLeft,
			App.keycode.ArrowLeft,
		].includes(key)) {
			history.go(-1);
		}

		if (!alt && !shift && (ctrl || meta) && key === App.keycode.KeyK) {
			App.command_tool.show();
			return true;
		} else if (App.windows.opened.length && !ctrl && !meta && !shift && alt && (key === App.keycode.KeyM || key === App.keycode.KeyAltM)) {
			App.windows.minimize()
			return true;
		} else if (App.window.task_view.is_last_opened() && shift && (ctrl || meta) && key === App.keycode.KeyK) {
			App.task_view.paginal.go(1);
			return true;
		} else if (App.window.task_view.is_last_opened() && shift && (ctrl || meta) && key === App.keycode.KeyJ) {
			App.task_view.paginal.go(-1);
			return true;
		} else if (App.right_panel.is_shown() && !shift && !ctrl && !meta && !in_input && !in_input_strict && key === App.keycode.BracketRight) {
			App.right_panel.hide();
			return true;
		}

		if (alt && !ctrl && !meta && (key === App.keycode.KeyV)) {
			if (!App.windows.has_opened() && $('#dataTable-settings, #filterButton__config').length) {
				$('#dataTable-settings, #filterButton__config').first().click();
				return true;
			}
		}

		if (!alt && !shift && (ctrl || meta) && (key === App.keycode.KeyF)) {
			if (App.menu.is_shown()) {
				// do nothing
			} else if (App.modal.is_shown()) {
				if (App.modal.obj_window.find('.searchInput input').length) {
					App.modal.obj_window.find('.searchInput input').focus();
				}
			} else if (!App.windows.has_opened())  {
				if (typeof App.page.start_context_search === 'function') {
					App.page.start_context_search();
				} else if ($('#filterItem__search').length) {
					$('#filterItem__search').click();
				}
			} else if (App.right_panel.is_shown()) {
				if (App.right_panel.obj_window.find('.searchInput input').length) {
					App.right_panel.obj_window.find('.searchInput input').focus();
				}
			} else if (
				App.mymenu.is_shown()
				&& (!App.task_view.is_shown() || App.mymenu.obj_wrapper.hasClass('priority-kbd'))
				&& App.mymenu.obj_window.find('.searchInput input').length
			) {
				App.mymenu.obj_window.addClass('sidePanel-searchFullscreen');
				App.helper.nextTick(() => {
					App.mymenu.obj_window.removeClass('withoutTopPanel');
					App.mymenu.obj_window.find('.searchInput input').focus();
				});
			} else if (App.task_view.is_shown()) {
				App.comments.start_search();
			}
			return true;
		}

		if (alt && !ctrl && !meta && !shift && (key === App.keycode.KeyF)) {
			if (App.modal.is_shown()) {
			} else if (App.chat_view.is_shown()) {
				App.chat_view.fullscreen();
				return true;
			} else if (App.task_view.is_shown()) {
				App.task_view.fullscreen();
				return true;
			} else if (App.task_create.is_shown()) {
				App.task_create.fullscreen();
				return true;
			}
		}

		if (key === App.keycode.Space && $('body').hasClass('drag_do')) { // Space on drag
			if ($('body').hasClass('drag_do')) {
				App.controls.notify.toggle();
				if (App.config.notify_action) $('body').addClass('drag_wnotify'); else $('body').removeClass('drag_wnotify');
				$('#dragNotifySwitch').attr('data-hint', App.config.notify_action ? App.page.locale['notify'] : App.page.locale['not_notify']);
				$('#dragNotifySwitch').attr('data-hint2', App.config.notify_action ? App.page.locale['space_to_not_notify'] : App.page.locale['space_to_notify']);
				return false;
			}
		}
		if (App.sidebar.onkeydown(key, alt, ctrl, meta, shift, in_input, in_input_strict)) return true;
		if (App.mymenu.onkeydown(key, alt, ctrl, meta, shift, in_input, in_input_strict)) return true;
		if (App.task_view.is_shown() && App.task_view.onkeydown(key, alt, ctrl, meta, shift, in_input, in_input_strict)) return true;

		if (!alt && !ctrl && !meta && !shift && !in_input && !in_input_strict && !in_editor && key === App.keycode.Enter) {
			if (App.task_view.is_shown() && App.task_edit.onkeydown(key, alt, ctrl, shift, in_input)) return true;
		}

		if (alt && !ctrl && !meta) {  // && !in_input
			if ([App.keycode.KeyA,  App.keycode.KeyD,  App.keycode.KeyS,  App.keycode.KeyL,  App.keycode.KeyP,  App.keycode.KeyX,  App.keycode.KeyT].includes(key)) {
				if (App.task_edit.onkeydown(key, alt, ctrl, shift, in_input)) return true;
			}
			if (App.modal.is_shown()) {
				if (key === App.keycode.KeyS) {
					if ($('#droptimermenu a.timer_stop').length === 0 && App.modal.obj_window.find('.quick_tmr').length) App.modal.obj_window.find('.quick_tmr:first').click(); else $('#droptimermenu a.ms_dbl').click();
					return true;
				} // ALT-S
				if (key === App.keycode.ArrowRight || key === App.keycode.ArrowLeft) { // ALT-RT ALT-LT
					if (!in_input) App.modal.obj_window.find('.modal__header__tabs a:first').click();
					return true;
				}
			} else {
				if (key === App.keycode.KeyZ) {
					$(App.core.theme.dark ? '#quick_theme_light' : '#quick_theme_dark').click();
					return true;
				} // ALT-Z
				if (key === App.keycode.KeyN) {
					App.controls.main_plus.add_task();
					return true;
				} // ALT-N
			}
		}
		if (!alt && (ctrl || meta) && (key === App.keycode.NumpadDivide || key === App.keycode.Slash || (key === App.keycode.Period && shift))) { // CTRL-/
			if (App.right_panel.is_shown()) App.right_panel.hide();
			else App.right_panel.show({
				url: App.helper.endpoint.primary() + '?' + App.actions.get('info_hotkey:show'),
				type: 'hotkey'
			});
			return true;
		}
		if (alt && (
			(ctrl && !App.device.is_ios_desktop()) ||
			(meta && App.device.is_ios_desktop())
		)) {
			if (key >= App.keycode.Digit1 && key <= App.keycode.Digit8 && /(account-|demo|test|^akg$|^gka$)/.test(window.location.hostname)) {
				let set_lang = key - App.keycode.Digit0;
				if (set_lang > 2) set_lang++;
				$.getScript(App.helper.endpoint.primary() + '?' + App.actions.get('process:save_lang') + '&set_lang=' + set_lang);
			}

			if (key === App.keycode.KeyB) { // ALT-CTRL-B
				if (App.task_view.is_shown()) App.task_view.obj_window.find('.bookmark').click();
				else if (App.modal.is_shown()) App.modal.obj_window.find('.bookmark').click();
				else if (App.menu.is_shown()) App.menu.obj_window.find('.bookmark').click();
				else App.bookmark.saveCurrentPage();
				return true;
			}
		}
		if (key === App.keycode.Escape) { // ESC

			if (shift) {
				if (App.menu.is_shown()) App.menu.hide();
				if (App.modal.is_shown()) App.modal.hide();
				if (App.mymenu.is_shown()) App.mymenu.hide();
				if (App.task_explorer.is_shown()) App.task_explorer.hide();
				if (App.right_panel.is_shown()) App.right_panel.hide();
				App.task_panel.item.minimize_all();
				return true;
			}
			if ($('body').hasClass('drag_do') || App.state.drag.is_on) debugger;
			if (App.helper.selection.is_not_empty()) {
				App.helper.selection.clear();
				return false;
			}
			if (App.hint.is_shown()) {
				App.hint.hide();
			}

			if (window.dragging) {
				window.dragesc = true;
				window.dragging.onmoveend();
				return true;
			} else if (App.menu.is_shown() && App.menu.obj_window.find('.menu__group-search input').val()) {
				App.menu.obj_window.find('.menu__group-search input').val('').focus().trigger('keyup');
				return false;
			} else if (App.modal.is_shown() && App.modal.obj_window.find('.modal__title__search input, .editBlock__picker__search input').val()) {
				App.modal.obj_window.find('.modal__title__search input, .editBlock__picker__search input').val('').focus().trigger('keyup');
				return false;
			} else if (App.keyboard_selection.process_escape_key()) {
				// tricky handler #1
				App.mymenu.is_shown() && App.context_search.mymenu.onkeydown(key, alt, (ctrl || meta), shift, in_input, in_editor);
				App.windows.reopen_last(3);
				return true;
			} else if (App.menu.is_shown()) {
				App.menu.hide();
				return true;
			} else if ($('#float_edit_inline').length) {
				$('#float_edit_inline').remove();
				$('.floatEditAppended').removeClass('floatEditAppended');
				return true;
			} else if ($('#form_edit_inline').length) {
				App.controls.float_edit.delete();
				return true;
			} else if ($('.editor__toolbar__link').is(':visible')) {
				$('.editor__toolbar__link').hide();
				return true;
			} else if ($('#prss').is(':visible')) {
				$('#prss').hide();
				return true;
			} else if ($('.task_quick_add').filter('.begin').length) {
				if (['gantt', 'kanban_days', 'users_tasks', 'kanban'].includes(App.page.where())) {
					App.page.task_add_form.hide(true);
					if (App.page.where() === 'gantt') App.page.chart.relations.draw_all_relation_lines();
					if (App.page.where() === 'kanban') $(this).closest('.listing__card').removeClass('listing__card-addBottom');
				} else {
					$('.task_quick_add').each(function () {
						if (!$(this).find('.input').val()) {
							$(this).removeClass('begin').parents().filter('.pre_begin').removeClass('pre_begin');
							if ($(this).attr('data-pair')) $($(this).attr('data-pair')).hide();
						}
					});
				}
			} else if (App.command_tool.is_shown()) {
				App.command_tool.back();
				return true;
			} else if (App.modal.is_shown()) {

				if ($('#modal__previewImage').hasClass('zoom_in')) {
					$('#zoom_data:visible a').trigger('click');
					return true;
				}

				if (App.modal.dismissible) App.modal.hide();
				return true;
			} else if (App.mass.is_shown()) {
				App.page.mass.hide_menu();
				return false;
			} else if (App.comments.mass.is_shown()) {
				App.comments.mass.hide_menu();
				return false;
			} else if (App.subtasks.mass.is_shown()) {
				App.subtasks.mass.hide_menu();
				return false;
			} else if (App.comment_form.is_started()) {
				App.comment_form.stop()
				return true;
			} else if ($('body').hasClass('massdo_top')) {
				App.page.mass.hide_menu();
				return false;
			} else if ($('#mouse_help').length && $('#mouse_help').hasClass('help_shown') && !$('#mouse_help').hasClass('help_hidden')) {
				$('#mouse_help .close').click();
			} else if (App.windows.close()) {
				return true;
			} else if (App.windows.reopen_last(3)) {
				return true;
			}
		}

		if ((ctrl || meta) && (key === App.keycode.Enter)) {
			if (App.editor.is_focused()) {
			} else if (App.modal.is_shown()) {
				if (App.modal.obj_window.find('input[type=submit]:visible').length && App.modal.obj_window.find('input[type=submit]').parent().is(':visible')) App.modal.obj_window.find('input[type=submit]:first').click();
				else if (App.modal.obj_window.find('.btn-ok,.btn-primary').length) App.modal.obj_window.find('.btn-ok,.btn-primary').click();
				else if (App.modal.obj_window.find('.buttons .button:not(.button_white)').length) App.modal.obj_window.find('.buttons .button:not(.button_white):first').click();
				else if (App.modal.obj_window.find('.sum_progress_b .button:not(.button_white)').length) App.modal.obj_window.find('.sum_progress_b .button:not(.button_white):first').click();
			} else if (App.task_create.is_shown()) {
				App.task_create.obj_window.find('.taskCreate__buttons .btn-primary').trigger('click');
			} else if (App.mymenu.is_shown() && App.mymenu.obj_window.find('.search_fld').length) {
				if (App.mymenu.obj_window.find('.search_fld').val().trim()) App.mymenu.obj_window.find('.search_fld').parent().submit();
			} else if ($('.search_fld').length) {
				if ($('.search_fld').val().trim()) $('.search_fld').parent().submit();
			} else if (document.frm) {
				if ($(document.frm).find('input[type=submit]').length) $(document.frm).find('input[type=submit]').click();
				else if ($(document.frm).find('button.btn-40').length) $(document.frm).find('button.btn-40').click();
			}
			return false;
		}

		// tricky handler #2
		App.mymenu.is_shown() && App.context_search.mymenu.onkeydown(key, alt, (ctrl || meta), shift, in_input, in_editor);

		if (App.mymenu.is_shown() && App.context_search.mymenu_recent.onkeydown(key, alt, (ctrl || meta), shift, in_input, in_editor)) return true;

		// -------------------------------------
		if (App.keyboard_selection.onkeydown(key, alt, (ctrl || meta), shift, in_input, in_editor)) return true;


		/** Scrolling processing **/
		if (!ctrl && !meta && !alt && !in_input) {
			if (key === App.keycode.Home) { // HOME
				let scroll_obj = App.scroll_listener.find_scrolling_target();
				if (scroll_obj) {
					if (scroll_obj.length) scroll_obj.scrollTop(0)
				} else if (App.controls.datatable.obj) {
					return false;
				} else {
					$('html, body').scrollTop(0);
				}
				return true;
			}
			if (key === App.keycode.End) { // END
				let scroll_obj = App.scroll_listener.find_scrolling_target();
				if (scroll_obj) {
					if (scroll_obj.length) scroll_obj.scrollTop(scroll_obj.get(0).scrollHeight);
				} else if (App.controls.datatable.obj) {
					return false;
				} else {
					$('html, body').scrollTop(App.helper.doc.content_height());
				}
				return true;
			}
			if (key === App.keycode.PageDown) { // PGUP
				let scroll_obj = App.scroll_listener.find_scrolling_target()
				if (scroll_obj) {
					if (scroll_obj.length) scroll_obj.stop(true, true).scrollAni(scroll_obj.scrollTop() + scroll_obj.height());
				} else if (App.controls.datatable.obj) {
					return false;
				} else {
					$('html, body').stop(true, true).scrollAni($(window).scrollTop() + $(window).height());
				}
				return true;
			}
			if (key === App.keycode.PageUp) { // PGDN
				let scroll_obj = App.scroll_listener.find_scrolling_target();
				if (scroll_obj) {
					if (scroll_obj.length) scroll_obj.stop(true, true).scrollAni(scroll_obj.scrollTop() - scroll_obj.height());
				} else if (App.controls.datatable.obj) {
					return false;
				}  else {
					$('html, body').stop(true, true).scrollAni($(window).scrollTop() - $(window).height());
				}
				return true;
			}
			if (!App.menu.is_shown() && !App.modal.is_shown()) {
				if (key === App.keycode.ArrowLeft) { // LEFT
					if ($('#listing').length && $('.listing__contentScrollable').length) {
						$('.listing__contentScrollable').scrollLeft($('.listing__contentScrollable').scrollLeft() - 300);
						return true;
					}
				}
				if (key === App.keycode.ArrowRight) { // RIGHT
					if ($('#listing').length && $('.listing__contentScrollable').length) {
						$('.listing__contentScrollable').scrollLeft($('.listing__contentScrollable').scrollLeft() + 300);
						return true;
					}
				}
			}
		}
		if (!ctrl && !meta && !alt && !in_input && !in_editor && (key === App.keycode.ArrowUp || key === App.keycode.ArrowDown || key === App.keycode.ArrowLeft || key === App.keycode.ArrowRight)) {

			if (key === App.keycode.ArrowDown) { // DN
				let scroll_obj = App.scroll_listener.find_scrolling_target();
				if (scroll_obj) {
					if (scroll_obj.length) scroll_obj.scrollTop(scroll_obj.scrollTop() + 50);
					return true;
				} else return false;
			}
			if (key === App.keycode.ArrowUp) { // UP
				let scroll_obj = App.scroll_listener.find_scrolling_target();
				if (scroll_obj) {
					if (scroll_obj.length) scroll_obj.scrollTop(scroll_obj.scrollTop() - 50);
					return true;
				} else return false;
			}
		}
		return false;
	},

	helper_ctrl_enter_esc_blur: function (element, event) { // TODO: normal naming
		let key = event.keyCode ? event.keyCode : event.charCode;
		event.stopPropagation();
		if ((event.ctrlKey && key === App.keycode.Enter) || key === App.keycode.Escape) {
			$(element).blur();
			return true;
		} else {
			return false;
		}
	},

	helper_enter_esc_blur: function (element, event) { // TODO: normal naming
		let key = event.keyCode ? event.keyCode : event.charCode;
		event.stopPropagation();
		if ((key === App.keycode.Enter) || key === App.keycode.Escape) {
			$(element).blur();
			return true;
		} else {
			return false;
		}
	},

	helper_minimal_offset_top: function (el) {
		if (!this.minimal_offset_top) this.minimal_offset_top = 80 + ($('.filter_over').length ? $('.filter_over').outerHeight() : 0);
		if (el && $(el).prev().hasClass('group')) return this.minimal_offset_top + $(el).prev().outerHeight() + 10;
		return this.minimal_offset_top;
	},

	onkeydown: function (e) {
		if (!App.me.id) return true;
		let key = e.keyCode ? e.keyCode : e.charCode, alt = e.altKey, ctrl = e.ctrlKey, meta = e.metaKey, shift = e.shiftKey;

		// треба для кейсів, коли є форма з інпутом, щоб не відправлявся нативний запит при Enter
		if (App.device.is_mobile()) {
			let o = $(e.target);
			if (o.attr('data-skip-enter') && !e.ctrlKey && (key === App.keycode.Enter)) return false;
			return true;
		}

		let intercept_data = {key, intercepted: false}
		if (key === App.keycode.F5 && !ctrl) {
			App.core.reload_everything();
			return false;
		}
		if (key === App.keycode.KeyR && ctrl && !shift) {
			App.core.reload_everything();
			return false;
		}
		if (App.menu.is_shown()) App.menu.obj_window.trigger('keydown_intercept', [intercept_data]);
		if (App.modal.is_shown()) App.modal.obj_window.trigger('keydown_intercept', [intercept_data]);
		if (intercept_data.intercepted) return false;
		let o = $(e.target);
		if (o.closest('ws-code-input').length) return true; // TODO тут свої хендлери, треба вписати їх в загальні
		if (o.attr('data-skip-enter') && !e.ctrlKey && (key === App.keycode.Enter)) return false;
		if (key === App.keycode.Enter && App.core.active_window({menu: true}).find('.selected').is('button')) {
			App.core.active_window({menu: true}).find('.selected').click();
			return false;
		}

		let o_parents = o.parents().addBack();
		let in_input_strict = o.is('input, textarea') || o_parents.filter('.editor__data').length > 0;
		let in_editor = (o.is('textarea') && o.val()) || (o_parents.filter('.editor__data').length > 0 && typeof App.editor.body.html() === 'string' && App.editor.body.html().trim() !== '');
		let in_input = o.is('input, textarea') && (o.val() || o.attr('tabindex')) || in_editor;

		in_editor = in_editor && !App.menu.in_editor;

		if (key === App.keycode.Space && $('body').hasClass('drag_do')) e.preventDefault();
		if (key === App.keycode.Tab && o.is('input, textarea') && o.hasClass('notab')) {
		} else if (key === App.keycode.Tab && o.is('input, textarea, button') && o.closest('.tabContainer').length) {
			if (App.keyboard_selection.process_tab_container(o, alt, ctrl, shift)) {
				return false;
			}
		} else if ((key === App.keycode.Enter) && o.attr('data-onenter')) {
			let sel_but = o.attr('data-onenter');
			if (sel_but.substring(0, 1) !== '#' && sel_but.substring(0, 1) !== '.') {
				(function () {
					eval(sel_but);
				}).call(e.target);
			} else $(sel_but).click();
			return false;
		} else if ((key === App.keycode.Enter) && o.is('a')) {
			o.click();
		} else if (App.page.where() === 'gantt' && App.page.chart.date_buttons.o && (key === App.keycode.Tab || key === App.keycode.Escape || key === App.keycode.ArrowLeft || key === App.keycode.ArrowRight)) {
		// } else if (o.is('.time_input') && key === App.keycode.Tab) {
		// 	// has its own tab listener; @see App.controls.time_input
		} else if (key === App.keycode.Escape && o.attr('data-onesc')) {
			let sel_but = o.attr('data-onesc');
			if (sel_but.substring(0, 1) !== '#' && sel_but.substring(0, 1) !== '.') {
				(function () {
					eval(sel_but);
				}).call(e.target);
			} else $(sel_but).click();
			return false;
		} else {
			if (App.keyboard_listener.process_key(key, alt, ctrl, meta, shift, in_input, in_input_strict, in_editor)) {
				e.preventDefault();
				e.stopPropagation();
				return false;
			}
			if (key === App.keycode.Enter && in_input && $(e.target).closest('.search_started').length) {
				e.preventDefault();
				e.stopPropagation();
				return false;
			}
		}
	},

	onkeyup: function (e) {
		let key = e.keyCode ? e.keyCode : e.charCode, alt = e.altKey, ctrl = e.ctrlKey, meta = e.metaKey, shift = e.shiftKey;
		let o = $(e.target);
		let intercept_data = {key, intercepted: false}
		if (key === App.keycode.Tab) {
			e.preventDefault();
			e.stopPropagation();
			return false;
		}
		if (App.menu.is_shown()) App.menu.obj_window.trigger('keyup_intercept', [intercept_data]);
		if (App.modal.is_shown()) App.modal.obj_window.trigger('keyup_intercept', [intercept_data]);
		let in_input = o.is('input, textarea') && (o.val() || o.attr('tabindex'));
		if (App.sidebar.onkeyup(key, alt, ctrl, meta, shift, in_input)) return true;
		if (e.intercepted) return false;
	},

	onBoot: function () {
		$(document).bind('keydown', App.keyboard_listener.onkeydown);
		$(document).bind('keyup', this.onkeyup);
	}
};

;var App = App || {};

(function () {
	let self = App.keyboard_selection = {

		select_default: 'a, button',

		focus_modal_inputs: 'input[type=text], input[type=number], input[type=email], input[type=password], input[type=url], input[type=tel], input[type=tel], input[type=date], input[type=time], textarea, a, button',

		active_container: null,
		hovered_item: null,
		is_mouse_moved: false,
		init_container: function (container, reverse, is_toggle_selected = true, direction = '') {
			let sel = container.data('select');
			let is_modal_spec_container = false;
			if (!sel) {
				is_modal_spec_container = App.modal.is_shown() && container.is('.editBlock, .inputBlock__wrapper');
				if (is_modal_spec_container) {
					sel = self.focus_modal_inputs;
					container.find('a').not('[href]').not('[tabindex]').attr('tabindex', 0); // make it focusable
				} else {
					sel = self.select_default;
				}
			}
			self.is_mouse_moved = false;
			let o = container.find(sel + ':visible').not('.ign_select').not('[class*="disabled"]').not('[disabled]').not(':disabled');
			let nav = container.attr('data-nav');
			if (nav == '4way' && document.activeElement.tagName === 'INPUT' && document.activeElement.value) nav = '2edge';
			let edge2edge = nav === '2edge' && (container.hasClass('ps--active-y') || container.hasClass('ps--active-x'));

			if (direction && (direction == 'up' || direction == 'down') && nav === '4way') {
				let current = container.find(sel + '.selected:visible').get(0);
				if (!current) {
					if (reverse) o = o.reverse();
					o.first().toggleSelected(true);
					self.init_select_by_hover(container);
					return;
				}


				let current_rect = current.getBoundingClientRect();
				let currentX = current_rect.left + current_rect.width / 2;

				let next_el = null;
				let min_score = Infinity;

				o.each(function () {
					if (this === current) return;

					let rect = this.getBoundingClientRect();
					let centerX = rect.left + rect.width / 2;

					let horizontal_overlap = rect.right >= current_rect.left && rect.left <= current_rect.right;
					let valid = false;
					let score;

					if (direction === 'up' && rect.bottom <= current_rect.top && horizontal_overlap) {
						valid = true;
						let vDist = current_rect.top - rect.bottom;
						let hOffset = Math.abs(currentX - centerX);
						score = vDist + hOffset * 0.25;
					}
					if (direction === 'down' && rect.top >= current_rect.bottom && horizontal_overlap) {
						valid = true;
						let vDist = rect.top - current_rect.bottom;
						let hOffset = Math.abs(currentX - centerX);
						score = vDist + hOffset * 0.25;
					}

					if (valid && score < min_score) {
						min_score = score;
						next_el = this;
					}
				});

				// if (next_el) {
				// 	$(current).toggleSelected(false);
				// 	$(next_el).toggleSelected(true);
				// } else if (direction === 'up') {
				// 	$(current).toggleSelected(false);
				// 	o.last().toggleSelected(true);
				// } else if (direction === 'down') {
				// 	$(current).toggleSelected(false);
				// 	o.first().toggleSelected(true);
				// }

				if (next_el) {
					$(current).toggleSelected(false);
					$(next_el).toggleSelected(true);
				} else if (direction === 'up') {
					$(current).toggleSelected(false);

					// Шукаємо попередню колонку (ліворуч) та її найнижчий елемент
					let fallback_el = null;
					let max_left = -Infinity;
					let max_bottom = -Infinity;

					o.each(function () {
						let rect = this.getBoundingClientRect();
						if (rect.left < current_rect.left - 5) { // Елемент ліворуч
							if (rect.left > max_left + 5) { // Знайшли ближчу колонку
								max_left = rect.left;
								max_bottom = rect.bottom;
								fallback_el = this;
							} else if (Math.abs(rect.left - max_left) <= 5 && rect.bottom > max_bottom) { // У тій же колонці, але нижче
								max_bottom = rect.bottom;
								fallback_el = this;
							}
						}
					});

					// Якщо колонки ліворуч немає, перестрибуємо на самий кінець списку (циклічність)
					$(fallback_el || o.last()).toggleSelected(true);

				} else if (direction === 'down') {
					$(current).toggleSelected(false);

					// Шукаємо наступну колонку (праворуч) та її найвищий елемент
					let fallback_el = null;
					let min_left = Infinity;
					let min_top = Infinity;

					o.each(function () {
						let rect = this.getBoundingClientRect();
						if (rect.left > current_rect.left + 5) { // Елемент праворуч
							if (rect.left < min_left - 5) { // Знайшли ближчу колонку
								min_left = rect.left;
								min_top = rect.top;
								fallback_el = this;
							} else if (Math.abs(rect.left - min_left) <= 5 && rect.top < min_top) { // У тій же колонці, але вище
								min_top = rect.top;
								fallback_el = this;
							}
						}
					});

					// Якщо колонки праворуч немає, перестрибуємо на самий початок (циклічність)
					$(fallback_el || o.first()).toggleSelected(true);
				}
			} else {
				if (reverse) o = o.reverse();
				if (is_toggle_selected) {
					if (container.find('.selected').length) {
						let is_found = null;
						o.each(function () {
							if (!is_found && $(this).hasClass('selected')) is_found = this;
							else if (is_found && $(this).is(':visible')) {
								$(is_found).toggleSelected(false);
								$(this).toggleSelected(true);
								is_found = null;
							}
						});
						if (is_modal_spec_container) {
							// do nothing
						} else if (is_found && !edge2edge) {
							$(is_found).toggleSelected(false);
							o.eq(0).toggleSelected(true);
						}
					} else {
						o.eq(0).toggleSelected(true);
					}
				}
			}

			self.init_select_by_hover(container);
		},

		move_to_closest: function (container, backward) {
			let sel = container.data('select');
			self.is_mouse_moved = false;
			let o = container.find(sel + ':visible, .selected').not('.ign_select');
			if (backward) o = o.reverse();
			let i = 0, i_selected = 0;
			o.each(function () {
				i++;
				if ($(this).hasClass('selected') || self.is_invalid_target(this)) i_selected = i;
			});
			if (i_selected === o.length) i_selected -= 2;
			container.find('.selected').toggleSelected(false);
			o.eq(i_selected).toggleSelected(true);
			self.init_select_by_hover(container);
		},

		find_closest_sibling: function (container, backward) {
			let sel = container.data('select');
			self.is_mouse_moved = false;
			let o = container.find(sel + ':visible, .selected').not('.ign_select');
			if (backward) o = o.reverse();
			let i = 0, i_selected = 0;
			o.each(function () {
				i++;
				if ($(this).hasClass('selected') || self.is_invalid_target(this)) i_selected = i;
			});
			if (i_selected === o.length) i_selected -= 2;
			return o.eq(i_selected);
		},

		find_next_item: function (container, backward) {
			let sel = container.data('select');
			self.is_mouse_moved = false;
			let o = container.find(sel + ':visible, .selected').not('.ign_select');
			if (backward) o = o.reverse();
			let i = 0, i_selected = 0;
			o.each(function () {
				i++;
				if ($(this).hasClass('selected') || self.is_invalid_target(this)) i_selected = i;
			});
			if (i_selected === o.length) return null;
			return o.eq(i_selected);
		},

		move_to_next_item: function (container, backward) {

			const next_item = self.find_next_item(container, backward);

			container.find('.selected').toggleSelected(false);
			if (next_item === null) return;
			next_item.toggleSelected(true);
			self.init_select_by_hover(container);
			self.selected_intoView(container);
		},

		init_container_with_preselected_item: function (container, reverse) {
			if ($('body').hasClass('mobile')) return;

			let sel = container.data('select') || self.select_default;
			container.find('.selected').toggleSelected(false);
			let o = container.find(sel + ':visible').not('.ign_select');
			if (reverse) o = o.reverse();
			let item = o.eq(0);
			if (!item.length) return;
			item.toggleSelected(true);
			if ((item.offset().top - container.offset().top) + item.outerHeight() > container.height() - 15) {
				container.scrollTop(container.scrollTop() + (item.offset().top - container.offset().top) + item.outerHeight() - container.height() + 15);
			}
			if ((item.offset().top - container.offset().top) < 0) {
				container.scrollTop(container.scrollTop() + (item.offset().top - container.offset().top));
			}
			self.init_select_by_hover(container);
		},

		init_select_by_hover: function (container) {
			if (container.is('ws-btn') || container.parents().addBack().filter('main').length) return false;
			if (container.is('.editBlock, .inputBlock__wrapper')) return false;
			let sel = container.data('select') || self.select_default;
			container.not('.ign_select').once_by_criteria('wshover').on('mouseover', sel, function (e) {
				if (App.scroll_listener.is_scrolling) return;
				if (self.is_invalid_target(e.target, sel)) return;

				if (self.is_mouse_moved && !$(this).is('.ign_select, .editBlock__picker__item') && !self.get_layer().find('.selected').hasClass('editBlock__picker__item')) {
					self.set_active_container($(this).closest('.keyboardZone'));
					$(this).closest('.keyboardZone, .menu').find('.selected').not(this).toggleSelected(false);
					if (!$(this).closest('.keyboardZone').is('[data-select-by-hover="false"]')) {
						$(this).toggleSelected(true);
					}
				}
			});
		},

		select_by_click: function (anchor) {
			anchor = $(anchor);
			let container = anchor.closest('.keyboardZone');
			if (!container.length) return;
			if (self.is_invalid_target(anchor, container.attr('data-select'))) return;

			self.get_layer().find('.keyboardZone').removeClass('keyboardZone-active');
			container.addClass('keyboardZone-active').find('.selected').toggleSelected(false);

			let target = anchor.closest(container.attr('data-select'));
			target.toggleSelected(true);
			self.active_container = container;
		},

		is_invalid_target: function (target, sel_item) {
			let it = sel_item ? $(target).closest(sel_item) : $(target);

			return it.hasClass('ign_select') || it.hasClass('menu__item-disabled') || it.is(':disabled');
		},

		go_to_container: function (step) {
			let containers = self.get_possible_containers();
			if (step === -1) containers = containers.reverse();
			let container = containers.filter('.keyboardZone-active');
			if (!container.length) container = containers.eq(0); else {
				let found = false;
				containers.each(function () {
					if (container.get(0) === this) found = true;
					else if (found) {
						container.find('.selected').addClass('last_selected').toggleSelected(false);
						found = false;
						container = $(this);
					}
				});
				if (found) {
					container.find('.selected').addClass('last_selected').toggleSelected(false);
					container = containers.eq(0);
				}
			}
			containers.removeClass('keyboardZone-active');
			if (container) {
				if (App.menu.is_shown()) App.menu.obj_window.find('.menu__group-search input').toggleFocus(!container.is('ws-btn'));
				else if (container.attr('data-focus')) $(container.attr('data-focus')).toggleFocus(true)
				container.addClass('keyboardZone-active');
				self.container_intoView(container);
				if (App.menu.is_shown() && container.closest('.editBlock__picker').length) {
					if (!container.find('.editBlock__picker__search input').val()) {
						self.init_container(container, true); // на останній елемент, щоб бути поближче до інпута
					}
					self.init_select_by_hover(container);
				} else if (App.modal.is_shown() && container.closest('.editBlock__picker').length) {
					if (!container.find('.editBlock__picker__search input').val()) {
						self.init_container(container, true); // на останній елемент, щоб бути поближче до інпута
					}
					self.init_select_by_hover(container);
				} else {
					let reverse = false;
					if (container.is('.editBlock, .inputBlock__wrapper') && App.modal.is_shown()) {
						reverse = step === -1;
					}
					self.init_container(container, reverse);
					self.selected_intoView(container);
				}
				return true;
			}
		},

		set_active_container: function (container) {
			if (container && !container.hasClass('keyboardZone-active')) {
				self.get_possible_containers().filter('.keyboardZone-active').removeClass('keyboardZone-active').find('.selected').addClass('last_selected').toggleSelected(false);
				container.addClass('keyboardZone-active');
				self.init_select_by_hover(container);
			}
		},

		unset_active_container: function (container, with_hover) {
			if (container == null || !container.hasClass('keyboardZone-active')) return;

			container.removeClass('keyboardZone-active').find('.selected').addClass('last_selected').toggleSelected(false);
			if (with_hover) container.off('mouseover');
		},

		container_intoView(container) {
			if (container.attr('data-block')) container = container.closest(container.attr('data-block'));
			// container.scrollIntoView({block: 'start', inline: 'start', behavior: 'instant'});
			let item = container;
			container = item.parent().closest('.ps');
			if (!container.length) return;
			let paddingTop = parseInt(container.css("padding-top").replace('px', ''));
			let paddingBottom = parseInt(container.css("padding-bottom").replace('px', ''));
			if ((item.offset().top - container.offset().top) + item.outerHeight() + paddingBottom > container.height() - 15) {
				container.scrollTop(container.scrollTop() + (item.offset().top - container.offset().top) + item.outerHeight() + paddingBottom - container.height() + 15);
			}
			if ((item.offset().top - container.offset().top - paddingTop) < 0) {
				container.scrollTop(container.scrollTop() + (item.offset().top - container.offset().top - paddingTop));
			}
		},

		selected_intoView(container) {
			let item = container.find('.selected');
			if (item.length) {
				const original_container = container;
				if (!container.is('.scrollZone')) {
					if (container.find('.scrollZone').length) {
						container = container.find('.scrollZone');
					} else if (container.find('.listing__card__contentScrollable').length) {
						container = container.find('.listing__card__contentScrollable');
					} else if (container.find('.flex_row-forceScrollable').length) {
						container = container.find('.flex_row-forceScrollable');
						item.scrollIntoView({behavior: 'auto', inline: 'center'}); // при центруванні менше смикання
						// item.scrollIntoView({behavior: 'smooth', inline: 'nearest'}); // при затисканні стілки погано працює
						return;
					}
				}


				let padding_top = 0;
				if (original_container.closest('.editBlock__picker').hasClass('editBlock__picker-withHeader')) {
					padding_top = parseFloat(container.css('padding-top'));
				}

				if ((item.offset().top - container.offset().top) + item.outerHeight() > container.height() - 15) {
					container.scrollTop(container.scrollTop() + (item.offset().top - container.offset().top) + item.outerHeight() - container.height() + 15);
				}
				if ((item.offset().top - container.offset().top) < padding_top) {
					container.scrollTop(container.scrollTop() + (item.offset().top - container.offset().top) - padding_top);
				}
				if ((item.offset().left - container.offset().left) + item.outerWidth() > container.width() - 15) {
					container.scrollLeft(container.scrollLeft() + (item.offset().left - container.offset().left) + item.outerWidth() - container.width() + 15);
				}
				if ((item.offset().left - container.offset().left) < 0) {
					container.scrollLeft(container.scrollLeft() + (item.offset().left - container.offset().left));
				}
			}
		},

		get_possible_containers: function () {
			let container = $();
			if (App.menu.is_shown()) {
				container = App.menu.obj_window.find('.keyboardZone');
				container = container.add(App.menu.obj_window.find('.menu__group-head ws-btn, .menu__group-search ws-btn'));
			} else if (App.modal.is_shown()) {
				container = App.modal.obj_window.find('.keyboardZone');
				container = container.add(App.modal.obj_window.find('.buttons ws-btn'));
				container = container.add(App.modal.obj_window.find('.editBlock__buttons ws-btn').filter(function () {
					// вкладені в інші блоки не треба, бо буде зациклюватися
					return !$(this).closest('.editBlock, .inputBlock__wrapper').length;
				}));
				container = container.add(App.modal.obj_window.find('.editBlock, .inputBlock__wrapper').filter(function () {
					// вкладені в інші блоки не треба, бо буде зациклюватися
					return !$(this).parent().closest('.editBlock, .inputBlock__wrapper').length;
				}));
			} else {
				container = self.get_layer().find('.keyboardZone');
				if (document.activeElement.tagName === 'INPUT' && $(document.activeElement).attr('data-keyboard-zone')) {
					container = container.filter($(document.activeElement).attr('data-keyboard-zone'));
				}
			}
			return container.filter(':visible').filter(function() {
				return !($(this).css('visibility') == 'hidden' || $(this).css('display') == 'none');
			}).filter(function() {
				let sel = $(this).attr('data-select') || self.select_default;
				let has_items = !!$(this).find(sel).filter(':visible').length
				has_items ||= $(this).is('ws-btn');
				has_items ||= ($(this).closest('.editBlock__picker').length && Boolean($(this).find('.editBlock__picker__search input:visible').val()));
				has_items ||= ($(this).is('.editBlock, .inputBlock__wrapper') && $(this).find(self.focus_modal_inputs).is(':visible'));
				if (!has_items) $(this).removeClass('keyboardZone-active');
				return has_items;
			});
		},

		get_layer: function() {
			let layer = App.core.active_window({menu: true});
			if (layer.is('main') && $('body').hasClass('withSidebar')) layer = layer.add('#sidebar__wrapper');
			if (layer.is('main') && $('body').hasClass('withAdminMenu')) layer = layer.add('#adminMenu__wrapper');
			return layer;
		},

		get_active_container: function () {
			let container = null;
			if (App.menu.is_shown()) {
				container = App.menu.obj_window.find('.keyboardZone-active');
				if (!container.length) container = App.menu.get_keyboard_zone();
				if (container.length > 1) container = $(container.filter(':has(.selected)').get(0) || container.get(0));
			} else if (App.core.has_modals()) {
				container = self.get_layer().find('.keyboardZone-active');
				if (App.mymenu.is_shown() && App.mymenu.obj_wrapper.hasClass('priority-kbd')) container = App.mymenu.obj_wrapper.find('.keyboardZone-active'); // exception for both mymenu and task_view windows
				if (!container.length && App.modal.is_shown()) container = self.get_possible_containers().eq(0);
				if (!container.length) container = self.get_layer().find('.keyboardZone-primary');
				if (!container.length) container = self.get_layer().find('.keyboardZone').eq(0);
			} else {
				container = self.get_layer().find('.keyboardZone-active');
				if (!container.length) container = null;
			}
			return container;
		},

		go_within_container: function (step, columns) {
			let container = self.get_active_container();
			// if (self.get_layer().find('.selected').is('button')) self.get_layer().find('.selected').toggleSelected(false);
			if (container && container.length) {
				if (columns && !container.data('columns') && !container.is('ws-btn') && !container.attr('data-nav') === '4way') return false;
				const direction = columns ? (step === -1 ? 'left' : 'right') : (step === -1 ? 'up' : 'down');
				self.init_container(container, step === -1, true, direction);
				self.selected_intoView(container);
				return true;
			}
		},

		click_by_enter_timeout: null,
		process_enter_key: function () {
			let container = self.get_active_container();
			if (!container) return;
			let item = container.find('.selected:visible');
			if (item.length) {
				if (item.is('[class*="disabled"]') || item.is('[disabled]') || item.is(':disabled')) return;
				clearTimeout(self.click_by_enter_timeout);
				window.click_by_enter = true;
				self.click_by_enter_timeout = setTimeout(function () {
					window.click_by_enter = false;
					self.click_by_enter_timeout = null;
				}, 100);
				if (item.attr('href')) {
					if (item.attr('href') === 'javascript:void(0)') return;
					if (item.attr('target') === '_blank') App.core.new_window(item.attr('href')); else App.core.goto(item.attr('href'));
				} else {
					item[0].emitEvent('click', {enter: !App.mass.is_shown()});
				}
				return true;
			}
		},

		process_x_key: function () {
			let container = self.get_active_container() || $();
			let item = container.find('.selected:visible');
			if (!item.length && self.hovered_item) item = self.hovered_item;
			if (item.length) {
				let mass_element = item.find('input.mass');
				if (mass_element.length) {
					mass_element.each(function () {
						$(this).trigger('ws_click');
					});
					return true;
				}
			}
		},

		process_ctrlA: function (is_group) {
			if (is_group) {
				let container = self.get_active_container() || $();
				let item = container.find('.selected:visible');
				if (!item.length && self.hovered_item) item = self.hovered_item;
				if (item.length) {
					if (App.controls.datatable.getObj().length) {
						item.prevAll('.dataTable__subgroup, .dataTable__group').eq(0).find('input.mass_group, input.mass_subgroup').eq(0).trigger('ws_click');
					} else {
						item.closest('.listing__group').find('input.mass_group').trigger('ws_click');
					}
					return true;
				}
			} else {
				if (App.controls.datatable.getObj().length) {
					$('.dataTable input.mass_all').trigger('ws_click');
				} else {
					$('#mass_n_filt .mass_select_all input').trigger('ws_click');
				}
				return true;
			}

		},

		process_escape_key: function () {
			let container = self.get_possible_containers().filter('.keyboardZone-active');
			if (container.length && container.find('.selected').length) {
				container.removeClass('keyboardZone-active').find('.selected').addClass('last_selected').toggleSelected(false).blur();

				let focus_el;
				if (App.menu.is_shown()) focus_el = App.menu.obj_window.find('.menu__group-search input');
				else if (container.attr('data-focus')) focus_el = $(container.attr('data-focus'));

				if (focus_el) {
					// коли keyboardZone активується мишкою - поле залишається в фокусі,
					// тоді клавіша Esc має відразу закрити контейнер, тому прокидуємо false
					if (focus_el.length && focus_el.get(0) === document.activeElement) return false;
					focus_el.toggleFocus(true);
				}

				return true;
			}
		},

		toggle_item_select(item) {
			const container = self.get_possible_containers().filter(function() { // only active layer of containers
				return this.contains(item.get(0));
			}).first();
			if (container.length) {
				self.set_active_container(container);
				if (item.hasClass('selected')) {
					item.toggleSelected(false);
				} else {
					container.find('.selected').toggleSelected(false);
					item.toggleSelected(true);
				}
			}
		},

		onkeydown: function (key, alt, ctrl, shift, in_input, in_editor) {
			if (!ctrl && !alt && key === App.keycode.Enter && !in_editor) {
				if (self.process_enter_key()) return true;
			}
			if (ctrl && key === App.keycode.KeyA && !App.core.has_modals() && !in_input) {
				if (self.process_ctrlA(alt)) return true;
			} else if (ctrl && key === App.keycode.KeyA && App.task_view.is_shown() && !in_input) {
				if (App.task_view.process_ctrlA(alt)) return true;
			}
			if (!in_input && !ctrl && !alt && [App.keycode.KeyX].includes(key)) {
				if (self.process_x_key()) return true;
			}
			const container = self.get_active_container();
			const is_modal_spec_container = App.modal.is_shown() && container.is('.editBlock, .inputBlock__wrapper') && container.find(self.focus_modal_inputs).length
			if (!ctrl && key === App.keycode.Tab) {

				// якщо відкрита модалка і в поточному контейнері є інпути - Tab має ходити між ними (всередині зони)
				if (is_modal_spec_container) {
					const prev_active_item = container.find('.selected');
					if (self.go_within_container(shift ? -1 : 1, false)) {
						// даємо інпуту реальний фокус для введення тексту
						const active_item = container.find('.selected');
						if (active_item.length && prev_active_item.get(0) !== active_item.get(0)) {
							if (active_item.is(self.focus_modal_inputs)) active_item.focus();
							return true;
						}
					}
				}

				// якщо інпутів немає або ми на межі контейнера - перестрибуємо на інший контейнер
				if (self.go_to_container(shift ? -1 : 1)) {
					// також фокусуємо інпут у новому контейнері, якщо він там перший
					const new_container = self.get_active_container();
					if (App.modal.is_shown() && new_container.is('.editBlock, .inputBlock__wrapper')) {
						const active_item = new_container.find('.selected');
						if (active_item.is(self.focus_modal_inputs)) active_item.focus();
					}
					return true;
				}

				// if (self.go_to_container(shift ? -1 : 1)) return true;
			}
			if (!ctrl && alt && [App.keycode.ArrowUp , App.keycode.ArrowDown].includes(key)) { // ALT-DN or ALT-UP - keyboardZone block
				if (self.go_to_container(key === App.keycode.ArrowUp ? -1 : 1)) return true;
			}
			if (!ctrl && !alt && !in_editor && [App.keycode.ArrowUp, App.keycode.ArrowDown].includes(key)) {
				if (is_modal_spec_container) return false;
				if (self.go_within_container(key === App.keycode.ArrowUp ? -1 : 1, key === App.keycode.ArrowRight)) return true;
			}
			if (!ctrl && !alt && !in_input && [App.keycode.ArrowLeft, App.keycode.ArrowRight].includes(key)) {
				if (is_modal_spec_container) return false;
				if (self.go_within_container(key === App.keycode.ArrowLeft ? -1 : 1, true)) return true;
			}
			// if (!in_input && key === App.keycode.KeyX && self.hovered_item) {
			// 	self.toggle_item_select(self.hovered_item);
			// }
			return false
		},

		process_tab_container: function (o, alt, ctrl, shift) {
			let tab_container = o.closest('.tabContainer');
			let current_index = parseInt(o.closest('[data-tab-index]').attr('data-tab-index'));

			if (isNaN(current_index)) return false;

			let max_index = tab_container.find('[data-tab-index]').get().reduce((a, b) => Math.max(a, parseInt(b.getAttribute('data-tab-index'))), 0),
				next_index = current_index + 1 <= max_index ? current_index + 1 : null,
				next_el = tab_container.find(next_index ? '[data-tab-index='+next_index+']' : '[data-tab-index]').first();

			if (next_el.is('ws-btn')) {
				next_el.find('button').first().focus();
			} else {
				if (next_el.attr('data-focus-type') === 'select') {
					next_el.focus_select_desktop();
				} else {
					next_el.focus();
				}
			}

			return true;
		},

		onBoot: function () {
			App.bus.app.on('menu_load modal_onload', function () {
				let container = self.get_active_container();
				if (!container.hasClass('ign_select')) self.set_active_container(container);
			});

			App.bus.app.on('modal_opened', function() {


				App.modal.obj_window.on('focusin.keyboard_selection', '.editBlock, .inputBlock__wrapper', function (e) {
					const container = $(this);
					const item = $(e.target);

					clearTimeout(container.data('blurTimeout'));

					if (item.hasClass('selected')) {
						self.set_active_container(container);
					} else {
						self.toggle_item_select(item);
					}
				});
				App.modal.obj_window.on('focusout.keyboard_selection', '.editBlock, .inputBlock__wrapper', function () {
					const container = $(this);

					const blurTimeout = setTimeout(() => {
						if (!container[0].contains(document.activeElement)) {
							self.unset_active_container(container);
						}
					}, 0);

					container.data('blurTimeout', blurTimeout);
				});

				const item = App.modal.obj_window
					.find('.editBlock, .inputBlock__wrapper')
					.find(self.focus_modal_inputs)
					.filter(':focus')
					.not('.selected');
				if (item.length) self.toggle_item_select(item);
			});

			App.bus.app.on('modal_closed', function() {
				if (!App.modal.obj_window) return;
				App.modal.obj_window.off('focusin.keyboard_selection');
				App.modal.obj_window.off('focusout.keyboard_selection');
			});

			App.bus.window.on('mousemove', App.helper.throttle(function (e) {
				self.is_mouse_moved = true
				self.hovered_item = null;
				let container = $(e.target).closest('.keyboardZone');
				if (container.length) {
					let item = $(e.target).closest(container.attr('data-select'));
					if (item.length) self.hovered_item = item;
				}
			}, 250));
		}
	};
})();

;(function () {
	const self = App.l10n = {
		init: function () {
			let mouseX = 0;
			let mouseY = 0;
			$(document).on('mousemove', function(event) {
				mouseX = event.clientX;
				mouseY = event.clientY;
			});
			$(document).on('keydown', function(event) {
				// if (event.altKey && event.key !== 'Alt') {
				// 	console.log({ altKey: event.altKey, key: event.key, code: event.code, event });
				// }
				// const keys = ['ё', 'Ё', '`', "'", "Dead"]; // tilda-key
				// if (event.altKey && keys.indexOf(event.key) >= 0) {
				if (event.altKey && event.code === 'Backquote') {
					event.preventDefault();

					const el_under_cursor = document.elementFromPoint(mouseX, mouseY);
					if (el_under_cursor) {
						const clicked_text = $(el_under_cursor).text().trim();
						const base_url = 'https://admin-dev.worksection.com/su_translate_ref.php';
						const new_url = base_url + '?search=' + encodeURIComponent(clicked_text);

						window.open(new_url, '_blank');
					}
				}
			});
		}
	};

	self.init();
})();
;var App = App || {};

App.mass = {
	HANDLERS: {
		DOWNLOAD_FILE: 'd',
		SUBMIT: 's',
		MODAL: 'm',
		EXPORT: 'e',
	},
	url: null,
	obj_type: '',
	init: function (params) {
		this.url = App.page ? App.page.url.base : '';
		this.after_action = false;
		this.count = {};
		this.ids = {};
		this.range.start = 0;
		this.range.end = 0;
		this.obj_type = params.obj_type || '';

		window.addEventListener("beforeunload", (e) => this.onunload(e));
	},

	shown: false,

	is_shown: function() {
		return this.shown;
	},

	show: function() {
		this.shown = true;
		$('body').addClass('withMass');
	},

	hide: function() {
		this.shown = false;
		$('body').removeClass('withMass');
	},

	apply_action: function(params) {
		const action = params.action,
			subaction = params.subaction,
			request = params.request || {},
			ids = params.ids;

		$.getScript(
			App.helper.url.add_query(
				this.action_url(action, subaction).replace('master', 'master_step_do'),
				$.param({
					ids: Array.isArray(ids) ? ids.join(',') : String(ids),
					...request,
					mdo: App.actions.get_mda(`mass_${action}`)
				}),
			)
		);

		return true;
	},

	handle_click: function(element) {
		const el = $(element),
			action = el.attr('data-mass-action'),
			access = el.attr('data-mass-access'),
			handler = el.attr('data-mass-handler');

		if (!action) return;

		const mass = this,
			ids = el.attr('data-mass-ids') ? el.attr('data-mass-ids').split(',') : mass.select_ids(access || 'all');

		let handler_config = el.attr('data-mass-handler-config');
		handler_config = handler_config ? JSON.parse(handler_config) : {};

		if (handler === App.mass.HANDLERS.DOWNLOAD_FILE) {
			App.core.download_file(App.helper.url.add_query(mass.action_url(action), 'ids=' + ids.join(',')));
		} else if (handler === App.mass.HANDLERS.SUBMIT) {
			mass.validate_and_submit(action, ids);
		} else if (handler === App.mass.HANDLERS.EXPORT) {
			App.mass.prevent_unload = false;
			setTimeout(() => App.mass.prevent_unload = true, 500);
			App.classes.workflows.export_report.run({
				delivery: 'download',
				ids,
				...handler_config
			});
		} else if (handler === 'project_report') {
			mass.prevent_unload = false;
			if (ids.length === 1) {
				App.core.goto('/project/' + ids[0] + '/' + el.attr('data-mass-subaction') + '/');
			} else {
				App.core.goto('/' + el.attr('data-mass-subaction') + '/?fs_ok=2&' + ids.map(i => `fs_pr[]=${i}`).join('&') + '&flt=1');
			}
			mass.hide();
		} else if (handler === 'invite_again') {
			App.invite_again.show(null, { id_user: ids[0] });
		} else if (handler === 'contact_invite') {
			if (mass.get_count('inv_noemail')) {
				App.modal.show({
					url: '/ajax/user/?' + App.actions.get('contact_edit_email:show') + '&ids_edit=' + mass.select_ids('inv_noemail') + '&ids=' + ids.join(','),
					width: 460,
					title: el.attr('data-modal-title') || el.attr('title'),
					group: 'invite'
				});
			} else {
				App.modal.show({
					url: '/ajax/user/?' + App.actions.get('user_add:show') + '&ids=' + ids.join(','),
					title: el.attr('data-modal-title') || el.attr('title'),
					group: 'invite'
				});
			}
		} else {
			mass.show_modal(action, ids, {
				title: el.attr('data-modal-title') || el.attr('title'),
				group: el.attr('data-modal-group')
			});
		}

		return false;
	},

	task_handle_click: function(element) {
		return this.handle_click(element);
	},

	select_ids: function(key) {
		let ids = [], mass = this;

		if (key && typeof key === 'string' && key.length > 0) {
			for (let a of key.trim().split(' ')) {
				ids = mass.ids[a] || '';
				ids = ids.split(',').filter((val) => val.trim().length);
				if (ids.length > 0) break;
			}
		}

		return ids;
	},

	get_count: function(key) {
		let cnt = 0, mass = this;

		if (key && typeof key === 'string' && key.length > 0) {
			for (let a of key.trim().split(' ')) {
				cnt = mass.count[a] || 0;
				if (cnt > 0) break;
			}
		}

		return cnt;
	},

	prevent_unload: true,
	onunload: function(e) {
		if (this.prevent_unload && this.is_shown()) {
			e.preventDefault();
			e.returnValue = '';
		}
	},

	reset: function() {
		for (let param in this.count) {
			if (param !== 'all') this.count[param] = 0;
			this.ids[param] = '';
		}
	},

	count: {},
	ids: {},
	range: {
		start: null,
		end: null
	},

	after_action: false,
	action_done: function () {
		this.after_action = true;
	},

	clear_action: function () {
		this.after_action = false;
	},

	is_after_action: function () {
		return this.after_action;
	},

	drag_many: function() {
		return this.is_shown() && this.get_count('all');
	},

	validate_and_submit(operation, ids, callback = null, url = '') {
		if (App.offline_mode.is_on()) return;
		let operation_sub = '';
		if (typeof operation == 'object') {
			operation_sub = operation[1];
			operation = operation[0];
		}
		let self = this;
		App.core.log('mass.url', url ? url : self.url);
		$.ajax({
			type: 'POST',
			url: App.helper.url.add_query(url ? url : self.url, App.actions.get('master') + (self.obj_type ? '&obj_type=' + self.obj_type : '') + '&operation=' + operation + (operation_sub ? '&operation_sub=' + operation_sub : '') + '&ids=' + (Array.isArray(ids) ? ids.join(',') : ids)),
			dataType: 'json',
			success: function (json) {
				if (json.hash) {
					if (callback) callback(json);
					else $.getScript(App.helper.url.add_query(url ? url : self.url, App.actions.get('master').replace('master', 'master_step_do') + (self.obj_type ? '&obj_type=' + self.obj_type : '')  + '&operation=' + operation + (operation_sub ? '&operation_sub=' + operation_sub : '') + '&ids=' + ids + '&mdb=' + json.hash));
				}
			}
		});
	},

	show_modal: function (action, ids, params = {}) {
		const mass = this,
			title = params.title,
			group = params.group;

		if (!action || ids.length === 0) return false;

		return App.modal.show({
			url: App.helper.url.add_query(mass.action_url(action), 'ids=' + ids.join(',')),
			title,
			group
		});
	},

	action_url: function(operation, operation_sub) {
		return App.helper.url.add_query(this.url, App.actions.get('master') + (this.obj_type ? '&obj_type=' + this.obj_type : '') + '&operation=' + operation + (operation_sub ? '&operation_sub=' + operation_sub : ''));
	},

	add_id: function(access, id) {
		if (this.count[access] === undefined) this.count[access] = 0;
		if (this.ids[access] === undefined) this.ids[access] = '';

		this.count[access] += String(id).split(',').length;
		this.ids[access] += id + ',';
	},

	remove_all_ids: function(access) {
		this.count[access] = 0;
		this.ids[access] = '';
	},

	set_massdrag_badge: function(ids, total, locale_quantity) {
		const el = $('#massdrag');

		el.find('i').html('<b></b><font>0</font>');
		el.attr('data-ids', ids.join(','));

		if (ids.length !== total) {
			el.attr('data-ids', ids.join(',')).addClass('masserr').find('i')
				.html('<span><b></b>' + ids.length + '<u>' + total + '</u></span>');
		} else {
			el.attr('data-ids', ids.join(',')).removeClass('masserr').find('i')
				.html('<b></b>' + ids.length);
		}

		el.find('font').html(App.format.quantity(total, App.object_state.locale.quantity.task));
	},

	destructor: function () {
		this.url = null;
		this.obj_type = '';
		this.shown = false;
		$('body').removeClass('withMass');
		this.count = {};
		this.ids = {};
		this.range.start = null;
		this.range.end = null;
		this.after_action = false;
	},

	onLogout: function () { this.destructor() },
	onLogin: function () {

		App.bus.state.on('custom_field_update', function (payload) {
			$(`.menu-mass-children .menu__item[data-mass-action="field:${payload.id}"]`).each(function () {
				$(this).find('.in').text(App.helper.html.encode(payload.data.name));
			});
		});
		App.bus.state.on('custom_field_projects', function (payload) {
			const remove_projects = payload.data.remove || [];
			$(`.menu-mass-children .menu__group[data-group=custom_field][data-project]`).each(function () {
				if (!remove_projects.includes(parseInt($(this).attr('data-project')))) return;

				$(this).find('.menu__item[data-mass-action="field:' + payload.id + '"]').remove();
				$(this).toggleClass('menu__group-hidden', $(this).children('.menu__item').length === 0);
			});
		});
		App.bus.state.on('custom_field_delete', function (payload) {
			$(`.menu-mass-children .menu__group[data-group=custom_field]`).each(function () {
				$(this).find(`.menu__item[data-mass-action="field:${payload.id}"]`).remove();
				$(this).toggleClass('menu__group-hidden', $(this).children('.menu__item').length === 0);
			});
		});

	},


	initController: function (params = {}) {
		const mass = this;

		mass.init(params.config ?? {});

		const ctrl = {
			has_range: false,
			is_shown: () => mass.is_shown(),
			children_menu: $(),
			is_after_action: () => mass.is_after_action(),
			clear_action: () => mass.clear_action(),
			action_done: () => mass.action_done(),
			range: mass.range,
			config: mass,
			obj_selector: params.obj_selector ?? '[id^="obj-"], [data-id]',
			select_ids: (key) => mass.select_ids(key),
			get_count: (key) => mass.get_count(key),
		};

		const panel = () => {
			if (typeof params.panel === 'function') return params.panel();
			return $(params.panel);
		}

		const container = () => {
			if (typeof params.container === 'function') return params.container();
			return $(params.container);
		};

		const checkbox_selector = '.inputCheckbox.act input.mass, input.mass:checked'; //input.mass:checked, input.mass:indeterminate';

		ctrl.fit_menu = function () {
			if (!mass.is_shown()) return;

			const $panel = panel(), $ops = $panel.find('.ops'), $btns = $ops.children('ws-btn');
			let allowed_width = $panel.width() * 0.75, ops_width = $ops.width();

			if (allowed_width < ops_width) {
				$btns.get().reverse().forEach(function (btn) {
					if (allowed_width > ops_width)
						return;

					if ($(btn).attr('data-text'))
						return;

					const label = $(btn).attr('text');
					$(btn).attr('text', '')
						.attr('data-text', label)
						.attr('data-title', label);

					ops_width = $ops.width();
				});
			} else {
				$btns.get().forEach(function (btn) {
					if (allowed_width < (ops_width + 150))
						return;

					const label = $(btn).attr('data-text');
					if (!label)
						return;

					$(btn).attr('text', label).attr('data-text', '').attr('data-title', '');
					ops_width = $ops.width();
				});
			}
		};

		ctrl.update_menu = App.helper.debounce(function () {
			const $panel = panel(),
				$container = container(),
				checked_cnt = $container.find(checkbox_selector).length;

			ctrl.has_range = $container.find('input.mass[data-cnt]:checked').length > 0;

			if (checked_cnt === 0) {
				mass.hide();
				return;
			}

			mass.show();
			mass.reset();
			mass.count['all'] = 0;
			mass.ids['all'] = '';

			$container.find(checkbox_selector).each(function () {
				const val = $(this).attr('value'),
					rels = ($(this).attr('rel') || '').split(',');

				mass.add_id('all', val);
				rels.forEach((r) => mass.add_id(r, val));

				if (typeof params.process_checkbox === 'function')
					params.process_checkbox(mass, { input: this, val, rels });
			});

			if (typeof params.process_ids === 'function')
				params.process_ids(mass);

			$panel.find('[data-mass-access]').add(ctrl.children_menu.find('[data-mass-access]')).toggleDisabled('disabled').filter(function() {
				return $(this).attr('data-mass-access').split(' ').some(a => mass.get_count(a) > 0);
			}).removeAttr('disabled');

			$panel.find('.cnt b').html(mass.get_count('all'));

			if (params.autofit === true) ctrl.fit_menu();

			if (typeof params.on_menu_update === 'function')
				params.on_menu_update(mass);

		}, 99);

		ctrl.hide_menu = function (forced) {
			mass.range.start = 0;
			if (!forced) mass.hide();

			const $panel = panel(), $container = container();

			$panel.find('.mass_all').removeClass('act').find('input').prop('checked', false);
			$panel.closest('div[id=mass_n_filt]').find('.mass_select_all input').prop('checked', false);

			$container.find(checkbox_selector).prop('checked', false).parent().removeClass('act').parent().removeClass('pre_act');

			/// datatable:
			$container.find('.dataTable__item-active, .dataTable__group-active, .dataTable__subgroup-active')
				.removeClass('dataTable__item-active', 'dataTable__group-active', 'dataTable__subgroup-active');
			$container.find('tr.pre_act').removeClass('pre_act');
			$container.find('input.mass_group').toggleChecked(false);
			$container.find('input.mass_subgroup').toggleChecked(false);

			/// listing:
			$container.find('.listing__item, .listing__group__title').removeClass('pre_act');

			// fileItem:
			$container.find('.fileItem-active').removeClass('fileItem-active');
			//$('#mass_n_filt .mass_select_all').removeClass('act').find('input').prop('checked', false);
		};

		ctrl.init_menu = function () {
			ctrl.update_menu();

			// TODO: is needed ???
			// if (App.mass.count['all']) App.mass.action_done(); // mark action as done after success redirect

			const $panel = panel(),
				$container = container();

			if ($panel.attr('data-init') === '1') return;
			$panel.attr('data-init', '1');

			const isVisibleInput = (input) => $(input).parent().is(':visible');

			const isAllowedInput = (input) => {
				const obj = $(input).closest(ctrl.obj_selector);
				if (obj.length === 0) return false;

				if (obj.is('.listing__item-hidden, .listing__item-missSavedFilter, .listing__item-missFilter'))
					return false;

				const card = obj.closest('.listing__card');
				if (card.length > 0)
					return !card.hasClass('listing__card-prohibited') && !card.hasClass('listing__card-defaultHidden');

				return true;
			};

			const setSelectState = (input, checked) => $(input).prop('checked', checked)
				.parent().toggleClass('act', checked)
				.closest(ctrl.obj_selector).toggleClass('pre_act', checked);

			const selectAll = (checked) => {
				ctrl.range.start = 0;

				$container.find('input.mass').each(function () {
					setSelectState(this, checked && isVisibleInput(this) && isAllowedInput(this));
				});

				ctrl.update_menu();
			}

			$panel.find('[data-children-menu]').each(function () {
				const box = $(this).attr('data-children-menu');

				ctrl.children_menu = ctrl.children_menu.add($(box));
				$(this).on('click', () => App.menu.show({ anchor: this, width: 250, box }));
			});

			$panel.find('a.ico_esc, i').on('click', () => ctrl.hide_menu());

			$panel.find('.mass_all').bind('click', function () {
				selectAll(this.checked);
			});
			$panel.closest('div[id=mass_n_filt]').find('.mass_select_all input').on('click', function () {
				selectAll(this.checked);
				// TODO: needed: .not('.listing__item-hidden') ???
				//$container.find('.listing__item.fileItem:visible').toggleClass('fileItem-active', this.checked);
			});

			$panel.find('span.op_more').on('click', function () {
				$(this).next().show();
				$(this).remove();
			});
			$panel.find('[data-mass-action]').add(ctrl.children_menu.find('[data-mass-access]')).on('click', function () {
				return mass.handle_click(this);
			});
			$panel.find('[data-mass-action]').add(ctrl.children_menu.find('[data-mass-access]')).on('mouseover', function () {
				if (App.scroll_listener.is_scrolling) return;

				const access = $(this).attr('data-mass-access'),
					ids = mass.select_ids(access), // TODO: cache
					cnt = ids.length,
					all = mass.get_count('all'),
					$cnt = $panel.find('.cnt');

				$panel.toggleClass('masserr', cnt !== all);

				if (cnt !== all) $cnt.css('width', $cnt.width()).find('b').html(cnt + ' <u>' + all + '</u>');
				else $cnt.css('width', '').find('b').html(all);

				$container.find('input.mass:checked').each(function () {
					if (ids.includes(this.value)) return;

					$(this).closest('tr').addClass('dataTable__item-warning');
					$(this).closest('.listing__item').addClass('listing__item-warning');
				});
			});
			$panel.find('[data-mass-action]').add(ctrl.children_menu.find('[data-mass-access]')).on('mouseout', function () {
				if (App.scroll_listener.is_scrolling) return;

				$panel.removeClass('masserr').find('.cnt').css('width', '').find('b').html(mass.get_count('all'));
				$container.find('.dataTable__item-warning').removeClass('dataTable__item-warning');
				$container.find('.listing__item-warning').removeClass('listing__item-warning');
			});

			//// INIT mass input:
			if (params.click_enabled) {
				$container.on('click ws_click', 'input.mass', function (e, e_original) {
					if (e.type === 'ws_click') {
						this.checked = !this.checked;
					}

					setSelectState(this, this.checked);

					e = e_original || e;
					e.stopPropagation();

					if (ctrl.is_after_action()) {
						if (!e.shiftKey) {
							ctrl.hide_menu(true);
							this.checked = true;
						}
						ctrl.clear_action();
					}
					if (!this.checked) {
						ctrl.range.start = 0;
					} else {
						if (e.shiftKey && ctrl.range.start) {
							ctrl.range.end = this.value;
							let in_range = false;
							$container.find('input.mass').each(function () {
								const val = $(this).val();
								if (val === ctrl.range.start || val === ctrl.range.end) in_range = !in_range;
								if (!in_range) return;

								setSelectState(this, isVisibleInput(this) && isAllowedInput(this));
							});
						} else {
							//App.effects.fly_to_mass($(this).parent().parent());
						}
						ctrl.range.start = this.value;
					}

					$panel.find('.mass_all').prop('checked', false).parent().removeClass('act').parent().removeClass('pre_act');
					ctrl.update_menu();
				});

				$container.on('click ws_click', 'input.mass_group', function (e) {
					if (e.type === 'ws_click') {
						this.checked = !this.checked;
					}
					if (ctrl.is_after_action()) {
						ctrl.clear_action();
					}

					const checked = this.checked;
					$(e.target).closest('.listing__group').find('input.mass').each(function () {
						setSelectState(this, isVisibleInput(this) && checked);
					});

					ctrl.update_menu();
				});
			}
		};

		ctrl.destructor = function () {
			ctrl.has_range = false;
		};

		ctrl.onClickItem = function (el, e) {
			if (!params.click_enabled) return;

			e.stopPropagation();

			if (ctrl.is_after_action()) {
				if (!e.shiftKey) ctrl.hide_menu();
				ctrl.clear_action();
			}

			const $panel = panel();

			$panel.find('.mass_all').prop('checked', false).parent().removeClass('act').parent().removeClass('pre_act');
			$panel.closest('div[id=mass_n_filt]').find('.mass_select_all input').prop('checked', false).parent().removeClass('act');
			$(el).find('input.mass').trigger('ws_click', [e]);
		};

		return ctrl;
	},
};

;var App = App || {};

(function() {
	let self = App.mass_operations = {
		checkboxes_plus_minus: function(options) {
			options ||= {}
			self.init_search();
			let o_selected = App.modal.obj_window.find('.modal__massSelected');
			let menu = App.modal.obj_window.find('.menuFake').eq(0);
			let form = App.modal.obj_window.find('form').eq(0);
			App.controls.menu.init(menu);
			menu.bind('after_interaction', function(e, data) {
				data ||= {};
				let cnt = 0, ids = [];
				$(this).find('.menu__item-active[data-id]').each(function() {
					cnt++;
					ids.push($(this).attr('data-id'));
				});
				if (options.input) form.find('input[name='+ options.input+']').val(ids.join(','));
				o_selected.html(cnt ? App.helper.template.fill('modal_massCnt', {cnt}) : '');
				if (!data.onload) form.removeClass('frm_unchanged').filter('.frm_needData').toggleClass('frm_dis', !cnt);
			}).trigger('after_interaction', {onload: true});

			let menu_options = App.modal.obj_window.find('.menuFake').eq(1);
			if (menu_options.length) App.controls.menu.init(menu_options);
		},
		visibility: function(options) {
			options ||= {}
			self.init_search();
			let menu = App.modal.obj_window.find('.menuFake').eq(0);
			let form = App.modal.obj_window.find('form').eq(0);
			App.controls.visibility_switch_and_go.init.call(menu);

			let hidden = form.find('input[name=hidden]').val().toIntArray();
			let guests = options.guests ? form.find('input[name=guests]').val().toIntArray() : [];
			let hidden_defaults = form.find('input[name=hidden_defaults]').val().toIntArray();
			menu.find('.menu__group[data-group]').each(function () {
				let id_group = $(this).attr('data-group').toInt();
				$(this).find('.menu__item[data-id]').each(function () {
					let id_user = $(this).attr('data-id').toInt();
					let is_active = hidden_defaults.includes(id_user) || hidden.includes(id_user) || (hidden.includes(-id_group) && (!$(this).hasClass('menu__item-guest') || guests.includes(id_user)));
					$(this).toggleClass('menu__item-active', is_active).toggleClass('menu__item-default', hidden_defaults.includes(id_user));
				});
			});

			menu.bind('after_interaction', function() {
				let hidden = [];
				let guests = [];
				let parent_limited = form.find('input[name=parent_limited]').val();
				if (menu.find('.menu__item[data-id]').not('.menu__item-guest').not('.menu__item-active').length) {
					menu.find('.menu__group[data-group]').each(function () {
						let id_group = $(this).attr('data-group').toInt();
						if (!parent_limited && !$(this).find('.menu__item[data-id]').not('.menu__item-guest').not('.menu__item-active').length) {
							hidden.push(-id_group);
						} else {
							$(this).find('.menu__item-active[data-id]').each(function () {
								hidden.push($(this).attr('data-id').toInt());
							})
						}
					});
				}
				menu.find('.menu__item-guest.menu__item-active').each(function () {
					guests.push($(this).attr('data-id').toInt());
				});
				if (hidden.join(',') !== form.find('input[name=hidden]').val() || guests.join(',') !== form.find('input[name=guests]').val()) {
					form.find('input[name=hidden]').val(hidden.join(','));
					if (options.guests) form.find('input[name=guests]').val(guests.join(','));
				}
			});
		},

		stage: function(options) {
			options ||= {}
			let o_selected = App.modal.obj_window.find('.modal__massSelected');
			let menu = App.modal.obj_window.find('.menuFake').eq(0);
			o_selected.on('click', '.modal__massSelected .data', function() {
				menu.find('.menu__item[data-id=0]').click();
				// App.modal.obj_window.find('input[name=is_updated]').val(1);
				// menu.find('.menu__item-active').removeClass('menu__item-active');
				// o_selected.html(App.helper.template.fill(options.template + '_empty', {name: ''}));
			});
			let stage_type = menu.is('[data-stage-type=1]') ? 1 : 0;
			menu.find('.menu__item[data-id]').bind('click', function() {
				App.modal.obj_window.find('input[name=is_updated]').val(1);
				App.controls.menu.item_set_active(this);
				let id_stage = $(this).attr('data-id').toInt();
				let id_tag = id_stage < 2 ? $(this).attr('data-inst') + '_' + 0 : id_stage;
				let html_stage = App.helper.template.fill(options.template, {
					id: id_stage,
					name: App.tags[id_tag].name,
					color: App.tags[id_tag].color,
					percent_style: App.tags[id_tag].percent_style,
					icon: App.tags_type_icon[stage_type][App.tags[id_tag].id_type],
				});
				o_selected.html(html_stage);
				return false
			}).filter('[data-id=' + options.id_active+ ']').addClass('menu__item-active');
		},

		assignee: function(options) {
			options ||= {}
			let o_selected = App.modal.obj_window.find('.modal__massSelected');
			let menu = App.modal.obj_window.find('.menuFake').eq(0);
			o_selected.on('click', function() {
				App.modal.obj_window.find('input[name=is_updated]').val(1);
				menu.find('.menu__item-active').removeClass('menu__item-active');
				o_selected.html(App.helper.template.fill('modal_massAssignee_empty', {name: '', id: 1}));
			});
			menu.find('.menu__item[data-id]').bind('click', function() {
				let id = $(this).attr('data-id').toInt();
				App.modal.obj_window.find('input[name=is_updated]').val(id !== -1 ? 1 : 0);
				App.controls.menu.item_set_active(this);
				o_selected.html(id !== -1 ? App.helper.template.fill('modal_massAssignee', {
					id,
					avatar: $(this).find('span:first-child').html(),
					name: $(this).find('.in').text(),
				}) : App.helper.template.fill('modal_massAssignee_diff'));
				return false
			}).filter('[data-id=' + options.id_active+ ']').addClass('menu__item-active');
		},

		tags: function (options) {
			options ||= {}
			let o_selected = App.modal.obj_window.find('.modal__massSelected');
			let menu = App.modal.obj_window.find('.menuFake').eq(0);
			let form = App.modal.obj_window.find('form').eq(0);
			App.controls.project_task_labels_and_go.init.call(menu, {
				search_callback: self.search_callback,
				detached_picker: true
			});
			menu.find('.menu__group-picker').addClass('menu__group-detached').appendTo(App.modal.obj_window.find('.modal__content__block-pickerZone'));
			menu.find('.scrollZone').removeClass('scrollZone keyboardZone keyboardZone-primary');

			let ids = form.find('input[name=tags]').length ? form.find('input[name=tags]').val().split(',').map(Number) : [];
			menu.find('.menu__item[data-id]').removeClass('menu__item-picked').filter(function() {
				return ids.includes($(this).attr('data-id').toInt());
			}).trigger('preset');

			menu.bind('after_interaction', function(e, data) {
				data ||= {};
				let ids = [];
				menu.find('.menu__item-picked').each(function() {
					ids.push($(this).attr('data-id').toInt());
				});
				form.find('input[name=tags]').val(ids.join(','));
				let cnt = ids.length;
				o_selected.html(cnt ? App.helper.template.fill('modal_massCnt', {cnt: cnt}) : '');
				if (!data.onload) form.removeClass('frm_unchanged').filter('.frm_needData').toggleClass('frm_dis', !cnt);
			}).trigger('after_interaction', {onload: true});

		},

		tags_minus: function() {
			let menu = App.modal.obj_window.find('.menuFake').parent().eq(0);
			let form = menu.closest('form');
			let o_selected = form.find('.modal__massSelected');
			let cnt = 0, ids = [];
			App.modal.obj_window.bind('keydown_intercept', function(e, data) {
				let keyCode = data.keyCode;
				if (keyCode === App.keycode.Escape) {
					if (menu.find('.selected').length) {
						menu.find('.selected').toggleSelected(false);
						data.intercepted = true;
						return false;
					}
				}
				if (keyCode === App.keycode.Tab) {
					if (menu.find('.selected').length) {
						menu.find('.selected').toggleSelected(false);
						form.find('.btn-primary').toggleSelected(true);
					} else {
						App.keyboard_selection.move_to_closest(menu);
						form.find('.btn-primary').toggleSelected(false);
					}
					data.intercepted = true;
					return false;
				}
				if (keyCode === App.keycode.Backspace || keyCode === App.keycode.Delete) {
					menu.find('.selected').trigger('click', [{delete: true, backward: keyCode === App.keycode.Backspace}]);
					data.intercepted = true;
				}
			});
			menu.find('.editBlock__picker__item').click(function(e, data) {
				data ||= {};
				if (!data.delete && !data.enter && !$(e.target).parents().addBack().filter('.delete').length) {
					if ($(this).hasClass('selected')) $(this).toggleSelected(false);
					else {
						menu.find('.selected').toggleSelected(false);
						$(this).toggleSelected(true);
					}
					return false;
				}
				cnt++;
				ids.push($(this).attr('data-id'));
				App.keyboard_selection.move_to_closest(menu, data.backward || false);
				$(this).remove();
				if (!menu.find('.editBlock__picker__item').length) {
					menu.remove();
					App.modal.obj_window.find('.modal__visibilityReset-labels').show();
				}
				form.find('input[name=tags]').val(ids.join(','));
				form.removeClass('frm_dis');
				o_selected.html(App.helper.template.fill('modal_massCnt', {cnt}));
				if (!menu.find('.editBlock__picker__item').length) form.find('.btn-primary').toggleSelected(true);
			});
			App.keyboard_selection.move_to_closest(menu);
		},

		copy_move: function(step, params) {
			params ||= {}
			if (step === 'step2') {
				let menu = App.modal.obj_window.find('.menuFake').eq(0);
				const context_search_callback = function (has_results) {
					App.controls.task_select_and_go.draw_tree.bind(menu);
					App.modal.obj_window.find('.buttons').toggleClass('buttons-asFooter', !has_results);
					App.modal.obj_window.find('.scrollZone').each(App.scroll_listener.onDivScroll);
				};
				App.controls.menu.init_toggle_search_bookmarks(menu, {
					obj_input: App.modal.obj_window.find('.modal__inlineSearch input'),
					obj_control: App.modal.obj_window.find('.menu__toggle-search-bookmarks'),
					context_search_callback: context_search_callback,
				});
				if (params.checkbox) {
					menu.find('.menu__item[data-id]').bind('click', function () {
						$(this).toggleClass('menu__item-active');
						let ids = [];
						menu.find('.menu__item-active').each(function() {
							ids.push($(this).attr('data-id'));
						});
						$(document.modfrm).find('input[name=id_task_many]').val(ids.join(','));
						if (ids.length) {
							$(document.modfrm).removeClass('frm_dis').find('ws-btn').toggleDisabled(false);
						} else {
							$(document.modfrm).addClass('frm_dis').find('ws-btn').toggleDisabled(true);
						}
						return false
					});

				} else {
					menu.find('.menu__item[data-id]').bind('click', function () {
						App.controls.menu.item_set_active(this);
						$(document.modfrm).find('input[name=id_task_to]').val($(this).attr('data-parent').toInt() || $(this).attr('data-id').toInt()).next().val($(this).attr('data-parent').toInt() ? $(this).attr('data-id').toInt() : 0);
						$(document.modfrm).removeClass('frm_dis').find('ws-btn').toggleDisabled(false);
						return false
					}).filter('[data-id=' + ($(document.modfrm).find('input[name=id_subtask_to]').val().toInt() || $(document.modfrm).find('input[name=id_task_to]').val().toInt()) + ']').addClass('menu__item-active');
				}

				App.modal.obj_window.find('.modal__inlineSearch input').bind('keyup', function () {
					App.context_search.menu.apply(this, menu, {
						callback: context_search_callback
					});
				});
			}
			if (params.other_project) {
				self.other_project = params.other_project;
				App.modal.obj_window.find('.other_project').click(function() {
					self.copy_move_projects_select(this);
					App.controls.project_select_and_go.show_context(this, null, {
						request: {type: self.other_project.type},
						onload: function () {
							let menu = $(this);
							App.controls.menu.init(menu);
							menu.on('click', '.menu__item', function() {
								App.menu.hide();
								App.modal.show({
									url: self.other_project.url.replace('%id%', $(this).attr('data-id')),
									replace: true,
									title: self.other_project.title,
							});
							});
						},
					});
				});
			}
		},

		copy_move_projects_select: function(anchor, params) {
			if (params) self.other_project = params;
			App.controls.project_select_and_go.show_context(anchor, null, {
				request: {type: self.other_project.type},
				backup: true,
				onload: function () {
					let menu = $(this);
					App.controls.menu.init(menu);
					menu.on('click', '.menu__item', function() {
						App.menu.hide();
						App.modal.show({
							url: self.other_project.url.replace('%id%', $(this).attr('data-id')),
							replace: true,
							title: self.other_project.title,
						});
					});
				},
			});
		},

		email_to: function(options) {
			options ||= {}
			self.init_search();
			let menu = App.modal.obj_window.find('.menuFake').eq(0);
			let form = App.modal.obj_window.find('form').eq(0);
			menu.find('.menu__item[data-id]').click(function() {
				App.controls.menu.item_set_active(this);
				form.find('input[name=id_user_to]').val($(this).attr('data-id'));
				form.removeClass('frm_dis');
			});
			form.find('ws-btn[name*=primary]').click(function() {
				$(this).find('ws-icon').replaceWith('<span class="loader_sm loader_white loadingimg">');
				App.core.form_submit(form);
			})
		},

		init_search: function() {
			App.modal.obj_window.find('.modal__title__search input, .modal__content__searchInput').bind('keyup', function() {
				App.context_search.menu.apply(this, App.modal.obj_window.find('.menu-inModal'), {
					callback: self.search_callback
				});
			});
		},

		search_callback: function(has_results) {
			App.modal.obj_window.find('.buttons').toggleClass('buttons-asFooter', !has_results);
			App.modal.obj_window.find('.modal__infoRow').toggle(has_results);
			App.modal.obj_window.find('.scrollZone').each(App.scroll_listener.onDivScroll);
		},

		submit: function(form) {
			if ($(form).hasClass('frm_dis')) return false;
			else if ($(form).hasClass('frm_unchanged')) App.modal.hide({hide_all: true});

			let btn = $(form).find('button.btn-primary'), old_btn_html = btn.html();

			btn.html("<ws-icon name='input-circle-blank:stopwatch_parts-rotation' class='btn-left-icon ws-icon-spinner'></ws-icon>");
			const handle_result = () => {
				btn.html(old_btn_html);
			}
			App.core.form_submit(form, handle_result, handle_result);
		},

		init_custom_fields: function(form) {
			const value_input = $(form).find('input[name=value]');

			$(form).find('.menuFake--fieldSelect, .menuFake--fieldUser, .menuFake--fieldUsers').each(function() {
				$(this).on('click', '.menu__item[data-id]', function() {
					const group = $(this).closest('.menu__group');
					if (!group.hasClass('menu__group-checkbox')) group.find('.menu__item').removeClass('menu__item-active');
					$(this).toggleClass('menu__item-active');
					value_input.val(App.controls.menu.get_active_ids($(this).closest('.menuFake')).join(','));
				});
			});

			$(form).find('.menuFake--fieldDate').each(function() {
				App.controls.menu_datepicker.onshow(this, { maxDate: undefined, defaultDate: null, beforeShowDay: undefined });
				$(this).on('select', function (e, val) {
					value_input.val(val);
					$(form).find('.menuFake--fieldDate').addClass('menuFake--fieldDate-active');
				});
			});

			$(form).find('input.timepicker').each(function() {
				$(this).timepicker({
					minTime: '00:00',
					maxTime: '24:00',
					minWorkTime: '00:00',
					maxWorkTime: '24:00',
					timeFormat: App.config.is_24h ? 'H:i' : 'g:ia',
					step: parseInt($(this).attr('data-step') || '15'),
					orientation: 'l',
				});
				$(this).on('selectTime', function(e, data) {
					value_input.val(data.time);
				});
			});

			$(form).find('.block-fieldLink').each(function() {
				const name = $(this).find('input[name=url_name]'), link = $(this).find('input[name=url_link]');
				name.add(link).on('change', function() {
					value_input.val(JSON.stringify({ name: name.val(), link: link.val() }));
				});
			});
		},

		resize_checkbox_row: function () {
			if (!App.modal.obj_window.find('.modal__optionsCheckboxes').length) return;
			App.modal.obj_window.find('.modal__optionsCheckboxes')
				.removeClass('modal__optionsCheckboxes-grouped')
				.addClass('ws-utility-visibility-hidden')
				.addClass('ws-utility-overflow-hidden');

			const tasks_start_el = App.modal.obj_window.find('.modal__optionsCheckboxes').find('.tasksStart');
			const tasks_start_el_display_original = tasks_start_el.css('display');
			tasks_start_el.show();

			if (App.modal.obj_window.find('.modal__optionsCheckboxes').hasScrollBar(true)) {
				App.modal.obj_window.find('.modal__optionsCheckboxes')
					.addClass('modal__optionsCheckboxes-grouped');
			}

			tasks_start_el.css('display', tasks_start_el_display_original);
			App.modal.obj_window.find('.modal__optionsCheckboxes')
				.removeClass('ws-utility-visibility-hidden')
				.removeClass('ws-utility-overflow-hidden');

		},
		priority: function () {
			App.modal.obj_window.find('.menu__item[data-id]').click(function() {
				App.controls.menu.item_set_active(this);
				App.modal.obj_window.find('input[name=important]').val($(this).attr('data-id'));
			});
		}
	}
})();

;var App = App || {};

(function() {
	let self = App.menu = {

		obj_window: null,
		active_anchor: null,
		active_box: null,
		prev_box: null,
		in_editor: false,
		force_css_pos: null,
		force_css_box: null,
		force_class: null,

		observer: null,

		safe_triangle: { vertical_padding_pc: 10, cursor_offset_px: 0, max_width_pc: 65 },
		do_not_hide_on_goto: false,

		shown: false,
		last_show_ts: 0,
		watch_cache_triggers: new Set(),

		debug: false,

		mouse_position_cache: null,

		is_shown() {
			return self.shown;
		},

		obj_detached: {},

		find: function(id) {
			return self.obj_detached[id] || $();
		},

		history_data: [],

		/**
		 * @deprecated
		 * may be rewritten by show(data) { anchor = arguments[0], type = arguments[1] ... }
		 */
		show_deprecated: function (anchor, type, box, title, again) {
			self.show({anchor, type, box, title, again});
		},

		reload: function(callback) {
			if (self.obj_window == null || self.active_box == null) return;

			self.obj_window.invalidateMenu();
			let data = self.active_box.menu_data;
			data.reload = true;
			data.backup = false;
			data.again = false;
			data.onreload = callback;
			self.show(data);
		},

		hide_and_reset() {
			if (!self.is_shown()) return;

			let data = self.active_box.menu_data;

			if (data.url) {
				self.obj_detached[self.get_cache_key(data)] = null;
			}

			self.hide();
		},

		/**
		 * @param {MenuShowData} data
		 * @return {boolean}
		 */
		show: function (data) {
			if (self.debug) console.trace('menu', 'show', {...data});
			if (App.offline_mode.is_on()) return;

			if (App.click_listener.long) {
				App.haptics.contextmenu();
			}

			self.last_show_ts = Date.now();
			data.type ||= '';
			data.class ||= '';
			data.box ||= '';
			data.title ||= '';
			data.again ||= false;
			data.backup ||= false;
			data.replace ||= false;
			data.reload ||= false;
			data.no_anim ||= false;
			data.use_prev_height ||= false;
			data.force_dropdown ||= false; // впливає на вигляд меню на мобільних пристроях
			data.post_data ??= null;
			if (!self.is_shown() || data.replace) data.backup = false;

			let force_dropdown_lvl2 = false;
			if ($(window).width() <= APP_SCREEN_THRESHOLD && self.active_anchor && self.active_anchor != data.anchor && data.backup && data.force_dropdown && self.active_box.menu_data.force_dropdown && $(data.box).closest('.menu__submenuWrapper').length > 0) {
				force_dropdown_lvl2 = true;
			}

			// noblur may be litttle buggy, cause added for one reason @see task_create
			if (data.noblur !== true && data.type.indexOf('text') === -1 && !App.device.is_mobile()) try {
				$(data.anchor).blur();
			} catch (e) {}
			if (data.url) {
				if (!self.obj_detached[self.get_cache_key(data)]) {
					let menu_class = 'menu menu-secondary menu-dynamic';
					menu_class = (menu_class+' '+data.class).trim();
					const param_type = (new URLSearchParams(data.url)).get('type');
					if (param_type) {
						menu_class += ' menu-type-'+param_type;
					}
					self.obj_detached[self.get_cache_key(data)] = $('<div />')
						.attr('class', menu_class)
						.attr('data-load-menu', data.url)
						.attr('data-cache-trigger', data.cache_trigger || 'no');
					if (data.cache_trigger && data.oninvalidate) {
						self.obj_detached[self.get_cache_key(data)].get(0).oninvalidate = data.oninvalidate;
					}

					if (data.cache_ttl) self.obj_detached[self.get_cache_key(data)].attr('data-cache-expire', App.helper.time.now() + data.cache_ttl);
					if (data.load_always) self.obj_detached[self.get_cache_key(data)].attr('data-load-always', 'yes');
				}
				data.box = self.obj_detached[self.get_cache_key(data)].get(0);
			}
			else if (data.box) data.box = $(data.box).get(0);
			else data.box = $('#' + data.anchor.id + '__menu').get(0) || $('#' + data.anchor.id.replace(/__.*/, '') + 'menu').get(0);
			if (!data.box) return;

			$(data.box).removeClass('menu-mode-dropdown menu-mode-auto');
			$(data.box).removeClass('menu-h48 menu-h44');
			if (App.device.is_mobile()) {
				// на мобілі важливо, якщо емптік поза скоролЗоною, перемістити його ДО неї, щоб він не був притиснутий до футера
				$(data.box).find('.menu__group-empty').prev('.scrollZone').before($(data.box).find('.menu__group-empty'));

				const max_layer = App.task_panel._layers.get_max_layer();
				$(data.box).css('--layer', max_layer ?? '');

				if (data.force_dropdown) {
					data.box.classList.add('menu-mode-dropdown');
					data.box.classList.add('menu-h44');
				} else {
					data.box.classList.add('menu-mode-auto');
					data.box.classList.add('menu-h48');
				}
			}

			data.box.menu_data = data;
			if (data.width) $(data.box).css({width: data.width});
			// if (data.height) $(data.box).css({height: data.height, '--max-height': data.height});

			if (+$(data.box).attr('data-cache-expire') > 0 && +$(data.box).attr('data-cache-expire') < App.helper.time.now()) {
				$(data.box).attr('data-loaded', null);
			}

			let scheduled_hide_obj_window = null;
			let is_replace = false;
			let prev_menu_height = null;
			// if (!data.again) self.in_editor = false;
			if (data.reload) {} else if (data.replace) {
				data.anchor = self.active_anchor;
				self.prev_box = self.active_box;
				if (self.prev_box && data.use_prev_height) prev_menu_height = $(self.prev_box).height();
				is_replace = true;
				data.replace = false;
				data.no_anim = true;
				scheduled_hide_obj_window = self.obj_window != null;
				if (self.obj_window) self.obj_window.addClass('menu-unloading');
				//self.obj_window.hide();
			} else if (self.active_anchor && self.active_anchor != data.anchor && !data.backup) {
				self.hide(true);
			}
			if ($(data.box).attr('data-load-menu') && !data.again && !$(data.box).attr('data-loaded')) {
				if (self.mouse_position.timeout) clearTimeout(self.mouse_position.timeout);
				App.click_listener.helper_stop_click()
				$('#dropmoregmenu, #dropmore2gmenu').remove();
				data.box._start_loading_ts = self.last_show_ts;
				if (!$(data.box).hasClass('menu--fixedHeight')) $(data.box).css('minHeight', '');
				$(data.box).clear_once_by_criteria('init-feature-reason');
				$(data.box).clear_once_by_criteria('menu_load');

				if (data.before_load) data.before_load.call(self.active_box, self.active_box);
				App.core.async_task.ajax({
					type: data.post_data ? 'POST' : 'GET',
					url: $(data.box).attr('data-load-menu'),
					data: data.post_data,
					dataType: 'html',
					success: function (response, status, xhr) {
						if (data.box._start_loading_ts !== self.last_show_ts) return;

						$(data.box).html(response);

						data.box.onload_fired = false;
						// тут робиться $().off() всіх обробників, але деякі не будуть повторно додані
						// наприклад, через $().once_by_criteria('wshover')
						// поки як костиль роблю очистку, але можливо треба видаляти обробники по namespace
						// Answer: тоді обробники треба вішати тільки в onload (здається логічним)
						$(data.box).clear_once_by_criteria('wshover');
						$(data.box).clear_once_by_criteria('last_value_apply');
						$(data.box).clear_once_by_criteria('last_value_change');
						$(data.box).off().not('[data-load-always]').attr('data-loaded', 'yes');
						data.again = true;
						if (xhr.getResponseHeader("X-Menu-width")) {
							$(data.box).css({width: xhr.getResponseHeader("X-Menu-width")});
						}
						if (xhr.getResponseHeader("X-Menu-cache-trigger")) {
							$(data.box).attr('data-cache-trigger', xhr.getResponseHeader("X-Menu-cache-trigger"));
						}
						if (xhr.getResponseHeader("X-Menu-cache-ttl")) {
							$(data.box).attr('data-cache-expire', App.helper.time.now() + parseInt(xhr.getResponseHeader("X-Menu-cache-ttl")));
						} else {
							$(data.box).attr('data-cache-expire', null);
						}
						if (xhr.getResponseHeader("X-Menu-class")) {
							$(data.box).addClass(xhr.getResponseHeader("X-Menu-class"));
						}
						if (scheduled_hide_obj_window) {
							if (self.obj_window) self.obj_window.removeClass('menu-active').removeClass('menu-unloading');
							data.no_anim = true;
						}

						if (xhr.getResponseHeader("X-Menu-cache-trigger") == null) {
							App.core.warn('menu.trigger_not_set', $(data.box).attr('data-load-menu'));
						}

						// це треба для позиціонування меню, що з'являються "під курсором"
						data.replace = is_replace;

						self.show(data);
					},
					error: function (xhr, status, errorThrown) {
						if (data.box._start_loading_ts !== self.last_show_ts) return;

						if (status === 'error') {
							let old_box = self.obj_detached[self.get_cache_key(data)];
							if (old_box) {
								old_box.removeWithComponents();
								self.obj_detached[self.get_cache_key(data)] = undefined;
							}
							return;
						}
					}
				});

				return false;
			}

			if (scheduled_hide_obj_window) self.obj_window.removeClass('menu-active').removeClass('menu-unloading');
			// if (App.mymenu.is_shown() && data.type.indexOf('mymenu') === -1 && !App.modal.is_shown() && !App.task_view.is_shown() && !self.same_position) {
			// 	$('body').css({height: 'auto'});
			// 	App.mymenu.hide();
			// }
			if ($(data.box).hasClass('menu-userCardMinimal') && $(data.box).find('.l').length) $(data.box).removeClass('menu-userCardMinimal');
			if (data.type.indexOf('min_wid')) data.type = data.type.replace('min_wid', 'left');
			if (data.backup) {
				self.obj_window.addClass('menu-paused');
				// if ($(window).width() <= APP_SCREEN_THRESHOLD) {
				// 	self.obj_window.removeClass('menu-fullscreen').css('margin-top', '');
				// }
				self.history_data.push({
					anchor: self.active_anchor,
					box: self.active_box,
				});
			}
			self.active_anchor = data.anchor;
			self.active_box = data.box;
			self.obj_window = $(data.box);

			self.obj_window.once_by_criteria('init-feature-reason').each(function () {
				if (self.obj_window.is('#sidebarProfileMenu')) return;

				const item_sel = '.menu__item';
				const attr_sel = '[data-feature-reason]';

				if (self.obj_window.find(item_sel+':not('+attr_sel+')').not('.menu__submenuWrapper '+item_sel).length === 0) return;

				const items = self.obj_window.find(item_sel+attr_sel).not('.menu__submenuWrapper '+item_sel);
				if (items.length < 2) return;

				const trigger = App.controls.menu.create_item({left_icon: 'award-fill', title: App.i18n.t('more_feature_menu_item'), right_icon: 'arrows/chevron-right'});
				const group = App.controls.menu.create_group({items: [trigger], bottom: true });
				const menu = App.controls.menu.create_menu({groups: [items.get()]});
				trigger.on('click', function () {
					menu.show({anchor: trigger, backup: true, type: 'submenu' });
				});
				let last = self.obj_window.find('.menu__group').last();
				last.after(group);
			});

			self.shown = true;
			App.core.history?.mobile?.push('menu');
			if (data.again) {
				if (self.obj_window.attr('data-onload')) setTimeout(self.obj_window.attr('data-onload'), 0);
			}
			if (!data.box.onload_fired) {
				data.box.onload_fired = true;
				$(self.active_box).on('click', '.menu__item-disabled', function (e) {
					e.stopImmediatePropagation();
					return false;
				});
				self.obj_window.trigger('onload');
				if (data.onload) data.onload.call(self.active_box, self.active_box);
			}

			// --- auto bind double click on .menu__item ---
			let form = self.obj_window.find('form');
			let submit_button = null;

			if (form.length) {
				form.find('ws-btn, button').each(function() {
					let events = $._data(this, 'events');
					if (events && events.click) {
						for (let i = 0; i < events.click.length; i++) {
							let handler = events.click[i].handler;
							if (handler && (handler.name === 'form_submit' || (handler.toString && handler.toString().includes('form_submit')))) {
								submit_button = this;
								break;
							}
						}
					}
					if (submit_button) return false;
				});
			}

			let radio_btn = null;
			if (!submit_button) {
				let radio_group = self.obj_window.find('.menu__group-radio');
				if (radio_group.length) {
					radio_btn = self.obj_window.find('ws-btn button').get(0);
				}
			}

			if (submit_button || radio_btn) {
				self.obj_window.find('.menu__item').each(function() {
					let item = $(this);
					if (!item.attr('onclick')) {
						item.off('dblclick.menu_item').on('dblclick.menu_item', function() {
							let target_button = submit_button;
							if (!target_button && item.closest('.menu__group-radio').length && radio_btn) {
								target_button = radio_btn;
							}
							if (target_button && !$(submit_button).attr('disable-menu-dblclick')) {
								item.addClass('menu__item-onDblClick');
								setTimeout(function () {
									$(target_button).trigger('click');
								}, 100);
							}
						});
					}
				});
			}
			// --- /auto bind double click on .menu__item ---

			// TODO можливо, onreload треба виконувати після onload (@see js/modal.js:375, js/controls/tag_edit.js:20)
			if (data.reload && data.onreload) data.onreload.call(self.active_box, self.active_box);

			// Обсервер высоты не пригодился
			// if ("ResizeObserver" in window) {
			// 	if (!self.observer) {
			// 		self.observer = new ResizeObserver((entries) => {
			// 			for (const entry of entries) self.update_maxHeight.call(entry.target);
			// 		});
			// 		self.observer.observe(data.box);
			// 	}
			// }

			$('body').addClass('bodyWithMenu');
			self.obj_window.find('[data-copy]').each(function () {
				if ($($(this).attr('data-copy')).length) {
					$(this).html($($(this).attr('data-copy')).html())
					$(this).find('[data-nocopy]').remove();
					$(this).find('.wshover').removeClass('wshover');
				} else {
					$(this).prev().filter('.line').remove();
					$(this).remove();
				}
			});
			if (data.type.indexOf('text') === -1) $('#menuOverlay').show().attr('data-sticky-focus', 'off');
			let scrollZone_css_box = {};
			let css_pos = {};
			let css_box = {};
			self.obj_window.toggleClass('menu-withEditorSearch', data.type.indexOf('text') !== -1);
			let ds_el = data.type.indexOf('parent4') !== -1 ? $(data.anchor).parent().parent().parent().parent() : data.type.indexOf('parent3') !== -1 ? $(data.anchor).parent().parent().parent() : (data.type.indexOf('parent2') !== -1 ? $(data.anchor).parent().parent() : (data.type.indexOf('parent') !== -1 ? $(data.anchor).parent() : (data.type.indexOf('prev') !== -1 ? $(data.anchor).prev() : $(data.anchor))));

			// -----------------------------------

			self.obj_window.find('.group_ignore').removeClass('group_ignore');
			self.obj_window.find('.menu__group-editorOnly').addClass('group_ignore');
			self.obj_window.find('.tmp_hidden').removeClass('tmp_hidden');
			self.obj_window.find('.menu__item-onDblClick').removeClass('menu__item-onDblClick');

			// ----------------------------------
			if (!self.obj_window.parent().hasClass('menu__submenuWrapper')) {
				self.obj_window.appendTo('#menuContainer');
			}
			self.obj_window.css(css_box).addClass('menu-active');

			$(self.active_box).off('click.onshow_disabled').on('click.onshow_disabled', '.menu__item-disabled', function (e) {
				e.stopImmediatePropagation();
				return false;
			});

			// should trigger search before positioning
			if (self.obj_window.attr('data-onshow')) setTimeout(self.obj_window.attr('data-onshow'), 0);
			self.obj_window.trigger('onshow');
			if (data.onshow) data.onshow.call(self.active_box, self.active_box);
			App.bus.app.emit('menu_show', self.active_box);


			// Add ScrollZone in menus
			if (!self.obj_window.find('.scrollZone').length && self.obj_window.find('.menu__group-searchable').not('.menu__group-noscroll').length) {

				const data_attributes = [];
				const clone_attrs = ['data-columns', 'data-nav'];
				clone_attrs.forEach(attr => {
					const val = self.obj_window.attr(attr);
					if (val !== undefined) {
						data_attributes.push(`${attr}="${val}"`);
					}
				});

				self.obj_window.find('.menu__group').not(
					'.menu__group-unsearchable, .menu__group-search, .menu__group-select-box, ' +
					'.menu__group-tabs, .menu__group-head, .menu__group-bottom, ' +
					'.menu__group-buttons , .menu__group-info').wrapAll(
						'<div class="menu__group-scrollZone"><div class="scrollZone keyboardZone" data-select=".menu__item" '+data_attributes.join(' ')+'></div></div>'
				);
			}

			self.obj_window.find('.menu__group-anchor').remove();
			self.obj_window.find('.menu__group-searchIco--mobile').removeClass('menu__group-searchIco menu__group-searchIco--mobile');
			if ($(window).width() <= APP_SCREEN_THRESHOLD && !data.force_dropdown) {

				// Lush на мобілі в великому меню треба завжди показувати іконку лупи
				if (
					!self.obj_window.find('.menu__group-picker').length
					&& self.obj_window.find('.menu__group-searchable').length
				) {
					self.obj_window.find('.menu__group-search').not('.menu__group-searchIco').addClass('menu__group-searchIco menu__group-searchIco--mobile');
				}

				self.obj_window.find('.menu__group-search a.delete').addClass('withRipple');

				if (!self.obj_window.find('.menu__swipe').length) self.obj_window.prepend('<div class="menu__swipe"></div>');

				if (is_replace && self.prev_box && $(self.prev_box).hasClass('menu-fullscreen')) {
					self.obj_window.addClass('menu-fullscreen noani swype').css({top: ''});
				} else {
					self.obj_window.removeClass('menu-fullscreen noani swype').css({
						marginTop: '',
						// experiment #8319786 - завжди притиснутий футер & покращена анімація
						// height: App.helper.viewport.height() - 4, // 4px - це позиція top в фулскрін режимі
					})
				}

				self.obj_window.eachDelayed(function () {
					$(this).removeClass('noani swype');
					self.resize_mobile_scrollZones();
				}, 300);
			} else {

				if (force_dropdown_lvl2) {
					const cloned_anchor = $(data.anchor).clone().removeClass('selected menu_open');
					cloned_anchor.removeAttr('onclick');
					const group_anchor = $('<div class="menu__group menu__group-anchor"></div>').html(cloned_anchor);
					cloned_anchor.on('click', function (e) {
						e.preventDefault();
						App.menu.hide(); // TODO flymod ховати з особливою анімацією
					});
					self.obj_window.prepend(group_anchor);
				}

				self.obj_window.find('.menu__swipe').remove();
			}
			self.obj_window.find('> form').addClass('flex_column flex_content');
			// to prevent form submit in menu by Enter
			self.obj_window.find('> form').on('submit.menu', function (e) { e.preventDefault(); });

			self.obj_window.removeClass('menu-collapsed menu-collapsed-in menu-collapsed-in-end menu-collapsed-out');

			if (data.text_position) {
				self.obj_window.find('.scrollZone').css('maxHeight', ''); // needs reset to get correct box_h
			}

			// do it earlier, to get correct anchor position
			$(data.anchor).addClass('menu_open').children().addBack().filter('.btn').addClass('hover');
			$(data.anchor).closest('.hoverZone').addClass('hoverZone-hover');

			const min_top = 5 + $('#sa_top').height();
			const min_bot = 5 + $('#sa_bot').height();
			const min_hor = 5;
			const box_pad = 0; //12;
			let kbd_h = App.helper.viewport.keyboard_height();
			let win_h = App.helper.viewport.height();
			let win_w = $(window).width();

			self.no_update_maxHeight = true;
			self.obj_window.css(css_box).css({
				left: '',
				top: '',
				bottom: '',
				right: '',
				maxHeight: '',
				overflowY: ''
			});
			let box_w = self.obj_window.outerWidth();
			let box_h = self.obj_window.outerHeight();
			let future_top = null;
			if (win_w <= APP_SCREEN_THRESHOLD && force_dropdown_lvl2) {

				const prev_data = self.history_data[self.history_data.length - 1];
				const prev_box = prev_data.box;
				const prev_box_w = $(prev_box).outerWidth();
				const prev_box_h = $(prev_box).outerHeight();

				css_box['width'] = Math.max(prev_box_w, box_w);

				const prevBoxBoundingRect = {
					left: $(prev_box).offset().left,
					top: $(prev_box).offset().top,
				};

				const prevItemBoundingRect = {
					left: ds_el.offset().left - box_pad,
					top: ds_el.offset().top - box_pad,
				};

				const anchor_item = self.obj_window.find('.menu__group-anchor .menu__item');

				const itemBoundingRect = {
					left: anchor_item.offset().left - box_pad,
					top: anchor_item.offset().top - box_pad,
				};

				const boxBoundingRect = {
					left: self.obj_window.offset().left,
					top: self.obj_window.offset().top,
				};

				/**
				 * transform: scale() & backdrop-filter: blur()
				 * заставляє вкладені елементи поводитися як position: absolute, замість fixed4
				 * TODO тож якщо це не submenu - то розрахунок буде інший
				 */
				const is_fixed = false;
				const tmp_top = prevItemBoundingRect.top - (itemBoundingRect.top - boxBoundingRect.top)

				// якщо влізло то відкривається вниз
				if (is_fixed) {
					css_box['top'] = tmp_top;
					css_box['left'] = prevItemBoundingRect.left - (itemBoundingRect.left - boxBoundingRect.left);
				} else {
					css_box['top'] = tmp_top - prevBoxBoundingRect.top + 4;
					css_box['right'] = 0;
				}

				// O Lushyk
				// Коли нехватає місця нехай перекриває все що треба та і все
				// Типу від верху росте вниз і якщо впирається внизу то росте вгору
				if (win_h <= (box_h + tmp_top)) {

					const prev_box_bottom_scaled = $(prev_box).offset().top + prev_box_h * 0.9;
					const box_bottom_scaled = tmp_top + box_h * 1.1111111;

					future_top = css_box['top'] + (prev_box_bottom_scaled - box_bottom_scaled);
				}
				// console.table({ prevBoxBoundingRect, prevItemBoundingRect, itemBoundingRect, boxBoundingRect });
			} else if (win_w <= APP_SCREEN_THRESHOLD && !data.force_dropdown) {
				css_box['width'] = '';
				// css_box['display'] = 'flex';
				// css_box['top'] = Math.max(win_h - box_h, 4);
				// $('#menuContainer .menu-paused').css({top: $(window).height() - self.obj_window.outerHeight() - 4});
			} else {
				if (data.type.indexOf('width') !== -1 || data.type.indexOf('min_wid') !== -1) {
					css_box['width'] = ds_el.outerWidth() + 2 * box_pad
				}
				if (data.type.indexOf('box_max') !== -1) {
					css_box['width'] = ds_el.outerWidth();
				}
				self.obj_window.css(css_box);
				const { x: mouse_position_x, y: mouse_position_y } = (is_replace ? self.mouse_position_cache : null) ?? self.mouse_position;
				if (data.text_position) {
					// не можна щоб такі менюшки перекривали текст,
					// тому беремо вільне місце зверху/знизу
					const space_above = data.text_position.y - min_top - 20;
					const space_below = win_h - data.text_position.y - min_bot - 10;
					// і пихаємо меню туди де більше місця (пріоритет над текстом)
					const place_below = space_below > space_above;
					let space_available = place_below ? space_below : space_above;

					if (self.prev_box) {
						space_available = self.prev_box.space_available;
						css_pos = self.prev_box.css_pos;
					} else {
						css_pos.left = data.text_position.x
							.clamp(min_hor, win_w - min_hor - box_w);

						if (place_below) {
							css_pos.top = data.text_position.y + 20;
							delete css_pos.bottom;
						} else {
							delete css_pos.top;
							css_pos.bottom = win_h - data.text_position.y + 10;
						}
					}

					const computedStyle = getComputedStyle(self.obj_window.get(0));
					const padding_top = parseFloat(computedStyle.paddingTop);
					const padding_bottom = parseFloat(computedStyle.paddingBottom);

					self.active_box.space_available = space_available;
					self.active_box.css_pos = css_pos;

					// не вилазимо за екран, обмежуючи скроллЗону
					scrollZone_css_box.maxHeight = (
						space_available
						- padding_top
						- padding_bottom
					).clamp(0, 440);
				} else if (mouse_position_x && mouse_position_y) {
					css_pos['left'] = mouse_position_x - Math.round(box_w / 2);
					css_pos['left'] = css_pos['left'].clamp(min_hor, win_w - min_hor - box_w);
					css_pos['top'] = mouse_position_y + 10;
					if (mouse_position_y > win_h / 2 && css_pos['top'] + box_h > win_h - min_bot) {
						delete (css_pos['top']);
						css_pos['bottom'] = win_h - mouse_position_y + 10;
					} else {
						css_pos['top'] = css_pos['top'].clamp(min_top, win_h - box_h - min_bot);
					}
				} else {
					let boundingRect = {
						left: ds_el.offset().left - box_pad,
						right: ds_el.offset().left + ds_el.outerWidth() + box_pad,
						top: ds_el.offset().top - box_pad,
						bottom: ds_el.offset().top + ds_el.outerHeight() + box_pad,
					}
					if (data.type.indexOf('picker') !== -1) {
						css_pos['left'] = boundingRect.left ;
						css_pos['top'] = boundingRect.top;
						css_box['width'] = ds_el.outerWidth();
						css_box['maxHeight'] = Math.max(440, win_h - min_bot - boundingRect.top);
						css_pos['top'] += win_h - min_bot - boundingRect.top - css_box['maxHeight'];
					} else {
						if (data.type.indexOf('right') !== -1 || data.type.indexOf('submenu') !== -1) {
							if (boundingRect.left > win_w / 2 && boundingRect.right + box_w > win_w - min_hor) {
								css_pos['left'] = boundingRect.left - box_w;
							} else {
								if ($(data.box).is('#sidebarAccOtherMenu')) {
									css_pos['left'] = boundingRect.right + 6;
								} else {
									css_pos['left'] = boundingRect.right;
								}
							}
						} else if (data.type.indexOf('left') !== -1 || data.type.indexOf('width') !== -1 || data.type.indexOf('box_max') !== -1) {
							if (boundingRect.left > win_w / 2 && boundingRect.left + box_w > win_w - min_hor) {
								css_pos['left'] = boundingRect.right - box_w;
							} else {
								css_pos['left'] = boundingRect.left;
							}
						} else {
							if (boundingRect.right < win_w / 2 && boundingRect.right - box_w < min_hor) {
								css_pos['left'] = boundingRect.left;
							} else {
								css_pos['left'] = boundingRect.right - box_w;
							}
						}
						css_pos['left'] = css_pos['left'].clamp(min_hor, win_w - min_hor - box_w);

						if (data.type.indexOf('right') !== -1 || data.type.indexOf('submenu') !== -1) {
							if (boundingRect.top > win_h / 2 && boundingRect.bottom + box_h > win_h - min_bot) {
								if ($(data.box).is('#sidebarProfileMenu')) {
									css_pos['bottom'] = $(window).height() - boundingRect.bottom - 28;
								} else if ($(data.box).is('#sidebarAccOtherMenu')) {
									css_pos['bottom'] = $(window).height() - boundingRect.bottom - 74;
								} else {
									css_pos['bottom'] = $(window).height() - boundingRect.bottom;
								}
								css_pos['bottom'] = css_pos['bottom'].clamp(min_bot + kbd_h, $(window).height() - box_h - min_top);
							} else {
								css_pos['top'] = boundingRect.top;
								css_pos['top'] = css_pos['top'].clamp(min_top, win_h - box_h - min_bot);
							}
						} else if (data.type.indexOf('bottom') !== -1) {
							if (boundingRect.bottom < win_h / 2 && boundingRect.bottom - box_h < min_top) {
								css_pos['top'] = boundingRect.bottom;
								css_pos['top'] = css_pos['top'].clamp(min_top, win_h - box_h - min_bot);
							} else {
								css_pos['bottom'] = $(window).height() - boundingRect.top;
								css_pos['bottom'] = css_pos['bottom'].clamp(min_bot + kbd_h, $(window).height() - box_h - min_top);
							}
						} else {
							if (boundingRect.top > win_h / 2 && boundingRect.top + box_h > win_h - min_bot) {
								css_pos['bottom'] = $(window).height() - boundingRect.top;
								css_pos['bottom'] = css_pos['bottom'].clamp(min_bot + kbd_h, $(window).height() - box_h - min_top);
							} else {
								css_pos['top'] = boundingRect.bottom;
								css_pos['top'] = css_pos['top'].clamp(min_top, win_h - box_h - min_bot);
							}
						}
						if (data.type.indexOf('center') !== -1) {
							css_pos['left'] = ((boundingRect.left + boundingRect.right) / 2) - (box_w / 2);
						}
					}
				}
			}
			if (self.same_position && self.force_css_pos) {
				if (self.remove_editor_css) self.force_class = self.force_class.replace('menu-withEditorSearch', '');
				self.same_position = false;
				css_pos = self.force_css_pos;
				css_box = self.force_css_box;
				self.obj_window.attr('class', self.force_class);
			} else if (is_replace && self.force_css_pos && self.force_css_box) {
				css_pos = self.force_css_pos;
				css_box = self.force_css_box;
			} else {
				self.force_css_pos = css_pos;
				self.force_css_box = css_box;
			}

			if (data.offset) {
				if (css_pos.top) css_pos.top += data.offset.top || 0; else css_pos.bottom -= data.offset.top || 0;
				if (css_pos.left) css_pos.left += data.offset.left || 0; else css_pos.right -= data.offset.left || 0;
			}

			// if (win_w <= APP_SCREEN_THRESHOLD && css_box.top < 99) {
			// 	self.obj_window.addClass('menu-fullscreen').attr('data-top', css_box.top).find('.menu__swipe').css({width: ''});
			// 	css_box.top = 4;
			// }

			/* Reversible */
			if (self.obj_window.hasClass('menu--reversible')) {
				const should_reverse = css_pos.bottom > 0 && !self.obj_window.hasClass('menu--reversed');
				const should_unreverse = !css_pos.bottom && self.obj_window.hasClass('menu--reversed');
				if (should_reverse || should_unreverse) {
					self.obj_window.append(self.obj_window.find('.menu__group__wrapper').children('.menu__group').get().reverse());
					self.obj_window.find('.menu__group--reversible').each(function () {
						$(this).append($(this).children().get().reverse());
					});

					self.obj_window.toggleClass('menu--reversed', should_reverse);
				}
			}
			/* /Reversible */

			/* Fixed height */
			if (css_pos.bottom > 0 && self.obj_window.find('.menu__group-search').length) {
				const is_replaced = is_replace && self.force_css_pos && self.force_css_box;
				const prev_height = is_replaced ? $(self.prev_box).outerHeight() : self.obj_window.outerHeight();
				const min_height = prev_menu_height ? prev_menu_height : prev_height;
				self.obj_window.css('minHeight', min_height);
				self.obj_window.addClass('menu--fixedHeight');
			} else {
				self.obj_window.css('minHeight', '');
				self.obj_window.removeClass('menu--fixedHeight');
			}
			/* /Fixed height */

			self.obj_window.use_show_animation = data.no_anim !== true;

			if(self.obj_window.use_show_animation) {
				if (force_dropdown_lvl2) {
					self.obj_window.addClass('menu-collapsed');
				} else {
					if (self.obj_window.hasClass('menu-mode-auto')) {
						self.obj_window.css({
							transition: 'unset',
							top: '100%',
						});
					} else {
						self.obj_window.css({
							transition: '',
							opacity: 0,
							scale: 0.97
						});
					}
				}
			}

			self.obj_window.css(css_box).css(css_pos);
			self.active_box.css_pos = css_pos;
			if (data.text_position) {
				self.obj_window.find('.scrollZone').css(scrollZone_css_box);
			} else if (is_replace && self.force_css_pos && self.force_css_box) {
				self.fit_desktop_scrollZone();
			}

			if (self.obj_window.use_show_animation) {
				self.obj_window.find('.scrollZone').each(function () {
					if (this.scrollBars) this.scrollBars.destroy();
				});
				setTimeout(() => {
					if (force_dropdown_lvl2) {
						if (self.obj_window) self.obj_window.addClass('menu-collapsed-in');
						if (self.obj_window && future_top !== null) self.obj_window.css('top', function (index, attr) {
							$(this).data('originalTop', attr);
							return future_top;
						});
					} else {
						if (self.obj_window) {
							if (self.obj_window.hasClass('menu-mode-auto')) {
								self.obj_window.css({
									transition: '',
									top: '',
								});
							} else {
								self.obj_window.css({
									transition: 'scale 0.15s ease-out, opacity 0.15s ease-out',
									opacity: 1,
									scale: 1,
								});
							}
						}
					}
				}, 1);
			}

			self.mouse_position.x = self.mouse_position.y = 0;

			let _init = () => {
				if (!self.obj_window) return;

				self.obj_window.css('transition', '').css('opacity', '').css('scale', '');
				if (self.obj_window.hasClass('menu-collapsed-in')) self.obj_window.removeClass('menu-collapsed menu-collapsed-in').addClass('menu-collapsed-in-end');
				self.obj_window.trigger('transitionend');

				if (App.device.is_mobile()) {
					// треба ховати клавіатуру, можливо тільки якщо !force_dropdown
					const is_keyboard_shown = App.controls.keyboard_detect.is_shown();
					if (!self.in_editor) document.activeElement.blur();
					if (self.obj_window.hasClass('menu--editBlock')) {
						self.obj_window.find('.editBlock__input input').focus_select();
						self.obj_window.find('.editBlock__input input').stickyFocus();
					} else {
						// на мобілі фокус треба робити тільки в прості меню (типу створення групи)
						// тож в меню з фільторм-пошуком робимо фокус тільки якщо клавіатура вже була відкрита
						if (is_keyboard_shown || !self.obj_window.find('.menu__group-searchable').length) {
							self.obj_window.find('.menu__group-search input').focus_enhanced({
								keyup: true,
							});
						}
						if (is_keyboard_shown) {
							self.obj_window.find('.editBlock__input input').focus_select();
							self.obj_window.find('input[data-focus="focus-select"]:visible').focus_select();
						}
					}
				} else {
					self.obj_window.find('.menu__group-search input').focus_enhanced({
						desktop_only: true,
						keyup: true,
					});
					self.obj_window.find('.editBlock__input input').focus_select_desktop();
					self.obj_window.find('input[data-focus="focus-select"]:visible').focus_select_desktop();
				}

				self.update_maxHeight.call(self.active_box);
				setTimeout(() => self.update_maxHeight.call(self.active_box), 10);

				self.obj_window.removeClass('keyboardZone-active');

				self.init_scroll_zones();
				self.init_submenu(self.active_box);

				let scroll_obj = self.obj_window.find('.scrollZone').filter(function () {
					return !$(this).closest('.editBlock__picker').length;
				});
				if (scroll_obj.length) {
					if (data.type.indexOf('bottom') !== -1 && $(window).width() > 480) {
						scroll_obj.scrollDelay(scroll_obj.get(0).scrollHeight);
					} else {
						scroll_obj.scrollDelay(0);
					}
				}
				const picker_scroll_obj = self.obj_window.find('.scrollZone').filter(function () {
					return $(this).closest('.editBlock__picker').length;
				});
				if (picker_scroll_obj.length) {
					picker_scroll_obj.scrollTop(picker_scroll_obj.get(0).scrollHeight);
					picker_scroll_obj.find('.editBlock__picker__search input')
						.off('.menu')
						.on('input.menu', function () {
							picker_scroll_obj.scrollTop(picker_scroll_obj.get(0).scrollHeight);
						})
						.on('focus.menu', function () {
							picker_scroll_obj.scrollTop(picker_scroll_obj.get(0).scrollHeight);
						});
				}

				let last_visible_group = self.obj_window.find('.menu__group:visible').last();
				if (last_visible_group.hasClass('menu__group-gray')) {
					last_visible_group.addClass('menu__group-bottom');
					self.obj_window.addClass('menu-bottomgray');
				}

				$(document).trigger('menu_load.everytime');
				$(document).trigger('menu_load.once').unbind('menu_load.once');

				if ($(data.box).attr('data-cache-trigger')) $(data.box).attr('data-cache-trigger').split(',').forEach(function (i) {
					self.watch_cache_triggers.add(i);
				});
			};

			if (self.obj_window.use_show_animation) {
				setTimeout(_init, 155);
			} else {
				setTimeout(_init, 0);
			}

			// self.obj_window.find('.menu__item .when-disabled').on('click', function (e) {
			// 	e.preventDefault()
			// 	e.stopPropagation()
			// 	return false;
			// })
			self.obj_window.find('.menu__item[data-cmd]').on('click', function () {
				const onclick = $(this).attr('onclick');

				if (onclick == null) return;
				if (onclick.startsWith('App.menu.show')) return;
				if (onclick.startsWith('App.task_edit.')) return;
				if (onclick.startsWith('App.controls')) return;
				if (onclick.startsWith('App.admin_menu.show_menu')) return;
				if (onclick.startsWith('App.profile.show_menu')) return;
				if (onclick.startsWith('App.comments.show_reaction_menu')) return;
				if (onclick.includes('clipboard_from_menu')) return;
				if (onclick.startsWith('App.mass_operations.copy_move_projects_select')) return;

				App.menu.hide_and_reset();
			})
			self.obj_window.find('.menu__group').each(function () {
				if ($(this).html().trim() === '') {
					$(this).remove();
				}
			})
		},

		hide_all: function() {
			if (self.debug) console.trace('menu', 'hide_all');
			while (self.is_shown() && !self.active_box.menu_data.hiding) self.hide();
		},

		hide: function (config) {
			if (self.debug) console.trace('menu', 'hide', config);

			config ||= {}
			if (window.ignore_drophide) return;
			if (!self.is_shown()) return;


			const data = self.active_box.menu_data;

			if (data.hiding) return;
			data.hiding = true;


			self.resize_mobile_scrollZones.reset();

			self.obj_window.trigger('before_hide');
			self.obj_window.find('.keyboardZone-active').removeClass('keyboardZone-active');
			self.obj_window.find('.selected').toggleSelected(false);
			self.obj_window.find('.menu__item.ign_hover').removeClass('ign_hover');
			self.obj_window.find('.loader_sm').prev().show().next().remove();
			if (window.loader_tm) clearTimeout(window.loader_tm);
			$(self.active_anchor).removeClass('menu_open').children().addBack().filter('.btn').removeClass('hover');
			$(self.active_anchor).closest('.hoverZone').removeClass('hoverZone-hover');
			self.obj_window.find('.menu__group-search:not([data-protected]) input').val('').trigger('keyup').trigger('input');
			self.obj_window.find('form').removeAttr('data-submitted');
			self.obj_window.find('form').off('submit.menu');
			self.obj_window.find('.editBlock__input input').stickyFocus('destroy');

			self.obj_window.css('min-height', 'unset');
			self.obj_window.find('.scrollZone').css('maxHeight', '');


			self.mouse_position_cache = null;

			if ($(window).width() <= APP_SCREEN_THRESHOLD && !data.force_dropdown) {
				self.obj_window.css('top', '100%').eachDelayed(function () {
					$(this).removeClass('menu-active').css('margin-top', '').css('top', '');
					$(this).removeClass('menu-mode-dropdown menu-mode-auto');
					$(this).removeClass('menu-h48 menu-h44');
				}, 155);
			} else {
				if (self.obj_window.hasClass('menu-collapsed-in-end')) {
					self.obj_window.addClass('menu-collapsed-out');
					const originalTop = self.obj_window.data('originalTop');
					if (originalTop) {
						self.obj_window.css('top', originalTop);
					}
					self.obj_window.eachDelayed(function () {
						$(this).removeClass('menu-active menu-unloading');
						$(this).removeClass('menu-collapsed menu-collapsed-in menu-collapsed-in-end menu-collapsed-out');
						$(this).removeClass('menu-mode-dropdown menu-mode-auto');
						$(this).removeClass('menu-h48 menu-h44');
					}, 155);
				} else {
					self.obj_window.removeClass('menu-active menu-unloading');
					self.obj_window.removeClass('menu-mode-dropdown menu-mode-auto');
					self.obj_window.removeClass('menu-h48 menu-h44');
				}
			}
			if (self.observer) {
				self.observer.unobserve(self.active_box);
				self.observer = null;
			}

			App.bus.app.emit('menu_hide', self.active_box);

			if (App.menu.obj_window.get(0).contains(document.activeElement)) {
				$(document.activeElement).blur();
			}

			if (self.history_data.length) {
				if (self.active_box.menu_data?.onhide) self.active_box.menu_data.onhide.call(self.active_box, self.active_box);
				let data = self.history_data.pop();
				self.active_anchor = data.anchor;
				self.active_box = data.box;
				self.obj_window = $(data.box);
				self.obj_window.removeClass('menu-paused');
				// if ($(window).width() <= APP_SCREEN_THRESHOLD) {
				// 	self.obj_window.css({top: $(window).height() - self.obj_window.outerHeight()});
				// 	$('#menuContainer .menu-paused').css({top: $(window).height() - self.obj_window.outerHeight() - 4});
				// }
			} else {
				$(document).trigger('menu_unload.everytime');
				$('body').removeClass('bodyWithMenu');
				$('#menuOverlay').hide();

				if (self.active_box.menu_data?.onhide) self.active_box.menu_data.onhide.call(self.active_box, self.active_box);

				self.active_box = null;
				self.prev_box = null;
				self.obj_window = null;
				self.active_anchor = null;
				self.in_editor = false;
				self.inline_emoji_select = false;
				self.shown = false;
				$(document).trigger('menu_unload.once').unbind('menu_unload.once'); // может быть проблемой при многоуровневых меню
			}

			if (!config.from_popstate) App.core.history?.mobile?.back_on_hide('menu');
		},

		get_cache_key: function(data) {
			return !data.post_data ? data.url : JSON.stringify({
				url: data.url,
				data: data.post_data ?? null,
			});
		},

		no_update_maxHeight: false,
		update_maxHeight: function() {
			if (self.no_update_maxHeight) return;
			let css_pos = this.css_pos;
			const min_top = 5 + $('#sa_top').height();
			const min_bot = 5 + $('#sa_bot').height();
			let win_h = $(window).height() - (App.hybrid_app ? App.hybrid_app.keyboard_height : 0);
			let win_w = $(window).width();
			if ('bottom' in css_pos) {
				$(this).css({
					maxHeight: win_h - min_top - css_pos['bottom'],
					overflowY: 'auto'
				});
			} else {
				$(this).css({
					maxHeight: win_h - min_bot - css_pos['top'],
					overflowY: 'auto'
				});
			}
			self.no_update_maxHeight = true;
		},

		mouse_position: {
			x: 0,
			y: 0,
			timeout: null
		},
		log_mouse_position: function (e, options) {

			const { auto_clear } = {
				auto_clear: true,
				...options,
			};

			if (e == null || e instanceof KeyboardEvent) {
				self.mouse_position.x = App.controls.mouse.pageX;
				self.mouse_position.y = App.controls.mouse.pageY;
			} else if (App.device.is_mobile()) {
				self.mouse_position.x = e.clientX;
				self.mouse_position.y = e.clientY;
			} else {
				self.mouse_position.x = e.clientX + $(window).scrollLeft();
				self.mouse_position.y = e.clientY + $(window).scrollTop();
			}

			self.mouse_position_cache = {
				x: self.mouse_position.x,
				y: self.mouse_position.y,
			};

			if (auto_clear) self.mouse_position.timeout = setTimeout(self.clear_mouse_position, 350);
		},

		clear_mouse_position: function () {
			self.mouse_position.x = 0;
			self.mouse_position.y = 0;
			self.mouse_position.timeout = null;
		},

		change_position: function (x, y) {
			if (y) $('#menuContainer').css('top', $('#menuContainer').position().top + y);
			if (x) $('#menuContainer').css('left', $('#menuContainer').position().left + x);
		},

		previous_params: null,
		show_previous: function () {
			if (self.previous_params) self.show(self.previous_params);
		},

		show_submenu: function(el) {
			if (App.device.is_mobile()) {
				if ($(el).parent().hasClass('clicked')) $(el).parent().removeClass('clicked'); else {
					$(el).parent().parent().find('.w_submenu').removeClass('clicked');
					$(el).parent().addClass('clicked');
				}
			} else {
				$(el).next().find('a:first').correct_click();
			}
		},
		init_submenu: function(el) {
			$(el).find('.menu__submenuWrapper-auto > .menu__item').once_by_criteria('menu_init').bind('mouseover', function(e) {
				if ($(e.target).closest('.menu__item-disabled').length) return false;

				const container = $(this).closest('.menu__submenuWrapper-auto');
				container.addClass('menu__submenuWrapper-hover');
				if ($(window).width() <= APP_SCREEN_THRESHOLD) return;
				let submenu = container.find('.menu');
				if (submenu.length && ($(window).height() - submenu.offset().top - 5 < submenu.outerHeight())) {
					let margin = submenu.outerHeight() + 5 + submenu.offset().top - $(window).height();
					submenu.css({'marginTop': '-' + margin + 'px'});
				}
				if (container.hasClass('menu__submenuWrapper-leftCalc')) container.removeClass('menu__submenuWrapper-left');
				const open_to_left = container.hasClass('menu__submenuWrapper-left') || (self.active_box.css_pos['left'] + self.active_box.offsetWidth + submenu.outerWidth() + 5) >= $(window).width();
				self.make_submenu_safe_triangle(submenu.get(0), container.children('.menu__item').get(0), e.pageX, open_to_left)
				if (open_to_left) container.addClass('menu__submenuWrapper-left menu__submenuWrapper-leftCalc');
			}).bind('mouseout', function (e) {
				if ($(e.target).closest('.menu__item-disabled').length) return false;

				const container = $(this).closest('.menu__submenuWrapper-auto');
				container.removeClass('menu__submenuWrapper-hover');
				if ($(window).width() <= APP_SCREEN_THRESHOLD) return;
			}).bind('click', function(e) {
				if ($(e.target).closest('.menu__item-disabled').length) return false;

				if ($(window).width() > APP_SCREEN_THRESHOLD) return; // mobile only
				let container = $(this).closest('.menu__submenuWrapper-auto');
				if (window.stop_click) return false;
				let type = container.attr('data-direction') || 'submenu';
				let width = container.attr('data-width') || null;
				// наслідує батьківську поведінку
				let force_dropdown = Boolean(self.active_box.menu_data.force_dropdown);
				App.menu.show({
					anchor: this,
					box: container.children('.menu').get(0),
					backup: true,
					type,
					width,
					force_dropdown,
					onhide: function() {
						container.append(App.menu.obj_window);
					}
				});
			});
			$(el).find('.menu__submenuWrapper-click').once_by_criteria('menu_init').bind('click', function(e) {
				if (window.stop_click || !App.menu.is_shown()) return false;
				if ($(e.target).closest('.menu, .menu__submenuWrapper-click').hasClass('menu')) return true;
				if ($(e.target).closest('.sw_pre, .menu__item-disabled').length) return false;
				if ($(this).closest('.menu').hasClass('menu-paused')) return false;
				let type = $(this).attr('data-direction') || 'submenu';
				let width = $(this).attr('data-width') || null;
				const value = self.obj_window.find('.menu__group-search input').val();
				App.menu.show({
					anchor: this,
					box: $(this).children('.menu').get(0),
					onshow: function() {
						const input = self.obj_window.find('.menu__group-search input').val(value);
						if (input.is('[data-rules]')) input.trigger('input');
						input.focus_to_end_desktop(true);
					},
					backup: true,
					type,
					width
				});
			});
		},
		make_submenu_safe_triangle: function (submenu_el, menuitem_el, mouse_pos_x, open_to_left) {
			if (submenu_el == null || menuitem_el == null) return;

			let safe_triangle_el = $(submenu_el).children('.menu__safeTriangle');
			let menu_y_offset_percent = self.safe_triangle.vertical_padding_pc;
			let max_w = self.safe_triangle.max_width_pc/100;

			if (safe_triangle_el.length === 0) {
				safe_triangle_el = $('<div>').addClass('menu__safeTriangle');
				safe_triangle_el.on('click', function () {
					safe_triangle_el.hide();
				});
				safe_triangle_el.on('mousemove', function () {
					clearTimeout(this._timer);
					this._timer = setTimeout(() => safe_triangle_el.remove(), 150);
				});
				$(submenu_el).append(safe_triangle_el)
			} else {
				safe_triangle_el.show();
			}

			let submenu_rect = submenu_el.getBoundingClientRect();
			let menu_item_rect = menuitem_el.getBoundingClientRect();
			let menu_item_w = menu_item_rect.right - menu_item_rect.left;

			let submenu_w = submenu_rect.right - submenu_rect.left;
			let submenu_h = submenu_rect.bottom - submenu_rect.top;

			let top_y_relative = Math.floor((menu_item_rect.top - submenu_rect.top) * 100 / submenu_h);
			let bottom_y_relative = Math.floor((menu_item_rect.bottom - submenu_rect.top) * 100 / submenu_h);

			let side_w = open_to_left ? (mouse_pos_x || menu_item_rect.right) - menu_item_rect.left : menu_item_rect.right - (mouse_pos_x || menu_item_rect.left);

			side_w-= self.safe_triangle.cursor_offset_px;

			if (open_to_left) {
				side_w-= submenu_rect.right - menu_item_rect.left;
				side_w = side_w/menu_item_w > max_w ? menu_item_w*max_w : side_w;
			} else {
				side_w+= submenu_rect.left - menu_item_rect.right;
				side_w = side_w/menu_item_w > max_w ? menu_item_w*max_w : side_w;
			}

			let side_x_relative = open_to_left ? Math.floor(side_w/submenu_w*100) : 100 - Math.floor(side_w/submenu_w*100);

			safe_triangle_el.css({
				'marginLeft': open_to_left ? '100%' : '-100%',
				'clip-path': open_to_left ? 'polygon(' + side_x_relative + '% ' + top_y_relative + '%' + ',' + side_x_relative + '% ' + bottom_y_relative + '%' +  ',0 '+(100-menu_y_offset_percent)+'%,0 '+menu_y_offset_percent+'%)' : 'polygon(' + side_x_relative + '% ' + top_y_relative + '%' + ',' + side_x_relative + '% ' + bottom_y_relative + '%' +  ',100% '+(100-menu_y_offset_percent)+'%,100% '+menu_y_offset_percent+'%)'
			})
		},
		same_position: false,
		remove_editor_css: false,
		use_same_position: function (remove_editor_css) {
			self.same_position = true;
			self.remove_editor_css = remove_editor_css || false;
		},

		get_all: function() {
			let menus = App.task_view_cache.get_all().add('body').find('.menu');
			menus = menus.add(App.task_view_cache.get_all_helpers().filter('.menu'));
			for (let key in self.obj_detached) {
				menus = menus.add(self.obj_detached[key]);
			}
			for (history_dom of App.modal.history_dom) {
				if (!history_dom || !history_dom.dom) continue;
				menus = menus.add(history_dom.dom.filter('.menu'));
			}
			return menus;
		},

		get_all_by_trigger: function(trigger) {
			let triggers = trigger.split(',');
			return self.get_all().filter('[data-cache-trigger]').filter(function() {
				return $(this).attr('data-cache-trigger').split(',').some(t => triggers.includes(t));
			});
		},

		invalidate_cache_by_trigger: function(trigger) {
			App.core.log('menu.invalidate_cache_by_trigger', trigger);

			trigger.split(',').forEach(function(t) {
				self.watch_cache_triggers.delete(t);
			});

			let menus = self.get_all_by_trigger(trigger);
			//
			// if (menus.filter('.menu-active').length > 0) {
			// 	App.menu.hide_all();
			// }

			menus.invalidateMenuWithoutDestroy();
			menus.each(function() {
				this.oninvalidate?.(this);
			})
		},

		invalidate_cache_all: function() {
			if (!self.debug) console.warn('For debug purposes only!');
			const watch_cache_triggers_str = self.watch_cache_triggers.values().toArray().join(',');
			console.log('invalidate_cache_all: ', watch_cache_triggers_str);
			self.invalidate_cache_by_trigger(watch_cache_triggers_str);
		},

		get_keyboard_zone: function() {
			let container = self.obj_window.find('.keyboardZone-primary');
			if (!container.length) container = self.obj_window.find('.keyboardZone').eq(0);
			if (!container.length) {
				container = self.obj_window;
				if (!container.data('select')) container.data('select', '.menu__item');
			}
			return container;
		},

		init_scroll_zones: function() {
			self.obj_window.find('.scrollZone').not('.ps').each(function() {
				this.scrollBars = App.controls.js_scrollbars.init(this, {
					wheelSpeed: 0.1
				});
			});
		},

		init: function() {
			$('#menuContainer').on('focus', '.menu__group-search input, .editBlock__input input', function(e) {
				if (self.is_shown() && $(window).width() <= APP_SCREEN_THRESHOLD) {
					// TODO прокинути якось параметрами в менюшки.. поки хз як краще
					const no_auto_fullscreen = [
						'menuCreateDepartment',
						'menuCreateTeam',
						'menuCreateWorkflow',
					].includes( self.obj_window.attr('id') ) || self.obj_window.hasClass('menu--editBlock');
					if (self.debug) console.log({ id: self.obj_window.attr('id'), no_auto_fullscreen });
					if (!self.obj_window.hasClass('menu-fullscreen') && !no_auto_fullscreen) {
						self.obj_window.addClass('menu-fullscreen noani swype').css({top: ''}).eachDelayed(function () {
							$(this).removeClass('noani swype');
							self.resize_mobile_scrollZones();
						}, 300);
					}
				}
			});
		},

		onKeyboardShow: function() {
			if (self.is_shown() && $(window).width() <= APP_SCREEN_THRESHOLD) {
				if (self.obj_window.hasClass('menu-fullscreen')) {
					App.controls.keyboard_detect.debounce(self.obj_window, 3);
					self.resize_mobile_scrollZones();
				}
			}
		},

		onKeyboardHide: function() {
			if (self.is_shown() && $(window).width() <= APP_SCREEN_THRESHOLD) {
				if (self.obj_window.hasClass('menu-fullscreen')) {
					self.obj_window.css('margin-top', '');
					self.resize_mobile_scrollZones();
				}
			}
		},

		onresize: function () {
			if (self.previous_screen_width && $(window).width() > APP_SCREEN_THRESHOLD) {
				if (self.previous_screen_width !== $(window).width()) self.hide_all();
			}
			self.previous_screen_width = $(window).width();
		},

		onresize_viewport: function() {
			if (self.is_shown() && $(window).width() <= APP_SCREEN_THRESHOLD) {
				if (self.obj_window.hasClass('menu-fullscreen')) {
					// стало зайвим, висота керується через position: top/bottom
					// self.obj_window.css('height', App.helper.viewport.height());
					self.resize_mobile_scrollZones();
				}
			}
		},

		resize_mobile_scrollZones: App.helper.debounce(function () {

			const is_keyboard = App.controls.keyboard_detect.last_state;

			if (self.obj_window.find('.scrollZone').length < 2) return;

			if (!self.obj_window.hasClass('menu-fullscreen')) {
				self.obj_window.find('.scrollZone').css('maxHeight', '');
				return;
			}

			const swipe_height = 9; // * static, mb from css?
			const margin_bottom_height = 4; // * static, mb from css?
			let reserved_height = swipe_height + margin_bottom_height;
			let main_scrollZone;

			// саме так складно, щоб точніше враховувати, наприклад gap
			const callback_no_wrapper = (ctx_scrollZone) => {
				self.obj_window.find('.scrollZone').css('maxHeight', 0);
				const skip_groups = ctx_scrollZone.find('.menu__group');
				let h = 0;
				self.obj_window.find('.menu__group').not(skip_groups).filter(':visible').each(function () {
					h += $(this).outerHeight();
				});
				self.obj_window.find('.scrollZone').css('maxHeight', '');
				return h;
			};
			const callback_has_wrapper = (ctx_scrollZone) => {
				const wrapper = ctx_scrollZone.closest('.menu__group__wrapper');
				self.obj_window.find('.scrollZone').css('maxHeight', 0);
				wrapper.css('flexGrow', 0);
				const skip_groups = wrapper.find('.menu__group');
				let h = wrapper.outerHeight();
				self.obj_window.find('.menu__group').not(skip_groups).filter(':visible').each(function () {
					h += $(this).outerHeight();
				});
				self.obj_window.find('.scrollZone').css('maxHeight', '');
				wrapper.css('flexGrow', '');
				return h;
			};

			const selectors = [
				{
					selector: '> .scrollZone',
					callback: callback_no_wrapper,
				},
				{
					selector: '> form > .scrollZone',
					callback: callback_no_wrapper,
				},
				{
					selector: '> .menu__group__wrapper > .scrollZone',
					callback: callback_has_wrapper,
				},
				{
					selector: '> form > .menu__group__wrapper > .scrollZone',
					callback: callback_has_wrapper,
				},
			];

			// looking for main scrollZone
			selectors.some(({selector, callback}) => {
				if (self.obj_window.find(selector).length) {
					main_scrollZone = self.obj_window.find(selector);
					reserved_height += callback(self.obj_window.find(selector));
					return true;
				}
				return false;
			});

			if (!main_scrollZone) return;

			let new_scrollZone_height;
			if (is_keyboard) {
				//  максимально ужимаємо зону з пікнутими елементами, щоб було видно інпут і трішки низ елементів
				new_scrollZone_height = 40;
			} else {
				// 112 == 32 (висота рядка) * 3.5
				new_scrollZone_height = Math.max(112, (App.helper.viewport.height() - reserved_height) / self.obj_window.find('.scrollZone').length);
			}

			// розмір основної скроллЗони МАЄ бути залишком місця в меню (що й прописано в css)
			// main_scrollZone.css('maxHeight', new_scrollZone_height);
			self.obj_window.find('.scrollZone').not(main_scrollZone).css('maxHeight', new_scrollZone_height).scrollBottom();
		}, 100),

		fit_desktop_scrollZone: function () {

			if (App.device.is_mobile()) return;
			if (!self.obj_window) return;
			if (self.obj_window.find('.scrollZone').length > 1) return;

			const min_top = 5 + $('#sa_top').height();
			const min_bot = 5 + $('#sa_bot').height();
			const win_h = App.helper.viewport.height();

			const scrollZone = self.obj_window.find('.scrollZone');
			scrollZone.css({ maxHeight: ''});

			const top = parseFloat(self.obj_window.get(0).style.top);
			const bottom = parseFloat(self.obj_window.get(0).style.bottom);

			const maxMenuHeight = Number.isFinite(top) ? win_h - top - min_bot : win_h - bottom - min_top;

			const available =
				maxMenuHeight -
				(self.obj_window.prop('offsetHeight') - scrollZone.prop('offsetHeight'));

			scrollZone.css({ maxHeight: Math.min(available, 440) + 'px' });
		},

		destructor: function () {
			// все інше норм в hide почистилось
			self.obj_detached = {};
		},

		onBoot: function () {
			App.bus.window
				.on('resize', App.helper.throttle(self.onresize))
				.on('resize_viewport', App.helper.throttle(self.onresize_viewport))
				.on('keyboard_show', self.onKeyboardShow)
				.on('keyboard_hide', self.onKeyboardHide);

			App.bus.state.on('any', function (payload, ctx) {
				const obj = ctx.event, id_obj = payload.id, fields = payload.data;

				if (payload.data == null) return;

				const triggers = new Set();
				Object.keys(fields).forEach(field => {
					if (typeof field === 'string') triggers.add(obj+id_obj+field);
				});

				if (obj === 'task') {
					if (!['seen','read'].some(f => fields[f] != null)) {
						triggers.add('task');
					}
					if (['subscribers','bookmark','costs','delete','done','limits','move','priority','status','tag','terms','undone','user_from','user_to','updated','timers','waitme_delete','visibility'].some(f => fields[f] != null)) {
						triggers.add('task'+id_obj);
					}
					if (fields.add) {
						triggers.add('project'+fields.add.id_project+'task');
					}
					if (fields.user_to && (fields.user_to.id === App.me.id || fields.user_to.before.id === App.me.id)) {
						triggers.add('user');
					}
				} else if (obj === 'account') {
					if (fields.work_time || fields.holidays || fields.datetime) triggers.add('calendar');
					if (fields.user_options) triggers.add('user');
					if (fields.update) {
						if (fields.update.time && fields.update.time.is_time !== undefined) triggers.add('account_update_time_is_time');
						if (fields.update.timer && fields.update.timer.is_timer !== undefined) triggers.add('account_update_timer_is_timer');
					}
				} else if (obj === 'folder') {
					triggers.add('folder');
					triggers.add('folder'+id_obj);
				} else if (obj === 'project') {
					triggers.add('project');
					triggers.add('project'+id_obj);

					if (fields.settings) {
						if (fields.settings.changes?.tag_group || fields.settings.changes?.workflow) {
							triggers.add('tag');
							triggers.add('tag_group');
						}
						if (fields.settings.changes?.assignee_permissions || fields.settings.changes?.user_permissions) {
							triggers.add('user');
						}
					}
					if (fields.user_to && (App.me.id === fields.user_to.id || App.me.id === fields.user_to.before.id)) {
						triggers.add('user');
					}
				} else if (obj === 'stage') {
					if (fields.update || fields.delete) triggers.add('tag');
				} else if (obj === 'tag') {
					if (fields.add || fields.delete || fields.update || fields.project_status) triggers.add('tag');
					triggers.add('tag'+id_obj);
				} else if (obj === 'tag_group') {
					if (fields.add || fields.delete || fields.update) triggers.add('tag_group');
				} else if (obj === 'user') {
					if (!fields.topic_status) {
						triggers.add('user');
						triggers.add('user'+id_obj);
					}
				} else if (obj === 'view') {
					triggers.add('view'+id_obj);
					if (fields.add || fields.delete) triggers.add('view');
				} else if (obj === 'config') {
					if (fields.sidebar_projects && fields.sidebar_projects.hasOwnProperty('show_hidden')) {
						triggers.add('project');
					}
				} else if (obj === 'custom_field') {
					if (fields.add || fields.update || fields.delete || fields.projects) triggers.add('custom_field');
				}

				let should_trigger = Array.from(triggers.values());
				if (should_trigger.some(t => self.watch_cache_triggers.has(t))) {
					App.menu.invalidate_cache_by_trigger(should_trigger.join(','));
				}
			});

			// NO trigger(menu.reposition)
			// $(window).bind('menu.reposition', function() {
			// 	self.update_maxHeight.call(self.active_box);
			// });
			self.onresize();
		},
		onLogin: function () {
			self.init();
		},
		onLogout: function () {
			while (App.menu.is_shown()) App.menu.hide();
			self.destructor();
		}
	}
})();

App.custom_control = {
	active_box: null,
}

$.fn.invalidateMenu = function () {
	this.find('.scrollZone').each(function() {
		if (this.scrollBars) this.scrollBars.destroy();
	});
	return this.destroyComponents().removeAttr('data-loaded');
};

$.fn.invalidateMenuWithoutDestroy = function () {
	return this.removeAttr('data-loaded');
}

/**
 * @typedef {Object} MenuShowData
 * @property {String} [type='']
 * @property {String} [class='']
 * @property {HTMLElement|String} [box='']
 * @property {String} [title='']
 * @property {Boolean} [again=false]
 * @property {Boolean} [backup=false]
 * @property {Boolean} [replace=false]
 * @property {Boolean} [reload=false]
 * @property {Boolean} [no_anim=false]
 * @property {Boolean} [use_prev_height=false]
 * @property {Boolean} [force_dropdown=false]
 * @property {HTMLElement|String} [anchor]
 * @property {String} [url]
 * @property {(menu: HTMLElement) => {}} [onreload]
 * @property {(menu: HTMLElement) => {}} [onshow]
 * @property {(menu: HTMLElement) => {}} [onhide]
 * @property {(menu: HTMLElement) => {}} [oninvalidate]
 * @property {{y: Number, x: Number}} [text_position]
 * @property {{top: Number, left: Number, bottom: Number, right: Number}} [offset]
 * @property {String} [cache_trigger]
 * @property {Number} [cache_ttl]
 * @property {Boolean} [load_always]
 * @property {Number} [width]
 */

;var App = App || {};

const MSG_VARIANT_A = 'a'
const MSG_VARIANT_B = 'b'
const MSG_VARIANT_G = 'g'
const MSG_VARIANT_S = 's'
const MSG_VARIANT_W = 'w'
const MSG_VARIANT_D = 'd'
const MSG_VARIANT_INVERT = 'i'

const MSG_TEMPLATE_DEFAULT = '<div class="l"><div class="indicator"></div><div class="icon"></div></div></div><div class="main"><div class="header"><div class="title"></div><div class="action"></div></div><div class="text"></div><div class="options"></div></div><div class="r"><div class="close"></div></div>';
const TICK_SIZE_MS = 450;
const STACK_SIZE = 6;
const PROGRESS_PIE_PATH_LENGTH = 439.6;
const MSG_ID_PREFIX = 'toast_';

(function () {
	const locale_title_keys = {
		[MSG_VARIANT_D]: 'error_msg',
		[MSG_VARIANT_W]: 'alert',
		[MSG_VARIANT_A]: 'notice',
		[MSG_VARIANT_S]: 'success'
	};
	const default_timeout_keys = {
		[MSG_VARIANT_D]: 12000,
		[MSG_VARIANT_W]: 10000,
		[MSG_VARIANT_A]: 9000,
		[MSG_VARIANT_S]: 6000
	};
	const default_icon_names = {
		[MSG_VARIANT_D]: 'exclam_triangle-solid',
		[MSG_VARIANT_W]: 'exclam_triangle-line',
		[MSG_VARIANT_A]: 'info_circle-line',
		[MSG_VARIANT_S]: 'check'
	};

	const offsetHeight = (el) => el instanceof jQuery ? (el.get(0)?.offsetHeight || 0) : el.offsetHeight;

	let timer = null;

	let self = App.message = {
		locale: {}, // from footer.phtml
		messages: [],
		default_btn_style: null,
		container: null,
		paused: false,

		format_id: function (id) {
			if (!id) return null;
			return id.startsWith(MSG_ID_PREFIX) ? id : MSG_ID_PREFIX + id;
		},

		is_shown: function() {
			return self.messages.length > 0;
		},

		info: function (text, config) { return self.show(text, MSG_VARIANT_A, config) },
		success: function (text, config) { return self.show(text, MSG_VARIANT_S, config) },
		warning: function (text, config) { return self.show(text, MSG_VARIANT_W, config) },
		error: function (text, config) { return self.show(text, MSG_VARIANT_D, config) },
		muted: function (text, config) { return self.show(text, MSG_VARIANT_G, config) },

		validation: function (errors, config) {
			const messages = [];
			Object.keys(errors).forEach(field_name => {
				if (errors[field_name][0]) messages.push(errors[field_name][0]);
			});

			if (messages.length > 0) self.warning(messages.join('<br>'), config);
		},

		show: function (text, type, config) {
			if (typeof text === 'object') {
				config = text;
				text = config.text || '';
				type = config.variant || null;
			} else if (typeof type === 'object') {
				config = type;
				type = config.variant || null;
			}

			let options = {
				title: App.object_state?.locale?.[locale_title_keys[type]] || '',
				text: text,
				action: null, // { text: '', onclick: '', left_icon: '', name: '' }
				icon_name: default_icon_names[type] || null,
				actions: [], // Array<{ text: '', onclick: '', left_icon: '', name: '' }>
				timeout_ms: default_timeout_keys[type] || 8000,
				variant: type,
				long: false,
				deduplicate: false,
				count: false,
			};

			const default_btn_style = options.variant === MSG_VARIANT_INVERT ? 'btn-g btn-solid' : 'btn-g btn-outline';

			if (config && config.onclick) {
				options.action = config; // BACKWARD compatibility
			} else {
				options = { ...options, ...config };
			}

			options.title ??= config?.title;

			const formattedId = self.format_id(options.id);

			// --- ОБРОБКА ІСНУЮЧОГО TOAST ЗА ID ---
			if (formattedId) {
				let existing = self.find_by_id(formattedId);

				if (existing && !existing.hidden) {
					if (options.deduplicate) {
						existing.left_ms = options.timeout_ms || existing.timeout_ms;
						existing.should_hide = false;

						if (options.count) {
							existing.count = (existing.count || 1) + 1;
							const baseText = existing.base_text || options.text;
							existing.find('.text').html(`${baseText} <span class="message__count">(x${existing.count})</span>`);
						}

						// Перезапуск анімації всього блоку .message
						const $msgEl = existing.find('.message');
						$msgEl.removeClass('message--updated');
						if ($msgEl.length && $msgEl[0]) {
							void $msgEl[0].offsetWidth; // тригер reflow для перезапуску CSS-анімації
						}
						$msgEl.addClass('message--updated');

						existing.refresh_progress();
						self.play();
						return existing;
					} else {
						existing.count = 1;
						existing.base_text = options.text;
						existing.find('.title').html(options.title);
						existing.find('.text').html(options.text);

						existing.left_ms = options.timeout_ms || existing.timeout_ms;
						existing.should_hide = false;

						existing.refresh_progress();
						self.play();
						return existing;
					}
				}
			}

			// --- СТВОРЕННЯ НОВОГО TOAST ---
			const wrapper = $('<div>', { class: 'message-wrapper' });
			const content = $('<div>', { class: 'message-content' });
			const el = $('<div>', { class: 'message', html: MSG_TEMPLATE_DEFAULT, id: formattedId });

			if (options.variant != null) el.addClass('message-'+options.variant);
			if (config?.icon) el.addClass('message-chat');

			const hide_it = function () {
				self.hide(wrapper);
			};

			el.find('.title').html(options.title);
			el.find('.text').html(options.text);

			if (options.long) el.addClass('message-long');

			if (options.action != null) el.find('.action').append(self.render_btn({ name: default_btn_style, ...options.action, hide_it }));
			if (config?.icon) {
				el.find('.icon').append(config.icon)
			} else if (options.icon_name != null) {
				el.find('.icon').append('<ws-icon name="'+options.icon_name+'"/>')
			} else {
				el.find('.l').addClass('hidden');
			}

			el.find('.close').append('<ws-btn name="btn btn-g btn-28 '+(options.variant === MSG_VARIANT_INVERT?'btn-solid':'btn-skeleton')+'" left-icon="close"></ws-btn>')

			if (Array.isArray(options.actions)) options.actions.forEach(function (action) {
				el.find('.options').append(self.render_btn({name: default_btn_style, ...action, hide_it}))
			})

			const progress_pie = $('<svg width="160" height="160" viewBox="0 0 160 160"><circle r="70" cx="80" cy="80" fill="transparent" stroke="red" stroke-width="12px" stroke-dasharray="439.6" stroke-dashoffset="0" stroke-linecap="round"></circle></svg>')
			el.find('.indicator').append(progress_pie)

			content.append(el)
			wrapper.append(content)

			wrapper.msg_id = formattedId;
			wrapper.base_text = options.text;
			wrapper.count = 1;
			wrapper.left_ms = options.timeout_ms;
			wrapper.timeout_ms = options.timeout_ms;
			wrapper.paused = false;
			wrapper.should_show = true;
			wrapper.should_hide = false;
			wrapper.refresh_progress = function () {
				progress_pie.find('circle').attr('stroke-dashoffset', PROGRESS_PIE_PATH_LENGTH * (1 - Math.max(0, wrapper.left_ms)/options.timeout_ms))
			}

			wrapper.bind('mouseover', function () {
				self.paused = true;
			}).bind('mouseout', function () {
				self.paused = false;
			}).on('click', '.close', hide_it);

			if (config?.url) {
				wrapper.bind('click', function (e) {
					if ($(e.target.closest('.close')).length) return;
					App.core.goto(config.url);
					hide_it();
				})
			}

			self.messages.push(wrapper);
			self.play();

			return wrapper;
		},

		hide: function(el) {
			let wrapper = el || self.messages[0];
			if (wrapper == null) return;

			wrapper.should_hide = true;
			self.play();
		},

		render_btn: function (options) {
			const btn_el = $('<ws-btn/>').attr('name', 'btn btn-28 ' + options.name);

			if (options.text) btn_el.attr('text', options.text);
			if (options.title) btn_el.attr('data-title', options.title);
			if (options.left_icon) btn_el.attr('left-icon', options.left_icon);
			if (options.right_icon) btn_el.attr('right-icon', options.right_icon);
			if (options.onclick) {
				if (typeof options.onclick === 'string') btn_el.attr('onclick', options.onclick);
				else if (typeof options.onclick === 'function') btn_el.on('click', function (e) {
					options.onclick(e);
					options.hide_it();
				});
			}
			if (options.attributes) {
				Object.keys(options.attributes).forEach(function (attr) {
					btn_el.attr(attr, options.attributes[attr]);
				});
			}

			return $('<div>').append(btn_el);
		},

		do_show: function (m) {
			m.should_show = false;
			m.shown = true;
			self.container.append(m);
			self.container.css({ height: self.container.height() + offsetHeight(m) + 'px' });
			m.css({ transform: 'translateY(0px)', height: offsetHeight(m) + 'px' });

			let shown = self.messages.filter(a => a.shown);

			if (shown.length > STACK_SIZE) self.do_hide(shown[0]);
		},
		do_hide: function (m) {
			let ry = offsetHeight(m);
			m.should_show = false;
			m.paused = true;
			m.hidden = true;
			m.css({ opacity: 0, height: 0, transform: 'translate(0, ' + Math.floor(ry/5) + 'px)' });
		},

		play: function () {
			clearTimeout(timer)

			if (self.messages.length === 0) return;

			timer = setTimeout(function () {
				self.messages.filter(m => m.hidden).map(w => w.remove());
				self.messages = self.messages.filter(m => !m.hidden);

				let to_show = self.messages.find(m => m.should_show && !m.paused)
				let to_hide = self.messages.find(m => m.should_hide && !m.paused)

				if (to_show) self.do_show(to_show);
				if (to_hide) self.do_hide(to_hide);

				const h = self.messages.filter(a => !a.hidden).reduce(function (acc, el) { return acc + offsetHeight(el); }, 0);
				self.container.css({ height: h + 'px' });

				self.messages.forEach(m => {
					if (self.paused || m.paused || m.should_hide) return;

					m.left_ms-= TICK_SIZE_MS;
					m.should_hide = m.left_ms <= 0;

					m.refresh_progress();
				})

				self.play();
			}, TICK_SIZE_MS)
		},

		find_by_id: function (id) {
			if (!id) return null;
			const formattedId = self.format_id(id);
			return self.messages.find(m => m.msg_id === formattedId || m.msg_id === id);
		},

		reset_timer_by_id: function (id) {
			let msg = self.find_by_id(id);
			if (!msg) return;

			msg.left_ms = msg.timeout_ms;
			msg.should_hide = false;
			msg.refresh_progress();
		},

		onBoot: function () {
			self.container = $('<div>', { class: 'message-container', id: 'message_container' });
			self.container.appendTo($('body'));
			self.container.css({ height: '0px' });
		},
	};
})();

;(function() {
	let self = App.mobile_menu_primary = {

		obj_overlay: null,
		obj_wrapper: null,
		obj_window: null,

		is_opened: function () {
			return self.is_half_opened() || self.is_full_opened();
		},

		is_full_opened: function () {
			return $('body').hasClass('mobileMenuOpen');
		},

		is_half_opened: function () {
			return $('body').hasClass('mobileMenuHalfOpen');
		},

		is_loaded: function () {
			return self.obj_window !== null;
		},

		full_open: function () {
			if (self.is_full_opened()) return;
			$('body').addClass('mobileMenuOpen').removeClass('mobileMenuHalfOpen');
			App.core.history?.mobile?.push('primary_menu'); // TODO перевірити чи не зайвий буде повторний пуш після halfOpen
		},

		half_open: function () {
			if (self.is_opened()) return;
			$('body').addClass('mobileMenuHalfOpen');
			App.core.history?.mobile?.push('primary_menu');
		},

		toggle: function () {
			if (self.is_opened()) self.hide();
			else self.half_open();
		},

		hide: function () {
			if (!self.is_opened()) return;
			$('body').removeClass('mobileMenuOpen mobileMenuHalfOpen').find('.scrollZone').scrollTop(0);
			App.core.history?.mobile?.back_on_hide('primary_menu');
		},

		load_mobile_menu: function() {
			App.core.async_task.ajax({
				id: 'mobile_menu_primary_load',
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('mobile_menu:show')),
				success: function(html) {
					self.obj_wrapper.html(html);
					self.obj_window = $('#mobileMenu');
					setTimeout(function() {
						self.obj_wrapper.addClass('mobileMenu__wrapper-loaded');
						self.obj_window.addClass('mobileMenu-loaded');
					});

					self.obj_window.on('click', 'a, ws-btn, [onclick]', function () {
						if ($(this).is('[data-keep-menu-open]')) return;
						if (this.tagName === 'WS-BTN' && $(this).find('.btn-solid').length) return;

						self.hide();
					});

					// self.init_scroll_zones();
				}
			});
		},

		reload: function () {
			self.load_mobile_menu();
		},

		// init_scroll_zones: function() {
		// 	self.obj_window.find('.scrollZone').not('.ps').each(function() {
		// 		this.scrollBars = App.controls.js_scrollbars.init(this, {
		// 			wheelSpeed: 0.1
		// 		});
		// 	});
		// },

		destructor: function () {
			self.obj_window = null;
		},

		onLogin: function () {
			$('body').removeClass('mobileMenuHidden');
			self.load_mobile_menu();

			App.bus.state.on('account_update', function () {
				self.reload();
			});
		},

		onLogout: function () {
			$('body').addClass('mobileMenuHidden');
			if (self.obj_wrapper) self.obj_wrapper.removeClass('mobileMenu__wrapper-loaded');
			self.hide();
			self.destructor();
		},

		onBoot: function () {
			self.obj_overlay = $('#mobileMenu__overlay');
			self.obj_wrapper = $('#mobileMenu__wrapper');

			self.obj_overlay.on('click', function (e) {
				self.hide();
			});

			App.bus.app.on('window_signal', function (e) {
				if (e.state === App.windows.states.OPENED && self.is_opened()) {
					self.hide();
				}
			});
		},
	}
})();

;var App = App || {};

App.modal_files = {

	init: function (type) {
		if (!App.device.is_mobile()) setTimeout(function () {
			App.modal.obj_window.find('.modal__header .searchInput input').focus();
		}, 100);
		App.modal_files.init_items();
		App.modal_files.mass.init(App.modal_files.mass.operations);
		if (type === 'recent_files') {
			$(document).bind('modal_onload.once', function() {
				App.modal.obj_window.find('.modal__header > .in .inherit').click(function() {
					App.modal_files.project_menu.show(this);
				})
			});
		}
		else if (type === 'google_drive') {
			$(document).bind('modal_onload.once', function() {
				['primary', 'secondary'].forEach(function(type) {
					App.modal.obj_window.find('ws-btn[name*=' + type + ']').click(() => App.upload.attach.await_upload_zone_and_run(function () {
						App.modal.obj_window.find('.fileItem-active').each(function () {
							let a = $(this).attr('data-file').split('|');
							App.upload.attach.get_zone(true).append(App.helper.template.fill('file_item_google_drive', {
								name: a[0],
								file: (type === 'primary' ? 'GOOGLEDRIVE_DL:' : 'GOOGLEDRIVE_MY:') + a[1],
								ext: a[3],
								size: $(this).attr('data-size'),
								editable: a[2]
							}));
						});
						App.modal.hide();
						return false
					}));
				});
			});
		}
	},

	mass: {
		operations: ['hid', 'all'],
		count: {},
		ids: {},
		range: {
			start: null,
			end: null
		},

		init: function (params) {
			App.modal_files.mass.count = {};
			App.modal_files.mass.ids = {};
			if (params.length) {
				for (let i in params) {
					App.modal_files.mass.count[params[i]] = 0;
					App.modal_files.mass.ids[params[i]] = '';
				}
			}
		},

		update_menu: function () {
			let form = App.modal.obj_window.find('form').eq(0);
			let cnt = App.modal_files.mass.count['all'] = $('#modalFilesListing .fileItem-active').length;
			App.modal_files.mass.count['hid'] = $('#modalFilesListing .fileItem-active .name ws-icon').length;
			if (App.modal_files.mass.count['all']) {
				App.modal.obj_window.find('.modal__infoRow').toggle(App.modal_files.mass.count['hid'] > 0);
			}
			let ids = [];
			$('#modalFilesListing .fileItem-active').each(function () {
				ids.push($(this).attr('data-id'));
			});
			form.find('input[name=ids_file]').val(ids.join(','));
			form.find('ws-btn[name*=primary] span').html(form.find('ws-btn[name*=primary]').attr('text') + ' <i>(' + cnt + ')</i>');
			form.removeClass('frm_unchanged').filter('.frm_needData').toggleClass('frm_dis', !cnt);
		},
	},

	search: {
		words: [],
		words_wrong_keyboard: []
	},

	order: '',
	desc: false,

	sorting_index: {}, // from template

	init_items: function () {
		$('#modalFilesListing .fileItem').bind('click', function (e) {
			if (!$(e.target).is('a')) {
				if ($(this).hasClass('fileItem-folder')) {
					$(this).find('a').trigger('click');
				} else {
					if ($(this).hasClass('fileItem-active')) {
						$(this).removeClass('fileItem-active')
						App.modal_files.mass.range.start = 0;
					} else {
						if (e.shiftKey && App.modal_files.mass.range.start) {
							App.modal_files.mass.range.end = $(el).val();
							let in_range = false;
							$('#modalFilesListing .fileItem').not('.fileItem-hidden').each(function () {
								if (this.value == App.modal_files.mass.range.start || this.value == App.modal_files.mass.range.end) in_range = true - mf_shift_flag;
								if (mf_shift_flag) $(this).addClass('fileItem-active')
							});
						}
						App.helper.selection.clear();
						App.modal_files.mass.range.start = $(el).val();
						$(this).addClass('fileItem-active')
					}
					App.modal_files.mass.update_menu();
				}
				return false;
			}
		});
	},

	sorting_update: function (type) {
		App.modal_files.order = type;
		$('#modalFilesListing').hide();
		let i, j;
		if (App.modal_files.search.words.length > 1) {
			if (App.modal_files.desc) {
				for (j = App.modal_files.search.words.length; j > 0; j--) {
					for (i = App.modal_files.sorting_index[type].length - 1; i >= 0; i--) {
						if (j === App.modal_files.search.words.length) $('#obj-file-modal' + App.modal_files.sorting_index[type][i] + '[rel=' + j + ']').removeClass('item_opac').appendTo($('#modalFilesListing'));
						else $('#obj-file-modal' + App.modal_files.sorting_index[type][i] + '[rel=' + j + ']').addClass('item_opac').appendTo($('#modalFilesListing'));
					}
				}
			} else {
				for (j = App.modal_files.search.words.length; j > 0; j--) {
					for (i = 0; i < App.modal_files.sorting_index[type].length; i++) {
						if (j === App.modal_files.search.words.length) $('#obj-file-modal' + App.modal_files.sorting_index[type][i] + '[rel=' + j + ']').removeClass('item_opac').appendTo($('#modalFilesListing'));
						else $('#obj-file-modal' + App.modal_files.sorting_index[type][i] + '[rel=' + j + ']').addClass('item_opac').appendTo($('#modalFilesListing'));
					}
				}
			}
		} else {
			if (App.modal_files.desc) {
				for (i = App.modal_files.sorting_index[type].length - 1; i >= 0; i--) {
					$('#obj-file-modal' + App.modal_files.sorting_index[type][i]).removeClass('item_opac').appendTo($('#modalFilesListing'));
				}
			} else {
				for (i = 0; i < App.modal_files.sorting_index[type].length; i++) {
					$('#obj-file-modal' + App.modal_files.sorting_index[type][i]).removeClass('item_opac').appendTo($('#modalFilesListing'));
				}
			}
		}
		$('#modalFilesListing').show();
	},

	process_search: function (input) {
		let q, j, i, txt;
		if ($(input).val() == '') {
			$('#modalFilesListing .fileItem').removeClass('fileItem-hidden');
			$('#modalFilesListing .fileItem').not('.fileItem-hidden').show();
			App.modal_files.search.words = [];
			q = $('#modalFilesListing .fileItem').not('.fileItem-hidden').length;
			$('#modalFilesListing').removeClass('modalFilesListing--notFound');
			$('#modalFilesListing').css('min-height', '');
		} else {
			$('#modalFilesListing').css('min-height', $('#modalFilesListing').height());
			App.modal_files.search.words = $(input).val().replace(/\s+/ig, ' ').toLowerCase().replace(/^\s+|\s+$/g, '').split(' '); // utf-recheck
			let is_no_results = true;
			$('#modalFilesListing .fileItem').each(function () {
				txt = $(this).find('b').text().toLowerCase();
				j = 0;
				for (i = 0; i < App.modal_files.search.words.length; i++) {
					if (txt.indexOf(App.modal_files.search.words[i]) !== -1) j++;
				}
				if (j > 0 && !$(this).is('.fileItem-folder')) {
					$(this).removeClass('fileItem-hidden').attr('rel', j);
					is_no_results = false;
				} else {
					$(this).addClass('fileItem-hidden').attr('rel', 0);
				}
			});
			$('#modalFilesListing').toggleClass('modalFilesListing--notFound', is_no_results);
		}
		App.modal.obj_window.find('.scrollZone').each(App.scroll_listener.onDivScroll);
		App.modal_files.sorting_update(App.modal_files.order);
	},

	reset_search: function () {
		const input = App.modal.obj_window.find('.modal__header .searchInput input').val('').get(0);
		if (!input) throw new Error('`input` is not finded');

		App.modal_files.process_search(input);
	},

	project_menu: {
		show: function (anchor) {
			const link = $(anchor);
			App.controls.project_select_and_go.show_context(anchor, null, {
				request: { file_select: true },
				onload: function () {
					const menu = $(this);
					menu.addClass('menu--project-select-in-file-select');
					App.controls.menu.init(menu);
					menu.on('click', '.menu__item', function() {
						App.menu.hide();
						App.modal.show({
							url: App.helper.url.add_query(App.helper.endpoint.project($(this).attr('data-id')), link.attr('data-action')),
							reload: true
						});
					});
				},
				onshow: function() {
					const menu = $(this);
					menu.find('.menu__item').each(function() {
						$(this).toggleClass('menu__item-active', $(this).attr('data-id') == link.attr('data-project'));
					});
				}
			});
		},
	}
}

;var App = App || {};

(function() {
	const default_data = {
		event: 0,
		event_hot: 0,
		project_new: 0,
		task_new: 0,
		task_hot: 0,
		task_warm: 0,
		task: 0,
	};
	let self = App.mymenu = {
		event: 'mymenu',

		debug: false,

		is_shown: function (type) {
			if (type) return self.shown && self.type === type;
			return self.shown
		},

		shown: false,
		window: null,
		saved_scroll_pos: null,

		cache: {},

		type: '',
		prev_type: '',
		obj_wrapper: null,
		obj_window: null,
		obj_menus: null,
		minibar: null,
		cached_search_strings: {},
		last_archived: {},
		cache_expire: {},

		last_pause_at: 0,

		toggle: function (data) {

			if (
				!self.is_shown(data.type)
				// && !(data.type === 'users' && self.is_shown() && ['users_star', 'users_contacts'].includes(self.type))
			) {
				self.show(data);
				return;
			}

			if (!App.device.is_mobile()) {
				self.hide();
				return;
			}

			if (!self.obj_wrapper.hasClass('top-layer')) {
				// на мобілі форсимо відкрите вікно на перший план
				self.window.alreadyOpened();
			} else {
				// якщо вже на першому плані, тоді ховаємо
				self.hide();
			}
		},

		show: function (data) {
			if (self.debug) console.trace('mymenu', 'show', {...data});
			if (self.hiding || !App.windows.before_open(self.window, data)) return;

			self.prefill_search_users.prev_type = App.mymenu.type;

			let is_reload = Boolean(data.reload);
			let type = data.type || 'default';
			let url = data.url || '';
			let skip_cache = data.skip_cache || '';
			let dont_cache = data.dont_cache || false;
			let cache_prev_type = data.cache_prev_type || false;
			if (!is_reload && App.menu.is_shown()) App.menu.hide();
			$('.primaryMenu__item[data-custom-page], .mobileMenu__bar__item[data-custom-page]').each(function() {
				$(this).blur().toggleClass('menu_open', type.indexOf($(this).attr('data-custom-page')) !== -1 || type.indexOf($(this).attr('data-alt-custom-page')) !== -1);
			});
			if (self.is_shown()) {
				self.obj_window.removeClass('sidePanel-searchFullscreen withoutTopPanel');
			}
			let cache_data = !skip_cache ? self.cache[type] : null;

			if (!url && cache_data && cache_data.url) url = cache_data.url;

			// Если URL изменился, пропускаем кеш (например, для другого пользователя)
			if (cache_data && url && cache_data.url && cache_data.url !== url) {
				cache_data = null;
			}

			if (cache_data && self.cache_expire[type] && self.cache_expire[type] < App.helper.time.now()) {
				cache_data.invalidated = true;
			}

			if (cache_data?.invalidated) {
				self.delete_cache_by_type(type);
				cache_data = null;
			}

			if (!url) {
				App.core.error('mymenu', 'no url');
				return;
			}

			App.core.async_task.abort('mymenu_show');
			self.loaded_html = null;

			if (self.shown && self.has_loaded) self.window.unready();

			let active_type = self.shown && self.has_loaded && self.type ? self.type.split('_').shift() : '';

			self.prev_type = cache_prev_type ? self.type : ( self.type === data.type ? self.prev_type : '' );
			self.type = type;
			self.loaded_html = null;
			self.dont_cache = dont_cache;
			self.url = url;
			self.stale_content = false;

			self.window.opening(is_reload ? { no_foreground: true } : null);
			let should_load = false;
			if (cache_data) {
				if (self.has_loaded) self.detach();

				self.obj_window = cache_data.obj_window;
				self.obj_menus = cache_data.obj_menus;
				self.obj_wrapper.html('').append(self.obj_window).append(self.obj_menus);
				self.minibar = cache_data.minibar;
				self.has_loaded = true;

				if (self.type === 'chats') self.onshow_chats();
			} else {
				let load_type = self.type.split('_').shift();

				if (active_type !== load_type) {
					if (self.has_loaded) self.detach();

					self.obj_window = $(self.skeleton[load_type] || self.skeleton.default || '<div style="text-align: center; padding: 32px">loading</div>');
					self.obj_wrapper.html('');
					self.obj_wrapper.append(self.obj_window);
					self.obj_menus = null;
				} else {
					self.stale_content = true;
				}

				self.has_loaded = false;
				should_load = true;
			}

			const check_ready = function () {
				if ((self.has_loaded && !self.window.is_ready()) || (self.loaded_html && self.window.is_opened())) {
					self.stale_content = false;
					self.ready();
					self.window.ready();
					if (data.callback) App.helper.eval_callback(data.callback);
				}
			};

			self.animate_show(function () {
				self.window.opened(is_reload ? { no_foreground: true } : null);
				check_ready();
			});
			self.shown = true;

			if (!should_load) return;

			App.core.async_task.ajax({
				id: 'mymenu_show',
				url: url,
				success: function (html, status, xhr) {
					if (xhr.getResponseHeader("X-Mymenu-cache-ttl")) {
						self.cache_expire[type] = App.helper.time.now() + parseInt(xhr.getResponseHeader("X-Mymenu-cache-ttl"));
					}
				},
				before_start: function () {
					if (self.stale_content) self.loader.start();
				},
			}).then(function (html) {
				self.loaded_html = html;
				App.helper.nextTick(check_ready);
			}).catch(function (err) {
				App.core.error('mymenu', err);
				// self.has_loaded = false;
				self.loader.stop();
			});
			// .finally(function () {
			// 	self.loader.stop();
			// });
		},

		ready: function () {

			if (self.loaded_html) {
				if (self.debug) console.time('mymenu App.helper.dom.html');
				App.helper.dom.html(self.obj_wrapper, self.loaded_html);
				if (self.debug) console.timeEnd('mymenu App.helper.dom.html');
				self.obj_menus = self.obj_wrapper.find('.menu[id]').appendTo('#sidePanel__wrapper');
				self.loader.stop();
				self.obj_window = self.obj_wrapper.find('.sidePanel');

				const scrollzones = self.obj_window.find('.scrollZone').filter(function() {
					return !$(this).closest('ws-menu').length;
				});
				self.minibar = scrollzones.length ? App.controls.js_scrollbars.init(scrollzones.get(0)) : null;

				if (self.dont_cache !== true) {
					self.cache[self.type] = {
						obj_window: self.obj_window,
						obj_menus: self.obj_menus,
						minibar: self.minibar,
						url: self.url,
						invalidated: false,
					}
				}

				self.init();
				self.toggle_event_filters_panel_state({ set_state:true });

				self.has_loaded = true;
				self.loaded_html = null;
			}

			self.prefill_search();
			self.prefill_search_users();
			self.reset_scroll();
			self.toggle_back_button();
			self.obj_window.find('.log_new').removeClass('log_new');
		},

		show_users: function (tab, options) {
			options = {
				save_search: false,
				...options
			};

			App.classes.ui_state_manager.getInstance().loadState({
				onLoaded(state) {
					tab && App.classes.ui_state_manager.getInstance().setStateSilent('sidepanel_users_tab', tab)
					const stateTab = tab || state.sidepanel_users_tab || 'users';
					const tabToTypeMap = {
						contacts: 'users_contacts',
						star: 'users_star',
					};
					const type = tabToTypeMap[stateTab] ?? 'users';
					if (options.save_search) {
						self.cached_search_strings[type] = self.cached_search_strings[self.type];
					}
					if (stateTab === 'contacts') {
						self.toggle({
							type,
							url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('menu_contacts:show')),
						});
					} else if (stateTab === 'star') {
						self.toggle({
							type,
							url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('menu_users:show'), {tab: 'star'}),
						});
					} else {
						self.toggle({
							type,
							url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('menu_users:show')),
						});
					}
				}
			});
		},
		show_events: function (tab) {
			App.classes.ui_state_manager.getInstance().loadState({
				onLoaded(state) {
					tab  && App.classes.ui_state_manager.getInstance().setStateSilent('sidepanel_events_tab', tab)
					const stateTab = tab || state.sidepanel_users_tab || 'events';
					if (stateTab !== 'events') {
						self.toggle({
							type: 'events_' + stateTab,
							url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('menu_events:show'), {tab: stateTab}),
						});
					} else {
						self.toggle({
							type: 'events',
							url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('menu_events:show')),
						});
					}
				}
			});
		},

		show_activity: function (anchor, id_user) {
			if (App.modal.is_shown()) App.modal.hide();

			const params = id_user ? { sel_user: id_user } : {};
			const url = App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('menu_activity:show'), params);

			self.show({
				url,
				type: 'activity',
				cache_prev_type: true,
				// skip_cache: true
			});
		},

		toggle_timers: function (options) {
			self.toggle({
				...options,
				type: 'costs',
				url: App.helper.url.add_query(App.helper.endpoint.primary(),
				App.actions.get('menu_costs:show')),
				//skip_cache: true
			});
		},

		toggle_plans: function (options) {
			self.toggle({
				...options,
				type: 'costs',
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('menu_costs:show'), { plan: 1 }),
				//skip_cache: true
			});
		},

		show_timers: function (options) {
			self.show({
				...options,
				type: 'costs',
				url: App.helper.url.add_query(App.helper.endpoint.primary(),
				App.actions.get('menu_costs:show')),
				//skip_cache: true
			});
		},

		show_plans: function (options) {
			self.show({
				...options,
				type: 'costs',
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('menu_costs:show'), { plan: 1 }),
				//skip_cache: true
			});
		},

		animate_show: function(next) {

			if ($(window).width() > 480) {
				$('body').addClass('sidePanelShown sidePanelShown480p');
			} else {
				$('body').addClass('sidePanelShown');
			}

			clearTimeout(self.animate_show_timer);
			if (next) {
				self.animate_show_timer = setTimeout(next, 350);
			}
		},

		meta_theme_color: {
			backup_and_change: function () {

				// шапки на мобілі скрізь однакові, схоже тепер не треба міняти колір
				return;

				if (!App.device.is_mobile()) return;
				const el = $('meta[name="theme-color"]');
				const old_color = el.attr('content');
				const new_color = self.obj_wrapper.css('background-color');
				el.attr('content', new_color);
				el.attr('data-old-content', old_color);
			},
			restore: function () {

				// шапки на мобілі скрізь однакові, схоже тепер не треба міняти колір
				return;

				if (!App.device.is_mobile()) return;
				const el = $('meta[name="theme-color"]');
				const old_color = el.attr('data-old-content');
				if (!old_color) return;
				el.attr('content', old_color);
				el.removeAttr('data-old-content');
			}
		},

		hide: function (config) {
			if (self.debug) console.trace('mymenu', 'hide', {...config});
			config ||= {}
			if (!self.is_shown() || self.hiding) return;

			self.toggle_event_filters_panel_state({ try_collapse: true });

			clearTimeout(self.animate_show_timer);

			self.window.closing(config);
			self.obj_window.removeClass('sidePanel-searchFullscreen');
			$('body').removeClass('sidePanelShown sidePanelShown480p');
			$('.primaryMenu__item[data-custom-page], .mobileMenu__bar__item[data-custom-page]').removeClass('menu_open');

			self.hiding = true;
			setTimeout(function () {
				if (self.has_loaded) self.detach();
				self.hiding = self.shown = self.has_loaded = false;
				self.window.closed(config);
				self.meta_theme_color.restore();
				self.type = '';
				delete self['url'];
				self.prev_type = '';
			}, 300);
		},

		back: function () {
			if (!self.prev_type || self.type === self.prev_type) {
				self.hide();
				return;
			}

			let cache_data = self.cache[self.prev_type];
			if (cache_data == null) {
				self.hide();
				return;
			}

			self.show({
				type: self.prev_type,
				url: cache_data.url,
			})
		},

		toggle_back_button: function () {
			const can_back = Boolean(App.device.is_mobile() || self.prev_type);
			self.obj_window.toggleClass('sidePanel-withBack', can_back);
		},

		detach: function() {
			self.obj_window.detach();
			self.obj_menus.detach();
		},

		remove: function() {
			self.minibar?.destroy();
			self.obj_window.removeWithComponents();
			self.obj_menus.removeWithComponents();
		},

		reload: function () {
			if (self.is_shown()) {
				self.show({type: self.type, url: self.cache[self.type].url, skip_cache: true})
			}
		},

		loader: {

			start: function () {
				if (!self.obj_window) return;
				if (!self.is_shown() && App.device.is_mobile()) {
					App.controls.loader.start();
				} else {
					App.controls.loader.overlay.start(self.obj_window);
				}
			},

			stop: function () {
				if (!self.obj_window) return;
				if (!self.is_shown() && App.device.is_mobile()) {
					App.controls.loader.stop();
				} else {
					App.controls.loader.overlay.stop(self.obj_window);
				}
			},
		},

		init: function (o) {
			o ||= self.obj_wrapper;

			self.scroll_listen(o);

			if ($(window).width() > 480) {
				$(o).find('.scrollZone').bind('scroll', self.onscroll);
				if (o.find('.mm_float').length === 0) o.find('.scrollZone').addClass('no_mm_float');
				self.onscroll();
				self.obj_wrapper.addClass('priority-kbd')
					.off('mouseenter.priority_kbd mouseleave.priority_kbd')
					.on('mouseenter.priority_kbd', function (){
						if (!App.scroll_listener.is_scrolling) $(this).addClass('priority-kbd');
					})
					.on('mouseleave.priority_kbd', function (){
						if (!App.scroll_listener.is_scrolling) $(this).removeClass('priority-kbd');
					});
			}
			self._init_tabs(o);
			self._init_touch(o);
			self.init_keyboard_selection(o);
			App.controls.slider.init_for_sidebar(o);

			if (self.type === '') return;

			let main_type = self.type.split('_').shift();
			let next = self['init_'+main_type] || function () {
				App.core.warn('mymenu.init', 'No init function for menu type: ' + main_type);
			};

			next();
		},

		/**
		 * при сколі з мобіли підсвічуємо елементи і показуємо плаваючі меню (.floatIcons)
		 */
		_init_touch: function (o) {
			if (!App.device.is_mobile()) return;
			$(o).find('.scrollZone').on('touchstart', function (e) {
				const scroll_obj = $(this);

				App.helper.dom.when_closest(e.target, scroll_obj.attr('data-select'), (item) => {

					const items = scroll_obj.find(scroll_obj.attr('data-select'));
					items.removeClass('selected_fake');

					const floatIcons = $(item).find('.floatIcons');
					if (!floatIcons.length) return;
					$(item).addClass('selected_fake');
				});
			});
		},

		/**
		 * центруємо активний таб
		 */
		_init_tabs: function (o) {

			if (!App.device.is_mobile()) return;

			const tabs = o.find('.sidePanel__tabs');
			if (!tabs.length) return;

			App.helper.scroll_to_active_tab(tabs, 'li.active', 0);
		},

		prefill_search: function() {
			const fld = self.obj_window.find('.search_fld');
			if (!fld.length) return;

			const val = self.saved_search_value = self.cached_search_strings[self.type] ?? '';
			if (val) {
				fld.val(val).trigger('keyup');
			} else if (fld.attr('data-autofocus') !== 'off') {
				if (App.device.is_mobile()) fld.trigger('keyup')
				else fld.focus_to_end_desktop(true);
			} else {
				fld.trigger('keyup');
			}
		},

		prefill_search_users: function () {
			const prev_type = self.prefill_search_users.prev_type;
			const union_types = ['users', 'users_star', 'users_contacts'];
			if (!union_types.includes(self.type)) return;
			if (
				!self.cached_search_strings[self.type]
				&& prev_type
				&& union_types.includes(prev_type)
			) {
				let el = self.obj_window.find('input.search_fld');
				let val = self.cached_search_strings[prev_type];
				if (val && el.length) el.val(val).trigger('keyup');
			}
		},

		mark_invalidated_window: function (type) {
			if (self.cache[type] != null) {
				self.cache[type].invalidated = true;
			}
		},

		invalidate_window: function (type, callback) {
			if (self.is_shown(type)) {
				App.core.call_once(function() {
					self.show({type, url: self.cache[type].url, skip_cache: true, callback, reload: true})
				})
			} else {
				// не видаляємо, а то загубимо url (потрібен для back to prev_type)
				self.mark_invalidated_window(type);
				callback?.call();
			}
		},

		delete_cache_by_type: function (type) {
			if (self.cache[type] == null) return;

			self.cache[type].minibar?.destroy();
			self.cache[type].obj_window.removeWithComponents();
			self.cache[type].obj_menus.removeWithComponents();
			delete(self.cache[type]);
		},

		delete_cache_all: function () {
			if (!self.debug) console.warn('For debug purposes only!');
			Object.keys(App.mymenu.cache).forEach((key) => {
				console.log('App.mymenu.delete_cache_by_type(', key, ')');
				App.mymenu.delete_cache_by_type(key);
			});
		},

		init_log_items: function () {
			App.ui.onMouse(self.obj_wrapper, '.eventsList__item', {
				onBefore: (e) => {
					e.data.url = $(e.closest('[data-href]')).attr('data-href') || $(e.first('[data-href]')).attr('data-href');
					e.data.it_clickable = !e.closest(".eventsList__item-click-disabled");

					const id_task = $(e.el).attr('data-task');
					const ids_task = $(e.el).attr('data-tasks');
					if (id_task && ids_task) {
						e.data.tasks_view_paginal = true;
					}

					e.data.id_task = id_task;
				},
				open: (e) => {
					if (e.data.it_clickable && e.data.url) App.core.new_window(e.data.url);
				},
				click: (e) => {
					let proj_small = e.closest('.eventsList__item__projectSmall[data-project]');
					if (proj_small) return App.project_view.show($(proj_small).attr('data-project'));

					const proj_big = e.first('.eventsList__item__project[data-project]');
					if (proj_big) return App.project_view.show($(proj_big).attr('data-project'));

					const task_small = e.closest('.eventsList__item__taskSmall');
					if (task_small && e.data.id_task) return App.window.task_view.open({ url: App.helper.url.task(e.data.id_task) });

					if (!e.data.it_clickable) return
					if (!e.data.url) return;

					if (e.data.tasks_view_paginal) {
						App.window.task_view.open({ url: e.data.url, anchor: e.el });
					} else {
						App.core.goto(e.data.url);
					}

				}
			});

			App.ui.onMouse(self.obj_wrapper, '.floatIcons', {
				onBefore: (e) => {
					e.data.action = $(e.closest("a[data-action]")).attr('data-action');
					e.data.id =  $(e.closest(".sidePanel__list__item")).attr('data-id');
					e.stop = !e.data.action || !e.data.id;
				},
				click: (e) => {
					let a = e.closest('a'), o = $(e.closest(".sidePanel__list__item")), action = e.data.action, id = e.data.id;

					if (action === 'menu') {
						App.menu.show({
							anchor: a,
							url: App.helper.endpoint.primary() + '?' + App.actions.get('log_delete:show') + '&id=' + id,
							type: 'mymenu',
							force_dropdown: true,
						});
						return;
					}

					if (action === 'notify') {
						App.core.async_task.ajax(App.helper.endpoint.primary() + '?' + App.actions.get('log_notify:do') + '&id=' + id);
						$(a).closest('.eventsList__item').removeClass('eventsList__item-noNotify');
						$(a).parent().remove();
						return;
					}

					let status_id = { archive: 4, unarchive: 1, star: 3, unstar: 1 }

					App.core.async_task.ajax(App.helper.endpoint.primary() + '?' + App.actions.get('log_status:do') + '&id=' + id + '&status=' + status_id[action]);

					if (action === 'star') {
						o.addClass('eventsList__item-star');
					} else if (action === 'unstar') {
						o.removeClass('eventsList__item-star');
					}

					if (self.type !== 'events' || (action !== 'star' && action !== 'unstar')) o.remove();

					App.mymenu.obj_window.find('.sidePanel__list__group__title').each(function() {
						if ($(a).next().is('br')) {
							$(a).next().remove();
							$(a).prev().addBack().remove();
						}
					})
				}
			});
		},

		init_bookmarks: function () {
			const obj_window = self.obj_window;
			let initial_click;

			obj_window.find('.sidePanel__tabs li').click(function() {
				let tab = $(this).data('tab'), search = obj_window.find('.searchInput input');
				App.classes.ui_state_manager.getInstance().setState('sidepanel_bookmarks_tab', tab);

				obj_window.find('.sidePanel__tabs li').removeClass('active');
				obj_window.find('.sidePanel__tabs li[data-tab='+tab+']').addClass('active');

				obj_window.find('[data-tab-content]').show();
				obj_window.find('[data-tab-content]:not([data-tab-content='+tab+'])').hide();
				search.trigger('keyup');
				if (!initial_click) App.mymenu.obj_wrapper.find('.scrollZone').scrollTop(0);
			});

			initial_click = true;
			obj_window.find('.sidePanel__tabs li.active').trigger('click')
			App.helper.nextTick(() => initial_click = false);
		},
		init_tasks: function () {
			// @see App.task_explorer
			// const obj_window = self.obj_window;
			// let initial_click;

			// obj_window.find('.sidePanel__tabs li').click(function() {
			// 	let tab = $(this).data('tab'), search = obj_window.find('.searchInput input');
			// 	tab && App.classes.ui_state_manager.getInstance().setStateSilent('sidepanel_tasks_tab', tab)

			// 	obj_window.find('.sidePanel__tabs li').removeClass('active');
			// 	obj_window.find('.sidePanel__tabs li[data-tab='+tab+']').addClass('active');

			// 	obj_window.find('[data-tab-content]').show();
			// 	obj_window.find('[data-tab-content]:not([data-tab-content='+tab+'])').hide();
			// 	search.trigger('keyup');
			// 	if (!initial_click) App.mymenu.obj_wrapper.find('.scrollZone').scrollTop(0);
			// });

			// initial_click = true;
			// obj_window.find('.sidePanel__tabs li.active').trigger('click')
			// App.helper.nextTick(() => initial_click = false);
		},
		init_costs: function() {
			App.timer.init();

			self.obj_wrapper.find('.sidePanel__tabs li').click(function() {
				self.show({
					type: 'costs',
					skip_cache: true,
					url: self.obj_window.attr('data-endpoint') + '&' + $.param({
						dt: $(this).attr('data-day') || self.obj_window.attr('data-day'),
						plan: $(this).attr('data-type') === 'plan' ? 1 : 0
					})
				});
			});

			self.obj_wrapper.find('.timerView__progress a').on('click', function() {
				let url = $(this).attr('data-href');
				App.controls.confirm.ask($(this), [{
					text: $(this).attr('data-confirm-text'),
					right_icon: 'arrows/arrow_diagonal-up-right',
					callback: function() {
						App.core.goto(url);
					}
				}]);
			});

			/** Day select */
			self.obj_wrapper.find('button[data-action=date]').click(function() {
				self.show({
					type: 'costs',
					skip_cache: true,
					url: self.obj_window.attr('data-endpoint') + '&' + $.param({
						dt: $(this).attr('data-day'),
						plan: self.obj_window.attr('data-type') === 'plan' ? 1 : 0
					})
				});
			});
			self.obj_wrapper.find('input[data-container=date]').datepicker({
				rangeSelect: false,
				numberOfMonths: 1,
				monthPicker: true,
				maxDate: self.obj_window.attr('data-max-date') ? new Date(self.obj_window.attr('data-max-date')) : null,
				firstDay: App.datepicker_firstDay,
				onSelect: function (dateText, inst) {
					self.show({
						type: 'costs',
						skip_cache: true,
						url: self.obj_window.attr('data-endpoint') + '&' + $.param({
							dt: dateText,
							plan: self.obj_window.attr('data-type') === 'plan' ? 1 : 0
						})
					});
				},
				beforeShowDay: App.controls.datepicker.config.disable_holidays ? App.controls.datepicker.helper_disable_holidays : App.controls.datepicker.helper_draw_holidays,
			});
			self.obj_window.find('[data-settings-name]').on('menuchange', function (e) {
				const data = {};
				data[e.delegateTarget.getAttribute('data-settings-name')] = e.originalEvent.detail.value;

				$.ajax({
					method: 'POST',
					url: App.helper.endpoint.primary() + '?' + App.actions.get('menu_costs:save_config') ,
					data: data,
					success: function () {
						self.invalidate_window('costs');
					}
				})
			});

			(function initDots() {
				App.core.log('mymenu', 'init costs items dots');

				const isMobile = App.device.is_mobile();

				function activateDot($dot) {
					if (!$dot.length) return;
					const id = $dot.attr('data-dot-id');
					const block = $dot.closest('.sidePanel__list__item-costs');
					block.setActiveEl($dot[0], 'task-dot--active');
					block.setActiveEl(block.find(`.details[data-dot-id="${id}"]`), 'details--active');
				}

				self.obj_window.find('.task-dots-bar').each(function () {
					const $bar = $(this);
					const barEl = this;

					$bar.on('click', function (e) {
						if (isMobile) {
							e.stopPropagation();
						}
					});

					const dotEvent = isMobile ? 'click' : 'mouseenter';
					$bar.on(dotEvent, '.task-dot', function (e) {
						if (isMobile) {
							e.preventDefault();
							e.stopPropagation();
						}
						activateDot($(this));
					});

					if ($bar.find('.task-dot').length <= 7) return;

					$bar.prepend('<span class="task-arrow task-arrow--prev"><ws-icon name="arrows/chevron_lg-left"></ws-icon></span>');
					$bar.append('<span class="task-arrow task-arrow--next"><ws-icon name="arrows/chevron_lg-right"></ws-icon></span>');
					$bar.addClass('has-next');

					let scrollEndTimer = null;
					$bar.on('scroll', function () {
						if (!barEl._raf) {
							barEl._raf = requestAnimationFrame(() => {
								const sl = barEl.scrollLeft;
								$bar.toggleClass('has-prev', sl > 4);
								$bar.toggleClass('has-next', sl + barEl.clientWidth < barEl.scrollWidth - 4);
								barEl._raf = null;
							});
						}

						clearTimeout(scrollEndTimer);
						scrollEndTimer = setTimeout(() => {
							const left = barEl.scrollLeft;
							const right = left + barEl.clientWidth;
							const $active = $bar.find('.task-dot--active');

							if ($active.length) {
								const dLeft = $active[0].offsetLeft;
								if (dLeft >= left && dLeft <= right) return;
							}

							$bar.find('.task-dot').each(function () {
								if (this.offsetLeft >= left - 2) {
									activateDot($(this));
									return false;
								}
							});
						}, 120);
					});

					if (isMobile) {
						$bar.on('click', '.task-arrow', function (e) {
							e.preventDefault();
							e.stopPropagation();

							const $arrow = $(this);
							const direction = $arrow.hasClass('task-arrow--next') ? 1 : -1;
							barEl.scrollBy({ left: direction * (barEl.clientWidth * 0.8), behavior: 'smooth' });
						});
					} else {
						let scrollInterval = null;
						$bar.on('mouseenter', '.task-arrow', function () {
							const $arrow = $(this);
							const direction = $arrow.hasClass('task-arrow--next') ? 1 : -1;

							const scrollStep = () => {
								barEl.scrollBy({ left: direction * (barEl.clientWidth * 0.8), behavior: 'smooth' });
							};

							scrollStep();
							clearInterval(scrollInterval);
							scrollInterval = setInterval(scrollStep, 350);
						}).on('mouseleave', '.task-arrow', function () {
							clearInterval(scrollInterval);
							scrollInterval = null;
						});
					}
				});
			})();
		},
		init_events: function () {
			App.object_state.update('event', 0, {seen: true}, MY_DIRECT_ACTION);
			self.obj_window.find('.log_new .time').blink();
		},

		init_user_items: function() {
			App.ui.onMouse(self.obj_wrapper, '.sidePanel__list__item-user', {
				onBefore: e => {
					e.data.id_user = $(e.el).attr('data-user');
					e.cancel = !e.data.id_user;
				},
				click: e => {
					const user_card_anchor = e.closest('[data-user-card]');
					if (user_card_anchor) {
						App.controls.user_menu.show(user_card_anchor, e.data.id_user, 'left', App.current_page.project);
						return;
					}
					App.controls.user_quick_menu.show(e.el, e.data.id_user, { type: 'center' })
				},
				dblclick: e => App.profile.modal.show(App.helper.endpoint.user(e.data.id_user) + '?' + App.actions.get('user_profile:show')),
			});
		},

		init_contact_items: function() {
			App.ui.onMouse(self.obj_wrapper, '.sidePanel__list__item-contact', {
				onBefore: e => {
					e.data.url = $(e.el).attr('data-url');
					e.cancel = !e.data.url;
				},
				click: e => App.modal.show({url: e.data.url, width: 450, group: 'contact'}),
				dblclick: e => App.modal.show({url: e.data.url, width: 450, group: 'contact'}),
				context: false
			});
		},

		init_costs_items: function () {
			App.ui.onMouse(self.obj_wrapper, '.sidePanel__list__item-costs[data-user]', {
				onBefore: e => {
					e.data.id = +$(e.el).attr('data-user');
					e.cancel = !e.data.id;
				},
				click: e => {
					let params = {id_user_to: e.data.id, dt: self.obj_window.attr('data-day'), plan: self.obj_window.attr('data-type') === 'plan' ? 1 : 0 };
					if (e.data.id === App.me.id && !App.device.is_mobile()) App.timer_view.show(true, params);
					else App.timer_view_modal.show(true, params);
				},
				context: e => App.controls.user_menu.show(e.target, e.data.id)
			});
			App.ui.onMouse(self.obj_wrapper, '.sidePanel__list__item-costs[data-task]', {
				onBefore: e => {
					e.data.url = App.helper.url.task($(e.el).attr('data-task'));
				},
				click: e => App.window.task_view.open({ url: e.data.url }),
				context: e => App.controls.task_menu.show(e.target, e.data.url)
			});
		},

		init_project_items: function () {
			App.ui.onMouse(self.obj_wrapper, '.sidePanel__list__item-project', {
				onBefore: e => {
					e.data.id = $(e.el).attr('data-project');
					e.data.url = App.helper.url.project(e.data.id);
					e.data.cancel = e.data.id == null;
				},
				open: function (e) {
					App.core.new_window(e.data.url);
				},
				click: function (e) {
					App.project_view.show(e.data.id);
				},
				dblclick: function (e) {
					App.core.goto(e.data.url);
				}
			});
		},

		init_task_items: function () {
			App.ui.onMouse(self.obj_wrapper, '.sidePanel__list__item-task', {
				onBefore: e => {
					e.data.id = $(e.el).attr('data-task');
					e.data.url = App.helper.url.task(e.data.id);
					e.data.cancel = e.data.id == null;
				},
				open: function (e) {
					App.core.new_window(e.data.url);
				},
				click: function (e) {
					App.window.task_view.open({ url: e.data.url, anchor: e.el });
				}
			});
		},

		init_bookmark_items: function () {
			App.ui.onMouse(self.obj_wrapper, '.sidePanel__list__item-bookmark', {
				onBefore: e => {
					e.data.id = $(e.el).attr('data-id');
					e.data.url = $(e.el).attr('data-url');
					e.data.cancel = e.data.id == null;
				},
				open: function (e) {
					App.core.new_window(e.data.url);
				},
				click: function (e) {
					let btn_menu = e.closest('ws-btn[name*=btn-menu]');
					if (btn_menu) {
						App.bookmark.controlMenu(btn_menu, { url: e.data.url, id: e.data.id })
					} else {
						App.core.goto(e.data.url);
					}
				},
				context: function (e) {
					App.bookmark.controlMenu(e.el, {url: e.data.url, id: e.data.id})
				}
			});
		},

		refresh_chat_items: function (obj_window) {
			obj_window = obj_window || self.cache['chats']?.obj_window || self.obj_window || $();

			let tab = obj_window.find('.sidePanel__tabs li.active').attr('data-tab');

			if (tab == null) return false;

			obj_window.find('.sidePanel__tabs li[data-tab=unread]').toggleClass(
				'hiddenBlock', obj_window.find('.sidePanel__tabs li[data-tab=unread] .count').text() === '0'
			);
			obj_window.find('.sidePanel__list__item').each(function () {
				let it = $(this), type = it.attr('data-type');
				let show = ['private','group','project', 'self'].includes(type);

				if (tab === 'unread') {
					show = it.find('task-unseen .cnt').length > 0;
				} else if (tab !== 'all') {
					show = type === tab || (type === 'self' && tab === 'private');
				}

				it.toggleClass('sidePanel__list__item-waste', it.attr('data-waste') === '1').toggleClass('sidePanel__list__item-disabled', !show);
			});
		},

		onshow_chats: function (obj_window) {
			obj_window = obj_window || self.obj_window;

			if (obj_window.attr('data-contacts') !== '1') {
				self.set_active_chat_callback();
				self.refresh_chat_items(obj_window);
				self.sort_chats(obj_window);
				self.refresh_chat_counters();
			}
		},

		init_chats: function (obj_window) {
			obj_window = obj_window || self.obj_window;

			self.onshow_chats(obj_window);

			obj_window.find('.sidePanel__tabs li').click(function() {
				let tab = $(this).data('tab'), search = obj_window.find('.searchInput input');

				App.classes.ui_state_manager.getInstance().setState('sidepanel_chats_tab', tab);

				if (obj_window.attr('data-contacts') === '1') {
					obj_window.find('ws-btn[name*=cancel]').attr('data-return-tab', tab);
					return self.cancel_chat_contacts();
				}

				obj_window.find('.sidePanel__tabs li').removeClass('active');
				obj_window.find('.sidePanel__tabs li[data-tab='+tab+']').addClass('active');

				obj_window.find('ws-btn[name*=new]').show();
				obj_window.find('ws-btn[name*=cancel]').hide();

				self.refresh_chat_items(obj_window);
				self.sort_chats(obj_window);
				self.refresh_chat_counters();
				App.mymenu.obj_wrapper.find('.scrollZone').scrollTop(0);
				search.trigger('keyup');
			});

			obj_window.find('.searchInput ws-btn[name*=cancel]').click(function () {
				let tab = $(this).attr('data-return-tab') || 'all';
				$(this).attr('data-return-tab', null);
				self.obj_window.find('.sidePanel__tabs li[data-tab='+tab+']').click();
			});
		},

		show_chat_contacts: function () {
			App.menu.hide();
			let obj_window = self.cache['chats'].obj_window,
				active_tab = obj_window.find('.sidePanel__tabs li.active'),
				search = obj_window.find('.searchInput input');

			active_tab.removeClass('active');

			obj_window.find('ws-btn[name*=new]').hide();
			obj_window.find('ws-btn[name*=cancel]').attr('data-return-tab', active_tab.attr('data-tab')).show();
			obj_window.find('.sidePanel__list__item').each(function () {
				let it = $(this),
					type = it.attr('data-type'),
					disabled = type !== 'private' && type !== 'private-empty' && type !== 'private-inactive';

				disabled = disabled || it.find('.user-spec-icon').children('[data-status=warning],[data-status=free],[data-status=reader]').length > 0;

				it.toggleClass('sidePanel__list__item-disabled', disabled);

				if (it.hasClass('sidePanel__list__item-waste')) it.attr('data-waste', '1').removeClass('sidePanel__list__item-waste');
				else if (type === 'private') it.addClass('sidePanel__list__item-waste');
			});

			search.attr('placeholder', search.attr('data-place-contacts')).trigger('keyup').focus();
			obj_window.attr('data-contacts', '1');
		},
		cancel_chat_contacts: function () {
			let obj_window = self.cache['chats'].obj_window;

			if (obj_window.attr('data-contacts') !== '1') return false;

			let tab = obj_window.find('ws-btn[name*=cancel]').attr('data-return-tab') || 'all',
				search = obj_window.find('.searchInput input');

			obj_window.attr('data-contacts', null);
			search.attr('placeholder', search.attr('data-place-chat')).val('');

			obj_window.find('.sidePanel__tabs li[data-tab='+tab+']').click();

			return true;
		},

		init_chat_items: function () {
			App.ui.onMouse(self.obj_wrapper, '.sidePanel__list__item-chat', {
				onBefore: (e) => (e.data.url = $(e.el).attr('data-href')),
				open: (e) => {
					self.cancel_chat_contacts();
					App.core.new_window(e.data.url);
				},
				click: (e) => {
					self.cancel_chat_contacts();
					App.keyboard_selection.select_by_click(e.el);
					App.window.chat_view.open({ url: e.data.url, anchor: e.el });
				},
				context: (e) => {
					let type = $(e.el).attr('data-type'), project = $(e.el).attr('data-project'), user = $(e.el).attr('data-user');

					if (type.includes('inactive')) {
						if (+user > 0) App.controls.user_menu.show(e.el, user, '', 0);
						return;
					}

					if (e.closest('.icon-user') && +user > 0) return App.controls.user_menu.show(e.el, user, '', 0);
					if (e.closest('.icon-group') && +project > 0) return App.controls.project_menu.show(e.el, App.helper.endpoint.ajax(project), {context_menu: true});

					App.keyboard_selection.select_by_click(e.el);
					App.controls.chat_menu.show(e.el, e.data.url);
				}
			});

		},

		keyboard_container: null,
		init_keyboard_selection: function (o, is_toggle_selected = true) {
			o ||=  self.obj_wrapper;
			if ($('body').hasClass('mobile')) return;
			let list = o.find('.keyboardZone-primary');
			if (!list.length) list = o.find('.keyboardZone');
			if (list.length) {
				App.keyboard_selection.init_container(list, false, is_toggle_selected);
			}
		},

		scroll_listen: function (o) {
			App.scroll.listen(o.find('.sidePanel__list'), {
				direction: 'vertical',
				obj_window: null,
				obj_topPanel: null,
				obj_list: null,
				topPanel_h: null,
				condition: function() {
					return Boolean(
						!App.mymenu.obj_window.hasClass('sidePanel-searchFullscreen')
						// (!App.device.is_mobile() || !App.mymenu.obj_window.hasClass('sidePanel-searchFullscreen'))
						// && App.mymenu.obj_window.find('.search_started').length === 0
						&& App.mymenu.obj_window.find('.sidePanel__topPanel').length > 0
					);
				},
				onstart: function () {
					this.obj_window = App.mymenu.obj_window;
					this.obj_list = App.mymenu.obj_window.find('.sidePanel__list');
					this.obj_topPanel = App.mymenu.obj_window.find('.sidePanel__topPanel').last();

					this.topPanel_h = this.obj_topPanel.outerHeight();

					// блін, а на практиці в анімації є свій шарм ;) хай поки буде
					// this.obj_list.addClass('noani');
					// this.obj_topPanel.addClass('noani');
				},
				onmove: function (diff) {

					const scrollTop = this.obj_list.get(0).scrollTop;
					const is_topPanel_hidden = this.obj_window.hasClass('withoutTopPanel');

					if (diff.direction === 'down' && is_topPanel_hidden) return;

					this.obj_topPanel.css('margin-top', Math.max(-1 * (scrollTop / 3), this.topPanel_h * -1) + 'px');
					this.obj_list.get(0).style.setProperty('margin-top', Math.min(this.topPanel_h * -1 + (scrollTop / 3), 0) + 'px', 'important');

					if (App.device.is_lg_width()) {
						App.mymenu.obj_window.css('--float-title-offset', Math.max(-1 * (scrollTop / 3), this.topPanel_h * -1) + 'px');
					}

					const is_hide_topPanel = scrollTop / 3 >= this.topPanel_h;
					const is_show_topPanel = scrollTop === 0;
					if (is_hide_topPanel) {
						this.obj_window.addClass('withoutTopPanel');
					} else if (is_show_topPanel) {
						this.obj_window.removeClass('withoutTopPanel');
					}
				},
				onend: function () {

					const scrollTop = this.obj_list.get(0).scrollTop;
					const is_hide_topPanel = scrollTop / 3 >= this.topPanel_h / 2;

					// this.obj_list.removeClass('noani');
					// this.obj_topPanel.removeClass('noani');

					this.obj_window.toggleClass('withoutTopPanel', is_hide_topPanel);
					this.obj_topPanel.css('margin-top', '');
					this.obj_list.css('margin-top', '');

					if (App.device.is_lg_width()) {
						App.mymenu.obj_window.css('--float-title-offset', '');
					}

					if (!is_hide_topPanel) {
						this.obj_list.get(0).scrollTo({
							top: 0,
							behavior: 'smooth'
						});
					}

					this.obj_window = null;
					this.obj_topPanel = null;
					this.obj_list = null;
				},
			});
		},

		// IntersectionObserver?
		onscroll_load_more: App.helper.throttle(function () {

			if (!self.is_shown()) return;
			if (App.device.is_sm_width()) return;

			const $moreBtn = self.obj_wrapper.find('.moredots-auto');

			if ($moreBtn.length && ($moreBtn.position().top < self.obj_wrapper.find('.scrollZone').height())) {
				$moreBtn.prop('disabled', true).trigger('click');
			}
		}),

		onscroll: function (e) {
			// if (!self.is_shown()) return;
			// if (App.device.is_sm_width()) return;

			self.onscroll_load_more();
			return;

			// sidePanel__list
			let fl = null;
			let fl_next = null;
			let gap = 0;

			let top_offset = 0; //86;
			let prev_height = 0;
			let skip = false;
			self.obj_wrapper.find('.mm_float_pre').each(function () {
				gap = 0; // $(this).data('gap') || 0;

				if (!$(this).parent().is(':visible')) return;
				if (skip) return;
				prev_height = $(this).next().outerHeight();
				if ($(this).position().top < top_offset + gap) {
					fl = this;
				} else if (fl && $(this).position().top < top_offset + gap + prev_height) {
					fl_next = this;
				} else {
					skip = true;
				}
			});
			self.obj_wrapper.find('.mm_float_pre').not(fl).next().css({top: 0});
			gap = 0; //fl ? ($(fl).data('gap') || 0) : 0;

			if (fl_next && fl) $(fl).next().css({top: $(fl_next).position().top - $(fl).position().top - gap - prev_height});
			else if (fl) {

				$(fl).next().css({top: top_offset - $(fl).position().top});
			}
		},
		reset_scroll() {
			self.obj_wrapper.find('.mm_float').css({top: 0,})
		},

		// піся завантаження фіксимо групування
		onMoreLoaded: function (container) {
			if (App.mymenu.obj_window.find(container).length === 0) {
				debugger;
				return; // схоже проскакують дублюючі запити до сервера
			}
			const $container = $(container);
			const $prevGroupLeftover = $container.children('.sidePanel__list__item');
			const $prevGroup = $container.prev('.sidePanel__list__group');
			if ($prevGroupLeftover.length && !$prevGroup.length) throw new Error('Oops, something went wrong.');
			$prevGroup.append($prevGroupLeftover);
			const $containerLeftover = $container.children();
			$container.after($containerLeftover);
			$container.remove();
		},

		go_nohistory: false,

		play_sounds: function () {
			if (self.data['event_add']) {
				if ($('body').hasClass('sound_on')) {
					App.core.sound('noty_to_me');
				}
				$('#primaryMenu__event__counter span.cnt_new, #primaryMenu__task__counter span.cnt_new, #mobileMenu__event__counter span.cnt_new, #mobileMenu__task__counter span.cnt_new').blink();
			} else if (self.data['event_cls']) {
				if ($('body').hasClass('sound_on')) {
					App.core.sound('task_done');
				}
				$('#primaryMenu__event__counter span.cnt_new, #mobileMenu__event__counter span.cnt_new').blink();
			} else if (self.data['event_snd']) {
				if ($('body').hasClass('sound_on')) {
					App.core.sound('noty');
				}
				$('#primaryMenu__event__counter span.cnt_new, #mobileMenu__event__counter span.cnt_new').blink();
			}
			self.data['event_snd'] = self.data['event_add'] = self.data['event_cls'] = 0;
		},

		enable_play_sounds: function () {
			App.core.set_cookie('snd_on', 'yes', false);
			App.core.sound('noty', true);
			$(document).unbind('click', self.enable_play_sounds);
		},

		load_event_count: function () {
			// Replace with get object_state events request!!
			App.core.multytab_function_call(function () {
				$.ajax({
					url: App.helper.endpoint.primary() + '?' + App.actions.get('menu_events_count:show') + '&type=json',
					dataType: 'json',
					success: function (json) {
						self.process_event_cnt(json, true);
						App.core.send_message_to_other_tabs({
							'command': 'events',
							'data': json,
							'dt': (new Date).getTime() + Math.random()
						})
					}
				});
			}, 'event', 60);
		},

		process_event_cnt: function (json, primary) {
			if (json && json['status'] && json['status'] === 'ok') {
				let params = ['project_new', 'task_new', 'task_hot', 'task_warm', 'task'];
				let need_update = json['event_removed'];
				params.forEach(params => {
					need_update = need_update || self.data[params] !== json[params];
					self.data[params] = json[params];
				});
				if (need_update) {
					self.invalidate_window('events');
				}
				if (json['event_html'] !== $('#primaryMenu__event__counter').html()) $('.primaryMenu__item[data-custom-page="events"]').removeClass('menu_open');
				self.data_tasks = json['tasks'];
				self.draw_counter();
				if (primary && !App.core.websocket.ready) self.play_sounds();

				if (App.hybrid_app) App.hybrid_app.set_badge_number(json['event']);
			}
		},

		data_tasks: {},
		data: default_data,
		play_sound: false,
		increase_event_cnt: function (type, id_task, primary) {
			self.data_tasks[id_task] ||= 0;
			self.data_tasks[id_task]++;
			if (self.data['event'] < 100) {
				self.data['event']++;

				if (!App.comments.helper_i_see_task(id_task) || type === 'alarm') {
					App.core.call_queue.add('menu_counter', self.draw_counter, App, null, 0.05);
					self.play_sound = true;
					App.core.send_message_to_other_tabs({'command':'who_see_task', 'data': id_task, 'dt' : (new Date).getTime()+Math.random()});
					setTimeout(function() {
						if (self.play_sound && primary && $('body').hasClass('sound_on')) switch (type || '') {
							case 'alarm':
							case 'my':
								App.core.sound('noty_to_me');
								break;
							case 'close':
								App.core.sound('task_done');
								break;
							default:
								App.core.sound('noty');
						}
					} , 50);
					$('#primaryMenu__event__counter span.cnt_new, #mobileMenu__event__counter span.cnt_new').blink();
				} else {
					App.core.call_queue.add('task_seen:' + id_task, function() {
						$.ajax({url: '/ajax/?' + App.actions.get('menu_events:seen') + '&id_task=' + id_task});
					}, null, 0.5);
				}
				self.invalidate_window('events');
			}
		},

		draw_counter: function() {
			let cnt = self.data['event'];
			let cnt_hot = self.data['event_hot'];
			if (cnt) {
				$('#primaryMenu__event__counter, #mobileMenu__event__counter').html('<span class="' + (cnt_hot ? 'cnt_hot' : 'cnt_new') + '">'+App.helper.number.limit(cnt)+'</span>');
			}	else {
				$('#primaryMenu__event__counter, #mobileMenu__event__counter').html('');
			}
			$('#primaryMenu__project__counter, #mobileMenu__project__counter').html(self.data['project_new'] ? '<span class="cnt_new">' + self.data['project_new'] + '</span>' : '');
			if (App.config['title_event_count']) self.update_page_title_counter(cnt);

			let html = '';
			if (self.data['task_new']) html =  '<span class="cnt_new">' + self.data['task_new'] + '</span>';
			else if (self.data['task_hot']) html =  '<span class="cnt_hot">' + self.data['task_hot'] + '</span>';
			else if (self.data['task_warm']) html =  '<span class="cnt_warm">' + self.data['task_warm'] + '</span>';
			else if (self.data['task']) html =  '<span class="cnt_all">' + self.data['task'] + '</span>';
			$('#primaryMenu__task__counter').html(html);
		},

		mark_events_as_seen: function (primary) {
			self.update_page_title_counter('');
			self.data_tasks = {};
			self.data['event'] = 0;
			self.draw_counter();
		},

		mark_task_as_seen: function(id_task) {
			if (id_task in self.data_tasks) {
				delete(self.data_tasks[id_task]);
				if (self.data['event'] < 100) {
					self.data['event'] = 0;
					for (let tmp_task in self.data_tasks) self.data['event'] += self.data_tasks[tmp_task];
				}
				App.core.call_queue.add('task_seen:' + id_task, function() {
					$.ajax({url: '/ajax/?' + App.actions.get('menu_events:seen') + '&id_task=' + id_task});
				}, null, 0.5);
			}
			if (self.cache['events']) {
				self.cache['events'].obj_window.find('.eventsList__item[data-task=' + id_task + ']').not('[data-comment]').removeClass('eventsList__item-unseen');
			}
			self.draw_counter();
		},

		mark_task_comment_as_seen: function(id_task, id_comment) {
			if (self.cache['events']) {

				self.cache['events'].obj_window.find('.eventsList__item[data-task=' + id_task + '][data-comment]').filter(function () {
					return +$(this).attr('data-comment') <= id_comment;
				}).removeClass('eventsList__item-unseen');
			}
		},

		helper_hide_delete_menu: function (fade) {
			if (window.log_delete_tm) clearTimeout(window.log_delete_tm);
			if (fade) {
				$('#log_delete').fadeOut(500);
				setTimeout(function () {
					$('#log_delete').remove();
				}, 500);
			} else {
				$('#log_delete').attr('id', '').css({height: 49}).attr('class', 'log_delete_').html('');
				setTimeout(function () {
					self.obj_window.find('.log_delete_').addClass('log_delete__');
				}, 5);
				setTimeout(function () {
					self.obj_window.find('.log_delete_').css({height: 0});
					self.onscroll();
				}, 10);
			}
		},

		project_goto_url: '',
		select_project_and_goto: function (url) {
			App.controls.project_select_and_go.show(function () {
				App.core.goto(App.helper.url.project($(this).attr('data-id'), url));
			});
		},

		start_search: function (from_panel) {
			const search = from_panel ? '' : self.saved_search_value;
			self.toggle({
				type: 'search',
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('menu_search:show')) + (App.current_page.project ? '&id_project=' + App.current_page.project : '') + '&search=' + encodeURIComponent(search),
				nocache: true
			});
		},

		open_search: function (search) {
			search = search || '';
			self.toggle({
				type: 'search',
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('menu_search:show')) + (App.current_page.project ? '&id_project=' + App.current_page.project : '') + '&search=' + encodeURIComponent(search),
				nocache: true,
				skip_cache: true,
			});
		},

		/**
		 * @deprecated use cached_search_strings instead
		 */
		saved_search_value: '',
		clear_search_string: function (only_saved) {
			self.saved_search_value = '';
			delete self.cached_search_strings[self.type];
			if (!only_saved) $('#search').removeClass('search_started').find('.sinp, .sinp2').val('');
		},
		save_search_string: function (el) {
			let val = el.value;
			self.cached_search_strings[self.type] = val;
			self.saved_search_value = val;
			$('#search').toggleClass('search_started', !!val).find('.sinp, .sinp2').val(val);
		},

		update_page_title_alert: function (active) {
			if (active) {
				document.title = document.title.replace(/^💬 /u, '');
			} else {
				if (!document.title.match(/^💬 /u)) document.title = '💬 ' + document.title;
			}
		},

		update_page_title_counter: function (num) {
			let has_baloon = document.title.match(/^💬 /u);
			document.title = (has_baloon ? '💬 ' : '') + (num && num < 100 ? '(' + num + ') ' : '') + document.title.replace(/^💬 /u, '').replace(/^\(\d+\) /u, '');
		},

		url_goto: null,
		helper_user_select: function (menu_anchor, type, url_goto) {
			self.url_goto = url_goto;
			App.controls.user_select_and_go.show_context(menu_anchor, App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('user_select_and_go:show')), {
				request: {type: 'team', is_ajax: 'mymenu' },
				type: type === 'default' ? undefined : 'submenu mymenu',
				backup: true,
				onload: function () {
					let menu = $(this);
					App.controls.menu.init(menu);
					$(this).on('click', '.menu__item', function () {
						App.menu.hide(true);
						self.show({type: self.type, url: self.url_goto + '&sel_user=' + $(this).attr('data-id'), skip_cache: true});
						return false
					});
				},
			});
		},
		events_filters_panel_state:true,
		events_filters_last_unread_hash:'',
		toggle_event_filters_panel_state: function toggle_event_filters_panel_state(options = {}) {
			if (!['events', 'events_star', 'events_archive', 'events_mine'].includes(self.type)) return;

			const { set_state = null, try_collapse = null, event = null } = options;

			const events_list_form = $('.sidePanel__form.eventsList__form')
			const current_unread_hash = events_list_form.attr('data-unread-hash') || '';
			const filter = events_list_form.find('.sidePanel__filter');

			if (!filter.length) return;

			if (set_state) {
				if (current_unread_hash && current_unread_hash !== self.events_filters_last_unread_hash) {
					events_list_form.removeClass('eventsList__form-collapsed');
				} else {
					events_list_form.toggleClass('eventsList__form-collapsed', self.events_filters_panel_state);
				}
			} else {
				// треба враховувати тільки активні фільтри.. ну нехай це будуть ті, в кого є хрестик-скидання
				const active_filters = filter.find('ws-btn[right-icon="close"]').length;
				if (try_collapse) {
					if (!active_filters) {
						self.events_filters_panel_state = true;
						events_list_form.toggleClass('eventsList__form-collapsed', self.events_filters_panel_state);
					}
				} else if (active_filters && !self.events_filters_panel_state) {
					self.events_filters_panel_state = true;
					events_list_form.find('.sidePanel__tabs .active').click();
				} else {
					events_list_form.toggleClass('eventsList__form-collapsed');
					self.events_filters_panel_state = events_list_form.hasClass('eventsList__form-collapsed');
				}

				if (self.events_filters_panel_state && current_unread_hash) {
					self.events_filters_last_unread_hash = current_unread_hash
				}
			}

			// при розкриванні фільтрів кнопкою - проскролимо до неї
			// PS в нових шапках може бути не актуально, бо кнопка липне до края і перекриває таби
			if (event && App.device.is_mobile() && !self.events_filters_panel_state) {
				const tabs = self.obj_window.find('.sidePanel__tabs');
				if (!tabs.length) return;

				App.helper.scroll_to_active_tab(tabs, '.eventsList__filter-btn');
			}
		},

		id_active_chat: null,
		set_active_chat: function(id, personal) {
			self.id_active_chat = id ? {id, personal} : null;
			if (self.cache['chats']) self.set_active_chat_callback();
		},
		set_active_chat_callback: function () {
			let o = self.cache['chats'].obj_window.find('.sidePanel__list__item-chat');

			o.removeClass('sidePanel__list__item-active');

			if (!self.id_active_chat) return;

			if (self.id_active_chat.personal) {
				o = o.filter('[data-user=' + self.id_active_chat.id + ']');
			} else {
				o = o.filter('[data-chat=' + self.id_active_chat.id + ']');
			}

			let should_update_list = false;
			switch (o.attr('data-type')) {
				case 'self-empty':
					should_update_list = true;
					o.attr('data-type', 'self').attr('data-waste', null).attr('data-dt', App.helper.time.now());
					break;
				case 'project-empty':
					should_update_list = true;
					o.attr('data-type', 'project').attr('data-waste', null).attr('data-dt', App.helper.time.now());
					break;
				case 'private-empty':
				case 'private-inactive':
					should_update_list = true;
					o.attr('data-type', 'private').attr('data-waste', null).attr('data-dt', App.helper.time.now());
					break;
			}

			o.addClass('sidePanel__list__item-active').removeClass('sidePanel__list__item-waste');

			let tab = self.cache['chats'].obj_window.find('.sidePanel__tabs li.active').attr('data-tab');
			let show = ['private','group','project', 'self'].includes(o.attr('data-type'));
			if (tab === 'unread') {
				show = o.find('task-unseen .cnt').length > 0;
			} else if (tab !== 'all') {
				show = o.attr('data-type') === tab || (o.attr('data-type') === 'self' && tab === 'private');
			}
			o.toggleClass('sidePanel__list__item-disabled', !show);

			if (should_update_list) self.sort_chats();
		},

		refresh_chat_counters: function () {
			if (self.cache['chats'] == null) return;

			let counters = { unread: 0, group: 0, project: 0, private: 0 };

			self.cache['chats'].obj_window.find('.sidePanel__list__item-chat').each(function () {
				let cnt = $(this).find('task-unseen .cnt').length > 0 ? 1 : 0;
				counters.unread+= cnt;
				counters[$(this).attr('data-type')]+= cnt;
			});

			self.cache['chats'].obj_window.find('.sidePanel__tabs li').each(function () {
				let tab = $(this).attr('data-tab'), count = counters[tab] || 0;
				$(this).find('.count').text(count).toggleClass('hiddenBlock', !count);
				if (tab === 'unread' && !$(this).hasClass('active')) {
					$(this).toggleClass('hiddenBlock', !count);
				}
			});
		},

		sort_chats: function (obj_window) {
			obj_window = $(obj_window) || self.cache['chats']?.obj_window || self.obj_window || $();

			const sort_chat_items = (items) => {
				items.sort((a, b) => {
					if (+b.getAttribute('data-pin') === +a.getAttribute('data-pin')) {
						return +b.getAttribute('data-dt') - +a.getAttribute('data-dt');
					}

					return +b.getAttribute('data-pin') - +a.getAttribute('data-pin');
				});
				return items;
			};

			obj_window.find('.chatList__group__content').each(function () {
				let items = sort_chat_items($(this).children('.sidePanel__list__item-chat').get());
				$(this).append(items);
			});

			obj_window.find('.dashboard__chatList').each(function () {
				let items = sort_chat_items($(this).children('.chatList__item').get());
				if (items.length) $(this).append(items);
			});
		},

		preload_chats: function(callback) {
			let url = App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('menu_chats:show'));
			$.ajax({
				url,
				context: this,
				success: function (html) {
					let div = $('<div />').css({
						position: 'fixed',
						left: -1000,
						top: 0
					}).appendTo('body');
					div.html(html);
					let minibar = div.find('.scrollZone').length ? App.controls.js_scrollbars.init(div.find('.scrollZone').get(0)) : null;
					let obj_menus = div.find('.menu[id]').detach();
					let obj_window = div.find('.sidePanel').detach();

					self.cache['chats'] = {
						obj_window: obj_window,
						obj_menus: obj_menus,
						minibar: minibar,
						url
					}
					div.remove();
					self.init(obj_window);
					self.init_chats(obj_window);
					App.chat_view.update_counter();
					if (callback) callback();
				}
			});
		},

		onkeyup: function (key, alt, ctrl, meta, shift, in_input) {},

		onkeydown: function (key, alt, ctrl, meta, shift, in_input, in_input_strict) {
			if (App.mymenu.is_shown('events')) {
				let item = App.mymenu.obj_window.find('.sidePanel__list__item.selected').first();
				if (item.length) {
					if (key === App.keycode.KeyS && !alt && !ctrl && !meta && !shift && !in_input && !in_input_strict) {
						item.find('.floatIcons a[data-action=' + (item.hasClass('eventsList__item-star') ? 'unstar' : 'star') + ']').trigger('click');
						return true;
					}
					if (key === App.keycode.KeyA && !alt && !ctrl && !meta && !shift && !in_input && !in_input_strict) {
						item.find('.floatIcons a[data-action=archive]').trigger('click');
						self.last_archived = {
							type: 'archived',
							time: Date.now(),
							id: item.attr('data-id'),
						};
						return true;
					}
				}
				if ((key === App.keycode.Escape || (key === App.keycode.KeyZ && (ctrl || meta))) && self.last_archived.time >= Date.now() - 3000 && self.last_archived.type === 'archived') {
					$.ajax(App.helper.endpoint.primary() + '?' + App.actions.get('log_status:do') + '&id=' + self.last_archived.id + '&status=1');
					self.invalidate_window('events');
					self.last_archived = {};
					return true;
				}
			} else if (App.mymenu.is_shown('events_archive')) {
				let item = App.mymenu.obj_window.find('.sidePanel__list__item.selected').first();
				if (item.length) {
					if (key === App.keycode.KeyA && !alt && !ctrl && !meta && !shift && !in_input && !in_input_strict) {
						item.find('.floatIcons a[data-action=unarchive]').trigger('click');
						self.last_archived = {
							type: 'unarchived',
							time: Date.now(),
							id: item.attr('data-id'),
						};
						return true;
					}
				}
				if ((key === App.keycode.Escape || (key === App.keycode.KeyZ && (ctrl || meta))) && self.last_archived.time >= Date.now() - 3000 && self.last_archived.type === 'unarchived') {
					$.ajax(App.helper.endpoint.primary() + '?' + App.actions.get('log_status:do') + '&id=' + self.last_archived.id + '&status=4');
					self.invalidate_window('events_archive');
					self.last_archived = {};
					return true;
				}
			}
			return false;
		},

		onload: function () {
			self.obj_wrapper = $('#sidePanel__wrapper');
			$('#sidePanel__overlay').bind('click', () => self.hide());
			if (App.config.sound && !App.core.get_cookie('snd_on')) {
				$(document).bind('click', this.enable_play_sounds);
			}
			self.play_sounds();
			self.init_task_items();
			self.init_chat_items();
			self.init_project_items();
			self.init_costs_items();
			self.init_log_items();
			self.init_user_items();
			self.init_contact_items();
			self.init_bookmark_items();

			App.helper.cron.add('load_event_count', function () {
				if (App.core.websocket.ready || !App.me.id) return;
				self.load_event_count();
			}, 120 * (App.config['rare_sync'] ? 2.5 : 1));
		},

		destructor: function() {
			App.core.async_task.abort('mymenu_show');
			App.helper.cron.remove('load_event_count');

			$('body').removeClass('sidePanelShown sidePanelShown480p');

			for (let type in self.cache) {
				self.cache[type].minibar?.destroy();
				self.cache[type].obj_window.removeWithComponents();
				self.cache[type].obj_menus.removeWithComponents();
			}
			self.shown = false;
			self.window.closed();
			self.saved_scroll_pos = null;
			self.cache = {};
			self.type = '';
			self.prev_type = '';
			self.obj_wrapper = null;
			self.obj_window = null;
			self.obj_menus = null;
			self.minibar = null;
			self.cached_search_strings = {};
			self.last_archived = {};
			self.cache_expire = {};
			self.last_pause_at = 0;
			self.keyboard_container = null;
			self.go_nohistory = false;
			self.data_tasks = {};
			self.data = default_data;
			self.play_sound = false;
			self.project_goto_url = '';
			self.saved_search_value = '';
			self.url_goto = null;
			self.events_filters_panel_state = true;
			self.events_filters_last_unread_hash = '';
			self.id_active_chat = null;

			clearTimeout(self.animate_show_timer);

			delete self['skeleton'];
			delete self['__rid'];
			delete self['loaded_html'];
			delete self['dont_cache'];
			delete self['url'];
			delete self['stale_content'];
			delete self['has_loaded'];
			delete self['animate_show_timer'];
		},

		onBoot: function () {
			self.window = App.window.left_panel.bind(self);
			App.bus.msg.on('events', self.process_event_cnt).on('i_see_task', () => {
				self.play_sound = false;
			});
			App.bus.window.on('active', function () {
				self.update_page_title_alert(true);
			});
			App.bus.state.on('task', function (state) {
				if (state.data.bookmark) self.mark_invalidated_window('bookmarks');
				if (state.data.read) {
					const ids_seen = state.data.read.ids_seen || [];
					ids_seen.push(state.data.read.id_seen);

					const obj_window = self.cache.events ? self.cache.events.obj_window : $();
					const flt = obj_window.find('.sidePanel__filter');

					if (flt.length > 0) {
						let unread_ids_mention = (flt.attr('data-ids-unread-mention') || '').toIntArray();
						let unread_ids_reply = (flt.attr('data-ids-unread-reply') || '').toIntArray();

						if (unread_ids_mention.length > 0 || unread_ids_reply.length > 0) {

							ids_seen.forEach(id_seen => {
								unread_ids_mention = unread_ids_mention.filter(i => i !== id_seen);
								unread_ids_reply = unread_ids_reply.filter(i => i !== id_seen);
							});

							flt.attr('data-ids-unread-mention', unread_ids_mention.join(','));
							flt.attr('data-ids-unread-reply', unread_ids_reply.join(','));

							flt.find('.cnt-unread-mention').text(unread_ids_mention.length);
							flt.find('.cnt-unread-reply').text(unread_ids_reply.length);

							const unread_mention_btn = flt.find('ws-btn.btn-unread-mention');
							const unread_reply_btn = flt.find('ws-btn.btn-unread-reply');
							const flt_btn = obj_window.find('.sidePanel__tabs .eventsList__filter-btn');

							if (unread_ids_mention.length) {
								unread_mention_btn.attr('text', App.format.quantity(unread_ids_mention.length, unread_mention_btn.attr('data-label')), unread_ids_mention.length > 1);
							} else {
								unread_mention_btn.remove();
							}

							if (unread_ids_reply.length) {
								unread_reply_btn.attr('text', App.format.quantity(unread_ids_reply.length, unread_reply_btn.attr('data-label')), unread_ids_reply.length > 1);
							} else {
								unread_reply_btn.remove();
							}

							if (unread_ids_mention.length === 0 && unread_ids_reply.length === 0 && flt_btn.length > 0) {
								self.events_filters_last_unread_hash = '';
								flt_btn.attr('name', flt_btn.attr('name').replace('btn-right-indicator-w', ''));
							}
						}
					}
				}
			});
			App.bus.app.on('window_signal', function (e) {

				if (e.payload?.no_foreground) return;
				if (!App.device.is_mobile()) return;

				const setup = () => {
					const mymenu_z_index = +self.obj_wrapper.css('z-index');
					if (App.task_panel.obj) App.task_panel.obj.css('--zIndex', mymenu_z_index + 1);
					if (App.mobile_menu_primary.obj_overlay) App.mobile_menu_primary.obj_overlay.css('--zIndex', mymenu_z_index + 2);
					if (App.mobile_menu_primary.obj_wrapper) App.mobile_menu_primary.obj_wrapper.css('--zIndex', mymenu_z_index + 3);
				};
				const clear = () => {
					if (App.task_panel.obj) App.task_panel.obj.css('--zIndex', '');
					if (App.mobile_menu_primary.obj_overlay) App.mobile_menu_primary.obj_overlay.css('--zIndex', '');
					if (App.mobile_menu_primary.obj_wrapper) App.mobile_menu_primary.obj_wrapper.css('--zIndex', '');
				};

				if (e.state === App.windows.states.ALREADY_OPENED) {
					if (e.key === 'left_panel') {
						setup();
					} else {
						clear();
					}
				} else if (e.state === App.windows.states.OPENING) {
					if (e.key === 'left_panel') {
						setup();
					} else {
						clear();
					}
				} else if (e.state === App.windows.states.OPENED) {
				} else if (e.state === App.windows.states.CLOSED) {
					if (App.windows.opened[0] === 'left_panel') {
						setup();
					} else {
						clear();
					}
				} else if (e.state === App.windows.states.MINIMIZING) {
				} else if (e.state === App.windows.states.CLOSING) {
				}
			});
			// якщо все таки треба розтягувати на весь екран, тоді треба врахувати оновлені zIndex в task_panel/mobile_menu_primary
			// App.bus.app.on('left_panel_opening', function () {
			// 	if (App.device.is_mobile()) {
			// 		self.obj_wrapper.toggleClass('sidePanel__wrapper--fullscreen', Boolean(App.task_view.is_shown()));
			// 	}
			// });
			App.bus.app.on('left_panel_ready', function () {
				if (App.mymenu.obj_window.find('.search_fld').length) {
					App.context_search.mymenu.last_value_processed = App.context_search.mymenu.last_value_pressed = App.mymenu.obj_window.find('.search_fld').val().trim();
				}
			});
			App.bus.state.on('user_bookmark', function (payload, context) {
				const id_user = payload.id;
				const data_obj = payload.data;
				if (!data_obj) return;
				if (
					data_obj.on
					&& self.is_shown('users_star')
					&& !self.obj_window.find(`.sidePanel__list__item-user[data-user="${id_user}"]`).length
				) {
					self.invalidate_window('users_star');
					return;
				}
				// інвалідуємо завжди, бо non-fav юзер має зникнути зі списку при наступному завантажені цього табу
				self.mark_invalidated_window('users_star');
				const get_sort_by_stars = () => App.helper.parseBoolean(self.obj_window.attr('data-sort-by-stars'));
				if (!self.is_shown('users') || get_sort_by_stars()) self.mark_invalidated_window('users');
			});
		},
		onLogin: function() {
			self.onload();

			self.skeleton = {};
			$('.mymenuSkeleton').each(function () {
				self.skeleton[$(this).attr('data-type')] = $(this).html();
			});
			$('.mymenuSkeleton').remove();

			if (App.hybrid_app) {
				App.hybrid_app.set_badge_number(App.mymenu.data.event);

				App.bus.hybrid_app
					.on('resume', function () {

					})
					.on('pause', function () {
						let ts = Math.floor(Date.now()/1000);

						if (ts - self.last_pause_at > 60) {
							self.load_event_count();
						}

						self.last_pause_at = ts;
					});
			}

			App.bus.app.on('task_view_ready', function (payload) {
				if (payload.target.get_id_project() == null && payload.target.is_chat && !App.device.is_mobile() && window.innerWidth > 1100 && !self.is_shown('chats') && !App.right_panel.is_shown()) {
					App.mymenu.toggle({type: 'chats', url: '/ajax/?'+App.actions.get('menu_chats:show')});
				}
			});

			App.bus.state.on('task_seen', function (payload) {
				App.mymenu.mark_task_as_seen(payload.id);
			}).on('task_timers', function () {
				if (App.mymenu.is_shown('costs') && App.mymenu.obj_window.data('type') === 'fact') {
					App.mymenu.invalidate_window('costs');
				}
			}).on('task_schedule_update', function (payload) {
				let data_obj = payload.data;
				if (!data_obj || !Array.isArray(data_obj)) return;
				data_obj.forEach(_data_obj => {
					if (App.mymenu.is_shown('costs') && App.mymenu.obj_window.data('type') === 'plan' && App.mymenu.obj_window.data('day') === _data_obj.day) {
						App.mymenu.invalidate_window('costs');
					}
				});
			});

			App.mymenu.preload_chats();
		},
		onLogout: () => self.destructor(),
	};
})();

;var App = App || {};

(function() {
	let self = App.notebook = {
		shown: false,
		obj_wrapper: null,
		obj_window: null,
		obj_menus: null,
		minibar: null,
		endpoint: null,

		state_saved: null,
		last_scroll_top: 0,

		is_shown: function () {
			return self.shown;
		},

		show: function() {
			if (!App.windows.before_open(self.window)) return;

			if (self.is_shown()) {
				self.window.alreadyOpened();
				return false;
			}

			self.window.opening();
			let cache_data = App.notebook_cache.pop();
			if (cache_data) {
				self.shown = true;
				self.obj_wrapper.html('').append(cache_data.obj_window).append(cache_data.obj_menus);
				self.obj_window = cache_data.obj_window;
				self.obj_window.find('.minimize').toggleClass('ws-utility-hidden', App.task_panel.item.exists(self));
				self.animate_show();
				self.state_saved = self.get_state();
				self.obj_wrapper.find('#noteBook__content').scrollTop(self.last_scroll_top);
				self.window.opened();
			} else {
				self.window.loading();
				$.ajax({
					url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('notebook:show') + '&id=' + self.id),
					success: function (html) {
						self.shown = true;
						self.obj_wrapper.html(html);
						self.animate_show();
						self.obj_menus = self.obj_wrapper.find('.menu').not('.menu-level2').appendTo('#noteBook__wrapper');
						self.obj_window = self.obj_wrapper.find('.noteBook');
						self.obj_window.find('.minimize').toggleClass('ws-utility-hidden', App.task_panel.item.exists(self));
						self.state_saved = self.get_state();
						self.init();
						App.notebook_cache.push(self);
						self.window.opened();
					},
					error: App.core.create_jq_ajax_error(function () {
						self.window.loadFailed();
					})
				});
			}
		},

		hide: function() {
			if (App.task_panel.item.exists(self)) {
				self.minimize();
			} else {
				self.delete();
			}
		},

		delete: function() {
			self.window.closing();
			self.schedule_save(1)
			self.minibar.destroy();
			App.notebook_cache.delete();
			self.animate_hide(function() {
				self.window.closed();
				self.shown = false;
				self.remove();
			});
		},

		animate_show: function() {
			if (App.device.is_mobile()) {
				$('body').addClass('mobileNoteBook');
			} else {
				self.obj_wrapper.addClass('noteBook__wrapper-active');
			}
		},

		animate_hide: function(callback) {
			if (App.device.is_mobile()) {
				$('body').removeClass('mobileNoteBook');
				callback();
			} else {
				self.obj_wrapper.removeClass('noteBook__wrapper-active');
				setTimeout(function() {
					callback.call(self);
				}, 300);
			}
		},

		minimize: function() {
			self.window.minimizing();
			self.schedule_save(1);
			self.animate_hide(function() {
				self.window.closed();
				self.shown = false;
				self.detach();
			});
		},

		detach: function() {
			self.obj_window.detach();
			self.obj_menus.detach();
		},

		remove: function() {
			self.obj_window.removeWithComponents();
			self.obj_menus.removeWithComponents();
		},

		get_state: function() {
			return self.obj_wrapper.find('textarea').val();
		},

		is_saved: function() {
			return self.state_saved === self.get_state();
		},

		request_save: function (params, onsuccess, onerror) {
			self.loader.start();
			$.ajax({
				url: self.endpoint,
				type: 'POST',
				data: 'note=' + encodeURIComponent(params.data),
				timeout: App.env === 'local' ? 60000 : 10000,
				error: App.core.create_jq_ajax_error(onerror),
				success: function () {
					self.loader.stop();
					if (onsuccess) onsuccess();
				}
			});
		},

		onform_update: function() {
			if (self.state_saved === self.get_state()) {
				self.loader.stop();
				return;
			}

			self.loader.stop();
			self.schedule_save();
		},

		schedule_save: function (delay_seconds) {
			let this_state = self.get_state();
			let queue_id = 'notebook';
			App.core.call_queue.delete(queue_id);
			self.state_saved = this_state;
			App.core.call_queue.add(queue_id, self.request_save, this, {
				data: this_state,
			}, delay_seconds || 1);
		},

		init: function () {
			self.endpoint = self.obj_window.attr('data-action');

			let content = self.obj_wrapper.find('#noteBook__content');
			let last_scroll_top = self.last_scroll_top;

			self.obj_window.find('textarea').bind('input', function(e) {
				$(this).height(0);
				$(this).height(Math.max(286, $(this).get(0).scrollHeight));

				if ($(this).val().length*.9 < e.target.selectionStart) {
					content.scrollTop(999999);
				}

				self.last_scroll_top = content.get(0).scrollTop;
				self.onform_update();
			}).trigger('input');

			self.minibar = App.controls.js_scrollbars.init('#noteBook__content');
			setTimeout(() => content.scrollTop(last_scroll_top), 10)
		},

		loader: {
			start: function() {
				self.obj_window.addClass('loading');
			},

			stop: function() {
				self.obj_window.removeClass('loading');
			},
		},

		onKeyboardShow: function() {
			if (self.is_shown() && $(window).width() <= APP_SCREEN_THRESHOLD) {
				self.obj_wrapper.css('height', App.helper.viewport.height());
			}
		},

		onKeyboardHide: function() {
			if (self.is_shown() && $(window).width() <= APP_SCREEN_THRESHOLD) {
				self.obj_wrapper.css('height', '');
			}
		},

		onload: function() {
			self.obj_wrapper = $('#noteBook__wrapper');
		},

		destructor: function() {

			if (self.is_shown()) {
				self.minibar.destroy();
				self.remove();
			}

			self.shown = false;
			self.window.closed();
			self.obj_wrapper = null;
			self.obj_window = null;
			self.obj_menus = null;
			self.minibar = null;
			self.endpoint = null;
			self.state_saved = null;
			self.last_scroll_top = 0;
		},

		onBoot: function () {
			self.window = App.window.notebook.bind(self);
			App.bus.window
				.on('keyboard_show', self.onKeyboardShow)
				.on('keyboard_hide', self.onKeyboardHide);
		},
		onLogin: () => self.onload(),
		onLogout: () => self.destructor(),
	}
})();

App.notebook_cache = {
	data: null,

	exists: function() {
		return !!this.data
	},

	pop: function() {
		return this.data;
	},

	delete: function() {
		this.data.obj_window.removeWithComponents();
		this.data.obj_menus.removeWithComponents();
		this.data = null;
	},

	push: function(self) {
		this.data = {
			obj_window: self.obj_window,
			obj_menus: self.obj_menus,
			id: self.id,
			title: self.title,
			state: 'open',
			dt_added: new Date()
		}
	},

	destructor: function() {
		if (this.exists()) this.delete();
	},

	onLogout: () => App.notebook_cache.destructor(),
}

;var App = App || {};

(function () {
	let self = App.offline_mode = {

		ping_url: '',
		active: false,
		hide_timer: null,
		ping_timer: null,
		ping_timeout: 10_000,

		show_offline: function () {
			clearTimeout(self.hide_timer);

			$('.page-offline.page-online, .page-offline.page-slow').remove();

			let o = $('.page-offline');
			if (o.length) {
				o.css({ top: '6vh', left: 'calc(50% - ' + o.width() + 'px/2)' });
				o.animate_css('slide-in-down', { speed: 'fast' });
				return;
			}

			o = $('<div />').addClass('page-offline flex_row');

			let text = App.object_state.locale['offline_mode_text'];
			o.html(App.device.is_mobile()
				? `<span><ws-marquee>${text}</ws-marquee></span>`
				: `<span class="loader_sm loader_err"></span><span>${text}</span>`);

			o.appendTo('#fixed_container');
			o.css({ top: '6vh', left: 'calc(50% - ' + o.width() + 'px/2)' });
		},

		show_warning: function () {
			let o = $('.page-offline');

			if (o.hasClass('page-slow')) {
				clearTimeout(self.hide_timer);
				self.hide_timer = setTimeout(self.hide, 9000);
			}

			if (o.length) return;

			o = $('<div />').addClass('page-offline page-slow flex_row');
			o.appendTo('#fixed_container');

			let text = App.object_state.locale['slow_conn_text'];
			o.html(App.device.is_mobile() ? `<span><ws-marquee>${text}</ws-marquee></span>` : `<span class="loader_sm"></span><span>${text}</span>`);
			o.css({ top: '6vh', left: 'calc(50% - ' + o.width() + 'px/2)' });

			clearTimeout(self.hide_timer);
			self.hide_timer = setTimeout(self.hide, 9000);
		},

		show_online: function () {
			let o = $('.page-offline');
			if (!o.length) {
				o = $('<div />').addClass('page-offline flex_row');
				o.appendTo('#fixed_container');
			}

			o.addClass('page-online');
			let text = App.object_state.locale['online_mode_text'];
			o.html(App.device.is_mobile() ? `<span><ws-marquee>${text}</ws-marquee></span>` : `<span>${text}</span>`);
			o.css({ top: '6vh', left: 'calc(50% - ' + o.width() + 'px/2)' });

			clearTimeout(self.hide_timer);
			self.hide_timer = setTimeout(self.hide, 5000);
		},

		hide: function () {
			clearTimeout(self.hide_timer);
			$('.page-offline').remove();
		},

		ping: function () {
			clearTimeout(self.ping_timer);
			App.core.async_task.ajax({
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('process:ping')),
				method: 'GET',
				cache: 'no-store',
				timeout: self.ping_timeout,
			})
				.then(self.on_online)
				.catch(self.on_offline);
		},

		is_on: function () {
			if (self.active) $('.page-offline').animate_css('slide-in-down', { speed: 'fast' });

			return self.active;
		},

		on_offline: function (err) {
			App.core.log('offline_mode', 'ping error: ' + (err?.message || '-'));

			if (err?.is_aborted) return;
			if (App.hybrid_app?.is_pause === 1) return;

			self.schedule_ping();

			if (self.active) return;
			self.active = true;
			$('body').addClass('offlineMode');
			self.show_offline();
			App.bus.app.emit('offline_mode', true);
		},

		on_online: function () {
			App.core.log('offline_mode', 'ping OK');

			if (!self.active) return;
			self.active = false;
			$('body').removeClass('offlineMode');
			self.show_online();
			App.bus.app.emit('offline_mode', false);
		},

		schedule_ping: function () {
			clearTimeout(self.ping_timer);
			self.ping_timer = setTimeout(self.ping, self.ping_timeout * 1.1);
		},

		onLogin: function () {
			const bus = App.hybrid_app ? App.bus.hybrid_app : App.bus.window;
			bus.on('offline', self.schedule_ping)
				.on('online', self.schedule_ping)
				.on('pause', () => clearTimeout(self.ping_timer))
				.on('resume', self.schedule_ping);

			const SAMPLES = {
				dts: [],
				triggered_dt: 0,
				add(duration) {
					this.dts.push(duration);

					if (this.dts.length > 12) this.dts.shift();

					if (this.avg() > 8000 && Date.now() - this.triggered_dt > 300000) {
						this.triggered_dt = Date.now();
						App.offline_mode.show_warning();
					}
				},
				avg() {
					return this.dts.reduce((a, b) => a + b, 0) / this.dts.length;
				},
			};
			const ignore_url_checks = [
				(url) => url.indexOf('/ajax/auth') > 0,
				(url) => url.indexOf('/account/') > 0,
				(url) => url.indexOf('workspace_config') > 0,
				(url) => url.indexOf('action=batch_load') > 0,
				(url) => url.indexOf('action=process') > 0,
				(url) => url.indexOf('action=menu_search_content') > 0,
				(url) => url.indexOf('action=task_unseen_summary') > 0,
				(url) => url.indexOf('action=ai_helper') > 0,
				(url) => url.endsWith('.json'),
				(url) => url.endsWith('.css'),
				(url) => url.endsWith('.js'),
			];

			$(document)
				.on('ajaxSend', function (e, xhr, settings) {
					if (!ignore_url_checks.some(p => p(settings.url))) xhr.__startTime = Date.now();
				})
				.on('ajaxComplete', function (e,xhr) {
					if (xhr.__startTime) SAMPLES.add(Date.now() - xhr.__startTime);
				});
		}
	};
})();

;var App = App || {};

(function() {
	let self = App.plan_change = {

		shown: false,

		is_shown() {
			return self.shown;
		},

		init: function() {
			self.helper.hover_new_plan();
			self.helper.planChangeSlider();
			self.helper.planChangeNoticeOneLine();
			$('.sw_plan_yearly').off('click').on('click', function () { $('ws-slider[name=paid_period] a[data-value="0"]').trigger('click'); });
			$('.sw_plan_monthly').off('click').on('click', function () { $('ws-slider[name=paid_period] a[data-value="1"]').trigger('click'); });
			$('.planChange__header').off('click').on('click', function () {
				$('.planChange__content-wrapper').scrollTop(0);
			});
		},

		show: function() {
			App.right_panel.show({url: App.helper.endpoint.primary() + '?' + App.actions.get('account_plan_change:show'), type: 'plan', 'overlay': true});
			self.shown = true;

			$(document).bind('right_panel_onload.final', function(){
				self.init();
			});
		},

		apply: function(id_plan, mda_action) {
			$.ajax({
				type: "POST",
				url: '/ajax/?' + mda_action,
				data: {
					id_plan: parseInt(id_plan)
				}
			});
		},

		helper: {
			hover_new_plan: function() {
				let plan_card = $('.planChange__card-switch');
				plan_card.each(function() {
					let quota_number = $(this).find('.quota_number[data-quota-show]');
					let plan_button = $(this).find('.planChange__card__price').next();
					plan_button.on('mouseenter touchstart', function (){
						if (App.scroll_listener.is_scrolling) return;
						let number_pay = $(this).find('.numbers .number_pay-animated');
						let plan_price_shown = number_pay.attr('data-shown');
						let plan_price_shown_sw = number_pay.attr('data-shown-switch');
						number_pay.numberRoller({
							start: parseInt(plan_price_shown),
							end: parseInt(plan_price_shown_sw),
							duration: 300,
							stepSize: 0.05
						});
						if (quota_number.length) quota_number.each(function () {
							let this_quota_show = $(this).attr('data-quota-show');
							let this_quota_sw = $(this).attr('data-quota-switch');
							$(this).numberRoller({
								start: parseInt(this_quota_show),
								end: parseInt(this_quota_sw),
								duration: 300,
								stepSize: 0.05
							});
						});
					});
					plan_button.on('mouseleave touchend', function (){
						let number_pay = $(this).find('.numbers .number_pay-animated');
						let plan_price_shown = number_pay.attr('data-shown');
						let plan_price_shown_sw = number_pay.attr('data-shown-switch');
						number_pay.numberRoller({
							start: parseInt(plan_price_shown_sw),
							end: parseInt(plan_price_shown),
							duration: 300,
							stepSize: 0.05
						});
						if (quota_number.length) quota_number.each(function () {
							let this_quota_show = $(this).attr('data-quota-show');
							let this_quota_sw = $(this).attr('data-quota-switch');
							$(this).numberRoller({
								start: parseInt(this_quota_sw),
								end: parseInt(this_quota_show),
								duration: 300,
								stepSize: 0.05
							});
						});
					});
				});
			},

			planChangeSlider: function() {
				const cardsQuantity = document.querySelectorAll('.planChange__card').length;
				if (cardsQuantity === 3) {
					$(".planChange__cards").not('.slick-initialized').slick({
						centerMode: true,
						centerPadding: "0px",
						slidesToShow: cardsQuantity,
						arrows: false,
						dots: true,
						initialSlide: 1,
						infinite: false,
						mobileFirst: true,
						autoplay: false,
						responsive: [{
							breakpoint: 1200,
							settings: {
								centerMode: true,
								centerPadding: "0px",
								slidesToShow: cardsQuantity,
								initialSlide: 1
							}
						}, {
							breakpoint: 960,
							settings: {
								centerMode: true,
								centerPadding: "20px",
								slidesToShow: cardsQuantity,
								initialSlide: 1
							}
						}, {
							breakpoint: 0,
							settings: {
								centerMode: true,
								centerPadding: "14px",
								slidesToShow: 1,
								variableWidth: true
							}
						}]
					});
				} else {
					$(".planChange__content").addClass('four-cards');
					$(".planChange__cards").not('.slick-initialized').slick({
						centerMode: true,
						centerPadding: "0px",
						slidesToShow: cardsQuantity,
						arrows: false,
						dots: true,
						initialSlide: 2,
						infinite: false,
						mobileFirst: true,
						autoplay: false,
						responsive: [{
							breakpoint: 1280,
							settings: {
								centerMode: true,
								centerPadding: "0px",
								slidesToShow: cardsQuantity,
								initialSlide: 2
							}
						}, {
							breakpoint: 0,
							settings: {
								centerMode: true,
								centerPadding: "14px",
								slidesToShow: 1,
								variableWidth: true
							}
						}]
					});
				}
			},

			planChangeNoticeOneLine: function() {
				let text = $('.planChange__notice');

				if (text) {
					let breakPoint = $('.planChange__content').hasClass('four-cards') ? 1280 : 960;
					if ($(window).width() <= breakPoint)  text.html(text.html().replace('<br>', ' '));
				}
			},

			payment_period_switch: function() {
				if ( $('#planChange').length ) {
					let period = $('input[name=paid_period]').val();
					$('.planChange__card__price').each(function(){
						$(this).find('span.sw_plan_yearly, span.sw_plan_monthly').toggle();
						$(this).find('.numbers .number_pay').each(function() {
							let number_pay = $(this);
							let plan_price_shown = number_pay.attr('data-shown');
							let plan_price_alt = number_pay.attr('data-alt');
							if (number_pay[0].hasAttribute('data-shown-switch')) {
								let plan_price_shown_sw = number_pay.attr('data-shown-switch');
								let plan_price_alt_sw = number_pay.attr('data-alt-switch');
								number_pay.attr('data-shown-switch', plan_price_alt_sw).attr('data-alt-switch', plan_price_shown_sw);
							}
							number_pay.numberRoller({
								start: parseFloat(plan_price_shown),
								end: parseFloat(plan_price_alt),
								duration: 300
							});
							number_pay.attr('data-shown', plan_price_alt).attr('data-alt', plan_price_shown);
						});
					});
				}
			},
		},

		destructor: function () {
			self.shown = false;
		},

		onLogout: () => self.destructor(),

		onBoot: function() {
			App.bus.app.on('right_panel_closed', function () {
				self.shown = false;
			});
		}
	}
})();

;var App = App || {};

(function () {
	let self = App.profile = {
		tab_url: '',
		close_alert_waits: {
			tab_url: '',
			tab_el: null,
		},
		modal_obj: {},
		modal_obj_content: {},
		modal_obj_sidebar: {},
		modal_obj_header_submit_btn: null,
		current_onclick: null,
		/**
		 * @type {MutationObserver|null}
		 */
		modal_observer: null,
		loader: {},
		hlt_selector: '',
		is_shown: false,
		default_settings: {
			notifications: {},
			notif_options: {},
			privacy_options: {
				'is_hide_names': '0',
				'is_hidecon': '2',
				'is_online': '1'
			},
			other_options: {},
		},

		html: `<div class="setupBlock__modal flex_content">
			<div id="modSidebar" class="setupBlock__modal-wrapper"></div>
			<div id="modProfile" class="setupBlock__modal-wrapper flex_column">
				<div id="modProfileContent" class="flex_content flex_column"></div>
				<div id="modProfileFooter"></div>
				<div class="profile__block__loader"><ws-icon name="worksection_bold-solid"></ws-icon><div class="loader"></div></div>
			</div>
		</div>`,

		mobile_header_html: `<div class="mobile-head">
			<div class="mobile-head__left"></div>
			<div class="mobile-head__content">
				<div class="mobile-head__ava-btn"><a></a></div>
				<div class="mobile-head__title">
					<div class="mobile-head__dropdown withRipple">
						<span class="in"></span>
						<ws-icon name="arrows/chevron-down"></ws-icon>
					</div>
				</div>
			</div>
			<div class="mobile-head__right"></div>
		</div>`,

		is_shown_user: function (id_user) {
			return self.is_shown && id_user === +self.modal_obj?.attr('data-user');
		},

		init: function () {
		},

		show_menu: function (anchor, options) {
			options ||= {};
			const id_user = options.id_user ?? $(anchor).attr('data-user') ?? App.me.id;
			const url = App.helper.url.add_query(
				App.helper.endpoint.user(id_user),
				App.actions.get('sidebar_profile:menu'),
			);
			App.menu.show({
				url,
				...options,
				anchor,
				onshow: function () {
					const menu = $(this);

					menu.find('.sidebar__menu__item-active').removeClass('sidebar__menu__item-active');
					if (self.current_onclick) menu.find('.menu__item[onclick="'+CSS.escape(self.current_onclick)+'"]').addClass('sidebar__menu__item-active');
				}
			});
		},

		modal: {
			resolve_id_user: function(url_content, user_id) {
				if (user_id) return user_id;
				const id_user = url_content ? App.helper.parse_endpoint.user(url_content) : null;
				if (id_user === null) throw new Error('id_user is required');
				return id_user;
			},
			show: function(url_content, user_id) {

				const async_task = App.core.async_task.context('profile_loading');

				const id_user = self.modal.resolve_id_user(url_content, user_id);
				const profile_endpoint = App.helper.endpoint.user(id_user);

				App.bus.app.emit('profile_loading');

				async_task.ajax({
					url: App.helper.url.add_query(profile_endpoint, App.actions.get('sidebar_profile:show')),
					success: function (html_sidebar) {
						App.helper.nextTick(() => {
							async_task.ajax({
								url: url_content,
								success: function (html_content) {

									self.tab_url = url_content;
									self.close_alert_waits.tab_url = '';
									self.close_alert_waits.tab_el = null;

									let width = self.helper.calc_modal_width();

									App.modal.show({
										html: self.html,
										width,
										group: 'profile',
										onhide: function () {
											App.bus.app.emit('profile_closed');
											self.destructor();
										},
									});

									self.modal_obj = $('#modProfile').attr({
										'data-endpoint': profile_endpoint,
										'data-user': id_user,
									});
									self.modal_obj_content = $('#modProfileContent');
									self.modal_obj_sidebar = $('#modSidebar');
									self.modal_obj_sidebar.html(html_sidebar);
									self.loader = self.modal_obj.find('.profile__block__loader');
									self.helper.title($('#sidebar_profile .sidebar__menu .sidebar__menu__item').first(), url_content);
									self.helper.content(html_content);
									self.form.bind();
									if ($(window).width() <= APP_SCREEN_THRESHOLD) App.modal.obj_window.addClass('modal-fullscreen').css({top: ''});
									$(document).trigger('modal_onload.once').unbind('modal_onload.once');
									$(document).trigger('profile.tab.onload').unbind('profile.tab.onload');
									App.bus.app.emit('profile_loaded');
								}
							});
						});
					}
				});
			},
			reload: function() {
				if ( self.tab_url ) {
					self.sidebar.load(self.tab_url);
				}
			},
			confirm: function(el) {
				const title = el.getAttribute('data-confirm-title') || '';
				const text = el.getAttribute('data-confirm-text') || '';
				const script = el.getAttribute('data-confirm-script') || '';
				const colors = el.getAttribute('data-confirm-colors') || '';

				const variant = (colors === 'alert') ? 'w' : 'a';

				App.controls.confirm.menu(el.tagName === 'WS-BTN' ? el.querySelector('.btn') : el, {
					message: text,
					variant: variant,
					ok_label: App['locale_general']['confirm'],
					cancel_label: App['locale_general']['cancel'],
					onconfirm: function() {
						try {
							let fn = new Function(script);
							fn();
						} catch (e) {
							console.error('Confirm script execution error:', e);
						}
					}
				});
			},
		},
		sidebar: {
			email_edit: function (anchor, options) {
				const el = $(anchor);
				if (el.hasClass('muted')) return false;

				options = {
					can_edit: false,
					email: null,
					...options
				};

				const buttons = [];

				if (options.email) {
					buttons.push({
						left_icon: 'content_copy',
						text: App.object_state.locale['copy'],
						callback: function () {
							App.core.clipboard_from_menu(this, options.email);
						}
					});
				}

				if (options.can_edit) {
					buttons.push({
						text: App.object_state.locale['edit'],
						right_icon: 'edit',
						callback: function () {
							self.sidebar.goto_email_edit(el);
						}
					});
				}

				if (!buttons.length) return;

				el.addClass('active');
				App.controls.confirm.ask(el, buttons, 'left', {
					onhide: function () {
						el.removeClass('active');
					}
				});
			},
			goto_email_edit: function (anchor) {
				const el = $(anchor);
				self.sidebar.click(
					el.attr('data-tab-url'),
					$('#modSidebar .sidebar__menu').find('.sidebar__menu__item[data-type="contacts"]'),
					{
						callback: function() { $('#modProfileContent input[name=email]').select().focus(); }
					}
				);
			},
			click: function(url, el, params) {

				const options = {
					callback: null,
					id_user: null,
					...params
				};

				if (!self.is_shown) {
					if (options.callback) console.warn('callback not processed');
					App.menu.hide_all();
					self.modal.show(url, options.id_user);
					return;
				}

				App.menu.hide();
				if (App.controls.editblock.has_unsaved_updates()) {
					App.controls.editblock.show_close_alert();
					self.close_alert_waits.tab_url = url;
					self.close_alert_waits.tab_el = el;
				} else {
					self.close_alert_waits.tab_url = '';
					self.close_alert_waits.tab_el = null;
				}
				if (event?.type!=='contextmenu' && !App.controls.editblock.has_unsaved_updates()) {
					if (!$(el).hasClass('sidebar__menu__item-active') && !$(el).hasClass('sidebar__menu__item-disabled') && typeof url !== 'undefined') {
						$('#drop_choose_avamenu').remove();
						self.sidebar.load(url, el, options);
					}
				}
			},
			load: function (url, el, params) {
				if (App.offline_mode.is_on()) return;
				if (url === undefined) return;
				const options = {
					callback: null,
					...params
				};

				const async_task = App.core.async_task.context('profile_loading');

				/***** BEFORE SEND *****/
				self.loader.css({
					width: self.modal_obj_content.outerWidth(),
					height: self.modal_obj_content.outerHeight(),
					top: self.modal_obj.outerHeight() - self.modal_obj_content.outerHeight()
				});

				App.bus.app.emit('profile_loading');

				$(el).addClass('selected');
				self.loaderTimer = setTimeout(function() {
					self.loader.show();
				}, 500);

				/***** START AJAX *****/
				async_task.ajax({
					url: url,
					success: function (html_content) {
						self.tab_url = url;
						self.close_alert_waits.tab_url = '';
						self.close_alert_waits.tab_el = null;
						self.helper.clear_menu();
						self.helper.title(el);
						self.helper.content(html_content);
						self.form.bind();
						self.modal_obj_sidebar.find('.sidebar__head .email').toggleClass('muted', $(el).attr('data-type') === 'contacts');
						setTimeout(() => {
							$(document).trigger('modal_onload.once').unbind('modal_onload.once');
							$(document).trigger('profile.tab.onload').unbind('profile.tab.onload');
						}, 300);
						if (typeof options.callback === 'function') options.callback();
						App.bus.app.emit('profile_loaded');
					}
				}).finally(() => {
					clearTimeout(self.loaderTimer);
					if (async_task.is_idle()) self.loader.hide();
					$(el).removeClass('selected');
				});
			}
		},
		form: {
			load_state: {},

			save: function(action) {
				let button = self.modal_obj_header_submit_btn;
				if (!button.prop('disabled')) {

					try {

						// validate & submit
						new Function(action)();

						// skip if invalid
						if (!self.modal_obj.find('form:not(.form_autoSave)').is('[data-submitted=yes]')) {
							return;
						}
					} catch (error) {
						console.error('Error creating function from action string:', error);
					}

					self.form.load_state = {};
					self.helper.startLoader();
					self.helper.formSubmitToggle();
				}
			},
			bind: function () {
				self.is_shown = true;
				self.form.load_state = {};
				self.helper.formSubmitToggle();
				App.controls.form_autosave.init();
				let form = self.modal_obj.find('form:not(.form_autoSave)');
				self.modal_obj_content.on('click input keyup', ()=> self.helper.formSubmitToggle() );
				self.modal_obj_content.find('#userpic').on('DOMSubtreeModified', ()=> self.helper.formSubmitToggle() );
				self.modal_obj.find('.editBlock').removeClass('editBlock');
				if ( form.length && self.modal_obj_content.children('.inputBlock').length === 0 ) {
					const variant = self.modal_obj_header_submit_btn ? 'save' : 'leave';
					App.controls.editblock.init({
						variant,
						should_hide_modal: false
					});
				}
				if (self.modal_observer) self.modal_observer.disconnect();
				self.modal_observer = new MutationObserver(function (event) {
					if (App.modal.obj_window.hasClass('editBlock-initClose')) self.helper.alertOnShow();
				});
				self.modal_observer.observe(App.modal.obj_window[0], {
					attributes: true,
					attributeFilter: ['class'],
					childList: false,
					characterData: false
				});
			},
			get_state: function(form_id) {
				let f = $('form#' + form_id);
				let res = {};
				if (f.length) {
					f.find('input, select, textarea').each(function() {
						let name = $(this).attr('name');
						let value = $(this).val();
						if (value === undefined) value = '';
						if (name && name !== 'null') {
							if (name === 'ids_project') {
								res[name] = value.split(',');
							} else if (name.includes('[')) {
								if (!Array.isArray(res[name])) {
									res[name] = [];
								}
								if ( $(this).attr('type') === 'checkbox' ) {
									if ($(this).is(':checked')) res[name].push(value);
								} else {
									res[name].push(value);
								}
							} else {
								if ( $(this).attr('type') === 'checkbox' ) {
									value = $(this).is(':checked') ? '1' : '0';
								}
								res[name] = value;
							}
						}
					});
				}
				return res;
			}
		},
		helper: {
			content: function(html) {
				$('#modProfile .modal__header').addClass('modal__header-big').find('.quick_search-modal, .buttons, #modal__headerContent, .modal-head .mobile-head__btn').each(function () {
					$(this).data('placeholder')?.remove();
				}).remove();
				self.modal_obj_header_submit_btn = null;

				self.modal_obj_content.html(html);
				let btn = self.modal_obj_content.find('div.buttons');
				if (btn.length) {
					btn.hide();
					let btn_sb = $('<button>').attr('type', 'button').toggleDisabled(true).addClass('btn btn-a btn-solid btn-36 btn-ok').html('<span>'+App.object_state.locale.update+'</span>');
					self.modal_obj_header_submit_btn = btn_sb;
					let div_buttons = $('<div>').addClass('buttons').append(btn_sb);
					self.modal_obj.find('.modal__header > .flex_gap').after(div_buttons);
					let btnElement = btn.find('.btn-primary, [name*="btn-primary"]');
					let action = btnElement.attr('onclick') || btnElement.attr('button-onclick');
					if (action) {
						action = action.trim();
						if (!action.endsWith(';')) action += ';';
						if (!action.includes('return false')) action += ' return false;';
						btn_sb.attr('onclick', 'App.profile.form.save("'+action+'")');
					}
					self.modal_obj.find('.modal__header__controls').remove();
				}
				let header_def_btn = self.modal_obj_content.find('div.default_button');
				self.modal_obj.find('.default_button').remove();
				if (header_def_btn.length) {
					self.modal_obj.find('.modal__header > .flex_gap').after(header_def_btn);
				}
				if (self.modal_obj_content.find('.quick_search-modal').length) {
					self.modal_obj.find('.modal__header > .in').after(self.modal_obj_content.find('.quick_search-modal'));
				}
				if (self.modal_obj_content.find('#modal__headerContent').length) {
					self.modal_obj.find('.modal__header > .in').append(self.modal_obj_content.find('#modal__headerContent'));
				}
				if (self.modal_obj_content.find('#modal__headerContent__replace').length) {
					self.modal_obj.find('.modal__header > .in').html(self.modal_obj_content.find('#modal__headerContent__replace').html());
					self.modal_obj.find('#modal__headerContent__replace').remove();
				}
				if (self.modal_obj.find('.modal__title__search').length) {
					let mpt = $('#modal__headerContent');
					if (mpt.length) {
						$('.modal__header > .in').empty().append(mpt.contents());
						mpt.remove();
					}
					mpt.find('input').focus();
				}

				let dash_btn = self.modal_obj_content.find('ws-btn.dashboard_btn');
				if (dash_btn) {
					self.modal_obj.find('.modal__header .buttons').append(dash_btn);
				}

				self.helper.init_scroll_zones();
				self.helper.update_header_buttons();
				self.helper.add_mobile_header_bookmark_button_once();
				self.helper.process_sidebar_hints();
				self.helper.init_my_desktop_push();

				App.core.context.when('profile_desktop_notifications_locale', function (data) {
					App.profile.profile_desktop_notifications_locale = data;
				});

				App.core.context.when('profile_default_settings', function (data) {
					App.profile.default_settings = {
						...App.profile.default_settings,
						...data
					};
				});
			},
			init_my_desktop_push: function() {
				const setup_desktop_push = $('#profile_notify_main .setupBlock[data-key=desktop_push] .setupBlock__title-sub');
				if (setup_desktop_push.length === 0) return;

				let block = { text: '', action: '' };

				if (App.hybrid_app || App.device.is_mobile()) return;

				const locale = App.profile.profile_desktop_notifications_locale;

				if (App.integration.desktop.is_denied()) {
					block.text = App.object_state.locale.desktop_notifications.permit_denied;
				} else if (App.integration.desktop.config.subscribed_at) {
					block.text = locale?.subscribed_status?.text || 'You are subscribed on this device.';
					block.action = $('<ws-btn>', { name: 'btn btn-w btn-skeleton btn-24' });
					block.action.attr('text', locale?.subscribed_status?.action || 'Disable');
					block.action.on('click', function() {
						block.action.toggleDisabled(true);
						App.integration.desktop.unsubscribe();
					});
				} else if (App.integration.desktop.config.disabled_at) {
					block.text = locale?.unsubscribed_status?.text || 'Do you want to subscribe on this device';
					block.action = $('<ws-btn>', { name: 'btn btn-b btn-skeleton btn-24' });
					block.action.attr('text', locale?.unsubscribed_status?.action || 'Yes, turn-on');
					block.action.on('click', function() {
						block.action.toggleDisabled(true);
						App.integration.desktop.subscribe();
					});
				}

				setup_desktop_push.toggleClass('hiddenBlock', !block.text);
				setup_desktop_push.find('.in').text(block.text);
				setup_desktop_push.find('.action').html(block.action);
			},
			init_scroll_zones: function () {
				if (self.is_shown && App.modal.window.is_ready()) {
					self.helper._init_scroll_zones();
				}
			},
			_init_scroll_zones: function () {
				if (self.modal_obj_content == null) return;

				let scrollZone = self.modal_obj_content.find('.scrollZone').get(0);
				if (scrollZone == null) return;

				if (scrollZone && scrollZone.scrollBars) scrollZone.scrollBars.destroy();

				scrollZone = self.modal_obj_content.find('.scrollZone').get(0);
				if (scrollZone) {
					let ps = App.controls.js_scrollbars.init(scrollZone);

					let scrollPointer = $('<div class="scrollPointer"></div>');
					scrollPointer.append('<ws-icon name="arrows/chevron-down"></ws-icon>');
					$(scrollZone).after(scrollPointer);
					if (ps.contentHeight>ps.containerHeight) scrollPointer.addClass('scrollPointer-on');

					scrollZone.addEventListener('ps-scroll-up', function () {
						scrollPointer.addClass('scrollPointer-on');
					});
					scrollZone.addEventListener('ps-y-reach-end', function () {
						scrollPointer.removeClass('scrollPointer-on');
					});
					scrollZone.addEventListener('ps-scroll-down', function () {
						$(".modal__header, .modal__header > .in").css({cursor: 'n-resize'});
					});
					scrollZone.addEventListener('ps-y-reach-start', function () {
						$(".modal__header, .modal__header > .in").css({cursor: 'initial'});
					});
					scrollPointer.click(function () {
						if (scrollPointer.hasClass('scrollPointer-on')) {
							App.controls.js_scrollbars.waitSmoothScrolling(ps);
							scrollZone.scrollTo({top: scrollZone.scrollHeight, behavior: 'smooth'});
						}
					});
					$(".modal__header, .modal__header > .in").on("click", function (event) {
						// If the clicked element is the same as the one listening for the click event
						if (event.target === this ) {
							App.controls.js_scrollbars.waitSmoothScrolling(ps);
							scrollZone.scrollTo({top: 0, behavior: 'smooth'});
						}
					});
					scrollZone.scrollBars = ps;
					App.scroll_listener.onDivScroll.call(scrollZone);
				}
			},
			add_header_bookmark_button_once: function () {

				$header = self.modal_obj.find('.modal__header');
				if ($header.find('.bookmark').length) return;

				const is_active = self.modal_obj_sidebar.find('.bookmark').hasClass('bookmark-active');

				const id_user = +self.modal_obj.attr('data-user');
				const $btn = $('<a/>', {
					"class": `btn btn-g btn-plain bookmark bookmark-withIcon${is_active ? ' bookmark-active' : ''}`,
					"data-user": id_user,
				});
				$btn.html('<ws-icon name="star:star-solid"></ws-icon>');
				$header.children('.flex_gap').before($btn);
			},
			add_mobile_header_bookmark_button_once: function () {

				$header = self.modal_obj.find('.mobile-head');
				if ($header.find('.bookmark').length) return;

				const $btn_container = $('<div class="mobile-head__btn"></div>');
				$header.find('.mobile-head__title').after($btn_container);

				const is_active = self.modal_obj_sidebar.find('.bookmark').hasClass('bookmark-active');

				const id_user = +self.modal_obj.attr('data-user');
				const $btn = $('<a/>', {
					"class": `btn btn-g btn-plain bookmark bookmark-withIcon${is_active ? ' bookmark-active' : ''}`,
					"data-user": id_user,
				});
				$btn.html('<ws-icon name="star:star-solid" class="btn-left-icon"></ws-icon>');
				$btn_container.html($btn);
			},
			update_header_buttons: function () {

				const $header = self.modal_obj.find('.modal__header');
				const selectors = [
					'.buttons',
					'#modal__headerContent',
					'.default_button',
				];

				selectors.forEach(selector => {

					const $el = $header.find(selector);
					if (!$el.length) return;

					if ($(window).width() <= APP_SCREEN_THRESHOLD) {
						if ($el.data('placeholder')) return;
						const placeholder = document.createComment('placeholder ' + selector);
						$el.after(placeholder);
						$el.data('placeholder', placeholder);
						self.helper.append_mobile_header_btn($el);

						$el.find('ws-btn').not($el.find('.user_workday_adjustDate ws-btn')).each(function () {
							$(this).ws_btn('set_size', function (index, size, element) {

								// не змінювати/не кешувати другий раз
								if ($(element).data('ws-btn-cache-size-profile') !== undefined) {
									return false;
								}

								// кешуємо, щоб потім можна було повернути оригінальний розмір
								$(element).data('ws-btn-cache-size-profile', size);

								// новий розмір
								return 32;
							});
						});

						$el.children('.btn').removeClass('btn-36').addClass('btn-32');
					} else {
						if (!$el.data('placeholder')) return;
						const placeholder = $el.data('placeholder');
						$(placeholder).replaceWith($el);
						$el.removeData('placeholder');

						$el.find('ws-btn').not($el.find('.user_workday_adjustDate ws-btn')).each(function () {
							$(this).ws_btn('set_size', function (index, size, element) {

								// restore size from data-attr
								if ($(element).data('ws-btn-cache-size-profile') !== undefined) {
									const prev_size = $(element).data('ws-btn-cache-size-profile')
									$(element).removeData('ws-btn-cache-size-profile');
									return prev_size;
								}

								return false; // no change
							});
						});
						$el.children('.btn').removeClass('btn-32').addClass('btn-36');
					}
				});
			},
			add_mobile_header_once: function() {

				$header = self.modal_obj.find('.modal__header');
				if ($header.find('.mobile-head').length) return;

				const $mobile_head = $(self.mobile_header_html);
				const $avatar = $mobile_head.find('.mobile-head__ava-btn a');

				const avatar_html = App.helper.team(self.modal_obj.attr('data-user'), 'avatar');
				$avatar.html(avatar_html);

				$mobile_head.find('.mobile-head__dropdown').add($avatar).on('click', function () {
					self.show_menu(this, {
						url: App.helper.url.add_query(self.modal_obj.attr('data-endpoint'), App.actions.get('sidebar_profile:menu')),
					});
				});

				$header.prepend($mobile_head);
			},
			append_mobile_header_btn: function (content) {

				$header = self.modal_obj.find('.modal__header');

				const append_btn_container_once = () => {
					if ($header.find('.mobile-head__btn.buttonsWrapper').length) return $header.find('.mobile-head__btn.buttonsWrapper');

					const $btn_container = $('<div class="mobile-head__btn buttonsWrapper"></div>');
					$header.find('.mobile-head .mobile-head__content').append($btn_container);

					return $btn_container;
				};

				const $btn_container = append_btn_container_once();

				$btn_container.append(content);
			},
			title: function(el, action) {

				$('.modal__header').detach().prependTo(self.modal_obj);

				self.helper.add_mobile_header_once();
				self.helper.add_header_bookmark_button_once();

				const active_item = self.helper.set_active_item(el, action);
				const title_text = $(active_item).find('span.in').html();

				self.modal_obj.find('.modal__header > .in').html(title_text);
				self.modal_obj.find('.mobile-head__dropdown > .in').html(title_text);
			},
			set_active_item: function(el, action) {
				$('#sidebar_profile .sidebar__menu').find('.sidebar__menu__item-active').removeClass('sidebar__menu__item-active');
				if (action !== undefined) {
					if (typeof action==='string') {
						if (action.indexOf('?action=') > 0) {
							const regex = /\?action=(\w+[:&].+)/gm;
							const res = regex.exec(action);
							if (res && res[1]) action = res[1];
						}
						el = $('#sidebar_profile .sidebar__menu .sidebar__menu__item[onclick*="' + action + '"]');
					}
				}

				if ($(el).is('.btn')) {
					self.current_onclick = $(el).attr('onclick');
					el = $('#sidebar_profile .sidebar__menu').find('.sidebar__menu__item[onclick="'+CSS.escape(self.current_onclick)+'"]');
				}

				if ($(el).length) {
					self.current_onclick = $(el).attr('onclick');
					$(el).addClass('sidebar__menu__item-active');
				}

				return el;
			},

			isLoading: function() {

				const button = self.modal_obj_header_submit_btn;
				if (!button) return false;

				return button.first().ws_loading('is_loading');
			},
			startLoader: function() {

				const button = self.modal_obj_header_submit_btn;

				// може додати опцій для стилю лоадера
				// бо раніше було .withLoader-white
				button.ws_loading('start');

				// по хорошому це треба викликати тільки в response
				// поки залишу, вдруг десь пропустив
				button.ws_loading('stop', {
					min_display_time: 10000,
					callback: () => {
						self.helper.formSubmitToggle();
					}
				});
			},
			stopLoader: function(callback) {
				const button = self.modal_obj_header_submit_btn;

				if (!self.helper.isLoading()) {
					if (typeof callback === 'function') {
						callback.call(button);
					}
					return;
				}

				button.ws_loading('stop', {
					min_display_time: 1000,
					callback: function () {
						if (self.is_shown) self.helper.formSubmitToggle();
						if (typeof callback === 'function') {
							callback.call(button);
						}
					}
				});
			},

			social_switch: function(social) {
				let el = $('.jsButton__'+social);
				if (el.length) el.toggleClass('hiddenBlock');
			},
			fid: function() {
				return 'fid_'+Math.random().toString(36).substr(2, 9);
			},
			formSubmitToggle: function() {

				if (!self.is_shown) return;

				let btn_sb = self.modal_obj_header_submit_btn;
				let formChanged = false;
				let form = self.modal_obj.find('form:not(.form_autoSave)');
				let formLoading = self.helper.isLoading();
				if ( Object.keys(self.form.load_state).length === 0) {
					if (form) {
						form.each(function() {
							if (!$(this).attr('id')) $(this).attr('id', self.helper.fid());
							self.form.load_state[$(this).attr('id')] = self.form.get_state($(this).attr('id'));
						});
					}
				}
				if (form) {
					form.each(function() {
						let form_id = $(this).attr('id');
						let currentFormState = self.form.get_state(form_id);

						if (formChanged === false && !form.hasClass('frm_unchanged')) {
							$.each(self.form.load_state[form_id], function(i, v) {
								if (Array.isArray(v)) {
									if (!self.helper.arraysEqual(currentFormState[i], v)) {
										formChanged = true;
										return false;
									}
								} else {
									if (currentFormState[i] !== v && currentFormState[i] !== undefined) {
										formChanged = true;
										return false;
									}
								}
							});

							$.each(currentFormState, function(i, v) {
								if (self.form.load_state[form_id][i] === undefined && v !== '') {
									formChanged = true;
									return false;
								}
							});
						}
					});
				}

				if (btn_sb) btn_sb.closest('.modal__header').toggleClass('withButtons', formChanged || formLoading);

				$('#profile_hacks_main .inputCheckbox').each(function () {
					const checkbox = $(this).find('input[type=checkbox]');
					const is_checked = checkbox.is(':checked');
					const button = $(this).parent().find('button');

					button
						.toggleClass('btn-a', is_checked)
						.toggleClass('btn-g', !is_checked)
						.prop('disabled', !is_checked);
				});


				if ( formChanged ) {
					App.controls.editblock.set_updated_state(true);
					if (!formLoading) {
						if (btn_sb) btn_sb.toggleDisabled(false).show();
					}
				} else {
					App.controls.editblock.set_updated_state(false);
					if (!formLoading) {
						if (btn_sb) btn_sb.toggleDisabled(true).hide();
					}
				}
			},
			passFieldToggle: function(el) {
				if (el.length) {
					el.attr('type') === 'text' ? el.prop('type', 'password') : el.prop('type', 'text');
				}
				event.preventDefault(); return false;
			},
			passCheck: function(el) {
				let matchedCase = [];
				let form = el.closest('form')[0];
				let val = el.val();
				let labelText = el.parent().find('.label').eq(0).contents().filter(function() { return this.nodeType === Node.TEXT_NODE; }).text().trim();

				matchedCase.push("[$@$!%*#?&]"); // Special Charector
				matchedCase.push("[A-ZА-Я]");      // Uppercase Alpabates
				matchedCase.push("[0-9]");      // Numbers
				matchedCase.push("[a-zа-я]");     // Lowercase Alphabates

				// Check the conditions
				let ctr = 0;
				for (let i = 0; i < matchedCase.length; i++) {
					if (new RegExp(matchedCase[i]).test(val)) ctr++;
				}
				if (ctr >= 3 && val.length >= 6) {
					el.attr('data-ok', 'yes').attr('data-password', 'strong').parent().find('.label').html(labelText + '<i> ~ ' + App.object_state.locale.password['strong'] +'</i>');
				} else if (val.length >= 6) {
					el.attr('data-ok', 'yes').attr('data-password', 'medium').parent().find('.label').html(labelText + '<i> ~ ' + App.object_state.locale.password['average'] +'</i>');
				} else if (val.length >= 1) {
					el.removeAttr('data-ok').attr('data-password', 'week').parent().find('.label').html(labelText + '<i> ~ ' + App.object_state.locale.password['weak'] +'</i>');
				} else {
					el.removeAttr('data-ok').attr('data-password', '').parent().find('.label').html(labelText);
				}
			},
			alertOnShow: function() {

				const on_close = function () {
					if (self.close_alert_waits.tab_url) {
						self.sidebar.load(self.close_alert_waits.tab_url, self.close_alert_waits.tab_el);
					} else {
						App.modal.hide({ force: true });
					}
				}

				App.controls.editblock
					.on('ok', function () {
						// перехід треба тільки якщо variant == save
						if (self.modal_obj_header_submit_btn) {
							self.modal_obj_header_submit_btn.click();
							on_close();
						}
					})
					.on('cancel', function () {
						if (self.modal_obj_header_submit_btn) {
							self.modal_obj.find('.modal__header').removeClass('withButtons');
							self.modal_obj_header_submit_btn.hide();
						}
						on_close();
					})
			},
			setDefaults: function(type) {
				let defs;
				if (self.default_settings.hasOwnProperty(type)) {
					defs = self.default_settings[type];
				} else {
					return;
				}
				switch (type) {
					case 'notifications':
						$.each(defs, function(key, value) {
							const checkboxes = $(self.modal_obj_content).find('.setupBlock__notify input[type=checkbox]').filter('[name="' + key + '[]"]');
							checkboxes.prop('checked', false);
							$.each(value.split(''), function(index, char) {
								checkboxes.filter('[value="' + char + '"]').prop('checked', true);
							});
							$(self.modal_obj_content).find('.setupBlock__notify').closest('form').addClass('form_autoSave-changed').trigger('change');
						});
						$('#defB1').attr('name', function(i, nameAttr) { return nameAttr+' btn-hide'; });
					break;
					case 'notif_options':
						$.each(defs, function(key, value) {
							const checkboxes = $(self.modal_obj_content).find('#user_profile_notif_options input[type=checkbox]').filter('[name="' + key + '"]');
							checkboxes.prop('checked', value === '1');
							$(self.modal_obj_content).find('#user_profile_notif_options').closest('form').addClass('form_autoSave-changed').trigger('change');
						});
						$('#defB2').attr('name', function(i, nameAttr) { return nameAttr+' btn-hide'; });
					break;
					case 'privacy_options':
						$.each(defs, function(key, value) {
							let el;
							let menu_inp = $(self.modal_obj_content).find('#user_profile_privacy_defs1 input[type=hidden]').filter('[name="' + key + '"]');
							if (menu_inp.length) {
								let menu = menu_inp.parent().attr('onclick').match(/box:\s*'([^']+)'/);
								if (menu !== null) el = menu[1];
								if (el) {
									App.menu.active_anchor = menu_inp.parent();
									$(el).find('a[data-set-value="' + value + '"]').click();
								}
							}
						});
						$('#defB1').attr('name', function(i, nameAttr) { return nameAttr+' btn-hide'; });
					break;
					case 'other_options':
						$.each(defs, function(key, value) {
							let el;
							const checkboxes = $(self.modal_obj_content).find('#profile_hacks_main input[type=checkbox]').filter('[name="' + key + '"]');
							checkboxes.prop('checked', value !== '0');
							let menu_inp = $(self.modal_obj_content).find('#profile_hacks_main input[type=hidden]').filter('[name="' + key + '"]');
							if (menu_inp.length) {
								if (menu_inp.parent().is('ws-slider')) {
									menu_inp.parent().attr('value', value);
								} else {
									let menu = menu_inp.parent().attr('onclick').match(/box:\s*'([^']+)'/);
									if (menu !== null) el = menu[1];
									if (el) {
										App.menu.active_anchor = menu_inp.parent();
										$(el).find('a[data-set-value="' + value + '"]').trigger('click');
									}
								}
							}
						});
						$('#defB1').attr('name', function(i, nameAttr) { return nameAttr+' btn-hide'; });
						$(self.modal_obj_content).find('#profile_hacks_main form').addClass('form_autoSave-changed').trigger('change');
						break;
				}
			},

			birthday_date_select: function(el) {
				let day;
				let month;
				let text = $(el).find('span').text();
				let type = isNaN(text) ? 'month' : 'day';
				if ($(el).hasClass('menu__item-delete')) type = 'clear';
				let anchor = $(App.menu.active_anchor);
				let result = '';
				if (type === 'day') {
					day = $(el).attr('rel').padStart(2, '0');
					month = anchor.attr('data-value').slice(0, 2);
					$(App.menu.active_box).find('.chech_links .menu__item').removeClass('menu__item-active');
					$(el).addClass('menu__item-active');
				} else if (type === 'month') {
					day = anchor.attr('data-value').slice(-2);
					month = $(el).attr('rel').padStart(2, '0');
					let monthNum = parseInt(month, 10);
					$(App.menu.active_box).find('.menu-birthday-right-col .menu__item').removeClass('menu__item-active');
					$(el).addClass('menu__item-active');
					let last_day = new Date(2023, month, 0).getDate();
					if (monthNum === 2) last_day = 29;
					$(App.menu.active_box).find('.menu__item').each(function() {
						let relValue = parseInt($(this).attr('rel'), 10);
						if (relValue > last_day) {
							$(this).addClass('menu__item-disabled').removeClass('menu__item-active');
						} else {
							$(this).removeClass('menu__item-disabled');
						}
					});
					if (day>last_day) {
						day = last_day;
						$(App.menu.active_box).find('.chech_links .menu__item[rel='+last_day+']').trigger('click');
					}
				}

				if (type === 'clear') {
					anchor.attr('data-value', '0000').find('input').val('0000');
					anchor.find('[rel=day]').html('--');
					anchor.find('[rel=month]').html('---');
					$(App.menu.active_box).find('a.menu__item').removeClass('menu__item-active').removeClass('menu__item-disabled');
					App.menu.hide();
					self.modal_obj_content.trigger('click');
				} else {
					if (day === '00') day = '--';
					result = String(month+day);
					anchor.attr('data-value', result).find('input').val(result);
					anchor.find('[rel=day]').html(day);
					anchor.find('[rel=month]').html($(App.menu.active_box).find('.menu-birthday-right-col .menu__item-active').attr('data-short'));
					if (day !== '--' && month !== '00') {
						App.menu.hide();
						self.modal_obj_content.trigger('click');
					}
				}
			},

			birthday_date_check: function() {
				let bd = $('input[name=datebirth]');
				let bd_val = bd.val();
				if (!/^\d+$/.test(bd_val)) bd.val(bd.attr('data-def'));
			},
			init_schedule_modal: function () {
				// let btn = App.modal.obj_window.find('div.buttons');
				// if (btn.length) {
				// 	App.modal.obj_window.find('.modal__header > .in').after(btn);
				// }
			},
			arraysEqual: function(arr1, arr2) {
				if (arr1.length !== arr2.length) return false;

				arr1 = arr1.slice().sort();
				arr2 = arr2.slice().sort();

				for (let i = 0; i < arr1.length; i++) {
					if (arr1[i] !== arr2[i]) return false;
				}
				return true;
			},
			clear_menu: function () {
				$('#menuContainer .menu').each(function(){
					let menu = $(this);
					if (!menu.hasClass('menu-alwaysRemain') && !menu.parents().hasClass('menu-alwaysRemain')) menu.detach();
				});
			},

			calc_modal_width: function () {
				let width = 880;
				// if (App.device.is_mobile()) {
				// 	#modProfileContent > * { max-width: 640px; }
				// 	width = 640;
				// }
				if ($(window).width() <= PROFILE_THRESHOLD) {
					// ширина сайдбара була 240, стала 80. Diff: 160
					width = 880 - 160;
					if ($(window).width() <= (640 + 80 + 16)) {
						width = $(window).width() - 16;
					}
				}

				return width;
			},

			process_sidebar_hints: function () {
				if ($(window).width() <= PROFILE_THRESHOLD) {
					self.modal_obj_sidebar.find('.sidebar__menu__item').attr('data-title-config', 'right_arrow');
					self.modal_obj_sidebar.find('.sidebar__menu__item').attr('data-title', function (index, attr) {
						return $(this).children('.in').text();
					});
				} else {
					self.modal_obj_sidebar.find('.sidebar__menu__item').removeAttr('data-title data-title-config');
				}
			},
		},

		destructor: function () {

			const async_task = App.core.async_task.context('profile_loading');
			async_task.abort();

			self.is_shown = false;
			self.tab_url = '';
			self.close_alert_waits.tab_url = '';
			self.close_alert_waits.tab_el = null;
			self.modal_obj = {};
			self.modal_obj_content = {};
			self.modal_obj_sidebar = {};
			self.modal_obj_header_submit_btn = null;
			self.loader = {};
			self.current_onclick = null;

			App.integration.viber.destructor();
			App.integration.telegram.destructor();

			if (self.modal_observer) self.modal_observer.disconnect();
			self.modal_observer = null;
		},

		onresize: function () {
			if (!self.is_shown) return;

			self.helper.update_header_buttons();
			self.helper.process_sidebar_hints();

			/* update width */
			if (App.device.is_mobile()) return;
			App.modal.width = self.helper.calc_modal_width();
		},

		onBoot: function () {
			App.bus.app.on('menu_unload', function () {
				if (self.is_shown) setTimeout(() => self.helper.formSubmitToggle(), 300);
			});

			App.bus.window.on('resize', App.helper.throttle(self.onresize));

			App.bus.app.on('desktop_push_updated', function () {
				App.profile.helper.init_my_desktop_push();
			});

			App.bus.app.on('modal_ready', function () {
				self.helper.init_scroll_zones();
			});

			App.bus.state.on('user_update', function({id, data}) {
				if (!self.is_shown_user(id)) return;
				self.modal_obj_sidebar.find('.email > span').text(data.email);
			});
		}
	}
})();

;var App = App || {};

(function() {
	let self = App.project_copy = {

		init: function() {
			self.virtual_list.init();
		},

		helper: {
			checkbox_level1: function(input) {
				self.virtual_list.on_checkbox(input);
				// const id_task = $(input).closest('.modal__dataTable__item').attr('data-id-task');
				// if (input.checked) {
				// 	$('.modal__dataTable-onCopy input[data-task='+id_task+']').toggleDisabled(false).parent().removeClass('label_dis');
				// } else {
				// 	$('.modal__dataTable-onCopy input[data-task='+id_task+']').prop('checked', false).toggleDisabled(true).parent().removeClass('act').addClass('label_dis').parent().removeClass('pre_act');
				// }
			},

			checkbox_level2: function(input) {
				self.virtual_list.on_checkbox(input);
				// const id_task = $(input).closest('.modal__dataTable__item').attr('data-id-task');
				// if (input.checked) {
				// 	$('.modal__dataTable-onCopy input[data-subtask='+id_task+']').toggleDisabled(false).parent().removeClass('label_dis');
				// } else {
				// 	$('#modal_tasks_all').prop('checked', false).parent().removeClass('act');
				// 	$('.modal__dataTable-onCopy input[data-subtask='+id_task+']').prop('checked', false).toggleDisabled(true).parent().removeClass('act').addClass('label_dis').parent().removeClass('pre_act');
				// }
			},

			checkbox_level3: function (input) {
				self.virtual_list.on_checkbox(input);
				// const id_task = $(input).closest('.modal__dataTable__item').attr('data-id-task');
				// if (input.checked) return;
				// $('#modal_tasks_all').prop('checked', false).parent().removeClass('act');
			},

			checkbox_subtsaks_copy: function (input) {
				self.virtual_list.on_checkbox_subtasks_copy(input);
				// if(input.checked) {
				// 	$('.modal__dataTable-onCopy .modal__dataTable__item-child label input').not('[disabled]').prop('checked', true).toggleDisabled(false).parent().addClass('act').parent().addClass('pre_act');
				// } else {
				// 	$('.modal__dataTable-onCopy .modal__dataTable__item-child label input').not('[disabled]').prop('checked', false).parent().removeClass('act').parent().removeClass('pre_act');
				// 	$('.modal__dataTable-onCopy input[rel^=st]').toggleDisabled(true);
				// }
			},

			set_state_checkbox_subtsaks_copy: function (state) {
				$('#modal_tasks_all').prop('checked', Boolean(state)).parent().removeClass('act');
			},

			form_submit: function (btn) {
				const fragment = document.createDocumentFragment();
				const create_input = (name, value) => {
					const input = document.createElement('input');
					input.type = 'hidden';
					input.name = name;
					input.value = value;
					input.classList.add('js-virtual-list-dynamic-input');
					return input;
				};

				btn.form.querySelectorAll('.js-virtual-list-dynamic-input').forEach(el => el.remove());

				self.virtual_list.dataMap.forEach((data, id_task) => {
					if (!data.checked) return;
					fragment.appendChild(create_input(`is_task_to[${id_task}]`, 1));
					if (data.name !== '') {
						fragment.appendChild(create_input(`name[${id_task}]`, data.name));
					}
					if (data.id_user_to !== '') {
						fragment.appendChild(create_input(`id_user_to[${id_task}]`, data.id_user_to));
					}
					if (data.dateend !== '') {
						fragment.appendChild(create_input(`dateend[${id_task}]`, data.dateend));
					}
				});

				btn.form.appendChild(fragment);

				App.core.form_submit(btn.form, null, function (xhr, body) {
					if (xhr.status === 422) {
						const errors = JSON.parse(body)?.errors ?? {};
						if (errors.project_name) $(btn.form.elements.project_name).closest('.editBlock__input').animate_css('head-shake');
						App.message.validation(errors);
						return true;
					}
				});
			}
		},

		virtual_list: {
			dataMap: new Map(),
			parentMap: new Map(),
			childrenMap: new Map(),
			visibleItemsMap: new Map(),

			init: function(options) {

				const {
					container: CONTAINER_SELECTOR,
					item: ITEM_SELECTOR,
					itemHeight: ITEM_HEIGHT,
					buffer: BUFFER,
				} = {
					container: '.modal__dataTable',
					item: '.modal__dataTable__item',
					itemHeight: 40,
					buffer: 10,
					...options
				};

				const container = document.querySelector(CONTAINER_SELECTOR);
				if (!container) return;

				const allItems = Array.from(container.querySelectorAll(ITEM_SELECTOR));

				const dataMap = self.virtual_list.dataMap;
				const parentMap = self.virtual_list.parentMap;
				const childrenMap = self.virtual_list.childrenMap;
				const renderItem = self.virtual_list.render_item;
				const visibleItemsMap = self.virtual_list.visibleItemsMap;
				const addVisibleItem = (item) => {
					if (item.dataset.idTask === undefined) return;
					const id_task = Number(item.dataset.idTask);
					let items = visibleItemsMap.get(id_task);
					if (!items) {
						items = new Set();
						visibleItemsMap.set(id_task, items);
					}
					items.add(item);
				};
				const removeVisibleItem = (item) => {
					if (item.dataset.idTask === undefined) return;
					const id_task = Number(item.dataset.idTask);
					const items = visibleItemsMap.get(id_task);
					if (!items) return;
					items.delete(item);
				};

				dataMap.clear();
				parentMap.clear();
				childrenMap.clear();
				visibleItemsMap.clear();

				allItems.forEach(el => {
					const id_task = Number(el.dataset.idTask);
					if (!id_task) return; // скіпаємо пустишки для тестування
					const id_task_parent = el.dataset.idTaskParent !== undefined ? Number(el.dataset.idTaskParent) : null;

					const checked = el.querySelector('.inputCheckbox input')?.checked ?? false;
					const id_user_to = el.querySelector('.td_user input').value;
					const dateend = el.querySelector('.td_term1 input').value;
					dataMap.set(id_task, {
						checked: checked,
						name: '',
						id_user_to: id_user_to !== '' ? Number(id_user_to) : '',
						dateend: dateend,
						terms2: '',
					});

					if (id_task_parent !== null) {
						parentMap.set(id_task, id_task_parent);
						let children = childrenMap.get(id_task_parent);
						if (!children) {
							children = new Set();
							childrenMap.set(id_task_parent, children);
						}
						children.add(id_task);
					}
				});

				const spacer = document.createElement('div');
				const content = document.createElement('div');

				spacer.className = 'vlist__spacer';
				content.className = 'vlist__content';

				container.innerHTML = '';
				container.appendChild(spacer);
				container.appendChild(content);

				spacer.style.height = (allItems.length * ITEM_HEIGHT) + 'px';

				let start = 0;
				let end = 0;

				const setRange = function (newStart, newEnd) {

					// якщо це перший рендер
					if (end === 0 && content.childNodes.length === 0) {
						const fragment = document.createDocumentFragment();
						for (let i = newStart; i < newEnd; i++) {
							addVisibleItem(allItems[i]);
							fragment.appendChild(allItems[i]);
						}
						content.appendChild(fragment);
						start = newStart;
						end = newEnd;
						return;
					}

					// додаємо вверх
					while (newStart < start) {
						start--;
						const item = renderItem(allItems[start]);
						addVisibleItem(item);
						content.insertBefore(item, content.firstChild);
					}

					// додаємо вниз
					while (end < newEnd) {
						const item = renderItem(allItems[end]);
						addVisibleItem(item);
						content.appendChild(item);
						end++;
					}

					// прибираємо зверху
					while (start < newStart) {
						const item = content.firstChild;
						removeVisibleItem(item);
						content.removeChild(item);
						start++;
					}

					// прибираємо знизу
					while (end > newEnd) {
						const item = content.lastChild;
						removeVisibleItem(item);
						content.removeChild(item);
						end--;
					}
				};

				const update = function (scrollTop) {

					const viewport = container.clientHeight;

					const newStart = Math.max(0,
						Math.floor(scrollTop / ITEM_HEIGHT) - BUFFER
					);

					const newEnd = Math.min(allItems.length,
						Math.ceil((scrollTop + viewport) / ITEM_HEIGHT) + BUFFER
					);

					if (end !== 0 && Math.abs(newStart - start) < 2) return;

					setRange(newStart, newEnd);

					content.style.transform =
						`translateY(${newStart * ITEM_HEIGHT}px)`;
				};

				container.addEventListener('scroll', App.helper.raf_throttle(() => {
					update(container.scrollTop);
				}));

				// init
				update(0);
			},

			render_item: function(item) {
				if (item.dataset.idTask === undefined) return item;
				const id_task = Number(item.dataset.idTask);
				const data = self.virtual_list.dataMap.get(id_task);
				self.virtual_list.render_checkbox(item, id_task, data);
				self.virtual_list.render_name(item, id_task, data);
				self.virtual_list.render_user(item, id_task, data);
				self.virtual_list.render_terms(item, id_task, data);
				self.virtual_list.render_terms2(item, id_task, data);
				return item;
			},

			render_checkbox: function(item, id_task, data) {
				if (id_task === undefined) id_task = Number(item.dataset.idTask);
				if (data === undefined) data = self.virtual_list.dataMap.get(id_task);
				const checkbox = item.querySelector('input[type="checkbox"]');
				checkbox.checked = data.checked;
				checkbox.disabled = self.virtual_list.is_disabled(id_task);
				const inputCheckboxClassList = item.querySelector('.inputCheckbox').classList;
				inputCheckboxClassList.toggle('act', checkbox.checked);
				inputCheckboxClassList.toggle('label_dis', checkbox.disabled);
			},

			render_name: function(item, id_task, data) {
				if (id_task === undefined) id_task = Number(item.dataset.idTask);
				if (data === undefined) data = self.virtual_list.dataMap.get(id_task);
				if (data.name === '') return;
				const td = item.querySelector('.td_name');
				const onch = td.querySelector('.onch');
				if (onch) onch.textContent = data.name;
			},

			render_user: function(item, id_task, data) {
				if (id_task === undefined) id_task = Number(item.dataset.idTask);
				if (data === undefined) data = self.virtual_list.dataMap.get(id_task);
				if (data.id_user_to === '') return;
				const td = item.querySelector('.td_user');
				td.querySelector('input').value = data.id_user_to;
				td.querySelector('a').dataset.title = App.helper.team(data.id_user_to, 'name');
				td.querySelector('a').innerHTML = App.helper.team(data.id_user_to, 'avatar');
			},

			render_terms: function(item, id_task, data) {
				if (id_task === undefined) id_task = Number(item.dataset.idTask);
				if (data === undefined) data = self.virtual_list.dataMap.get(id_task);
				if (data.dateend === '') return;
				const td = item.querySelector('.td_term1');
				td.querySelector('input').value = data.dateend;
				td.querySelector('.onch').textContent = data.dateend;
			},

			render_terms2: function(item, id_task, data) {
				if (id_task === undefined) id_task = Number(item.dataset.idTask);
				if (data === undefined) data = self.virtual_list.dataMap.get(id_task);
				if (data.terms2 === '') return;
				const td = item.querySelector('.td_term2');
				td.textContent = data.terms2;
			},

			render_items_by_id: function(id_task, fn) {
				const currentVisibleItems = self.virtual_list.visibleItemsMap.get(id_task);
				if (currentVisibleItems) {
					currentVisibleItems.forEach(item => {
						if (typeof fn === 'function') {
							fn(item);
						} else {
							self.virtual_list.render_item(item);
						}
					});
				}
			},

			/**
			 * @param {HTMLInputElement} input
			 */
			on_checkbox_subtasks_copy: function (input) {
				if (!input.checked) {
					self.virtual_list.parentMap.forEach((id_task_parent, id_task) => {
						self.virtual_list.dataMap.set(id_task, {...self.virtual_list.dataMap.get(id_task), checked: false});
						self.virtual_list.render_items_by_id(id_task, self.virtual_list.render_checkbox);
					});
				} else {
					self.virtual_list.parentMap.forEach((id_task_parent, id_task) => {
						if (self.virtual_list.dataMap.get(id_task_parent).checked) {
							self.virtual_list.dataMap.set(id_task, {...self.virtual_list.dataMap.get(id_task), checked: true});
							self.virtual_list.render_items_by_id(id_task, self.virtual_list.render_checkbox);
						}
					});
				}
			},

			/**
			 * @param {HTMLInputElement} input
			 */
			on_checkbox: function(input) {
				const id_task = Number(input.closest('.modal__dataTable__item').dataset.idTask);
				const state = input.checked;
				const dataMap = self.virtual_list.dataMap;
				const childrenMap = self.virtual_list.childrenMap;
				const parentMap = self.virtual_list.parentMap;
				const data = dataMap.get(id_task);

				const stack = [id_task];
				let process;

				if (!state) {
					const is_child = parentMap.get(id_task) !== undefined;
					if (is_child) {
						self.helper.set_state_checkbox_subtsaks_copy(false);
					}
					process = (current) => {
						dataMap.set(current, {...data, checked: state});
						self.virtual_list.render_items_by_id(current, self.virtual_list.render_checkbox);
					};
				} else {
					dataMap.set(id_task, {...data, checked: state});
					process = (current) => {
						self.virtual_list.render_items_by_id(current,  self.virtual_list.render_checkbox);
					};
				}

				while (stack.length) {
					const current = stack.pop();

					process(current);

					const children = childrenMap.get(current);
					if (children) {
						for (const child of children) {
							stack.push(child);
						}
					}
				}
			},

			/**
			 * @param {HTMLInputElement} input
			 */
			on_name: function(input) {
				const id_task = Number(input.closest('.modal__dataTable__item').dataset.idTask);
				const data = self.virtual_list.dataMap.get(id_task);
				self.virtual_list.dataMap.set(id_task, {...data, name: input.value});
				self.virtual_list.render_items_by_id(id_task, self.virtual_list.render_name);
			},

			/**
			 * @param {HTMLInputElement} input
			 */
			on_user: function(input) {
				const id_task = Number(input.closest('.modal__dataTable__item').dataset.idTask);
				const data = self.virtual_list.dataMap.get(id_task);
				self.virtual_list.dataMap.set(id_task, {...data, id_user_to: input.value});
				self.virtual_list.render_items_by_id(id_task, self.virtual_list.render_user);
			},

			/**
			 * @param {HTMLInputElement} input
			 */
			on_terms: function(input) {
				const id_task = Number(input.closest('.modal__dataTable__item').dataset.idTask);
				const data = self.virtual_list.dataMap.get(id_task);
				self.virtual_list.dataMap.set(id_task, {...data, dateend: input.value});
				self.virtual_list.render_items_by_id(id_task, self.virtual_list.render_terms);
			},

			/**
			 * @param {HTMLElement} el
			 */
			on_terms2: function(el) {
				const id_task = Number(el.closest('.modal__dataTable__item').dataset.idTask);
				const data = self.virtual_list.dataMap.get(id_task);
				self.virtual_list.dataMap.set(id_task, {...data, terms2: el.textContent});
				self.virtual_list.render_items_by_id(id_task, self.virtual_list.render_terms2);
			},

			is_disabled: function(id_task) {
				const parentMap = self.virtual_list.parentMap;
				const dataMap = self.virtual_list.dataMap;

				let parent = parentMap.get(id_task);

				while (parent) {
					const data = dataMap.get(parent);
					if (!data.checked) return true; // батько вимкнений
					parent = parentMap.get(parent);
				}

				return false;
			},

			destructor: function() {
				self.virtual_list.dataMap.clear();
				self.virtual_list.parentMap.clear();
				self.virtual_list.childrenMap.clear();
				self.virtual_list.visibleItemsMap.clear();
			}
		},

		destructor: function() {
			self.virtual_list.destructor();
		},

		onLogout: () => self.destructor(),

		onBoot: function () {
			App.bus.app.on('modal_unload modal_closing', function () {
				const action = App.modal.obj_window.find('form[name=modfrm] input[name=action]').val();
				if (action !== 'project_copy:apply') return;
				self.destructor();
			});
		}
	}
})();

;var App = App || {};

(function() {
	let self = App.project_edit = {
		user: function(menu_anchor, extendVisibility, params) {
			params ||= {}
			params.field ||= 'id_user_to';
			App.controls.user_select_and_go.show_context(menu_anchor, params?.endpoint ?? null, {
				request: {
					force: extendVisibility || 0
				},
				replace: extendVisibility || false,
				onload: function () {
					let menu = $(this);
					menu.find('.menu__group-head ws-btn, .menu__group-search ws-btn').click(function () {
						App.core.form_submit(menu.find('form'));
					});
					menu.find('.menu__item[data-id]').click(function () {
						App.controls.menu.item_set_active_by_id(menu, $(this).attr('data-id'));
						App.controls.menu.process_select_box(menu);
						menu.find('input[name=' + params.field + ']').val($(this).attr('data-id'));
					});
					App.controls.menu.init_select_box(menu, {
						on_remove: (menu, select_box, placeholder) => {
							const placeholder_item = placeholder.find('.menu__item[data-id]');
							menu.find('input[name='+params.field+']').val(placeholder_item.attr('data-id'));
						}
					});
				},
				onshow: function () {
					let menu = $(this);
					$(this).find('ws-btn input[name=skip_notify]').val('');
					let id = $(this).find('input[name=' + params.field + ']').length ? $(this).find('input[name=' + params.field + ']').val() : 0;
					$(this).find('.menu__item').each(function () {
						$(this).toggleClass('menu__item-active', $(this).attr('data-id') == id)
					});
					App.controls.menu.item_set_active_by_id(menu, id);
					App.controls.menu.process_select_box(menu, { animate_selectbox: false });
				}
			});
		},

		folder: function (menu_anchor, params) {
			params ||= {};
			let menu_endpoint = params.menu_endpoint || $(menu_anchor).attr('data-menu-url');
			let proj_endpoint = params.project_endpoint || $(menu_anchor).attr('data-proj-url');
			let id_active = $(menu_anchor).attr('data-group');
			App.controls.project_group_select_and_go.show_context(menu_anchor, menu_endpoint, {
				backup: params.backup || false,
				type: params.type || '',
				width: 360,
				onload: function() {
					let menu = $(this);
					menu.find('.menu__item[data-id]').bind('click', function() {
						if ($(this).hasClass('menu__item-active')) return false;
						let id_group = $(this).attr('data-id');
						$.getScript(proj_endpoint + '?drag_to=' + id_group + '&' + App.actions.get('project_drag:do')).done(function() {
							App.menu.hide_all();
						});
					});

					menu.find('#menuCreateTeam ws-btn').click(function () {
						let name = $(this).closest('.menu').find('input[name=name]').val().trim();
						if (name) {
							$.getScript(proj_endpoint + '?drag_to=-1&name=' + encodeURIComponent(name) + '&' + App.actions.get('project_drag:do')).done(function() {
								App.menu.hide_all();
							});
						}
					});

					App.controls.menu.init(menu);
				},
				onshow: function() {
					$(this).find('.menu__item[data-id]').each(function() {
						$(this).toggleClass('menu__item-active', $(this).attr('data-id') == id_active).find('.space ws-icon').toggleClass('withHover', $(this).attr('data-id') != id_active);
					});
				}
			});
		},

		workflow: function(menu_anchor, endpoint, params) {
			params ||= {}
			endpoint ||= $(menu_anchor).attr('data-url');

			let current_id_workflow = null;

			App.menu.show({
				anchor: menu_anchor,
				url: endpoint,
				type: params.type || '',
				backup: params.backup || false,
				replace: params.replace || false,
				cache_trigger: 'tags',
				onload: function() {
					let menu = $(this);
					App.controls.menu.init(menu);
					current_id_workflow = menu.find('input[name=id_workflow]').val();

					menu.on('click', '.menu__item[data-id]', function() {
						App.controls.menu.item_set_active(this);
						let id = $(this).attr('data-id').toInt();
						menu.find('input[name=id_workflow]').val(id);
						menu.find('input[name=is_updated]').val('yes');
					});
					menu.find('.menu__group-search ws-btn').bind('click', function(e) {
						if (menu.find('input[name=is_updated]').val() === 'yes') {
							menu.find('input[name=is_updated]').val('no');
							App.controls.menu.item_set_active(menu.find('.menu__item[data-id=' + current_id_workflow + ']'));
							App.modal.show({
								url: App.helper.url.add_query(menu.find('form').attr('action'), menu.find('form').serialize()),
								backup: true,
								preserve: true,
								onload: function() {
									let modal = $(this);
									modal.check_match_ids = function (){
										let matched = true;
										modal.find('input[name^=tag_replace]').each(function () {
											if ($(this).val() === '-1') matched = false;
										});
										if (!matched) {
											modal.find('.buttons ws-btn').attr('disabled', true);
										} else {
											modal.find('.buttons ws-btn').removeAttr('disabled');
										}
									}

									modal.check_match_ids(); // initial check

									$(this).find('a.drop_select').off('click').on('click', function() {
										let action = $(this).attr('data-action');
										let url = $(this).attr('data-url-'+action);
										switch (action) {
											case 'select':
												App.controls.stage_tag_select_and_go.show_context(this, url, {
													onshow: function () {
														let menu = $(this);
														menu.on('click', '.menu__item[data-id]', function(e) {
															let el = modal.find('a.drop_select.menu_open');
															el.find('.in').text($(this).find('.in').text());
															el.prev().replaceWith($(this).find('ws-icon').clone());
															el.next('input[type=hidden]').val($(this).attr('data-id'));
															modal.check_match_ids();
															App.menu.hide();
														});
													}
												});
												break;
											case 'add':
												App.controls.tag_edit.add_tag_helper(this, url,  {is_hid: $(this).attr('data-workflow'), id_type: $(this).attr('data-id-type'), from: 'modal_workflow'});
												break;
										}
									});
								}
							});
						} else {
							App.menu.hide();
						}
					});

					menu.find('#menuCreateWorkflow button').bind('click', function() {
						let menu = $(this).closest('#menuCreateWorkflow'), data = {};
						data['name'] = menu.find('input').val().trim();
						if (data['name']) {
							$.ajax({
								type: "POST",
								url: $(this).closest('#menuCreateWorkflow').attr('data-add-enpoint'),
								data: data,
								success: function (html) {
									App.menu.hide(true);
								}
							});
						}	else {
							App.menu.hide();
						}
					});
				}
			});
		},

		stage: function(menu_anchor, endpoint, params) {
			params = params || {};

			App.controls.project_task_stage_and_go.show_context(menu_anchor, endpoint || $(menu_anchor).attr('data-url'), {
				backup: params.backup || false,
				type: params.type || '',
				onload: function() {
					let menu = $(this);
					menu.find('.menu__group-search ws-btn[name*=primary]').click(function() {
						App.core.form_submit(menu.find('form'));
					});
					menu.find('.menu__item[data-id]').click(function() {
						App.controls.menu.item_set_active(this);
						menu.find('input[name=id_stage]').val($(this).attr('data-id'));
					})
				},
				onshow: function() {
					$(this).find('ws-btn input[name=skip_notify]').val('');
					let id = $(this).find('input[name=id_stage]').length ? $(this).find('input[name=id_stage]').val() : 0;
					$(this).find('.menu__item').each(function() {
						$(this).toggleClass('menu__item-active', $(this).attr('data-id') == id)
					});
				}
			});
		},

		limit_tag_group: null,
		ids_hidden_tags: [],
		tags: function(menu_anchor, endpoint) {
			self.limit_tag_group = $(menu_anchor).is('[data-filter]') ? $(menu_anchor).attr('data-filter') : null;
			App.controls.project_task_labels_and_go.show_context(menu_anchor, endpoint || $(menu_anchor).attr('data-url'), {
				onload: function() {
					let menu = $(this);
					menu.find('.menu__group-head ws-btn[name*=primary]').click(function() {
						let ids = self.ids_hidden_tags;
						menu.find('.menu__item-picked').each(function() {
							ids.push($(this).attr('data-id').toInt());
						});
						menu.find('input[name=tags]').val(ids.join(','))
						App.core.form_submit(menu.find('form'));
					});
				},
				onshow: function() {
					self.ids_hidden_tags = [];
					$(this).find('ws-btn input[name=skip_notify]').val('');
					$(this).find('.editBlock__picker__item').remove();
					$(this).find('.menu__group-bottom').removeClass('menu__group-hidden');
					$(this).find('.tagsSingleSelect__group').addClass('menu__group-searchable').removeClass('menu__group-hidden');
					$(this).removeClass('menu-tagSplit');
					if (self.limit_tag_group != null) {
						$(this).addClass('menu-tagSplit');
						$(this).find('.tagsSingleSelect__group').not('[data-group='+self.limit_tag_group+']').removeClass('menu__group-searchable').addClass('menu__group-hidden');
						$(this).find('.menu__group-bottom').addClass('menu__group-hidden');
						let replace_title = $(this).find('.tagsSingleSelect__group[data-group='+self.limit_tag_group+'] .tagsSingleSelect__group__title span.flex_content:first').html();
						$(this).find('.menu__group-head .checkboxCount').attr('data-default-text', replace_title).html('').append(replace_title);
					} else {
						$(this).find('.menu__group-head .checkboxCount')
							.attr('data-default-text', $(this).find('.menu__group-head .checkboxCount').attr('data-basic-text'))
							.html($(this).find('.menu__group-head .checkboxCount').attr('data-basic-text'));
					}
					let ids = $(this).find('input[name=tags]').length ? $(this).find('input[name=tags]').val().split(',').map(Number) : [];
					$(this).find('.menu__item[data-id]').removeClass('menu__item-picked').filter(function() {
						let match = ids.includes($(this).attr('data-id').toInt());
						if (match && self.limit_tag_group != null && $(this).closest('.tagsSingleSelect__group').attr('data-group') != self.limit_tag_group) {
							self.ids_hidden_tags.push($(this).attr('data-id').toInt());
							return false;
						}
						return match;
					}).trigger('preset');
				}
			});
		},
	}
})();

;var App = App || {};

(function() {
	let self = App.project_log = {
		loaded: false,
		have_data: false,
		obj_wrapper: null,
		obj_window: null,
		obj_menus: null,
		endpoint: '',
		controller: 'views_right_panel',
		params: {},
		init: function (url, params) {
			this.endpoint = url;
			this.params = params || {};
			App.controls[this.controller].init(url);
			this.init_items();
		},

		filter_params: ['type', 'user', 'role', 'task'],
		filter_data: {},

		filter_update: function (data) {
			if ('clear' in data) {
				for (let i in self.filter_params) data[self.filter_params[i]] = 0;
			}
			let need_save = false;
			let save_data = [];
			self.filter_params.forEach(param => {
				if (param in data && self.filter_data[param] !== data[param]) {
					self.filter_data[param] = data[param];
					need_save = true;
				}
				if (self.filter_data[param] == null) return;
				save_data.push('sel_' + param + '=' + String(self.filter_data[param]));
			});
			if (need_save) App.controls[this.controller].save_filter(save_data.join('&'));
		},

		init_items: function () {
			self.obj_wrapper
				.on('mousedown', '.eventsList__item', function (e) {
					let o_clickable = $(this).find('[data-href]');
					if (!o_clickable.length) return true;
					let url = o_clickable.attr('data-href');
					if (e.which === 2) {
						App.core.new_window(url);
						return false;
					}
				})
				.on('click dblclick contextmenu', '.eventsList__item', function (e) {
					let o_clickable = $(e.target).closest('[data-href]'); //
					if (!o_clickable.length) o_clickable = $(this).find('[data-href]');
					if (o_clickable.length !== 1) return true; // correct process of joined events
					if (App.click_listener.is_moved(e)) return false;
					let url = o_clickable.attr('data-href');
					if (e.type === 'contextmenu' || (App.click_listener.is_longclick(e) && App.device.is_mobile()) || e.altKey) {
						if (o_clickable.length) {
							App.menu.log_mouse_position(e);
							App.keyboard_selection.select_by_click(this);
							if (App.helper.validate.project_url.test(url)) {
								App.controls.project_menu.show(this, App.helper.endpoint.ajax(RegExp.$1));
							} else {
								App.controls.task_menu.show(this, url.replace(/#.*/, ''));
							}
						}
						return false;
					}
					if (!$(e.target).parents().addBack().filter('a,.ava,ws-term').length) {
						let a = url;
						if (e.metaKey || e.ctrlKey) {
							App.core.new_window(a);
						} else {
							App.click_listener.longclick.stop(e);
							if (App.helper.validate.project_url.test(url)) {
								self.hide();
								App.core.goto(a);
							} else {
								App.task_view.show({url: url, anchor: e.target});
							}

							return false;
						}
						return false;
					}
				});
		},

		helper_task_select: function (menu_anchor) {
			App.controls.task_select_and_go.show_context(menu_anchor, App.helper.endpoint.ajax(self.get_id_project()), {
				request: {
					type: 'project_log',
				},
				type: 'left',
				onload: function() {
					let menu = $(this);
					menu.on('click', '.menu__item[data-id]', function() {
						self.filter_update({task: $(this).attr('data-id')});
						App.menu.hide();
					});
					menu.find('.menu__group-search input').bind('keyup', function () {
						menu.find('.switch_search_mode b').text(this.value);
						App.context_search.menu.apply(this.value, menu);
					});
				},
				on_project_change: function() {},
				on_server_search: function() {}
			});
		},

		get_id_project: function() {
			return App.helper.validate.project_url.test(self.endpoint) ? RegExp.$1 : 0;
		},

		onBoot: function () {
			self.obj_wrapper = $('#rightPanel__wrapper');

			App.bus.app.on('right_panel_closed', function () {
				if (!$('.eventsList-full').length) App.controls.views_right_panel.override = {}
			});
		},

		destructor: function () {
			this.endpoint = '';
			this.params = {};
			this.filter_data = {};
		},
		onLogout: function () {
			this.destructor();
		},
	};
})();

// TODO: refactor to classes with inherit
App.account_log = App.helper.object.clone(App.project_log, {
	controller: 'views_left_panel',

	helper_collapse: function(el) {
		let o = $(el).closest('.dashboard__block');
		o.toggleClass('dashboard__block-off');
		let is_on = o.hasClass('dashboard__block-off');
		this.params.group_collapsed ||= [];
		if (is_on) this.params.group_collapsed.push(o.attr('data-project') || o.attr('data-user'));
		else this.params.group_collapsed = this.params.group_collapsed.filter(id => id !== (o.attr('data-project') || o.attr('data-user')));
		App.controls.views_left_panel.set_option({group_collapsed: this.params.group_collapsed.join(',')}, null, true);
	},

	init_mouse: function () {
		App.ui.onMouse(this.obj_wrapper, 'dashboard-block[data-project] .dashboard__block__header', {
			onBefore: (e) => {
				const id_project = $(e.target).closest('dashboard-block').attr('data-project');
				const url = window.location.origin + App.helper.url.project(id_project);

				e.data.id_project = id_project;
				e.data.url = url;
			},
			context: (e) => {
				App.menu.log_mouse_position(e.originalEvent);
				App.controls.project_quick_menu.show(e.target, e.data.id_project);
			},
			open: (e) => {
				App.core.new_window(e.data.url);
			},
			click: (e) => {
				// має свій onclick
				if ($(e.target).closest('[onclick]').length) return;
				App.menu.log_mouse_position(e.originalEvent);
				App.controls.project_quick_menu.show(e.target, e.data.id_project);
			},
			dblclick: (e) => {
				App.account_log.helper_collapse(e.target);
			},
		});
		App.ui.onMouse(this.obj_wrapper, 'dashboard-block[data-user] .dashboard__block__header', {
			onBefore: (e) => {
				const id_user = $(e.target).closest('dashboard-block').attr('data-user');
				const url = window.location.origin + App.helper.url.user(id_user);

				e.data.id_user = id_user;
				e.data.url = url;
			},
			context: (e) => {
				App.menu.log_mouse_position(e.originalEvent);
				App.controls.user_quick_menu.show(e.target, e.data.id_user);
			},
			open: (e) => {
				App.core.new_window(e.data.url);
			},
			click: (e) => {
				// має свій onclick
				if ($(e.target).closest('[onclick]').length) return;
				App.menu.log_mouse_position(e.originalEvent);
				App.controls.user_quick_menu.show(e.target, e.data.id_user);
			},
			dblclick: (e) => {
				App.account_log.helper_collapse(e.target);
			},
		});
	},

	onBoot: function () {
		this.obj_wrapper = $('#sidePanel__wrapper');
		this.init_mouse();
	}
}); // same structure

;var App = App || {};

(function() {
	let self = App.project_view = {

		id: 0,

		obj_wrapper: null,

		last_tab: 'info',

		content_loader: null,

		onload_once: null, // TODO якось нормально оформить, поки так швиденько накидав

		init: function(id_project) {
			self.id = id_project;
			self.obj_wrapper = App.modal.obj_window;
			self.obj_wrapper.attr('data-view-project', self.id);

			self.obj_wrapper.find('.modal__tabs__item').bind('click', function() {
				let type = $(this).attr('data-type');
				let modalContentCap = self.obj_wrapper.find('.modal__content__cap');

				self.last_tab = type;
				self.obj_wrapper.find('.modal__tabs__item:not([data-type='+type+'])').removeClass('active');
				self.obj_wrapper.find('.projectView').hide();
				$(this).addClass('active');

				let content = self.obj_wrapper.find('.projectView[data-type=' + type + ']');
				content.show();
				self.content_loader.abort();

				if (content.length === 0 || content.attr('data-reload') != null) {
					if (content.length === 0) modalContentCap.show();
					self.content_loader.ajax($(this).attr('data-url'))
						.then((html) => {
							if (self.obj_wrapper.find('.modal__tabs__item.active[data-type='+type+']').length === 0) return;
							self.onload(type, html)
						})
						.catch(() => {
							if (self.content_loader.is_idle()) modalContentCap.hide()
						});
				}
			});
			self.obj_wrapper.on('click', '.projectView__params__item', function(e) {
				if (!$(e.target).parents().addBack().filter('a').length) {
					App.menu.log_mouse_position(e);
					$(this).find('a.primary').click();
				}
			});
			self.obj_wrapper.find('#projectNotificationsMenu a').bind('click', function() {
				$.getScript($(this).attr('data-action'));
				App.menu.hide();
			});

			self.obj_wrapper.on('click', '.projectSettings-workflow .projectSettings__item .nextStage a', function(e) {
				let id = $(this).closest('.projectSettings__item').attr('data-id');
				if ($(e.target).parents().addBack().filter('.delete').length) {
					$.getScript($(this).attr('data-delete-url') + '&' + $.param({id_tag: id, id_tag_to: 0}))
				} else if ($(this).attr('data-url')) {
					App.controls.tag_edit.next_stage(this, null, {id, id_to: $('#obj-tag' + id).attr('data-next-stage')})
				}
			});

			self.obj_wrapper.on('click', '.projectView__group-users', function(e) {
				if ($(e.target).closest('.cnt_over').length) {
					let id_user = $(e.target).closest('.componentTeamAvatars__item').attr('rel');
					self.hide();
					App.task_explorer.show('sel_user='+id_user+'&tmp=1&tab=overdue');
				} else {
					self.toggle_tab('members');
				}
			});

			self.obj_wrapper.get(0).onHandshake('custom_field_context', () => {
				return {
					external_edit_url: App.helper.url.add_query(
						App.helper.endpoint.ajax(id_project),
						App.actions.get('project_edit_field:show'),
					)
				}
			});
			self.obj_wrapper.get(0).addDelegatedEventListener('apply', 'custom-field', function ({detail}, el) {
				App.core.async_task.ajax({
					url: App.helper.url.add_query(
						App.helper.endpoint.ajax(id_project),
						App.actions.get('project_edit_field:apply'),
						App.controls.notify.notify_params('task_edit_field'),
					),
					data: detail,
					error(res) {
						if (res.status !== 422){
							return false;
						}
						const {errors: {value}} = res.responseJSON;
						el.setExternalError(value.join('; '))
					},
					success(res) {
						el.clearExternalError()
					}
				});
			});
		},

		on_tag_group_change: function(id_group) {
			let has_group = $(self.obj_wrapper).find('.projectView[data-workflow='+id_group+'], .projectSettings__item-group[data-id='+id_group+']').length > 0;
			if (!has_group) return;

			self.tab_reload('settings');
		},

		on_status_change: function(id_project, status, old_status) {
			if (+self.id !== +id_project) return;

			if (old_status === 'archive' || status === 'archive') {
				if (App.project_view.is_shown()) self.reload();
				return;
			}

			if (status === 'mute' || status === 'active') {
				let btn = App.project_view.obj_wrapper.find('#buttonProjectNotifications'),
					menu = $('#projectNotificationsMenu'),
					is_muted = status === 'mute',
					locale = App.object_state.locale;

				btn
					.attr('left-icon', is_muted ? 'notifications_off' : 'notifications')
					.attr('text', is_muted ? locale.without_notify : locale.with_notify);

				menu.find('.menu__item').removeClass('menu__item-active').filter('[data-key='+status+']').addClass('menu__item-active');
			}

		},

		init_scroll_zones: function () {
			self.obj_wrapper.find('.scrollZone').not('.ps').each(function() {
				this.scrollBars = App.controls.js_scrollbars.init(this);
			});
		},

		is_shown: function () {
			return App.modal.is_shown() && self.obj_wrapper != null;
		},

		hide: function () {
			App.modal.hide();
		},

		show: function(id, params) {
			App.bus.app.emit('project_view_show', { id_project: +id });
			self.content_loader.abort();

			if (typeof params === 'string') {
				params = { tab: params };
			} else {
				params ||= {};
			}

			App.modal.show({
				url: App.helper.endpoint.ajax(id) + '?' + App.actions.get('project_view:show'),
				tab: params.tab || self.last_tab,
				backup: params.backup === true,
			});
		},

		toggle_tab: App.helper.debounce(function (type) {
			self.obj_wrapper.find('.modal__tabs__item[data-type='+type+']').click();
		}),

		on_add_users: function (e) {
			e.stopPropagation();
			const btn = $(e.target).closest('ws-btn');
			App.controls.project_add_users.show(btn.get(0), btn.attr('data-action'), {
				backup: true,
				type: 'submenu'
			})
		},

		reload: function() {
			App.menu.hide_all();
			self.toggle_tab.reset();
			self.show(self.id);
		},

		tab_reload: function(data) {
			if (!self.is_shown()) return;
			let arr = Array.from((new Set(data.split(','))).values()), reload_active_tab = null;

			arr.forEach(function(dataType) {
				let tab = self.obj_wrapper.find('.modal__tabs__item[data-type='+dataType+']'), content = self.obj_wrapper.find('.projectView[data-type=' + dataType + ']');

				if (tab.hasClass('active')) {
					content.attr('data-reload', 'yes');
					reload_active_tab = dataType;
				} else {
					content.remove();
				}
			});

			if (reload_active_tab) self.toggle_tab(reload_active_tab);
		},

		onload: function(type, html) {
			let content = self.obj_wrapper.find('.projectView[data-type='+type+']'),
				restore_scroll_top = content.length ? content.scrollTop() : -1;

			self.obj_wrapper.find('.modal__content__cap').hide();
			content.remove();
			self.obj_wrapper.find('.modal__content').append(html);

			self.init_scroll_zones();

			content = self.obj_wrapper.find('.projectView[data-type='+type+']');

			if (type === 'members') App.controls.project_members.init(content.attr('data-user-cnt'));
			else if (type === 'description') App.controls.project_description.init();
			else if (type === 'note') App.controls.project_note.init();
			else if (type === 'permissions') App.controls.project_permissions.init();

			self.obj_wrapper.find('.modal__header .project_open').toggleClass('hiddenBlock', App.current_page.project === self.id);

			if (restore_scroll_top > 0) content.scrollTop(restore_scroll_top);

			if (typeof self.onload_once === 'function') {
				self.onload_once(self.obj_wrapper);
				self.onload_once = null;
			}
		},

		edit_inline: {
			obj: null,
			is_shown() {
				return !!self.edit_inline.obj;
			},
			show: function(type, endpoint) {
				$.ajax({
					url: endpoint,
					success: function(html) {
						if (type  === 'descr') {
							let obj_detach = self.obj_wrapper.find('.projectView__group-descr').addClass('projectView__group-editing').find('.projectView__group__content').hide();
							self.edit_inline.obj = $('<div />').attr('class', 'projectView__group__contentEdit').html(html).insertAfter(obj_detach);
							App.editor.init(self.edit_inline.obj);
						}
					}
				})
			},
			end: function() {
				self.edit_inline.obj.prev().show().parents('.projectView__group-editing').removeClass('projectView__group-editing');
				self.edit_inline.obj.remove();
				self.edit_inline.obj = null;
			},
			destructor: function() {
				self.edit_inline.obj = null;
			}
		},
		edit_group: {
			show: function (endpoint, dock) {
				$.ajax({
					url: endpoint,
					success: function (html) {
						let content = $(html);
						content.removeClass('setupBlock__title');
						content.removeClass('tagsAdmListing__group__title');
						content.find('ws-btn').each(function () {
							if ($(this).attr('name').includes('btn-36')) {
								$(this).attr('name', $(this).attr('name').replace('btn-36', 'btn-28'))
							}
						});
						content.find('.ws-btn-cancel').attr('onclick', 'App.project_view.edit_group.cancel(this);');
						$(dock).before(content);
						setTimeout(() => content.find('input.in').focus_to_end(), 10);
					}
				})
			},
			cancel: function (btn) {
				$(btn).closest('form').remove();
			}
		},

		clear_grid_selection: function () {
			console.log('clear_grid_selection');
			
			if (App.page.where() !== 'projects_grid' || !self.id) return;
			$('#obj-project' + self.id).toggleSelected(false);
		},

		onBoot: function () {
			self.content_loader = App.core.async_task.context('project_view');

			App.bus.app.on('modal_load', function () {
				if (+App.modal.obj_window.attr('data-view-project') !== self.id) return;

				self.obj_wrapper.find('.modal__tabs__item.active').click();
				App.bus.app.emit('project_view_load', { id_project: self.id });
			}).on('modal_unload', function () {
				if (+App.modal.obj_window.attr('data-view-project') !== self.id) return;

				self.clear_grid_selection();
				App.bus.app.emit('project_view_hide', { id_project: self.id });
				self.content_loader.abort();
				self.id = null;
				self.obj_wrapper = null;
			});

			App.bus.state.on('account', function(payload) {
				if (payload.data.update?.user_options != null) {
					self.tab_reload('info,members');
				}
			}).on('project', function(payload, context) {
				const id_project = payload.id, fields = payload.data;

				if (+self.id !== +id_project) return;

				if (fields.descr) self.tab_reload('description');
				if (fields.team) {
					if (fields.team.delete && fields.team.delete.includes(App.me.id)) return;
					self.tab_reload('info,members');
				}

				if (fields.active) self.on_status_change(id_project, 'active', fields.active.before);
				else if (fields.mute) self.on_status_change(id_project, 'mute', fields.mute.before);
				else if (fields.archive) self.on_status_change(id_project, 'archive', fields.archive.before);

				if (fields.settings) {
					let ch = fields.settings.changes || {};
					if (!context.active_tab) {
						if (ch.assignee_permissions || ch.user_permissions || ch.time_limits || ch.require_fields) self.tab_reload('permissions');
						if (ch.tag_group || ch.workflow || ch.tag_terms) self.tab_reload('settings');
					}
					if (ch.user_def) self.tab_reload('info,members');
				}

				if (fields.user_to && ([fields.user_to.id, fields.user_to.before.id].includes(App.me.id))) {
					if (App.project_view.is_shown()) {
						self.last_tab = 'info';
						self.reload();
					}
				}
			});

			App.bus.state.on('tag', function(payload) {
				const id_obj = payload.id, fields = payload.data;

				if (fields.add) self.on_tag_group_change(fields.add.id_group);
				if (fields.update) self.on_tag_group_change(fields.update.id_group);
				if (fields.delete) self.on_tag_group_change(fields.delete.id_group);

				if (fields.project_status && App.tags_group[App.tags[id_obj].id_group].stage && self.is_shown() && +self.id === fields.project_status.id_project) {

					if ('status' in fields.project_status) {
						$('#obj-tag' + id_obj).toggleClass('projectSettings__item-off', !fields.project_status.status);
					}

					if ('id_user_to' in fields.project_status) {
						const id_user_to = fields.project_status.id_user_to;
						if (id_user_to) {
							$('#obj-tag'+id_obj+' .ava .data').html(App.helper.team(id_user_to, 'avatar')).find('.av_sm').attr('data-title', App.object_state.locale['assignee'] +': ' + App.helper.team(id_user_to, 'name'));
						} else {
							$('#obj-tag'+id_obj+' .ava .data').html('<ws-icon name="none"></ws-icon>');
						}
					}

					if ('id_tag_from' in fields.project_status) {
						const id_tag_from = fields.project_status.id_tag_from;

						$('#obj-tag'+id_obj+' .ava .data').find('.tag').remove();

						if (id_tag_from) {
							$('#obj-tag'+id_obj+' .ava .data').append(App.components.task_stage.template({id: id_tag_from}, 'icon')).find('.tag').removeAttr('data-title');
						}
					}

					if ('next_stage' in fields.project_status) {
						const next_stage = fields.project_status.next_stage, next_tag = App.tags[next_stage];

						$('#obj-tag'+id_obj).attr('data-next-stage', next_stage);
						$('#obj-tag'+id_obj+' .nextStage .data').html(next_stage ? App.helper.template.fill('workflow_nextStage', {
							name: next_tag.name,
							color: next_tag.color,
							percent_style: next_tag.percent_style,
							icon: App.tags_type_icon[0][next_tag.id_type],
						}) : '');
						$('#obj-tag'+id_obj+' .nextStage').toggleClass('nextStage-active', !!next_stage);
					}

				}
			});
		},
		onLoadPage: function() {
			App.core.process_start_hash(/#project-(\d+)-([\d\w]+)$/, function (m) {
				App.project_view.show(m[1], m[2])
			});
		},
		destructor: function() {
			self.edit_inline.destructor();
			self.id = 0;
			self.obj_wrapper = null;
			self.last_tab = 'info';
		},
		onLogout: () => self.destructor(),
	};
})();

;var App = App || {};

(function() {
	let self = App.queue = {
		window: null,

		shown: false,
		obj_wrapper: null,
		obj_window: null,
		obj_listing: null,
		tick_id: 0,
		cnt_run: 0,
		total: 0,
		progress: 0,
		html: null,

		is_shown: function () {
			return self.shown;
		},

		show: function() {
			if (self.is_shown()) {
				self.window.alreadyOpened();
				return false;
			}

			self.window.opening();
			let cache_data = App.queue_cache.pop();
			if (cache_data) {
				self.shown = true;
				self.obj_wrapper.html('').append(cache_data.obj_window).append(cache_data.obj_menus);
				self.animate_show();
				self.window.opened();
			} else {
				self.window.loading();
				$.ajax({
					url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('menu_queue:show') + '&with_wrapper=1'),
					success: function (html) {
						self.shown = true;
						self.obj_wrapper.html(html);
						self.animate_show();
						self.obj_menus = self.obj_wrapper.find('.menu').not('.menu-level2').appendTo('#queueView__wrapper');
						self.obj_window = self.obj_wrapper.find('.queueView');
						self.obj_listing = self.obj_window.find('.queueView__content');
						self.save_html();
						self.init();
						self.init_scroll_zones();
						App.queue_cache.push(self);
						self.window.opened();
					},
					error: App.core.create_jq_ajax_error(function () {
						self.window.loadFailed();
					}),
				});
			}
		},

		hide: function() {
			if (self.cnt_run) {
				self.minimize();
			} else {
				self.hide_all();
				self.delete();
			}
		},

		delete: function() {
			self.window.closing();
			App.queue_cache.delete();
			self.animate_hide(function() {
				self.window.closed();
				self.shown = false;
				self.remove();
				let o = App.task_panel.obj.find('.taskPanel__item-queue');
				if (o.length) {
					App.task_panel.item.remove(self);
				}
			});
		},

		animate_show: function() {
			if (App.device.is_mobile()) {
				$('body').addClass('mobileQueueView');
			} else {
				self.obj_wrapper.addClass('queueView__wrapper-active');
			}
		},

		animate_hide: function(callback) {
			if (App.device.is_mobile()) {
				$('body').removeClass('mobileQueueView');
				callback();
			} else {
				self.obj_wrapper.removeClass('queueView__wrapper-active');
				setTimeout(function() {
					callback.call(self);
				}, 300);
			}
		},

		minimize: function() {
			self.window.minimizing();
			self.animate_hide(function() {
				self.window.closed();
				self.shown = false;
				self.detach();
			});
		},

		detach: function() {
			if (!self.obj_window) return;
			self.obj_window.detach();
			self.obj_menus.detach();
		},

		remove: function() {
			self.destroy_scroll_zones();
			self.obj_window.removeWithComponents();
			self.obj_menus.removeWithComponents();
		},

		init: function(cnt_run, total, progress, skip_redraw) {
			if (typeof cnt_run != 'undefined') {
				let old_hash = self.cnt_run + '_' + self.total + '_' + self.process;
				self.cnt_run = 1*cnt_run;
				self.total = 1*total;
				self.progress = 1*progress;

				if (!skip_redraw && self.cnt_run + '_' + self.total + '_' + self.process !== old_hash) {
					App.task_panel.replaceOrAppend({
						type: App.queue.window.key,
						run: self.cnt_run,
						done: self.total - self.cnt_run,
						total: self.total,
						progress: self.progress
					});
				}
			}
			if (self.cnt_run) {
				if (!self.tick_id) self.tick_id = setInterval(self.tick, 1000);
			} else {
				if (self.tick_id) { clearInterval(self.tick_id); self.tick_id = 0; }
 			}
			if (!self.total && self.is_shown()) self.delete();
		},

		init_scroll_zones: function() {
			self.obj_window.find('.scrollZone').not('.ps').each(function() {
				this.scrollBars = App.controls.js_scrollbars.init(this);
			});
		},
		destroy_scroll_zones: function() {
			self.obj_window.find('.scrollZone').each(function() {
				if (this.scrollBars) this.scrollBars.destroy();
			});
		},

		process: function(primary, tick) {
			self.html = localStorage.getItem('queue_html') || '';
			if (tick) this.tick();
			self.obj_listing.html(self.html);
			let cnt_run = self.obj_listing.find('.queueList__item.process').length;
			let total = self.obj_listing.find('.queueList__item').length;
			let sum_progress = 0, num_progress = 0;
			self.obj_listing.find('.queueList__item').each(function() {
				let progress = $(this).find('progress-bar');
				if ($(this).hasClass('process') && progress.length) {
					sum_progress += parseInt(progress.attr('real'));
					num_progress++;
				} else {
					sum_progress += 100;
					num_progress++;
				}
			});
			let progress = num_progress ? Math.ceil(sum_progress / num_progress) : 0;
			self.init(cnt_run, total, progress);
		},

		tick: function(force) {
			let ttl = self.is_shown() ? 10 : 2;
			if (force) ttl = 0;
			App.core.multytab_function_call(function() {
				$.ajax({url: App.helper.endpoint.primary() + '?'+App.actions.get('menu_queue:show'), dataType: 'html',success: function(html) {
						self.html = html;
						localStorage.setItem('queue_html', html);
						self.process(true);
						App.core.send_message_to_other_tabs({'command':'queue', 'dt' : (new Date).getTime()+Math.random()})
					}});
			}, 'event', ttl);
		},

		hide_item: function(el) {
			$.ajax(App.helper.endpoint.primary() + '?' + App.actions.get('menu_queue:delete') + '&id=' + $(el).attr('data-id'));
			$(el).parents('.queueList__item').remove();
			self.save_html();
		},
		cancel_item: function(el) {
			$.ajax(App.helper.endpoint.primary() + '?' + App.actions.get('menu_queue:delete') + '&cancel=1&id=' + $(el).attr('data-id'));
			$(el).parents('.queueList__item').addClass('canceling');//.removeClass('process');
			$(el).parents('.queueList__item__action').remove();
			self.save_html();
		},

		hide_all: function() {
			$.ajax(App.helper.endpoint.primary() + '?' + App.actions.get('menu_queue:delete') + '&all=1');
			self.save_html();
		},

		save_html: function() {
			self.html = self.obj_listing.html();
			localStorage.setItem('queue_html', self.html);
			App.core.send_message_to_other_tabs({'command':'queue', 'data': self.html, 'dt' : (new Date).getTime()+Math.random()});
			self.process();
		},

		start: function() {
			this.tick(true);
			if (!App.task_panel.is_shown()) App.task_panel.expand();
		},

		onload: function() {
			self.obj_wrapper = $('#queueView__wrapper');
			self.obj_listing = $('<div />').detach();
			self.init();
		},

		destructor: function() {
			if (self.is_shown()) {
				$('body').removeClass('mobileQueueView');
				self.remove();
			}
			self.shown = false;
			self.window.closed();
			self.obj_wrapper = null;
			self.obj_window = null;
			self.obj_listing = null;
			clearInterval(self.tick_id);
			self.tick_id = 0;
			self.cnt_run = 0;
			self.total = 0;
			self.progress = 0;
		},

		onBoot: function () {
			App.bus.msg.on('queue', () => self.process());
			self.window = App.window.queue.bind(self);
		},
		onLogin: () => self.onload(),
		onLogout: () => self.destructor(),
	};
})();


App.queue_cache = {
	data: null,

	exists: function() {
		return !!this.data
	},

	pop: function() {
		return this.data;
	},

	delete: function() {
		if (!this.data) return;
		this.data.obj_window.removeWithComponents();
		this.data.obj_menus.removeWithComponents();
		this.data = null;
	},

	push: function(self) {
		this.data = {
			obj_window: self.obj_window,
			obj_menus: self.obj_menus,
			id: self.id,
			title: self.title,
			state: 'open',
			dt_added: new Date()
		}
	},

	destructor: function() {
		if (this.exists()) this.delete();
	},

	onLogout: () => App.queue_cache.destructor(),
}

;var App = App || {};

(function() {
	let self = App.right_panel = {
		event: 'right_panel',

		is_shown: function () {
			return self.shown;
		},

		shown: false,
		window: null,
		cache: {},

		type: '',
		overlay: false,
		obj_wrapper: null,
		obj_window: null,
		obj_menus: null,
		minibar: null,
		width: 800,

		toggle: function (data) {
			if (self.is_shown() && self.type === data.type) {
				self.hide();
			} else {
				self.show(data);
			}
		},

		show: function (data) {
			if (!App.windows.before_open(self.window, data)) return;
			App.core.async_task.abort('right_panel_show');

			let type = data.type || 'default';
			let url = data.url || '';
			let skip_cache = data.skip_cache ?? true;
			let overlay = data.overlay || false;

			if (App.menu.is_shown()) App.menu.hide_all();
			if (App.modal.is_shown()) App.modal.hide();
			if (App.task_view.is_shown() && window.innerWidth < 1400) App.task_view.hide();

			if (type === 'default' && url.includes('project_activity')) type = 'project_activity';
			else if (type === 'default' && url.includes('project_activity')) type = 'project_log';

			if (self.shown && self.has_loaded) self.window.unready();

			let active_type = self.shown && self.has_loaded && self.type ? self.type : '';

			self.overlay = overlay;
			self.type = type;
			self.loaded_html = null;
			self.url = url;
			self.stale_content = false;

			let cache_data = !skip_cache ? self.cache[type] : null;

			self.window.opening();
			let should_load = false;
			if (cache_data) {
				if (self.has_loaded) {
					$(document).trigger(self.event + '_onunload.once').unbind(self.event + '_onunload.once');
					$(document).trigger(self.event + '_onunload.final').unbind(self.event + '_onunload.final');
					$(document).trigger(self.event + '_onunload.everytime');
					self.detach();
				}

				self.obj_menus = cache_data.obj_menus;
				self.obj_window = cache_data.obj_window;
				self.minibar = cache_data.minibar;
				self.obj_wrapper.attr('data-type', type).html('').append(self.obj_window).append(self.obj_menus);
				self.has_loaded = true;
			} else {
				let load_type = type;

				if (active_type !== load_type) {
					if (self.has_loaded) {
						$(document).trigger(self.event + '_onunload.once').unbind(self.event + '_onunload.once');
						$(document).trigger(self.event + '_onunload.final').unbind(self.event + '_onunload.final');
						$(document).trigger(self.event + '_onunload.everytime');
						// if (self.type === type) self.remove(); else self.detach();
						self.detach();
					}

					self.obj_window = $(self.skeleton[load_type] || self.skeleton.default || '<div style="text-align: center; padding: 32px">loading</div>');
					self.obj_wrapper.attr('data-type', type).html('').append(self.obj_window);
					self.obj_menus = null;
				} else {
					self.stale_content = true;
				}

				self.has_loaded = false;
				should_load = true;
			}

			const check_ready = function () {
				if ((self.has_loaded && !self.window.is_ready()) || (self.loaded_html && self.window.is_opened())) {
					self.stale_content = false;
					self.ready();
					self.window.ready();
				}
			};

			self.animate_show(function () {
				self.window.opened();
				check_ready();
			});
			self.shown = true;

			if (!should_load) return;

			App.core.async_task.ajax({
				id: 'right_panel_show',
				url: url,
				// before_start: function () {
				// 	if (self.stale_content) self.loader.start();
				// },
			}).then(function (html) {
				self.loaded_html = html;
				App.helper.nextTick(check_ready);
			}).catch(function () {
				self.window.loadFailed();
				// self.loader.stop();
			});
		},

		ready: function () {

			if (self.loaded_html) {

				App.helper.dom.html(self.obj_wrapper.attr('data-type', self.type), self.loaded_html);
				self.obj_menus = self.obj_wrapper.find('.menu[id]').appendTo('#rightPanel__wrapper');
				// self.loader.stop();
				self.obj_window = $('.rightPanel');
				self.minibar = null;

				let scrollZone = self.obj_window.find('.scrollZone');
				if (scrollZone.length) {
					App.controls.js_scrollbars.init(scrollZone.get(0));
					scrollZone.bind('scroll', self.onscroll);
					self.onscroll();
				}

				$(document).trigger(self.event + '_onload.once').unbind(self.event + '_onload.once');
				$(document).trigger(self.event + '_onload.final').unbind(self.event + '_onload.final');
				$(document).trigger(self.event + '_onload.everytime');
				$(document).trigger(self.event + '_onshow.everytime');

				self.cache[self.type] = {
					obj_window: self.obj_window,
					obj_menus: self.obj_menus,
					minibar: self.minibar,
					url: self.url
				};


				if (self.type === 'hotkey') {
					self.update_hotkeys_state();
				}

				self.has_loaded = true;
				self.loaded_html = null;
			} else {
				$(document).trigger(self.event + '_onshow.from_history');
				$(document).trigger(self.event + '_onshow.everytime');
			}
		},

		animate_show: function(next) {
			if ($(window).width() > 480) $('body').addClass('rightPanelShown rightPanelShown480p'); else $('body').addClass('rightPanelShown');
			if (self.overlay) $('body').addClass('rightPanelOverlay');

			clearTimeout(self.animate_show_timer);
			if (next) {
				self.animate_show_timer = setTimeout(next, 350);
			}
		},

		hide: function (config) {
			config ||= {};
			if (!self.is_shown()) return;

			clearTimeout(self.animate_show_timer);

			self.window.closing(config);
			$('body').removeClass('rightPanelShown rightPanelShown480p rightPanelOverlay');
			self.detach();
			self.shown = false;
			self.has_loaded = false;
			self.window.closed(config);
			self.type = '';
			delete self['url'];
			App.task_view.toggle_right_panel_view(false);
		},

		update_hotkeys_state: function() {
			if (!self.obj_window) return;

			let gloabal_switch = self.obj_window.find('#hotkey_global_switch');

			let is_active = gloabal_switch.hasClass('sw_act');
			App.config.hotkeys = is_active;

			if (!is_active) {
				self.obj_window.find('.rightPanel__list__item').each(function () {
					let $item = $(this);
					let has_modifier = $item.find('.key').is(function () {
						let key = $(this).text().trim().toLowerCase();
						return ['ctrl', 'alt', '⌘', '⌥'].includes(key);
					});

					$item.toggleClass('rightPanel__list__item-off', has_modifier);
					$item.find('.hotKey').toggleClass('hotKey-off', has_modifier);
				});
				gloabal_switch.removeClass('sw_act');
			} else {
				self.obj_window.find('.rightPanel__list__item').removeClass('rightPanel__list__item-off');
				self.obj_window.find('.hotKey').removeClass('hotKey-off');
				gloabal_switch.addClass('sw_act');
			}
		},

		hotkey_global_toggle: function (el, user_id) {
			let switch_el = $(el).parent();
			switch_el.toggleClass('sw_act');
			let is_active = switch_el.hasClass('sw_act');

			App.config.hotkeys = is_active;
			self.update_hotkeys_state();

			let action = is_active ? 'user_process:hotkey_on' : 'user_process:hotkey_off';
			let endpoint = App.helper.endpoint.user(user_id) + '?' + App.actions.get(action);
			$.ajax({
				type: "POST",
				url: endpoint
			});
		},

		detach: function() {
			self.obj_window?.detach();
			self.obj_menus?.detach();
		},

		remove: function() {
			self.minibar?.destroy();
			self.obj_window?.removeWithComponents();
			self.obj_menus?.removeWithComponents();
		},

		reload: function () {
			if (self.is_shown()) {
				self.show({type: self.type, url: self.cache[self.type].url, skip_cache: true});
			}
		},

		clear_cache: function (type) {
			if (self.is_shown() && self.type === type) {
				self.show({type, url: self.cache[type].url, skip_cache: true});
			} else if (type in self.cache) {
				self.cache[type].minibar?.destroy();
				self.cache[type].obj_window.removeWithComponents();
				self.cache[type].obj_menus.removeWithComponents();
				delete(self.cache[type]);
			}
		},

		keyboard_container: null,
		init_keyboard_selection: function (o) {
			o ||= self.obj_wrapper;
			if ($('body').hasClass('mobile')) return;
			let list = o.find('.keyboardZone-primary');
			if (!list.length) list = o.find('.keyboardZone');
			if (list.length) {
				App.keyboard_selection.init_container(list);
			}
		},

		onscroll: function () {
			if (self.obj_wrapper.find('.moredots-auto').length && (self.obj_wrapper.find('.moredots-auto').position().top < self.obj_wrapper.find('.scrollZone').height())) {
				self.obj_wrapper.find('.moredots-auto').trigger('click');
			}
		},

		more_load: function(el, url) {
			if ($(el).parent().hasClass('moreLoad__place')) $(el).hide().parent().addClass('moreLoad__place-clicked');
			$('.rightPanel__wrapper .moreLoad__futureContent').removeClass('moreLoad__futureContent').load(url, function() {
				if (self.obj_wrapper.find('.same_month').length && self.obj_wrapper.find('.moredots-auto').is(':visible')) {
					self.obj_wrapper.find('.same_month').children().insertAfter(self.obj_wrapper.find('.moreLoad__place-clicked'));
					self.obj_wrapper.find('.same_month').remove();
					self.obj_wrapper.find('.moreLoad__place-clicked').remove();
				}
			});
		},

		onload: function () {
			self.obj_wrapper = $('#rightPanel__wrapper');
			$('#rightPanel__overlay').bind('click', () => self.hide());
		},

		destructor: function() {
			App.core.async_task.abort('right_panel_show');
			$('body').removeClass('rightPanelShown rightPanelShown480p rightPanelOverlay');
			self.shown = false;
			self.window.closed();
			for (let type in self.cache) {
				self.cache[type].minibar?.destroy();
				self.cache[type].obj_window.removeWithComponents();
				self.cache[type].obj_menus.removeWithComponents();
			}
			self.minibar = null;
			self.obj_window = null;
			self.obj_menus = null;
			self.type = '';
			self.cache = {};

			clearTimeout(self.animate_show_timer);

			delete self['skeleton'];
			delete self['loaded_html'];
			delete self['has_loaded'];
			delete self['stale_content'];
			delete self['animate_show_timer'];
			delete self['url'];
		},

		onBoot: function () {
			self.window = App.window.right_panel.bind(self);
			self.onload();
		},

		onLogin: () => {
			self.skeleton = {};
			$('.rightPanelSkeleton').each(function () {
				self.skeleton[$(this).attr('data-type')] = $(this).html();
			});
			$('.rightPanelSkeleton').remove();
		},

		onLogout: () => self.destructor(),
	};
})();

;var App = App || {};

const SCROLL_DETECT_STATE = 'detect';

(function() {

	let self = App.scroll = {

		listen: function (obj_el, component) {

			let timeout;
			$(obj_el).each(function (_, el) {

				el.dataset.lastScrollTop = el.scrollTop;
				el.dataset.lastScrollLeft = el.scrollLeft;

				el.addEventListener('scroll', (e) => {

					if (timeout) clearTimeout(timeout);

					self.onscroll(e, component);

					timeout = setTimeout(() => {
						self.onscrollend(e, component);
					}, 600);
				}, true);

				// TODO в ідеалі треба щоб це запрацювало - дає найкращі відчуття відгуку
				// шкода... через кастомний perfect-scrollbar не працює на тяганні thumb
				// тому поки через setTimeout
				// FYI для сафарі все рівно треба поліфілл
				// el.addEventListener('scrollend', (e) => {
				// 	self.onscrollend(e, component);
				// }, true);
			});
		},

		onscroll: function (e, component) {

			const diff = {
				x: e.target.dataset.lastScrollLeft - e.target.scrollLeft,
				y: e.target.dataset.lastScrollTop - e.target.scrollTop
			};
			const horizontal = Math.abs(diff.x) > Math.abs(diff.y) + 2;
			const vertical = Math.abs(diff.x) + 2 < Math.abs(diff.y);

			diff.direction = vertical ? (diff.y < 0 ? 'down' : 'up') : (horizontal ? (diff.x < 0 ? 'right' : 'left') : null);

			if (!e.target.dataset.scrollStarted) {
				if (!horizontal && !vertical) return;
				if (
					(
						component.direction === 'both'
						|| (component.direction === 'vertical' && vertical)
						|| (component.direction === 'horizontal' && horizontal)
					) && component.condition(e, diff)
				) {
					component.onstart();
					e.target.dataset.scrollStarted = true;
					return;
				}
			} else {
				component.onmove(diff);
			}
		},

		onscrollend: function (e, component) {

			if (!e?.target?.dataset?.scrollStarted) return;

			component.onend();

			e.target.dataset.scrollStarted = '';
			e.target.dataset.lastScrollTop = e.target.scrollTop;
			e.target.dataset.lastScrollLeft = e.target.scrollLeft;
		},
	};
})();

;var App = App || {};

(function() {
	let self = App.scroll_listener = {

		scroll_pos: 0,
		scroll_direction: 1,
		scroll_turn_pos: 0,
		is_scrolled: null,
		is_scrolled57: null,
		is_scrolled120: null,
		is_scrolled_part_divider: 0,
		is_scrolling: false,

		stop_scroll_events: false,
		stop_events: function () {
			self.stop_scroll_events = true;
		},
		resume_events: function () {
			self.stop_scroll_events = false;
			self.onscroll();
		},

		find_scrolling_target: function () {
			let scroll_obj;
			if (App.controls.mouse && App.controls.mouse.pageX != null && App.controls.mouse.pageY != null) {
				const x = App.controls.mouse.pageX - window.scrollX;
				const y = App.controls.mouse.pageY - window.scrollY;
				let el = document.elementFromPoint(x, y);
				if (el) {
					let scroll_obj = $(el).closest('.scrollZone, .ps');
					if (scroll_obj.length) return scroll_obj;
				}
			}

			if (App.menu.is_shown()) {
				scroll_obj = App.menu.obj_window.find('.scrollZone');
			} else if (App.modal.is_shown()) {
				scroll_obj = App.modal.obj_window.find('.scrollZone');
				if (!scroll_obj.length) scroll_obj = App.modal.obj_window.find('.modal__content');
			} else if (App.mymenu.is_shown()) {
				scroll_obj = $('#sidePanel__wrapper .scrollZone:visible');
			} else if (App.task_view.is_shown()) {
				scroll_obj = App.task_view.obj_window.find('.ps');
			} else {
				scroll_obj = null;
			}
			return scroll_obj;
		},

		onscroll: function (onload) {
			if (self.stop_scroll_events) return false;
			if (typeof onload != 'boolean' && $(window).scrollTop() > self.scroll_pos) {
				if ($('#modal__previewImage').length && $(window).width() > 480) App.modal.hide();
			}
			if ($(window).scrollTop() > self.scroll_pos) { // DN
				if (self.scroll_direction !== 1) {
					self.scroll_direction = 1;
					self.scroll_turn_pos = self.scroll_pos;
				}
			} else if ($(window).scrollTop() < self.scroll_pos) { // UP
				if (self.scroll_direction !== 2) {
					self.scroll_direction = 2;
					self.scroll_turn_pos = self.scroll_pos;
				}
			}
			if (self.is_scrolled !== 1 && $(window).scrollTop() > 0) {
				self.is_scrolled = 1;
				$('#title_float .in, #mass_n_filt .filter, .commentListPanel .in').addClass('scrolled');
			}
			if (self.is_scrolled !== 0 && $(window).scrollTop() === 0) {
				self.is_scrolled = 0;
				$('#title_float .in, #mass_n_filt .filter, .commentListPanel .in').removeClass('scrolled');
			}
			if (!window.time_total) window.time_total = 0;

			if ($('#part_divider').length) {
				if (self.is_scrolled_part_divider !== 2 && $(window).scrollTop() > $('#part_divider').offset().top - 140) {
					self.is_scrolled_part_divider = 2;
					$('#title_float .part:first').removeClass('act').next().next().addClass('act');
				}
				if (self.is_scrolled_part_divider !== 1 && $(window).scrollTop() <= $('#part_divider').offset().top - 140) {
					self.is_scrolled_part_divider = 1;
					$('#title_float .part:first').addClass('act').next().next().removeClass('act');
				}
			}
			self.scroll_pos = $(window).scrollTop();
		},

		active_scroll_obj: null,

		onmousewheel: function (e) {
			if ($(e.target).is('em-emoji-picker')) return true;
			if ($('#modal__previewFrame').length && e.target && ($(e.target).is('#modal__previewFrame') || $(e.target).parents('#modal__previewFrame').length)) return true;
			if (e.target.id === 'menuOverlay' && App.modal.is_shown()) {
				e.preventDefault();
				return false
			}
			let horizontal = e.shiftKey;
			if ($('#modal__previewImage').length || $('#modal__previewFrame').length) return false;
			if ($(window).width() > 480 && !$('body').hasClass('mobile')) {
				let scrollDiff = null;
				if (e.type === 'mousewheel') scrollDiff = ((e.originalEvent ? e.originalEvent.wheelDelta : e.wheelDelta) * -1);
				else if (e.type === 'DOMMouseScroll') scrollDiff = 40 * (e.originalEvent ? e.originalEvent.detail : e.detail);
				else return false;

				let scroll_obj;
				if (self.active_scroll_obj) {
					scroll_obj = self.active_scroll_obj;
				}	else if (e.target) {
					scroll_obj = $(e.target).closest('.scrollZone, .ps');
					while (scroll_obj.length && !scroll_obj.canScrollToDirection(scrollDiff > 0 ? 1 : -1, horizontal)) scroll_obj = scroll_obj.parent().closest('.scrollZone, .ps');
					if (!scroll_obj.length || !scroll_obj.canScrollToDirection(scrollDiff > 0 ? 1 : -1, horizontal)) scroll_obj = null;
					if (scroll_obj) return true; // Native browser behavior
				}
				if (scroll_obj) {
				} else if ($('.ui-timepicker-wrapper:visible .scrollZone').length) {
					scroll_obj = $('.ui-timepicker-wrapper:visible .scrollZone');
				} else if (e.target && $(e.target).is('textarea') && $(e.target).hasScrollBar(horizontal)) {
					scroll_obj = $(e.target);
				} else if (App.menu.is_shown()) {
					// якщо меню закінчилися скроллЗони, котрі можна скролити в вибраному напрямі == кінець
					if ($(e.target).closest('.scrollZone').closest(App.menu.obj_window).length) return true; // Native browser behavior
					// інакше шукаємо "основну" скролл зону
					scroll_obj = App.menu.obj_window.find('> .scrollZone, > form > .scrollZone, > .menu__group__wrapper > .scrollZone, > form > .menu__group__wrapper > .scrollZone')
					if (!scroll_obj.length) scroll_obj = App.menu.obj_window.find('.scrollZone').first();
				} else if (App.modal.is_shown()) {
					// якщо в модалці закінчилися скроллЗони, котрі можна скролити в вибраному напрямі == кінець
					if ($(e.target).closest(App.modal.obj_window).length) return true; // Native browser behavior
					// інакше шукаємо першу ліпшу видиму скроллЗону, котру можна скролити в вибраному напрямі
					App.modal.obj_window.find('.scrollZone.scrollZone--in-view').each(function () {
						if ($(this).canScrollToDirection(scrollDiff > 0 ? 1 : -1, horizontal)) {
							scroll_obj = $(this);
							return false;
						}
					});
					if (!scroll_obj || !scroll_obj.length) scroll_obj = App.modal.obj_window.find('.modal__content');
				} else {
					scroll_obj = null;
				}
				if (scroll_obj && scroll_obj.length) {
					self.active_scroll_obj = scroll_obj;
					// console.log('scroll_obj: ', scroll_obj);
					App.core.call_queue.add('active_scroll_obj' , function() {
						self.active_scroll_obj = null;
					}, App, null, 0.5);
					if (scrollDiff) {
						if (horizontal)	scroll_obj.scrollLeft(scrollDiff + $(scroll_obj).scrollLeft());
						else scroll_obj.scrollTop(scrollDiff + $(scroll_obj).scrollTop());
						e.preventDefault();
						return false;
					}
				}
			}
		},

		onDivScroll: function () {
			if (this.classList.contains(App.controls.datatable.wrapperClass) || this.classList.contains('listing')) return false;
			this.classList.toggle('scrollZone-top', this.scrollTop > 0);
			this.classList.toggle('scrollZone-bottom', Math.round(this.scrollHeight - this.clientHeight - this.scrollTop) > 0);
		},

		exit_scrolling_state: App.helper.debounce(function () {
			self.is_scrolling = false;
		}, 99),

		onBoot: function () {
			App.bus.window.on('scroll', self.onscroll);
			self.onscroll(true);
			document.addEventListener('scroll', function (event) {
				self.is_scrolling = true;
				self.exit_scrolling_state();
				if (event.target.className?.indexOf('scrollZone') !== -1) { // or any other filtering condition
					self.onDivScroll.call(event.target);
				}
			}, true /*Capture event*/);
			$(window).bind_active('mousewheel DOMMouseScroll', self.onmousewheel);
		}
	};
})();

;var App = App || {};

(function() {
	let self = App.context_search = {
		letters_with_empty_result: 0,
		search_projects_type: [],

		mymenu: {

			last_value_processed: '',
			last_value_pressed: '',
			search_words: [],
			search_words_regexps: null,
			semantic_results: null,
			load: function () {
				App.core.call_queue.delete('menu_search');
				let search_fld = App.mymenu.obj_window.find('.search_fld');
				let current_value = search_fld.val().trim();

				if (self.mymenu.last_value_processed === current_value) return;
				const is_search_started = self.mymenu.last_value_processed.length >= 3;
				const is_skip_search = current_value.length < 3;
				if (is_skip_search && !is_search_started) return;

				self.mymenu.last_value_processed = current_value;
				search_fld.parent().parent().addClass('search_loading');
				$('#search_results').find('.sidePanel__list__group-semantic').remove();
				App.core.async_task.ajax({
					id: 'mymenu_search_load',
					url: App.helper.endpoint.primary() + '?' + App.actions.get('menu_search_content:show'),
					data: {
						search: current_value
					},
				}).then(function(response) {
					const results_container = $('#search_results');

					results_container.destroyComponents();
					results_container.html(response);

					search_fld.parent().parent().removeClass('search_loading');
					App.mymenu.init_keyboard_selection(undefined, false);
					App.bus.app.emit('mymenu_onsearch');

					results_container.find('.sidePanel__list__item .in.flex_overflow').each(function (_, item) {
						const search_tokens = (self.mymenu.search_words_regexps || self.mymenu.search_words)
							.map(token => token.trim())
							.sort((a, b) => b.length - a.length)
							.filter((token, index, array) => {
								return !array.some((longer_token, longer_index) =>
									longer_index < index && longer_token.includes(token)
								);
							});

						const recursive_highlight = function (node, token) {
							if (node.nodeType === Node.TEXT_NODE) { // Якщо це текстовий вузол
								const text = node.nodeValue;
								const search_regex = new RegExp(self.mymenu.search_words_regexps ? App.helper.regexp.replaceWordBoundaries(token) : token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'iu');

								if (search_regex.test(text)) {
									const highlighted_text = text.replace(search_regex, function (match) {
										return '<span class="sidePanel__highlight">' + match + '</span>';
									});

									const fragment = $('<div>').html(highlighted_text);
									fragment.contents().insertBefore($(node));
									$(node).remove();
									return true;
								}
							} else { // Якщо це не текстовий вузол, обходимо дочірні елементи
								for (let i = 0; i < node.childNodes.length; i++) {
									if (recursive_highlight(node.childNodes[i], token)) {
										return true;
									}
								}
							}
							return false;
						}

						if (search_tokens.length) {
							search_tokens.forEach(token => {
								recursive_highlight(item, token);
							});
						}
					});

					let semantic_container = results_container.find('.sidePanel__list__group-semantic');
					if (semantic_container.length === 0) return;

					const load_ai_results = function (points) {
						App.core.async_task.ajax({
							id: 'mymenu_search_load',
							url: App.helper.endpoint.primary() + '?' + App.actions.get('menu_search_content:show'),
							data: {
								search: search_fld.val(),
								points: JSON.stringify(points),
								ai: 1,
							},
						}).then(function(response) {
							semantic_container.after(response);
							semantic_container.remove();
						}).catch(function(error) {
							if (error.name === 'AbortError') return;
							semantic_container.removeClass('sidePanel__list__group-loading');
						});
					};

					if (semantic_container.attr('data-loaded') === '1') {
						let points = semantic_container.data('points');
						if (points.length) {
							load_ai_results(points);
						} else {
							semantic_container.remove();
						}
					} else {
						App.core.async_task.ajax({
							id: 'mymenu_search_load',
							url: App.helper.endpoint.primary() + '?' + App.actions.get('menu_search_content:show'),
							data: {
								search: search_fld.val(),
								semantic: 1,
							},
						}).then(function(response) {
							let new_container = $(response),
								points = new_container.data('points');

							if (points.length) {
								semantic_container.replaceWith(new_container);
								semantic_container = new_container;
								results_container.find('.sidePanel__empty--not-found > span').remove();
								load_ai_results(points);
							} else {
								semantic_container.remove();
							}
						});
					}

				}).finally(function () {
					search_fld.parent().parent().removeClass('search_loading');
				});
			},
			reload: function () {
				self.mymenu.last_value_processed = '';
				self.mymenu.last_value_pressed = '';
				self.mymenu.apply();
			},
			apply: function () {
				if (App.mymenu.obj_window.find('.search_fld').val() == self.mymenu.last_value_pressed) {
					return;
				}
				App.mymenu.obj_window.find('.search_fld').parent().parent().toggleClass('search_started', !!App.mymenu.obj_window.find('.search_fld').val());
				self.mymenu.last_value_pressed = App.mymenu.obj_window.find('.search_fld').val();
				App.core.call_queue.add('menu_search', self.mymenu.load, self, null, 0.5);
			},
			onkeydown: function (key, alt, ctrl, shift, in_input, in_editor) {
				// exit from edit-mode, go to list-mode
				if (!ctrl && !alt && [App.keycode.ArrowUp, App.keycode.ArrowDown].includes(key) && App.mymenu.obj_window.find('.search_fld').length) {
					App.mymenu.obj_window.find('.search_fld').toggleFocus(false);
					App.keyboard_selection.set_active_container(App.mymenu.obj_window.find('.search_fld').closest('.sidePanel').find('.keyboardZone'));
					return;
				}
			}
		},

		mymenu_recent: {
			init: function () {
				const tab_selected_callback = (section, content_selector) => {
					const container = $(content_selector).closest('.keyboardZone');
					if (App.mymenu.obj_window.find('.search_fld').is(':focus')) {
						App.keyboard_selection.set_active_container(container);
						App.keyboard_selection.init_container(container, false, false);
						container.find('.selected').addClass('last_selected').toggleSelected(false);
					} else {
						App.keyboard_selection.init_container_with_preselected_item(container);
					}
				};

				self.mymenu_recent.init_tabs($('.sidePanel__recent'), tab_selected_callback);

				$('.sidePanel__list__item-search[data-value]').on('click', function (event) {
					event.preventDefault();
					App.mymenu.obj_window.find('.search_fld').val($(this).attr('data-value')).trigger('keyup');
				});

				// tricky timeout to cheat auto-select
				setTimeout(() => {
					if ($('.sidePanel__recent').find('.tabs-row__item--active').length === 0) {
						$('.sidePanel__recent').find('.tabs-row__item').first().trigger('click');
					}
				}, 100);
			},
			init_tabs: function (el, callback) {
				el.find('.tabs-row__item:not(.tabs-row__item--active)').on('click', function (event) {
					event.preventDefault();

					const section = $(this).attr('data-section');
					const content_selector = el.attr('data-content-selector');

					$(this)
						.addClass('tabs-row__item--active')
						.siblings().removeClass('tabs-row__item--active');

					$(content_selector).find('.tabs-content__item[data-section='+section+']')
						.addClass('tabs-content__item--active')
						.siblings().removeClass('tabs-content__item--active');

					if (callback && typeof callback === 'function') {
						callback(section, content_selector);
					}
				})
			},
			onkeydown: function (key, alt, ctrl, shift, in_input, in_editor) {
				const is_active = () => {
					const active_container = App.keyboard_selection.get_active_container();
					return Boolean(App.mymenu.obj_window.find(active_container).length);
				};
				if (in_input || in_editor || !is_active()) return false;
				if ($('.sidePanel__recent').length === 0) return false;
				if (!ctrl && !alt && [App.keycode.ArrowLeft, App.keycode.ArrowRight].includes(key)) {
					if(App.mymenu.obj_window.find('.search_fld').is(':focus') && App.mymenu.obj_window.find('.search_fld').parent().parent().hasClass('search_loading')) return false;
					const active_tab = $('.sidePanel__recent').find('.tabs-row__item--active');
					if (active_tab.length === 0) {
						$('.sidePanel__recent').find('.tabs-row__item').first().trigger('click');
					} else {
						if (key === App.keycode.ArrowRight) {
							active_tab.next('.tabs-row__item').trigger('click');
						} else if (key === App.keycode.ArrowLeft) {
							active_tab.prev('.tabs-row__item').trigger('click');
						}
					}
					return true;
				}
				return false
			}
		},

		modal__dataTable: {
			apply: function (el, list, linear) {
				linear = $(list).parent().hasClass('menu');
				let val = (typeof el == 'object') ? el.value : el;
				if (val) {
					$(list).addClass('search_started');
					$(el).closest('.searchInput').addClass('searchInput-start');
					let str = val.replace(/\s+/ig, ' ').toLowerCase().replace(/^\s+|\s+$/g, '')
					let str_tr = App.helper.keyboard.switch(str);
					let task_words = str.split(' '); // utf-recheck
					let task_words_tr = str_tr.split(' '); // utf-recheck
					$(list).find('.item').hide();
					found = false;
					if (!linear) {
						$(list).find('.modal__dataTable__item-level3').each(function () {
							txt = $(this).find('.td_name').text().toLowerCase();
							j = 0;
							for (let i = 0; i < task_words.length; i++) if (txt.indexOf(task_words[i]) !== -1) j++;
							if (j === 0) for (let i = 0; i < task_words_tr.length; i++) if (txt.indexOf(task_words_tr[i]) !== -1) j++;
							if (j === task_words.length) { // j > 0
								found = true;
								if (j === task_words.length) $(this).show().removeClass('itemm_opac').parent().prev().show().addClass('itemm_opac').parent().prev().show().addClass('itemm_opac'); else $(this).show().addClass('itemm_opac').parent().prev().show().addClass('itemm_opac').parent().prev().show().addClass('itemm_opac');
							}
						});
						$(list).find('.modal__dataTable__item-level2').each(function () {
							txt = $(this).find('.td_name').text().toLowerCase();
							j = 0;
							for (let i = 0; i < task_words.length; i++) if (txt.indexOf(task_words[i]) !== -1) j++;
							if (j === 0) for (let i = 0; i < task_words_tr.length; i++) if (txt.indexOf(task_words_tr[i]) !== -1) j++;
							if (j === task_words.length) { // j > 0
								found = true;
								if (j === task_words.length) $(this).show().removeClass('itemm_opac').parent().prev().show().addClass('itemm_opac'); else $(this).show().addClass('itemm_opac').parent().prev().show().addClass('itemm_opac');
							}
						});
					}
					$(list).find(linear ? '.modal__dataTable__item-simple' : '.modal__dataTable__item-level1').each(function () {
						txt = $(this).find('.td_name').text().toLowerCase();
						j = 0;
						for (let i = 0; i < task_words.length; i++) if (txt.indexOf(task_words[i]) !== -1) j++;
						if (j === 0) for (let i = 0; i < task_words_tr.length; i++) if (txt.indexOf(task_words_tr[i]) !== -1) j++;
						if (j === task_words.length) { // j > 0
							found = true;
							if (j === task_words.length) $(this).show().removeClass('itemm_opac'); else $(this).show().addClass('itemm_opac');
						}
					});
					if ($(list).find('.selected').length === 0 || $(list).find('.selected').is(':hidden')) {
						$(list).find('.selected').toggleSelected(false);
						let o = $(list).find('.item:visible');
						if (o.length) {
							o.eq(0).toggleSelected(true);
						}
					}
					if (found) {
						$(list).find('.item_empty').hide();
						self.letters_with_empty_result = 0;
					} else {
						$(list).find('.item_empty').show();
						self.letters_with_empty_result++;
					}
				} else {
					$(list).removeClass('search_started');
					$(el).closest('.searchInput').removeClass('searchInput-start');
					$(list).find('.item').show().removeClass('itemm_opac');
					$(list).find('.item_empty').hide();
					self.letters_with_empty_result = 0;
				}
			}
		},

		users: {
			apply: function (el, list) {
				let val = (typeof el == 'object') ? el.value : el;
				if (val) {
					$(list).addClass('user_list_search');
					val = val.toLowerCase();
					let val_tr = App.helper.keyboard.switch(val);
					let val_translit = App.helper.translit.convert(val);
					$(list).find('.group').not('.group_ignore').each(function () {
						j_in = 0;
						$(this).find('.sub, .sub2').hide();
						$(this).find('.user').each(function () {
							txt_in = ' ' + $(this).justtext().toLowerCase() + ($(this).attr('data-text') ? ' ' + $(this).attr('data-text').toLowerCase() : '');
							if (txt_in.indexOf(' ' + val) !== -1 || txt_in.indexOf(' ' + val_tr) !== -1 || txt_in.indexOf(' ' + val_translit) !== -1) {
								j_in++;
								$(this).show().css({opacity: 1}).parent().show();
							} else {
								$(this).hide();
							}
						});
						if (j_in) $(this).show(); else $(this).hide();
					});
					if ($(list).find('.selected').length === 0 || $(list).find('.selected').is(':hidden')) {
						$(list).find('.selected').toggleSelected(false);
						let o = $(list).find('.user:visible');
						if (o.length) {
							o.eq(0).toggleSelected(true);
							$(list).find('.item_empty').hide();
							self.letters_with_empty_result = 0;
						} else {
							$(list).find('.item_empty').show();
							self.letters_with_empty_result++;
						}
					} else {
						$(list).find('.item_empty').hide();
						self.letters_with_empty_result = 0;
					}
				} else {
					$(list).removeClass('user_list_search');
					$(list).find('.user').show().css({opacity: 1}).parent().show();
					$(list).find('.group').not('.group_ignore').show().css({opacity: 1}).parent().show();
					$(list).find('.item_empty').hide();
					$(list).find('.waste').hide();
					self.letters_with_empty_result = 0;
				}
			}
		},

		project_add_members: {
			apply: function (el, list) {
				let val = (typeof el == 'object') ? el.value : el;
				if (val) {
					$(list).addClass('user_list_search');
					val = val.toLowerCase();
					let val_tr = App.helper.keyboard.switch(val);
					let val_translit = App.helper.translit.convert(val);
					$(list).find('.group').each(function () {
						j_in = 0;
						$(this).find('.sub, .sub2').hide();
						$(this).find('.item_').each(function () {
							txt_in = ' ' + $(this).text().toLowerCase() + ($(this).attr('data-text') ? ' ' + $(this).attr('data-text').toLowerCase() : '');
							if (txt_in.indexOf(' ' + val) !== -1 || txt_in.indexOf(' ' + val_tr) !== -1 || txt_in.indexOf(' ' + val_translit) !== -1) {
								j_in++;
								$(this).show().css({opacity: 1}).parent().show();
							} else {
								$(this).hide();
							}
						});
						if (j_in) $(this).show(); else $(this).hide();
					});
					if ($(list).find('.selected').length === 0 || $(list).find('.selected').is(':hidden')) {
						$(list).find('.selected').toggleSelected(false);
						let o = $(list).find('.item_:visible');
						if (o.length) {
							o.eq(0).toggleSelected(true);
							self.letters_with_empty_result = 0;
						} else {
							$(list).find('.item_empty').show();
							self.letters_with_empty_result++;
						}
					} else {
						$(list).find('.item_empty').hide();
						self.letters_with_empty_result = 0;
					}
				} else {
					$(list).removeClass('user_list_search');
					$(list).find('.item_, .group').show().css({opacity: 1}).parent().show();
					$(list).find('.item_empty').hide();
					$(list).find('.waste').hide();
					self.letters_with_empty_result = 0;
				}
			}
		},
		project_members: {
			apply: function (el, list) {
				let val = (typeof el == 'object') ? el.value : el;
				if (val) {
					let str = val.replace(/\s+/ig, ' ').toLowerCase().replace(/^\s+|\s+$/g, '');
					let str_tr = App.helper.keyboard.switch(str);
					let words = str.split(' '); // utf-recheck
					let words_tr = str_tr.split(' '); // utf-recheck
					let count = 0;
					$(list).addClass('membersList-search');
					$(el).closest('.searchInput').addClass('searchInput-start');

					$(list).find('.fullname .text').each(function () {
						let txt = $(this).text().toLowerCase();
						let j = self.helper_match_count(txt, words, words_tr);
						if (j === words.length) {
							count++;
							$(this).closest('.membersList__user').show();
						} else {
							$(this).closest('.membersList__user').hide();
						}
					});

					let txt = (count > 0 ? App.format.quantity(count, $(list).find('.membersList__search__results').attr('data-text-found')) : $(list).find('.membersList__search__results').attr('data-text-nofound')) + ': ';
					$(list).find('.membersList__search__results .count').text(count > 0 ? count : '');
					$(list).find('.membersList__search__results .text').text(txt);
					$(list).find('.membersList__search__results .word').text(val);

					//App.format.quantity
				} else {
					$(list).removeClass('membersList-search');
					$(el).closest('.searchInput').removeClass('searchInput-start');
					$(list).find('.membersList__user').show();
				}
			}
		},

		tags: {
			apply: function (el, list, options) {
				if (!options) options = {group: '.someListing__group', item: '.someListing__item'};
				self.projects.apply(el, list, options);
			}
		},

		projects: {
			apply: function (el, list, options) {
				if (!options) options = {group: '.gtitle', item: '.item'};
				if (el.value) {
					$(el).parent().add(list).addClass('search_started');
					if ($(el).parent().parent().hasClass('searchInput')) $(el).parent().parent().addClass('searchInput-start');

					let str = el.value.replace(/\s+/ig, ' ').toLowerCase().replace(/^\s+|\s+$/g, '');
					let str_tr = App.helper.keyboard.switch(str);
					let words = str.split(' '); // utf-recheck
					let words_tr = str_tr.split(' '); // utf-recheck

					$(list).find(options.group).each(function () {
						txt = $(this).text().toLowerCase();
						let j_in = 0;
						let j = self.helper_match_count(txt, words, words_tr);
						if (j === words.length) { // j > 0
							if (j === words.length) $(this).css('display', 'block').css({opacity: 1}); else $(this).css('display', 'block').css({opacity: 0.5});
							$(this).parent().find(options.item).each(function () {
								txt_in = $(this).text().toLowerCase() + ' ' + txt;
								j = self.helper_match_count(txt_in, words, words_tr);
								if (j === words.length || (options['show_act'] && ($(this).hasClass('pre_act') || $(this).hasClass('act')))) { // j > 0
									j_in++;
									if (j === words.length) $(this).css('display', 'block').css({opacity: 1}); else $(this).css('display', 'block').css({opacity: 0.5});
								} else {
									$(this).hide();
								}
							});
							$(this).parent().show();
						} else {
							$(this).parent().find(options.item).each(function () {
								txt_in = $(this).text().toLowerCase();
								let j = self.helper_match_count(txt_in, words, words_tr);
								if (j === words.length || (options['show_act'] && ($(this).hasClass('pre_act') || $(this).hasClass('act')))) { //j > 0
									j_in++;
									if (j === words.length) $(this).css('display', 'block').css({opacity: 1}); else $(this).css('display', 'block').css({opacity: 0.5});
								} else {
									$(this).hide();
								}
							});
							if (j_in) $(this).parent().show(); else $(this).parent().hide();
						}
					});
					if ($(list).find('.selected').length === 0 || $(list).find('.selected').is(':hidden') || $(list).find('.selected').hasClass('proj')) {
						$(list).find('.selected').toggleSelected(false);
						let o = $(list).find(options.item + ':visible');
						if (o.length) {
							o.eq(0).toggleSelected(true);
							self.letters_with_empty_result = 0;
							$(list).find('.item_empty').hide();
						} else {
							$(list).find('.item_empty').show();
							self.letters_with_empty_result++;
						}
					} else {
						$(list).find('.item_empty').hide();
						self.letters_with_empty_result = 0;
					}

				} else {
					$(el).parent().add(list).removeClass('search_started');
					$(el).parent().parent().removeClass('searchInput-start');
					$(list).find(options.item + ', ' + options.group).show().css({opacity: 1}).parent().show();
					$(list).find('.waste').hide();
					$(list).find('.item_empty').hide();
				}
			}
		},

		custom: {
			apply: function (el, list, options) {
				if (!options) options = {
					group: '.some__group',
					group_title: '.some__group__title',
					item: '.some__item'
				};
				if (el.value) {
					$(el).closest('.in').add(list).addClass('search_started');

					let str = el.value.replace(/\s+/ig, ' ').toLowerCase().replace(/^\s+|\s+$/g, '');
					let str_tr = App.helper.keyboard.switch(str);
					let words = str.split(' '); // utf-recheck
					let words_tr = str_tr.split(' '); // utf-recheck

					$(list).find(options.group).each(function () {
						txt = $(this).find(options.group_title).text().toLowerCase();
						let j_in = 0;
						let j = self.helper_match_count(txt, words, words_tr);
						if (j === words.length) { // j > 0
							if (j === words.length) $(this).removeClass('hidden').css({opacity: 1}); else $(this).removeClass('hidden').css({opacity: 0.5});
							$(this).find(options.item).each(function () {
								txt_in = $(this).text().toLowerCase() + ' ' + txt;
								j = self.helper_match_count(txt_in, words, words_tr);
								if (j === words.length || (options['show_act'] && ($(this).hasClass('pre_act') || $(this).hasClass('act')))) { // j > 0
									j_in++;
									if (j === words.length) $(this).removeClass('hidden').css({opacity: 1}); else $(this).removeClass('hidden').css({opacity: 0.5});
								} else {
									$(this).addClass('hidden');
								}
							});
							$(this).removeClass('hidden');
						} else {
							$(this).find(options.item).each(function () {
								txt_in = $(this).text().toLowerCase();
								j = self.helper_match_count(txt_in, words, words_tr);
								if (j === words.length || (options['show_act'] && ($(this).hasClass('pre_act') || $(this).hasClass('act')))) { //j > 0
									j_in++;
									if (j === words.length) $(this).removeClass('hidden').css({opacity: 1}); else $(this).removeClass('hidden').css({opacity: 0.5});
								} else {
									$(this).addClass('hidden');
								}
							});
							if (j_in) $(this).removeClass('hidden'); else $(this).addClass('hidden');
						}
					});
					if ($(list).find('.selected').length === 0 || $(list).find('.selected').is(':hidden') || $(list).find('.selected').hasClass('proj')) {
						$(list).find('.selected').toggleSelected(false);
						let o = $(list).find(options.item + ':visible');
						if (o.length) {
							o.eq(0).toggleSelected(true);
							self.letters_with_empty_result = 0;
							$(list).find('.item_empty').addClass('hidden');
						} else {
							$(list).find('.item_empty').removeClass('hidden');
							self.letters_with_empty_result++;
						}
					} else {
						$(list).find('.item_empty').addClass('hidden');
						self.letters_with_empty_result = 0;
					}

				} else {
					$(el).closest('.in').add(list).removeClass('search_started');
					$(list).find(options.item + ', ' + options.group).removeClass('hidden').css({opacity: 1}).removeClass('hidden');
					$(list).find('.waste').addClass('hidden');
					$(list).find('.item_empty').addClass('hidden');
				}
			}
		},

		modal_projects: {
			apply: function (el, list) {
				let options = {
					group_selector: '.projects__group',
					group_hidden_class: 'projects__group-hidden',
					group_opac_class: 'projects__group-partSearch',
					group_title_selector: '.projects__group__title__name',
					item_selector: '.proj',
					item_title_selector: '.proj_text',
					item_hidden_class: 'proj-hidden',
					item_opac_class: 'proj-partSearch',
					empty_state_selector: '.item_empty'
				};
				self.configurable.apply(el, list, options);
			}
		},

		sidebar_tasks: {
			apply: function (el, list) {
				let is_chats = $(list).find('.sidePanel__list.chatList').length > 0;

				let options = {
					parent_group_selector: '.sidePanel__list__parent-group',
					group_selector: '.sidePanel__list__group',
					group_hidden_class: 'sidePanel__list__group-hidden',
					group_opac_class: 'sidePanel__list__group-partSearch',
					group_title_selector: '.sidePanel__list__group__title:first-child',
					item_selector: '.sidePanel__list__item:not(.sidePanel__list__item-disabled)',
					item_title_selector: is_chats ? '.name > .in' : '.in',
					item_hidden_class: 'sidePanel__list__item-hidden',
					item_opac_class: 'sidePanel__list__item-partSearch',
					empty_state_selector: '.sidePanel__empty',
					recheck_groups: true
				};
				if (el) {
					self.configurable.apply(el, list, options);
					App.mymenu.save_search_string(el);
				} else {
					$(list).find(options.empty_state_selector).show();
				}

				const active_tab = $('.sidePanel__tabs li.active').data('tab')
				const has_search_query = App.mymenu.saved_search_value.trim() !== '';

				let role = $('.sidePanel').attr('data-role');

				$('.sidePanel__empty .btn-show-all').toggle(!has_search_query && active_tab !== 'all' || role === '2')
				$('.sidePanel__empty .btn-add-new').toggle(role !== '2')
				$('.sidePanel__empty .btn-clear').toggle(has_search_query)
				$('.sidePanel__empty .hint').hide();

				if (active_tab !== 'all') {
					$('.sidePanel__empty .hint.tab-empty').toggle(!has_search_query)
				} else {
					$('.sidePanel__empty .hint.no-tasks').toggle(!has_search_query)
				}
			}
		},

		sidebar_chats: {
			apply: function (el, list) {
				let is_chats = $(list).find('.sidePanel__list.chatList').length > 0;

				let no_chats_title = $('.sidePanel__empty .title');

				let options = {
					parent_group_selector: '.sidePanel__list__parent-group',
					group_selector: '.sidePanel__list__group',
					group_hidden_class: 'sidePanel__list__group-hidden',
					group_opac_class: 'sidePanel__list__group-partSearch',
					group_title_selector: '.sidePanel__list__group__title',
					item_selector: '.sidePanel__list__item:not(.sidePanel__list__item-disabled)',
					item_title_selector: is_chats ? '.name > .in' : '.in',
					item_hidden_class: 'sidePanel__list__item-hidden',
					item_opac_class: 'sidePanel__list__item-partSearch',
					empty_state_selector: '.sidePanel__empty',
					recheck_groups: true
				};
				if (el) {
					self.configurable.apply(el, list, options);
					App.mymenu.save_search_string(el);
				} else {
					$(list).find(options.empty_state_selector).show();
				}

				const active_tab = $('.sidePanel__tabs li.active').data('tab')
				const has_search_query = App.mymenu.cached_search_strings['chats'].trim() !== '';

				$('.sidePanel__empty .hint.tab-empty').toggle(!has_search_query)
				no_chats_title.text(has_search_query ? no_chats_title.attr('data-empty-search-text') : no_chats_title.attr('data-empty-text'));
			}
		},

		sidebar_projects: {
			apply: function (el, list) {
				let options = {
					group_selector: '.sidebar__projects__group:not(.sidebar__projects__group-extra)',
					group_hidden_class: 'sidebar__projects__group-hidden',
					group_opac_class: 'sidebar__projects__group-partSearch',
					group_title_selector: '.sidebar__projects__group__title',
					item_selector: '.sidebar__projects__item',
					item_title_selector: '.in',
					item_hidden_class: 'sidebar__projects__item-hidden',
					item_opac_class: 'sidebar__projects__item-partSearch',
					empty_state_selector: '.item_empty'
				};
				self.configurable.apply(el, list, options);
			}
		},

		shortcuts: {
			apply: function (el, list) {
				let options = {
					group_selector: '.rightPanel__list__group',
					group_hidden_class: 'rightPanel__list__group-hidden',
					group_opac_class: 'rightPanel__list__group-partSearch',
					group_title_selector: '.rightPanel__list__group__title',
					item_selector: '.rightPanel__list__item',
					item_title_selector: '.in',
					item_hidden_class: 'rightPanel__list__item-hidden',
					item_opac_class: 'rightPanel__list__item-partSearch',
					empty_state_selector: '.rightPanel__empty',
					recheck_groups: true
				};
				self.configurable.apply(el, list, options);
			}
		},

		configurable: {
			apply: function (el, list, options) {
				App.keyboard_selection.active_container = list;
				const parent_group_recheck = () => {
					if (options.parent_group_selector) {
						$(list).find(options.parent_group_selector).each(function () {
							const parent_group = $(this);
							const visible_items = parent_group.find(options.item_selector).not('.'+options.item_hidden_class);
							if (visible_items.length) {
								parent_group.removeClass(options.item_hidden_class);
							} else {
								parent_group.addClass(options.item_hidden_class);
							}
						});
					}
				};
				if (el.value && el.value.trim().length > 0) {
					$(el).closest('.in').add(list).addClass('search_started');
					if ($(el).parent().parent().hasClass('searchInput')) $(el).parent().parent().addClass('searchInput-start');

					let str = el.value.replace(/\s+/ig, ' ').toLowerCase().replace(/^\s+|\s+$/g, '');
					let str_tr = App.helper.keyboard.switch(str);
					let words = str.split(' '); // utf-recheck
					let words_tr = str_tr.split(' '); // utf-recheck
					$(list).find(options.group_selector).each(function () {
						let group = $(this); // to easy read
						let txt = group.find(options.group_title_selector).text().toLowerCase();
						let j = self.helper_match_count(txt, words, words_tr);
						let j_in = 0;
						if (j === words.length) { // j > 0
							if (j === words.length) group.removeClass(options.item_hidden_class).removeClass(options.item_opac_class);
							else group.removeClass(options.item_hidden_class).addClass(options.item_opac_class);
							group.find(options.item_selector).each(function () {
								let item = $(this); // to easy read
								let txt_in = item.find(options.item_title_selector).text().toLowerCase() + ' ' + txt;
								let j = self.helper_match_count(txt_in, words, words_tr);
								if (j === words.length) { // j > 0
									j_in++;
									if (j === words.length) item.removeClass(options.item_hidden_class).removeClass(options.item_opac_class);
									else item.removeClass(options.item_hidden_class).addClass(options.item_opac_class);
								} else {
									item.addClass(options.item_hidden_class);
								}
							});
							group.removeClass(options.group_hidden_class);
						} else {
							group.find(options.item_selector).each(function () {
								let item = $(this); // to easy read
								let txt_in = item.find(options.item_title_selector).text().toLowerCase();
								let j = self.helper_match_count(txt_in, words, words_tr);
								if (j === words.length) { //j > 0
									j_in++;
									if (j === words.length) item.removeClass(options.item_hidden_class).removeClass(options.item_opac_class);
									else item.removeClass(options.item_hidden_class).addClass(options.item_opac_class);
								} else {
									item.addClass(options.item_hidden_class);
								}
							});
							if (j_in) group.removeClass(options.group_hidden_class);
							else group.addClass(options.group_hidden_class);
						}
					});
					parent_group_recheck();
					if ($(list).find('.selected').length === 0 || $(list).find('.selected').is(':hidden') || (options.allow_empty_groups && $(list).find(options.group_selector).filter(':visible').length)) {
						$(list).find('.selected').toggleSelected(false);
						let o = $(list).find(options.item_selector + ':visible');
						if (o.length || (options.allow_empty_groups && $(list).find(options.group_selector).filter(':visible').length)) {
							if (o.length) o.eq(0).toggleSelected(true);
							self.letters_with_empty_result = 0;
							$(list).find(options.empty_state_selector).hide();
						} else {
							$(list).find(options.empty_state_selector).show();
							self.letters_with_empty_result++;
						}
					} else {
						$(list).find(options.empty_state_selector).hide();
						self.letters_with_empty_result = 0;
					}
				} else {
					$(el).closest('.in').add(list).removeClass('search_started');
					$(el).parent().parent().removeClass('searchInput-start');
					if (options.recheck_groups) {
						$(list).find(options.item_selector).removeClass(options.item_hidden_class).removeClass(options.item_opac_class);
						$(list).find(options.group_selector).removeClass(options.group_hidden_class).removeClass(options.group_opac_class);
						parent_group_recheck();
						let o = $(list).find(options.item_selector + ':visible');
						$(list).find(options.group_selector).addClass(options.group_hidden_class);
						o.parents(options.group_selector).removeClass(options.group_hidden_class);
						if (o.length) {
							$(list).find(options.empty_state_selector).hide();
						} else {
							$(list).find(options.empty_state_selector).show();
						}
					} else {
						$(list).find(options.item_selector).removeClass(options.item_hidden_class).removeClass(options.item_opac_class);
						$(list).find(options.group_selector).removeClass(options.group_hidden_class).removeClass(options.group_opac_class);
						$(list).find(options.empty_state_selector).hide();
					}
				}
			}
		},

		menu: {
			apply: function (el, list, options_overwrite) {
				let options = $.extend({}, App.controls.menu.default_options, {
					allow_empty_groups: false,
					item_waste_class: 'menu__item-waste',
				}, options_overwrite);
				if (!list) return; // closed menu issue
				let has_results = false, val = '', clear_selection = false, set_selection = false;
				val = (typeof el == 'object') ? el.value : el;
				let e = event;
				if ((e?.type === 'keydown' || e?.type === 'keyup') && typeof el == 'object') {
					let keyCode = e.keyCode ? e.keyCode : e.charCode;
					if (keyCode === App.keycode.Escape) {
						el.value = val = '';
						clear_selection = true;
						e.stopPropagation();
						e.preventDefault();
					}
					// if (keyCode === App.keycode.Enter && ($(list).find(options.empty).is(':visible') || !$(list).find(options.item+'.selected').length)) {
					if (keyCode === App.keycode.Enter && !$(list).find(options.item+'.selected').length) {
						el.value = val = '';
						clear_selection = true;
						e.stopPropagation();
						e.preventDefault();
					}
					if (keyCode === App.keycode.Tab) {
						return false;
					}

					// O Lushyk, [27.01.2026 16:49]
					// — цікаво, ось тут в пошуку я можу зсунуть курсор стрілою вліво тільки на одну позицію, коли клікноу ще раз вліво — каретка просто зникає
					// if ([App.keycode.ArrowRight, App.keycode.ArrowDown, App.keycode.ArrowLeft, App.keycode.ArrowUp].indexOf(keyCode) !== -1) {
					// 	el.setSelectionRange(el.value.length, el.value.length);
					// 	el.blur();
					// 	return false;
					// }
				}
				set_selection = (e?.type === 'keydown' || e?.type === 'keyup') || val !== '';
				$(list).find(options.group).removeClass(options.group_hidden);
				$(list).find(options.subset).removeClass(options.subset_hidden);
				if (val) {
					App.menu.obj_window?.find('.switch_search_mode b').text(val);
					if (typeof el == 'object') $(el).closest('.in').add(list).addClass('search_started');
					else $(list).addClass('search_started');

					let str = val.replace(/\s+/ig, ' ').toLowerCase().replace(/^\s+|\s+$/g, '');
					let str_tr = App.helper.keyboard.switch(str);
					let words = str.split(' '); // utf-recheck
					let words_tr = str_tr.split(' '); // utf-recheck
					$(list).find(options.group + ' ' + options.item).each(function () {
						let txt = $(this).find(options.title).text().toLowerCase();
						if ($(this).attr('data-search-txt')) txt += ' ' + $(this).attr('data-search-txt').toLowerCase();
						let j = self.helper_match_count(txt, words, words_tr);
						if (j === words.length || (val.startsWith('#') && '#' + $(this).attr('data-id') === val)) {
							$(this).removeClass(options.item_hidden).css({opacity: 1});
						} else {
							$(this).addClass(options.item_hidden);
						}
					});

					has_results = App.controls.menu.process_groups_visibility(list, options);
					if (has_results) {
						self.letters_with_empty_result = 0;
					} else {
						if ($(list).find('.menu__searchText').length) {
							console.log(App.helper.html.encode('"' + val + '"'))
							$(list).find('.menu__searchText').html(App.helper.html.encode('"' + val + '"'));
						}
						self.letters_with_empty_result++;
					}
				} else {
					if (typeof el == 'object') $(el).closest('.in').add(list).removeClass('search_started');
					else $(list).removeClass('search_started');

					$(list).find(options.item).removeClass(options.item_hidden).css({opacity: 1});
					$(list).find('.' + options.item_waste_class).addClass(options.item_hidden);

					let o = $(list).find(options.group + ':visible').find(options.item)
						.not('.' + options.item_hidden)
						.not('.' + options.item_picked)
						.not('.' + options.item_not_possible_class);

					if (!options.allow_empty_groups) {
						$(list).find(options.group).addClass(options.group_hidden); // this was commented earlier -- may cause problems
						$(list).find(options.subset).addClass(options.subset_hidden);
						o.parents(options.group).removeClass(options.group_hidden);
						o.parents(options.subset).removeClass(options.subset_hidden);
					}
					$(list).find(options.empty).hide();
					$(list).find(options.hide_on_search_empty_selector).each(function () {
						if ($(this).hasClass('menu__group')) {
							$(this).removeClass('menu__group-hidden')
						} else if ($(this).hasClass('menu__item')) {
							$(this).removeClass('menu__item-hidden')
						} else {
							$(this).show();
						}
					});
					$(list).find(options.tip_selector).removeClass('ws-utility-hidden');
					has_results = true;
				}
				if (!options.skip_selection) {
					let container = list;
					if (!container.is('.keyboardZone')) container = container.closest('.keyboardZone');
					if (!container.length) container = list.find('.keyboardZone-active'); // для меню з пікером
					App.keyboard_selection.set_active_container(container);
					if (clear_selection) {
						$(container).find('.selected').toggleSelected(false);
					} else if ($(container).find('.selected').length === 0 || $(container).find('.selected').is(':hidden')) {
						$(container).find('.selected').toggleSelected(false);
						let o = $(container).find(options.item)
							.not('.' + options.item_hidden)
							.not('.' + options.item_picked)
							.not('.' + options.item_not_possible_class)
							.not('.menu__item-skipSearchSelect');

						if (o.length && set_selection) {
							o.eq(0).toggleSelected(true);
						}
					}
				}
				if (options.callback) options.callback(has_results, val);
			}
		},
		tasks: {
			apply: function (el, list) {
				if (el.value) {
					$(el).parent().addClass('search_started');
					let str = el.value.replace(/\s+/ig, ' ').toLowerCase().replace(/^\s+|\s+$/g, '')
					let str_tr = App.helper.keyboard.switch(str);
					let task_words = str.split(' '); // utf-recheck
					let task_words_tr = str_tr.split(' '); // utf-recheck
					$(list).find('.item, .mm_task_list').hide();
					found = false;
					$(list).find('.mm_float').each(function () {
						if ($(this).parent().hasClass('waste')) return;
						txt = $(this).text().toLowerCase();
						j = 0;
						for (let i = 0; i < task_words.length; i++) if (txt.indexOf(task_words[i]) !== -1) j++;
						if (j === task_words.length) { // j > 0
							found = true;
							$(this).parent().filter('.mm_task_list').show().find('.item').show().css({opacity: 0.5});
						}
						if (j === 0) {
							for (let i = 0; i < task_words_tr.length; i++) if (txt.indexOf(task_words_tr[i]) !== -1) j++;
							if (j === task_words_tr.length) { // j > 0
								found = true;
								$(this).parent().filter('.mm_task_list').show().find('.item').show().css({opacity: 0.5});
							}
						}
					});
					$(list).find('.modal__dataTable__item-level0, .itm').each(function () {
						txt = $(this).find('a.t, a.t_').text().toLowerCase();
						j = 0;
						for (let i = 0; i < task_words.length; i++) if (txt.indexOf(task_words[i]) !== -1) j++;
						if (j === task_words.length) { // j > 0
							found = true;
							if (j === task_words.length) $(this).show().css({opacity: 1}); else $(this).show().css({opacity: 0.5});
							$(this).parent().filter('.mm_task_list').show();
						}
						if (j === 0) {
							for (let i = 0; i < task_words_tr.length; i++) if (txt.indexOf(task_words_tr[i]) !== -1) j++;
							if (j === task_words_tr.length) { // j > 0
								found = true;
								if (j === task_words_tr.length) $(this).show().css({opacity: 1}); else $(this).show().css({opacity: 0.5});
								$(this).parent().filter('.mm_task_list').show();
							}
						}
					});
					if ($(list).find('.selected').length === 0 || $(list).find('.selected').is(':hidden')) {
						$(list).find('.selected').toggleSelected(false);
						let o = $(list).find('.modal__dataTable__item-level0:visible');
						if (o.length) {
							o.eq(0).toggleSelected(true);
						}
					}
					if (found && !$(list).find('.mm_task_list:visible').not('.waste').length) {
						$(list).find('.item_empty').hide();
						$(list).find('.item_empty2').show();
					} else if (found) {
						$(list).find('.item_empty, .item_empty2').hide();
					} else {
						$(list).find('.item_empty').show();
						$(list).find('.item_empty2').hide();
					}
				} else {
					$(el).parent().removeClass('search_started');
					$(list).find('.item, .mm_task_list').show().css({opacity: 1});
					$(list).find('.waste').hide();
					$(list).find('.item_empty, .item_empty2').hide();
				}
			}
		},

		helper_match_count: function(txt, words, words_tr) {
			let j = 0;
			for (let i = 0; i < words.length; i++) {
				if (txt.indexOf(words[i]) !== -1) j++;
			}
			if (j === 0) {
				for (let i = 0; i < words_tr.length; i++) {
					if (txt.indexOf(words_tr[i]) !== -1) j++;
				}
			}
			if (j === 0) {
				let str_translit = App.helper.translit.convert(words.join(' '));
				for (let i = 0; i < str_translit.length; i++) {
					if (txt.indexOf(str_translit[i]) !== -1) j++;
				}
			}
			return j;
		}
	}
})();

;var App = App || {};

(function () {
	let self = App.search_stemmer = {
		suffixes: {
			'en': ['ing', 'ed', 'es', 's', 'er', 'ly', 'ness', 'ment', 'ation', 'able', 'ous', 'al', 'est', 'ful', 'ive', 'less', 'ic', 'en', 'ize'],
			'uk': ['гія', 'гії', 'гій', 'ії', 'ї', 'ій', 'ією', 'іїю', 'єю', 'ами', 'ями', 'еві', 'ові', 'у', 'ю', 'і', 'е', 'а', 'о', 'ом', 'ем', 'ів', 'ей', 'ах', 'ях', 'ий', 'ого', 'ому', 'им', 'ою', 'ше', 'ші', 'ія', 'їв', 'єй', 'ов', 'ев', 'ам', 'ям', 'и', 'я', 'ими', 'іми'],
			'ru': ['ией', 'иею', 'иям', 'иями', 'ии', 'ий', 'ами', 'ями', 'ов', 'ев', 'ом', 'ем', 'у', 'е', 'а', 'ы', 'ого', 'ему', 'ее', 'ую', 'их', 'ие', 'яя', 'ша', 'ше', 'ших', 'шею', 'ить', 'ишь', 'ит', 'им', 'ите', 'ят', 'ал', 'ала', 'али', 'ло', 'ешь', 'ете', 'ами','ями','ах','ях','ов','ев','ей','ам','ям','ы','и','а','я'],
			'pl': ['ność', 'ności', 'nościami', 'nych', 'ni', 'nia', 'ami', 'owie', 'ach', 'ie', 'ego', 'ych', 'ym', 'em', 'ów', 'ą', 'ę', 'a', 'i', 'o', 'u', 'ej', 'emu', 'ymi', 'cie', 'mi', 'liśmy', 'cież', 'szmy', 'łeś', 'ami','ach','ów','i','y','e','om','owie','owiec','owieści'],
			'es': ['ía', 'ías', 'éis', 'ieron', 'iera', 'ando', 'iendo', 'ar', 'er', 'ir', 'ado', 'ido', 'as', 'es', 'ís', 'amos', 'emos', 'áis', 'an', 'en', 'aba', 'ía', 'arán', 'aré', 'ará'],
			'fr': ['ienne', 'iennes', 'ion', 'iens', 'ien', 'ie', 'ement', 'issant', 'ation', 'eur', 'euse', 'euses', 'ifs', 'ives', 'ité', 'ées', 'é', 'er', 'ez', 'ons', 'ais', 'ait', 'ant', 'ante', 'ants', 'èrent', 'iez', 'aient'],
			'de': ['keit', 'lichkeit', 'tät', 'tion', 'isch', 'en', 'er', 'n', 'e', 'em', 'es', 's', 'ung', 'lich', 'end', 'est', 'ste', 'sten', 'ischen', 'iger', 'igem'],
			'it': ['zione', 'zioni', 'ità', 'are', 'ere', 'ire', 'ato', 'uto', 'ito', 'a', 'e', 'i', 'o', 'ano', 'amo', 'ate', 'endo', 'ando'],
			'ro': ['iilor', 'iile', 'iia', 'iei', 'ii', 'ului', 'elor', 'ile', 'ul', 'ea', 'ei', 'e', 'a', 'u', 'ând', 'ind', 'eşte', 'esc', 'eam', 'eai', 'eau', 'iţi', 'im'],
			'pt-br': ['idade', 'idades', 'mente', 'ções', 'ção', 'ível', 'áveis', 'ando', 'endo', 'ar', 'er', 'ir', 'ado', 'ido', 'as', 'es', 'os', 'is', 'ável', 'ível', 'ista', 'osos', 'osas', 'inho', 'inha'],
			'kk': ['ларда', 'лардан', 'ның', 'нің', 'ға', 'ге', 'ды', 'ді', 'ты', 'мен', 'менен', 'дан', 'ден', 'та', 'те', 'лар', 'лер', 'ып', 'іп', 'ған', 'ген', 'атын', 'етін', 'ушы', 'уші', 'мақ', 'мек']
		},

		stopwords: {
			'en': ['a', 'an', 'and', 'the', 'in', 'on', 'at', 'by', 'of', 'for', 'to', 'with', 'as', 'is', 'are', 'was', 'were', 'be'],
			'uk': ['і', 'та', 'в', 'на', 'з', 'до', 'що', 'який', 'це', 'не', 'як', 'у', 'по', 'без', 'аби', 'щоб'],
			'ru': ['и', 'в', 'на', 'не', 'что', 'как', 'а', 'по', 'с', 'за', 'от', 'без', 'или', 'же', 'у'],
			'pl': ['i', 'w', 'na', 'że', 'do', 'z', 'o', 'po', 'bez', 'czy', 'nie', 'jak'],
			'es': ['el', 'la', 'los', 'las', 'de', 'en', 'por', 'con', 'y', 'a', 'que', 'es', 'un', 'una', 'no'],
			'fr': ['le', 'la', 'les', 'un', 'une', 'des', 'en', 'dans', 'par', 'avec', 'et', 'à', 'pour', 'de', 'que'],
			'de': ['der', 'die', 'das', 'und', 'in', 'zu', 'den', 'von', 'mit', 'auf', 'für', 'ist', 'nicht', 'ein'],
			'it': ['il', 'la', 'i', 'gli', 'le', 'un', 'una', 'e', 'di', 'che', 'per', 'con', 'in', 'su', 'a'],
			'ro': ['şi', 'în', 'la', 'cu', 'de', 'pe', 'din', 'un', 'o', 'este', 'să', 'că', 'nu'],
			'pt-br': ['a', 'o', 'as', 'os', 'de', 'do', 'da', 'dos', 'das', 'em', 'no', 'na', 'nos', 'nas', 'e', 'ou', 'mas', 'que', 'se', 'por', 'com', 'sem', 'um', 'uma', 'uns', 'umas', 'eu', 'tu', 'ele', 'ela', 'nós', 'vós', 'eles', 'elas', 'é', 'foi', 'são', 'era', 'vai', 'tem', 'tinha', 'há'],
			'kk': ['мен', 'сен', 'ол', 'біз', 'сіз', 'осы', 'сол', 'осында', 'сонда', 'және', 'немесе', 'да', 'де', 'ма', 'ме', 'ба', 'бе', 'па', 'пе', 'бір', 'екі', 'үш', 'тек', 'әрі', 'осылай', 'сондай', 'бар', 'жоқ', 'болды', 'еді', 'еткен', 'қазір', 'кейін', 'the', 'and', 'or', 'not', 'in', 'on']
		},

		languageFallbacks: {
			'uk': ['ru', 'en'],
			'ru': ['uk', 'en'],
			'en': ['uk', 'ru'],
			'pl': ['uk', 'ru'],
			'es': ['pt-br', 'en'],
			'pt-br': ['es', 'en'],
			'fr': ['en'],
			'de': ['en'],
			'it': ['ro', 'fr'],
			'ro': ['it', 'fr'],
			'kk': ['ru', 'uk']
		},

		map_stem: {},

		init: function () {
			for (let lang in self.suffixes) {
				self.suffixes[lang].sort((a, b) => b.length - a.length);
			}
		},
		stem: function (word, lang) {
			word = word.toLowerCase();
			const langs = [lang, ...(self.languageFallbacks[lang] || [])];

			for (let currentLang of langs) {
				const list = self.suffixes[currentLang] || [];
				for (let suffix of list) {
					if (word.endsWith(suffix)) {
						const stemmed = word.slice(0, word.length - suffix.length);
						self.map_stem[word] = {
							stem: stemmed,
							lang: currentLang
						};
						return stemmed;
					}
				}
			}
			self.map_stem[word] = {
				stem: word,
				lang: false
			};
			return word;
		},

		isStopWord: function (word, lang) {
			return (self.stopwords[lang] || []).includes(word.toLowerCase());
		},

		filterStopWords: function (words, lang) {
			return words.filter(w => !self.isStopWord(w, lang));
		},

		tokenize: function (text) {
			return text.toLowerCase().split(/[^\p{L}\p{N}]+/u).filter(Boolean);
		},

		preprocessText: function (text, lang) {
			self.map_stem = {}; // очищення карти перед новою обробкою
			const tokens = self.tokenize(text);
			const filtered = self.filterStopWords(tokens, lang);
			return filtered.map(w => self.stem(w, lang));
		},

		matchText: function (text, query, lang, requireAll = false) {
			text = text.toLowerCase().replace(/<[^>]+>/g, '');
			const tokens = self.preprocessText(query, lang);

			for (let stem of tokens) {
				const detectedLang = self.map_stem[stem]?.lang || lang;
				const suffixes = self.suffixes[detectedLang] || [];
				const group = suffixes.map(s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
				let pattern;
				if (detectedLang === false) {
					pattern = new RegExp(stem, 'iu');
				} else {
					const suffixes = self.suffixes[detectedLang] || [];
					const group = suffixes.map(s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
					pattern = new RegExp('(^|[^\p{L}])' + stem + '(' + group + ')?([^\p{L}]|$)', 'iu');
				}

				const matched = pattern.test(text);
				if (requireAll && !matched) return false;
				if (!requireAll && matched) return true;
			}

			return requireAll;
		},

		getRegexPattern: function (stem, lang) {
			const meta = self.map_stem[stem] || {lang};
			const detectedLang = meta.lang;

			if (detectedLang === false) {
				return new RegExp(stem, 'iu');
			}

			const suffixes = self.suffixes[detectedLang] || [];
			const group = suffixes.map(s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
			return new RegExp('(^|[^\p{L}])' + stem + '(' + group + ')?([^\p{L}]|$)', 'iu');
		}
	};

	self.init();
})();

;(function () {
	let self = App.setup_guide = {
		editMode: false,
		selectionType: 'target', // 'target' or 'trigger'

		picked: {
			selector: '',
			pickToken: '',
			rootEl: null,
			chain: [],
			treeJson: [],
			currentIdx: 0,
			checked: {
				classes: Object.create(null),
				attrs: Object.create(null),
			},
		},

		highlight: { el: null },

		init: function() {
			if (App.env !== 'local' && App.env !== 'dev') return;
			document.addEventListener('keydown', self._onKeyDown);
			document.addEventListener('click', self._onClick, true);
			console.log('[setup_guide] init done');
		},

		_onKeyDown: function(e) {
			// Alt+G — вкл/викл edit mode
			if (e.altKey && e.key.toLowerCase() === 'g') {
				self.editMode = !self.editMode;
				console.log('[setup_guide] editMode:', self.editMode ? 'ON' : 'OFF');
			}

			if (!self.editMode) return;

			// Alt+1 — вибираємо target
			if (e.altKey && e.key === '1') {
				self.selectionType = 'target';
				console.log('[setup_guide] selectionType: target');
			}

			// Alt+2 — вибираємо trigger
			if (e.altKey && e.key === '2') {
				self.selectionType = 'trigger';
				console.log('[setup_guide] selectionType: trigger');
			}
		},

		_onClick: function(e) {
			if (App.modal.is_shown() && App.modal.obj_window.attr('data-group') === 'guide') return;
			if (!self.editMode) return;
			if (!e.altKey) return;

			e.preventDefault();
			e.stopPropagation();

			const el = e.target;
			const selector = self._buildSelector(el);

			console.log('[setup_guide]', self.selectionType, selector, el);

			self._handlePickedElement(selector, el);
		},

		_copyComputedStylesDeep: function(srcEl, dstEl) {
			if (!srcEl || !dstEl) return;

			const ALLOW = new Set([
				'display','position','top','right','bottom','left',
				'box-sizing',
				'width','height','min-width','min-height','max-width','max-height',
				'margin','margin-top','margin-right','margin-bottom','margin-left',
				'padding','padding-top','padding-right','padding-bottom','padding-left',
				'border','border-top','border-right','border-bottom','border-left',
				'border-width','border-style','border-color',
				'border-radius','border-top-left-radius','border-top-right-radius','border-bottom-right-radius','border-bottom-left-radius',
				'outline','outline-width','outline-style','outline-color','outline-offset',

				'color','font-family','font-size','font-weight','font-style',
				'line-height','letter-spacing','text-align','text-transform','text-decoration',
				'white-space','text-overflow','word-break','overflow-wrap',

				'background','background-color','background-image','background-size','background-position','background-repeat',
				'opacity','visibility',
				'box-shadow',
				'filter',

				'flex','flex-grow','flex-shrink','flex-basis','flex-direction','flex-wrap',
				'justify-content','align-items','align-content','align-self','order',
				'gap','row-gap','column-gap',
				'grid','grid-template-columns','grid-template-rows','grid-template-areas',
				'grid-area','grid-column','grid-row',

				'overflow','overflow-x','overflow-y',
				'cursor',
			]);

			const shouldSkip = (prop, val) => {
				if (!prop) return true;

				if (prop.startsWith('--')) return true;

				if (prop === 'accent-color') return true;
				if (prop === 'transition') return true; // в превʼю не треба
				if (prop === 'animation') return true;

				if (val == null || val === '') return true;

				if (prop === 'box-shadow') {
					const v = String(val || '').replace(/\s+/g, ' ').trim();

					const bad1 = 'rgb(0, 121, 224) 0px 0px 0px 1px, rgba(0, 153, 255, 0.24) 0px 0px 0px 4px';

					const looksLike =
						v.includes('rgb(0, 121, 224)') &&
						v.includes('rgba(0, 153, 255, 0.24)') &&
						v.includes('0px 0px 0px 1px') &&
						v.includes('0px 0px 0px 4px');

					if (v === bad1 || looksLike) return true;
				}

				if (!ALLOW.has(prop)) return true;

				return false;
			};

			const needTempUnhighlight = self.highlight && self.highlight.el === srcEl && srcEl.classList && srcEl.classList.contains('setupGuide__highlight');
			if (needTempUnhighlight) {
				try { srcEl.classList.remove('setupGuide__highlight'); } catch (e) {}
			}

			const copyOne = (src, dst) => {
				const cs = window.getComputedStyle(src);

				let cssText = '';
				for (let i = 0; i < cs.length; i++) {
					const prop = cs[i];
					const val = cs.getPropertyValue(prop);
					const prio = cs.getPropertyPriority(prop);

					if (shouldSkip(prop, val)) continue;

					cssText += `${prop}:${val}${prio ? ' !important' : ''};`;
				}

				dst.style.cssText = cssText;

				dst.style.setProperty('pointer-events', 'none', 'important');

				if (cs.display === 'none') dst.style.setProperty('display', 'block', 'important');
				if (cs.opacity === '0' || parseFloat(cs.opacity) === 0) dst.style.setProperty('opacity', '1', 'important');
				if (cs.visibility === 'hidden') dst.style.setProperty('visibility', 'visible', 'important');
			};

			try {
				copyOne(srcEl, dstEl);

				const srcAll = srcEl.querySelectorAll('*');
				const dstAll = dstEl.querySelectorAll('*');

				const len = Math.min(srcAll.length, dstAll.length);
				for (let i = 0; i < len; i++) {
					copyOne(srcAll[i], dstAll[i]);
				}
			} finally {
				if (needTempUnhighlight) {
					try { srcEl.classList.add('setupGuide__highlight'); } catch (e) {}
				}
			}
		},

		_handlePickedElement: function(selector, el) {
			if (App.modal.is_shown() && App.modal.obj_window.attr('data-group') === 'guide') return;

			const page = window.location.pathname;
			const type = self.selectionType;

			// стабільний маркер — щоб модалка брала саме клікнутий елемент
			self._markPickedElement(el);

			const query =
				App.actions.get('setup_guide:show')
				+ '&selector=' + encodeURIComponent(selector)
				+ '&page=' + encodeURIComponent(page)
				+ '&type=' + encodeURIComponent(type);

			App.modal.show({
				url: App.helper.url.add_query('/ajax/', query),
				width: 500,
				backup: true,
				group: 'guide',
				title: 'Вибір елемента',
				onload: function (){
					App.setup_guide.helper_modal($(this));
				},
				onhide: function () {
					App.setup_guide._highlightClear();
					App.setup_guide._unmarkPickedElement();
				},
			});

			console.log('[setup_guide] open modal with selector:', selector, { page, type });
		},

		_markPickedElement: function(el) {
			try {
				document.querySelectorAll('[data-sg-pick]').forEach(n => n.removeAttribute('data-sg-pick'));
			} catch (e) {}

			const token = 'sg_' + Date.now() + '_' + Math.random().toString(16).slice(2);
			self.picked.pickToken = token;

			try {
				if (el && el.setAttribute) el.setAttribute('data-sg-pick', token);
			} catch (e) {}
		},

		_unmarkPickedElement: function() {
			const token = self.picked.pickToken;
			if (!token) return;

			try {
				const el = document.querySelector(`[data-sg-pick="${token}"]`);
				if (el) el.removeAttribute('data-sg-pick');
			} catch (e) {}

			self.picked.pickToken = '';
		},

		_findClickableRoot: function(el) {
			if (!el || el.nodeType !== 1) return el;

			const isClickable = (node) => {
				if (!node || node.nodeType !== 1) return false;

				const tag = node.tagName ? node.tagName.toLowerCase() : '';
				if (tag === 'ws-btn' || tag === 'a') return true;

				if (node.getAttribute && node.getAttribute('onclick')) return true;
				if (node.hasAttribute && (node.hasAttribute('data-target') || node.hasAttribute('data-url'))) return true;

				return false;
			};

			let node = el;
			let safety = 0;

			while (node && node.nodeType === Node.ELEMENT_NODE && safety < 30) {
				safety++;
				if (isClickable(node)) return node;
				if (node === document.body) break;
				node = node.parentElement;
			}

			return el;
		},

		_buildSelector: function (el) {
			if (!el || el.nodeType !== 1) return '';

			el = self._findClickableRoot(el);

			const isGoodId = (id) => !!id && !/^\d+$/.test(id);

			const isSafeAttrValue = (val) => {
				if (!val) return false;
				if (val.includes('"') || val.includes("'")) return false;
				return true;
			};

			const buildPart = (node) => {
				let part = node.nodeName.toLowerCase();

				if (node.classList && node.classList.length) {
					const classes = Array.from(node.classList)
						.filter(c => !/^js-/.test(c) && !/^ng-/.test(c))
						.slice(0, 3);

					if (classes.length) part += '.' + classes.join('.');
				}

				const nameAttr = node.getAttribute && node.getAttribute('name');
				if (nameAttr && isSafeAttrValue(nameAttr)) {
					part += `[name="${nameAttr}"]`;
				}

				if (part === 'a') {
					const href = node.getAttribute && node.getAttribute('href');
					if (href && isSafeAttrValue(href)) {
						part += `[href="${href}"]`;
					}
				}

				if (node.attributes && node.attributes.length) {
					for (const attr of Array.from(node.attributes)) {
						const attrName = attr.name;
						if (!attrName.startsWith('data-')) continue;
						if (attrName === 'data-title' || attrName === 'data-deep') continue;

						const val = attr.value;
						if (!isSafeAttrValue(val)) continue;

						part += `[${attrName}="${val}"]`;
					}
				}

				return part;
			};

			const parts = [];
			let node = el;
			let safetyCounter = 0;

			while (node && node.nodeType === Node.ELEMENT_NODE && safetyCounter < 30) {
				safetyCounter++;

				if (isGoodId(node.id)) {
					parts.unshift('#' + node.id);
					break;
				}

				if (node === document.body) {
					parts.unshift('body');
					break;
				}

				parts.unshift(buildPart(node));
				node = node.parentElement;
			}

			return parts.join(' > ');
		},

		_parseElementToJson: function(el) {
			const out = { tag: null, id: null, classes: [], attrs: [] };
			if (!el || el.nodeType !== 1) return out;

			out.tag = (el.tagName || '').toLowerCase();
			out.id = el.id || null;

			if (el.classList && el.classList.length) {
				out.classes = Array.from(el.classList);
			}

			const nm = el.getAttribute && el.getAttribute('name');
			if (nm) out.attrs.push({ name: 'name', value: nm });

			if (out.tag === 'a') {
				const href = el.getAttribute && el.getAttribute('href');
				if (href) out.attrs.push({ name: 'href', value: href });
			}

			if (el.attributes && el.attributes.length) {
				for (const a of Array.from(el.attributes)) {
					const n = a.name;
					if (!n || !n.startsWith('data-')) continue;
					if (n === 'data-title' || n === 'data-deep') continue;
					if (!a.value) continue;
					out.attrs.push({ name: n, value: a.value });
				}
			}

			return out;
		},

		_buildChainFromAnchor: function(el) {
			const isGoodId = (id) => !!id && !/^\d+$/.test(id);

			const chain = [];
			let node = el, safety = 0;

			while (node && node.nodeType === 1 && safety < 40) {
				safety++;
				chain.unshift(node);

				if (isGoodId(node.id)) break;
				if (node === document.body) break;

				node = node.parentElement;
			}

			return chain;
		},

		_isTooBigToPreview: function(el) {
			try {
				const r = el.getBoundingClientRect();
				const w = Math.round(r.width);
				const h = Math.round(r.height);

				if (w <= 0 || h <= 0) return true;

				const area = w * h;

				if (w > 400 || h > 400) return true;
				if (area > 160000) return true;

				return false;
			} catch (e) {
				return true;
			}
		},

		_renderElementPreviewInModal: function(modal) {
			const st = self.picked;
			const $holder = modal.find('.setupGuide__element');
			$holder.empty();

			const el = st.chain[st.currentIdx];
			if (!el) {
				$holder.text('Елемент не знайдено.');
				return;
			}

			if (self._isTooBigToPreview(el)) {
				$holder.text('Розмір елемента завеликий для відображення');
				return;
			}

			let $clone = $(el).clone(false, false);
			$clone.removeAttr('id');

			$clone.removeClass('setupGuide__highlight');
			$clone.find('.setupGuide__highlight').removeClass('setupGuide__highlight');

			$clone.find('a').attr('href', 'javascript:void(0);');
			$clone.find('form').attr('action', 'javascript:void(0);');
			$clone.find('input, textarea').prop('disabled', true);
			$clone.find('button, ws-btn').prop('disabled', true);

			$holder.append($clone);

			try {
				self._copyComputedStylesDeep(el, $clone.get(0));
			} catch (e) {
				console.warn('[setup_guide] failed to copy computed styles', e);
			}
		},

		_renderCheckboxesInModal: function(modal) {
			const st = self.picked;
			const $mount = modal.find('.setupGuide__treeMount');
			$mount.empty();

			const json = st.treeJson[st.currentIdx] || { classes: [], attrs: [] };

			const esc = (s) => String(s)
				.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
				.replace(/"/g,'&quot;').replace(/'/g,'&#039;');

			const renderGroup = (title, itemsHtml) => `
				<div class="line" style="margin-top: 16px;"></div>
				<div class="menu__group__wrapper flex_column">
					<div class="menu__group menu__group-projects menu__group-searchable menu__group-checkbox">
						<div class="menu__group__title-bold">${esc(title)}</div>
						${itemsHtml || `<div class="menu__item flex_row"><span class="in flex_content">—</span></div>`}
					</div>
				</div>`;

			let classesHtml = '';
			json.classes.forEach((cls) => {
				const key = 'c:' + cls;
				const on = (st.checked.classes[key] !== false);
				classesHtml += `
					<a class="menu__item flex_row ${on ? 'menu__item-active' : ''}" href="javascript:void(0);" data-kind="class" data-key="${esc(key)}">
						<ws-icon name="checkbox"></ws-icon>
						<span class="in flex_content">${esc(cls)}</span>
					</a>`;
			});

			let attrsHtml = '';
			json.attrs.forEach((it) => {
				const key = 'a:' + it.name + '=' + it.value;
				const on = (st.checked.attrs[key] !== false);
				attrsHtml += `
					<a class="menu__item flex_row ${on ? 'menu__item-active' : ''}" href="javascript:void(0);" data-kind="attr" data-key="${esc(key)}">
						<ws-icon name="checkbox"></ws-icon>
						<span class="in flex_content">${esc(it.name)}="${esc(it.value)}"</span>
					</a>`;
			});

			$mount.append(renderGroup('Класи', classesHtml));
			$mount.append(renderGroup('Атрибути', attrsHtml));

			$mount.off('click.setupGuide').on('click.setupGuide', 'a.menu__item[data-kind]', function() {
				const kind = $(this).data('kind');
				const key = $(this).data('key');

				if (kind === 'class') {
					st.checked.classes[key] = (st.checked.classes[key] === false);
				} else {
					st.checked.attrs[key] = (st.checked.attrs[key] === false);
				}

				$(this).toggleClass('menu__item-active');

				self._updateSelectorInputInModal(modal);
			});
		},

		_movePickedCurrent: function(modal, dir) {
			const st = self.picked;
			if (!st.chain || !st.chain.length) return;

			let next = st.currentIdx + dir;
			if (next < 0) next = 0;
			if (next >= st.chain.length) next = st.chain.length - 1;
			if (next === st.currentIdx) return;

			st.currentIdx = next;

			st.checked = { classes: Object.create(null), attrs: Object.create(null) };

			self._renderElementPreviewInModal(modal);
			self._renderCheckboxesInModal(modal);
			self._updateSelectorInputInModal(modal);

			self._highlightApply(self.picked.chain[self.picked.currentIdx]);
		},

		_highlightApply: function(el) {
			if (!el || el.nodeType !== 1) return;

			try {
				if (el.closest && el.closest('.setupGuide__container')) return;
			} catch (e) {}

			if (self.highlight.el && self.highlight.el !== el) {
				self._highlightClear();
			}
			if (self.highlight.el === el) return;

			self.highlight.el = el;
			try { el.classList.add('setupGuide__highlight'); } catch (e) {}
		},

		_highlightClear: function() {
			const el = self.highlight.el;
			if (!el || el.nodeType !== 1) {
				self.highlight.el = null;
				return;
			}
			try { el.classList.remove('setupGuide__highlight'); } catch (e) {}
			self.highlight.el = null;
		},

		_buildSelectorPartFromJson: function(json, checked) {
			if (!json) return '';

			let part = (json.tag || 'div');

			if (json.id) part += '#' + json.id;

			if (json.classes && json.classes.length) {
				const keep = [];
				for (const cls of json.classes) {
					const key = 'c:' + cls;
					if (!checked || checked.classes[key] !== false) keep.push(cls);
				}
				if (keep.length) part += '.' + keep.join('.');
			}

			if (json.attrs && json.attrs.length) {
				for (const it of json.attrs) {
					const key = 'a:' + it.name + '=' + it.value;
					if (checked && checked.attrs[key] === false) continue;

					const v = String(it.value).replace(/"/g, '\\"');
					part += `[${it.name}="${v}"]`;
				}
			}

			return part;
		},

		_buildFullSelectorFromPicked: function() {
			const st = self.picked;
			if (!st.treeJson || !st.treeJson.length) return '';

			const parts = [];
			const last = Math.min(st.currentIdx, st.treeJson.length - 1);

			for (let i = 0; i <= last; i++) {
				const json = st.treeJson[i];

				// anchor
				if (json && json.id && i === 0) {
					parts.push('#' + json.id);
					continue;
				}

				const checked = (i === last) ? st.checked : null;
				parts.push(self._buildSelectorPartFromJson(json, checked));
			}

			return parts.join(' > ');
		},

		_updateSelectorInputInModal: function(modal) {
			const $inp = modal.find('form input[name="selector"]');
			if (!$inp.length) {
				console.warn('[setup_guide] selector input not found in modal');
				return;
			}

			const sel = self._buildFullSelectorFromPicked();
			$inp.val(sel).trigger('change');

			console.log('[setup_guide] selector updated', {
				currentIdx: self.picked.currentIdx,
				selector: sel,
			});
		},

		helper_modal: function(modal) {
			const selector = (modal.find('form input[name=selector]').val() || '').trim();

			modal.find('.setupGuide__element').empty();
			modal.find('.setupGuide__treeMount').empty();

			if (!selector) {
				modal.find('.setupGuide__element').text('Селектор не передано.');
				return;
			}

			let el = null;
			const token = self.picked.pickToken;
			if (token) {
				try {
					el = document.querySelector(`[data-sg-pick="${token}"]`);
				} catch (e) {}
			}

			if (!el) {
				try { el = document.querySelector(selector); } catch (e) {}
			}

			self._unmarkPickedElement();

			if (!el) {
				modal.find('.setupGuide__element').text('Елемент за селектором не знайдено на сторінці.');
				return;
			}

			self.picked.selector = selector;
			self.picked.rootEl = el;
			self.picked.chain = self._buildChainFromAnchor(el);
			self.picked.treeJson = self.picked.chain.map(n => self._parseElementToJson(n));
			self.picked.currentIdx = self.picked.chain.length ? (self.picked.chain.length - 1) : 0;
			self.picked.checked = { classes: Object.create(null), attrs: Object.create(null) };

			modal.off('click.setupGuidePick').on('click.setupGuidePick', '.js-sg-up, .js-sg-down', function() {
				const dir = $(this).hasClass('js-sg-up') ? -1 : +1;
				self._movePickedCurrent(modal, dir);
			});

			modal.off('click.setupGuideSubmit').on('click.setupGuideSubmit', '.buttons ws-btn', function() {
				let inp = modal.find('.setupGuide__input input[name=name]');
				if (!inp.val().length) {
					inp.addClass('input-error');
				} else {
					inp.removeClass('input-error');
					let form = modal.find('form');
					if (form.length) App.core.form_submit(form);
				}
			});

			self._renderElementPreviewInModal(modal);
			self._renderCheckboxesInModal(modal);
			self._updateSelectorInputInModal(modal);

			self._highlightApply(self.picked.chain[self.picked.currentIdx]);

			console.log('[setup_guide] picked.treeJson:', self.picked.treeJson);
		},

		enable: function() {
			self.editMode = true;
			console.log('[setup_guide] editMode: ON');
		},

		disable: function() {
			self.editMode = false;
			console.log('[setup_guide] editMode: OFF');
		},

		onLoadPage() {
			self.init();
		}
	};

})();

;var App = App || {};

(function() {
	let sidebar_featured_project = App.helper.localStorage.value('sidebar_featured_project', null);

	let self = App.sidebar = {
		status: null,
		ready: false,
		available: true,
		hot_counters: {},
		with_hidden_projects: false,
		with_arch_projects: false,
		with_empty_folders: false,
		count_new_projects: 0,
		loading_type: '',
		update_order_task: null,
		new_folder_ids: [],

		px_sidebar_impact: 0,
		process_media_css: function() {
			let px_sidebar_impact = 0;
			if ($(window).width() > MOBILE_SCREEN_THRESHOLD) px_sidebar_impact = $('body').hasClass('withSidebar') ? 300 : 0;
			if (px_sidebar_impact === self.px_sidebar_impact) return;
			for (let i in document.styleSheets) {
				if (document.styleSheets[i].href && document.styleSheets[i].href.indexOf('page.') !== -1) {
					let rules = document.styleSheets[i].cssRules;
					for (let j in rules) {
						if (rules[j].media) {
							rules[j].media.mediaText = rules[j].media.mediaText.replace(/(\d+)px/g, function(match, p1, offset, string) {
								return (1*p1 - px_sidebar_impact + self.px_sidebar_impact) + 'px';
							});
						}
					}
				}
			}
			self.px_sidebar_impact = px_sidebar_impact;
		},

		hide_mobile: function() {
			$('body').removeClass('mobileSidebar mobileSidebarFullscreen');
			if (self.search.is_focused()) self.search.blur();
		},

		cancel_mobile_fullscreen: function() {
			$('body').removeClass('mobileSidebarFullscreen');
		},

		with_any_sidebar: function() {
			return $('body').hasClass('withSidebar') || self.with_over_sidebar();
		},

		with_over_sidebar: function() {
			return $('body').hasClass('withSidebarOver');
		},

		slide: function () {
			if (self.with_any_sidebar()) {
				self.toggle(false, false, false);
			} else if ($(window).width() > MOBILE_SCREEN_THRESHOLD) {
				$('body').addClass('withSidebarOver');
			} else {
				self.toggle(true, false, false);
			}
		},

		show: function (save) {
			self.toggle(true, save === true, false);
		},

		close: function (save) {
			self.toggle(false, save === true, false);
		},

		toggle: function(is_on, save, focus_on_show = false) {
			if (save === true && $('body').hasClass('withSidebarOver')) save = false;

			if ($(window).width() < MOBILE_SCREEN_THRESHOLD) {
				if (typeof is_on === 'undefined' || is_on === null) return;
				$('body').toggleClass('mobileSidebar', is_on);
				if (!is_on) self.cancel_mobile_fullscreen();
				if (is_on && App.task_view.is_shown()) App.task_view.hide();
				if (is_on && App.right_panel.is_shown()) App.right_panel.hide();
			} else {
				$('body').removeClass('withSidebarOver');
				if (typeof is_on === 'undefined' || is_on === null) is_on = !self.available;
				else if (save) self.available = is_on;
				if ($('body').hasClass('withSidebar') === is_on) return;
				if (focus_on_show) {
					$('.sidebar__search input').toggleFocus(is_on);
				}
				$('body').addClass('animateSidebar');
				setTimeout(function () {
					if (App.controls.datatable.obj?.length) App.controls.datatable.shadows_remove();
					$('body').toggleClass('withSidebar', is_on);
					App.bus.app.emit('sidebar_toggle');
				}, 0);
				if (is_on) {
					self.process_media_css();
					//$('#content').css({width: $('#content').width() - 260, marginRight: -260}); // for? creating content twitching bug
					setTimeout(function() {
						$('#content').css({width: 'auto', marginRight: 0});
						$(window).trigger('resize.page');
					}, 300);
				} else {
					//$('#content').css({width: $('#content').width(), marginRight: -260}); // for? creating content twitching bug
					setTimeout(function() {
						$('#content').css({width: 'auto', marginRight: 0});
						self.process_media_css();
						$(window).trigger('resize.page');
					}, 300);
				}
				if (save) $.ajax({url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('process:collapse') + '&type=custom&id=' + App.collapse.CUSTOM_SIDEBAR + '&is_on=' + (is_on ? 1 : 0))});
				setTimeout(function () {
					$('body').removeClass('animateSidebar');
					App.helper.nextTick(() => App.controls.view_list.onresize());
				}, 400);
			}
		},
		set_active_page: function(id) {
			let o = $('.primaryMenu__item[data-page]');
			o.removeClass('primaryMenu__item-active');
			let ids = id.split('|', 2);
			if (ids[0]) {
				o.filter('[data-page='+ids[0]+']:not([data-subpage]), [data-page*=",'+ids[0]+',"]:not([data-subpage])')
					.addClass('primaryMenu__item-active').removeClass('wait');
			}
			if (ids[0] && ids[1] && o.filter('[data-subpage='+ids[1]+']').length) {
				o.removeClass('primaryMenu__item-active');
				o.filter('[data-page='+ids[0]+'][data-subpage='+ids[1]+']').addClass('primaryMenu__item-active').removeClass('wait');
			}
		},
		set_active_project: function(id) {
			if (!self.obj_projects) return;
			let o = self.obj_projects.find('.sidebar__projects__group .sidebar__projects__item');
			o.removeClass('sidebar__projects__item-active');
			if (id) {
				o = o.filter('[data-project='+id+']');
				o.addClass('sidebar__projects__item-active');
				o.parents('.sidebar__projects__moreContent').not('.sidebar__projects__moreContent-active').addClass('sidebar__projects__moreContent-active').prev().hide();
			}
		},

		set_custom_elements: function() {
			if (App.page.where() === 'search') {
				$('.primaryMenu__item[data-custom-page=search]').addClass('primaryMenu__item-active');
				$('.mobileMenu__bar__item[data-custom-page=search]').addClass('mobileMenu__bar__item-active');
			} else {
				$('.primaryMenu__item[data-custom-page=search]').removeClass('primaryMenu__item-active');
				$('.mobileMenu__bar__item[data-custom-page=search]').removeClass('mobileMenu__bar__item-active');
			}
		},

		update_visibility: function() {
			this.featured_project.save();

			$('.primaryMenu__item[data-bar=sidebar]').removeClass('wait').toggleClass('primaryMenu__item-active', !!App.current_page.project);

			// на мобілі відкриття екранної клавіатури викликає цю подію і замість пошуку - закриває сайдбар
			if (App.device.is_mobile()) return;

			self.toggle($(window).width() > MOBILE_SCREEN_THRESHOLD && self.available && !!App.current_page.project, false);
		},

		featured_project: {
			current: sidebar_featured_project.get(),
			default: null,
			save: function() {
				if (!App.current_page.project || !App.current_page.url) return;

				self.featured_project.current = {id: +App.current_page.project, url: App.current_page.url};
				sidebar_featured_project.set(self.featured_project.current);
				self.featured_project.update_title();
			},
			set_default: function (project) {
				self.featured_project.default = project;

				if (self.featured_project.current != null && [App.config.id_project_inbox, App.config.id_project_chat].includes(self.featured_project.current.id)) {
					self.featured_project.current = null;
				}
				if (self.featured_project.current != null && App.projects[self.featured_project.current.id] == null) {
					self.featured_project.current = null;
				}
				if (self.featured_project.current != null) return;

				self.featured_project.current = project;
				self.featured_project.update_title();
			},
			update_title: function () {
				const menu_item = $('#primaryMenu .primaryMenu__item[data-bar=sidebar]');
				const id_project = self.featured_project.current?.id || null;
				const project_name = App.helper.project(id_project, 'name');
				let title = App.object_state.locale.project;

				if (project_name) title += (project_name ? ': %B' + project_name + 'B%' : '');

				menu_item.attr('data-title', title);
			},
			load: function() {
				if (App.mymenu.is_shown()) App.mymenu.hide();
				if ($(window).width() < MOBILE_SCREEN_THRESHOLD) {
					self.toggle(!$('body').hasClass('mobileSidebar'))
				}

				if (self.featured_project.current?.url && self.featured_project.current.url !== App.current_page.url) {
					$('.primaryMenu__item[data-bar=sidebar]').addClass('wait');
					App.core.goto(self.featured_project.current.url);
				} else if (!self.available || $('body').attr('data-project') === '0') {
					self.slide();
				}
			},
			remove: function() {
				sidebar_featured_project.del();
				self.featured_project.current = self.featured_project.default;
				self.featured_project.update_title();
			}
		},

		project: {
			obj: null,
			endpoint: null,
			create: function(id, show_endpoint, apply_endpoint, txt) {
				if (this.obj !== null) return false;
				this.endpoint = apply_endpoint + '&id_group=' + id;
				this.obj = $('<div/>').addClass('sidebar__projects__group__add inline-edit').append($('<input type="text" />'));
				let a = $('<a class="wysiwyg thickbox" data-modal-url="'+show_endpoint+'" data-modal-backup="true" data-title="'+txt+'"></a>')
						.append('<ws-icon name="arrows/arrow_expand_sm"></ws-icon>')
						.bind('click', function() {
							$(this).attr('href', $(this).attr('href') + '&name=' + self.project.obj.find('input').val());
							self.project.end();
						});

				this.obj.append(a);
				this.obj.insertAfter($('#obj-folder' + id).find('.sidebar__projects__group__title'));
				this.obj.find('input').focus().bind('keydown', function(e) {
					let key = e.keyCode || e.charCode;
					e.stopPropagation();
					if (key === App.keycode.Enter) {
						if (this.value) self.project.save(this.value); else self.project.end();
						return false;
					} else if (key === App.keycode.Escape) {
						self.project.end();
						return false;
					}
				});
			},
			save: function() {
				$.ajax({
					url: this.endpoint + '&name=' + encodeURIComponent(this.obj.find('input').val()),
					context: this,
					success: function () {
						this.end();
					}.bind(this)
				});
			},
			end: function() {
				this.obj.remove();
				this.obj = null;
				this.endpoint = null;
			}
		},

		obj_projects: null,

		minibar_projects: null,
		type: null,
		no_effects: false,
		saved_scroll_pos: -1,

		remember_scroll: function () {
			self.saved_scroll_pos = $('#sidebar .sidebar__projects').scrollTop();
		},
		reset_scroll: function () {
			self.saved_scroll_pos = -1;
			$('#sidebar .sidebar__projects').scrollTop(0);
		},
		move_scroll: function (pos) {
			$('#sidebar .sidebar__projects').scrollTop(pos);
		},
		restore_scroll: function () {
			if (self.saved_scroll_pos < 0) return;

			$('#sidebar .sidebar__projects').scrollTop(self.saved_scroll_pos);
			self.saved_scroll_pos = -1;
		},
		sync_folder_filter_order: function () {
			let menu = $('#filterItem__group__menu');
			if (!menu.length) return;

			let target_group = menu.find('.scrollZone .menu__group-searchable').first();
			if (!target_group.length) return;

			$('#sidebar .sidebar__projects__group[data-key=folder]').each(function () {
				let item = menu.find('#slgr' + $(this).attr('data-group'));
				if (item.length) target_group.append(item);
			});
		},

		update_sidebar: function(callback) {
			self.load_sidebar('projects', 'sidebar_projects:show', callback);
			self.set_optional_menu();
			self.featured_project.update_title();
		},

		need_reload: App.helper.debounce((type) => self.reload(type), 100),

		reload: function(type, callback) {
			if (self.type === type) {
				self.type = null;
				self['obj_' + type] = null;
				self.no_effects = true;
				self.remember_scroll();
				self.load_sidebar(type, 'sidebar_' + type + ':show', () => {
					if (type === 'projects') {
						let unseen = Object.entries(App.projects).filter(([id, project]) => project.seen === false).length;
						let counter_container = $('#primaryMenu__project__counter');
						if (unseen > 0) {
							counter_container.html('<span class="cnt_new">' + unseen + '</span>');
						} else {
							counter_container.empty();
						}
						self.restore_scroll();
						self.sync_folder_filter_order();
						self.new_folder_ids.forEach(id => {
							let folder = $('#obj-folder' + id);
							if (!folder.length) return;
							folder.addClass('sidebar__projects__group-new');
							folder.find('.cnt_empty').after('<span class="cnt cnt_new">new</span>');
						});
					}
					if (callback) callback();
				});
			} else {
				self['obj_' + type] = null;
			}
		},

		preload_project: function(callback) {
			let type = 'projects'
			$.ajax({
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('sidebar_projects:show')),
				success: function (html) {
					const fragment = document.createRange().createContextualFragment(html);
					// document.getElementById('sidebar__wrapper').replaceChildren(fragment);
					$('#sidebar__wrapper').html('').append(fragment);
					self['obj_' + type] = $('#sidebar');
					self.set_active_project(App.current_page.project);
					self.init_projects();
					$('#sidebar').detach();
					if (callback) callback();
				}
			});
		},
		load_sidebar: function(type, action, callback) {
			if (!self.ready) {
				setTimeout(() => self.load_sidebar(type, action, callback), 50);
				return false;
			}
			if (type !== self.type) {
				if (self.type) self['obj_' + self.type].detach();
				if (self['obj_' + type]) {
					$('#sidebar__wrapper').append(self['obj_' + type]);
					self.set_active_project(App.current_page.project);
					if (!$('#sidebar').hasClass('sidebar-loaded')) setTimeout(function () {
						$('#sidebar').addClass('sidebar-loaded');
					});
					if (callback) callback();
				} else {
					self.loading_type = type;
					$.ajax({
						url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get(action)),
						success: function (html) {
							if (self['minibar_' + type]) {
								self['minibar_' + type].destroy();
								self['minibar_' + type] = null;
							}
							$('#sidebar__wrapper').html(html);
							self['obj_' + type] = $('#sidebar');
							if (self.no_effects) {
								$('#sidebar').addClass('sidebar-loaded');
								self.no_effects = true;
							} else {
								setTimeout(function () {
									$('#sidebar').addClass('sidebar-loaded');
								});
							}
							self.set_active_project(App.current_page.project);
							self.init_projects();
							if (callback) callback();
						},
						complete: function () {
							self.loading_type = '';
						}
					});
				}
				self.type = type;
			} else {
				if (callback) callback();
			}
			self.helper.clear_on_load();
		},
		load_primary_menu: function() {
			$.ajax({
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('primary_menu:show')),
				success: function(html) {
					$('#primaryMenu__wrapper').html(html);
					App.helper.nextTick(function() {
						$('#primaryMenu').addClass('primaryMenu-loaded');
						self.set_optional_menu();
						App.controls.me.menu.init();
						App.task_panel.update_counter();
					});
					$('.primaryMenu__head a').bind('contextmenu', function() {
						App.menu.show({anchor: this, box: '#sidebarAccMenu', type: 'fixed right', onshow: self.custom_menu_handler});
					});
				}
			});
		},

		check_sb_height: function() {
			let sidebarFooter = $('#primaryMenu .primaryMenu__foot');
			let sidebarGap = $('#primaryMenu .primaryMenu__gap');
			let sidebarFooterPos = sidebarFooter.offset();
			let footerBottomPos = sidebarFooterPos.top + sidebarFooter.height();
			return parseInt(footerBottomPos, 10)+16 > parseInt($(window).height(), 10) || parseInt(sidebarGap.height(), 10) < 16;
		},

		set_optional_menu: function() {
			let hideFirst = $('#primaryMenu .primaryMenu__item-hideFirst');
			let optional = $('#primaryMenu .primaryMenu__item-optional[data-config]');

			if (App.me.sidebar) {
				hideFirst.removeClass('primaryMenu__item-hidden');
				optional.addClass('primaryMenu__item-hidden');
				$('#sidebarExtraMenu .menu__item[data-config]').removeClass('menu__item-hidden');
				for (let key in App.me.sidebar) {
					if (App.me.sidebar[key] === 1) {
						$('#primaryMenu .primaryMenu__item-optional[data-config=' + key + ']').removeClass('primaryMenu__item-hidden');
						$('#sidebarExtraMenu .menu__item[data-config=' + key + ']').addClass('menu__item-hidden');
					}
				}
				if ($('#primaryMenu__support__counter').length) $('#primaryMenu__support__counter').appendTo($('#sidebarHelpMenuBox'));
			}

			let hideFirstElements = hideFirst.get().reverse();
			let optionalElements = optional.not('.primaryMenu__item-hidden').not('.primaryMenu__item-active').get().reverse();
			let elementsArray = [...hideFirstElements, ...optionalElements];

			let supportIndex = elementsArray.findIndex(el => $(el).data('config') === 'support');
			let bookmarksIndex = elementsArray.findIndex(el => $(el).data('config') === 'bookmarks');
			if (supportIndex > -1) {
				let supportEl = elementsArray.splice(supportIndex, 1)[0];
				if (bookmarksIndex > -1) {
					elementsArray.splice(bookmarksIndex - 1, 0, supportEl);
				} else {
					elementsArray.push(supportEl);
				}
			}

			elementsArray.forEach(function(element) {
				if (self.check_sb_height()) {
					$(element).addClass('primaryMenu__item-hidden');
					$('#sidebarExtraMenu .menu__item[data-config=' + $(element).attr('data-config') + ']').removeClass('menu__item-hidden');
					if ($(element).find('#primaryMenu__support__counter').length) {
						$('#primaryMenu__support__counter').appendTo('.primaryMenu__foot .profile');
					}
				}
			});
			if ($('#sidebarExtraMenu .menu__item[data-config]:not(.menu__item-hidden)').length === 0) {
				$('#primaryMenu .primaryMenu__item-optional:not([data-config])').last().addClass('primaryMenu__item-hidden').prev().removeClass('primaryMenu__item-hidden');
			} else {
				$('#primaryMenu .primaryMenu__item-optional:not([data-config])').last().removeClass('primaryMenu__item-hidden').prev().addClass('primaryMenu__item-hidden');
			}
			$('#sidebarExtraMenu .menu__group').each(function() {
				if (!$(this).find('.menu__item:not(.menu__item-hidden)').length) {
					$(this).addClass('menu__group-hidden');
				} else {
					$(this).removeClass('menu__group-hidden');
				}
			});
		},

		drag_projects: {
			last_drop_id: null,
			init: function () {
				let start_mo = null;
				let options = {
					clone: true,
					opacity: 1,
					target: '.sidebar__projects__group[data-key=folder] .sidebar__projects__group__title, .sidebar__projects__group[data-key=folder] .sidebar__projects__item__dropPlace',
					tolerance: 'pointer',
					minibar: $('#sidebar .sidebar__projects'),
					renewTarget: true,
					before_start: function (o, event) {
						return !$('.sidebar__projects').hasClass('search_started') && !self.loading_type && self.update_order_task.is_idle();
					},
					start: function (o, event) {
						$('.sidebar__projects__item-draggable').removeClass('sidebar__projects__item-dragThis').removeClass('sidebar__projects__item-dragThisDone');
						o.originalElem.addClass('sidebar__projects__item-dragThis');
						App.state.drag.start();
						$('body').addClass('body-dragInProgress').addClass('grabbing');
						$('#sidebar__projects').addClass('sidebar__projects-withDrag');
						o.prepareTargetMatrix();
						$('#mouse_help').addClass('help_hidden');
						if (o.originalElem.parent().hasClass('sidebar__projects__group-teamWithAdmins')) $('#drag_notice').addClass('act').find('b').text(o.originalElem.parent().find('.gtitle a.inline2').text());
						self.drag_projects.find_nearest_target(o, event);
						start_mo = !o.originalElem.prev().prev().length ? 0 : parseInt(o.originalElem.prev().prev().attr('data-order'));
					},
					end: function (o) {
						$('.sidebar__projects__groups .sidebar__projects__group__title').removeClass('dragHover');
						$('body').removeClass('body-dragInProgress').removeClass('grabbing');
						o.elem.removeClass('sidebar__projects__item-dragThis');
						$('#sidebar__projects').removeClass('sidebar__projects-withDrag');
						setTimeout(App.state.drag.stop, 100);
						$('#drag_notice').removeClass('act');
						$('.dragHover').removeClass('dragHover');
					},
					move: App.helper.debounce(self.drag_projects.find_nearest_target, 50, true),
					drop: function (o, t) {
						setTimeout(function () {
							App.state.drag.stop();
							$('body').removeClass('body-dragInProgress');
						}, 100);
						o.elem.removeClass('sidebar__projects__item-dragThis');
						t.removeClass('dragHover');
						let id_group = t.parents('.sidebar__projects__group').attr('data-group');
						let cur_id_group = o.elem.closest('.sidebar__projects__group').attr('data-group');
						let cur_mo = parseInt(o.elem.attr('data-order'));
						let mo = t.hasClass('sidebar__projects__group__title') || !t.prev().length ? 0 : parseInt(t.prev().attr('data-order'));
						if (cur_id_group !== id_group || (mo !== start_mo && mo !== cur_mo)) {
							self.drag_projects.last_drop_id = o.elem.attr('data-project');
							self.update_order_task.ajax(App.helper.endpoint.ajax(o.elem.attr('data-project')) + '?drag_to=' + id_group + '&mo=' + mo + '&' + App.actions.get('project_drag:do'));
							setTimeout(() => { $('.sidebar__projects__item-draggable[data-project='+self.drag_projects.last_drop_id+']').addClass('sidebar__projects__item-dragThis2'); }, 10);
						}
					},

					autoscroll: true,
					target_self: false,
				}
				$('.sidebar__projects__group[data-key=folder] .sidebar__projects__item-draggable')
					.removeClass('sidebar__projects__item-dragThis').removeClass('sidebar__projects__item-dragThisDone')
					.dragable(options).find('a').bind('dragstart', function () {
						return false
					}).attr('draggable', false);

				if (self.drag_projects.last_drop_id) {
					$('.sidebar__projects__item-draggable[data-project='+self.drag_projects.last_drop_id+']').addClass('sidebar__projects__item-dragThisDone');
					self.drag_projects.last_drop_id = null;
				}
			},

			prepareTargetMatrix: false,
			find_nearest_target: function (o, event) {
				if (self.drag_projects.prepareTargetMatrix) {
					o.prepareTargetMatrix();
					self.drag_projects.prepareTargetMatrix = false;
				}

				o.target.removeClass('dragHover');

				let i_min = -1;
				let min_distance = 9999;
				let oy = event?.clientY ?? o.top + o.originalElem.outerHeight()/2;

				for (let i = 0; i < o.targetMatrix.length; i++) {
					const t = o.targetMatrix[i];

					if (o.left < t.x1 - 100 || o.left > t.x2 + 100) continue;

					const distance = Math.abs((t.y1 + (t.y2 - t.y1)/2) - oy);
					if (distance > min_distance) continue;

					min_distance = distance;
					i_min = i;
				}

				let group_target = null;

				if (i_min !== -1) {
					if (o.currentTarget && o.currentTarget.get(0) !== $(o.targetMatrix[i_min].t)) o.currentTarget.trigger('drag_out');
					o.currentTarget = $(o.targetMatrix[i_min].t);
					group_target = o.currentTarget.closest('.sidebar__projects__group');
					if (o.currentTarget) o.currentTarget.addClass('dragHover').trigger('drag_hover');
				} else {
					if (o.currentTarget) o.currentTarget.trigger('drag_out');
					o.currentTarget = null;
				}

				if (group_target) {
					group_target.find('.sidebar__projects__group__title').addClass('dragHover');
				} else {
					$('.sidebar__projects__groups .sidebar__projects__group__title').removeClass('dragHover');
				}
			},
		},

		drag_folders: {
			last_drop_id: null,

			update_drop_places: function () {
				let container = $('#sidebar .sidebar__projects');
				if (self.with_empty_folders) {
					container.find('.sidebar__projects__group-empty').each(function () {
						$(this).after('<div class="sidebar__projects__group__dropPlace"></div>');
					});
				} else {
					container.find('.sidebar__projects__group-empty + .sidebar__projects__group__dropPlace').remove();
				}

				if (self.with_hidden_projects) {
					container.find('.sidebar__projects__group-waste').each(function () {
						$(this).after('<div class="sidebar__projects__group__dropPlace"></div>');
					});
				} else {
					container.find('.sidebar__projects__group-waste + .sidebar__projects__group__dropPlace').remove();
				}
			},

			init: function () {
				self.drag_folders.update_drop_places();

				let options = {
					clone: true,
					opacity: 1,
					target: '.sidebar__projects__group__dropPlace',
					tolerance: 'pointer',
					minibar: $('#sidebar .sidebar__projects'),
					renewTarget: true,
					before_start: function (o, event) {
						return !$('.sidebar__projects').hasClass('search_started') && !self.loading_type && self.update_order_task.is_idle();
					},
					start: function (o, event) {
						$('.sidebar__projects__group').removeClass('sidebar__projects__group-dragThis').removeClass('sidebar__projects__group-dragThisDone');

						o.originalElem.addClass('sidebar__projects__group-dragThis');
						App.state.drag.start();
						$('#sidebar__projects').addClass('sidebar__projects-withFolderDrag');
						o.prepareTargetMatrix();
						$('#mouse_help').addClass('help_hidden');
						if (o.originalElem.parent().hasClass('sidebar__projects__group-teamWithAdmins')) $('#drag_notice').addClass('act').find('b').text(o.originalElem.parent().find('.gtitle a.inline2').text());
						self.drag_folders.find_nearest_target(o, event);
					},
					end: function (o) {
						o.elem.removeClass('sidebar__projects__group-dragThis');
						$('#sidebar__projects').removeClass('sidebar__projects-withFolderDrag');
						setTimeout(App.state.drag.stop, 100);
						$('#drag_notice').removeClass('act');
						$('.dragHover').removeClass('dragHover');
					},
					move: App.helper.debounce(self.drag_folders.find_nearest_target, 50, true),
					drop: function (o, t) {
						$('.sidebar__projects__group').removeClass('sidebar__projects__group-dragThis');
						setTimeout(function () {
							App.state.drag.stop();
							$('body').removeClass('body-dragInProgress');
						}, 100);
						o.elem.removeClass('sidebar__projects__group-dragThis');
						t.removeClass('dragHover');
						let id_group = o.elem.parents('.sidebar__projects__group').attr('data-group');
						let mo = parseInt(t.prev().attr('data-order')) + 1;
						let cur_mo = parseInt(o.elem.parents('.sidebar__projects__group').attr('data-order'));
						if (Math.abs(cur_mo-mo) > 1) {
							self.update_order_task.ajax(App.helper.endpoint.ajax() + '?edit_group=' + id_group + '&mo=' + mo + '&' + App.actions.get('project_folder_drag:do'));
							self.drag_folders.last_drop_id = id_group;
							setTimeout(() => { $('.sidebar__projects__group[data-group='+self.drag_folders.last_drop_id+']').addClass('sidebar__projects__group-dragThis2'); }, 10);
						}
					},
					autoscroll: true,
					target_self: false,
				}
				$('.sidebar__projects__group-draggable .sidebar__projects__group__title').dragable(options).find('a').bind('dragstart', function () {
					return false
				}).attr('draggable', false);

				$('.sidebar__projects__group-draggable').removeClass('sidebar__projects__group-dragThis').removeClass('sidebar__projects__group-dragThisDone');

				if (self.drag_folders.last_drop_id) {
					$('.sidebar__projects__group[data-group='+self.drag_folders.last_drop_id+']').addClass('sidebar__projects__group-dragThisDone');
					self.drag_folders.last_drop_id = null;
				}
			},

			prepareTargetMatrix: false,
			find_nearest_target: function (o, event) {
				if (self.drag_folders.prepareTargetMatrix) {
					o.prepareTargetMatrix();
					self.drag_folders.prepareTargetMatrix = false;
				}

				o.target.removeClass('dragHover');

				let i_min = -1;
				let min_distance = 9999;
				let oy = event?.clientY ?? o.top + o.originalElem.outerHeight()/2;

				for (let i = 0; i < o.targetMatrix.length; i++) {
					const t = o.targetMatrix[i];

					if (o.left < t.x1 - 100 || o.left > t.x2 + 100) continue;

					const distance = Math.abs((t.y1 + (t.y2 - t.y1)/2) - oy);
					if (distance > min_distance) continue;

					min_distance = distance;
					i_min = i;
				}

				if (i_min !== -1) {
					if (o.currentTarget && o.currentTarget.get(0) !== $(o.targetMatrix[i_min].t)) o.currentTarget.trigger('drag_out');
					o.currentTarget = $(o.targetMatrix[i_min].t);
					if (o.currentTarget) o.currentTarget.addClass('dragHover').trigger('drag_hover');
				} else {
					if (o.currentTarget) o.currentTarget.trigger('drag_out');
					o.currentTarget = null;
				}
			},
		},

		drag_bookmarks: {
			last_drop_id: null,
			init: function () {
				let start_mo = null;

				let items = $('.sidebar__projects__group[data-key=bookmark] .sidebar__projects__item:not(.sidebar__projects__item-waste)');

				items.toggleClass('sidebar__projects__item-draggable', items.length > 1);

				let options = {
					clone: true,
					opacity: 1,
					target: '.sidebar__projects__group[data-key=bookmark] .sidebar__projects__item__dropPlace',
					tolerance: 'pointer',
					minibar: $('#sidebar .sidebar__projects'),
					renewTarget: true,
					before_start: function (o, event) {
						return !$('.sidebar__projects').hasClass('search_started') && !self.loading_type && self.update_order_task.is_idle();
					},
					start: function (o, event) {
						$('.sidebar__projects__item-draggable').removeClass('sidebar__projects__item-dragThis').removeClass('sidebar__projects__item-dragThisDone');
						o.originalElem.addClass('sidebar__projects__item-dragThis');
						App.state.drag.start();
						$('body').addClass('body-dragInProgress').addClass('grabbing');
						$('#sidebar__projects').addClass('sidebar__projects-withDrag');
						o.prepareTargetMatrix();
						$('#mouse_help').addClass('help_hidden');

						self.drag_bookmarks.find_nearest_target(o, event);
						start_mo = parseInt(o.originalElem.prev().prev().attr('data-project') || 0);
					},
					end: function (o) {
						$('.sidebar__projects__groups .sidebar__projects__group__title').removeClass('dragHover');
						$('body').removeClass('body-dragInProgress').removeClass('grabbing');
						o.elem.removeClass('sidebar__projects__item-dragThis');
						$('#sidebar__projects').removeClass('sidebar__projects-withDrag');
						setTimeout(App.state.drag.stop, 100);
						$('#drag_notice').removeClass('act');
						$('.dragHover').removeClass('dragHover');
					},
					move: App.helper.debounce(self.drag_bookmarks.find_nearest_target, 50, true),
					drop: function (o, t) {
						setTimeout(function () {
							App.state.drag.stop();
							$('body').removeClass('body-dragInProgress');
						}, 100);
						o.elem.removeClass('sidebar__projects__item-dragThis');
						t.removeClass('dragHover');

						let cur_mo = parseInt(o.elem.attr('data-project'));
						let after_mo = t.prev().length ? parseInt(t.prev().attr('data-project')) : 0;

						if (after_mo !== start_mo && after_mo !== cur_mo) {
							self.drag_bookmarks.last_drop_id = o.elem.attr('data-project');
							self.update_order_task.ajax(App.helper.endpoint.ajax(o.elem.attr('data-project')) + '?id_after=' + after_mo + '&' + App.actions.get('project_bookmark_drag:do'));
							setTimeout(() => { $('.sidebar__projects__item-draggable[data-project='+self.drag_projects.last_drop_id+']').addClass('sidebar__projects__item-dragThis2'); }, 10);
						}
					},

					autoscroll: true,
					target_self: false,
				}
				$('.sidebar__projects__group[data-key=bookmark] .sidebar__projects__item-draggable')
					.removeClass('sidebar__projects__item-dragThis')
					.removeClass('sidebar__projects__item-dragThis2')
					.removeClass('sidebar__projects__item-dragThisDone')
					.dragable(options).find('a').bind('dragstart', function () {
						return false
					}).attr('draggable', false);

				if (self.drag_bookmarks.last_drop_id) {
					$('.sidebar__projects__group[data-key=bookmark] .sidebar__projects__item-draggable[data-project='+self.drag_bookmarks.last_drop_id+']').addClass('sidebar__projects__item-dragThisDone');
					self.drag_bookmarks.last_drop_id = null;
				}
			},

			prepareTargetMatrix: false,
			find_nearest_target: function (o, event) {
				if (self.drag_projects.prepareTargetMatrix) {
					o.prepareTargetMatrix();
					self.drag_projects.prepareTargetMatrix = false;
				}

				o.target.removeClass('dragHover');

				let i_min = -1;
				let min_distance = 9999;
				let oy = event?.clientY ?? o.top + o.originalElem.outerHeight()/2;

				for (let i = 0; i < o.targetMatrix.length; i++) {
					const t = o.targetMatrix[i];

					if (o.left < t.x1 - 100 || o.left > t.x2 + 100) continue;

					const distance = Math.abs((t.y1 + (t.y2 - t.y1)/2) - oy);
					if (distance > min_distance) continue;

					min_distance = distance;
					i_min = i;
				}

				if (i_min !== -1) {
					if (o.currentTarget && o.currentTarget.get(0) !== $(o.targetMatrix[i_min].t)) o.currentTarget.trigger('drag_out');
					o.currentTarget = $(o.targetMatrix[i_min].t);
					if (o.currentTarget) o.currentTarget.addClass('dragHover').trigger('drag_hover');
				} else {
					if (o.currentTarget) o.currentTarget.trigger('drag_out');
					o.currentTarget = null;
				}
			},
		},

		search: {
			input_selector: '#sidebar .sidebar__search input',
			prev_value: '',
			is_active: function () {
				return $('#sidebar .sidebar__projects').hasClass('search_started') && this.get_current_query().length > 0;
			},
			is_focused: function () {
				return $('#sidebar .sidebar__projects').hasClass('search_focused');
			},
			get_current_query: function () {
				let search_query = $(this.input_selector).val();
				return String(search_query || '').trim();
			},
			is_showed_empty_message: function () {
				return $('#sidebar__projects .item_empty').is(':visible');
			},
			is_search_started: function () {
				return $('#sidebar__projects').hasClass('search_started');
			},
			remember: function (query) {
				if (query == null && !this.is_active()) return;

				query = query || this.get_current_query();
				$.getScript(App.helper.endpoint.primary() + '?add_query=' + encodeURIComponent(query) + '&' + App.actions.get('sidebar_projects:search_log'));
			},
			update_links: function (queries) {
				const link_list = $('.sidebar__projects__group[data-key=latest] .sidebar__projects__group__links');

				link_list.find('.link__search-query').remove();

				queries.forEach(function (query) {
					link_list.append(
						$('<ws-chip class="link__search-query" name="chip chip-fill chip-rounded" text="'+query+'" cross-icon="true"></ws-chip>')
					);
				});
			},
			forget: function (query) {
				$.getScript(App.helper.endpoint.primary() + '?del_query=' + encodeURIComponent(query) + '&' + App.actions.get('sidebar_projects:search_log'));
			},
			activate: function (query) { $(this.input_selector).val(query).trigger('keyup'); },
			focus: function () {
				self.search.onblur.reset();
				$(self.search.input_selector).focus();
			},
			blur: function () {
				$(self.search.input_selector).blur();
			},
			onblur: App.helper.debounce(() => {
				if (self.search.is_search_started()) return;

				$('#sidebar__projects').removeClass('search_focused');
				if(self.minibar_projects) self.minibar_projects.update();
				self.restore_scroll();
			}, 333),
			init: function () {
				$('#sidebar__wrapper')
					.on('focus', '.sidebar__search input', () => {
						if (!this.is_search_started()) {
							self.remember_scroll();
							self.move_scroll(0);
						}

						self.search.onblur.reset();
						$('#sidebar__projects').addClass('search_focused');
						self.minibar_projects.update();
						App.keyboard_selection.set_active_container($('#sidebar .keyboardZone'));

						if (App.device.is_mobile()) $('body').addClass('mobileSidebarFullscreen');
					})
					.on('blur', '.sidebar__search input', () => {
						self.search.onblur();
						App.keyboard_selection.unset_active_container($('#sidebar .keyboardZone'), true);
					})
			},
			apply: function (e) {
				if (e.keyCode === App.keycode.Enter && self.search.is_showed_empty_message()) {
					self.search.open();
					self.search.clear();
					return;
				}
				if (e.keyCode === App.keycode.ArrowUp || e.keyCode === App.keycode.ArrowDown) {
					return;
				}
				if (this.get_current_query().length > 0) $('#sidebar__projects').addClass('search_focused');
				self.move_scroll(0);
				App.context_search.sidebar_projects.apply($(self.search.input_selector).get(0), '#sidebar__projects');
				self.minibar_projects.update();
			},
			clear: function () {
				this.activate('');
				$('#sidebar__projects').removeClass('search_focused');
				$(this.input_selector).blur();
				self.restore_scroll();
			},
			open: function (is_advanced) {
				if (is_advanced) {
					App.core.goto('/search/?search='+encodeURIComponent(this.get_current_query()));
				} else {
					App.mymenu.open_search(this.get_current_query());
				}
			},
			open_archive: function (url) {
				App.mymenu.show({
					type: 'archive',
					url: url,
					skip_cache: true,
					dont_cache: true,
					callback: function () {
						App.mymenu.obj_window.find('.search_fld').val(self.search.get_current_query()).trigger('keyup');
						self.search.clear();
					}
				});
			}
		},

		save_config: App.helper.debounce(function () {
			$.getScript(App.helper.endpoint.primary() + '?'
				+ 'show_hidden=' + (self.with_hidden_projects ? 1 : 0) + '&'
				+ 'show_archived=' + (self.with_arch_projects ? 1 : 0) + '&'
				+ 'show_empty_folders=' + (self.with_empty_folders ? 1 : 0) + '&'
				+ App.actions.get('sidebar_projects:config')
			);
		}, 1000),

		projects_menu_onshow: function () {
			let active_box = $(this);
			let expanded_sel = '.sidebar__projects__group:not(.sidebar__projects__group-extra):not(.sidebar__projects__group-collapsed)';
			let collapsed_sel = '.sidebar__projects__group:not(.sidebar__projects__group-extra).sidebar__projects__group-collapsed';
			let expanded_cnt = $(expanded_sel).length;
			let collapsed_cnt = $(collapsed_sel).length;

			active_box.find('#menu__item-expandAll').off('click').on('click', () => {
				$(collapsed_sel + ' .sidebar__projects__group__title').click();
				App.menu.hide();
				self.minibar_projects.update();
				self.projects_menu_onshow.apply(this);
			}).toggleClass('menu__item-hidden', collapsed_cnt === 0);
			active_box.find('#menu__item-collapseAll').off('click').on('click', () => {
				$(expanded_sel + ' .sidebar__projects__group__title').click();
				App.menu.hide();
				self.minibar_projects.update();
				self.projects_menu_onshow.apply(this);
			}).toggleClass('menu__item-hidden', expanded_cnt === 0);

			active_box.find('#menu__group-toggleAll').toggleClass('menu__group-hidden', collapsed_cnt === 0 && expanded_cnt === 0);

			const update_switches = () => {
				active_box.find('.menu__item[data-key=hidden_projects]').toggleClass('sw_act', self.with_hidden_projects);
				active_box.find('.menu__item[data-key=arch_projects]').toggleClass('sw_act', self.with_arch_projects);
				active_box.find('.menu__item[data-key=empty_folders]').toggleClass('sw_act', self.with_empty_folders);
			};

			update_switches();
			self.projects_menu_onshow.update_switches = update_switches;
		},

		toggle_empty_folders: function () {
			self.with_empty_folders = !self.with_empty_folders;
			$('#sidebar .sidebar__projects').toggleClass('with-emptyFolders', self.with_empty_folders);
			self.drag_folders.update_drop_places();
			App.menu.hide();
			self.minibar_projects.update();
			self.save_config();
		},

		toggle_hidden_projects: function () {
			self.with_hidden_projects = !self.with_hidden_projects;
			$('#sidebar .sidebar__projects').toggleClass('with-hiddenProjects', self.with_hidden_projects);
			self.drag_folders.update_drop_places();
			App.menu.hide();
			self.minibar_projects.update();
			self.save_config();
		},

		toggle_archived_projects: function () {
			self.with_arch_projects = !self.with_arch_projects;
			$('#sidebar .sidebar__projects').toggleClass('with-archProjects', self.with_arch_projects);
			self.drag_folders.update_drop_places();
			App.menu.hide();
			self.minibar_projects.update();
			self.save_config();
		},

		init_projects: function() {
			self.minibar_projects = App.controls.js_scrollbars.init('#sidebar .sidebar__projects', {
				wheelSpeed: 0.2
			});
			self.drag_projects.init();
			self.drag_folders.init();
			self.drag_bookmarks.init();

			$('#sidebar .sidebar__projects').toggleClass('with-hiddenProjects', self.with_hidden_projects);
			$('#sidebar .sidebar__projects').toggleClass('with-archProjects', self.with_arch_projects);
			$('#sidebar .sidebar__projects').toggleClass('with-emptyFolders', self.with_empty_folders);
			$('#sidebar .sidebar__projects').on('click', '.sidebar__projects__group__title', function(e) {
				if (App.helper.event.link_click(e)) return;
				if ($(e.target).is('input')) return;

				let el = $(this).parents('.sidebar__projects__group');
				//if (el.hasClass('sidebar__projects__group-waste')) return;

				let was_collapsed = el.hasClass('sidebar__projects__group-collapsed');
				let content = el.find('.sidebar__projects__group__content');
				let id = el.attr('data-group');
				let type = el.hasClass('sidebar__projects__group-extra') ? 'sidebar_folder_extra' : 'sidebar_folder';

				if (parseInt(id) === -1) return;

				if (was_collapsed) {
					content.css({ height: 0, overflow: 'hidden', transition: 'height .15s linear' });
				}

				el.toggleClass('sidebar__projects__group-collapsed');

				if (was_collapsed) {
					content.css('height', content.prop('scrollHeight') + 'px');
					setTimeout(function () {
						content.css({ height: '', overflow: '', transition: '' });
					}, 200);
				}

				$.ajax({url: App.helper.endpoint.primary() + '?' + App.actions.get('process:collapse') + '&type=' + type + '&id=' + id + '&is_on=' + (!was_collapsed ? 0 : 1)});
			}).on('drag_hover', '.sidebar__projects__group__title', function() {
				if (App.state.drag.is_on) {
					let el = $(this).parents('.sidebar__projects__group:not(.sidebar__projects__group-extra)');
					if (el.hasClass('sidebar__projects__group-collapsed')) {
						App.core.call_queue.add('drag_projects_expand' + el.attr('data-group'), function() {
							$(this).click();
							self.drag_projects.prepareTargetMatrix = true;
						}, this, null, 1);
					}
				}
			}).on('drag_out', '.sidebar__projects__group__title', function() {
				let el = $(this).parents('.sidebar__projects__group:not(.sidebar__projects__group-extra)');
				if (el.length) App.core.call_queue.delete('drag_projects_expand' + el.attr('data-group'));
			}).on('click dblclick', '.sidebar__projects__item[data-project]', function(e) {

				self.search.remember();

				let this_id = $(this).attr('data-project').toInt();

				if (App.projects[this_id] && App.projects[this_id].seen === false) {
					self.helper.seen_project(this_id);
					App.core.send_message_to_other_tabs({command: 'i_see_project', data: {id: this_id}});
					App.core.websocket.postMessage({
						action: 'send_to_me',
						message: {
							command: 'i_see_project',
							data: {id: this_id},
						}
					});
				}

				if (!App.helper.event.link_click(e)) {
					if ($(e.target).closest('.sidebar__projects__item-waste').length === 1) {
						App.project_view.show(this_id);
					} else {
						App.core.goto($(this).attr('data-href'));
					}
				}
			}).on('click', '.link__search-query', function (e) {
				let chip = $(e.target).closest('ws-chip');
				let is_remove = $(e.target).closest('.delete').length === 1;
				let search_query = chip.attr('text');
				let links_container = $(e.target).closest('.sidebar__projects__group__links');

				if (is_remove) {
					chip.remove();
					self.search.forget(search_query);
				} else {
					self.search.activate(search_query);
				}

				self.search.focus();

				if (links_container.children().length === 0) links_container.remove();
			});

			App.ui.onMouse('#sidebar .sidebar__projects', '.sidebar__projects__item[data-project] .but', {
				onBefore: function (e) {
					e.data.id = $(e.el).closest('[data-project]').attr('data-project').toInt();
				},
				click: (e) => App.helper.context_menu.project(e.data.id, e.el),
				dblclick: (e) => App.project_view.show(e.data.id)
			})
		},

		init: function() {
			if (!$('#sidebar__wrapper').length) return;
			self.process_media_css();
			self.load_primary_menu();
			let promises = []; // force load
			promises.push(new Promise(function (resolve, reject) {
				self.preload_project(resolve);
			}));
			// promises.push(new Promise(function (resolve, reject) {
			// 	App.mymenu.preload_chats(resolve);
			// }));
			Promise.all(promises).then(function(values) {
				self.ready = true;
			}).catch(function(reason) {
				console.log(reason);
			});

			$('#sidebarOverlay').click(function() {
				if ($(window).width() > MOBILE_SCREEN_THRESHOLD) {
					$('body').removeClass('withSidebarOver');
				} else {
					self.toggle(false);
				}
			});
			$('#primaryMenu__wrapper').on('click', '.primaryMenu__item.primaryMenu__item-optional', function() {
				if (['invite','help','bookmarks'].includes($(this).attr('data-config')) || $(this).attr('data-custom-page') === 'sidebar_settings') {
					$(this).addClass('menu_open');
				} else if (this.hasAttribute('data-nowait')) {
					return;
				} else {
					$(this).addClass('wait');
				}
			});
			$('#primaryMenu__wrapper').on('click', '.primaryMenu__head a', function() {
				if (App.page.url.base === '/') App.menu.show({anchor: $(this).get(0), box: '#sidebarAccMenu', type: 'right', onshow: self.custom_menu_handler});
				else App.core.goto('/');
			});
			$('#sidebar__wrapper').on('click', '.sidebar__menu__item', function() {
				$(this).addClass('selected');
			});

			self.search.init();
		},

		onload: function() {
			if (!App.me.id) return;
			if (!self.ready) {
				setTimeout(() => self.onload(), 50);
				return;
			}
			if (!$('#sidebar__wrapper').length) return;
			let pageName;
			let pageWhere = App.page.where();
			if (pageWhere === 'report_table') pageWhere = 'report';

			if ($('body').attr('data-subpage') && $('body').attr('data-subpage') !== pageWhere) pageName = pageWhere + '|' + $('body').attr('data-subpage');
			else pageName = pageWhere || '';

			self.set_active_page(App.current_page.project ? '' : pageName );
			self.set_active_project(App.current_page.project);
			self.set_custom_elements();
			self.update_sidebar();

			if (pageName === 'account_dashboard') {
				$('.primaryMenu__head a').attr('data-title', '');
			} else {
				$('.primaryMenu__head a').attr('data-title', App.object_state.locale['homepage']);
			}

		},

		onresize: function () {
			if (!App.me.id) return;
			if (self.resize_timeout) clearTimeout(self.resize_timeout);
			self.resize_timeout = setTimeout(() => self.set_optional_menu(), 100);
			self.update_visibility();
		},

		is_shown: function() {
			if ($(window).width() < MOBILE_SCREEN_THRESHOLD) {
				return $('body').hasClass('mobileSidebar');
			} else {
				return $('body').hasClass('withSidebar') || $('body').hasClass('withSidebarOver');
			}
		},

		onkeyup: function (key, alt, ctrl, meta, shift, in_input) {},

		onkeydown: function (key, alt, ctrl, meta, shift, in_input, in_input_strict) {

			if (!App.config.hotkeys) return false;

			let letter = String.fromCharCode(key);
			if (key === App.keycode.Comma) letter = ',';
			if (key === App.keycode.Slash || key === App.keycode.NumpadDivide) letter = '/';
			letter = (ctrl || meta ? 'ctrl-' : '') + (alt ? 'alt-' : '') + (shift ? 'shift-' : '') + letter;

			// if (self.search.is_showed_empty_message() && in_input_strict && key === App.keycode.Slash) {
			// 	App.mymenu.open_search(self.search.get_current_query());
			// 	return true;
			// }

			if (self.search.is_focused() && key === App.keycode.Escape) {
				self.search.clear();
				return true;
			}

			if (key === App.keycode.Escape && self.with_over_sidebar()) {
				self.slide();
				return true;
			}

			if ((
				(ctrl && !App.device.is_ios_desktop()) ||
				(meta && App.device.is_ios_desktop())
			) && key === App.keycode.Period) {

				if (App.current_page.project) {
					self.toggle(!self.is_shown(), true);
				} else {
					self.slide();
				}

				return true;
			}

			if (!alt && !ctrl && !meta && !shift && !in_input && !in_input_strict && key === App.keycode.BracketLeft) {

				if (App.current_page.project) {
					self.toggle(!self.is_shown(), true);
				} else {
					self.slide();
				}

				return true;
			}

			const process_hotkey = function (container, letter) {
				let target = $(container).find('[data-hotkey="' + letter +'"]');
				if (target.length === 0) return false;

				target.click();
				return true;
			};

			if (alt && shift && [
				App.keycode.KeyX,
			].includes(key) && process_hotkey('#primaryMenu', letter)) return true;

			if ((
				(ctrl && !App.device.is_ios_desktop()) ||
				(meta && App.device.is_ios_desktop())
				) && alt && [
				App.keycode.KeyP,
				App.keycode.KeyT,
				App.keycode.KeyK,
				App.keycode.KeyR,
				App.keycode.KeyG,
				App.keycode.KeyC,
				App.keycode.KeyU
			].includes(key) && process_hotkey('#primaryMenu', letter)) return true;

			if (alt && [
				App.keycode.KeyN,
				App.keycode.KeyI
			].includes(key) && process_hotkey('#sidebarAddMenu', letter)) return true;

			if ((
				(ctrl && !App.device.is_ios_desktop()) ||
				(meta && App.device.is_ios_desktop())
				) && alt && [
				App.keycode.KeyM,
				App.keycode.KeyAltM,
				App.keycode.Comma
			].includes(key) && process_hotkey('#sidebarProfileMenu', letter)) return true;

			if (ctrl && shift && [
				App.keycode.Digit0,
				App.keycode.Digit1,
				App.keycode.Digit2,
				App.keycode.Digit3,
				App.keycode.Digit4,
				App.keycode.Digit5,
				App.keycode.Digit6,
				App.keycode.Digit7,
				App.keycode.Numpad0,
				App.keycode.Numpad1,
				App.keycode.Numpad2,
				App.keycode.Numpad3,
				App.keycode.Numpad4,
				App.keycode.Numpad5,
				App.keycode.Numpad6,
				App.keycode.Numpad7,
			].includes(key)) {
				let i = key - App.keycode.Numpad0;
				if (i < 0) i = key - App.keycode.Digit0;
				if (i === 0) $('#primaryMenu .primaryMenu__item-optional:not(.primaryMenu__item-hideFirst):not(.primaryMenu__item-hidden):last').click();
				else $('#primaryMenu .primaryMenu__item').eq(i - 1).click();
				return true;
			}

			if (!in_input_strict && !ctrl && !meta && !alt && [
				App.keycode.KeyT,
				App.keycode.KeyN,
				App.keycode.KeyC,
				App.keycode.KeyP,
				App.keycode.KeyS,
				App.keycode.Slash,
				App.keycode.NumpadDivide
			].includes(key)  && process_hotkey('#primaryMenu', letter)) return true;
		},

		destructor: function() {
			sidebar_featured_project.del();

			['projects'].forEach((type) => {
				if (self['obj_' + type]) {
					self['obj_' + type].remove();
					self['obj_' + type] = null;
				}
				if (self['minibar_' + type]) {
					self['minibar_' + type]?.destroy();
					self['minibar_' + type] = null;
				}
			});

			self.status = null;
			self.ready = false;
			self.available = true;
			self.hot_counters = {};
			self.with_hidden_projects = false;
			self.with_arch_projects = false;
			self.with_empty_folders = false;
			self.count_new_projects = 0;
			self.loading_type = '';
			self.px_sidebar_impact = 0;
			self.featured_project.current = null;
			self.featured_project.default = null;
			self.type = null;
			self.no_effects = false;
			self.saved_scroll_pos = -1;

			self.drag_projects.last_drop_id = null;
			self.drag_projects.prepareTargetMatrix = false;
			self.drag_folders.last_drop_id = null;
			self.drag_folders.prepareTargetMatrix = false;
			self.drag_bookmarks.last_drop_id = null;
			self.drag_bookmarks.prepareTargetMatrix = false;

			delete App.sidebar.projects_menu_onshow.update_switches;
		},
		helper: {
			clear_on_load: function () {
				$('.sidebar__wrapper .selected').removeClass('selected');
			},
			seen_project: function (id) {
				if (App.projects[id]) {
					App.projects[id].seen = true;
					let unseen = Object.entries(App.projects).filter(([id, project]) => project.seen === false).length;
					let counter_container = $('#primaryMenu__project__counter');
					if (unseen > 0) {
						counter_container.html('<span class="cnt_new">' + unseen + '</span>');
					} else {
						counter_container.empty();
					}
					let item = $('.sidebar__projects__item[data-project=' + id + ']');
					item.find('.space:first').empty();
					App.components.project_stage.redraw(item.find('project-stage').get(0));

				}
			}
		},
		custom_menu_handler: function () {
			let main_menu = $(this);
			if (!main_menu.is('#sidebarAccMenu, #sidebarProfileMenu')) return;
			if (main_menu.is('#sidebarProfileMenu')) {
				let el_help = main_menu.find('.menu.menu-getHelp').prev();
				let el_help2 = main_menu.find('.menu.menu-getHelp a[data-cmd="help_open_support"]');
				let help_counter = $('#primaryMenu__support__counter');
				let cnt = help_counter.find('.cnt_new').text().toInt();
				if (cnt && cnt>0) {
					el_help.find('.cnt_new').show().text(cnt);
					el_help2.find('.cnt_new').show().text(cnt);
				}
				else {
					el_help.find('.cnt_new').hide();
					el_help2.find('.cnt_new').hide();
				}
			}
			let mousemove_handler = App.helper.debounce(function(e) {
				let submenu_wrapper = main_menu.find('.selected').parent('.menu__submenuWrapper-auto');
				let submenu_opened = submenu_wrapper.find('.menu');
				if (submenu_opened.length && submenu_wrapper.length && !$(e.target).closest(submenu_wrapper).length) {
					submenu_wrapper.find('.selected').removeClass('selected');
				}
			});

			main_menu.off('mousemove.footer_menu').on('mousemove.footer_menu', function(e) {
				mousemove_handler(e);
			});
		},

		onBoot: function () {
			self.update_order_task = App.core.async_task.context('sidebar_update_order');

			App.bus.msg
				.on('sidebar_options', function (data) {
					App.me.sidebar = data;
					self.set_optional_menu();
				})
				.on('i_see_project', function (data) {
					self.helper.seen_project(data.id);
				});

			App.bus.state.on('project', function (payload) {
				const id_project = payload.id, fields = payload.data;

				if (fields.team && fields.team.delete && fields.team.delete.includes(App.me.id) && self.featured_project.current?.id === id_project) {
					self.featured_project.remove();
				}

				let reload_proj = false;
				reload_proj ||= fields.team && fields.team.add && fields.team.add.includes(App.me.id);
				reload_proj ||= fields.team && fields.team.delete && fields.team.delete.includes(App.me.id);
				reload_proj ||= fields.bookmark || fields.archive;
				reload_proj ||= fields.active && fields.active.before === 'archive';
				reload_proj ||= fields.mute && fields.mute.before === 'archive';
				reload_proj ||= fields.add || fields.delete || fields.import;
				if (reload_proj) App.sidebar.need_reload('projects');

			}).on('project_order', function (payload) {
				let data = payload.data;
				if (App.object_state.active_tab && data.id_group) {
					App.sidebar.reload('projects', function() {
						$('#ug'+data.id_group+'menu .edit').click();
					});
				} else {
					App.sidebar.need_reload('projects');
				}
			}).on('project_name', function (payload) {
				let id = payload.id, data = payload.data;
				let o = App.sidebar.obj_projects.find('.sidebar__projects__item[data-project='+id+']');
				if (o.length) o.find('span.in').text(data.name);
			}).on('config_sidebar_projects', function (payload) {
				const data = payload.data;

				let changed = false;
				if (data.hasOwnProperty('show_hidden') && self.with_hidden_projects != data.show_hidden) {
					changed = true;
					self.with_hidden_projects = data.show_hidden;
					$('#sidebar .sidebar__projects').toggleClass('with-hiddenProjects', self.with_hidden_projects);
				}
				if (data.hasOwnProperty('show_archived') && self.with_arch_projects != data.show_archived) {
					changed = true;
					self.with_arch_projects = data.show_archived;
					$('#sidebar .sidebar__projects').toggleClass('with-archProjects', self.with_arch_projects);
				}
				if (data.hasOwnProperty('show_empty_folders') && self.with_empty_folders != data.show_empty_folders) {
					changed = true;
					self.with_empty_folders = data.show_empty_folders;
					$('#sidebar .sidebar__projects').toggleClass('with-emptyFolders', self.with_empty_folders);
				}

				if (changed) {
					self.drag_folders.update_drop_places();
					self.minibar_projects.update();
					self.projects_menu_onshow.update_switches?.call();
				}
			});

			App.bus.window.on('resize', App.helper.debounce(self.onresize));

			App.bus.app.on('page_load left_panel_opened right_panel_opened task_create_opened modal_onload', function() {
				$('body').removeClass('withSidebarOver');
				if ($(window).width() <= APP_SCREEN_THRESHOLD) {
					self.toggle(false, false);
				}
			});
		},
		onLogin: () => {
			self.init();
		},
		onLogout: () => {

			$('body').removeClass('withSidebar withSidebarOver');
			self.hide_mobile();

			self.destructor();
		},
		onLoadPage: () => self.onload(),
	};
})();

;var App = App || {};

(function () {
	let self = App.special_states = {
		selectors: {
			wrapper: '.top_banner_wrapper .banner.acc_freeze',
			row: '.two_rows',
			collapse: '.two_rows > span.text:first-child a.collapse',
			textB: '.two_rows > span.text.b',
			text: '.two_rows > span.text:last-child'
		},

		$els: null,
		active: false,
		resizeHandler: null,
		_intercomWaitTimer: null, // NEW

		init: function () {
			const $wrapper = $(self.selectors.wrapper);
			if (!$wrapper.length) return;

			const $row    = $wrapper.find(self.selectors.row);
			const $btn    = $wrapper.find(self.selectors.collapse);
			const $textB  = $wrapper.find(self.selectors.textB);
			const $text   = $wrapper.find(self.selectors.text);
			if (!$row.length || !$btn.length || !$textB.length || !$text.length) return;

			self.$els = { $wrapper, $row, $btn, $textB, $text };
			self.active = true;
		},

		updateButtonVisibility: function () {
			if (!self.active) return;

			const textBTop = self.$els.$textB.offset().top;
			const textTop  = self.$els.$text.offset().top;

			if (Math.round(textBTop) !== Math.round(textTop)) {
				self.$els.$btn.show();
			} else {
				self.$els.$btn.hide();
			}
		},

		onClickCollapse: function (e) {
			e.preventDefault();

			const $wrapper = self.$els.$wrapper.closest('.top_banner_wrapper');
			$wrapper.toggleClass('collapsed');

			const url = self.$els.$btn.data('action');
			if (url) {
				$.get(url).fail(() => {});
			}

			self.updateButtonVisibility();
		},

		_isIntercomReady: function () {
			return typeof window.Intercom === 'function' && !window.Intercom.q;
		},

		_ensureIntercomAndShow: function () {
			if (self._isIntercomReady()) {
				try { App.communication_widget.intercom_show(); } catch (e) {}
				return;
			}

			try { App.communication_widget.intercom_init(); } catch (e) {}

			let tries = 0, maxTries = 30; // ~6 сек при 200мс
			if (self._intercomWaitTimer) clearInterval(self._intercomWaitTimer);
			self._intercomWaitTimer = setInterval(function () {
				if (self._isIntercomReady()) {
					clearInterval(self._intercomWaitTimer);
					self._intercomWaitTimer = null;
					try { App.communication_widget.intercom_show(); } catch (e) {}
				} else if (++tries >= maxTries) {
					clearInterval(self._intercomWaitTimer);
					self._intercomWaitTimer = null;
				}
			}, 200);
		},

		get_help: function (e) {
			e?.preventDefault?.();
			self._ensureIntercomAndShow();
			return false;
		},

		bind: function () {
			self.$els.$btn.on('click', self.onClickCollapse);
			self.resizeHandler = function () {
				self.updateButtonVisibility();
			};
			$(window).on('resize', self.resizeHandler);
		},

		unbind: function () {
			if (self.$els?.$btn) {
				self.$els.$btn.off('click', self.onClickCollapse);
			}
			if (self.resizeHandler) {
				$(window).off('resize', self.resizeHandler);
				self.resizeHandler = null;
			}
			if (self._intercomWaitTimer) { // NEW
				clearInterval(self._intercomWaitTimer);
				self._intercomWaitTimer = null;
			}
		},

		onLoadPage: function () {
			self.init();
			if (!self.active) return;

			self.bind();
			self.updateButtonVisibility();
		},

		onUnloadPage: function () {
			if (!self.active) return;
			self.unbind();
			self.$els = null;
			self.active = false;
		}
	};
})();

;var App = App || {};

App.subscribe = {

	menu_waits_hide: new WeakSet(),

	add_me: function (url, anchor = null) {

		let el;
		if (anchor) {
			el = $(anchor).closest('.a_sub');
			el.find('.sw_pre').addClass('sw_act').addClass('sw_loading');
		}
		if (App.menu.is_shown()) App.subscribe.menu_waits_hide.add(App.menu.active_box);

		$.getScript(url + '?' + App.actions.get('task_subscribe:do') + '&is_ajax=1&is_mass=0&id_user_to=' + App.me.id).always(() => {
			if (el) el.find('.sw_pre').removeClass('sw_act').removeClass('sw_loading');
		});
	},

	remove_me: function (url, anchor = null) {

		let el;
		if (anchor) {
			el = $(anchor).closest('.a_unsub');
			el.find('.sw_pre').removeClass('sw_act').addClass('sw_loading');
		}
		if (App.menu.is_shown()) App.subscribe.menu_waits_hide.add(App.menu.active_box);

		$.getScript(url + '?' + App.actions.get('task_unsubscribe:do') + '&is_ajax=1&is_mass=0&id_user_to=' + App.me.id).always(() => {
			if (el) el.find('.sw_pre').addClass('sw_act').removeClass('sw_loading');
		});
	},

	add_user: function (url, id, mass) {
		if (mass == -1) mass = 0; else $.getScript(url + '?' + App.actions.get('task_subscribe:do') + '&is_ajax=1&is_mass=' + mass + '&id_user_to=' + id);
	},

	remove_user: function (url, id, mass) {
		if (mass == -1) mass = 0; else $.getScript(url + '?' + App.actions.get('task_unsubscribe:do') + '&is_ajax=1&is_mass=' + mass + '&id_user_to=' + id);
	},

	onLogin: function () {
		App.bus.state.on('task_subscribers', function ({ id, data }, context) {

			const is_me_on = data.ids_user.includes(App.me.id);

			let containers = App.menu.get_all_by_trigger('task' + id);
			App.modal.history_dom.forEach(function (modal) {
				if (modal.window.attr('data-view-chat') != id) return;
				containers = containers.add(modal.window);
			});
			containers.find('.a_sub').toggleClass('hiddenBlock', is_me_on);
			containers.find('.a_unsub').toggleClass('hiddenBlock', !is_me_on);

			if (context.active_tab && App.menu.is_shown() && App.subscribe.menu_waits_hide.has(App.menu.active_box)) {
				setTimeout(() => {
					if (App.subscribe.menu_waits_hide.delete(App.menu.active_box)) {
						App.menu.hide();
					}
				}, 600);
			}
		});

		App.bus.app.on('menu_hide', (active_box) => {
			App.subscribe.menu_waits_hide.delete(active_box);
		});
	},

	onLogout: function() {
		App.subscribe.menu_waits_hide = new WeakSet();
	}
}

;var App = App || {};

(function() {
	let self = App.subtasks = {
		url: '',
		obj_window: null,
		obj_container: null,
		loaded: false,

		order: '',
		desc: false,
		match: {},
		match_plus_parents: {},
		match_state: null,
		match_projects: [],
		total_match: 0,
		total_exists: {
			done : 0,
			undone: 0,
			all: 0,
		},
		tree: {
			'parent': {},
			'parent_top': {},
		},
		match_tree: {
			'project': {},
			'parent': {},
		},

		data: {
			task: {},
			costs: {},

			init: function(type, data, keys) { // incoming data should be mapped;
				if (this[type] == null) this[type] = {};

				for (let i in data) {
					this[type][i] = {'id' : i};
					for (let j in keys) {
						this[type][i][keys[j]] = data[i][j];
					}
				}

				self.build_tree();
			},

			add: function(type, id, data) {
				data.id = id;
				this[type][id] = data;
				if (data['id_parent'] !== App.task_view.id && data['id_parent_top'] !== App.task_view.id) return;
				self.updated_state.tree = true;
				self.updated_state.data = true;

				if (self.order === 'manual_order' && self.task_add_form.pending_next_place === 'after_add' && self.task_add_form.form != null) {
					self.task_add_form.set_next_place(id);
				}

				App.core.call_queue.add('subtasks.update', self.update_callback, self, null, 0.01);
			},

			update: function(type, id, data, update_tree) {
				for (let i in data) {
					this[type][id][i] = data[i];
				}
				if (update_tree) self.updated_state.tree = true;
				self.updated_state.data = true;
				App.core.call_queue.add('subtasks.update', self.update_callback, self, null, 0.01);
			},

			delete: function(type, id) {
				// self.filter_check_match(this[type][id], true);
				delete(this[type][id]);
				if (id in self.dom[type]) {
					self.dom[type][id].findWithComponentsAndRemoveInCache();
					self.dom[type][id].removeWithComponents();
					delete(self.dom[type][id]);
				}
				self.updated_state.tree = true;
				self.updated_state.data = true;
				App.core.call_queue.add('subtasks.update', self.update_callback, self, null, 0.01);
			},

			exists: function(type, id) {
				return this[type] && id in this[type];
			},

			get_manual_order: function (type, id) {
				return this[type][id]?.manual_order ?? -1;
			},
			get_dateadd: function (type, id) {
				return this[type][id]?.dateadd || null;
			},

			destructor: function() {
				self.data.task = {};
				self.data.costs = {};
			},
		},

		dom: {

			task: {},

			invalidate_all: function() {
				if (!self.debug) App.core.warn('comments', 'For debug purposes only!');
				if (self.data.task) Object.keys(self.data.task).forEach(id => self.dom.invalidate(id, true));
			},

			invalidate: function(id, update_tree) { // this = self.dom
				if (!(id in this.task)) return;
				delete(this.task[id]);
				if (update_tree) {
					self.updated_state.tree = true;
					self.updated_state.data = true;
				} else {
					if (!(id in self.match_plus_parents)) return;
					self.page = 0;
				}
				App.core.call_queue.add('subtasks.update', self.update_callback, self, null, 0.01);
			},

			ready_to_load: true,
			load_items: function(ids, callback) {
				self.dom.ready_to_load = false;

				App.core.async_task.ajax({
					id: 'subtasks_load_items',
					url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('task_items:show') + '&type=subtask'),
					data: 'ids=' + ids.join(','),
					type: 'post'
				}).then(function (html) {
					self.obj_container.find('.subtaskList__item.subtaskList__item-updated').removeClass('subtaskList__item-updated');
					App.helper.dom.parse(html, function() {
						let id, match;
						if ($(this).hasClass('subtaskList__item')) {
							match = $(this).attr('id').match(/^obj-subtask(\d+)$/);
							id = parseInt(match[1]);
							if (id in self.dom.task) {
								self.dom.task[id].findWithComponentsAndRemoveInCache();
								self.dom.task[id].removeWithComponents();
							}
							self.dom.task[id] = $(this).detach();
							self.dom.task[id].findWithComponentsAndSetInCache();
							self.drag.init(self.dom.task[id]);
							self.draw_item_done_progress(id);
						}
					});
					ids.forEach(function(id) {
						self.dom.task[id] ||= null;
					});
					if (callback) callback();
				}).finally(function() {
					self.dom.ready_to_load = true;
				});
			},

			destructor: function() {
				self.dom.task = {};
				self.dom.ready_to_load = true;
			},
		},

		build_tree: function() {
			self.tree = { 'parent': {} }
			for (let id in self.data.task) if (self.integrity_check(id)) {
				if (self.data.task[id]['id_parent']) App.helper.object.push_deep(self.tree['parent'], self.data.task[id]['id_parent'], id);
			}
		},

		updated_state: {},
		update_callback: function() {
			if (self.updated_state.tree) self.build_tree();
			if (self.updated_state.data) self.process_filter_and_search(DATA_UPDATE);
			else self.draw();
			self.updated_state = {}
		},

		child_check: function (id) {
			return self.data.task[id] && (self.data.task[id]['id_parent'] === App.task_view.id || self.data.task[id]['id_parent_top'] === App.task_view.id);
		},
		direct_child_check: function (id) {
			return self.data.task[id] && self.data.task[id]['id_parent'] === App.task_view.id;
		},
		integrity_check: function (id) {
			return self.direct_child_check(id) || (self.data.task[id]['id_parent'] in self.data.task)
		},


		filter_task_status: {
			status: SHOW_ALL,

			check_match: function (data) {
				if (this.status === SHOW_UNDONE && data['status']) return false;
				if (this.status === SHOW_DONE && !data['status']) return false;
				return true;
			},

			apply: function (status) {
				App.menu.hide();
				if (status !== this.status) {
					this.status = status;
					$('#dropsubsmenu a[data-id=done]').toggleClass('sw_act', status === SHOW_ALL)
					self.process_filter_and_search();
					App.core.async_task.ajax('/ajax/?' + App.actions.get('subtasks_config:apply') + '&key=show_status&value=' + status);
				}
			},

			toggle: function() {
				this.apply(this.status ? SHOW_ALL : SHOW_UNDONE);
			},

			destructor: function() {
				self.filter_task_status.status = SHOW_ALL;
			},
		},

		process_filter_and_search: function (state) {
			if (!self.loaded) return;

			/** --- Filter and Search match --- **/
			/** --- (+) Build match_tree --- **/
			self.total_match = 0;
			self.total_exists.all = 0;
			self.total_exists.done = 0;
			self.total_exists.undone = 0;
			self.match = {}
			self.match_plus_parents = {}
			self.match_tree = {
				'parent': {},
			}
			let data, id_parent, match, match_state;
			for (let id in self.data.task) if (self.direct_child_check(id)) {
				data = self.data.task[id];
				if (self.data.task[id]['id_parent'] !== App.task_view.id && self.data.task[id]['id_parent_top'] !== App.task_view.id) return;
				self.total_exists.all++;
				if (data['status']) self.total_exists.done++; else self.total_exists.undone++;
				match = self.filter_task_status.check_match(data);
				if (match) {
					self.total_match++;
					self.match[id] = match;
					self.match_plus_parents[id] = match;
					id_parent = data['id_parent'];
					if (id_parent && !(id_parent in self.match_plus_parents)) self.match_plus_parents[id_parent] = MATCH_CHILD;
					App.helper.object.push_deep(self.match_tree['parent'], id_parent, id);
				}
			}

			match_state = Object.keys(self.match).join(',');
			if (match_state == self.match_state) {
				if (state != ORDER_CHANGE && state != CHANGE_VIEW && state != DATA_UPDATE) return;
			}
			self.match_state = match_state;

			if (self.total_match) {

				/** --- Sorting --- **/

				for (let id_parent in self.match_tree['parent']) {
					self.match_tree['parent'][id_parent].sort(self.order_func);
				}
			}
			self.draw(state);
			App.search.done();

			let order_label = $('#dropsubsmenu a[data-sort-key='+self.order+']').attr('data-btn-label') || $('#dropsubsmenu a[data-sort-key='+self.order+'] .in').text();
			const icon = self.order === 'manual_order' ? 'arrows/arrow_swap_sm' : 'arrows/arrow_sort_sm-simple-Descending';
			self.obj_container.find('ws-btn.config').attr('text', order_label).attr(App.device.is_mobile() ? 'left-icon' : 'right-icon', icon);
		},

		paginal: {
			per_page_default: 25,
			page_grow: 25,
			per_page: {},
			loaded_ids: {}
		},
		draw: function(state) {
			self.filter_counter();

			/** --- Paginal -- **/

			let ids_vis = {}, i = 0, match_tree_parent = self.match_tree['parent'][App.task_view.id] || [];

			if (!(App.task_view.id in self.paginal.per_page)) self.paginal.per_page[App.task_view.id] = self.paginal.per_page_default;
			if (!(App.task_view.id in self.paginal.loaded_ids)) self.paginal.loaded_ids[App.task_view.id] = new Set();
			if (self.total_match <= self.paginal.per_page[App.task_view.id] + self.paginal.page_grow) {
				self.paginal.per_page[App.task_view.id] = self.total_match;
			}

			let dig_child = function(id) {
				if (id in self.match) i++;
				if (i <= self.paginal.per_page[App.task_view.id]) ids_vis[id] = 1;
				if (App.helper.time.server() - self.data.get_dateadd('task', id) < 300) ids_vis[id] = 1;
			}
			match_tree_parent.forEach((id) => dig_child(id));

			/** --- Load DOM if needed -- **/

			let ids_load = [];
			Object.keys(ids_vis).forEach(function(id) {
				if (!(id in self.dom.task)) {
					ids_load.push(id);
					self.paginal.loaded_ids[App.task_view.id].add(id);
				}
			});

			if (ids_load.length) {
				if (!self.dom.ready_to_load) {
					clearTimeout(self.draw_timer);
					self.draw_timer = setTimeout(() => {
						self.draw(state);
						self.mass.update_menu();
					}, 100);
					return false;
				}
				self.dom.load_items(ids_load, self.draw);
				return false;
			}
			$('.subtaskList__item-level1').detach();
			$('.subtaskList__item-level0').detach();
			$('.subtaskList__item__children').remove();
			$('.subtaskList__dropPlace').remove();
			$('.subtaskList__moreItems').remove();

			let container;
			i = 0;
			let append_child = function(id, container, level) {
				if (i >= self.paginal.per_page[App.task_view.id]) return;
				if (!self.paginal.loaded_ids[App.task_view.id].has(id)) return;

				if (id in self.match) i++;
				if (!self.dom.task[id]) {
					self.dom.task[id] = $('<div></div>')
						.attr('class', 'subtaskList__item subtaskList__item-fake subtaskList__item-level' + level)
						.attr('id', '#obj-subtask' + id);
				}
				container.append(self.dom.task[id]);
				if (!self.data.task[id]['status']) container.append(
					$('<div></div>')
						.attr('class', 'subtaskList__dropPlace subtaskList__dropPlace-level' + level)
						.attr('data-after', id)
				);
				self.dom.task[id]
					.toggleClass('subtaskList__item-partSearch', self.match_plus_parents[id] !== MATCH)
					.removeClass('subtaskList__item-level0 subtaskList__item-level1')
					.addClass('subtaskList__item-level' + level)
					.toggleClass('subtaskList__item-child', level > 0);
			}
			container = $('#subtaskList');
			container.append(
				$('<div></div>')
					.attr('class', 'subtaskList__dropPlace subtaskList__dropPlace-level0')
					.attr('data-after', 0)
			);
			match_tree_parent.forEach((id) => append_child(id, container, 0));
			if (self.total_match > self.paginal.per_page[App.task_view.id]) {
				container.append(App.helper.template.fill('subtasks_more', {
					cnt: Math.min(self.total_match, self.paginal.per_page[App.task_view.id]),
					total: self.total_match,
					cnt_more: Math.min(2 * self.paginal.per_page[App.task_view.id], self.total_match),
				}));
			}

			self.update_progress_bars_done();
			self.task_add_form.update_position();
			self.mass.update_menu();
			App.bus.app.emit('task_view_subtasks_redrawed');
		},

		filter_counter: function() {
			if (self.total_exists.done) {
				$('.taskView__subtasks__foot > div:last-child').html(App.helper.template.fill(self.filter_task_status.status == SHOW_ALL ? 'subtasks_show_undone' : 'subtasks_show_all', {cnt: self.total_exists.done}));
			} else {
				$('.taskView__subtasks__foot > div:last-child').html('');
			}
		},

		order_func: function(a, b) {
			let cmp = 0;
			let data_a = self.data.task[a];
			let data_b = self.data.task[b];
			if (self.order != 'name' && self.order != 'action'  && self.order != 'action_primary' && self.order != 'create' && self.order != 'sum_time' && self.order != 'sum_money')
			{
				cmp = App.helper.sort.compare(data_a["status"], data_b["status"]) || App.helper.sort.compare(data_b["dateclose"], data_a["dateclose"]);
				if (cmp) return cmp;
			}
			switch (self.order)
			{
				case 'manual_order':
					cmp = App.helper.sort.compare(data_a["manual_order"], data_b["manual_order"]);
					break;
				case 'name':
					cmp = App.helper.sort.compare_strings_natural(data_a["name"], data_b["name"]);
					break;
				case 'finish':
					cmp = App.helper.sort.compare(data_b["dateend"] ? 1 : 0, data_a["dateend"] ? 1 : 0) // desc
						|| App.helper.sort.compare(data_a["dateend"], data_b["dateend"])
						|| App.helper.sort.compare(data_a["timeend"], data_b["timeend"])
						|| App.helper.sort.compare(data_b["important"], data_a["important"]); // desc
					break;
				case 'action':
					cmp = App.helper.sort.compare(data_b["dateact"], data_a["dateact"]);
					break;
				case 'action_primary':
					cmp = App.helper.sort.compare(data_b["dateact_primary"], data_a["dateact_primary"]);
					break;
				case 'start':
					cmp = App.helper.sort.compare(data_a["datestart"], data_b["datestart"]);
					break;
				case 'create':
					break;
				case 'status':
					cmp = App.helper.sort.compare(App.helper.stage.order(data_a['id_stage']), App.helper.stage.order(data_b['id_stage']))
						|| App.helper.sort.compare(data_b["important"], data_a["important"]); // desc
					break;
				case 'sum_time':
					cmp = App.helper.sort.compare(data_b["used_time"], data_a["used_time"]);
					break;
				case 'sum_money':
					cmp = App.helper.sort.compare(data_b["used_money"], data_a["used_money"]);
					break;
				case 'hot':
					cmp = App.helper.sort.compare(data_b["important"], data_a["important"]) // desc
						|| App.helper.sort.compare(data_a["dateend"] ? 1 : 0, data_b["dateend"] ? 1 : 0) // desc
						|| App.helper.sort.compare(data_b["dateend"], data_a["dateend"]);
					break;
				default:
					cmp = App.helper.sort.compare(data_b["important"], data_a["important"]) // desc
						|| App.helper.sort.compare(data_b["dateend"] ? 1 : 0, data_a["dateend"] ? 1 : 0) // desc
						|| App.helper.sort.compare(data_a["dateend"], data_b["dateend"]);
			}
			return (self.desc ? -1 : 1) * (cmp || App.helper.sort.compare(data_b["id"], data_a["id"])); // desc
		},

		drag: {
			init: function (o) {
				let options = {
					clone: true,
					opacity: 1,
					target: '.subtaskList__dropPlace',
					tolerance: 'none',
					before_start: function () {
						return self.obj_window.hasClass('subtaskList-withDrag') && !self.mass.is_shown();
					},
					start: self.drag.onstart,
					end: self.drag.onend,
					move: self.drag.find_nearest_target,
					drop: self.drag.ondrop,
					autoscroll: true,
					target_self: false,
					renewTarget: true
				}
				o.filter('.subtaskList__item-draggable').dragable(options);
				o.find('a').bind('dragstart', function () { return false }).attr('draggable', false);
			},

			ondrop: function (o, target) {
				setTimeout(function () {
					App.state.drag.stop();
					$('body').removeClass('body-dragInProgress');
				}, 100);
				o.elem.removeClass('subtaskList__item-dragThis');
				App.core.async_task.ajax({
					url: App.task_view.url + '?' + App.actions.get('task_subtask_drop:apply'),
					data: {
						id_task_move: o.elem.attr('data-task'),
						id_task_before: target.attr('data-after')
					},
					dataType: 'script'
				});
			},

			onstart: function (o, event) {
				if (!self.obj_window.hasClass('subtaskList-withDrag')) return false;
				o.originalElem.addClass('subtaskList__item-dragThis');
				self.drag.find_nearest_target(o, event);
				$('body').addClass('grabbing');
			},

			onend: function (o, event) {
				o.elem.removeClass('subtaskList__item-dragThis');
				$('body').removeClass('grabbing');
				setTimeout(function () {
					App.state.drag.stop();
					$('body').removeClass('body-dragInProgress');
				}, 100);
				o.target.removeClass('subtaskList__dropPlace-hover');
			},

			find_nearest_target: function (o, event) {
				App.state.drag.start();
				$('body').addClass('body-dragInProgress');
				let j = 10000;
				let i_min = -1;
				o.target.removeClass('subtaskList__dropPlace-hover');

				let dif = 0; //$(o.elem).outerHeight(); //15;
				for (let i = 0; i < o.targetMatrix.length; i++) {
					if (j > Math.abs(o.top + dif - o.targetMatrix[i].y1 - 0.001 * i)
						&& $(o.targetMatrix[i].t).attr('data-task') != o.elem.attr('data-task') // drop to self
						&& o.top > o.targetMatrix[i].y1 - 100 && o.top < o.targetMatrix[i].y1 + 100
						&& o.left > o.targetMatrix[i].x1 - 100 && o.left < o.targetMatrix[i].x2 + 100
					) {
						j = Math.abs(o.top + dif - o.targetMatrix[i].y1 - 0.001 * i);
						i_min = i;
					}
				}
				if (i_min !== -1) {
					o.currentTarget = $(o.targetMatrix[i_min].t);
					o.currentTarget.addClass('subtaskList__dropPlace-hover');
				} else {
					o.currentTarget = null;
				}
			}
		},
		task_add_form: {
			sent: true,
			pending_next_place: null,
			place: 'top',
			is_loading: false,
			context_menu: null,
			form: function () {
				return self.obj_container.find('.subtaskForm');
			},
			focus_input: App.helper.debounce(function () {
				if (!self.task_add_form.form().hasClass('subtaskForm-active')) return;

				self.task_add_form.form().find('.input').focus();
			}),
			set_next_place: function (new_place) {
				this.pending_next_place = null;
				this.form().attr('data-place', new_place);
			},
			toggle_loading: function (st) {
				this.is_loading = st;
			},
			update_position: function (new_place) {
				let form = this.form();

				if (new_place != null) {
					this.place = new_place;
					form.attr('data-place', new_place);
				}

				let list = self.obj_container.find('.subtaskList');
				let order = form.find('input[name="order"]');
				let place = form.attr('data-place');
				let place_task = parseInt(place) > 0 ? list.children('[id*="subtask'+place+'"]') : null

				if (place_task != null && place_task.length === 1) {
					place_task.after(form);
					order.val(self.data.get_manual_order('task', place) + 1);
				} else if (place === 'bottom') {
					let more_block = list.find('.subtaskList__moreItems');

					if (more_block.length === 1) {
						more_block.before(form);
					} else {
						form.appendTo(list);
					}

					order.val(self.data.get_manual_order('task', list.children('.subtaskList__item').last().attr('data-task')) + 1);
				} else {
					form.prependTo(list);
					order.val(0);
				}

				let add_btn = form.find('.btn-add');

				if (self.order === 'manual_order' && place !== 'bottom') {
					add_btn.attr('data-title', add_btn.attr('data-title-manual'));
				} else {
					add_btn.attr('data-title', add_btn.attr('data-title-default'));
				}

				this.focus_input();
			},
			is_active: function () {
				return this.form().hasClass('subtaskForm-active');
			},
			activate: function () {
				this.form().addClass('subtaskForm-active');
			},
			show_form: function (place) {
				let form = this.form();

				$('.taskView__subtasks__wrapper').removeClass('collapsed');

				this.update_position(place);

				if (this.is_active()) form.shortblink();

				this.activate();
				this.focus_input();
				self.obj_container.find('.subtaskForm .btn-add').toggleDisabled(this.form().find('.input').val().trim() === '');
			},
			init: function() {
				let form = this.form();
				if (form.length === 0) return;

				form.find('span.open').bind('click', function(e) {
					App.subtasks.task_add_form.open_full_mode($(this).closest('form'));
					e.stopPropagation()
				});

				App.ui.onMouse(self.obj_container.find('.taskView__subtasks'), '.plus', {
					open: function (e) {
						App.task_create.new($(e.el).attr('data-params'));
					},
					click: function (e) {
						if ($(e.el).attr('data-full')) {
							App.task_create.new($(e.el).attr('data-params'));
						} else {
							self.task_add_form.show_form($(e.target).closest('.taskView__subtasks__foot').length === 1 ? 'bottom' : 'top');
						}
					},
					dblclick: function (e) {
						App.task_create.new($(e.el).attr('data-params'));
					}
				})

				for (let i in self.task_add_form.components) {
					self.task_add_form.components[i].init();
				}

				self.obj_container.find('.subtaskForm form .input').bind('keydown', function (e) {
					if (this.is_loading) return;

					if (e.keyCode === App.keycode.Escape) {
						if (App.menu.is_shown()) return; // Esc close menu
						self.task_add_form.hide_form(true);
						return false;
					}
					if (e.keyCode === App.keycode.Enter && e.shiftKey && self.order === 'manual_order' && self.task_add_form.place !== 'bottom') {
						self.task_add_form.pending_next_place = 'after_add';
					}
				}).bind('keyup', function (e) {
					self.obj_container.find('.subtaskForm .btn-add').toggleDisabled($(this).val().trim() === '');
				});
				self.obj_container.find('.subtaskForm form').bind('submit', function(e) {
					if (this.is_loading) return;

					if ($(this).find('.input').val().trim() !== '') {
						if (self.order !== 'manual_order' && -1 === ['top', 'bottom'].indexOf(self.task_add_form.place)) {
							self.task_add_form.set_next_place('top');
						}
						self.task_add_form.toggle_loading(true);
						App.core.async_task.ajax({
							id: 'subtask_form_submit',
							url: $(this).attr('data-action') + '&' + $(this).serialize(),
							type: 'GET',
							dataType: 'script',
						}).then(function () {
							self.task_add_form.reset_form();
						}).finally(function () {
							self.task_add_form.toggle_loading(false);
						});
					} else {
						self.task_add_form.form().animate_css('head-shake');
					}

					return false;
				});
				self.task_add_form.init_context_menu(self.task_add_form.form().find('input[name=name]'));
				self.task_add_form.init_multiline_paste(self.task_add_form.form().find('input[name=name]'));
			},
			init_context_menu: function (input) {
				const context_menu = new App.classes.task_context_menu({
					components: [
						{type: 'priority', selected: self.task_add_form.components.priority.is_selected()},
						{type: 'stage', selected: self.task_add_form.components.stage.is_selected()},
						{type: 'assignee', selected: self.task_add_form.components.assignee.is_selected()},
					],
					input: input
				});
				context_menu.on('task_context_menu.component.show', function (component) {
					self.task_add_form.components[component.type]?.show(component.element());
				});
				context_menu.on('task_context_menu.component.clear', function (component) {
					self.task_add_form.components[component.type]?.clear(component.element());
				})
				self.task_add_form.context_menu = context_menu;
			},
			init_multiline_paste: function(input) {
				App.helper.handle_multiline_paste.register(input, self.task_add_form.open_mass, () => null)
			},
			open_mass: function (texts = []) {
				const form = self.task_add_form.form().find('form');
				const data = new URLSearchParams(form.data('params'));
				App.task_create_mass.show({
					request: {
						id_project: data.get('id_project'),
						id_parent: data.get('id_parent'),
					},
					onload: function() {
						if (texts.length) {
							App.task_create_mass.removeRows();
							App.task_create_mass.fill_rows(...texts);
						}
					}
				})
			},
			components: {
				priority: {
					init: function () {
						self.obj_container.find('.subtaskForm [data-container=priority] a').bind('click', function(e, data) {
							App.controls.priority.open(this, {
								anchor: data?.anchor || this,
								backup: data?.backup || false,
								onApply: function (id) {
									if (id === '1') {
										self.obj_container.find('.subtaskForm form').trigger('change');
										self.task_add_form.context_menu?.emit('task_context_menu.component.cleared', 'priority');
									} else {
										self.obj_container.find('.subtaskForm form').trigger('change');
										self.task_add_form.context_menu?.emit('task_context_menu.component.selected', 'priority');
									}
								}
							});
						});
					},
					show: function (element) {
						self.obj_container.find('.subtaskForm [data-container=priority] a').trigger('click', {
							anchor: element,
							backup: true
						});
					},
					clear: function() {

						const id = '1';

						self.obj_container.find('.subtaskForm [data-container=priority] a').each(function () {
							const el = $(this);
							if (el.attr('data-obj')) {
								$(el.attr('data-obj')).val(id);
								$(el.attr('data-obj'))[0].dispatchEvent(new Event('change', {bubbles: true}));
							}
							el.attr('class', el.attr('class').replace(/ prior\d+/, '') + ' prior' + id).html(id == 0 ? PRIOR0_HTML : App.helper.priority.id_to_num(id));
						});

						self.obj_container.find('.subtaskForm form').trigger('change');
						self.task_add_form.context_menu?.emit('task_context_menu.component.cleared', 'priority');
					},
					is_selected: function() {
						return self.task_add_form.form().find('input[name=important]').val() !== '1';
					}
				},
				stage: {
					init: function () {
						self.obj_container.find('.subtaskForm [data-container=stage]').bind('click', function(e, data) {
							App.controls.project_task_stage_and_go.show_context(data?.anchor || this, App.helper.url.add_query(App.helper.endpoint.ajax(App.task_view.get_id_project()), App.actions.get('project_task_stage_and_go:show'), {new_task:true,from:'subtask'}), {
								onload: function() {
									$(this).on('click', '.menu__item', function() {
										self.task_add_form.components.stage.callback.call(this);
										App.menu.hide();
									})
								},
								backup: data?.backup || false,
							});
						});
					},
					show: function (element) {
						self.obj_container.find('.subtaskForm [data-container=stage]').trigger('click', {
							anchor: element,
							backup: true
						});
					},
					callback: function () {

						if ($(this).attr('data-id') === '0') {
							self.task_add_form.components.stage.clear();
						} else {
							self.obj_container.find('.subtaskForm [data-container=stage]').html(App.helper.template.fill('subtask_create_stage', {
								name: $(this).find('.flex_content').text(),
								color: $(this).attr('data-color'),
								id: $(this).attr('data-id'),
								icon: $(this).find('ws-icon').attr('name'),
								percent_style: $(this).attr('data-percent-style') ? ' style="--percent: ' + $(this).attr('data-percent-style') + '"' : '',
							}));

							self.obj_container.find('.subtaskForm form').trigger('change');
							self.task_add_form.context_menu?.emit('task_context_menu.component.selected', 'stage')
						}

						let o = $(this).find('.av_pre');
						if (o.length && App.helper.user.get_id_user_assignee_on_create(o.attr('data-id'))) {
							self.task_add_form.components.assignee.set({
								name: o.attr('data-name'),
								avatar: o.html(),
								id: o.attr('data-id'),
							});
						}
					},
					clear: function () {
						const backlog = App.tags[2]; // @see Tags::$id_system_map

						self.obj_container.find('.subtaskForm [data-container=stage]').html(App.helper.template.fill('subtask_create_stage', {
							name: backlog.name,
							color: backlog.color,
							id: '0',
							icon: App.tags_type_icon[0][backlog.id_type]
						}));

						self.obj_container.find('.subtaskForm form').trigger('change');
						self.task_add_form.context_menu?.emit('task_context_menu.component.cleared', 'stage')
					},
					is_selected: function() {
						return self.task_add_form.form().find('input[name=id_stage]').val() === '0';
					}
				},
				assignee: {
					init: function () {
						self.obj_container.find('.subtaskForm [data-container=user]').bind('click', function(e, data) {
							if (self.task_add_form.components.assignee.get_ids().length > 1 || data?.multi) {
								const ids = self.task_add_form.components.assignee.get_ids();
								App.controls.user_select_and_go.show_context(this, App.helper.url.add_query(self.url, App.actions.get('task_user_select_and_go:show'), {multiple: 1, type: 'subtask'}), {
									onload: function() {
										let menu = $(this);
										App.controls.menu.init(menu);
										$(this).on('click', '.menu__item, .menu__itemFake', function() {
											self.task_add_form.components.assignee.callback_multiple.call(menu);
										});
									},
									onshow: function() {
										$(this).find('.menu__item').each(function() {
											$(this).toggleClass('menu__item-active', ids.includes($(this).attr('data-id').toInt()));
										});
									},
									anchor: data?.anchor || this,
									backup: data?.backup || false,
								});
							} else  {
								App.controls.user_select_and_go.show_context(this, App.helper.url.add_query(self.url, App.actions.get('task_user_select_and_go:show'), {multiple_enabled: 1, type: 'subtask'}), {
									onload: function() {
										$(this).on('click', '.menu__item', function() {
											self.task_add_form.components.assignee.callback.call(this);
											App.menu.hide();
										}).on('click', '.multi-select', function() {
											App.menu.hide(true);
											self.obj_container.find('.subtaskForm [data-container=user]').trigger('click', [{multi:true}]);
										});
									},
									anchor: data?.anchor || this,
									backup: data?.backup || false,
								});
							}
						});
					},
					callback_multiple: function () { // this = menu
						let o = $(this).find('.menu__item-active');
						if (o.length === 0) { // none selected fallback
							self.task_add_form.components.assignee.clear();
							return false;
						}
						if (o.length === 1) { // single selected fallback
							self.task_add_form.components.assignee.callback.call(o.get(0));
							return false;
						}
						let ids = [];
						o.each(function() {
							ids.push($(this).attr('data-id'));
						});
						const avatar = $(`<span>${ids.length}</span>`)
							.addClass('av_sm av_let av_let0');

						self.obj_container.find('.subtaskForm [data-container=user]').html(App.helper.template.fill('subtask_create_assignee_multiple', {
							avatar: avatar[0].outerHTML,
							ids: ids
						}));
						self.task_add_form.context_menu?.emit('task_context_menu.component.selected', 'assignee')
						self.obj_container.find('.subtaskForm form').trigger('change');
						return false;
					},
					callback: function () {
						self.task_add_form.components.assignee.set({
							name: $(this).find('.in').text(),
							avatar: $(this).find('.av_sm').get(0).outerHTML,
							id: $(this).attr('data-id'),
						});
					},
					clear: function () {
						self.obj_container.find('.subtaskForm [data-container=user]').html(App.helper.template.fill('subtask_create_assignee', {
							avatar: $('<ws-icon name="person" class="av_sm av_svg"></ws-icon>')[0].outerHTML,
							id: NO_ASSIGNEE,
						}));
						self.obj_container.find('.subtaskForm form').trigger('change');
						self.task_add_form.context_menu?.emit('task_context_menu.component.cleared', 'assignee')
					},
					show: function (element) {
						self.obj_container.find('.subtaskForm [data-container=user]').trigger('click', {anchor: element, backup: true});
					},
					set: function ({ id, name, avatar }) {
						if (id?.toString()?.toInt() === NO_ASSIGNEE) {
							self.task_add_form.components.assignee.clear();
							return;
						}
						self.obj_container.find('.subtaskForm [data-container=user]').html(App.helper.template.fill('subtask_create_assignee', {
							name,
							avatar,
							id,
						}));
						self.obj_container.find('.subtaskForm form').trigger('change');
						self.task_add_form.context_menu?.emit('task_context_menu.component.selected', 'assignee')
					},
					get_id: function() {
						return self.obj_container.find('.subtaskForm [data-container=user] input[name=id_user_to]').length ? self.obj_container.find('.subtaskForm [data-container=user] input[name=id_user_to]').val().toInt() : 0;
					},
					get_ids: function() {
						return self.obj_container.find('.subtaskForm [data-container=user] input[name=ids_assignee]').length ? self.obj_container.find('.subtaskForm [data-container=user] input[name=ids_assignee]').val().toIntArray() : [self.task_add_form.components.assignee.get_id()];
					},
					is_selected: function() {
						return self.task_add_form.components.assignee.get_id() !== NO_ASSIGNEE;
					}
				}
			},
			open_full_mode: function () {
				if (this.is_loading) return;

				let form = this.form().find('form');
				App.task_create.new(form.attr('data-params') + '&' + form.serialize());
				this.hide_form(true);
			},
			hide_form: function (do_reset) {
				this.form().removeClass('subtaskForm-active');
				if (do_reset) this.reset_form();
			},
			reset_form: function () {
				this.form().find('.input').val('');
			},

			destructor: function() {
				self.task_add_form.sent = true;
				self.task_add_form.pending_next_place = null;
				self.task_add_form.place = 'top';
				self.task_add_form.is_loading = false;
				self.task_add_form.context_menu = null;
			},
		},

		init: function () {
		},

		init_items: function () {
			self.obj_window.on('click dblclick', '.subtaskList__item', function (e) {
				if ($(e.target).closest('.subtaskForm, [onclick]').length > 0) return;
				if ($(e.target).is('task-wait')) return;

				if (App.click_listener.is_moved(e)) return false;
				if (App.state.drag.is_on) return false;
				if (!$(this).find('a.t').length) return false;

				if (self.mass.is_shown() || e.shiftKey || App.click_listener.is_longclick(e)) {
					self.mass.onClickItem(this, e);
					return false;
				}

				let anchor = this;
				if (!$(e.target).parents().addBack().filter('a:not(.t),.av_sm, label').length) {
					let a = $(this).find('a.t').attr('href');
					if (e.metaKey || e.ctrlKey) {
						App.core.new_window(a);
					} else if (e.type == 'dblclick' || $(window).width() <= 480 || !App.device.is_preview_on()) {
						App.click_listener.longclick.stop(e);
						App.task_view.show({url: a, anchor});
						return false;
					} else {
						App.click_listener.longclick.call(function () {
							App.task_view.show({url: a, anchor});
						});
					}
					return false;
				}
			});
		},

		sorting_update: function (el, type, save) {
			self.order = type;
			App.core.async_task.ajax('/ajax/?' + App.actions.get('subtasks_config:apply') + '&key=order&value=' + type);
			$('#subtaskList').toggleClass('subtaskList-withDrag', type === 'manual_order')
			self.process_filter_and_search(ORDER_CHANGE);
		},

		initial_item_highlight: function () {
			$('.st_highlight').blink().removeClass('st_highlight').first().scroll_to_this();
		},

		update_progress_bars_done: function() {
			let html = '', txt1, txt2, stats = $('.taskView__subtasks__head .stats');
			let cnt_done = 0, cnt = 0, cnt_hot = 0, cnt_undone = 0;
			for (let id in self.data.task) if (self.direct_child_check(id)) {
				cnt++;
				if (self.data.task[id]['status']) cnt_done++;
				else if (self.data.task[id]['class'].split(' ').includes('p' + App.components.task_terms.list_task_classes['burning'])) cnt_hot++;
			}

			// self.obj_container.find('.taskView__subtasks__wrapper').toggleClass('collapsed', cnt === 0);
			self.obj_container.toggleClass('taskView-no_subtasks', cnt === 0);

			if (cnt === 0) {
				stats.html('');
				self.obj_container.find('.taskView__head .btn-subtasks').addClass('hiddenBlock');
				return;
			}

			cnt_undone = cnt - cnt_done;
			self.obj_container.find('.taskView__head .btn-subtasks').attr('text', cnt_undone).toggleClass('hiddenBlock', cnt_undone === 0);

			txt1 =  Math.floor(100 * cnt_done / cnt) + '%';
			txt2 = App.object_state.locale['done_s_of_s']
				.replace('%s', cnt_done)
				.replace('%s', App.format.quantity(cnt, App.object_state.locale['subtasks'], QTY_WITH_TEXT));

			if (cnt_hot > 0) txt2+= '%NL%%R' + App.format.quantity(cnt_hot, App.object_state.locale['task_overdue'], QTY_WITH_TEXT) + 'R%'

			html = App.helper.template.fill('progress_done_subtasks', {
				type: 'done',
				txt1: txt1,
				txt2: App.object_state.locale['done_s_of_s'].replace('%s', cnt_done).replace('%s', cnt),
				real: cnt_done,
				max: cnt,
				over: cnt_hot,
				txt_over: App.format.quantity(cnt_hot, App.object_state.locale['task_overdue'], QTY_WITH_TEXT)
			});

			stats.attr('data-title', txt2).html(html);
		},

		draw_item_done_progress: function(id) {
			if (self.data.task[id]['id_parent'] !== self.data.task[id]['id_parent_top']) return;
			let cnt_done = 0, cnt = 0, cnt_hot = 0;
			if (id in self.tree['parent']) {
				self.tree['parent'][id].forEach(function(id_child) {
					cnt++;
					if (self.data.task[id_child]['status']) cnt_done++;
					else if (self.data.task[id_child]['class'].split(' ').includes('p' + App.components.task_terms.list_task_classes['burning'])) cnt_hot++;
				});
			}
			self.dom.task[id].find('.child_num').toggleClass('child_num-visible', cnt - cnt_done > 0).find('ws-btn').attr('text', cnt - cnt_done);
		},

		load_more_data: function () {
			self.task_add_form.hide_form();
			self.paginal.per_page[App.task_view.id] = 2 * self.paginal.per_page[App.task_view.id];
			self.draw();
		},

		helper_option_toggle(param, value) {
			App.menu.hide();
			App.core.async_task.ajax('/ajax/?' + App.actions.get('subtasks_config:apply') + '&key='+param+'&value=' + value);
		},

		onBoot: function () {
			const mass = App.helper.object.clone(App.mass);

			mass.show = function() {
				this.shown = true;
				App.subtasks.obj_container.addClass('taskView-withSubtaskMass');
				App.task_view.scroller.helper_link_subtask_wrapper();
				App.subtasks.task_add_form.hide_form();
			}
			mass.hide = function() {
				this.shown = false;
				App.subtasks.obj_container.removeClass('taskView-withSubtaskMass');
				App.task_view.scroller.helper_link_subtask_wrapper();
			};

			self.mass = mass.initController({
				config: {
					obj_type: 'subtask',
				},
				autofit: true,
				click_enabled: true,
				panel: () => self.obj_container.find('.subtaskListPanel__mass'),
				container: () => self.obj_container.find('.subtaskList'),
				process_checkbox(mass, { val, rels }) {
					if (rels.includes('label')) {
						mass.add_id(rels.includes('stage_done') ? 'stage_done' : 'stage_undone', val);
					}
				}
			});
		},

		onLogin: function () {
			App.bus.window.on('resize', self.mass.fit_menu);
			App.bus.app.on('task_view_fullscreen task_view_resize_end', self.mass.fit_menu);
			App.bus.app
				.on('task_view_ready', function () {
					self.obj_container = App.task_view.obj_window;
					self.obj_window = self.obj_container.find('.subtaskList');

					if (self.obj_window.attr('data-init') !== 'yes') {
						self.obj_window.attr('data-init', 'yes');
						self.init();
						self.init_items();
						self.task_add_form.init();
						self.initial_item_highlight();
						self.mass.init_menu();
					}

					self.url = self.mass.config.url = App.task_view.url;
					self.process_filter_and_search(CHANGE_VIEW);
				})
				.on('task_view_unready', function () {
					clearTimeout(self.draw_timer);
					App.core.async_task.abort('subtasks_load_items');
					App.core.async_task.abort('subtask_form_submit');
				});
		},
		destructor: function () {

			self.data.destructor();
			self.dom.destructor();
			self.filter_task_status.destructor();
			self.task_add_form.destructor();

			self.url = '';
			self.obj_window = null;
			self.obj_container = null;
			self.loaded = false;

			self.order = '';
			self.desc = false;
			self.match = {};
			self.match_plus_parents = {};
			self.match_state = null;
			self.match_projects = [];
			self.total_match = 0;
			self.total_exists = {
				done : 0,
				undone: 0,
				all: 0,
			};
			self.tree = {
				'parent': {},
				'parent_top': {},
			};
			self.match_tree = {
				'project': {},
				'parent': {},
			};

			self.updated_state = {};

			self.paginal = {
				per_page_default: 25,
				page_grow: 25,
				per_page: {},
				loaded_ids: {}
			};
		},
		onLogout: () => self.destructor(),
	};
})();

;var App = App || {};

const SWIPE_DETECT_STATE = 'detect';

(function() {
	const can_scroll = (target, diff) => {
		let horizontal = Math.abs(diff.x) > Math.abs(diff.y);
		let now_break = false;

		const get_closest_scrollZone = (el, init) => {
			const scrollZone = init
				? $(el).closest('.scrollZone, .ps, textarea, .flex_row-scrollable')
				: $(el).parent().closest('.scrollZone, .ps, textarea, .flex_row-scrollable');

			if (!scrollZone.length) return $();
			if (!now_break && scrollZone.length && scrollZone.canScrollToDirection((horizontal ? diff.x : diff.y) < 0 ? 1 : -1, horizontal)) {
				return scrollZone;
			}
			return get_closest_scrollZone(scrollZone, false);
		};

		const scrollZone = get_closest_scrollZone(target, true);

		return Boolean(scrollZone.length);
	};
	// для меню врахував кейс, коли підменю без скролЗони вкладено в меню зі скролЗоною
	const can_scroll_in_menu = (target, diff) => {
		let horizontal = Math.abs(diff.x) > Math.abs(diff.y);
		let rootMenu = $(target).closest('.menu');

		if (rootMenu.is('#editorEmojiMenu')) return true;
		// пофіг на скрол - форсимо відкриття на фулскрін
		if (!rootMenu.hasClass('menu-fullscreen')) return false;

		const scrollZone = $(target).closest('.scrollZone, .ps, textarea');

		if (!scrollZone.length || !scrollZone.closest(rootMenu).length) {
			return false;
		}

		return scrollZone.canScrollToDirection((horizontal ? diff.x : diff.y) < 0 ? 1 : -1, horizontal);
	};
	const has_selection_inside = (container) => {

		container = $(container).get(0);

		const sel = window.getSelection?.();
		if (!sel || sel.isCollapsed || !sel.rangeCount) return false;

		const range = sel.getRangeAt(0);
		return (
			container === range.commonAncestorContainer ||
			container.contains(range.commonAncestorContainer)
		);
	};
	const selection_inside_selectable_block = (target) => {
		const sel = window.getSelection?.();
		if (!sel || sel.isCollapsed || !sel.rangeCount) return false;

		const range = sel.getRangeAt(0);
		const sel_node = range.commonAncestorContainer;

		// знаходимо найближчий блок, де дозволений select
		const selectable = sel_node.nodeType === Node.ELEMENT_NODE
			? sel_node.closest('[data-allow-select], [contenteditable=""], [contenteditable="true"]')
			: sel_node.parentElement?.closest('[data-allow-select], [contenteditable=""], [contenteditable="true"]');

		if (!selectable) return false;

		// перевіряємо, що жест стартував у цьому ж блоці
		return selectable.contains(target);
	};


	let self = App.swipe = {
		x: null,
		y: null,
		type: null,
		target_el: null,
		modal_preview_x: null,
		modal_preview_y: null,
		move_prevent_default: false,

		last_pos: { x: null, y: null },
		last_direction: null,
		last_time: null,

		components: {

			// має спрацювати нативний жест, тому не треба наших свайпів
			safe_area: {
				direction: 'both',
				condition: function(e) {
					let target = e.target;
					return Boolean($(target).closest('#sa_bot').length);
				},
				onstart: function () {
				},
				onmove: function (diff) {
				},
				onend: function () {
				},
			},

			dashboard_iceland__switcher: {
				o: null,
				direction: 'vertical',
				current_index: null,
				stop: false,
				condition: function(e, diff) {
					let target = e.target;
					this.o = $(target).closest('.iceland__switcher');

					if (!App.device.is_mobile() || !this.o.length) {
						return false;
					}

					// return true; // або карусель

					const current_index = parseInt(this.o.css('--switcher-active-i'), 10);
					const offset = (diff.y < 0 ? -1 : 1);
					const total = parseInt(this.o.css('--switcher-n'), 10);
					const new_index = (current_index + offset).clamp(1, total);

					return new_index != current_index;
				},
				onstart: function () {
					this.stop = false;
					this.current_index = parseInt(this.o.css('--switcher-active-i'), 10);
				},
				onmove: function (diff) {

					if (this.stop) {
						return;
					}

					const current_index = this.current_index;
					const offset = (diff.y < 0 ? -1 : 1);
					const total = parseInt(this.o.css('--switcher-n'), 10);
					const new_index = (current_index + offset).clamp(1, total);
					// const new_index = ((current_index - 1 + offset + total) % total) + 1; // або карусель

					this.stop = true;
					App.controls.dashboard.iceland.switcher_toggle(this.o, null, {
						next_index: new_index
					});
				},
				onend: function () {
					this.stop = false;
				}
			},

			mobile_dashboard_block: {
				o: null,
				direction: 'both',
				disable: false,
				condition: function(e, diff) {
					let target = e.target;
					let horizontal = Math.abs(diff.x) > Math.abs(diff.y);
					this.o = $(target).closest('.scrollZone');
					return App.device.is_mobile() && this.o.length && $('.dashboard').length
						&& this.o.canScrollToDirection((horizontal ? diff.x : diff.y) < 0 ? 1 : -1, horizontal) && this.o.parents().addBack().filter('.dashboard__block').length;
				},
				onstart: function () {},
				onmove: function (diff) {
					this.o.scrollTop(this.o.scrollTop() - diff.y);
					this.o.scrollLeft(this.o.scrollLeft() - diff.x);
					self.x += diff.x;
					self.y += diff.y;
					this.last_diff_top = diff.y;
					this.last_diff_left = diff.x;
				},
				onend: function () {}
			},
			mobile_datatable_horizontal: {
				o: null,
				direction: 'horizontal',
				diffX: 0,
				disable: false,
				scrollTimeout: null,
				condition: function(e, diff) {
					let target = e.target;
					let check = false;

					this.o = $(target).parents().addBack().filter('.' + App.controls.datatable.wrapperClass);
					if (App.device.is_mobile() && this.o.length && App.controls.datatable.obj?.length && !self.components.mobile_datatable_horizontal.disable) {
						check = this.o.canScrollToDirection(diff.x < 0 ? 1 : -1, true) && self.x >= App.controls.datatable.scrollBar.startX;
						if (check) {
							if (diff.x <= 0 && App.controls.datatable.columnMainMobilePercent !== App.controls.datatable.columnMainMobilePercentMin) {
								self.components.mobile_datatable_horizontal.mainscroll(App.controls.datatable.columnMainMobilePercentMin, true);
							}
						} else {
							e.preventDefault();
							self.move_prevent_default = true;
							if (self.x < App.controls.datatable.scrollBar.startX) {
								if (diff.x > 0 && App.controls.datatable.columnMainMobilePercent === 0.7
									|| diff.x <= 0 && App.controls.datatable.columnMainMobilePercent === App.controls.datatable.columnMainMobilePercentMin) return false;
								self.components.mobile_datatable_horizontal.mainscroll(diff.x > 0 ? 0.7 : App.controls.datatable.columnMainMobilePercentMin);
							} else if (diff.x > 0) {
								self.components.mobile_datatable_horizontal.mainscroll(0.7);
							}
						}
					}
					return check;
				},
				onstart: function () {
					$('#mobileMenu__wrapper').addClass('noani swype');
					App.controls.datatable.obj.find('.ps__rail-x').addClass('ps__rail-active');
					clearTimeout(self.components.mobile_datatable_horizontal.scrollTimeout);
				},
				onmove: function (diff) {
					if (!self.components.mobile_datatable_horizontal.disable) {
						this.o.scrollLeft(this.o.scrollLeft() - diff.x);
						self.components.mobile_datatable_horizontal.diffX += diff.x
						self.x += diff.x;
					}
				},
				onend: function () {
					self.move_prevent_default = false;
					self.components.mobile_datatable_horizontal.disable = false;
					let columnMobileWidth = Math.floor(App.controls.datatable.obj.innerWidth() * App.controls.datatable.columnMobilePercent);
					let scrolledElem = false;

					if (self.components.mobile_datatable_horizontal.diffX < 0) {
						$.each(App.controls.datatable.tableObjData.thWidths, function(key, value) {
							if (!scrolledElem && App.controls.datatable.get_scroll_offset_left() < value) {
								scrolledElem = true;
								if (self.components.mobile_datatable_horizontal.diffX <= -50
									|| value - App.controls.datatable.get_scroll_offset_left() <= columnMobileWidth / 2) {
									App.controls.datatable.scrollBar.zone.scrollTo({left: value, behavior: 'smooth'});
								}
							}
						});
					} else {
						let tmp = App.controls.datatable.tableObjData.thWidths.slice().reverse();
						tmp.push(0);
						$.each(tmp, function(key, value) {
							if (!scrolledElem && App.controls.datatable.get_scroll_offset_left() > value) {
								scrolledElem = true;
								if (self.components.mobile_datatable_horizontal.diffX >= 50
									|| App.controls.datatable.get_scroll_offset_left() - value <= columnMobileWidth / 2) {
									App.controls.datatable.scrollBar.zone.scrollTo({left: tmp[key], behavior: 'smooth'});
								}
							}
						});
					}

					self.components.mobile_datatable_horizontal.diffX = 0;
					self.components.mobile_datatable_horizontal.scrollTimeout = setTimeout(function() {
						App.controls.datatable.obj.find('.ps__rail-x').removeClass('ps__rail-active');
					}, 500);
				},
				mainscroll: function(percent, noreset) {
					let oldPercent = App.controls.datatable.columnMainMobilePercent;
					self.components.mobile_datatable_horizontal.disable = true;
					App.controls.datatable.columnMainMobilePercent = percent;
					App.controls.datatable.shadows_remove();
					App.controls.datatable.shadowsTimeoutMS = 500;
					App.controls.datatable.calibrate(false, true);
					setTimeout(function() {
						if (percent > oldPercent) {
							App.controls.datatable.obj_head.find('th.main ws-icon[name=subtask]').show();
							App.controls.datatable.obj.find('td.main span.space-asTD').removeClass('space-none');
						} else if (percent < oldPercent) {
							App.controls.datatable.obj_head.find('th.main ws-icon[name=subtask]').hide();
							App.controls.datatable.obj.find('td.main span.space-asTD').addClass('space-none');
						}
						App.controls.datatable.scrollBar.calculateStartEndX();
						if (!noreset) self.components.mobile_datatable_horizontal.disable = false;
					}, App.controls.datatable.shadowsTimeoutMS);
				}
			},
			mobile_datatable_vertical: {
				o: null,
				direction: 'vertical',
				diffY: 0,
				disable: false,
				scrollTimeout: null,
				condition: function(e, diff) {
					let target = e.target;
					this.o = $(target).parents().addBack().filter('.' + App.controls.datatable.wrapperClass);
					return App.device.is_mobile() && this.o.length && this.o.canScrollToDirection(diff.y < 0 ? 1 : -1, false) && App.controls.datatable.obj?.length;
				},
				onstart: function () {
					$('#mobileMenu__wrapper').addClass('noani swype');
					App.controls.datatable.obj.find('.ps__rail-y').addClass('ps__rail-active');
					clearTimeout(self.components.mobile_datatable_vertical.scrollTimeout);
				},
				onmove: function (diff) {
					this.o.scrollTop(this.o.scrollTop() - diff.y);
					self.components.mobile_datatable_vertical.diffY += diff.y
					self.y += diff.y;
				},
				onend: function () {
					if (self.components.mobile_datatable_vertical.diffY < -150) {
						App.controls.datatable.scrollBar.zone.scrollTo({top: App.controls.datatable.get_scroll_offset_top() - self.components.mobile_datatable_vertical.diffY, behavior: 'smooth'});
					}
					if (self.components.mobile_datatable_vertical.diffY >= 150) {
						App.controls.datatable.scrollBar.zone.scrollTo({top: App.controls.datatable.get_scroll_offset_top() - self.components.mobile_datatable_vertical.diffY, behavior: 'smooth'});
					}
					self.components.mobile_datatable_vertical.diffY = 0;
					self.components.mobile_datatable_vertical.scrollTimeout = setTimeout(function() {
						App.controls.datatable.obj.find('.ps__rail-y').removeClass('ps__rail-active');
					}, 1500);
				},
			},
			datatable: {
				o: null,
				direction: 'both',
				disable: false,
				condition: function(e, diff) {
					let target = e.target;
					let horizontal = Math.abs(diff.x) > Math.abs(diff.y);
					this.o = $(target).parents().addBack().filter('.' + App.controls.datatable.wrapperClass);
					return this.o.length && this.o.canScrollToDirection((horizontal ? diff.x : diff.y) < 0 ? 1 : -1, horizontal) && App.controls.datatable.obj?.length;
				},
				onstart: function () {},
				onmove: function () {},
				onend: function () {}
			},
			scrollZone: {
				o: null,
				direction: 'both',
				disable: false,
				last_diff_top: 0,
				last_diff_left: 0,
				inertia_running: false,
				condition: function(e, diff) {
					return false;
					const get_closest_scrollZone = (el, init) => {
						const scrollZone = init
							? $(el).closest('.scrollZone, .ps, textarea').not('.scrollZone[data-block]')
							: $(el).parent().closest('.scrollZone, .ps, textarea').not('.scrollZone[data-block]');

						if (!scrollZone.length) return $(el);
						if (!now_break && scrollZone.length && scrollZone.canScrollToDirection((horizontal ? diff.x : diff.y) < 0 ? 1 : -1, horizontal)) {
							return scrollZone;
						}
						return get_closest_scrollZone(scrollZone, false);
					};

					let target = e.target;
					let horizontal = Math.abs(diff.x) > Math.abs(diff.y);
					let now_break = false;
					if (window.getSelection().toString().length > 0 || App.controls.dashboard.drag.obj ||
						!App.device.is_touch_screen() && $(e.target).closest('[data-allow-select=true], [name=drag_indicator]').length > 0) now_break = true;

					this.o = get_closest_scrollZone(target, true);
					return !now_break && this.o.length && this.o.canScrollToDirection((horizontal ? diff.x : diff.y) < 0 ? 1 : -1, horizontal);
				},
				onstart: function () {
					this.inertia_running = false;
					$('#mobileMenu__wrapper').addClass('noani swype');

					App.device.is_touch_screen() && this.o.addClass('scrollZone--scrolled');
				},
				onmove: function (diff) {
					if (this.o.canScrollToDirection(diff.y < 0 ? 1 : -1, false)) {
						this.o.scrollTop(this.o.scrollTop() - diff.y);
					}
					if (this.o.canScrollToDirection(diff.x < 0 ? 1 : -1, true)) {
						this.o.scrollLeft(this.o.scrollLeft() - diff.x);
					}
					self.x += diff.x;
					self.y += diff.y;
					this.last_diff_top = diff.y;
					this.last_diff_left = diff.x;
				},
				onend: function () {
					let t = this;
					let top = t.last_diff_top, left = t.last_diff_left, o = t.o;

					let inertia = function () {
						if (!t.inertia_running) return;
						if (Math.abs(top) < 1 && Math.abs(left) < 1) {
							t.inertia_running = false;

							App.device.is_touch_screen() && o.removeClass('scrollZone--scrolled');
							return;
						}

						top*= 0.95;
						left*= 0.95;

						if (Math.abs(top) > 1 && o.canScrollToDirection(top < 0 ? 1 : -1, false)) o.scrollTop(o.scrollTop() - top);
						if (Math.abs(left) > 1 && o.canScrollToDirection(left < 0 ? 1 : -1, true)) o.scrollLeft(o.scrollLeft() - left);

						requestAnimationFrame(inertia);
					};

					t.inertia_running = true;
					requestAnimationFrame(inertia);
				},
			},


			file_listing: {
				direction: 'horizontal',
				selection: null,
				condition: function(e, diff) {

					if ($(e.target).closest('#modal__previewPanel').length) return false;
					if ($(e.target).closest('#modal__previewFrame.w_scroll').length) return false;

					const $overlay = $(e.target).closest('.modal__overlay-withPanel');
					const o_len = $(e.target).closest('#modal__previewImage').length
						// даю свайпать по оверлею, щоб маленькі картинки було зручно перемикати
						|| $overlay.next('#modal__previewImage').length
						|| $overlay.find('#modal__alert, #modal__previewFrame, #modal__previewAudio, #modal__previewVideo, #modal__previewSvg').length;

					return o_len
						&& $('#modal__previewPanel a.prev, #modal__previewPanel a.next').length
						&& !self.components.file_preview_zoomed.condition(e, diff);
				},
				onstart: function () {

					// ios кейс: перехоплюємо, але оскільки жест на виділенні - нічого не робимо
					if ($('#modal__previewFrame').length && has_selection_inside($('#modal__previewFrame'))) {
						this.selection = true;
						return;
					}

					$('#mobileMenu__wrapper').addClass('noani swype');
				},
				onmove: function (diff) {

					if (this.selection) return;

					const scale = 1 - Math.min(1, 0.0025 * Math.abs(diff.x));
					App.modal.obj_window.css({
						transform: `translateX(${diff.x}px) scale(${scale})`,
						transformOrigin: diff.x < 0 ? 'left center' : 'right center',
						transition: '',
					});
					$('#modal__previewImage').css({
						transform: `translateX(${diff.x}px) scale(${scale})`,
						transformOrigin: diff.x < 0 ? 'left center' : 'right center',
						transition: '',
						// left: Math.round(50 + 200 * diff.x / $(window).width()) + '%',
						// transform: 'scale(' + scale + ')',
					});

					/** action threshold */
					if (diff.x < -80) {
						let j = $('#modal__previewPanel .fileItem-active').next().filter('.fileItem');
						if (!j.length) {
							j = $('#modal__previewPanel .fileItem:first');
							App.modal.swipe_end = true;
						}
						if (j.length) {
							setTimeout(function () {
								j.find('a:first').trigger('click');
								if (App.modal.swipe_end) $('#modal__previewPanel a.prev').trigger('click'); else {
									offset = j.offset();
									if (offset.left - $(window).scrollLeft() - $(window).width() > -210) $('#modal__previewPanel a.next:visible').trigger('click');
								}
							}, 300);
							if ($('#modal__previewImage').length) {
								$('#modal__previewImage').addClass('item_ania').css({
									transform: `translateX(${$(window).width() * -1}px) scale(0)`,
									// left: '-100%',
									// transform: 'scale(0)',
								}).eachDelayed(function () {
									$(this).removeClass('item_ania');
								}, 600);
							} else {
								App.modal.obj_window.addClass('item_ania').css({
									transform: `translateX(${$(window).width() * -1}px) scale(0)`,
								});
							}
							setTimeout(function () {
								App.modal.obj_window.removeClass('item_ania').css({
									transform: '',
									transformOrigin: '',
								});
							}, 600);
							self.x = null;
							self.y = null;
							self.type = null;
						} else self.onend();
					} else if (diff.x > 80) {
						let j = $('#modal__previewPanel .fileItem-active').prev().filter('.fileItem');
						if (!j.length) {
							j = $('#modal__previewPanel .fileItem:last');
							App.modal.swipe_end = true;
						}
						if (j.length) {
							setTimeout(function () {
								j.find('a:first').trigger('click');
								if (App.modal.swipe_end) $('#modal__previewPanel a.next').trigger('click'); else {
									offset = j.offset();
									if (offset.left - $(window).scrollLeft() < 0) $('#modal__previewPanel a.prev:visible').trigger('click');
								}
							}, 300);
							if ($('#modal__previewImage').length) {
								$('#modal__previewImage').addClass('item_ania').css({
									transform: `translateX(${$(window).width()}px) scale(0)`,
									// left: '200%',
									// transform: 'scale(0)',
								}).eachDelayed(function () {
									$(this).removeClass('item_ania');
								}, 600);
							} else {
								App.modal.obj_window.addClass('item_ania').css({
									transform: `translateX(${$(window).width()}px) scale(0)`,
								});
							}
							setTimeout(function () {
								App.modal.obj_window.removeClass('item_ania').css({
									transform: '',
									transformOrigin: '',
								});
							}, 600);
							self.x = null;
							self.y = null;
							self.type = null;
						} else self.onend();
					}
				},
				onend: function () {

					if (this.selection) {
						this.selection = null;
						return;
					}

					App.modal.obj_window.addClass('item_ania').css({
						transform: '',
						transformOrigin: '',
					});
					$('#modal__previewImage').css({
						left: '',
						top: '',
						transform: '',
						opacity: '',
					});
					setTimeout(function () {
						App.modal.obj_window.removeClass('item_ania');
					}, 600);
				},
			},

			file_preview_zoomed: {
				direction: 'both',
				point: { x: 0, y: 0 },
				condition: function(e, diff) {
					return $(e.target).closest('#modal__previewImage').hasClass('zoom_in')
						|| $(e.target).closest('#modalContainer').find('#modal__previewImage').hasClass('zoom_free');
				},
				onstart: function () {
					$('#modal__previewImage').addClass('zoom_in-moving');
					self.modal_preview_x = 1 * $('#modal__previewImage').css("margin-left").replace("px", "");
					self.modal_preview_y = 1 * $('#modal__previewImage').css("margin-top").replace("px", "");
				},
				onmove: function (diff) {
					$('#modal__previewImage').css({
						marginLeft: Math.round(self.modal_preview_x + diff.x) + 'px',
						marginTop: Math.round(self.modal_preview_y + diff.y) + 'px'
					});
				},
				onend: function () {
					$('#modal__previewImage').removeClass('zoom_in-moving').addClass('item_ania').eachDelayed(function () {
						$(this).removeClass('item_ania');
					}, 600);
				},
			},

			file_preview_close: {
				direction: 'vertical',
				selection: null,
				condition: function(e, diff) {
					const res = $('#modal__previewImage, #modal__alert, #modal__previewFrame:not(.w_scroll), #modal__previewAudio, #modal__previewVideo, #modal__previewSvg').length
						&& diff.y > 0
						&& !can_scroll(e.target, diff);
					return res;
				},
				onstart: function () {

					// ios кейс: перехоплюємо, але оскільки жест на виділенні - нічого не робимо
					if ($('#modal__previewFrame').length && has_selection_inside($('#modal__previewFrame'))) {
						this.selection = true;
						return;
					}

					$('#mobileMenu__wrapper').addClass('noani swype');
				},
				onmove: function (diff) {

					if (this.selection) return;

					const easeIn = (x, max = 1, factor = 2) => {
						let progress = Math.min(x / max, 1);
						return Math.pow(progress, factor) * max;
					};

					const threshold = 160;

					const diff_y = Math.max(diff.y, 0);
					const k = easeIn(diff_y, threshold, 2) / threshold;
					App.modal.obj_window
						.add($('#modal__previewImage'))
						.css({
							transform: `translateY(${diff_y * 2 * k}px)`,
							opacity: 1 - k,
						});

					const PANEL_DELAY = 60;
					const panel_dy = Math.max(diff_y - PANEL_DELAY, 0);
					const panel_k = easeIn(panel_dy, threshold - PANEL_DELAY, 3) / (threshold - PANEL_DELAY);

					$('#modal__previewPanel').css({
						transform: `translateY(${panel_k * 100}%)`,
						// opacity: 1 - panel_k,
					});

					/** action threshold */
					if (diff.y >= threshold) self.onend();
				},
				onend: function (payload) {

					if (this.selection) {
						this.selection = null;
						return;
					}

					if (
						payload.direction === 'down'
						&& (
							(payload.velocity >= 1.5 && payload.distance >= 80)
							|| payload.distance >= 160
						)
					) {
						App.modal.hide();
						return;
					}

					App.modal.obj_window
						.add($('#modal__previewImage'))
						.add($('#modal__previewPanel'))
						.css({
							transform: '',
							opacity: '',
						});
				},
			},

			task_view: {
				direction: 'horizontal',
				target: null,
				selection: null,
				condition: function(e, diff) {

					if (App.editor.is_active() || App.menu.is_shown() || App.modal.is_shown() || App.comment_form.is_expanded()) return false;

					let target = e.target;

					return diff.x > 0
						&& App.device.is_mobile()
						&& App.task_view.is_shown()
						&& $(target).closest(App.task_view.obj_wrapper).length
						&& !can_scroll(target, diff)
						&& (this.target = target);
				},
				onstart: function () {

					// ios кейс: перехоплюємо, але оскільки жест на виділенні - нічого не робимо
					if (selection_inside_selectable_block(this.target)) {
						this.selection = true;
						return;
					}

					App.task_view.obj_wrapper
						.css({
							transition: '',
							transform: '',
						})
						.addClass('swype');
				},
				onmove: function (diff) {

					if (this.selection) return;

					const offset_x = Math.max(0, diff.x);

					App.task_view.obj_wrapper.css({
						transform: 'translateX(' + Math.min($(window).width() - 60, offset_x) + 'px)',
					});
				},
				onend: function (payload) {

					this.target = null;
					if (this.selection) {
						this.selection = null;
						return;
					}

					if (
						payload.direction === 'right'
						&& (
							( payload.distance >= $(window).width() / 2 )
							|| ( payload.velocity >= 1.5 && payload.distance >= 80 )
						)
					) {
						App.task_view.hide();
						return;
					}

					App.task_view.obj_wrapper
						.css({
							transition: 'transform .2s ease-in',
							transform: 'translateX(0)',
						}).one('transitionend', () => {
							App.task_view.obj_wrapper
								.css({
									transition: '',
									transform: '',
								})
								.removeClass('swype');
						});
				},
			},

			// swipe left to hide
			mobile_sidebar_hide: {
				direction: 'horizontal',
				initial_x: null,
				condition: function(e, diff) {
					if (!App.me.id) return false;
					if ($(document.activeElement).is('input, textarea')) return false;
					if (App.mobile_menu_primary.is_opened()) return false;

					return diff.x < 0 && App.device.is_mobile() && App.sidebar.is_shown();
				},
				onstart: function () {
				},
				onmove: function (diff) {
					if (this.initial_x === null) this.initial_x = diff.x;

					const wrapper = $('#sidebar__wrapper');
					const main = $('main');

					const shift = Math.min( (diff.x - this.initial_x) * 1.5, 0 );

					wrapper.css('left', shift + 'px');
					main.css('left', shift + wrapper.width() + 'px');

					if (diff.x <= -80) {
						App.sidebar.hide_mobile();
						self.onend();
						return;
					}
				},
				onend: function () {
					this.first_diff_x = null;
					const wrapper = $('#sidebar__wrapper');
					const main = $('main');
					wrapper.css('left', '');
					main.css('left', '');
				},
			},

			// swipe right to show sidebar
			mobile_sidebar_show: {
				direction: 'horizontal',
				initial_x: null,
				datatable_obj: null,
				condition: function(e, diff) {
					if (!App.me.id) return false;
					if ($(document.activeElement).is('input, textarea')) return false;
					if (App.editor.is_active() || App.menu.is_shown() || App.modal.is_shown() || App.comment_form.is_expanded()) return false;
					if (App.mobile_menu_primary.is_opened()) return false;

					let target = e.target;

					this.datatable_obj = null;
					const target_can_scroll = () => {
						let can_scroll = false;
						$(target).parents().addBack().each(function (_, el) {
							if ($(el).canScrollToDirection(-1, true)) {
								can_scroll = true;
								return false;
							}
						});

						if (App.controls.datatable.tableObjData.obj && $.contains(App.controls.datatable.tableObjData.obj.get(0), target)) {
							this.datatable_obj = App.controls.datatable.tableObjData.obj;
						}

						return can_scroll;
					};

					return diff.x > 0
						&& App.device.is_mobile()
						&& !App.modal.is_shown()
						&& !App.menu.is_shown()
						&& !App.mymenu.is_shown()
						&& !App.right_panel.is_shown()
						&& !target_can_scroll();
				},
				onstart: function () {
				},
				// ! async if target is datatable
				onmove: function (diff) {

					const show_sidebar_if_needed = () => {
						if (diff.x < 80) return;
						else App.sidebar.toggle(true, false);
						self.onend();
					};

					if (!this.datatable_obj) return show_sidebar_if_needed();
					// щоб точно спрацьовувало після процесінгу datatable
					App.helper.nextTick(() => {
						if (this.datatable_obj && this.datatable_obj.data('has-transition')) return;
						show_sidebar_if_needed();
					});
				},
				onend: function () {
				},
			},

			mobile_menu_primary: {
				direction: 'vertical',
				initial_bar_width: null,
				prev_bar_width: null,
				next_bar_width: null,
				half_open_height: null,
				full_open_height: null,
				condition: function(e) {
					let target = e.target;

					if (!App.me.id) return false;
					if (!App.mobile_menu_primary.is_loaded()) return false;
					if ($(target).closest('.mobileMenu__swipe').length) return true;

					return App.device.is_touch_screen() && !!$(target).parents().addBack().filter('#mobileMenu__wrapper').length
				},
				onstart: function () {
					const wrapper = $('#mobileMenu__wrapper');

					wrapper.addClass('noani swype swype-self');

					const swipe = wrapper.find('.mobileMenu__swipe');
					const computed_style = getComputedStyle(swipe.get(0));
					const swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-swipe-width').trim();

					let prev_swipe_width, next_swipe_width;

					if (App.mobile_menu_primary.is_half_opened()) {
						prev_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-default-opened-swipe-width').trim();
						next_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-full-opened-swipe-width').trim();
					}
					else if (App.mobile_menu_primary.is_full_opened()) {
						prev_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-default-opened-swipe-width').trim();
						next_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-full-opened-swipe-width').trim();
					}
					else {
						prev_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-default-opened-swipe-width').trim();
						next_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-half-opened-swipe-width').trim();
					}

					this.initial_bar_width = parseInt(swipe_width);
					this.prev_bar_width = parseInt(prev_swipe_width);
					this.next_bar_width = parseInt(next_swipe_width);

					this.half_open_height = parseInt(computed_style.getPropertyValue('--mobile-primary-menu-half-opened-conent-height'));
					this.full_open_height = parseInt(computed_style.getPropertyValue('--mobile-primary-menu-full-opened-conent-height'));
				},
				onmove: function (diff) {
					let shift = Math.round(0.5 * diff.y);

					const wrapper = $('#mobileMenu__wrapper');
					const css_primary_menu_height = 'var(--primary-menu-height)';
					const half_open_height = this.half_open_height;
					const full_open_height = this.full_open_height;
					const swipe_threshold = 40;
					const ratio = Math.abs(diff.y) / swipe_threshold;

					let bar_width = this.initial_bar_width;

					if (diff.y < 0) {
						bar_width += (this.next_bar_width - this.initial_bar_width) * ratio;
					} else {
						bar_width -= (this.initial_bar_width - this.prev_bar_width) * ratio;
					}

					if (App.mobile_menu_primary.is_half_opened()) {
						if (diff.y > 0) {
							if (diff.y >= swipe_threshold) {
								self.onend();
								App.mobile_menu_primary.hide();
							} else {
								wrapper.find('.mobileMenu__content-part1 .mobileMenu__pages__item').find('.icon_main, .in').each(function (index, item) {
									item.style.setProperty('transition-delay', '0s');
									item.style.setProperty('opacity', 0.4 - 0.4 * ratio / 0.6); // from 0.4 to 0
								});
								wrapper.find('.mobileMenu__bar__item--part1').each(function (index, item) {
									item.style.setProperty('transition-delay', '0s');
									item.style.setProperty('opacity', 0.4 - 0.4 * ratio / 0.6); // from 0.4 to 0
								});
								wrapper.css({top: `calc(100% - ${css_primary_menu_height} - ` + (half_open_height - 2 * shift) + 'px)'});
								wrapper.find('.mobileMenu__swipe').css({width: bar_width});
							}
						}
						if (diff.y < 0 && !App.mobile_menu_primary.is_full_opened()) {
							if (diff.y <= swipe_threshold * -1) {
								self.onend();
								App.mobile_menu_primary.full_open();
							} else {
								wrapper.find('.mobileMenu__bar__item--part1').each(function (index, item) {
									item.style.setProperty('opacity', 1 - 1 * ratio); // from 1 to 0
								});
								wrapper.css({top: `calc(100% - ${css_primary_menu_height} - ` + (half_open_height - 2 * shift) + 'px)'});
								wrapper.find('.mobileMenu__swipe').css({width: bar_width});
							}
						}
					} else {
						if (diff.y > 0 && App.mobile_menu_primary.is_full_opened()) {
							if (diff.y >= swipe_threshold) {
								self.onend();
								App.mobile_menu_primary.hide();
							} else {
								wrapper.find('.mobileMenu__content-part2 .mobileMenu__pages__item').find('.icon_main, .in').each(function (index, item) {
									item.style.setProperty('transition-delay', '0s');
									item.style.setProperty('opacity', 0.4 - 0.4 * ratio / 0.6); // from 0.4 to 0
								});
								wrapper.css({top: `calc(100% - ${css_primary_menu_height} - ` + (full_open_height - 2 * shift) + 'px)'});
								wrapper.find('.mobileMenu__swipe').css({width: bar_width});
							}
						}
						if (diff.y < 0 && !App.mobile_menu_primary.is_full_opened()) {
							if (diff.y <= swipe_threshold * -1) {
								self.onend();
								App.mobile_menu_primary.half_open();
							} else {
								wrapper.find('.mobileMenu__bar__item--general').each(function (index, item) {

									let item_offset = 100 * ratio;
									let item_opacity_ratio = ratio / 0.6
									if (index === 0 || index === 3) {
										item_offset *= 2;
										item_opacity_ratio = ratio / 0.8;
									}
									if (index >= 2) item_offset *= -1;

									item.style.setProperty('--item-offset', item_offset + '%'); // move to center
									item.style.setProperty('--item-scale', 1 - 0.25 * ratio); // from 1 to 0.75
									item.style.setProperty('opacity', 1 - item_opacity_ratio); // from 1 to 0 (but hide earlier)
								});
								wrapper.css({top: `calc(100% - ${css_primary_menu_height} - ` + (- 2 * shift) + 'px)'});
								wrapper.find('.mobileMenu__swipe').css({width: bar_width});
							}
						}
					}
				},
				onend: function () {
					const wrapper = $('#mobileMenu__wrapper');
					wrapper.find('.mobileMenu__bar__item--general').each(function (_, item) {
						item.style.removeProperty('--item-offset');
						item.style.removeProperty('--item-scale');
						item.style.removeProperty('opacity');
					});
					wrapper.find('.mobileMenu__bar__item--part1').each(function (_, item) {
						item.style.removeProperty('--item-offset');
						item.style.removeProperty('opacity');
						item.style.removeProperty('transition-delay');
					});
					wrapper.find('.mobileMenu__content-part1 .mobileMenu__pages__item').find('.icon_main, .in').each(function (index, item) {
						item.style.removeProperty('transition-delay');
						item.style.removeProperty('opacity');
					});
					wrapper.find('.mobileMenu__content-part2 .mobileMenu__pages__item').find('.icon_main, .in').each(function (index, item) {
						item.style.removeProperty('transition-delay');
						item.style.removeProperty('opacity');
					});
					wrapper.removeClass('noani swype swype-self').css({top: ''});
					wrapper.find('.mobileMenu__swipe').css({width: ''});
				},
			},

			mobile_menu: {
				direction: 'vertical',

				initial_top: null,
				max_top: null,
				initial_bar_width: null,
				prev_bar_width: null,
				next_bar_width: null,
				half_open_height: null,
				full_open_height: null,

				threshold_exceeded: false,
				threshold_action: null,

				condition: function(e, diff) {
					let target = e.target;
					/* we have some inline menus: see #pageFilter_range_embedded */
					return App.device.is_touch_screen() && !!$(target).parents().addBack().filter('.menu').length && App.menu.is_shown() && App.menu.active_box.menu_data.force_dropdown === false && !can_scroll_in_menu(target, diff);
				},
				onstart: function () {
					App.menu.obj_window.addClass('noani swype');
					App.menu.obj_window.find('.menu__swipe').addClass('noani');

					const swipe = App.menu.obj_window.find('.menu__swipe');
					const computed_style = getComputedStyle(swipe.get(0));
					const swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-swipe-width').trim();

					let prev_swipe_width, next_swipe_width;

					const is_half_opened = !App.menu.obj_window.hasClass('menu-fullscreen');
					const is_full_opened = App.menu.obj_window.hasClass('menu-fullscreen');

					if (is_half_opened) {
						prev_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-default-opened-swipe-width').trim();
						next_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-full-opened-swipe-width').trim();
					}
					else if (is_full_opened) {
						prev_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-default-opened-swipe-width').trim();
						next_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-full-opened-swipe-width').trim();
					}
					else {
						prev_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-default-opened-swipe-width').trim();
						next_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-half-opened-swipe-width').trim();
					}

					this.initial_bar_width = parseInt(swipe_width);
					this.prev_bar_width = parseInt(prev_swipe_width);
					this.next_bar_width = parseInt(next_swipe_width);
					this.initial_top = App.menu.obj_window.get(0).offsetTop;
					this.max_top = ($('#taskPanel').get(0)?.offsetTop || $('#mobileMenu__wrapper').get(0).offsetTop || ($(window).height() + visualViewport.offsetTop)) - 9;
				},
				onmove: function (diff) {

					const is_half_opened = !App.menu.obj_window.hasClass('menu-fullscreen');


					const full_opened_top = 4 + visualViewport.offsetTop;
					const closed_top = $(window).height() + visualViewport.offsetTop;
					const initial_top = this.initial_top;


					const next_top = diff.y >= 0 ? closed_top : full_opened_top;
					const new_top = (initial_top + diff.y).clamp(full_opened_top, this.max_top);


					const total_distance = Math.abs(next_top - initial_top);
					const threshold_distance = total_distance / 2;
					const current_distance = Math.abs(diff.y);
					const bar_ratio = threshold_distance ? Math.min(1, current_distance / threshold_distance) : 0;


					const initial_bar_width = this.initial_bar_width;
					const next_bar_width = diff.y >= 0 ? this.prev_bar_width : this.next_bar_width;
					const new_bar_width = initial_bar_width + (next_bar_width - initial_bar_width) * bar_ratio;


					App.menu.obj_window.css({ top: new_top });
					App.menu.obj_window.find('.menu__swipe').css({ width: new_bar_width });


					this.threshold_exceeded = current_distance >= threshold_distance;
					this.threshold_action = diff.y >= 0
						? 'hide'
						: (is_half_opened ? 'full' : '');
				},
				onend: function (payload) {

					const is_half_opened = !App.menu.obj_window.hasClass('menu-fullscreen');

					App.menu.obj_window.removeClass('noani swype');
					App.menu.obj_window.find('.menu__swipe').addClass('noani');
					App.menu.obj_window.css({
						top: '',
					});
					App.menu.obj_window.find('.menu__swipe').css({
						width: '',
					});

					const perform_action = (action) => {
						if (action === 'hide') {
							App.menu.hide();
						} else if (action === 'full') {
							App.menu.obj_window.addClass('menu-fullscreen');
							App.menu.resize_mobile_scrollZones();
						}
					};

					let action = null;
					if (this.threshold_exceeded && this.threshold_action) {
						action = this.threshold_action;
					} else if (payload.velocity >= 1.5 && payload.distance >= 80) {
						if (payload.direction === 'down') action = 'hide';
						else if (payload.direction === 'up' && is_half_opened) action = 'full';
					}

					if (action) perform_action(action);
				},
			},

			mobile_modal: {
				direction: 'vertical',

				initial_top: null,
				max_top: null,
				initial_bar_width: null,
				prev_bar_width: null,
				next_bar_width: null,
				half_open_height: null,
				full_open_height: null,

				threshold_exceeded: false,
				threshold_action: null,

				condition: function(e, diff) {
					let target = e.target;
					return $(window).width() <= APP_SCREEN_THRESHOLD
						&& !!$(target).closest('.modal').length
						&& !$(target).closest('.modal__overlay-withPanel').length
						&& !App.modal.is_fullpage()
						&& !App.modal.obj_window.hasClass('.editBlock-initClose')
						&& !App.modal.dont_hide
						&& !can_scroll(target, diff);
				},
				onstart: function () {
					App.modal.obj_window.addClass('noani swype');
					App.modal.obj_window.find('.modal__swipe').addClass('noani');

					const swipe = App.modal.obj_window.find('.modal__swipe');
					const computed_style = getComputedStyle(swipe.get(0));
					const swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-swipe-width').trim();

					let prev_swipe_width, next_swipe_width;

					const is_half_opened = !App.modal.obj_window.hasClass('modal-fullscreen');
					const is_full_opened = App.modal.obj_window.hasClass('modal-fullscreen');

					if (is_half_opened) {
						prev_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-default-opened-swipe-width').trim();
						next_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-full-opened-swipe-width').trim();
					}
					else if (is_full_opened) {
						prev_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-default-opened-swipe-width').trim();
						next_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-full-opened-swipe-width').trim();
					}
					else {
						prev_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-default-opened-swipe-width').trim();
						next_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-half-opened-swipe-width').trim();
					}

					this.initial_bar_width = parseInt(swipe_width);
					this.prev_bar_width = parseInt(prev_swipe_width);
					this.next_bar_width = parseInt(next_swipe_width);
					this.initial_top = App.modal.obj_window.get(0).offsetTop;
					this.max_top = ($('#taskPanel').get(0)?.offsetTop || $('#mobileMenu__wrapper').get(0).offsetTop || ($(window).height() + visualViewport.offsetTop)) - 9;
				},
				onmove: function (diff) {

					const is_half_opened = !App.modal.obj_window.hasClass('modal-fullscreen');


					const full_opened_top = 4 + visualViewport.offsetTop;
					const closed_top = $(window).height() + visualViewport.offsetTop;
					const initial_top = this.initial_top;


					const next_top = diff.y >= 0 ? closed_top : full_opened_top;
					const new_top = (initial_top + diff.y).clamp(full_opened_top, this.max_top);


					const total_distance = Math.abs(next_top - initial_top);
					const next_distance = Math.abs(new_top - initial_top);
					const threshold_distance = total_distance / 2;
					const current_distance = Math.abs(diff.y);
					const bar_ratio = threshold_distance ? Math.min(1, current_distance / threshold_distance) : 0;


					const initial_bar_width = this.initial_bar_width;
					const next_bar_width = diff.y >= 0 ? this.prev_bar_width : this.next_bar_width;
					const new_bar_width = initial_bar_width + (next_bar_width - initial_bar_width) * bar_ratio;


					if (!is_half_opened || initial_top < new_top) {
						App.modal.obj_window.css({
							transform: `translateY(${next_distance / total_distance * 100}%)`
						});
					} else {
						App.modal.obj_window.css({
							top: new_top,
							transform: '',
						});
					}
					App.modal.obj_window.find('.modal__swipe').css({ width: new_bar_width });


					this.threshold_exceeded = current_distance >= threshold_distance;
					this.threshold_action = diff.y >= 0
						? 'hide'
						: (is_half_opened ? 'full' : '');
					if (
						this.threshold_exceeded
						&& diff.y >= 0
						&& App.controls.editblock.has_unsaved_updates()
					) {
						self.onend();
						return;
					}
				},
				onend: function (payload) {

					const is_half_opened = !App.modal.obj_window.hasClass('modal-fullscreen');

					App.modal.obj_window.removeClass('noani swype');
					App.modal.obj_window.find('.modal__swipe').addClass('noani');
					App.modal.obj_window.find('.modal__swipe').css({
						width: '',
					});

					const perform_action = (action) => {
						if (action === 'hide') {
							if (App.controls.editblock.has_unsaved_updates()) {
								App.modal.obj_window.css({
									transform: '',
								});
							}
							App.modal.hide();
						} else {
							App.modal.obj_window.css({
								transform: '',
							});
							if (action === 'full') {
								App.modal.obj_window.css({
									top: '',
								});
								App.modal.obj_window.addClass('modal-fullscreen');
							}
						}
					};

					let action = null;
					if (this.threshold_exceeded && this.threshold_action) {
						action = this.threshold_action;
					} else if (payload.velocity >= 1.5 && payload.distance >= 80) {
						if (payload.direction === 'down') action = 'hide';
						else if (payload.direction === 'up' && is_half_opened) action = 'full';
					}

					perform_action(action);
				},
			},

			mobile_dashboardView: {
				direction: 'vertical',

				initial_top: null,
				max_top: null,
				initial_bar_width: null,
				prev_bar_width: null,
				next_bar_width: null,
				half_open_height: null,
				full_open_height: null,

				threshold_exceeded: false,
				threshold_action: null,

				condition: function(e, diff) {
					let target = e.target;
					return $(window).width() <= APP_SCREEN_THRESHOLD
						&& !!$(target).closest('.dashboardView').length
						&& !can_scroll(target, diff);
				},
				onstart: function () {
					App.dashboard_view.obj_window.addClass('noani swype');
					App.dashboard_view.obj_window.find('.dashboardView__swipe').addClass('noani');

					const swipe = App.dashboard_view.obj_window.find('.dashboardView__swipe');
					const computed_style = getComputedStyle(swipe.get(0));
					const swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-swipe-width').trim();

					let prev_swipe_width, next_swipe_width;

					const is_half_opened = !App.dashboard_view.obj_window.hasClass('dashboardView-fullscreen');
					const is_full_opened = App.dashboard_view.obj_window.hasClass('dashboardView-fullscreen');

					if (is_half_opened) {
						prev_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-default-opened-swipe-width').trim();
						next_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-full-opened-swipe-width').trim();
					}
					else if (is_full_opened) {
						prev_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-default-opened-swipe-width').trim();
						next_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-full-opened-swipe-width').trim();
					}
					else {
						prev_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-default-opened-swipe-width').trim();
						next_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-half-opened-swipe-width').trim();
					}

					this.initial_bar_width = parseInt(swipe_width);
					this.prev_bar_width = parseInt(prev_swipe_width);
					this.next_bar_width = parseInt(next_swipe_width);
					this.initial_top = App.dashboard_view.obj_window.get(0).offsetTop;
					this.max_top = ($('#taskPanel').get(0)?.offsetTop || $('#mobileMenu__wrapper').get(0).offsetTop || ($(window).height() + visualViewport.offsetTop)) - 9;
				},
				onmove: function (diff) {

					const is_half_opened = !App.dashboard_view.obj_window.hasClass('dashboardView-fullscreen');


					const full_opened_top = 4 + visualViewport.offsetTop;
					const closed_top = $(window).height() + visualViewport.offsetTop;
					const initial_top = this.initial_top;


					const next_top = diff.y >= 0 ? closed_top : full_opened_top;
					const new_top = (initial_top + diff.y).clamp(full_opened_top, this.max_top);


					const total_distance = Math.abs(next_top - initial_top);
					const next_distance = Math.abs(new_top - initial_top);
					const threshold_distance = total_distance / 2;
					const current_distance = Math.abs(diff.y);
					const bar_ratio = threshold_distance ? Math.min(1, current_distance / threshold_distance) : 0;


					const initial_bar_width = this.initial_bar_width;
					const next_bar_width = diff.y >= 0 ? this.prev_bar_width : this.next_bar_width;
					const new_bar_width = initial_bar_width + (next_bar_width - initial_bar_width) * bar_ratio;


					if (!is_half_opened || initial_top < new_top) {
						App.dashboard_view.obj_window.css({
							transform: `translateY(${next_distance / total_distance * 100}%)`
						});
					} else {
						App.dashboard_view.obj_window.css({
							top: new_top,
							transform: '',
						});
					}
					App.dashboard_view.obj_window.find('.dashboardView__swipe').css({ width: new_bar_width });


					this.threshold_exceeded = current_distance >= threshold_distance;
					this.threshold_action = diff.y >= 0
						? 'hide'
						: (is_half_opened ? 'full' : '');
					if (
						this.threshold_exceeded
						&& diff.y >= 0
						&& App.controls.editblock.has_unsaved_updates()
					) {
						self.onend();
						return;
					}
				},
				onend: function (payload) {

					const is_half_opened = !App.dashboard_view.obj_window.hasClass('dashboardView-fullscreen');

					App.dashboard_view.obj_window.removeClass('noani swype');
					App.dashboard_view.obj_window.find('.dashboardView__swipe').addClass('noani');
					App.dashboard_view.obj_window.find('.dashboardView__swipe').css({
						width: '',
					});

					const perform_action = (action) => {
						if (action === 'hide') {
							App.dashboard_view.hide();
						} else {
							App.dashboard_view.obj_window.css({
								transform: '',
							});
							if (action === 'full') {
								App.dashboard_view.obj_window.css({
									top: '',
								});
								App.dashboard_view.obj_window.addClass('dashboardView-fullscreen');
							}
						}
					};

					let action = null;
					if (this.threshold_exceeded && this.threshold_action) {
						action = this.threshold_action;
					} else if (payload.velocity >= 1.5 && payload.distance >= 80) {
						if (payload.direction === 'down') action = 'hide';
						else if (payload.direction === 'up' && is_half_opened) action = 'full';
					}

					perform_action(action);
				},
			},

			mobile_expand_comment_form: {
				direction: 'vertical',

				initial_height: null,
				max_height: null,

				initial_bar_width: null,
				prev_bar_width: null,
				next_bar_width: null,
				half_open_height: null,
				full_open_height: null,

				threshold_exceeded: false,
				threshold_action: null,

				condition: function(e, diff) {
					let target = e.target;
					return App.device.is_mobile()
						&& App.comment_form.is_shown()
						&& App.comment_form.is_started()
						&& !App.comment_form.is_expanded()
						&& !!$(target).closest('#comment_new').length
						&& !can_scroll(target, diff);
				},
				onstart: function () {

					const obj_window = App.comment_form.obj;
					const obj_window_height = obj_window.outerHeight();

					const placeholder = $('<div/>', {
						class: 'commentFormPlaceholder',
						css: { height: obj_window_height },
					});
					obj_window.before(placeholder);

					obj_window.addClass('noani swype');
					obj_window.find('.commentForm__swipe').addClass('noani');
					obj_window.css({
						height: '',
						'--comment-form-height': `${obj_window_height}px`
					});

					const swipe = obj_window.find('.commentForm__swipe');
					const computed_style = getComputedStyle(swipe.get(0));
					const swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-swipe-width').trim();

					const prev_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-default-opened-swipe-width').trim();
					const next_swipe_width = computed_style.getPropertyValue('--mobile-primary-menu-full-opened-swipe-width').trim();

					this.initial_bar_width = parseInt(swipe_width);
					this.prev_bar_width = parseInt(prev_swipe_width);
					this.next_bar_width = parseInt(next_swipe_width);
					this.initial_height = obj_window_height;
					this.max_height = $(window).height(); // App.helper.viewport.height();
				},
				onmove: function (diff) {

					const obj_window = App.comment_form.obj;

					const initial_height = this.initial_height;


					const closed_height = 0;
					const next_height = diff.y >= 0 ? closed_height : this.max_height;
					const new_height = (initial_height - diff.y).clamp(closed_height, this.max_height);


					const total_distance = Math.abs(next_height - initial_height);
					const next_distance = Math.abs(new_height - initial_height);
					const threshold_distance = total_distance / 2;
					const current_distance = Math.abs(diff.y);
					const bar_ratio = threshold_distance ? Math.min(1, current_distance / threshold_distance) : 0;


					const initial_bar_width = this.initial_bar_width;
					const next_bar_width = diff.y >= 0 ? this.prev_bar_width : this.next_bar_width;
					const new_bar_width = initial_bar_width + (next_bar_width - initial_bar_width) * bar_ratio;


					obj_window.css({
						'--comment-form-height': `${new_height}px`
					});
					obj_window.find('.commentForm__swipe').css({ width: new_bar_width });


					this.threshold_exceeded = current_distance >= threshold_distance;
					this.threshold_action = diff.y <= 0 ? 'expand' : 'stop';
				},
				onend: function (payload) {

					const obj_window = App.comment_form.obj;

					obj_window.prev('.commentFormPlaceholder').remove();

					obj_window.removeClass('noani swype');
					obj_window.find('.commentForm__swipe').removeClass('noani');
					obj_window.find('.commentForm__swipe').css({
						width: '',
					});

					const perform_action = (action) => {
						obj_window.css({
							'--comment-form-height': '',
						});
						if (action === 'expand') App.comment_form.expand();
						else if (action === 'stop') App.comment_form.stop();
					};

					let action = null;
					if (this.threshold_exceeded && this.threshold_action) {
						action = this.threshold_action;
					} else if (payload.velocity >= 1.5 && payload.distance >= 80) {
						if (payload.direction === 'up') action = 'expand';
						else if (payload.direction === 'down') action = 'stop';
					}

					perform_action(action);
				},
			},

			task_panel: {
				$cloned_el: null,
				$target_el: null,
				direction: 'vertical',
				condition: function(e, diff) {
					let target = e.target;
					if (diff.y >= 0) return false;
					if (!App.device.is_mobile()) return false;

					$target_el = $(target).closest('.taskPanel__item');
					if (!$target_el.length || !$target_el.find('.close').length) return false;

					this.$target_el = $target_el;
					return true;
				},
				onstart: function () {
					const $target_el = this.$target_el;
					const $cloned_el = $target_el.clone();

					const offset = $target_el.offset();
					const outer_width = $target_el.outerWidth();
					const outer_height = $target_el.outerHeight();

					// додаємо в body, а не поруч
					$('body').append($cloned_el);

					$cloned_el.css({
						position: 'fixed',
						top: offset.top + 'px',
						left: offset.left + 'px',
						width: outer_width + 'px',
						height: outer_height + 'px',
						zIndex: 9999, // щоб точно поверх
						pointerEvents: 'none' // щоб не ловив кліки
					});

					$cloned_el.addClass('taskPanel__item--clone');

					$target_el.css({
						visibility: 'hidden'
					});

					this.$cloned_el = $cloned_el;
				},
				onmove: function (diff) {
					const $target_el = this.$target_el;
					const $cloned_el = this.$cloned_el;
					const { top } = $target_el.offset();
					$cloned_el.css({
						top: (top+diff.y)+'px',
						opacity: 1 - Math.abs(diff.y) / 80,
					});

					if (diff.y < -80) {
						$target_el.find('.close').click();
					}
				},
				onend: function () {
					const $target_el = this.$target_el;
					const $cloned_el = this.$cloned_el;
					if ($target_el.length) {
						$target_el.css({
							visibility: ''
						});
					}
					$cloned_el.remove();
					this.$target_el = null;
					this.$cloned_el = null;
					self.x = null;
					self.y = null;
					self.type = null;
				},
			},

			admin_search: {
				search: null,
				list: null,
				search_height: null,
				show_distance: 120,
				direction: 'vertical',
				condition: function(e, diff) {
					let target = e.target;

					const check_list = () => {
						this.list = this.search.parent().closest('div');
						return this.list.length > 0;
					};

					const check_search = () => {
						this.search = $(target).closest('body[data-page=account] #content').find('.accountSearch');
						return this.search.length > 0 && this.search.is(':hidden');
					};

					return App.device.is_mobile()
						&& diff.y > 0
						&& check_search()
						&& check_list()
						&& !can_scroll(target, diff);
				},
				onstart: function () {

					this.search.add(this.list).css({
						transition: 'none',
					});

					this.search.css({
						display: 'flex',
					});

					this.search_height = this.search.outerHeight(true);

					const initialOffset = -this.search_height;

					this.search.css({ translate: `0 ${initialOffset}px` });
					this.list.css({ translate: `0 ${initialOffset}px` });
				},
				onmove: function (diff) {

					const progress = Math.min(diff.y / this.show_distance, 1);

					const searchEased = 1 - Math.pow(1 - progress, 3);
					const searchOffset = -this.search_height * (1 - searchEased);

					const listOffset = -this.search_height * (1 - progress);
					// const searchOffset = listOffset;

					this.search.css({
						translate: `0 ${searchOffset}px`,
					});

					this.list.css({
						translate: `0 ${listOffset}px`,
					});

					if (diff.y >= this.show_distance) {
						self.onend();
					}
				},
				onend: function (payload) {

					const search = this.search;
					const list = this.list;
					const search_height = this.search_height;

					const is_shown = payload.direction === 'down'
						&& payload.distance >= this.show_distance;

					if (is_shown) {
						search.add(list).css({
							translate: '0 0',
							transition: '',
						});
						if (payload.is_cancel) {
							App.helper.nextTick(() => self.onstart(payload.event));
						}
					} else {

						const cleanup = () => {
							search.add(list).css({
								display: '',
								translate: '',
								transition: 'none',
							});
						};

						search.add(list).css({
							translate: `0 -${search_height}px`,
							transition: 'translate .2s ease-in-out',
						});

						App.helper.promise.transitionEnd(search.add(list)).then(cleanup);
					}

					this.search = null;
					this.list = null;
					this.search_height = null;
				},
			},

			swype_to_reload: {
				s: null,
				o: null,
				direction: 'vertical',
				add_content_padding: null,
				haptics_done: false,
				condition: function(e, diff) {
					let target = e.target;

					const check_o = () => {
						if ($(target).closest('.commentForm').length) return false;
						this.o = $(target).closest('main, #taskView__wrapper');
						return this.o.length > 0;
					};

					return App.me.id
						&& App.device.is_mobile()
						&& diff.y > 0
						&& !App.controls.swipe_reload.is_started
						&& check_o()
						&& !can_scroll(target, diff);
				},
				onstart: function () {
					$('body').removeClass('withSwipeReloadTransition');

					this.s = $('#swipeReload');
					this.s.addClass('swipeReload--shown');
					const content = this.o.find('#content, .taskView__contentScrollOut').first();

					let add_height = 0;
					if (this.o.is('#taskView__wrapper')) {
						const obj_window = this.o.find('.taskView');
						const is_head_panel_overlay = obj_window.not('.taskView-headMobileHidden').length;
						const is_comment_panel_overlay = obj_window.is('.taskView-comment_massInvisible');
						if (is_comment_panel_overlay || is_head_panel_overlay) {
							if (is_head_panel_overlay) add_height += this.o.find('.taskView__head--mobile').outerHeight();
							else if (is_comment_panel_overlay) add_height += this.o.find('.commentListPanel').height();
						}
					}

					if (content.is('#content')) {
						this.add_content_padding = 24 - parseInt(content.css('padding-top')).clamp(0, 24);
					}

					const head_height = (content.get(0)?.offsetTop ?? 0) + 1 + add_height;

					this.s
						.css({
							"--swipeReload-headerHeight": `${head_height}px`,
						})
						.toggleClass('swipeReload--addTop', this.add_content_padding > 0);
				},
				onmove: function (diff) {

					const shift = Math.max(0, Math.round(0.5 * diff.y));
					const threshold_exceeded = shift >= 120;

					if (!this.s.length) {
						let opacity = Math.min(1, 0.005 * diff.y);
						$('#main').css({opacity: 1 - opacity});
						$('#content').css({paddingTop: shift + 20});
						if (shift >= 80) {
							$('.ico_back_to').addClass('clicked').trigger('click');
							self.onend();
						}
						return;
					}

					if (!threshold_exceeded || this.haptics_done != threshold_exceeded) {
						const progress = (shift / 120).clamp(0, 1);

						const easeOut = (x, max = 1) => {
							let progress = Math.min(x / max, 1);
							return Math.pow(progress, 0.5) * max;
						}
						const easeIn = (x, max = 1) => {
							let progress = Math.min(x / max, 1);
							return Math.pow(progress, 3) * max;
						}
						const easeRotate = (linearRotate, minRotate, maxRotate) => {
							let progress = (linearRotate - minRotate) / (maxRotate - minRotate);
							progress = progress.clamp(0, 1);

							let eased = easeIn(progress);
							return minRotate + eased * (maxRotate - minRotate);
						}

						let opacity, rotate;

						if (shift >= 20) {
							opacity = Math.min(1, progress * 2);
							rotate = easeRotate(shift * 3 + 45, 20 * 3 + 45, 120 * 3 + 45) + 'deg';
						}

						const add_top = this.add_content_padding * easeOut(progress);

						this.s.css({
							"--swipeReload-top": `${shift}px`,
							"--swipeReload-add-top": `${add_top}px`,
							"--swipeReload-opacity": opacity,
							"--swipeReload-rotate": rotate,
						});

						$('#content').css({
							"--swipeReload-top": `${shift}px`,
							"--swipeReload-add-top": `${add_top}px`,
							pointerEvents: 'none',
						});
					}

					if (this.haptics_done !== threshold_exceeded) {


						$('#swipeReload').toggleClass('swipeReload-state', threshold_exceeded);
						this.haptics_done = threshold_exceeded;
						App.haptics.swipe_to_reload();
					}
				},
				onend: function (payload) {

					this.add_content_padding = 0;

					if (!$('#swipeReload').length) {
						if (!$('.appico_back').hasClass('clicked')) {
							$('#main').css({opacity: 1});
							$('#content').css({paddingTop: 20});
						}
						return;
					}

					if (payload.distance >= 240 && payload.direction == 'down') {
						App.controls.swipe_reload.start();
						return;
					}

					$('body').addClass('withSwipeReloadTransition');
					App.controls.swipe_reload.stop();
				},
			}
		},

		onstart: function (e) {
			let touch = e;
			if (e.type === 'touchstart') {
				const getTouches = e => {
					if (e.touches && e.touches.length) return e.touches;
					if (e.changedTouches && e.changedTouches.length) return e.changedTouches;
					return [];
				};
				const touches = getTouches(e.originalEvent);
				if (touches.length === 2) return; // перехопимо в App.ui.onGesture
				touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] || e;
			} else if (e.type === 'swipeend') {
				touch = {
					pageX: e.detail.x,
					pageY: e.detail.y,
				};
			}
			self.x = touch.pageX;
			self.y = touch.pageY;
			self.type = SWIPE_DETECT_STATE;

			self.last_pos = { x: self.x, y: self.y };
			self.last_time = Date.now();
		},

		onmove: function (e) {

			if (self.move_prevent_default) e.preventDefault();
			if (self.type === null) return;
			let touch = e;
			if (e.type === 'touchmove') touch = e.touches[0] || e.changedTouches[0] || e;
			let this_x = touch.pageX;
			let this_y = touch.pageY;
			let diff = {x: this_x - self.x, y: this_y - self.y};
			let horizontal = Math.abs(diff.x) > Math.abs(diff.y) + 2;
			let vertical = Math.abs(diff.x) + 2 < Math.abs(diff.y);

			// пробую позбавитися скрола, коли включена клавіатура:
			// /task/8321361
			// /task/8320991/#com20804206
			if (
				e.type === 'touchmove'
				&& document.body.classList.contains('w_keyboard')
				&& !( (tmp_input = e.target.closest('input')) && tmp_input.selectionStart !== tmp_input.selectionEnd )
				&& !can_scroll(e.target, diff)
				&& !can_scroll_in_menu(e.target, diff)
				&& !has_selection_inside(e.target)
				&& !selection_inside_selectable_block(e.target)
			) {
				// console.warn('touchmove preventDefault'); // 4 debug
				e.preventDefault();
			}

			self.last_pos = { x: this_x, y: this_y };
			self.last_direction = vertical ? (diff.y < 0 ? 'up' : 'down') : (horizontal ? (diff.x < 0 ? 'left' : 'right') : null);

			if (self.type === SWIPE_DETECT_STATE) {
				if (!horizontal && !vertical) return;
				for (let type in self.components) {
					let component = self.components[type];
					if (
						(
							component.direction === 'both'
							|| (component.direction === 'vertical' && vertical)
							|| (component.direction === 'horizontal' && horizontal)
						) && component.condition(e, diff)
					) {
						self.type = type;
						component.onstart();
						if (e.cancelable) e.preventDefault();
						return;
					}
				}
				self.type = null;
			} else {
				if (e.cancelable) e.preventDefault();
				let component = self.components[self.type];
				component.onmove(diff);
			}
		},

		onend: function (e) {
			if (self.type === null) return;

			// >>>>>>> Розрахунок швидкості свайпа
			let now = Date.now();
			let dt = now - self.last_time;
			let dx = self.last_pos.x - self.x;
			let dy = self.last_pos.y - self.y;
			let distance = Math.sqrt(dx * dx + dy * dy);
			let velocity = distance / dt; // px/ms
			let direction = self.last_direction;
			// <<<<<<<

			if (self.type !== SWIPE_DETECT_STATE) {
				let component = self.components[self.type];
				component.onend({
					velocity,
					distance,
					direction,
					// is_cancel === true - це ручний виклик self.onend
					// наприклад, для попередження повторних спрацювань після перетину threshold point
					is_cancel: e === undefined,
					event: new CustomEvent('swipeend', {
						detail: {
							x: self.last_pos.x,
							y: self.last_pos.y,
						}
					})
				});
			}

			self.x = null;
			self.y = null;
			self.type = null;
			self.modal_preview_x = null;
			self.modal_preview_y = null;
			self.move_prevent_default = false;

			self.last_pos = { x: null, y: null };
			self.last_direction = null;
			self.last_time = null;
		},

		onBoot: function () {
			// if (!App.device.is_touch_screen()) return;

			$(window)
				.bind('mousedown touchstart', self.onstart)
				.bind_active('mousemove touchmove', self.onmove)
				.bind('click mouseup touchend', self.onend)
				.bind('scroll', self.onend);
		},
	};
})();

;var App = App || {};

(function() {
	let self = App.task_create = {
		shown: false,
		id: 0,
		id_tmp: 0,
		title: '',
		locale: {},

		obj_wrapper: null,
		obj_window: null,
		obj_menus: null,
		window: null,

		state_saved: null,
		state_noticed: null,

		open_in_fullscreen: false,
		width: 640,
		/**
		 * @type {TaskContextMenu|null}
		 */
		context_menu: null,

		force_project_menu_timeout: null,

		is_shown: function () {
			return self.shown;
		},

		selector_component_delete: '.delete',

		new: function(params) {
			params ||= '';

			App.menu.hide_all();

			self.show(0, 0, params);
		},

		show: function(id, id_tmp, params) {
			if (!App.windows.before_open(self.window, {id, id_tmp, params})) return;

			if (id != null) id = Number(id);
			if (self.is_shown() && self.id === id && params?.reload !== true) {
				self.window.alreadyOpened();
				return false;
			}

			if (self.is_shown()) {
				self.task_panel_update();
			}

			self.id = id || 0;
			self.id_tmp = id_tmp || App.helper.time.now();

			self.window.opening();
			let cache_data = App.task_create_cache.pop(id);

			if (cache_data && params?.reload !== true) {
				if (self.is_shown()) {
					self.detach();
				}
				self.shown = true;
				self.obj_wrapper.html('').append(cache_data.obj_window).append(cache_data.obj_menus);
				self.animate_show();
				self.obj_window = self.obj_wrapper.find('.taskCreate');
				self.title = cache_data.title;
				self.state_saved = self.state_noticed = self.get_state();
				self.editor_init();
				self.window.opened();
				self.components.init();
				self.init_multiline_paste()
				self.init_change_callback();
			} else {
				self.window.loading();
				$.ajax({
					url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('task_draft:show') + (self.id ? '&id=' + self.id : (params.indexOf('id_project') !== -1 ? '' : '&id_project=' + App.current_page.project) + (params ? '&' + params : ''))),
					success: function (html) {
						if (html === 'notfound') {
							App.task_panel.item.remove_by_item($('.taskPanel__item-draft[data-draft='+self.id+']'));
							return self.window.loadFailed();
						}
						if (self.is_shown()) {
							self.detach();
						}
						self.shown = true;
						self.obj_wrapper.html(html);
						self.animate_show();
						self.obj_menus = self.obj_wrapper.find('.menu').not('.menu-level2').appendTo('#taskCreate__wrapper');
						self.obj_window = self.obj_wrapper.find('.taskCreate');
						self.obj_window.attr('data-id', ); // for Queue
						self.state_saved = self.state_noticed = self.get_state();
						if (self.id === 0) self.state_saved = null;
						self.init();
						self.init_scroll_zones();
						self.editor_init();
						App.task_create_cache.push(self.id || self.id_tmp, self);
						self.form_validate();
						self.window.opened();
						if (App.current_page.project === 0) {
							self.components.assignee.set_me();
						}
						self.components.init();
						self.init_multiline_paste()
						self.init_change_callback();
					},
					error: App.core.create_jq_ajax_error(function () {
						self.window.loadFailed();
					})
				});
			}

		},

		init_change_callback: function () {
			self.obj_window.on('change', function () {
				const project_ids = self.components.project.get_ids();
				const assignee_ids = self.components.assignee.get_ids();
				const buttons_container = self.obj_window.find('.taskCreate__buttons');
				if (project_ids.length != 1 || assignee_ids.length > 1) {
					self.components.subscribers.hideContainer()
					self.components.visibility.hideContainer()
					buttons_container.addClass('taskCreate__buttons--controlsHidden');
				} else  {
					self.components.subscribers.showContainer();
					self.components.visibility.showContainer();
					buttons_container.removeClass('taskCreate__buttons--controlsHidden');
				}
			});
		},
		init_multiline_paste: function() {
			App.helper.handle_multiline_paste.register(self.obj_window.find('.taskCreate__content__title').find('textarea'), self.open_mass, () => null)
		},
		init_context_menu: function () {

			const make_component_config = (item) => {
				const ctrl = item.id.indexOf('field_') === 0 ? 'custom_fields' : item.id;

				return {
					type: item.id,
					container: item.id,
					icon: item.icon,
					text: item.label,
					group: self.components[ctrl]?.group ?? 'main',
					hasCounter: self.components[ctrl]?.hasCounter ?? false,
					canBeRemoved: self.components[ctrl]?.canBeRemoved ?? true,
				};
			};
			const disabled = self.obj_window.find('[name=disabled_features]').val().split(',');
			const context_menu = new App.classes.task_context_menu({
				components: [
					...self.components.list.filter(i => !i.disabled && i.id.indexOf('field_') === -1).map(c => ({
						type: c.id,
						selected: self.components.has_value(c.id),
						config: make_component_config(c),
					})),
					...['subscribers', 'visibility'].filter(t => !disabled.includes(t)).map(type => {
						return { type, selected: self.components.has_value(type), counter: self.components.counter(type) }
					}),
				],
				input: this.obj_window.find('textarea[name=name]')
			});
			context_menu.on('task_context_menu.component.show', function (component) {
				self.components.show(component.type, { anchor: component.element() });
			});
			context_menu.on('task_context_menu.component.clear', function (component) {
				self.components.clear(component.type, { anchor: component.element() });
			})
			self.context_menu = context_menu;
		},

		open_mass: function (texts = [], request = {}) {
			const serializedForm = App.task_create.obj_wrapper.find('form').serialize();
			self.is_shown() && self.minimize();
			App.task_create_mass.show({
				request: serializedForm.length ? serializedForm : App.helper.object.toFormUrlEncoded(request),
				onload: function() {
					if (texts.length) {
						App.task_create_mass.removeRows();
						App.task_create_mass.fill_rows(...texts);
					}
				}
			});
		},

		reload: function(options) {
			self.show(self.id, null, { reload: true });
		},

		fullscreen: function() {
			self.open_in_fullscreen = !self.open_in_fullscreen;
			self.obj_wrapper.find('button').blur();

			const canvas_width = $(window).width();
			if (canvas_width < 480) return;

			const should_open = !self.obj_wrapper.hasClass('taskCreate__wrapper-fullscreen');
			if (should_open) {
				setTimeout(() => self.obj_wrapper.addClass('taskCreate__wrapper-fullscreen'), 0);
			} else {
				setTimeout(() => self.obj_wrapper.removeClass('taskCreate__wrapper-fullscreen'), 0);
			}
		},

		has_not_saved_state: function() {
			return self.id || (self.state_noticed !== self.state_saved && self.has_name_or_descr());
		},

		hide: function(config) {
			config ||= {}
			if (App.modal.is_shown()) App.modal.hide({immediate: true, hide_all: true});
			if (self.has_not_saved_state()) {
				if (config.from_popstate) App.core.history?.mobile?.push('task_create');
				App.controls.confirm.menu(self.obj_window.find('.taskCreate__head .close, .mobile-head .close'), {
					message: App.object_state.locale['draft_will_delete'],
					ok_label: App.object_state.locale['yes_delete'],
					cancel_label: App.object_state.locale['no_cancel'],
					onconfirm: function () {
						self.delete(config);
					}
				});
			} else {
				self.delete(config);
			}
		},

		mobile_hide: function() {
			if (App.modal.is_shown()) App.modal.hide({immediate: true, hide_all: true});

			if (self.has_not_saved_state()) {
				App.controls.confirm.menu(self.obj_window.find('.taskCreate__head .close, .mobile-head .close'), {
					message: App.object_state.locale['draft_will_delete'],
					ok_label: App.object_state.locale['yes_delete'],
					cancel_label: App.object_state.locale['no_cancel'],
					onconfirm: function () {
						self.delete();
					},
					oncancel: function () {
						self.window.minimizing();
						self.task_panel_update();
						self.animate_hide(function () {
							self.window.closed();
							self.shown = false;
							self.id = self.id_tmp = 0;
							self.detach();
						});
					}
				});
			} else {
				self.delete();
			}
		},

		hide_and_delete: function() {
			if (App.modal.is_shown()) App.modal.hide({immediate: true, hide_all: true});
			self.delete();
		},

		hide_from_editor: function (e) {
			if (self.id || self.state_noticed !== self.state_saved) {
				App.controls.confirm.menu($(e.target).closest('.menu__item'), {
					message: App.object_state.locale['draft_will_delete'],
					ok_label: App.object_state.locale['yes_delete'],
					cancel_label: App.object_state.locale['no_cancel'],
					onconfirm: function () {
						App.menu.hide();
						self.delete();
					}
				});
			} else {
				App.menu.hide();
				self.delete();
			}
		},

		clear_fullscreen: function () {
			self.obj_wrapper.removeClass('taskCreate__wrapper-fullscreen');
		},

		delete: function(config) {
			config ||= {}
			self.window.closing(config);
			if ($(window).width() > 480) self.clear_fullscreen();
			let queue_id = 'task_create' + self.id_tmp;
			if (self.id) {
				App.core.call_queue.add(queue_id, self.request_delete, self, {id: self.id});
			} else {
				App.core.call_queue.delete(queue_id);
			}
			App.task_create_cache.delete(self.id || self.id_tmp);
			self.animate_hide(function() {
				self.shown = false;
				self.window.closed(config);
				self.id = self.id_tmp = 0;
				self.remove();
			});
		},

		on_foreground: function () {
			self.editor_init();
		},

		remove_from_task_panel: function(el) {
			const id = $(el).attr('data-draft');
			if (self.is_shown() && self.id == id) {
				self.hide(el);
				return;
			}

			if (!id) {
				App.task_panel.item.remove_by_item($(el));
				return;
			}

			App.controls.confirm.menu(el, {
				message: App.object_state.locale['draft_will_delete'],
				ok_label: App.object_state.locale['yes_delete'],
				cancel_label: App.object_state.locale['no_cancel'],
				onconfirm: function () {
					const queue_id = 'task_create' + id;
					App.core.call_queue.add(queue_id, self.request_delete, self, { id });
					App.task_create_cache.delete(id);
					App.task_panel.item.remove_by_item($(el));
				},
				close_strategy: 'hide'
			});
		},

		animate_show: function() {
			if (App.device.is_mobile()) {
				$('body').addClass('mobileTaskCreate');
			} else {
				self.obj_wrapper.addClass('taskCreate__wrapper-active');
			}
			let textarea = self.obj_wrapper.find('.taskCreate__content__title textarea');
			setTimeout(function() {
				textarea.val().trim() ? textarea.focus_select_desktop() : textarea.focus();
			}, 100);

			// or transitionend
			setTimeout(() => {
				self.window.ready();
			}, 300);
		},

		animate_hide: function(callback) {
			if (App.device.is_mobile()) {
				$('body').removeClass('mobileTaskCreate');
				callback();
			} else {
				self.clear_fullscreen();
				self.obj_wrapper.removeClass('taskCreate__wrapper-active');
				setTimeout(function() {
					callback.call(self);
				}, 300);
			}
		},

		minimize: function() {
			if (!self.has_not_saved_state()) return self.hide();

			self.window.minimizing();
			self.task_panel_update();
			self.animate_hide(function() {
				self.window.closed();
				self.shown = false;
				self.id = self.id_tmp = 0;
				self.detach();
			});
		},

		task_panel_update: function() {
			let name = self.get_from_name_value() || App.object_state.locale.task_panel.task_create_default_title;

			const { panel_item: task_panel_item } = App.task_panel.item.find(self);

			const update = (id, name, task_panel_item) => {
				if (task_panel_item.length) {
					App.task_panel.item.update_by_item(task_panel_item, (item) => {
						item.children('.flex_content').html(name);
					});
				} else {
					App.task_panel.append({type: 'draft', id: id, name: name});
				}
			};

			if (self.id) return update(self.id, name, task_panel_item);

			App.core.call_queue.delete('task_create' + self.id_tmp);
			self.request_save({ id: self.id, id_tmp: self.id_tmp, data: self.get_state() }, (res) => update(res.id, name, task_panel_item));
		},

		detach: function() {
			self.obj_window.detach();
			self.obj_menus.detach();
		},

		remove: function() {
			self.destroy_scroll_zones();
			self.obj_window.removeWithComponents();
			self.obj_menus.removeWithComponents();
		},

		get_from_name_value: function () {
			return self.obj_window.find('textarea[name=name]').val().trim();
		},

		form_validate: function() {
			let valid = true;
			if (!self.obj_window.find('textarea[name=name]').val()) {
				valid = false;
			} else if (self.obj_window.find('[name=require_project]').val() === '1') {
				if (!self.components.project.get_ids().length) valid = false;
			} else if (!self.components.assignee.get_id() && !self.components.project.get_ids().length) {
				valid = false;
			} else if (self.obj_window.find('[data-container].require .data_place').length) {
				valid = false;
			}

			self.obj_window.find('.taskCreate__buttons .btn-primary, .taskCreate__buttons .btn-delay').toggleDisabled(!valid);
			return valid;
		},

		request_publish: function (params, onsuccess, onerror) {
			let btn = self.obj_window.find('.taskCreate__buttons .btn-primary, .taskCreate__buttons .btn-delay');
			btn.toggleDisabled(true);
			$.ajax({
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('task_draft:publish') + '&id=' + params.id + '&next_action=' + params.next_action),
				type: 'POST',
				dataType: 'script',
				data: params.data,
				timeout: App.env === 'local' ? 60000 : 10000,
				error: App.core.create_jq_ajax_error(function () {
					btn.toggleDisabled(false);
					if (onerror) onerror();
				}),
				success: function () {
					// Remove draft from tray before resetting IDs
					const draft_id = params.id || params.id_tmp;
					const draft_item = $('.taskPanel__item-draft[data-draft=' + draft_id + ']');
					if (draft_item.length) {
						App.task_panel.item.remove_by_item(draft_item);
					}

					if (self.id_tmp === params.id_tmp) { // still open
						self.id = self.id_tmp = 0;
						App.task_create.delete();
					} else {
						App.task_create_cache.delete(draft_id);
					}
					self.send_object_state('publish', params.id);
					if (onsuccess) onsuccess();
				}
			});
		},

		request_delete: function (params, onsuccess, onerror) {
			$.ajax({
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('task_draft:delete') + '&id=' + params.id),
				dataType: 'json',
				timeout: App.env === 'local' ? 60000 : 10000,
				error: App.core.create_jq_ajax_error(onerror),
				success: function (json) {
					if (json.status !== 'ok') {
						if (onerror) onerror();
					} else {
						self.send_object_state('delete', params.id);
						if (onsuccess) onsuccess();
					}
				}
			});
		},

		request_save: function (params, onsuccess, onerror) {
			$.ajax({
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('task_draft:save') + '&id=' + params.id),
				type: 'POST',
				dataType: 'json',
				data: params.data,
				timeout: App.env === 'local' ? 60000 : 10000,
				error: App.core.create_jq_ajax_error(onerror),
				success: function (json) {
					if (json.status !== 'ok') {
						if (onerror) onerror();
					} else {
						if (!self.id_tmp) return false; // already deleted
						if (!params.id) App.task_create_cache.replace(params.id_tmp, json.id);
						if (self.id_tmp === params.id_tmp) {
							self.id = json.id;
							self.state_saved = params.data;
						}
						if (self.id) self.obj_wrapper.find('.minimize').show();
						self.send_object_state('update', json.id);
						if (onsuccess) onsuccess({
							id_tmp: params.id_tmp,
							id: json.id
						});
					}
				}
			});
		},

		send_object_state: function(type, id) {
			const message = {
				command: 'task_create',
				data: { type, id },
				dt: (new Date).getTime() + Math.random()
			};
			App.core.send_message_to_other_tabs(message);
			App.core.send_message_to_other_devices(message);
		},

		get_state: function() {
			return self.obj_window.serialize();
		},

		has_name_or_descr: function () {
			return !!self.obj_window.find('[name=name]').val()?.trim() || !!self.obj_window.find('[name=descr]').val()?.trim();
		},

		is_saved: function() {
			return self.state_saved === self.get_state();
		},

		force_save: function() {
			let queue_id = 'task_create' + self.id_tmp;
			let this_state = self.get_state();
			if (self.state_saved !== this_state) {
				self.state_noticed = this_state;
				App.core.call_queue.add(queue_id, self.request_save, this, {
					id: self.id,
					id_tmp: self.id_tmp,
					data: this_state,
				}, 0);
			} else {
				App.core.call_queue.delete(queue_id);
			}
		},

		form_on_update: function() {
			self.form_validate();

			if (!self.has_name_or_descr() && !self.id) return;

			self.obj_wrapper.find('.minimize').show();

			let queue_id = 'task_create' + self.id_tmp, this_state = self.get_state();
			if (self.state_saved !== this_state) {
				if (self.state_noticed !== this_state) {
					self.state_noticed = this_state;
					App.core.call_queue.add(queue_id, self.request_save, this, {
						id: self.id,
						id_tmp: self.id_tmp,
						data: this_state,
					}, 5);
				}
			} else {
				App.core.call_queue.delete(queue_id);
			}
		},

		form_on_submit: function(next_action) {
			let is_valid = self.form_validate();
			if (!is_valid) return;

			let queue_id = 'task_create' + self.id_tmp;
			let params = {
				id: self.id,
				id_tmp: self.id_tmp,
				next_action: next_action,
				data: self.get_state(),
			};
			App.core.call_queue.add(queue_id, self.request_publish, this, params, 0);
		},

		init: function() {
			if (!self.id) self.obj_wrapper.find('.minimize').hide();

			self.obj_window.bind('change', () => self.form_on_update());
			self.obj_window.find('.taskCreate__buttons .btn-primary').bind('click', () => self.form_on_submit());
			self.obj_window.find('.taskCreate__buttons .btn-delay').bind('click', function() {
				App.menu.show({anchor: this, box: '#taskCreate__menu__send_options', type: 'bottom',});
			});
			self.obj_window.find('.taskCreate__content__editor-wrapper').bind('click', function(e) {
				if ($(e.target).hasClass('taskCreate__content__editor-wrapper') || $(e.target).hasClass('editor__toolbar')) {
					App.editor.focus();
				}
			});
			const handleForceProjectSelect = function (e) {
				// force project selection
				if (self.force_project_menu_timeout) {
					clearTimeout(self.force_project_menu_timeout);
					self.force_project_menu_timeout = null;
				}

				const key = App.device.is_mobile() && e.type === 'input' ? (e.originalEvent.data || e.key || '') : (e.key || '');

				if (key === '/' && self.components.project.get_ids().length === 0) {

					// skip task_context_menu
					e.stopImmediatePropagation();

					self.force_project_menu_timeout = setTimeout(() => {
						const input = e.target;
						const rect = $(input).getCaretCoordinates().rect;

						self.components.show('project', {
							anchor: input,
							noblur: true,
							text_position: {
								x: rect.x,
								y: rect.y,
							},
							onhide: function () {
								const menu = $(this);
								input.focus();
								if (self.components.project.get_ids().length > 0) {
									self.context_menu.input_command_menu.clearInput()
								}
							}
						});
					}, 400);

					return true;
				}
			}
			self.obj_window.find('.taskCreate__content__title textarea').bind('input paste', function() {
				this.value = this.value.replace(/[\n\r]+/ig, ' ');
				$(this).height(0);
				$(this).height(this.scrollHeight);
				$(this).parents('form').trigger('change');
			}).bind('keydown', function(e) {

				if (!App.device.is_mobile() && handleForceProjectSelect(e)) {
					return;
				}

				let key = e.keyCode ? e.keyCode : e.charCode;

				if (e.altKey && (e.ctrlKey || e.metaKey) && key === App.keycode.Enter) return self.form_on_submit('open');
				if (e.shiftKey && (e.ctrlKey || e.metaKey) && key === App.keycode.Enter) return self.form_on_submit('new');

				if (!(e.ctrlKey || e.metaKey) && key === App.keycode.Enter && !App.menu.is_shown()) return false;
			});
			// .bind('input', function(e) {
			// 	if (App.device.is_mobile() && handleForceProjectSelect(e)) {
			// 		return;
			// 	}
			// });
			App.upload.init(self.obj_window.find('.drop_zone_body'));

			let title_text = self.obj_window.find('.taskCreate__content__title textarea');
			title_text.height(title_text.get(0).scrollHeight);
		},

		editor_init: function() {
			App.editor.init(self.obj_window, {
				onkeydown: function (e) {
					let key = e.keyCode ? e.keyCode : e.charCode;

					if (e.altKey && (e.ctrlKey || e.metaKey) && key === App.keycode.Enter) {
						self.form_on_submit('open'); return true;
					}
					if (e.shiftKey && (e.ctrlKey || e.metaKey) && key === App.keycode.Enter) {
						self.form_on_submit('new'); return true;
					}
				},
			});
		},

		components: {
			list: [],
			always_visible: ['assignee', 'terms', 'priority', 'stage'],
			init: function() {
				const params = self.obj_window.find('.params'),
					is_initialized = params.attr('data-init') === '1',
					call_method = is_initialized ? 'reset' : 'init';

				params.attr('data-init', '1');

				self.components.list = JSON.parse(params.attr('data-list'));

				for (let i in self.components) {
					if (typeof self.components[i] === 'object' && call_method in self.components[i])
						self.components[i][call_method]();
				}

				self.components.list = self.components.list.map(i => ({
					...i,
					visible: self.components.always_visible.includes(i.id) || self.components.has_value(i.id),
				}));

				self.components.refresh(true);
				self.init_context_menu();
			},
			// begin: BASE INTERFACE:
			show: function (key, params) {
				const item = this.list.find(i => i.id === key);
				if (item) item.visible = true;

				if (this.list.filter(i => !i.visible).length < 3) {
					this.list = this.list.map(i => ({ ...i, visible: true }));
				}

				this.refresh(true);

				if (key.startsWith('field_')) {
					self.components.custom_fields.show(parseInt(key.substring(6)), params);
				} else if (self.components[key]?.show != null) {
					self.components[key].show(params);
				} else {
					self.obj_window.find(`[data-container=${key}]`).trigger('click', { backup: true, ...(params || {}) });
				}
			},
			show_all: function () {
				this.list = this.list.map(i => ({ ...i, visible: true }));
				this.refresh(true);
			},
			clear: function (key, params) {
				if (key.startsWith('field_')) {
					self.components.custom_fields.clear(parseInt(key.substring(6)), params);
				} else {
					self.components[key].clear?.(params);
				}

				this.refresh(true);
			},
			hide: function (key, params) {
				const item = this.list.find(i => i.id === key);
				if (item) item.visible = false;

				if (key.startsWith('field_')) {
					self.components.custom_fields.hide(parseInt(key.substring(6)), params);
				} else {
					self.components[key]?.hide?.(params);
				}

				this.refresh(true);
			},
			set: function (key, value) {
				if (key.startsWith('field_')) {
					self.components.custom_fields.set(parseInt(key.substring(6)), value);
				} else {
					self.components[key]?.set?.(value);
				}
			},
			has_value: function (key) {
				if (key.startsWith('field_')) return self.components.custom_fields.is_selected(parseInt(key.substring(6)));

				return self.components[key]?.is_selected?.() === true;
			},
			counter: function (key) {
				return self.components[key.startsWith('field_') ? 'custom_fields' : key]?.counter?.() || 0;
			},
			disable: function (key, state) {
				const item = this.list.find(i => i.id === key);
				if (item) item.disabled = state ?? true;
				this.refresh();
			},
			require: function (key, state) {
				const item = this.list.find(i => i.id === key);
				if (item) item.required = state ?? true;
				this.refresh();
			},
			set_disabled: function (keys) {
				this.list = this.list.map(function (item) {
					item.disabled = keys.includes(item.id);
					return item;
				});
				this.refresh();
			},
			set_required: function (keys) {
				this.list = this.list.map(function (item) {
					item.required = keys.includes(item.id);
					return item;
				});
				this.refresh();
			},
			// end: BASE INTERFACE:
			refresh: function (force_render = false) {

				const hidden_items = [];

				this.list = this.list.map(i => {
					const has_value = self.components.has_value(i.id);
					const item = {
						...i,
						has_value,
						visible: (!!i.visible || has_value || !!i.required) && i.disabled !== true,
					};

					if (!item.disabled && !item.visible) {
						hidden_items.push(item);
					}

					return item;
				});

				if (hidden_items.length > 0 && hidden_items.length <= 2) {
					this.list = this.list.map(i => {
						if (!i.disabled && !i.visible) {
							return { ...i, visible: true };
						}
						return i;
					});
				}

				clearTimeout(this._render_timer);
				if (force_render) this.render();
				else this._render_timer = setTimeout(self.components.render, 1);
			},
			render: function () {
				const it = self.components;

				self.obj_window.find('.params').attr('data-list', JSON.stringify(it.list));

				it.list.forEach(function (item) {
					let el, is_custom_field = item.id.startsWith('field_');

					if (is_custom_field && item.visible) {
						el = self.components.custom_fields.render(parseInt(item.id.substring(6)));
					} else if (is_custom_field) {
						self.obj_window.find(`.params [data-container="${item.id}"]`).remove();
					} else {
						el = self.obj_window.find(`.params [data-container="${item.id}"]`);
						if (el.length === 0) el = null;
					}

					if (!el) return;

					el.toggleClass('hiddenBlock', !item.visible).toggleClass('require', !!item.required);

					if (!!item.required && !item.has_value) {
						el.attr('data-title', item.name + '%NL%' + App.i18n.t('required_input'));
					} else if (item.has_value) {
						el.attr('data-title', item.name);
					} else {
						el.attr('data-title', null);
					}
				});

				self.components.more.render();
				self.form_validate();
			},

			custom_fields: {
				group: 'footer',
				id_project: null,
				is_allowed: () => self.obj_window.find(`.params`).attr('data-custom-fields') === '1',
				init: function () {
					const custom_fields = self.components.custom_fields;
					if (!custom_fields.is_allowed()) return;

					self.obj_window.find(`.params`)
						.on('delete', '[data-container^=field_]', function () { self.components.hide($(this).attr('data-container')); })
						.on('apply', '[data-container^=field_]', function (e) { self.components.set($(this).attr('data-container'), e.detail.value); });

					self.obj_window.get(0).onHandshake('custom_field_context', () => ({
						external_edit_url: App.helper.url.add_query(
							App.helper.endpoint.primary(),
							App.actions.get('task_draft:field'),
							{ id_project: custom_fields.id_project }
						)
					}));

					custom_fields.reset();
					custom_fields.id_project = self.components.project.get_id();

					self.obj_window.on('change', function() {
						const id_project = self.components.project.get_id();
						if (custom_fields.id_project === id_project) return;
						custom_fields.id_project = id_project;
						custom_fields.on_project_changed();
					});
				},
				reset: function () {
					self.obj_window.find(`input[name^=field_]`).each(function () {
						const key = $(this).attr('name'), id_field = parseInt(key.substring(6));
						App.state.custom_values.setTask(0, id_field, $(this).val() || '');
					});
				},
				on_project_changed: function () {
					const id_project = self.components.custom_fields.id_project;

					if (!id_project) {
						self.components.list = self.components.list.filter(i => !i.id.startsWith('field_'));
						self.obj_window.find(`.params a[data-container^=field_]`).remove();
						return self.components.refresh();
					}

					App.core.async_task.ajax({
						id: 'task_create_project_fields',
						url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('task_draft:field'), { id_project, list: 1 })
					}).then(function (custom_fields) {
						const new_keys = custom_fields.map(f =>`field_${f.id}`),
							rendered_keys = self.obj_window.find(`.params a[data-container^=field_]`).get().map(i => i.getAttribute('data-container'));

						rendered_keys.filter(k => !new_keys.includes(k)).forEach(k => {
							self.obj_window.find(`.params a[data-container=${k}]`).remove();
						});

						self.components.list = [
							...self.components.list.filter(i => !i.id.startsWith('field_')),
							...custom_fields.map(f => ({
								id: `field_${f.id}`,
								label: f.name,
								icon: f.icon,
								visible: rendered_keys.includes(`field_${f.id}`),
							})),
						];
						self.components.refresh();
					});
				},
				render: function (id_field) {
					const field = App.state.custom_fields.find(id_field), key = `field_${id_field}`;
					if (field == null) return null;

					if (self.obj_window.find(`input[name=${key}]`).length === 0) {
						self.obj_window.append(`<input type="hidden" name="${key}" value="">`);
					}

					let el = self.obj_window.find(`.params [data-container="${key}"]`);

					if (el.length === 0) {
						el = $('<a>').attr('data-container', key);
						el.html(CustomField.create(field, 0, {
							format: 'chip',
							value: self.obj_window.find(`input[name=${key}]`).val() || ''
						}));
						self.obj_window.find('.params [data-container=more]').before(el);
					}

					return el;
				},
				show: function (id_field) {
					const el = self.components.custom_fields.render(id_field);
					if (!el) return;

					const custom_field = el.find(`custom-field`);

					if (self.components.custom_fields.is_selected(id_field)) {
					} else if (custom_field.attr('type') === 'boolean') {
						self.components.custom_fields.set(id_field, 'true');
					} else {
						setTimeout(() => custom_field.trigger('click'), 100);
					}
				},
				set: function (id_field, value) {
					self.obj_window.find(`input[name=field_${id_field}]`).val(value);
					App.state.custom_values.setTask(0, id_field, value);
					self.obj_window.trigger('change');
				},
				clear: function (id_field) {
					self.components.custom_fields.set(id_field, '');
				},
				hide: function (id_field) {
					App.state.custom_values.setTask(0, id_field, '');
					self.obj_window.find(`input[name=field_${id_field}]`).remove();
					self.obj_window.find(`.params [data-container=field_${id_field}]`).remove();
					self.obj_window.trigger('change');
				},
				is_selected: function (id_field) {
					return !!self.obj_window.find(`input[name=field_${id_field}]`).val();
				}
			},

			more: {
				menu: null,
				select_list: function () {
					return self.components.list.filter(i => !i.disabled && !i.visible && !i.required);
				},
				has_more: function () {
					return self.components.more.select_list().length > 0;
				},
				render: function () {
					self.obj_window.find('.params [data-container=more]').toggleClass('hiddenBlock', !self.components.more.has_more());
				},
				show_menu: function (params) {
					const select_list = self.components.more.select_list();
					const cache_key = select_list.map(i => i.id).join('-');

					if (self.components.more.menu?._cache_key !== cache_key) {
						self.components.more.menu?.destroy();
						self.components.more.menu = null;
					}

					if (self.components.more.menu === null) {
						self.components.more.menu = App.controls.menu.create_menu({
							id: 'task_create_menu_more',
							search: true,
							button: {
								text: '',
								right_icon: 'arrows/guillemet-right',
								name: 'btn btn-28 btn-g btn-skeleton',
							},
							groups: [
								{
									search: true,
									items: select_list.map(i => ({
										title:    i.label,
										icon:     i.icon,
										dataset: { key: i.id }
									}))
								},
							],
						});
						self.components.more.menu._cache_key = cache_key;
					}

					return self.components.more.menu.show({
						onload: function (m) {
							$(m).find('.menu__item[data-key]').on('click', function () {
								self.components.show($(this).attr('data-key'));
								App.menu.hide();
							});
							$(m).find('ws-btn[name*=primary]').on('click', function () {
								self.components.show_all();
								App.menu.hide();
							});
						},
						...params,
					});
				},
				init: function () {
					self.obj_window.find('[data-container=more]').on('click', function () {
						self.components.more.show_menu({ anchor: this, type: 'left' });
					});
				},
				reset: function () {
					self.components.more.menu?.destroy();
					self.components.more.menu = null;
				}
			},

			project: {
				group: 'header',
				init: function() {
					self.obj_window.find('[data-container=project]').on('click', function (e, data) {
						data ||= {};
						data.anchor ||= this;
						if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							self.components.project.callback_delete();
						} else {
							let ids = $(this).find('input').length ? $(this).find('input').val().split(',').map(Number) : [];
							if (ids.length > 1 || data.multi) {
								App.controls.project_select_and_go.show_context(data.anchor, null, {
									request: {multiple: true, requirements: true, use_sidebar_config: true},
									onload: function () {
										let menu = $(this);
										App.controls.menu.init(menu);
										$(this).on('click', '.menu__item, .menu__itemFake', function() {
											self.components.project.callback_multiple.call(menu);
										});
									},
									onshow: function() {
										$(this).find('.menu__item[data-id]').each(function() {
											$(this).toggleClass('menu__item-active', ids.includes($(this).attr('data-id').toInt()));
										});
									},
									onhide: data?.onhide || null,
									noblur: data?.noblur || null,
									text_position: data?.text_position || null,
									backup: data?.backup || false,
								});
							} else {
								const request = {multiple_enabled: Number(self.components.assignee.get_ids().length <= 1), requirements: true};
								const ids_assignee = self.components.assignee.get_ids();
								if (ids_assignee.length > 1) {
									request.ids_assignee = ids_assignee.join(',');
								}

								App.controls.project_select_and_go.show_context(data.anchor, null, {
									request: { ...request, use_sidebar_config: true },
									onload: function () {
										let menu = $(this);
										App.controls.menu.init(menu);
										$(this).on('click', '.menu__item', function() {
											self.components.project.callback.call(this);
											App.menu.hide();
										}).on('click', '.multi-select', function() {
											App.menu.hide(true);
											self.obj_window.find('[data-container=project]').eq(0).trigger('click', [{multi:true}]);
										});
									},
									onshow: function() {
										$(this).find('.menu__item[data-id]').each(function() {
											$(this).toggleClass('menu__item-active', ids.includes($(this).attr('data-id').toInt()));
										});
									},
									onhide: data?.onhide || null,
									noblur: data?.noblur || null,
									text_position: data?.text_position || null,
									backup: data?.backup || false,
								});
							}
						}
					});
					self.components.project.callback_final();
				},
				clear: function () {
					self.components.project.callback_delete();
				},
				callback: function () { // this = menu__item
					let id = $(this).attr('data-id');
					let require = $(this).attr('data-require').split(',');

					self.components.set_required(require);
					self.components.project.set({ id, icon: $(this).find('span.space').first().html() });
					self.obj_window.find('[data-container=parent]').show().html(App.helper.template.fill('task_create_parent_empty'));
					self.obj_window.attr('action', App.helper.endpoint.project(id)).attr('ajax-action', App.helper.endpoint.ajax(id));
					$('#taskCreate__menu__file .recent_files').attr('data-modal-url', App.helper.url.add_query(App.helper.endpoint.project(id), $('#taskCreate__menu__file .recent_files').attr('data-action')))
					App.controls.user_select_and_go.team(self.helper_user_endpoint('team'), self.components.team.callback);
					if (require.includes('hidden') && (!self.obj_window.find('input[name=hidden]').val() && !self.obj_window.find('input[name=guests]').val())) {
						self.components.visibility.preset('me');
					}
					self.components.project.callback_final();
					return false;
				},
				callback_multiple: function () {
					let o = $(this).find('.menu__item-active');
					if (o.length === 0) { // none selected fallback
						self.components.project.callback_delete();
						return false;
					}
					const ids = new Set();
					o.each(function() {
						ids.add($(this).attr('data-id'));
					});
					if (ids.size === 1) { // single selected fallback
						self.components.project.callback.call(o.get(0));
						return false;
					}
					self.obj_window.find('[data-container=project]').html(App.helper.template.fill('task_create_project_multiple', {
						name: App.format.quantity(ids.size, App.object_state.locale['projects'], QTY_WITH_TEXT),
						ids: [...ids].join(','),
						icon: '<ws-icon name="project-solid"></ws-icon>'
					}));
					self.obj_window.find('[data-container=parent]').hide().html(App.helper.template.fill('task_create_parent_empty'));
					self.obj_window.find('[data-container=assignee]').html(App.helper.template.fill('task_create_assignee_empty'));
					self.obj_window.attr('action', self.obj_window.attr('data-def-action')).attr('ajax-action', self.obj_window.attr('data-def-ajax-action'));
					self.components.project.callback_final();
					return false;
				},
				callback_delete: function() {
					self.components.set_required([]);
					if (!self.components.assignee.get_id()) self.components.assignee.set_me();
					self.obj_window.find('[data-container=project]').html(App.helper.template.fill('task_create_project_empty'));
					self.obj_window.find('[data-container=parent]').hide().html(App.helper.template.fill('task_create_parent_empty'));
					self.obj_window.attr('action', self.obj_window.attr('data-def-action')).attr('ajax-action', self.obj_window.attr('data-def-ajax-action'));
					self.components.project.callback_final();
				},
				callback_final: function() {
					let ids_project = self.components.project.get_ids();
					self.obj_window.find('.editor__toolbar .mention').toggle(ids_project.length === 1);
					self.obj_window.find('[data-container=hidden]').toggle(ids_project.length === 1 && self.components.assignee.get_ids().length <= 1);
					self.obj_window.find('.taskCreate__subscribers').toggle(ids_project.length === 1  && self.components.assignee.get_ids().length <= 1);
					$('#taskCreate__menu__file .recent_files').toggle(ids_project.length === 1);
					if (ids_project.length === 0) {
						self.components.set_disabled(['limits']);
						self.components.set_required(['assignee']);
					}
					self.components.project.update_placeholder();
					self.obj_window.trigger('change');
				},
				set_multiple: function({name, ids, icon}) {
					self.obj_window.find('[data-container=project]').html(App.helper.template.fill('task_create_project_multiple', {
						name,
						ids,
						icon
					}));
				},
				set: function({id, icon}) {
					self.obj_window.find('[data-container=project]').html(App.helper.template.fill('task_create_project', {
						name: App.components.expand('project-name', { project: id, format: 'chip' }, {
							name: App.helper.project(id, 'name'),
						}),
						id,
						icon,
					}));
				},
				get_ids: function(obj_window) {
					obj_window ||= self.obj_window;
					return obj_window.find('[data-container=project]').find('input').length ? obj_window.find('[data-container=project]').find('input').val().split(',').map(Number) : [];
				},
				get_id: function(obj_window) {
					const ids = self.components.project.get_ids(obj_window);
					return ids.length === 1 ? ids[0] : null;
				},

				update_placeholder: function () {
					const no_project = self.obj_window.find('[data-container=project]').find('input').val() === undefined;
					const placeholder_default = self.obj_window.find('.taskCreate__content__title-placeholder--default');
					const placeholder_project = self.obj_window.find('.taskCreate__content__title-placeholder--noproject');

					placeholder_default.toggleClass('ws-utility-hidden', no_project);
					placeholder_project.toggleClass('ws-utility-hidden', !no_project);
				},
			},

			parent: {
				group: 'header',
				init: function() {
					self.obj_window.find('[data-container=parent]').on('click', function (e, data) {
						if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							self.obj_window.find('[data-container=parent]').html(App.helper.template.fill('task_create_parent_empty'));
						} else {
							App.controls.task_select_and_go.show_context(data?.anchor || this, self.obj_window.attr('ajax-action'), {
								request: {type: 'create'},
								onload: function() {
									let menu = $(this);
									App.controls.menu.init(menu);
									$(this).on('click', '.menu__item', function() {
										self.components.parent.callback.call(this);
										App.menu.hide();
									})
								},
								backup: data?.backup || false,
							});
						}
					});
					const project_ids = self.components.project.get_ids();
					if (project_ids.length < 1 || project_ids.length > 1) {
						self.obj_window.find('[data-container=parent]').hide().html(App.helper.template.fill('task_create_parent_empty'));
					}
				},
				callback: function () { // this = menu__item
					self.components.parent.set({
						name: $(this).find('.in').text(),
						url: $(this).attr('data-url'),
						id: $(this).attr('data-id'),
						icon: $(this).find('task-stage').html(),
					});
					App.menu.hide();
					App.controls.user_select_and_go.team(self.helper_user_endpoint('team'), self.components.team.callback);
					return false;
				},
				set: function ({name, url, id, icon}) {
					self.obj_window.find('[data-container=parent]').html(App.helper.template.fill('task_create_parent', {
						name,
						url,
						id,
						icon,
					}));
				},
				get: function () {
					let parent = self.obj_window.find('[data-container=parent]');
					let id = parent.find('input')?.val()?.toInt();

					return {
						id: id,
					};
				}
			},

			team: {
				callback: function(ids) {
					let id_user_to = self.components.assignee.get_id();
					if (id_user_to>= App.config.real_user_id && !ids.includes(id_user_to)) self.obj_window.find('[data-container=assignee]').html(App.helper.template.fill('task_create_assignee_empty'));
					let ids_subscribe = self.obj_window.find('input[name=ids_subscribe]').val().toIntArray();
					let seen_dom = {};
					self.obj_window.find('[data-container=subscribers]').find('.taskCreate__subscribers__item').each(function() {
						let id = $(this).attr('data-id').toInt();
						if (!ids.includes(id) || seen_dom[id]) $(this).remove();
						else seen_dom[id] = true;
					}).end().trigger('draw_more');
					let seen_ids = {};
					ids_subscribe = ids_subscribe.filter(function(id) {
						if (!ids.includes(id) || seen_ids[id]) return false;
						seen_ids[id] = true;
						return true;
					});
					self.components.team.set({ids:ids_subscribe});
				},
				set: function({ids}) {
					self.obj_window.find('input[name=ids_subscribe]').val(ids.join(','));
				},
				get: function() {
					return {
						ids: self.obj_window.find('input[name=ids_subscribe]').val().toIntArray()
					};
				}
			},

			assignee: {
				init: function() {
					self.obj_window.find('[data-container=assignee]').on('click', function(e, data) {
						if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							self.components.assignee.clear();
						} else {
							let ids_project = self.components.project.get_ids();
							let request = {
								type: 'assign',
								select_user_format: 'FLD_LL_F',
								id_toggle_search_bookmarks: 'task_create',
							}
							if (ids_project.length > 1) request.ids_project = ids_project.join(',');
							let hidden = self.obj_window.find('input[name=hidden]').val().toIntArray();
							let filter_by_hidden = hidden.length && !self.components.visibility.is_me_mode();
							if (self.components.visibility.is_required() && self.components.visibility.is_auto_required_hidden(hidden)) {
								filter_by_hidden = false;
							}
							if (filter_by_hidden) request.hidden = hidden.join(',');
							if (self.components.assignee.get_ids().length > 1 || data?.multi) {
								request.multiple = 1;
								const ids = self.components.assignee.get_ids();
								App.controls.user_select_and_go.show_context(this, self.helper_user_endpoint(), {
									request,
									onload: function() {
										let menu = $(this);
										App.controls.menu.init(menu);
										$(this).on('click', '.menu__item, .menu__itemFake', function() {
											self.components.assignee.callback_multiple.call(menu);
										});
									},
									onshow: function() {

										$(this).find('.menu__item[data-id]').each(function() {
											$(this).toggleClass('menu__item-active', ids.includes($(this).attr('data-id').toInt()));
										});
									},
									anchor: data?.anchor || this,
									backup: data?.backup || false,
								});
							} else  {
								request.multiple_enabled = Number(self.components.project.get_ids().length <= 1);

								App.controls.user_select_and_go.show_context(this, self.helper_user_endpoint(), {
									request,
									onload: function() {
										let menu = $(this);
										App.controls.menu.init(menu);
										$(this).on('click', '.menu__item', function() {
											if (!$(this).attr('data-id')) return false;
											self.components.assignee.callback.call(this);
											App.menu.hide();
										}).on('click', '.multi-select', function() {
											App.menu.hide(true);
											self.obj_window.find('[data-container=assignee]').eq(0).trigger('click', [{multi:true}]);
										});
									},
									anchor: data?.anchor || this,
									backup: data?.backup || false,
								});
							}

						}
					});
				},
				callback_multiple: function () { // this = menu
					let btn_counter = self.obj_window.find('.taskCreate__buttons .btn-primary i');
					self.obj_window.find('[data-container]').removeClass('require').removeAttr('data-title');
					let o = $(this).find('.menu__item-active');
					if (o.length === 0) { // none selected fallback
						btn_counter.html('');
						self.components.assignee.clear();
						return false;
					}
					if (o.length === 1) { // single selected fallback
						btn_counter.html('');
						self.components.assignee.callback.call(o.get(0));
						return false;
					}
					let ids = [];
					o.each(function() {
						ids.push($(this).attr('data-id'));
					});
					self.obj_window.find('[data-container=assignee]').html(App.helper.template.fill('task_create_assignee_multiple', {
						name: App.format.quantity(ids.length, App.object_state.locale['tasks'], QTY_WITH_TEXT),
						ids: ids.join(','),
						icon: '<ws-icon name="person" class="test"></ws-icon>'
					}));
					btn_counter.html(ids.length > 1 ? `(${ids.length})` : '');
					self.context_menu?.emit('task_context_menu.component.selected', 'assignee')
					self.obj_window.trigger('change');
					self.components.refresh();
					return false;
				},
				clear: function () {
					self.obj_window.find('[data-container=assignee]').html(App.helper.template.fill('task_create_assignee_empty'));
					self.obj_window.find('.taskCreate__buttons .btn-primary i').html('');
					self.obj_window.find('input[name=ids_subscribe]').val('');
					self.obj_window.find('input[name=ids_assignee]').val('')
					if (self.components.visibility.is_required()) {
						self.components.visibility.preset('me');
					} else {
						self.components.visibility.apply_preset(0);
					}
					self.context_menu?.emit('task_context_menu.component.cleared', 'assignee')
					self.obj_window.trigger('change');
					self.components.refresh();
				},
				callback: function() { // this = menu__item
					let user_name = $(this).find('.in');
					let id_user_to = $(this).attr('data-id').toInt();
					let ids_subscribe = self.obj_window.find('input[name=ids_subscribe]').val().toIntArray();
					if (id_user_to > 1) {
						self.obj_window.find('[data-container=assignee]').html(App.helper.template.fill('task_create_assignee', {
							name: user_name.attr('data-select-name') ? user_name.attr('data-select-name') : user_name.text(),
							avatar: $(this).find('.av_sm').get(0).outerHTML,
							id: $(this).attr('data-id'),
						}));
						self.context_menu?.emit('task_context_menu.component.selected', 'assignee')
					} else {
						self.components.assignee.clear();
					}
					self.obj_window.trigger('change');

					if (id_user_to>= App.config.real_user_id) {
						let $subscribers_in = self.obj_window.find('[data-container=subscribers]').find('.in');
						let already_in_dom = $subscribers_in.find('.taskCreate__subscribers__item[data-id="' + id_user_to + '"]').length > 0;
						if (!ids_subscribe.includes(id_user_to)) {
							ids_subscribe.push(id_user_to);
							self.obj_window.find('input[name=ids_subscribe]').val(ids_subscribe.join(',')); // hello component?
						}
						if (!already_in_dom) {
							$subscribers_in.append(App.helper.template.fill('task_create_subscriber', {
								name: $(this).find('.in').text(),
								avatar: $(this).find('.av_sm').get(0).outerHTML,
								id: $(this).attr('data-id'),
							})).end().trigger('draw_more');
							self.context_menu?.emit('task_context_menu.component.selected', 'assignee')
						}
					}
					self.components.visibility.apply_preset(id_user_to);

					if (App.modal.is_shown() && App.modal.obj_window.find('.modal-setDateOnCreate, #dateend_div').length) {
						if (App.controls.task_terms_on_create && App.controls.task_terms_on_create.saved_params) {
							App.controls.task_terms_on_create.saved_params.id_user_to = id_user_to || 0;
							App.modal.reload();
						}
					}

					self.components.refresh();
				},
				get_id: function() {
					return self.obj_window.find('input[name=id_user_to]').length ? self.obj_window.find('input[name=id_user_to]').val().toInt() : 0;
				},
				get_ids: function() {
					return self.obj_window.find('input[name=ids_assignee]').length ? self.obj_window.find('input[name=ids_assignee]').val().toIntArray() : [self.components.assignee.get_id()];
				},
				set_me: function () {
					let me = self.obj_wrapper.find('.assignee_me').html();
					self.obj_window.find('[data-container=assignee]').html(me).attr('data-title', App.object_state.locale['assignee']);
				},
				set: function ({name, avatar, id}) {
					self.obj_window.find('[data-container=assignee]').html(App.helper.template.fill('task_create_assignee', {
						name,
						avatar,
						id,
					}));
					self.obj_window.trigger('change');
					self.components.refresh();
				},
				is_selected: function() {
					return self.components.assignee.get_ids().length > 0 && !!self.components.assignee.get_ids()[0];
				}
			},

			terms: {
				init: function() {
					self.obj_window.find('[data-container=terms]').on('click', function(e, data) {
						self.context_menu?.close();
						if (false && $(this).find('.data_place').length) {
							App.menu.show({
								anchor: data?.anchor || this,
								box: '#taskCreate__menu__terms_preset',
								backup: data?.backup || false,
							});
						} else if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							self.obj_window.find('[data-container=terms]').html(App.helper.template.fill('task_create_terms_empty'));
							self.obj_window.find('[data-container=terms_inputs] input').each(function(num, el) {
								el.value = el.getAttribute('data-default');
							});
							self.components.refresh();
						} else {
							self.components.terms.showTerms();
						}
					});
					self.obj_window.find('[data-container=terms_inputs] input').each(function(num, el) {
						el.setAttribute('data-default', el.value);
					});
				},
				clear: function () {
					self.components.terms.callback({})
				},
				showTerms: function(tab) {
					let params = {}
					tab ||= 0;
					let ids = self.components.project.get_ids();
					params.is_allow_repeat = ids.length <= 1 ? 1 : 0;
					if (ids.length === 1)	{
						params.id_project = ids.pop();
						params.is_mass = 0;
						params.id_parent = self.obj_window.find('[data-container=parent]').find('input').length ? self.obj_window.find('[data-container=parent]').find('input').val() : false;
					}
					else
					{
						params.is_mass = 1;
						params.id_parent = 0;
						params.id_project = 0;
					}
					let id_user_to = self.components.assignee.get_id();
					if (id_user_to) {
						params.id_user_to = id_user_to;
					}
					App.controls.task_terms_on_create.show(self.obj_window.find('[data-container=terms_inputs]'), tab, params, self.components.terms.callback);
				},
				preset: function (dateend, timeend) {
					let data = {
						dateend: dateend,
						datestart: '',
						timeend: timeend,
						timestart: '',
					}
					self.obj_window.find('[data-container=terms]').html(App.helper.template.fill('task_create_terms', {
						terms: App.format.terms_from_inputs_data(data),
					}));
					self.obj_window.find('[data-container=terms_inputs] input[name=dateend]').val(dateend);
					self.obj_window.find('[data-container=terms_inputs] input[name=timeend]').val(timeend);
					self.obj_window.find('[data-container=terms_inputs] input[name=is_term]').val(1);
				},
				callback: function(data) {
					if (data.dateend) {
						self.obj_window.find('[data-container=terms]').html(App.helper.template.fill('task_create_terms', {
							terms: App.format.terms_from_inputs_data(data),
							is_repeat: data.is_repeat
						}));
						self.context_menu?.emit('task_context_menu.component.selected', 'terms')
					} else {
						self.obj_window.find('[data-container=terms]').html(App.helper.template.fill('task_create_terms_empty'));
						self.context_menu?.emit('task_context_menu.component.cleared', 'terms')
					}
					App.modal.hide();
					self.obj_window.trigger('change');
					self.components.refresh();
				},
				set: function (data) {
					if (!data.empty) {
						self.obj_window.find('[data-container=terms]').html(App.helper.template.fill('task_create_terms', data));
					} else {
						self.obj_window.find('[data-container=terms]').html(App.helper.template.fill('task_create_terms_empty'));
					}
				},
				is_selected: function() {
					const datestart = self.obj_window.find('[data-container=terms_inputs] input[name=datestart]').val();
					const dateend = self.obj_window.find('[data-container=terms_inputs] input[name=dateend]').val();

					return Boolean(datestart || dateend);
				}
			},

			stage: {
				init: function() {
					self.obj_window.find('[data-container=stage]').on('click', function(e, data) {

						if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							self.components.stage.callback_delete();
						} else {
							App.controls.project_task_stage_and_go.show_context(data?.anchor || this, App.helper.url.add_query(self.obj_window.attr('ajax-action'), App.actions.get('project_task_stage_and_go:show'), {new_task:true,from:'task_create'}), {
								onload: function() {
									$(this).on('click', '.menu__item', function() {
										self.components.stage.callback.call(this);
										App.menu.hide();
									})
								},
								backup: data?.backup || false,
							});
						}
					});
				},
				clear: function () {
					self.components.stage.callback_delete();
				},
				on_show: function () {
					self.obj_window.find('[data-container=stage]').click();
				},
				callback: function() { // this = menu__item
					self.components.stage.set({
						name: $(this).find('.flex_content').text(),
						color: $(this).attr('data-color'),
						id: $(this).attr('data-id'),
						icon: $(this).children().first().prop('outerHTML'),
					});
					let o = $(this).find('.av_pre');
					if (o.length && App.helper.user.get_id_user_assignee_on_create(o.attr('data-id'))) {
						self.components.assignee.set({
							name: o.attr('data-name'),
							avatar: o.html(),
							id: o.attr('data-id'),
						});
					}
					return false;
				},
				callback_delete: function() {
					self.obj_window.find('[data-container=stage]').html(App.helper.template.fill('task_create_stage_empty'));
					self.components.refresh();
					self.context_menu?.emit('task_context_menu.component.cleared', 'stage')
				},
				set: function({id, name, color, icon}) {
					self.obj_window.find('[data-container=stage]').html(App.helper.template.fill('task_create_stage', {
						name,
						color,
						id,
						icon,
					}));
					self.obj_window.trigger('change');
					self.components.refresh();
					self.context_menu?.emit('task_context_menu.component.selected', 'stage')
				},
				get: function () {
					const component = self.obj_window.find('[data-container=stage]');
					return {
						id: component.find('input').length ? component.find('input').val().toInt() : 0,
					};
				},
				is_selected: function() {
					return self.components.stage.get()?.id > 0;
				}
			},

			labels: {
				init: function() {
					self.obj_window.find('[data-container=labels]').on('click', function(e, data) {
						data ||= {}
						if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							self.components.labels.callback_delete();
						} else {
							App.controls.project_task_labels_and_go.show_context(data?.anchor || this, App.helper.url.add_query(self.obj_window.attr('ajax-action'), App.actions.get('project_task_labels_and_go:show')), {
								onload: function() {
								},
								onshow: function() {
									// let menu = $(this);
									// menu.off('after_interaction.unique').on('after_interaction.unique', function() {
									// 	self.components.labels.callback.call(menu);
									// });
									$(this).find('.editBlock__picker__item').remove();
									let ids = self.obj_window.find('[data-container=labels]').find('input').length ? self.obj_window.find('[data-container=labels]').find('input').val().split(',').map(Number) : []
									$(this).find('.menu__item[data-id]').removeClass('menu__item-picked').filter(function() {
										return ids.includes($(this).attr('data-id').toInt());
									}).trigger('preset');
								},
								onhide: function() {
									let menu = $(this);
									self.components.labels.callback.call(menu);
								},
								backup: data?.backup || false,
							});
						}
					});
				},
				clear: function () {
					self.components.labels.callback_delete();
				},
				on_show: function () {
					self.obj_window.find('[data-container=labels]').click();
				},
				callback: function() { // this = menu
					let o = $(this).closest('.menu').find('.menu__item-picked');
					if (o.length === 0) { // none selected fallback
						self.components.labels.callback_delete();
						return false;
					}
					let ids = [], tags = [];
					o.each(function() {
						let id_tag = $(this).attr('data-id');
						ids.push(id_tag);
						tags.push({
							name: App.tags[id_tag].name,
							color: App.tags[id_tag].color,
						});
					});
					self.obj_window.find('[data-container=labels]').html(App.helper.template.fill('task_create_labels', {
						name: App.format.quantity(ids.length, App.object_state.locale['labels'], QTY_WITH_TEXT),
						ids: ids.join(','),
						tags
					}));
					self.obj_window.trigger('change');
					self.context_menu?.emit('task_context_menu.component.selected', 'labels')
					self.components.refresh();
					return false;
				},
				callback_delete: function() {
					self.obj_window.find('[data-container=labels]').html(App.helper.template.fill('task_create_labels_empty'));
					self.components.refresh();
					self.context_menu?.emit('task_context_menu.component.cleared', 'labels')
				},
				set: function ({ids}) {
					if (!ids.length) {
						return self.components.labels.callback_delete();
					}
					const tags = ids.map(id => ({
						name: App.tags[id].name,
						color: App.tags[id].color,
					}));
					self.obj_window.find('[data-container=labels]').html(App.helper.template.fill('task_create_labels', {
						name: App.format.quantity(ids.length, App.object_state.locale['labels'], QTY_WITH_TEXT),
						ids: ids.join(','),
						tags
					}));
					self.obj_window.trigger('change');
					self.components.refresh();
				},
				is_selected: function() {
					const tags = self.obj_window.find('[data-container=labels] input[name=tags]').val() ?? '';
					return Boolean(tags);
				}
			},

			priority: {
				init: function() {
					self.obj_window.find('[data-container=priority]').on('click', function(e, data) {
						App.controls.priority.open(this, data, self.components.priority.callback);
					});
				},
				on_show: function () {
					self.obj_window.find('[data-container=priority]').click();
				},
				callback: function() {
					self.components.priority.set({
						priority: $(this).attr('data-id').toInt(),
						num: $(this).find('span').first().text()
					})
				},
				clear: function() {
					self.components.priority.set({
						priority: 1,
						num: '',
					});
				},
				set: function({priority, num}) {
					if (priority === 1) {
						self.obj_window.find('[data-container=priority]').html(App.helper.template.fill('task_create_priority_empty'));
						self.context_menu?.emit('task_context_menu.component.cleared', 'priority')
					} else {
						self.obj_window.find('[data-container=priority]').html(App.helper.template.fill('task_create_priority', {
							priority,
							num
						}));
						self.context_menu?.emit('task_context_menu.component.selected', 'priority')
					}
					self.obj_window.trigger('change');
					self.components.refresh();
				},
				is_selected: function() {
					const priority = self.obj_window.find('[data-container=priority] input[name=important]').val().toInt();
					return priority !== 1;
				}
			},

			limits: {
				init: function() {
					self.obj_window.find('[data-container=limits]').on('click', function (e) {
						if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							self.components.limits.callback_delete();
						} else {
							self.context_menu?.close();
							let max_time = self.obj_window.find('[data-container=limits]').find('input[name=max_time]').length ? self.obj_window.find('[data-container=limits]').find('input[name=max_time]').val() : '';
							let max_money = self.obj_window.find('[data-container=limits]').find('input[name=max_money]').length ? self.obj_window.find('[data-container=limits]').find('input[name=max_money]').val() : '';
							App.controls.task_limits_select_and_go.show(self.helper_limits_endpoint(), {
								onload: function () { // this = App.modal.obj_window
									$(this).find('input[name=max_time]').val(max_time).trigger('keyup');
									$(this).find('input[name=max_money]').val(max_money).trigger('keyup');
								},
								onsuccess: self.components.limits.callback
							});
						}
					});
				},
				callback: function() { // this = App.modal.obj_window
					let max_time = $(this).find('input[name=max_time]').length ? $(this).find('input[name=max_time]').val() : '';
					let max_money = $(this).find('input[name=max_money]').length ? $(this).find('input[name=max_money]').val() : '';
					self.components.limits.set({
						max_time: max_time,
						max_money: max_money,
					});
					App.modal.hide({force: true});
					self.obj_window.trigger('change');
					self.components.refresh();
				},
				callback_delete: function() {
					self.obj_window.find('[data-container=limits]').html(App.helper.template.fill('task_create_limits_empty'));
					self.components.refresh();
					self.context_menu?.emit('task_context_menu.component.cleared', 'limits')
				},
				clear: function() {
					self.components.limits.callback_delete();
				},
				set: function({max_time, max_money}) {
					if (!max_time && !max_money) {
						self.obj_window.find('[data-container=limits]').html(App.helper.template.fill('task_create_limits_empty'));
						self.context_menu?.emit('task_context_menu.component.cleared', 'limits')
					} else {
						self.obj_window.find('[data-container=limits]').html(App.helper.template.fill('task_create_limits', {
							max_time,
							max_money,
						}));
						self.context_menu?.emit('task_context_menu.component.selected', 'limits')
					}
				},
				is_selected: function() {
					const max_time = self.obj_window.find('[data-container=limits] input[name=max_time]').val() ?? '';
					const max_money = self.obj_window.find('[data-container=limits] input[name=max_money]').val() ?? '';
					return Boolean(max_time || max_money);
				}
			},

			subscribers: {
				canBeRemoved: false,
				group: 'footer',
				hasCounter: true,
				init: function() {
					self.obj_window.find('[data-container=subscribers]').on('click', function(e, data) {
						let ids_project = self.components.project.get_ids();
						let ids = self.obj_window.find('input[name=ids_subscribe]').val().toIntArray();
						let request = {type: 'subscribers'}
						if (ids_project.length > 1) request.ids_project = ids_project.join(',');
						let hidden = self.obj_window.find('input[name=hidden]').val().toIntArray();
						if (hidden.length) request.hidden = hidden.join(',');
						App.controls.user_select_and_go.show_context(data?.anchor || this, self.helper_user_endpoint(), {
							backup: data?.backup || false,
							request,
							type: 'left',
							last_value_target: self.obj_window.find('[data-container=subscribers]'),
							onload: function () {
								App.controls.menu.init($(this));
							},
							onshow: function() {
								let menu = $(this);
								menu.off('click.app.subscribers_menu.done', '.menu__group-head ws-btn').on('click.app.subscribers_menu.done', '.menu__group-head ws-btn', () => {
									self.components.subscribers.callback.call(menu);
									App.menu.hide();
								});
								menu.find('.menu__item[data-id]').each(function() {
									$(this).toggleClass('menu__item-active', ids.includes($(this).attr('data-id').toInt()));
								});
								menu.trigger('after_interaction');
							}
						});
					}).bind('draw_more', function() {
						$(this).find('.more').remove();
						let cnt = $(this).find('.taskCreate__subscribers__item').length;
						if (cnt > 6) $(this).find('.in').append('<span class="more">+' + (cnt - 5) + '</span>');
						else $(this).find('.in').append('<span class="more">+</span>');
					});
				},
				callback: function () { // this = menu
					let o = $(this).find('.menu__item-active');
					let ids = [], html = [];
					o.each(function() {
						ids.push($(this).attr('data-id'));
						html.push(App.helper.template.fill('task_create_subscriber', {
							name: $(this).find('.in').text(),
							avatar: $(this).find('.av_sm').get(0).outerHTML,
							id: $(this).attr('data-id'),
						}));
					});
					self.components.subscribers.set({
						ids: ids,
						html: html
					});
					if (ids.length > 0) {
						self.context_menu?.emit('task_context_menu.component.selected', 'subscribers', {
							counter: ids.length
						})
					} else {
						self.context_menu?.emit('task_context_menu.component.cleared', 'subscribers')
					}
					return false;
				},
				set: function({ids, html}) {
					self.obj_window.find('[data-container=subscribers]').find('.in').html(html.join('')).end().trigger('draw_more');
					self.obj_window.find('input[name=ids_subscribe]').val(ids.join(','));
					self.obj_window.trigger('change');
				},
				get: function() {
					return {
						ids: self.obj_window.find('input[name=ids_subscribe]').val()?.toIntArray()
					}
				},
				hideContainer: function() {
					self.obj_window.find('[data-container=subscribers]').hide();
				},
				showContainer: function() {
					self.obj_window.find('[data-container=subscribers]').show();
				},
				is_selected: function() {
					return self.components.subscribers.get()?.ids.length > 0;
				},
				counter: function() {
					return self.components.subscribers.get()?.ids.length;
				},
			},

			visibility: {
				group: 'footer',
				get_preset: function() {
					return self.obj_window.attr('data-visibility-preset') || '';
				},
				set_preset: function(type) {
					if (type) self.obj_window.attr('data-visibility-preset', type);
					else self.obj_window.removeAttr('data-visibility-preset');
				},
				is_required: function() {
					return self.obj_window.find('[data-container=hidden]').hasClass('require');
				},
				is_me_mode: function() {
					if (self.components.visibility.get_preset() === 'me') return true;
					let hidden = self.obj_window.find('input[name=hidden]').val().toIntArray();
					return hidden.length === 1 && hidden[0] === App.me.id;
				},
				is_auto_required_hidden: function(hidden) {
					if (!self.components.visibility.is_required()) return false;
					hidden = hidden || self.obj_window.find('input[name=hidden]').val().toIntArray();
					let id_to = self.components.assignee.get_id();
					let auto = [App.me.id];

					if (id_to >= App.config.real_user_id) auto.push(id_to);
					return hidden.length > 0 && hidden.every(function(id) {
						return id > 0 && auto.includes(id);
					});
				},
				apply_preset: function(id_user_to) {
					const can_apply = self.components.visibility.is_me_mode() || (self.components.visibility.is_required() && self.components.visibility.is_auto_required_hidden());
					if (!can_apply) return;

					let hidden = [App.me.id];
					if (id_user_to >= App.config.real_user_id && id_user_to !== App.me.id) hidden.push(id_user_to);
					self.components.team.callback(hidden);
					self.components.visibility.set(hidden, []);
				},
				init: function() {
					self.obj_window.find('ws-btn.hidden, ws-btn.hidden_remove').on('click', function(e, data) {
						if (!self.obj_window.find('input[name=hidden]').val() && !self.obj_window.find('input[name=guests]').val()) {
							App.menu.show({
								anchor: data?.anchor || this,
								box: '#taskCreate__menu__visibility_preset',
								backup: data?.backup || false,
								replace: data?.replace || false,
							});
						} else {
							let ids_project = self.components.project.get_ids();
							let request = {type: 'visibility'};
							if (ids_project.length > 1) request.ids_project = ids_project.join(',');
							App.controls.visibility_switch_and_go.show_context(data?.anchor || this, self.helper_user_endpoint(), {
								request,
								backup: data?.backup || false,
								replace: data?.replace || false,
								onload: function () {
									App.controls.menu.init_toggle_search_chosen($(this));
								},
								onshow: function () {
									let menu = $(this);
									menu.off('click.app.visibility_menu.done', '.menu__group-head ws-btn').on('click.app.visibility_menu.done', '.menu__group-head ws-btn', () => self.components.visibility.callback.call(menu));
									menu.off('click.app.visibility_menu.clear', '.menu__group-buttons ws-btn').on('click.app.visibility_menu.clear', '.menu__group-buttons ws-btn', function() {
										App.menu.hide();
										self.components.visibility.callback_delete();
									});
									let hidden = self.obj_window.find('input[name=hidden]').val().toIntArray();
									let guests = self.obj_window.find('input[name=guests]').val().toIntArray();
									let hidden_defaults = [App.me.id, self.components.assignee.get_id()];
									menu.find('.menu__group[data-group]').each(function () {
										let id_group = $(this).attr('data-group').toInt();
										$(this).find('.menu__item[data-id]').each(function () {
											let id_user = $(this).attr('data-id').toInt();
											let is_active;
											if (hidden.length) {
												is_active = hidden_defaults.includes(id_user) || hidden.includes(id_user) || (hidden.includes(-id_group) && (!$(this).hasClass('menu__item-guest') || guests.includes(id_user)))
											} else {
												is_active = !$(this).hasClass('menu__item-guest') || guests.includes(id_user) || hidden_defaults.includes(id_user)
											}
											$(this).toggleClass('menu__item-active', is_active).toggleClass('menu__item-default', hidden_defaults.includes(id_user));
										});
									});
									menu.find('.menu__group-buttons').toggle(!self.components.visibility.is_required());
								},
								onhide: function() {
									self.components.visibility.on_menu_hide();
								},
							});
						}
					});
					if (self.components.visibility.is_required() && self.components.visibility.is_auto_required_hidden()) {
						self.components.visibility.set_preset('me');
					}
				},
				show: function(params) {
					self.obj_window.find('ws-btn.hidden').trigger('click', { backup: true, ...(params || {}) });
				},
				show_custom: function(anchor) {
					self.components.visibility.set_preset('custom');

					let ids_subscribe = self.obj_window.find('input[name=ids_subscribe]').val().toIntArray();
					if (!ids_subscribe.includes(App.me.id)) ids_subscribe.push(App.me.id);
					self.obj_window.find('input[name=hidden]').val(ids_subscribe.join(','));
					self.components.visibility.show({ anchor, replace: true, backup: false });
				},
				preset: function(type) {
					App.menu.hide();
					self.components.visibility.set_preset(type);

					let hidden = [];
					let id_user_to = self.components.assignee.get_id();
					switch (type) {
						case 'department':
							App.controls.user_select_and_go.team(self.helper_user_endpoint('team') + '&preset=department', function(ids) {
								hidden = ids;
								if (id_user_to>= App.config.real_user_id && !ids.includes(id_user_to)) {
									hidden.push(id_user_to);
									ids.push(id_user_to);
								}
								self.components.team.callback(ids);
								self.components.visibility.set(hidden, []);
							});
							break;
						case 'team':
							hidden.push(-App.me.id_group);
							App.controls.user_select_and_go.team(self.helper_user_endpoint('team') + '&preset=team', function(ids) {
								if (id_user_to>= App.config.real_user_id && !ids.includes(id_user_to)) {
									hidden.push(id_user_to);
									ids.push(id_user_to);
								}
								self.components.team.callback(ids);
								self.components.visibility.set(hidden, []);
							});
							break;
						case 'me':
						default:
							hidden.push(App.me.id);
							if (id_user_to>= App.config.real_user_id && id_user_to !== App.me.id) hidden.push(id_user_to);
							self.components.team.callback(hidden);
							self.components.visibility.set(hidden, []);
					}
				},
				callback: function() { // this = menu
					let hidden = [];
					let guests = [];
					$(this).find('.menu__group[data-group]').each(function () {
						let id_group = $(this).attr('data-group').toInt();
						if (!$(this).find('.menu__item[data-id]').not('.menu__item-guest').not('.menu__item-active').length) {
							hidden.push(-id_group);
							$(this).find('.menu__item-guest[data-id].menu__item-active').each(function () {
								hidden.push($(this).attr('data-id').toInt());
							});
						} else {
							$(this).find('.menu__item-active[data-id]').each(function () {
								hidden.push($(this).attr('data-id').toInt());
							})
						}
					});
					$(this).find('.menu__item-guest.menu__item-active').each(function() {
						guests.push($(this).attr('data-id').toInt());
					});

					self.components.visibility.set_preset('');
					self.components.visibility.set(hidden, guests);
					App.menu.hide();
				},
				on_menu_hide: function() {
					if (self.components.visibility.get_preset() !== 'custom') return;
					let hidden = self.obj_window.find('input[name=hidden]').val().toIntArray();
					if (hidden.length !== 1 || hidden[0] !== App.me.id) return;

					// clear but no emit
					self.components.visibility.set_preset('');
					self.components.visibility._set([], []);
				},
				callback_delete: function() {
					self.components.visibility.set_preset('');
					self.components.visibility.set([], []);
				},
				clear: function() {
					self.components.visibility.callback_delete();
				},
				_set: function(hidden, guests) {
					self.obj_window.find('input[name=is_hidden]').val(hidden.length ? 1 : 0);
					self.obj_window.find('input[name=hidden]').val(hidden.join(','));
					self.obj_window.find('input[name=guests]').val(guests.join(','));
					if (hidden.length) self.obj_window.find('ws-btn.hidden').hide().next().show();
					else self.obj_window.find('ws-btn.hidden').show().next().hide();
					self.obj_window.trigger('change');
				},
				set: function(hidden, guests) {
					self.components.visibility._set(hidden, guests);
					if (hidden.length) {
						self.context_menu?.emit('task_context_menu.component.selected', 'visibility')
					} else {
						self.context_menu?.emit('task_context_menu.component.cleared', 'visibility')
					}
				},
				hideContainer: function() {
					self.obj_window.find('[data-container=hidden]').hide();
				},
				showContainer: function() {
					self.obj_window.find('[data-container=hidden]').show();
				},
				is_selected: function() {
					const hidden = self.obj_window.find('input[name=hidden]').val();
					return Boolean(hidden);
				}
			},

			mass: {
				init: function() {
					self.obj_window.find('[data-container=mass]').on('click', function (e) {

						let texts = [self.obj_window.find('[name=name]').val(), ''];
						const id_project = self.components.project.get_ids().length > 1 ? null : self.components.project.get_ids()[0];
						const id_parent = self.components.parent.get().id;

						if (self.has_not_saved_state()) {

							App.controls.confirm.menu(e.target, {
								message: App.object_state.locale['ask_delete_draft'],
								ok_label: App.object_state.locale['yes_delete'],
								cancel_label: App.object_state.locale['no_continue'],
								onconfirm: function() {
									self.state_saved = self.state_noticed = null;
									self.hide_and_delete();
									App.task_create.open_mass(texts, {id_project, id_parent});
								},
								oncancel: function() {
									self.minimize();
									App.task_create.open_mass(texts);
								}
							});

							return;
						}

						App.task_create.open_mass(texts, {id_project, id_parent});
					});
				},
			},
		},

		helper_user_endpoint: function(type) {
			type ||= 'show';
			if (self.obj_window.find('[data-container=parent]').find('input').length) { // no parent
				return App.helper.url.add_query(self.obj_window.find('[data-container=parent]').find('input').attr('data-url'), App.actions.get('task_user_select_and_go:' + type));
			} else {
				return App.helper.url.add_query(self.obj_window.attr('action'), App.actions.get('user_select_and_go:' + type));
			}
		},

		helper_limits_endpoint: function() {
			if (self.obj_window.find('[data-container=parent]').find('input').length) { // no parent
				return App.helper.url.add_query(self.obj_window.find('[data-container=parent]').find('input').attr('data-url'), App.actions.get('task_limits_select_and_go:show'), { autofocus: true });
			} else {
				return App.helper.url.add_query(self.obj_window.attr('ajax-action'), App.actions.get('project_limits_select_and_go:show'), { autofocus: true });
			}
		},

		init_scroll_zones: function() {
			self.obj_window.find('.scrollZone').not('.ps').each(function() {
				this.scrollBars = App.controls.js_scrollbars.init(this);
			});
		},

		destroy_scroll_zones: function() {
			self.obj_window.find('.scrollZone').filter(function() {
				return !$(this).closest('.menu').length;
			}).each(function() {
				if (this.scrollBars) this.scrollBars.destroy();
			});
		},

		// scroll_to_editor_if_needed: function () {
		// 	self.obj_window.find('.mobile-head').css('marginBottom', '');
		// 	const editor_wrapper_el = self.obj_window.find('.taskCreate__content__editor-wrapper').has(document.activeElement);
		// 	if (!editor_wrapper_el.length) return;
		//
		// 	self.obj_window.find('.mobile-head').css(
		// 		'marginBottom',
		// 		editor_wrapper_el.get(0).getBoundingClientRect().top * -1
		// 		+ self.obj_window.find('.mobile-head').height() + 4
		// 	);
		// },

		// onKeyboardShow: function() {
		// 	if (self.is_shown() && $(window).width() <= APP_SCREEN_THRESHOLD) {
		// 		self.obj_window.css('height', App.helper.viewport.height());
		// 		self.scroll_to_editor_if_needed();
		// 		// self.destroy_scroll_zones();
		// 		// self.init_scroll_zones();
		// 	}
		// },

		// onKeyboardHide: function() {
		// 	if (self.is_shown() && $(window).width() <= APP_SCREEN_THRESHOLD) {
		// 		self.obj_window.css('height', '');
		// 		self.obj_window.find('.mobile-head').css('marginBottom', '');
		// 	}
		// },

		onload: function() {
			self.obj_wrapper = $('#taskCreate__wrapper');
			// App.bus.window
			// 	.on('keyboard_show', self.onKeyboardShow)
			// 	.on('keyboard_hide', self.onKeyboardHide);
		},

		destructor: function() {
			self.shown = false;
			self.window.closed();
			self.obj_window = null;
			self.obj_menus = null;
			self.id = 0;
			self.id_tmp = 0;
			self.title = '';
			self.locale = {};
			self.state_saved = null;
			self.state_noticed = null;
			self.open_in_fullscreen = false;
			self.context_menu = null;
			self.data = {};
		},

		onBoot: function () {
			self.window = App.window.task_create.bind(self);
			self.onload();

			// нахуа ховать? якщо це був кейс з тим, що ламається редактор після модалки, то це треба інакше фіксити
			// поки залишаю як є, бо я в задачі не знайшов чекбокса по цій правці, а Ярік вже на корпоратіві :D
			App.bus.app.on('chat_info_init project_view_show', function () {
				if (self.is_shown()) self.minimize();
			});

			App.bus.app.on('task_create_opened', function () {
				self.components.project.update_placeholder();
			});

			App.bus.msg.on('task_create', function (payload) {
				if (payload.type === 'update') {
					App.task_create_cache.invalidate_by_id(payload.id);
				} else if (payload.type === 'delete' || payload.type === 'publish') {
					if (payload.id === self.id) {
						self.id = 0;
						self.delete();
					} else {
						App.task_create_cache.delete(payload.id);
					}
				}
			});
		},
		onLogout: () => self.destructor(),
	}
})();

App.task_create_cache = {

	data: {},

	exists: function(id) {
		return id in this.data
	},

	pop: function(id) {
		if (id in this.data) return this.data[id];
		return null;
	},

	delete: function(id) {
		if (!this.data[id]) return;
		this.data[id].obj_window.removeWithComponents();
		this.data[id].obj_menus.removeWithComponents();
		delete(this.data[id]);
	},

	push: function(id, task_create) {
		this.data[id] = {
			obj_window: task_create.obj_window,
			obj_menus: task_create.obj_menus,
			id: task_create.id,
			title: task_create.title,
			state: 'open',
			dt_added: new Date()
		}
	},

	replace: function(id_tmp, id) {
		if (!this.data[id_tmp]) return;
		this.data[id] = this.data[id_tmp];
		this.data[id].id = id;
		delete(this.data[id_tmp]);
	},

	set_state(id, state) {
		this.data[id].state = 'state';
	},

	get_all: function(state) {
		let o = $();
		for (let id in this.data) {
			o = o.add(this.data[id].obj_window);
		}
		return o;
	},

	destructor: function() {
		for (let id in this.data) {
			this.delete(id);
		}
	},

	invalidate_all: function() {
		for (let id in this.data) {
			if (id == App.task_create.id && App.task_create.is_shown()) {
				App.task_create.reload();
			} else {
				this.delete(id);
			}
		}
	},

	invalidate_by_id: function(id) {
		if (App.task_create.id === id) App.task_create.reload();
		else App.task_create_cache.delete(id);
	},

	invalidate_by_project: function(id_project) {
		for (let id in this.data) {
			let obj_window = this.data[id].obj_window;
			let ids_project = App.task_create.components.project.get_ids(obj_window);

			if (ids_project.indexOf(id_project) !== -1) {
				if (id == App.task_create.id && App.task_create.is_shown()) {
					App.task_create.reload();
				} else {
					this.delete(id);
				}
			}
		}
	},

	onLogout: () => App.task_create_cache.destructor()
}

;var App = App || {};

(function () {
	let self = App.task_create_mass = {
		obj_window: null,
		shown: false,

		show: function (data) {
			if (self.shown) return;
			self.shown = true;
			data ||= {};
			data['request'] ||= {};
			$.get(App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('task_drafts:show'), data['request']),
				(response) => {
					const window = Node.fromSingle(response)
					document.querySelector('#massTaskCreate__wrapper').setContent(window)
					window.onceLifecycle('disconnected', () => {
						self.shown = false;
						self.obj_window = null;
					});
					window.onceLifecycle('mount:after', () => {
						data.onload?.(window);
					});
					self.obj_window = window;
				}
			).catch(() => {
				self.destructor()
			});

		},
		add_row: function () {
			self.obj_window.insertRow();
		},
		fill_rows: function (...texts) {
			self.obj_window.fillRows(...texts);
		},
		removeRows: function () {
			self.obj_window.removeRows();
		},
		destructor: function () {
			if (self.obj_window) {
				self.obj_window.clear();
				self.obj_window = null;
			}
			self.shown = false;
		},
		onLogout: () => self.destructor(),
	}

})();

;var App = App || {};

(function() {
	let self = App.task_edit = {
		assignee: function (event) {
			let t = $(event.target);

			let a = t.closest('a');
			let author = t.closest('.author');
			let endpoint_to = a.attr('data-to-url');
			let endpoint_from = a.attr('data-from-url');

			if (author.length > 0 && endpoint_from != null && endpoint_from !== '') {
				App.task_edit.user(author.get(0), null, {type: "left", endpoint: endpoint_from, author: true});
			} else if (endpoint_to != null && endpoint_to !== '') {
				App.task_edit.user(a.get(0), null, {type: "left", endpoint: endpoint_to});
			}
		},

		author: function (event) {
			let a = $(event.target).closest('a');
			let endpoint = a.attr('data-url');

			if (endpoint != null && endpoint !== '') {
				App.task_edit.user(a.get(0), null, {type: "left", endpoint: endpoint, author: true})
			}
		},

		user: function(menu_anchor, extendVisibility, params) {
			params ||= {};
			params.field = params.author ? 'id_user_from' : 'id_user_to';
			App.controls.user_select_and_go.show_context(menu_anchor, params.endpoint || null, {
				request: {
					force: extendVisibility || 0,
					type: params.author ? 'author' : 'assignee'
				},
				type: params.type || '',
				backup: params.backup || false,
				replace: params.replace || extendVisibility || false,
				onload: function() {
					let menu = $(this);

					App.controls.menu.init(menu);

					menu.find('.menu__group-head ws-btn, .menu__group-buttons .btn-primary, .menu__group-buttonsConfirm .btn-primary, .menu__group-search .btn-primary, .menu__group-search ws-btn[name~="btn-primary"]').click(function() {
						App.core.form_submit(menu.find('form'));
					});
					menu.find('.menu__item[data-id]').click(function() {
						App.controls.menu.item_set_active_by_id(menu, $(this).attr('data-id'));
						App.controls.menu.process_select_box(menu);
						menu.find('input[name='+params.field+']').val($(this).attr('data-id'));
					});
					App.controls.menu.init_select_box(menu, {
						on_remove: (menu, select_box, placeholder) => {
							const placeholder_item = placeholder.find('.menu__item[data-id]');
							menu.find('input[name='+params.field+']').val(placeholder_item.attr('data-id'));
						}
					});
				},
				onshow: function() {
					let menu = $(this);
					$(this).find('ws-btn input[name=skip_notify]').val('');
					let id = $(this).find('input[name='+params.field+']').length ? $(this).find('input[name='+params.field+']').val() : 0;
					App.controls.menu.item_set_active_by_id(menu, id);
					App.controls.menu.process_select_box(menu, { animate_selectbox: false });
				}
			});
		},

		submit_on_inbox_pick: function(form) {
			if (form.is('[data-inbox-project]')) App.core.form_submit(form);
		},

		priority: function(menu_anchor, params) {
			params ||= {};
			App.controls.user_select_and_go.show_context(menu_anchor, params.endpoint || null, {
				width: 244,
				onload: function() {
					let menu = $(this);
					let form = menu.find('form');
					menu.find('.menu__group-search .btn-primary').click(function() {
						App.core.form_submit(form);
					});
					menu.find('.menu__item[data-id]').click(function() {
						App.controls.menu.item_set_active(this);
						form.find('input[name=important]').val($(this).attr('data-id'));
						self.submit_on_inbox_pick(form);
					})
				},
				onshow: function() {
					$(this).find('ws-btn input[name=skip_notify]').val('');
					let id = $(this).find('input[name=important]').length ? $(this).find('input[name=important]').val() : 0;
					$(this).find('.menu__item').each(function() {
						$(this).toggleClass('menu__item-active', $(this).attr('data-id') == id)
					});
				},
				...params
			});
		},

		stage2: function(menu_anchor, params) {
			self.stage({}, {...params, target: menu_anchor});
		},

		// TODO: fix kostil, make another handler for click to call .stage() (task_edit.click_stage(event))
		stage: function(event, params = {}) {
			const target = $(params.target || event.target);
			const btn = target.closest('ws-btn');
			const menu_anchor = target.closest('a').length ? target.closest('a') : target;

			if (btn.length) return false;

			let url = params.endpoint || $(menu_anchor).attr('data-url');

			App.controls.project_task_stage_and_go.show_context(menu_anchor, url + (params.force ? '&force=1' : ''), {
				type: params.type || '',
				backup: params.backup || false,
				replace: params.replace || false,
				onload: function() {
					let menu = $(this);
					let form = menu.find('form');
					menu.find('.menu__group-search .btn-primary, .menu__group-head button.btn-primary').click(function() {
						App.core.form_submit(form);
					});
					menu.find('.menu__item[data-id]').click(function() {
						App.controls.menu.item_set_active(this);
						form.find('input[name=id_stage]').val($(this).attr('data-id'));
						self.submit_on_inbox_pick(form);
					})
					menu.find('.other_status').click(function() {
						params.replace = true;
						params.force = true;
						App.task_edit.stage(event, params);
					})
				},
				onshow: function() {
					$(this).find('ws-btn input[name=skip_notify]').val('');
					let id = $(this).find('input[name=id_stage]').length ? $(this).find('input[name=id_stage]').val() : 0;
					$(this).find('.menu__item').each(function() {
						$(this).toggleClass('menu__item-active', $(this).attr('data-id') == id);
					});
				}
			});
		},

		stage_fields: function (params) {
			App.modal.show({
				url: params.url,
				width: 480,
				title: params.title,
				onload: function () {
					const modal = $(this);
					modal.find('.btn-primary').on('click', function () {
						App.core.form_submit(modal.find('form'));
					});
				}
			})
		},

		limit_tag_group: null,
		ids_hidden_tags: [],
		tags: function(menu_anchor, params) {
			params ||= {};

			let url = params.endpoint || $(menu_anchor).attr('data-url');

			self.limit_tag_group = $(menu_anchor).is('[data-filter]') ? $(menu_anchor).attr('data-filter') : null;
			App.controls.project_task_labels_and_go.show_context(menu_anchor, url, {
				type: params.type || '',
				backup: params.backup || false,
				replace: params.replace || false,
				onload: function() {
					let menu = $(this);
					menu.find('.menu__group-head .btn-primary').click(function() {
						let ids = self.ids_hidden_tags;
						menu.find('.menu__item-picked').each(function() {
							ids.push($(this).attr('data-id').toInt());
						});
						menu.find('input[name=tags]').val(ids.join(','))
						App.core.form_submit(menu.find('form'));
					});
				},
				onshow: function() {
					self.ids_hidden_tags = [];
					$(this).find('ws-btn input[name=skip_notify]').val('');
					$(this).find('.editBlock__picker__item').remove();
					$(this).find('.menu__group-bottom').removeClass('menu__group-hidden');
					$(this).find('.tagsSingleSelect__group').addClass('menu__group-searchable').removeClass('menu__group-hidden');
					$(this).removeClass('menu-tagSplit menu-tagOnce');

					if (self.limit_tag_group != null) {
						$(this).addClass('menu-tagSplit');

						const is_once = Boolean(App.tags_group[self.limit_tag_group]?.once);
						if (is_once) $(this).addClass('menu-tagOnce');

						$(this).find('.tagsSingleSelect__group').not('[data-group='+self.limit_tag_group+']').removeClass('menu__group-searchable').addClass('menu__group-hidden');
						$(this).find('.menu__group-bottom').addClass('menu__group-hidden').remove();
						let replace_title = '';
						if (is_once) {
							replace_title += $(this).find('.tagsSingleSelect__group[data-group='+self.limit_tag_group+'] .tagsSingleSelect__group__title tags-group-icon').prop('outerHTML') ?? '';
						}
						replace_title += $(this).find('.tagsSingleSelect__group[data-group='+self.limit_tag_group+'] .tagsSingleSelect__group__title span.flex_content:first').html();
						replace_title = replace_title.trim();
						$(this).find('.menu__group-head .checkboxCount').attr('data-default-text', replace_title).html('').append(replace_title);
						$(this).find('.tagsSingleSelect__group__content ws-btn').remove();
						let btn = $(this).find('.tagsSingleSelect__group[data-group=' + self.limit_tag_group + '] .tagsSingleSelect__group__title ws-btn');
						let target = $(this).find('.tagsSingleSelect__group[data-group=' + self.limit_tag_group + '] .tagsSingleSelect__group__content');
						target.append(btn.clone().attr('name', 'btn btn-g btn-24 btn-solid btn-rounded').removeAttr('right-icon').attr('left-icon', 'plus'));
					} else {
						$(this).find('.menu__group-head .checkboxCount')
							.attr('data-default-text', $(this).find('.menu__group-head .checkboxCount').attr('data-basic-text'))
							.html($(this).find('.menu__group-head .checkboxCount').attr('data-basic-text'));
					}
					let ids = $(this).find('input[name=tags]').length ? $(this).find('input[name=tags]').val().split(',').map(Number) : [];
					$(this).find('.menu__item[data-id]').removeClass('menu__item-picked').filter(function() {
						let match = ids.includes($(this).attr('data-id').toInt());
						if (match && self.limit_tag_group != null && $(this).closest('.tagsSingleSelect__group').attr('data-group') != self.limit_tag_group) {
							self.ids_hidden_tags.push($(this).attr('data-id').toInt());
							return false;
						}
						return match;
					}).trigger('preset');

					$(this).find('.tagsSingleSelect__group[data-limited]').each(function() {
						$(this).removeClass('menu__group-searchable').addClass('menu__group-hidden');
					});
				}
			});
		},

		subscribers: function(menu_anchor) {
			let endpoint = $(menu_anchor).closest('[data-url]').attr('data-url');
			if (!App.helper.string.is_str(endpoint)) return;

			App.controls.user_select_and_go.show_context(menu_anchor, endpoint, {
				cache_trigger: 'user,task' + App.task_view.id + ':visibility',
				type: 'left',
				last_value_target: $(menu_anchor).closest('[data-url]'),
				onload: function () {
					let menu = $(this);
					App.controls.menu.init(menu);
					menu.on('click', '.menu__group-head ws-btn', function() {
						let ids = [];
						menu.find('.menu__item-active').each(function() {
							ids.push($(this).attr('data-id').toInt());
						});
						menu.find('input[name=ids_user]').val(ids.join(','))
						App.core.form_submit(menu.find('form'));
						App.menu.hide();
					});
				},
				onshow: function() {
					let ids = [];
					App.comment_form.obj.find('.commentForm__subscribers .commentForm__subscribers__item[data-id]').each(function() {
						ids.push($(this).attr('data-id').toInt());
					});
					$(this).find('.menu__item[data-id]').each(function() {
						$(this).toggleClass('menu__item-active', ids.includes($(this).attr('data-id').toInt()));
					});
					$(this).trigger('after_interaction');
				}
			});
		},

		visibility: function(menu_anchor, params) {
			params ||= {};
			const endpoint = params.url || $(menu_anchor).closest('[data-url]').attr('data-url');
			const task_id = params.task_id || $(menu_anchor).closest('.dataTable__item').attr('data-id') || App.task_view.id;
			App.controls.visibility_switch_and_go.show_context(menu_anchor, endpoint, {
				cache_trigger: 'user,task' + task_id + ':visibility',
				type: params.type || 'left bottom',
				backup: params.backup || false,
				replace: params.replace || false,
				onload: function () {
					let menu = $(this);
					App.controls.menu.init_toggle_search_chosen(menu);

					if (menu.find('input[name=preset]').length) {
						menu.on('click', '.menu__group-head .btn-primary', function () {
							App.core.form_submit(menu.find('form'));
							App.menu.hide();
						});
						menu.on('click', '.menu__item[data-preset]', function () {
							App.controls.menu.item_set_active(this);
							menu.find('input[name=preset]').val($(this).attr('data-preset'));
						});
					} else {
						menu.on('click', '.menu__group-head .btn-primary', function () {
							let hidden = [];
							let guests = [];
							let parent_limited = menu.find('input[name=parent_limited]').val();
							if (menu.find('.menu__item[data-id]').not('.menu__item-guest').not('.menu__item-active').length) {
								menu.find('.menu__group[data-group]').each(function () {
									let id_group = $(this).attr('data-group').toInt();
									if (!parent_limited && !$(this).find('.menu__item[data-id]').not('.menu__item-guest').not('.menu__item-active').length) {
										hidden.push(-id_group);
									} else {
										$(this).find('.menu__item-active[data-id]').each(function () {
											hidden.push($(this).attr('data-id').toInt());
										})
									}
								});
							}
							menu.find('.menu__item-guest.menu__item-active').each(function () {
								guests.push($(this).attr('data-id').toInt());
							});
							if (hidden.join(',') !== menu.find('input[name=hidden]').val() || guests.join(',') !== menu.find('input[name=guests]').val()) {
								menu.find('input[name=hidden]').val(hidden.join(','));
								menu.find('input[name=guests]').val(guests.join(','));
								App.core.form_submit(menu.find('form'));
							}
							App.menu.hide();
						});
						menu.on('click', '.menu__group-buttons ws-btn', function () {
							menu.find('input[name=hidden]').val('');
							menu.find('input[name=guests]').val('');
							App.core.form_submit(menu.find('form'));
							App.menu.hide();
						});
					}
				},
				onshow: function() {
					let menu = $(this);
					if (!menu.find('input[name=preset]').length) {
						let hidden = menu.find('input[name=hidden]').val()?.toIntArray() || [];
						let guests = menu.find('input[name=guests]').val()?.toIntArray() || [];
						let hidden_defaults = menu.find('input[name=hidden_defaults]').val()?.toIntArray() || [];
						menu.find('.menu__group[data-group]').each(function () {
							let id_group = $(this).attr('data-group').toInt();
							$(this).find('.menu__item[data-id]').each(function () {
								let id_user = $(this).attr('data-id').toInt();
								let is_active;
								if (hidden.length) {
									is_active = hidden_defaults.includes(id_user) || hidden.includes(id_user) || (hidden.includes(-id_group) && (!$(this).hasClass('menu__item-guest') || guests.includes(id_user)))
								} else {
									is_active = !$(this).hasClass('menu__item-guest') || guests.includes(id_user) || hidden_defaults.includes(id_user)
								}
								$(this).toggleClass('menu__item-active', is_active).toggleClass('menu__item-default', hidden_defaults.includes(id_user));
							});
						});
					}
				}
			});
		},

		onkeydown: function (key, alt, ctrl, shift, in_input) {
			let active_window = App.core.active_window({menu: true});
			let container = active_window.find('.keyboardZone-active');
			let item = container.find('.selected:visible');
			let letter = String.fromCharCode(key);
			let anchor;

			if (key === App.keycode.Enter && item.length) {
				anchor = item.find('a');
				anchor = anchor.length ? anchor : item.find('.data_place');
				if (anchor.length) {
					anchor.eq(0).click();
					return true;
				}
			}

			if (key === App.keycode.KeyT && App.timer.status && !App.task_view.is_shown()) {
				App.timer_view.show();
				return true;
			}

			if (App.mass.is_shown()) {
				anchor = $('#massdo, .menu-mass-children').find('[data-hotkey="alt-'+ letter +'"]');
				if (anchor.length) {
					anchor.eq(0).click();
					return true;
				}
			}

			if (item.length) {
				anchor = item.find('[data-hotkey="alt-'+ letter +'"]');
				if (anchor.length) {
					anchor.eq(0).click();
					return true;
				}
			}
			if (container.length) { // this may be used for mass operations

			}
			if (App.task_view.is_shown()) {
				anchor = App.task_view.obj_window.find('.taskView__params').find('[data-hotkey="alt-'+ letter +'"]');
				if (anchor.length) {
					anchor.eq(0).click();
					return true;
				}

				anchor = App.task_view.obj_window.find('.taskView__head').find('[data-hotkey="alt-'+ letter +'"]');
				if (anchor.length) {
					if (anchor.eq(0).is('ws-btn[name*=btn-sp-time]') && App.task_view.obj_window.find('.taskView__head .taskView__timer').length) {
						$.ajax({ url: '/ajax/time/?' + App.actions.get('timer_stop:do') });
					} else {
						anchor.eq(0).click();
					}
					return true;
				}
			}
		},
	}
})();

;var App = App || {};


(function() {
let self = App.task_explorer = {
	type: 'tasks',
	obj_window: null,
	sel_terms: {
		'overdue': '2',
		'upcoming': '1',
		'completed': '13',
		// 'new': '99',
	},
	last_scroll_top: 0,
	toggle: function () {
		App.mymenu.toggle({
			type: self.type,
			url: App.helper.url.add_query('/ajax/', App.actions.get('menu_tasks:show') + '&role=0'),
		})
	},
	show: function (filter_params, options) {

		options ||= {};
		if (options === true) {
			console.warn('deprecated, use { dont_cache: true } instead');
			options = { dont_cache: true };
		}

		if (filter_params != null && typeof filter_params === 'string') {
			filter_params = Object.fromEntries([...new URLSearchParams(filter_params)]);
		}

		if (options.preserve_active_tab) {
			filter_params = {
				...filter_params,
				tab: self.get_active_tab()
			};
		}

		App.menu.hide(true);

		App.mymenu.show({
			...options,
			type: self.type,
			url: App.helper.url.add_query('/ajax/', App.actions.get('menu_tasks:show'), filter_params),
			skip_cache: true
		});
	},
	filter: function (filter_params, options) {

		options ||= {};
		if (options === true) {
			console.warn('deprecated, use { dont_cache: true } instead');
			options = { dont_cache: true };
		}

		options.preserve_active_tab = true;
		self.show(filter_params, options);
	},
	load_more: function (filter_params) {
		self.last_scroll_top = self.obj_window.find('.sidePanel__list').scrollTop();
		self.show(filter_params);
	},
	is_shown: function () {
		return App.mymenu.is_shown(self.type)
	},
	hide: function () {
		App.mymenu.hide()
	},
	init: function () {
		if (App.mymenu.obj_window.attr('data-task-explorer') === '1') return;
		App.mymenu.obj_window.attr('data-task-explorer', '1');

		self.obj_window = App.mymenu.obj_window

		// ховаємо таби, якщо він 1 і нема додаткової кнопки справа
		self.obj_window.find('.sidePanel__tabs').toggleClass(
			'ws-utility-hidden',
			(
				self.obj_window.find('.sidePanel__tabs li').not('.ws-utility-hidden').length <= 1
				&& !self.obj_window.find('.sidePanel__tabs .sidePanel__tabs__right').length
			)
		);

		self.obj_window.find('.sidePanel__tabs li').off('click').on('click', function () {
			self.select_tab($(this).attr('data-tab'))
			self.update_group_links();
			self.update_tab_scroll();
		})

		self.search.init();
		self.activate_tab(self.get_active_tab());
		self.update_tab_scroll();
		self.update_group_links();

		if (self.last_scroll_top) {
			self.obj_window.find('.sidePanel__list').scrollTop(self.last_scroll_top);
			self.last_scroll_top = 0;
		}
	},
	update_tab_scroll: function () {
		const ul_el = self.obj_window.find('.sidePanel__tabs ul').get(0)
		const active_li = self.obj_window.find('.sidePanel__tabs li.active').get(0)

		if (!ul_el || !active_li || ul_el.scrollWidth <= ul_el.offsetWidth) return

		if (active_li.offsetLeft + active_li.offsetWidth * 1.2 > ul_el.offsetWidth) {
			ul_el.scroll({left: ul_el.scrollLeft + active_li.offsetWidth, top: 0, behavior: "smooth"})
		} else if(active_li.offsetLeft - ul_el.scrollLeft < ul_el.offsetWidth * 0.2) {
			ul_el.scroll({left: ul_el.scrollLeft-active_li.offsetWidth, top: 0, behavior: "smooth"})
		}
	},
	get_active_tab: function () {
		return self.obj_window.find('.sidePanel__tabs li.active').attr('data-tab');
	},
	goto_tasks: function () {
		App.core.goto(self.get_tasks_url());
	},
	get_tasks_url: function (params = {}) {
		const url = new URL('/', window.location.origin);
		const active_tab = self.get_active_tab(),
			user = Number(self.obj_window.attr('data-user')),
			role = Number(self.obj_window.attr('data-role'));

		if (params) {
			Object.keys(params).forEach(key => {
				if (params[key]) url.searchParams.set(key, params[key]);
			});
		}

		if (user === App.me.id) {
			url.pathname = `/my-tasks/`;
			url.searchParams.set('sel_role', String(role + 1));
		} else {
			url.pathname = `/user/${user}/tasks/`;
			url.searchParams.set('sel_role', '1');
		}

		if (self.sel_terms[active_tab] != null) {
			url.searchParams.set('sel_term', self.sel_terms[active_tab]);
		}

		url.searchParams.set('flt_force', '1');
		url.searchParams.set('flt_upd', '1');

		return url.pathname + url.search;
	},
	update_group_links: function () {
		self.obj_window.find('.sidePanel__list__group a.sidePanel__list__group__title, .sidePanel__list__group .sidePanel__list__group__title a').each(function () {
			if ($(this).hasClass('termin')) return;

			$(this).attr('href', self.get_tasks_url({
				sel_stage: $(this).attr('data-stage'),
				sel_project: $(this).attr('data-project'),
			}));
		})
	},
	select_tab: function (tab_key) {
		const active_tab = self.get_active_tab();
		if (active_tab === tab_key || tab_key == null) return;

		let too_many = self.obj_window.find('.sidePanel__list__more').length > 0;
		if (too_many) {
			App.task_explorer.show(self.obj_window.find('.sidePanel__list__more').attr('data-params') + '&tab=' + tab_key);
			return;
		}

		let filter_order_finish = self.obj_window.find('#task-list-params').attr('data-filter-order') === 'finish';
		if (filter_order_finish && ((tab_key === 'completed' && active_tab !== 'completed') || (tab_key !== 'completed' && active_tab === 'completed'))) {
			App.task_explorer.show(self.obj_window.find('#task-list-params').attr('data-params') + '&tab=' + tab_key);
			return;
		}

		self.activate_tab(tab_key);
		// TODO flymod use loadState() on show?
		// TODO flymod do setStateSilent() on too_may etc?
		App.classes.ui_state_manager.getInstance().setState('sidepanel_tasks_tab', tab_key);
	},
	activate_tab: function (tab_key) {
		self.obj_window.find('.sidePanel__tabs li').removeClass('active')
		self.obj_window.find('.sidePanel__tabs li[data-tab='+tab_key+']').addClass('active');
		self.obj_window.find('.sidePanel__list__item').removeClass('sidePanel__list__item-disabled');

		if (tab_key !== 'all') {
			self.obj_window.find('.sidePanel__list__item').not('.' + tab_key).addClass('sidePanel__list__item-disabled')
		}

		self.search.apply();
	},
	search: {
		list: null,
		input: null,
		init: function () {
			self.search.list = $('#sidePanel__wrapper')
			self.search.input = self.obj_window.find('.searchInput input[name=search]');

			self.search.input.off('keyup').on('keyup', self.search.apply)
			self.obj_window.find('.searchInput a.delete').off('click').on('click', self.search.clear)
		},
		apply: function () {
			App.context_search.sidebar_tasks.apply(self.search.input.get(0), self.search.list)
		},
		clear: function () {
			self.search.input.val('')
			App.mymenu.clear_search_string();
			self.search.apply();
		}
	},
	get_group_by: function () {
		return $(App.mymenu.cache[self.type]?.obj_window).find('.sidePanel__list[data-group-by]').attr('data-group-by') || '';
	},
	sel_role: function () { return +$(App.mymenu.cache[self.type]?.obj_window).attr('data-role'); },
	sel_user: function () { return +$(App.mymenu.cache[self.type]?.obj_window).attr('data-user'); },
	has_task: function (task_id) {
		return $(App.mymenu.cache[self.type]?.obj_window).find('.sidePanel__list__item-task[data-task='+task_id+']').length > 0;
	},

	mark_invalidated: function () {
		App.mymenu.mark_invalidated_window(self.type);
	},

	invalidate_by_group_and_task: function (group_by, task_id) {
		if (self.get_group_by() === group_by && self.has_task(task_id)) self.mark_invalidated();
	},

	update: function () {
		App.mymenu.invalidate_window(self.type);
	},

	onBoot: function () {
		App.bus.state.on('task', function (payload) {
			let id_task = payload.id, data = payload.data;

			if (data.priority) self.invalidate_by_group_and_task('important', id_task);
			if (data.move) self.invalidate_by_group_and_task('project', id_task);
			if (data.status) self.invalidate_by_group_and_task('status', id_task);
			if (data.terms) self.invalidate_by_group_and_task('finish', id_task);

			if (data.user_to && self.sel_role() === 0 && [data.user_to.id, data.user_to.before?.id].includes(self.sel_user())) {
				self.mark_invalidated();
			}
			if (data.user_from && self.sel_role() === 1 && [data.user_from.id, data.user_from.before?.id].includes(self.sel_user())) {
				self.mark_invalidated();
			}
			if ((data.undone || data.done || data.delete) && self.has_task(id_task)) {
				self.mark_invalidated();
			}
		});

		App.bus.app.on('left_panel_ready', function () {
			if (App.mymenu.type === self.type) App.task_explorer.init();
		});
	}
};
})();

$(document).on('click', '[data-user-tasks]', function (e) {
	e.stopPropagation();
	let el = $(e.target).closest('[data-user-tasks]')
	App.task_explorer.show(el.attr('data-user-tasks'), { dont_cache: true });
})

;var App = App || {};

(function() {

	let self = App.task_grid_create = {
		obj: null,
		obj_close: null,
		obj_dock: null,
		sent: false,
		is_shown: false,
		context_menu: null,
		state: {}, // group, subgroup, parent linkage
		backups: {}, // backup data for components

		selector_component_delete: 'ws-btn[right-icon=close]',
		selector_more_menu: '#taskGridCreate__menu__more',


		init: function() {
			self.obj = $('.dataTable__item-newTask').hide();
			if (!self.obj.length) return;

			self.obj_close = $('.closeNewTask').hide();
			const obj_wrapper = $('.dataTable__wrapper');

			if (self.obj_close.length) {
				self.obj_close.insertBefore(obj_wrapper);

				obj_wrapper.on('scroll', function () {
					const scrolled = $(this).scrollTop();

					const baseTop =
						self.obj[0].offsetTop +
						(self.obj[0].offsetHeight - self.obj_close[0].offsetHeight) / 2;

					const newTop = baseTop - scrolled;

					self.obj_close
						.toggleClass('closeNewTask--is-scrolled', scrolled !== 0)
						.css('top', `${newTop}px`);
				});
			}

			$(self.selector_more_menu).insertAfter(self.obj);
			self.helper_component_requirements();
			self.obj.bind('change', () => {
				self.form_on_update()
			});
			self.obj.bind('click', () => {
				self.helper_on_blur_name.reset();
			});
			self.obj.detach();
			self.focus_state = null;
			const input = self.obj.find('input[name=name]');
			input.on('keyup', function () {
				self.form_on_update();
			});
			input.on('keydown', function (e) {
				const { altKey, ctrlKey, metaKey } = e;
				let keyCode = e.which || e.keyCode || e.charCode;

				const get_anchor = () => self.obj.find('.space-asTD ws-btn').get(0);

				switch (true) {
					case !App.menu.in_editor && altKey && (ctrlKey || metaKey) && keyCode === App.keycode.Enter:
						self.form_on_submit({next_action: 'open', anchor: get_anchor()});
						break;
					case !App.menu.in_editor && keyCode === App.keycode.Enter:
						e.preventDefault();
						self.form_on_submit({anchor: get_anchor()});
						break;
					case !App.menu.in_editor && keyCode === App.keycode.Escape:
						self.close_new_task();
						break;
				}
			});
			self.init_context_menu(input)
			self.components.init();
			self.sent = true;
			self.obj.find('.space-asTD ws-btn').bind('click', function () {
				self.form_on_submit({anchor: this})
			});
		},

		close_new_task: function () {
			self.is_shown = false;
			self.detach(true);
			self.obj_close.hide();
			if (!App.page.have_data) $('.empty__state-wrapper').show();
		},

		init_context_menu: function (input) {
			const isDisabled = (component_name) => {
				return App.page.disabled_components.includes(component_name);
			};
			const context_menu = new App.classes.task_context_menu({
				components: [
					{type: 'project', selected: self.components.project.is_selected(), disabled: App.current_page.project !== 0},
					{type: 'parent', selected: self.components.parent.is_selected()},
					{type: 'terms', selected: self.components.terms.is_selected()},
					{type: 'priority', selected: self.components.priority.is_selected()},
					{type: 'assignee', selected: self.components.assignee.is_selected()},
					{type: 'stage', selected: self.components.stage.is_selected()},
					{type: 'labels', selected: self.components.labels.is_selected()},
					...( !isDisabled('limits') ? [{type: 'limits', selected: self.components.limits.is_selected()}] : [] ),
					{type: 'subscribers', selected: self.components.subscribers.is_selected(), counter: self.components.subscribers.get_counter()},
					...( !isDisabled('visibility') ? [{type: 'visibility', selected: self.components.visibility.is_selected()}] : [] ),
				],
				input: input
			});
			context_menu.on('task_context_menu.component.show', function (component) {
				self.components[component.type]?.show(component.element());
			});
			context_menu.on('task_context_menu.component.clear', function (component) {
				self.components[component.type]?.clear(component.element());
			})
			self.context_menu = context_menu;
		},


		open_full_mode: function () {
			App.task_create.new(self.obj.find('input').serialize());
			self.is_shown = false;
			self.detach(true);
			self.obj_close.hide();
		},

		form_validate: function() {
			let valid = true, require_empty = false, has_fill = false, is_empty_project = self.components.project.get_ids().length === 0;
			let fill_assignee_or_project = self.components.assignee.get_id() || !is_empty_project;
			if (!self.obj.find('input[name=name]').val().trim()) {
				valid = false;
			} else if (!fill_assignee_or_project) {
				valid = false;
			}

			const filled = {};
			self.obj.find('[data-container]').each(function() {
				let field = $(this).attr('data-container');
				if (field === 'time' || field === 'money') field = 'limits';
				const fill = $(this).find('input').length && $(this).find('input').val();
				filled[field] ||= !!fill;
				if (fill && field !== 'project' && field !== 'parent') has_fill = true;
				$(self.selector_more_menu).find('[data-container=' + field + ']').toggleClass('menu__item-active', filled[field]);
			});

			$(self.selector_more_menu).find('[data-container=limits],[data-container=subscribers],[data-container=hidden]').toggleClass('menu__item-hidden', is_empty_project);
			$(self.selector_more_menu).find('.menu__group').each(function () {
				let should_hide = $(this).find('.menu__item:not(.menu__item-hidden)').length === 0;
				$(this).toggleClass('menu__group-hidden', should_hide);
			});

			self.obj.find('[data-container].require').each(function() {
				let field = $(this).attr('data-container');
				let fill = false;
				if (field === 'max_time' || field === 'max_money') field = 'limits';
				if (field === 'assignee' || field === 'project') {
					fill = fill_assignee_or_project;
				} else if (field === 'limits') {
					self.obj.find('[data-container=max_time], [data-container=max_money]').find('input').each(function() {
						if (this.value) fill = true;
					});
				} else {
					fill = $(this).find('input').length && $(this).find('input').val();
				}
				if (!fill) {
					valid = false;
					require_empty = true;
					$(this).addClass('require_empty');
					self.get_more_button(field).addClass('require_empty');
				} else {
					$(this).removeClass('require_empty');
					self.get_more_button(field).removeClass('require_empty');
				}
			});
			self.obj.find('.plus .in').toggleClass('require_empty', require_empty).toggleClass('has_fill', has_fill);

			if (require_empty) {
				self.obj.find('.plus .in ws-btn').attr('name', 'btn btn-24 btn-w btn-solid').attr('right-icon', 'edit_prop');
			} else if (has_fill) {
				self.obj.find('.plus .in ws-btn').attr('name', 'btn btn-24 btn-a btn-solid').attr('right-icon', 'edit_prop');
			} else {
				self.obj.find('.plus .in ws-btn').attr('name', 'btn btn-24 btn-g btn-ghost').attr('right-icon', 'edit_prop');
			}

			if (valid) {
				self.obj.find('.space-asTD ws-btn button').removeAttr('disabled');
				return true;
			} else {
				self.obj.find('.space-asTD ws-btn button').toggleDisabled(true);
				return false;
			}
		},

		form_on_update: function() {
			self.form_validate();
		},

		form_on_submit: function({next_action, anchor} = {}) {
			if (!self.obj.find('input[name=name]').val().trim()) {
				self.obj.find('input[name=name]').animate_css('head-shake');
				return false;
			}
			let o_empty = self.obj.find('.require.require_empty');
			if (o_empty.length) {
				o_empty.eq(0).trigger('click', { anchor });
				return false;
			}
			if (self.obj.find('.space-asTD ws-btn button').prop('disabled')) return false;

			self.obj.find('.space-asTD ws-btn button').toggleDisabled(true);
			$.ajax({
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('task_draft:publish') + '&next_action=' + next_action),
				type: 'POST',
				dataType: 'script',
				data: self.obj.find('input').serialize(),
				timeout: App.env === 'local' ? 60000 : 10000,
				success: function () {
					self.obj.find('input[name=name]').val('').focus();
					self.obj.find('input[name=name]').one('blur', self.helper_on_blur_name);
					self.obj.find('.space-asTD ws-btn button').toggleDisabled(false);
				}
			});
		},

		helper_on_blur_name: App.helper.debounce(function(e) {
			setTimeout(function () {
				if (!self.is_shown || $(e.target).val().trim() !== '' || App.controls.datatable.emptyGrid.addClicked) return;
				self.is_shown = false;
				self.detach(true);
				self.obj_close.hide();
				if (!App.page.have_data) $('.empty__state-wrapper').show();
			}, 50);
		}, 100),

		helper_component_replace: function() {
			const container = self.obj.find('[data-container=' + $(this).attr('data-container') + ']');
			if (!container.length) return;

			if (!container.data('default-state')) container.data('default-state', container.html());
			container.html($(this).html());
			if ($(this).attr('data-container') === 'project') {
				container.attr('data-require', $(this).attr('data-require')).attr('data-project', $(this).attr('data-project'));
				App.task_grid_create.components.project.callback_component_replace();
			}
		},

		helper_component_restore: function() {
			self.obj.find('[data-container]').each(function() {
				if ($(this).data('default-state')) $(this).html($(this).data('default-state'));
			})
		},

		helper_component_requirements: function(require, id_project) {
			if (typeof require !== 'undefined') {
				self.obj.data('data-require', require);
				self.obj.data('data-project', id_project);
			} else {
				require = self.obj.attr('data-require');
			}
			require = require.split(',');
			require.push('assignee');
			require.push('project');
			self.obj.add(self.selector_more_menu).find('[data-container]').each(function() {
				if (require.includes($(this).attr('data-container'))) $(this).addClass('require').attr('data-title', App.object_state.locale['hint_required_input']); else $(this).removeClass('require').removeAttr('data-title');
			});
			if (require.includes('hidden') && (!self.obj.find('input[name=hidden]').val() && !self.obj.find('input[name=guests]').val())) {
				self.components.visibility.preset('me');
			}
			if (require.includes('limits')) { // limit fields separated to max_time and max_money
				self.obj.find('[data-container=max_time], [data-container=max_money]').addClass('require').attr('data-title', App.object_state.locale['hint_required_input']);
			} else {
				self.obj.find('[data-container=max_time], [data-container=max_money]').removeClass('require').removeAttr('data-title');
			}
			self.obj.trigger('change');
		},

		refresh_components_state: function() {
			self.context_menu.components.forEach((menu_component) => {

				const component_type = menu_component.type;
				const component = self.components[component_type];

				if (!component) return;

				if (component.is_selected?.()) {
					self.context_menu?.emit('task_context_menu.component.selected', component_type, {
						counter: component.get_counter?.(),
					});
				} else {
					self.context_menu?.emit('task_context_menu.component.cleared', component_type);
				}
			});
		},

		focus_state: null,

		detach: function(escape) {
			if (!self.obj?.length) return;
			if (self.obj.hasClass('dataTable__item-instead')) {
				self.obj.before(App.controls.datatable.emptyGrid.getItem());
			}
			self.focus_state = self.obj.find('input[name=name]').is(':focus');
			self.obj.detach();
			self.obj.find('input[name=name]').off('blur');
			self.obj_close?.hide();
			App.controls.datatable.emptyGrid.update();
			if (escape) App.controls.datatable.calibrate(true, true);
			self.state = {};
		},

		attach: function() {
			if (self.is_shown) {
				if (self.obj_dock && !self.obj_dock.closest('.dataTable').length) {
					self.is_shown = false;
					self.obj_close?.hide();
				} else {
					self.show(self.obj_dock);
				}
			}
		},

		destructor: function(escape) {
			if (self.obj)	{
				self.obj.find('input[name=name]').off('blur');
				self.obj.remove();
				self.obj = null;
				self.obj_dock = null;
				self.sent = false;
				self.is_shown = false;
				self.backups = {};
				self.state = {};
			}
		},

		get_task_filter_dock: function() {
			if (!App.page.is_task_filter) return null;
			const obj_dock = App.controls.datatable.getObj()
				.find('.dataTable__item[data-id="' + App.page.is_task_filter + '"]')
				.first();
			return obj_dock.length ? obj_dock : null;
		},

		show: function(obj_dock, options)  {

			options ||= {};

			if (options.anchor && options.select_project) {
				self.components.project.show(options.anchor, {
					onhide: function () {
						if (self.components.project.multi_loading) return; // not select+hide, but mode changed
						if (self.components.project.get_ids().length > 0) {
							self.show(obj_dock, { ...options, select_project: false });
						}
					}
				});
				return false;
			}

			if($('.project_archive_line').is(':visible')) return;
			if (App.device.is_mobile()) {
				App.task_create.new();
				return false;
			}
			App.controls.datatable.emptyGrid.addClicked = true;
			self.is_shown = true;
			self.obj_dock = obj_dock;
			self.obj.removeClass('dataTable__item-level0 dataTable__item-level1 dataTable__item-level2 dataTable__item-child dataTable__item-instead');
			if (!obj_dock) {
				self.obj.prependTo(App.controls.datatable.getObjBody());
				self.get_container('parent').show().html(App.helper.template.fill('task_grid_create_parent_empty'));
				App.task_grid_create.helper_component_restore();
				self.state = {
					position: 'top'
				};
			}
			else if (obj_dock.hasClass('dataTable__group')) {
				self.obj.insertAfter(obj_dock);
				obj_dock.find('[data-container]').each(App.task_grid_create.helper_component_replace);
				self.state = {
					id_group: obj_dock.attr('data-group-id'),
					position: 'top'
				};
			} else if (obj_dock.hasClass('dataTable__subgroup')) {
				self.obj.insertAfter(obj_dock);
				obj_dock.find('[data-container]').each(App.task_grid_create.helper_component_replace);
				while (!obj_dock.hasClass('dataTable__group')) obj_dock = obj_dock.prev();
				obj_dock.find('[data-container]').each(App.task_grid_create.helper_component_replace);
				self.state = {
					id_group: obj_dock.attr('data-group-id'),
					id_group_sub: obj_dock.attr('data-group-sub-id'),
					position: 'top'
				};
			} else if (obj_dock.hasClass('dataTable__item-empty')) { // replace this
				let obj_group = obj_dock.prevAll('.dataTable__subgroup, .dataTable__group').eq(0);
				const obj_task_filter = !obj_group.length ? self.get_task_filter_dock() : null;
				obj_dock.replaceWith(self.obj);
				self.obj.addClass('dataTable__item-instead');
				if (obj_group.length) {
					obj_group.find('[data-container]').each(App.task_grid_create.helper_component_replace);
					self.state = {
						id_group: obj_group.attr('data-group-id'),
						id_group_sub: obj_dock.hasClass('dataTable__subgroup') ? obj_group.attr('data-group-sub-id') : null,
						position: 'bottom'
					};
				} else if (obj_task_filter) {
					obj_task_filter.find('[data-container]').each(App.task_grid_create.helper_component_replace);
					self.state = {
						id_parent: obj_task_filter.attr('data-id'),
						position: 'bottom'
					};
					self.obj.addClass('dataTable__item-child dataTable__item-level1');
				} else {
					App.task_grid_create.helper_component_restore();
					self.state = {
						position: 'bottom'
					};
				}
			} else {
				self.obj.insertAfter(obj_dock);
				obj_dock.find('[data-container]').each(App.task_grid_create.helper_component_replace);
				self.state = {
					id_parent: obj_dock.attr('data-id'),
					position: 'top'
				};
				if (obj_dock.hasClass('dataTable__item-level0')) {
					self.obj.addClass('dataTable__item-child dataTable__item-level1');
				} else if (obj_dock.hasClass('dataTable__item-level1')) {
					self.obj.addClass('dataTable__item-child dataTable__item-level2');
				}
			}
			// console.log(self.state);

			App.controls.datatable.emptyGrid.update();
			self.helper_params_by_filter();
			self.obj.trigger('change');
			self.refresh_components_state();
			self.obj.show();
			self.obj_close.show();

			const rowDraggerVisibleClass = 'rowDragger-visible';
			setTimeout(() => {

				const rect = self.obj[0].getBoundingClientRect();
				const wrapperRect = $('.dataTable__wrapper')[0].getBoundingClientRect();

				const baseTop =
					(rect.top - wrapperRect.top) +
					(self.obj[0].offsetHeight - self.obj_close[0].offsetHeight) / 2;

				self.obj_close.css('top', `${baseTop}px`);
				$('.'+rowDraggerVisibleClass).removeClass(rowDraggerVisibleClass);
			}, 0);

			if (!$('.filter__item-search.filter__item-active').length)self.obj.find('input').focus(); // if (self.focus_state !== false)
			self.obj.find('input[name=name]').one('blur', self.helper_on_blur_name);
			App.controls.datatable.calibrate(true, true);
			$('.empty__state-wrapper').hide();
		},

		get_container: function(field) {
			let container = self.obj.find('[data-container='+field+']');
			if (!container.length) {
				container = $('<div></div>').attr('data-container', field);
				self.obj.find('[data-container=containers]').append(container);
			}
			return container;
		},

		get_more_button: function(field) {
			return $(self.selector_more_menu + ' [data-container='+field+']');
		},

		components: {
			init: function() {
				for (let i in self.components) {
					if ('init' in self.components[i]) self.components[i].init();
				}
			},

			more: {
				init: function() {
					self.obj.find('.plus ws-btn').on('click', function (e, data) {
						data ||= {};
						App.menu.show({
							anchor: this,
							box: self.selector_more_menu,
							onshow: data.onshow || null
						});
					});
				}
			},

			project: {
				init: function() {
					self.obj.add(self.selector_more_menu).on('click', '[data-container=project]', function (e, data) {
						data ||= {};
						data.anchor ||= this;
						if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							self.components.project.callback_delete();
						} else {
							let ids = self.components.project.get_ids();
							if (ids.length > 1 || data.multi) {
								App.controls.project_select_and_go.show_context(data.anchor, null, {
									request: {multiple: true, requirements: true},
									backup: data?.backup || !!$(data.anchor).closest(self.selector_more_menu).length,
									onload: function () {
										let menu = $(this);
										App.controls.menu.init(menu);
										$(this).on('click', '.menu__item', function() {
											self.components.project.callback_multiple.call(menu);
										});
									},
									onshow: function() {
										$(this).find('.menu__item').each(function() {
											$(this).toggleClass('menu__item-active', ids.includes($(this).attr('data-id').toInt()));
										});
									},
									onhide: data?.onhide,
								});
							} else {
								App.controls.project_select_and_go.show_context(data.anchor, null, {
									request: {multiple_enabled: true, requirements: true},
									backup: data?.backup || !!$(data.anchor).closest(self.selector_more_menu).length,
									onload: function () {
										$(this).on('click', '.menu__item', function() {
											self.components.project.callback.call(this);
											App.menu.hide();
										}).on('click', '.multi-select', function() {
											self.components.project.multi_loading = true;
											App.menu.hide(true);
											self.components.project.multi_loading = false;
											self.obj.add(self.selector_more_menu).find('[data-container=project]').first().trigger('click', [{multi:true, anchor: data.anchor, onhide: data?.onhide}]);
										});
									},
									onshow: function() {
										$(this).find('.menu__item').each(function() {
											$(this).toggleClass('menu__item-active', ids.includes($(this).attr('data-id').toInt()));
										});
									},
									onhide: data?.onhide,
								});
							}
						}
					});
					// self.components.project.callback_final();
				},
				show: function (element, options) {
					self.obj.add(self.selector_more_menu).find('[data-container=project]').first().trigger('click', {
						anchor: element,
						backup: true,
						onhide: options?.onhide || null,
					});
				},
				clear: function () {
					self.components.project.callback_delete();
				},
				callback: function () { // this = menu__item
					let id = $(this).attr('data-id');
					self.helper_component_requirements($(this).attr('data-require'), id);
					self.get_container('project').html(App.helper.template.fill('task_grid_create_project', {
						name: $(this).find('.in').text(),
						id,
						icon: $(this).find('span:first-child').html(),
					}));
					self.get_container('parent').show().html(App.helper.template.fill('task_grid_create_parent_empty'));
					self.get_more_button('parent').show();

					self.obj.attr('data-old-endpoint', App.helper.endpoint.project(id)).trigger('change');
					self.obj.attr('data-endpoint', App.helper.endpoint.ajax(id)).trigger('change');
					// $('#taskGridCreate__menu__file .recent_files').attr('data-modal-url', App.helper.url.add_query(App.helper.endpoint.project(id), $('#taskGridCreate__menu__file .recent_files').attr('data-action')))
					App.controls.user_select_and_go.team(self.helper_user_endpoint('team'), self.components.team.callback);
					self.components.project.callback_final();
					self.context_menu?.emit('task_context_menu.component.selected', 'project')
					return false;
				},
				callback_component_replace: function () { // this = menu__item
					let id = self.get_container('project').find('input').val();
					self.helper_component_requirements(self.get_container('project').attr('data-require'), id);
					self.get_container('parent').show().html(App.helper.template.fill('task_grid_create_parent_empty'));
					self.get_more_button('parent').show();
					self.obj.attr('data-old-endpoint', App.helper.endpoint.project(id)).trigger('change');
					self.obj.attr('data-endpoint', App.helper.endpoint.ajax(id)).trigger('change');
					// $('#taskGridCreate__menu__file .recent_files').attr('data-modal-url', App.helper.url.add_query(App.helper.endpoint.project(id), $('#taskGridCreate__menu__file .recent_files').attr('data-action')))
					App.controls.user_select_and_go.team(self.helper_user_endpoint('team'), self.components.team.callback);
					self.components.project.callback_final();
					self.context_menu?.emit('task_context_menu.component.selected', 'project')
					return false;
				},
				callback_multiple: function () { // this = menu
					self.helper_component_requirements('');
					let o = $(this).find('.menu__item-active');
					if (o.length === 0) { // none selected fallback
						self.components.project.callback_delete();
						return false;
					}
					if (o.length === 1) { // single selected fallback
						self.components.project.callback.call(o.get(0));
						return false;
					}
					let ids = [];
					o.each(function() {
						ids.push($(this).attr('data-id'));
					});
					self.get_container('project').html(App.helper.template.fill('task_grid_create_project_multiple', {
						name: App.format.quantity(ids.length, App.object_state.locale['projects'], QTY_WITH_TEXT),
						ids: ids.join(','),
					}));
					self.get_container('parent').hide().html(App.helper.template.fill('task_grid_create_parent_empty'));
					self.get_more_button('parent').hide();
					self.get_container('assignee').html(App.helper.template.fill('task_grid_create_assignee_empty'));
					self.obj.attr('data-old-endpoint', self.obj.attr('data-def-old-endpoint')).trigger('change');
					self.obj.attr('data-endpoint', self.obj.attr('data-def-endpoint')).trigger('change');
					self.components.project.callback_final();
					self.context_menu?.emit('task_context_menu.component.selected', 'project')
					return false;
				},
				callback_delete: function() {
					self.helper_component_requirements('');
					self.get_container('project').html(App.helper.template.fill('task_grid_create_project_empty'));
					self.get_container('parent').hide().html(App.helper.template.fill('task_grid_create_parent_empty'));
					self.get_more_button('parent').hide();
					self.obj.attr('data-old-endpoint', self.obj.attr('data-def-old-endpoint')).trigger('change');
					self.obj.attr('data-endpoint', self.obj.attr('data-def-endpoint')).trigger('change');
					self.components.project.callback_final();
					self.context_menu?.emit('task_context_menu.component.cleared', 'project')
				},
				callback_final: function() {
					let ids_project = self.components.project.get_ids();
					// $('#taskGridCreate__menu__file .recent_files').toggle(ids_project.length === 1);
					if (ids_project.length === 0) self.components.assignee.callback_delete();

					self.context_menu?.emit('task_context_menu.component.disabled', 'limits', ids_project.length === 0);
					self.context_menu?.emit('task_context_menu.component.disabled', 'subscribers', ids_project.length === 0);
					self.context_menu?.emit('task_context_menu.component.disabled', 'visibility', ids_project.length === 0);
					self.context_menu?.emit('task_context_menu.component.disabled', 'parent', ids_project.length === 0);
					self.context_menu?.emit('task_context_menu.component.cleared', 'parent');

					self.obj.trigger('change');
					self.obj.trigger('menu_item_selected');
				},
				get_ids: function() {
					return self.get_container('project').find('input').length ? self.get_container('project').find('input').val().split(',').map(Number) : [];
				},
				is_selected: function() {
					return self.components.project.get_ids()?.length > 0;
				}
			},

			parent: {
				init: function() {
					self.obj.add(self.selector_more_menu).on('click', '[data-container=parent]', function (e, data) {
						if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							self.components.parent.clear();
						} else {
							App.controls.task_select_and_go.show_context(data?.anchor || this, self.obj.attr('data-endpoint'), {
								request: {type: 'create'},
								backup: data?.backup || !!$(this).closest(self.selector_more_menu).length,
								onload: function() {
									$(this).on('click', '.menu__item', function() {
										self.components.parent.callback.call(this);
										App.menu.hide();
									})
								},
								onshow: function() {
									const menu = $(this);
									const id_parent = self.get_container('parent').find('input').val();
									App.controls.menu.item_set_active_by_id(menu, id_parent);
								}
							});
						}
					});
				},
				show: function (element) {
					self.obj.add(self.selector_more_menu).find('[data-container=parent]').first().trigger('click', {
						anchor: element,
						backup: true
					});
				},
				clear: function() {
					self.components.parent.callback_delete();
				},
				callback: function () { // this = menu__item
					self.get_container('parent').html(App.helper.template.fill('task_grid_create_parent', {
						name: $(this).find('.in').text(),
						url: $(this).attr('data-url'),
						id: $(this).attr('data-id'),
						icon: $(this).find('task-stage').html(),
					}));
					App.menu.hide();
					App.controls.user_select_and_go.team(self.helper_user_endpoint('team'), self.components.team.callback);
					self.obj.trigger('change');
					self.obj.trigger('menu_item_selected');
					self.context_menu?.emit('task_context_menu.component.selected', 'parent')
					return false;
				},
				callback_delete: function() {
					self.get_container('parent').html(App.helper.template.fill('task_grid_create_parent_empty'));
					self.context_menu?.emit('task_context_menu.component.cleared', 'parent')
					self.obj.trigger('change');
				},
				get: function () {
					let parent = self.get_container('parent');
					let id = parent.find('input')?.val()?.toInt();
					return {
						id: id,
					};
				},
				is_selected: function() {
					return self.get_container('parent').find('input').val() > 0;
				}
			},

			team: {
				callback: function(ids) {
					let id_user_to = self.components.assignee.get_id();
					if (id_user_to>= App.config.real_user_id && !ids.includes(id_user_to)) self.get_container('assignee').html(App.helper.template.fill('task_grid_create_assignee_empty'));
					let ids_subscribe = self.obj.find('input[name=ids_subscribe]').val().toIntArray();
					ids_subscribe = ids_subscribe.filter((id) => ids.includes(id));
					self.obj.find('input[name=ids_subscribe]').val(ids_subscribe.join(','));
					if (ids_subscribe.length > 0) {
						self.context_menu?.emit('task_context_menu.component.selected', 'subscribers', {
							counter: ids_subscribe.length
						})
					} else {
						self.context_menu?.emit('task_context_menu.component.cleared', 'subscribers')
					}
				},
			},

			assignee: {
				init: function() {
					self.obj.add(self.selector_more_menu).on('click', '[data-container=assignee]', function(e, data) {
						if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							self.components.assignee.clear();
						} else {
							let ids_project = self.components.project.get_ids();
							let request = {type: 'assign'}
							if (ids_project.length > 1) request.ids_project = ids_project.join(',');
							let hidden = self.obj.find('input[name=hidden]').val().toIntArray();
							if (hidden.length && !self.components.visibility.is_me_mode()) request.hidden = hidden.join(',');
							App.controls.user_select_and_go.show_context(this, self.helper_user_endpoint(), {
								request,
								backup: data?.backup || !!$(this).closest(self.selector_more_menu).length,
								onload: function() {
									$(this).on('click', '.menu__item', function() {
										self.components.assignee.callback.call(this);
										App.menu.hide();
									})
								},
								anchor: data?.anchor || this,
							});
						}
					});
					// self.components.assignee.saveBackup();
				},
				show: function (element) {
					self.obj.add(self.selector_more_menu).find('[data-container=assignee]').first().trigger('click', {
						anchor: element,
						backup: true
					});
				},
				clear: function () {
					self.components.assignee.callback_delete();
				},
				callback: function() { // this = menu__item
					let id_user_to = $(this).attr('data-id').toInt();
					let ids_subscribe = self.obj.find('input[name=ids_subscribe]').val().toIntArray();

					if (App.modal.is_shown() && App.modal.obj_window.find('.modal-setDateOnCreate, #dateend_div').length) {
						if (App.controls.task_terms_on_create && App.controls.task_terms_on_create.saved_params) {
							App.controls.task_terms_on_create.saved_params.id_user_to = id_user_to || 0;
							App.modal.reload();
						}
					}

					if (id_user_to === NO_ASSIGNEE) {
						self.components.assignee.callback_delete();
						return;
					}

					self.get_container('assignee').html(App.helper.template.fill('task_grid_create_assignee', {
						name: $(this).find('.in').text(),
						avatar: $(this).find('.av_sm').get(0).outerHTML,
						id: $(this).attr('data-id'),
					}));
					if (id_user_to>= App.config.real_user_id && !ids_subscribe.includes(id_user_to)) {
						ids_subscribe.push(id_user_to);
						self.obj.find('input[name=ids_subscribe]').val(ids_subscribe.join(','));
						if (ids_subscribe.length > 0) {
							self.context_menu?.emit('task_context_menu.component.selected', 'subscribers', {
								counter: ids_subscribe.length
							})
						} else {
							self.context_menu?.emit('task_context_menu.component.cleared', 'subscribers')
						}
					}
					self.components.visibility.apply_preset(id_user_to);
					self.obj.trigger('change');
					self.obj.trigger('menu_item_selected');
					self.context_menu?.emit('task_context_menu.component.selected', 'assignee')
				},
				get_id: function() {
					return self.obj.find('input[name=id_user_to]').length ? self.obj.find('input[name=id_user_to]').val().toInt() : 0;
				},
				callback_delete: function () {
					// if (self.backups.assignee) {
					// 	self.get_container('assignee').html(App.helper.template.fill('task_grid_create_assignee', {
					// 		name: self.backups.assignee.name,
					// 		avatar: self.backups.assignee.avatar,
					// 		id: self.backups.assignee.id,
					// 	}));
					// 	return;
					// }
					self.get_container('assignee').html(App.helper.template.fill('task_grid_create_assignee_empty'));
					self.obj.find('input[name=id_user_to]').val(NO_ASSIGNEE);
					self.components.visibility.apply_preset(0);
					self.obj.trigger('change');
					self.context_menu?.emit('task_context_menu.component.cleared', 'assignee')
				},
				// saveBackup: function() {
				// 	const container = self.get_container('assignee');
				// 	const input = container.find('input');
				// 	if (input.val().toInt() > 0) {
				// 		self.backups.assignee = {
				// 			id: container.find('input').val(),
				// 			name: App.helper.html.encode(container.find('.in').text()),
				// 			avatar: container.find('.av_sm').get(0).outerHTML,
				// 		};
				// 	}
				// },
				is_selected: function() {
					return self.components.assignee.get_id() > 0;
				}
			},

			terms: {
				init: function() {
					self.obj.add(self.selector_more_menu).on('click', '[data-container=terms]', function(e, data) {
						if ($(this).find('.data_place').length) {
							App.menu.show({
								anchor: data?.anchor || this,
								backup: data?.backup || !!$(this).closest(self.selector_more_menu).length,
								box: '#taskGridCreate__menu__terms_preset'
							});
						} else if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							self.get_container('terms').html(App.helper.template.fill('task_grid_create_terms_empty'));
							self.obj.find('[data-container=terms_inputs] input').each(function(num, el) {
								el.value = el.getAttribute('data-default');
							});
							self.obj.trigger('change');
						} else {
							self.components.terms.showTerms();
						}
					});
					self.obj.find('[data-container=terms_inputs] input').each(function(num, el) {
						el.setAttribute('data-default', el.value);
					});
				},
				show: function (element) {
					self.obj.add(self.selector_more_menu).find('[data-container=terms]').first().trigger('click', {
						anchor: element,
						backup: true
					});
				},
				clear: function () {
					self.components.terms.callback({})
				},
				showTerms: function(tab) {
					let params = {}
					tab ||= 0;
					let ids = self.components.project.get_ids();
					if (ids.length === 1)	{
						params.id_project = ids.pop();
						params.is_allow_repeat = 1;
						params.is_mass = 0;
						params.id_parent = self.get_container('parent').find('input').length ? self.get_container('parent').find('input').val() : false;
					}
					else {
						params.is_allow_repeat = 0;
						params.is_mass = 1;
						params.id_parent = 0;
						params.id_project = 0;
					}
					let id_user_to = self.components.assignee.get_id();
					if (id_user_to) {
						params.id_user_to = id_user_to;
					}
					App.controls.task_terms_on_create.show(self.obj.find('[data-container=terms_inputs]'), tab, params, self.components.terms.callback);
				},
				preset: function (dateend, timeend) {
					let data = {
						dateend: dateend,
						datestart: '',
						timeend: timeend || '',
						timestart: '',
					}
					self.get_container('terms').html(App.helper.template.fill('task_grid_create_terms', self.components.terms.append_data(data), true));
					self.obj.find('[data-container=terms_inputs] input[name=dateend]').val(dateend);
					self.obj.find('[data-container=terms_inputs] input[name=timeend]').val(timeend);
					self.obj.find('[data-container=terms_inputs] input[name=is_term]').val(1);
					self.obj.trigger('change');
					self.context_menu?.emit('task_context_menu.component.selected', 'terms');
				},
				callback: function(data) {
					if (data.dateend) {
						self.get_container('terms').html(App.helper.template.fill('task_grid_create_terms', self.components.terms.append_data(data), true));
						self.context_menu?.emit('task_context_menu.component.selected', 'terms')
					} else {
						self.get_container('terms').html(App.helper.template.fill('task_grid_create_terms_empty'));
						self.context_menu?.emit('task_context_menu.component.cleared', 'terms')
					}
					App.modal.hide();
					self.obj.trigger('change');
					self.obj.trigger('menu_item_selected');
				},
				append_data: function(params) {
					if (params.dateend) params.dateend = App.helper.date.to_timestamp(App.helper.date.from_input(params.dateend));
					if (params.datestart) params.datestart = App.helper.date.to_timestamp(App.helper.date.from_input(params.datestart));
					if (params.timeend) params.timeend = App.helper.date.time_from_input(params.timeend);
					if (params.timestart) params.timestart = App.helper.date.time_from_input(params.timestart);

					params.time_diff = params.dateend + (params.timeend ? params.timeend * 900 : App.config.day_end) - App.helper.time.account();
					params.time_diff_start = params.datestart + (params.timestart ? params.timestart * 900 : App.config.day_start) - App.helper.time.account();
					params.terms = params.terms_end = params.dateend ? App.format.terms_from_inputs_data({
						dateend: params.dateend ? App.helper.date.to_input(new Date((params.dateend + App.config.date_timestamp_offset)  * 1000)) : '',
						datestart: params.datestart ? App.helper.date.to_input(new Date((params.datestart+ App.config.date_timestamp_offset) * 1000)) : '',
						timeend: params.timeend ? App.format.term_time(params.timeend) : '',
						timestart: params.timestart ? App.format.term_time(params.timestart) : '',
					}) : '';
					if (params.terms.indexOf(' &mdash;') !== -1) [params.terms_start, params.terms_end] = params.terms.split(' &mdash;');
					if (params.is_related) {}
					else if (params.datestart && params.timestart && params.time_diff_start > 0) params.wait = 1;
					else if (params.datestart && !params.timestart && params.datestart > App.helper.customDate.get('today')) params.wait = 1;
					else if (params.dateend && Math.abs(params.time_diff) >= 60) {
						if (params.time_diff < 0) params.hot = 1;
						else if (params.dateend === App.helper.customDate.get('today')) params.today = 1;
						else if (params.dateend === App.helper.customDate.get('tomorrow')) params.tomorrow = 1;
						else if (params.time_diff < 7 * 86400) params.warm = 1;
						else params.normal = 1;
					}
					return params;
				},
				is_selected: function() {
					return self.get_container('terms').find('input').val() == 1;
				}
			},

			stage: {
				init: function() {
					self.obj.add(self.selector_more_menu).on('click', '[data-container=stage]', function(e, data) {
						if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							self.components.stage.clear();
						} else {
							App.controls.project_task_stage_and_go.show_context(data?.anchor || this, App.helper.url.add_query(self.obj.attr('data-endpoint'), App.actions.get('project_task_stage_and_go:show'), {new_task:true,from:'task_grid_create'}), {
								backup: data?.backup || !!$(this).closest(self.selector_more_menu).length,
								onload: function() {
									$(this).on('click', '.menu__item', function() {
										self.components.stage.callback.call(this);
										App.menu.hide();
									})
								},
								onshow: function() {
									const menu = $(this);
									const id_stage = self.get_container('stage').find('input').val();
									App.controls.menu.item_set_active_by_id(menu, id_stage);
								}
							});
						}
					});
					self.components.stage.saveBackup();
				},
				show: function (element) {
					self.obj.add(self.selector_more_menu).find('[data-container=stage]').first().trigger('click', {
						anchor: element,
						backup: true
					});
				},
				clear: function () {
					self.components.stage.callback_delete();
				},
				callback: function() { // this = menu__item

					if ($(this).attr('data-id') === '0') {
						self.components.stage.callback_delete();
						return false;
					}

					self.get_container('stage').html(App.helper.template.fill('task_grid_create_stage', {
						name: $(this).find('.flex_content').text(),
						color: $(this).attr('data-color'),
						icon_html: $(this).find('ws-icon')[0].outerHTML,
						id: $(this).attr('data-id'),
					}));
					let o = $(this).find('.av_pre');
					if (o.length && App.helper.user.get_id_user_assignee_on_create(o.attr('data-id'))) {
						self.get_container('assignee').html(App.helper.template.fill('task_grid_create_assignee', {
							name: o.attr('data-name'),
							avatar: o.html(),
							id: o.attr('data-id'),
						}));
					}
					self.obj.trigger('change');
					self.obj.trigger('menu_item_selected');
					self.context_menu?.emit('task_context_menu.component.selected', 'stage')
					return false;
				},
				callback_delete: function() {
					self.get_container('stage').html(App.helper.template.fill('task_grid_create_stage_empty', self.backups.stage));
					self.obj.trigger('change');
					self.context_menu?.emit('task_context_menu.component.cleared', 'stage')
				},
				saveBackup: function() {
					const container = self.get_container('stage');
					self.backups.stage = container.find('[data-render-params]').data('render-params');
				},
				is_selected: function() {
					return self.get_container('stage').find('input').val() >= 0;
				}
			},

			labels: {
				limit_tag_group: null,
				ids_hidden_tags: [],
				init: function() {
					self.obj.add(self.selector_more_menu).on('click', '[data-container=labels]', function(e, data) {
						self.components.labels.limit_tag_group = $(this).is('[data-filter]') ? $(this).attr('data-filter') : null;
						data ||= {}
						if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							if ($(this).is('[data-filter]')) self.components.labels.callback_delete_group($(this).attr('data-filter'));
							else self.components.labels.callback_delete();
						} else {
							App.controls.project_task_labels_and_go.show_context(data?.anchor || this, App.helper.url.add_query(self.obj.attr('data-endpoint'), App.actions.get('project_task_labels_and_go:show')), {
								backup: data?.backup || !!$(this).closest(self.selector_more_menu).length,
								onload: function() {
								},
								onshow: function() {
									// let menu = $(this);
									// menu.off('after_interaction.unique').on('after_interaction.unique', function() {
									// 	self.components.labels.callback.call(menu);
									// });
									self.components.labels.ids_hidden_tags = [];
									$(this).find('.editBlock__picker__item').remove();
									$(this).find('.menu__group-bottom').removeClass('menu__group-hidden');
									$(this).find('.tagsSingleSelect__group').addClass('menu__group-searchable').removeClass('menu__group-hidden');
									if (self.components.labels.limit_tag_group != null) {
										$(this).find('.tagsSingleSelect__group').not('[data-group='+self.components.labels.limit_tag_group+']').removeClass('menu__group-searchable').addClass('menu__group-hidden');
										$(this).find('.menu__group-bottom').addClass('menu__group-hidden');
									}
									let ids = self.get_container('labels').find('input').length ? self.get_container('labels').find('input').val().split(',').map(Number) : []
									$(this).find('.menu__item[data-id]').removeClass('menu__item-picked').filter(function() {
										let match = ids.includes($(this).attr('data-id').toInt());
										if (match && self.components.labels.limit_tag_group != null && $(this).closest('.tagsSingleSelect__group').attr('data-group') != self.components.labels.limit_tag_group) {
											self.components.labels.ids_hidden_tags.push($(this).attr('data-id').toInt());
											return false;
										}
										return match;
									}).trigger('preset');
								},
								onhide: function() {
									let menu = $(this);
									self.components.labels.callback.call(menu);
								},
							});
						}
					});
				},
				show: function (element) {
					self.obj.add(self.selector_more_menu).find('[data-container=labels]').first().trigger('click', {
						anchor: element,
						backup: true
					});
				},
				clear: function () {
					self.components.labels.callback_delete();
				},
				callback: function() { // this = menu
					let o = $(this).closest('.menu').find('.menu__item-picked');
					if (o.length === 0) { // none selected fallback
						self.components.labels.callback_delete();
						return false;
					}
					let ids = self.components.labels.ids_hidden_tags.slice();
					o.each(function() {
						let id_tag = $(this).attr('data-id');
						ids.push(id_tag);
					});
					self.components.labels.redraw(ids);
					self.obj.trigger('change');
					self.obj.trigger('menu_item_selected');
					self.context_menu?.emit('task_context_menu.component.selected', 'labels')
					return false;
				},
				callback_delete_group: function(filter) {
					let ids = self.get_container('labels').find('input').length ? self.get_container('labels').find('input').val().split(',').map(Number) : [];
					ids = ids.filter(id_tag => App.tags[id_tag].id_group != filter);
					self.components.labels.redraw(ids);
				},
				callback_delete: function() {
					self.components.labels.redraw([]);
					self.obj.trigger('change');
					self.context_menu?.emit('task_context_menu.component.cleared', 'labels')
				},
				redraw(ids) {
					self.get_container('labels').each(function() {
						let tags = [];
						let filter = $(this).is('[data-filter]') ? $(this).attr('data-filter') : null;
						ids.forEach(function(id_tag) {
							if (filter != null && App.tags[id_tag].id_group != filter) return;
							tags.push({
								name: App.tags[id_tag].name,
								color: App.tags[id_tag].color,
								space: tags.length > 1 && tags[tags.length-1].id_group !== App.tags[id_tag].id_group ? '<em></em>' : '',
								id_group: App.tags[id_tag].id_group
							});
						})
						if (tags.length) $(this).html(App.helper.template.fill('task_grid_create_labels', {
							name: App.format.quantity(tags.length, App.object_state.locale['labels'], QTY_WITH_TEXT),
							ids: ids.join(','),
							tags
						})); else $(this).html(App.helper.template.fill('task_grid_create_labels_empty'));
					});
				},
				is_selected: function() {
					return self.get_container('labels').find('input').val()?.toIntArray().length > 0;
				}
			},

			priority: {
				init: function() {
					self.obj.add(self.selector_more_menu).on('click', '[data-container=priority]', function(e, data = {}) {
						if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							self.components.priority.clear();
						} else {
							App.controls.priority.open(this, {
								backup: data?.backup || !!$(this).closest(self.selector_more_menu).length,
								anchor: data?.anchor || this,
								current: self.get_container('priority').find('input').val()
							}, self.components.priority.callback);
						}
					});
				},
				show: function (element) {
					self.obj.add(self.selector_more_menu).find('[data-container=priority]').first().trigger('click', {
						anchor: element,
						backup: true
					});
				},
				clear: function () {
					self.components.priority.callback_delete();
				},
				callback: function() { // this = menu__item
					if ($(this).attr('data-id') == 1) {
						self.components.priority.callback_delete();
					} else {
						self.get_container('priority').html(App.helper.template.fill('task_grid_create_priority', {
							id: $(this).attr('data-id'),
							html: $(this).find('span:first-child').html(),
							text: $(this).find('span.in').text(),
						}));
						self.obj.trigger('change');
						self.obj.trigger('menu_item_selected');
						self.context_menu?.emit('task_context_menu.component.selected', 'priority')
					}
				},
				callback_delete: function() {
					self.get_container('priority').html(App.helper.template.fill('task_grid_create_priority_empty'));
					self.obj.trigger('change');
					self.context_menu?.emit('task_context_menu.component.cleared', 'priority')
				},
				is_selected: function() {
					return self.get_container('priority').find('input').val() >= 0;
				}
			},

			limits: {
				init: function() {
					self.obj.add(self.selector_more_menu).on('click', '[data-container=max_time], [data-container=time], [data-container=max_money], [data-container=money], [data-container=limits]', function (e) {
						if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							self.components.limits.clear();
						} else {
							self.context_menu?.close();
							let max_time = self.get_container('time').find('input[name=max_time]').length ? self.get_container('time').find('input[name=max_time]').val() : '';
							let max_money = self.get_container('money').find('input[name=max_money]').length ? self.get_container('money').find('input[name=max_money]').val() : '';
							const endpoint = App.helper.url.add_query(self.helper_limits_endpoint(), '', {
								...( this.dataset.container !== 'limits' ? { focus: this.dataset.container.replace('max_', '') } : {} ),
								...( this.dataset.container === 'limits' ? { autofocus: true } : {} ),
							});
							App.controls.task_limits_select_and_go.show(endpoint, {
								onload: function () { // this = App.modal.obj_window
									$(this).find('input[name=max_time]').val(max_time).trigger('keyup');
									$(this).find('input[name=max_money]').val(max_money).trigger('keyup');
								},
								onsuccess: self.components.limits.callback
							});
						}
					});
				},
				show: function (element) {
					self.obj.add(self.selector_more_menu).find('[data-container=limits]').first().trigger('click', {
						anchor: element,
						backup: true
					});
				},
				clear: function () {
					self.components.limits.callback_delete();
				},
				callback: function() { // this = App.modal.obj_window
					let max_time = $(this).find('input[name=max_time]').length ? $(this).find('input[name=max_time]').val() : '';
					let max_money = $(this).find('input[name=max_money]').length ? $(this).find('input[name=max_money]').val() : '';

					if (!max_time && !max_money) {
						App.modal.hide({force: true});
						self.components.limits.callback_delete();
						return;
					}

					if (max_time) {
						self.get_container('max_time').html(App.helper.template.fill('task_grid_create_limits_time', {
							max_time
						}));
						self.get_container('time').html(App.helper.template.fill('task_grid_create_limits_time', {
							max_time
						}));
					}
					if (max_money) {
						self.get_container('max_money').html(App.helper.template.fill('task_grid_create_limits_money', {
							max_money,
						}));
						self.get_container('money').html(App.helper.template.fill('task_grid_create_limits_money', {
							max_money,
						}));
					}
					App.modal.hide({force: true});
					self.obj.trigger('change');
					self.obj.trigger('menu_item_selected');
					self.context_menu?.emit('task_context_menu.component.selected', 'limits')
				},
				callback_delete: function() {
					self.get_container('max_time').html(App.helper.template.fill('task_grid_create_limits_empty'));
					self.get_container('time').html(App.helper.template.fill('task_grid_create_limits_empty'));
					self.get_container('max_money').html(App.helper.template.fill('task_grid_create_limits_empty'));
					self.get_container('money').html(App.helper.template.fill('task_grid_create_limits_empty'));
					self.context_menu?.emit('task_context_menu.component.cleared', 'limits')
					self.obj.trigger('change');
				},
				is_selected: function() {
					let max_time = self.get_container('time').find('input[name=max_time]').val();
					let max_money = self.get_container('money').find('input[name=max_money]').val();

					return Boolean(max_time || max_money);
				}
			},

			subscribers: {
				init: function() {
					self.obj.add(self.selector_more_menu).on('click', '[data-container=subscribers]', function(e, data) {
						if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							self.components.subscribers.clear();
						} else {
							let ids_project = self.components.project.get_ids();
							let ids = self.obj.find('input[name=ids_subscribe]').val().toIntArray();
							let request = {type: 'subscribers'}
							if (ids_project.length > 1) request.ids_project = ids_project.join(',');
							let hidden = self.obj.find('input[name=hidden]').val().toIntArray();
							if (hidden.length) request.hidden = hidden.join(',');
							App.controls.user_select_and_go.show_context(data?.anchor || this, self.helper_user_endpoint(), {
								request,
								backup: data?.backup || !!$(this).closest(self.selector_more_menu).length,
								onload: function () {
									App.controls.menu.init($(this));
								},
								onshow: function () {
									let menu = $(this);
									menu.off('click.app.subscribers_menu.done', '.menu__group-head ws-btn').on('click.app.subscribers_menu.done', '.menu__group-head ws-btn', () => {
										self.components.subscribers.callback.call(menu);
										App.menu.hide();
									});
									menu.find('.menu__item[data-id]').each(function () {
										$(this).toggleClass('menu__item-active', ids.includes($(this).attr('data-id').toInt()));
									});
									menu.trigger('after_interaction');
								}
							});
						}
					});
				},
				show: function (element) {
					self.obj.add(self.selector_more_menu).find('[data-container=subscribers]').first().trigger('click', {
						anchor: element,
						backup: true
					});
				},
				clear: function () {
					self.components.subscribers.callback_delete();
				},
				callback: function () { // this = menu
					let o = $(this).find('.menu__item-active');
					let ids = [];
					o.each(function() {
						ids.push($(this).attr('data-id'));
					});
					self.obj.find('input[name=ids_subscribe]').val(ids.join(','));
					self.obj.trigger('change');
					self.obj.trigger('menu_item_selected');
					if (ids.length > 0) {
						self.context_menu?.emit('task_context_menu.component.selected', 'subscribers', {
							counter: ids.length
						})
					} else {
						self.context_menu?.emit('task_context_menu.component.cleared', 'subscribers')
					}
					return false;
				},
				callback_delete: function() {
					self.obj.find('input[name=ids_subscribe]').val('');
					self.obj.trigger('change');
					self.context_menu?.emit('task_context_menu.component.cleared', 'subscribers')
				},
				is_selected: function() {
					return Boolean(self.get_container('subscribers').find('input').val());
				},
				get_counter: function() {
					const ids_str = self.get_container('subscribers').find('input').val() ?? '';
					return ids_str.toIntArray().length;
				}
			},

			visibility: {
				get_preset: function() {
					return self.obj.attr('data-visibility-preset') || '';
				},
				set_preset: function(type) {
					if (type) self.obj.attr('data-visibility-preset', type);
					else self.obj.removeAttr('data-visibility-preset');
				},
				is_me_mode: function() {
					if (self.components.visibility.get_preset() === 'me') return true;
					let hidden = self.obj.find('input[name=hidden]').val().toIntArray();
					return hidden.length === 1 && hidden[0] === App.me.id;
				},
				apply_preset: function(id_user_to) {
					if (!self.components.visibility.is_me_mode()) return;
					let hidden = [App.me.id];
					if (id_user_to >= App.config.real_user_id && id_user_to !== App.me.id) hidden.push(id_user_to);
					self.components.team.callback(hidden);
					self.components.visibility.set(hidden, []);
				},
				init: function() {
					self.obj.add(self.selector_more_menu).on('click', '[data-container=hidden]', function(e, data) {
						if (!self.obj.find('input[name=hidden]').val() && !self.obj.find('input[name=guests]').val()) {
							App.menu.show({
								anchor: data?.anchor || this,
								backup: data?.backup || !!$(this).closest(self.selector_more_menu).length,
								replace: data?.replace || false,
								box: '#taskGridCreate__menu__visibility_preset'
							});
						} else if ($(e.target).parents().addBack().filter(self.selector_component_delete).length) {
							self.components.visibility.clear();
						} else {
							let ids_project = self.components.project.get_ids();
							let request = {type: 'visibility'};
							if (ids_project.length > 1) request.ids_project = ids_project.join(',');
							App.controls.visibility_switch_and_go.show_context(data?.anchor || this, self.helper_user_endpoint(), {
								request,
								backup: data?.backup || !!$(this).closest(self.selector_more_menu).length,
								replace: data?.replace || false,
								onshow: function () {
									let menu = $(this);
									menu.off('click.app.visibility_menu.done', '.menu__group-head ws-btn').on('click.app.visibility_menu.done', '.menu__group-head ws-btn', () => self.components.visibility.callback.call(menu));
									menu.off('click.app.visibility_menu.clear', '.menu__group-buttons ws-btn').on('click.app.visibility_menu.clear', '.menu__group-buttons ws-btn', function() {
										App.menu.hide();
										self.components.visibility.callback_delete();
									});
									let hidden = self.obj.find('input[name=hidden]').val().toIntArray();
									let guests = self.obj.find('input[name=guests]').val().toIntArray();
									let hidden_defaults = [App.me.id, self.components.assignee.get_id()];
									menu.find('.menu__group[data-group]').each(function () {
										let id_group = $(this).attr('data-group').toInt();
										$(this).find('.menu__item[data-id]').each(function () {
											let id_user = $(this).attr('data-id').toInt();
											let is_active;
											if (hidden.length) {
												is_active = hidden_defaults.includes(id_user) || hidden.includes(id_user) || (hidden.includes(-id_group) && (!$(this).hasClass('menu__item-guest') || guests.includes(id_user)))
											} else {
												is_active = !$(this).hasClass('menu__item-guest') || guests.includes(id_user) || hidden_defaults.includes(id_user)
											}
											$(this).toggleClass('menu__item-active', is_active).toggleClass('menu__item-default', hidden_defaults.includes(id_user));
										});
									});
									menu.find('.menu__group-buttons').toggle(!self.get_container('hidden').hasClass('require'));
								},
								onhide: function() {
									self.components.visibility.on_menu_hide();
								},
							});
						}
					});
				},
				show: function (element, params = {}) {
					self.obj.add(self.selector_more_menu).find('[data-container=hidden]').first().trigger('click', {
						backup: true,
						...params,
						anchor: element,
					});
				},
				show_custom: function(anchor) {
					self.components.visibility.set_preset('custom');

					let ids_subscribe = self.obj.find('input[name=ids_subscribe]').val().toIntArray();
					if (!ids_subscribe.includes(App.me.id)) ids_subscribe.push(App.me.id);
					self.obj.find('input[name=hidden]').val(ids_subscribe.join(','));
					self.components.visibility.show(anchor, { replace: true, backup: false });
				},
				clear: function () {
					self.components.visibility.callback_delete();
				},
				preset: function(type) {
					App.menu.hide();
					self.components.visibility.set_preset(type);

					let hidden = [];
					let id_user_to = self.components.assignee.get_id();
					switch (type) {
						case 'department':
							App.controls.user_select_and_go.team(self.helper_user_endpoint('team') + '&preset=department', function(ids) {
								hidden = ids;
								if (id_user_to>= App.config.real_user_id && !ids.includes(id_user_to)) {
									hidden.push(id_user_to);
									ids.push(id_user_to);
								}
								self.components.team.callback(ids);
								self.components.visibility.set(hidden, []);
							});
							break;
						case 'team':
							hidden.push(-App.me.id_group);
							App.controls.user_select_and_go.team(self.helper_user_endpoint('team') + '&preset=team', function(ids) {
								if (id_user_to>= App.config.real_user_id && !ids.includes(id_user_to)) {
									hidden.push(id_user_to);
									ids.push(id_user_to);
								}
								self.components.team.callback(ids);
								self.components.visibility.set(hidden, []);
							});
							break;
						case 'me':
						default:
							hidden.push(App.me.id);
							if (id_user_to>= App.config.real_user_id && id_user_to !== App.me.id) hidden.push(id_user_to);
							self.components.team.callback(hidden);
							self.components.visibility.set(hidden, []);
					}
				},
				callback: function() { // this = menu
					let hidden = [];
					let guests = [];
					$(this).find('.menu__group[data-group]').each(function () {
						let id_group = $(this).attr('data-group').toInt();
						if (!$(this).find('.menu__item[data-id]').not('.menu__item-guest').not('.menu__item-active').length) {
							hidden.push(-id_group);
							$(this).find('.menu__item-guest[data-id].menu__item-active').each(function () {
								hidden.push($(this).attr('data-id').toInt());
							});
						} else {
							$(this).find('.menu__item-active[data-id]').each(function () {
								hidden.push($(this).attr('data-id').toInt());
							})
						}
					});
					$(this).find('.menu__item-guest.menu__item-active').each(function() {
						guests.push($(this).attr('data-id').toInt());
					});

					self.components.visibility.set_preset('');
					self.components.visibility.set(hidden, guests);
					App.menu.hide();
				},
				on_menu_hide: function() {
					if (self.components.visibility.get_preset() !== 'custom') return;
					let hidden = self.obj.find('input[name=hidden]').val().toIntArray();
					if (hidden.length !== 1 || hidden[0] !== App.me.id) return;
					self.components.visibility.clear();
				},
				callback_delete: function() {
					self.components.visibility.set_preset('');
					self.components.visibility.set([], []);
				},
				set: function(hidden, guests) {
					self.obj.find('input[name=is_hidden]').val(hidden.length ? 1 : 0);
					self.obj.find('input[name=hidden]').val(hidden.join(','));
					self.obj.find('input[name=guests]').val(guests.join(','));
					self.obj.trigger('menu_item_selected');
					self.obj.trigger('change');
					if (hidden.length) {
						self.context_menu?.emit('task_context_menu.component.selected', 'visibility')
					} else {
						self.context_menu?.emit('task_context_menu.component.cleared', 'visibility')
					}
				},
				is_selected: function() {
					return self.get_container('hidden').find('input[name=is_hidden]').val() == 1;
				}
			},
		},

		helper_user_endpoint: function(type) {
			type ||= 'show';
			if (self.get_container('parent').find('input').length) { // no parent
				return App.helper.url.add_query(self.get_container('parent').find('input').attr('data-url'), App.actions.get('task_user_select_and_go:' + type));
			} else {
				return App.helper.url.add_query(self.obj.attr('data-old-endpoint'), App.actions.get('user_select_and_go:' + type));
			}
		},

		helper_limits_endpoint: function() {
			if (self.get_container('parent').find('input').length) { // no parent
				return App.helper.url.add_query(self.get_container('parent').find('input').attr('data-url'), App.actions.get('task_limits_select_and_go:show'));
			} else {
				return App.helper.url.add_query(self.obj.attr('data-endpoint'), App.actions.get('project_limits_select_and_go:show'));
			}
		},
		// DEPRECATED:
		helper_params_by_filter: function () {
			if (App.filter.have_data()) {
				if (App.filter.data.assignee && App.page.match_tree?.all?.length) {
					for (let id of App.page.match_tree.all) {
						let component = $(App.controls.datatable.getObjBody()).find('task-assignee[data-task='+id+']');
						if (component.find('span[data-user='+App.filter.data.assignee+']').length) {
							let id_user_to = parseInt(App.filter.data.assignee);
							let ids_subscribe = self.obj.find('input[name=ids_subscribe]').val().toIntArray();
							self.get_container('assignee').html(App.helper.template.fill('task_grid_create_assignee', {
								name: component.find('.in').text(),
								avatar: component.find('.av_sm').get(0).outerHTML,
								id: App.filter.data.assignee,
							}));
							if (id_user_to>= App.config.real_user_id && !ids_subscribe.includes(id_user_to)) {
								ids_subscribe.push(id_user_to);
								self.obj.find('input[name=ids_subscribe]').val(ids_subscribe.join(','));
								if (ids_subscribe.length > 0) {
									self.context_menu?.emit('task_context_menu.component.selected', 'subscribers', {
										counter: ids_subscribe.length
									})
								} else {
									self.context_menu?.emit('task_context_menu.component.cleared', 'subscribers')
								}
							}
							self.obj.trigger('change');
							break;
						}
					}
				}
				if (App.filter.data.priority && App.filter.data.priority.length === 1 && App.page.match_tree?.all?.length) {
					let priority = App.filter.data.priority[0] - 100;
					self.get_container('priority').html(App.helper.template.fill('task_grid_create_priority', {
						id: priority,
						html: priority,
						text: priority,
					}));
					self.obj.trigger('change');
				}
			}
		},

		onReadyPage: function() {
			App.ui.onMouse('#mass_n_filt', '.add_task', {
				click: (e) => {

					const options = App.task_grid_create.components.project.get_ids().length > 0 ? {} : {
						anchor: e.el,
						select_project: true,
					};

					let obj_dock = App.task_grid_create.get_task_filter_dock();

					App.task_grid_create.show(obj_dock, options);
				},
				dblclick: (e) => {
					let params = e.el.getAttribute('data-params');
					if (App.page.is_task_filter) {
						params = (params ? params + '&' : '') + 'id_parent=' + App.page.is_task_filter;
					}
					App.task_create.new(params);
				}
			});
		},

		onUnloadPage: function() {
			App.task_grid_create.destructor();
		},
	}
})();

;var App = App || {};

(function() {
	let self = App.task_panel = {

		is_collapsed: null,

		obj: null,
		obj_menu: null,
		data: [],
		version: 1,
		click_after_load: null,

		is_shown: function() {
			return $('body').hasClass('withTaskPanel');
		},

		click: function(el) {

			const { component, name } = self.item._get_component_by_item($(el));

			if ($(el).hasClass('taskPanel__item-active') && component.window.is_opened()) {
				component.minimize();
				return;
			}

			if (name === 'task_create') {
				return App.window.task_create.open($(el).attr('data-draft'));
			}
			if (name === 'file_create') {
				return App.window.file_create.open($(el).attr('data-file-draft'));
			}
			if (name === 'task_view') {
				return App.window.task_view.open({url: $(el).attr('data-href'), anchor: el});
			}
			if (name === 'chat_view') {
				return App.window.chat_view.open({url: $(el).attr('data-href'), anchor: el});
			}

			if (name === 'timer_view') {
				let btn = $('#taskPanel').find('.taskPanel__item-costs, .taskPanel__item-timer');
				if (btn.length) {
					btn.find('.badge').removeAttr('data-ids').empty();
				}
			}

			App.windows.open(name);
		},

		remove: function(el) {
			throw new Error("Deprecated use self.item.remove instead");
		},

		_remove: function(el) {
			const { component, name } = self.item._get_component_by_item($(el));
			if (['task_create', 'file_create', 'task_view', 'chat_view'].includes(name)) {
				component.remove_from_task_panel(el);
				return;
			}
			self.item.remove(component);
		},

		update_symbols: function() {
			let symbol;
			for (let i in self.data) {
				symbol = self.obj.find('.taskPanel__item[data-panel-id='+self.data[i].panel_id+']').find('.av_nm, .proj_color, .priorb');
				if (symbol.length) self.data[i].symbol = symbol.get(0).outerHTML.trim();
			}
			self.save();
		},

		find_one: function(criteria) {
			for (let i in self.data) {
				let item = self.data[i];
				let match = true;

				for (let key in criteria) {
					if (Array.isArray(criteria[key])) {
						if (!criteria[key].includes(item[key])) {
							match = false;
							break;
						}
					} else {
						if (item[key] !== criteria[key]) {
							match = false;
							break;
						}
					}
				}

				if (match) return item;
			}

			return null;
		},

		update_one: function(criteria, data, redraw = true) {
			const item = self.find_one(criteria);

			if (!item) return;

			// Object.assign(item, data); // we have nesting
			$.extend(true, item, data)

			if (redraw) {
				self.redraw_one_debounced(item);
			}
		},

		update: function(data) {
			self.data = data;
			self.draw();
			self.save(true);
		},

		last_save: '',
		send_state: function() {
			const message = {
				command: 'task_panel',
				data: self.data,
				dt: (new Date).getTime() + Math.random()
			};
			App.core.send_message_to_other_tabs(message);
			App.core.send_message_to_other_devices(message);
		},
		save: function(skip_db) {
			if (!skip_db) self.send_state();
			let db_data = [], match;
			for (let i in self.data) {
				switch (self.data[i].type)
				{
					case 'notebook':
						db_data.push({type: 'notebook'});
						break;
					case 'queue':
						db_data.push({type: 'queue'});
						break;
					case 'timer':
						db_data.push({type: 'timer'});
						break;
					case 'task':
						match = self.data[i].url.match(App.helper.validate.task_url);
						if (match) db_data.push({type: 'task', id: parseInt(match[1])});
						else { // old url scheme fallback
							match = self.data[i].url.match(App.helper.validate.task_url_fallback);
							db_data.push({type: 'task', id: parseInt(match[4] || match[2])});
						}
						break;
					case 'chat':
						match = self.data[i].url.match(App.helper.validate.chat_url);
						db_data.push({type: 'chat', personal: !!match[1], id: parseInt(match[2])});
						break;
					case 'draft':
						db_data.push({type: 'draft', id: self.data[i].id});
						break;
					case 'file_draft':
						db_data.push({type: 'file_draft', id: self.data[i].id});
						break;
				}
			}
			if (self.last_save !== JSON.stringify(db_data)) {
				self.last_save = JSON.stringify(db_data);
				if (!skip_db) $.ajax({
					type: 'POST',
					url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('task_panel:save')),
					data: {data: self.last_save}
				});
			}
		},

		get_by_url: function(url) {
			for (let i in self.data) {
				if (self.data[i].type === 'task' && self.data[i].url === url) return self.obj.find('.taskPanel__item-task[data-panel-id='+self.data[i].panel_id+']');
			}
			return false;
		},

		draw: function() {
			let html  = [], html_menu = [];

			html.push(App.helper.template.fill('task_panel_close'));

			for (let i in self.data) {
				const res = self.get_item_html(self.data[i]);
				if (res.html) html.push(res.html);
				if (res.html_menu) html_menu.push(res.html_menu);
			}

			html.push(App.helper.template.fill('task_panel_more'));

			// $(document).trigger('on_panel_before_update'); // TODO see no usage, remove?

			if (self.obj) {
				self.obj.destroyComponents();
				self.obj.html(html.join(''));
			}

			if (self.obj_menu) {
				self.obj_menu.destroyComponents();
				self.obj_menu.html('<div class="menu__group scrollZone">' + html_menu.join('') + '</div>');
			}

			self.onresize();

			// $(document).trigger('on_panel_update'); // TODO see no usage, remove?
		},

		get_item_html: function(item) {
			let params = {}, html = '', html_menu = '';

			switch (item.type)
			{
				case 'notebook':
					params = {
						panel_id: item.panel_id,
					};
					html = App.helper.template.fill('task_panel_notebook', params);
					html_menu = App.helper.template.fill('task_panel_menu_notebook', params);
					break;
				case 'queue':
					params = {
						panel_id: item.panel_id,
						run: item.run,
						done: item.total - item.run,
						total: item.total,
						progress: item.progress
					};
					html = App.helper.template.fill('task_panel_queue', params);
					// no menu duplicate
					break;
				case 'timer':
					if (item.timer.active) item.timer.time_formatted = App.format.timer_seconds(item.timer.time);
					item.costs.time_formatted = App.format.time(60 * item.costs.time, true);
					params = {
						panel_id: item.panel_id,
						timer: item.timer,
						costs: item.costs,
						today_plan: item.today_plan > 0 ? item.today_plan : '',
					};
					html = App.helper.template.fill('task_panel_timer', params);
					// no menu duplicate
					break;
				case 'task':
					params = {
						panel_id: item.panel_id,
						url: item.url,
						id_task: item.id_task,
						name: App.components.expand('task-name', {
							task: item.id_task,
							format: 'chip',
						}, { name: item.name }),
						terms_class: item.stage_data.status ? 'completed' : '',
						symbol: App.components.expand('task-stage', {
							task: item.id_task,
							format: 'task_workflow',
						}, item.stage_data),
						unseen: App.components.expand('task-unseen', {
							task: item.id_task,
							format: 'task_panel',
						}, item.unseen_data),
					};
					html = App.helper.template.fill('task_panel_task', params);
					html_menu = App.helper.template.fill('task_panel_menu_task', params);
					break;
				case 'chat':
					params = {
						panel_id: item.panel_id,
						url: item.url,
						name: item.name,
						symbol: item.symbol,
						unseen: App.components.expand('task-unseen', {
							task: item.id_task,
							format: 'task_panel',
						}, item.unseen_data),
					};
					html = App.helper.template.fill('task_panel_chat', params);
					html_menu = App.helper.template.fill('task_panel_menu_chat', params);
					break;
				case 'draft':
					params = {
						panel_id: item.panel_id,
						id: item.id,
						name: item.name
					};
					html = App.helper.template.fill('task_panel_draft', params);
					html_menu = App.helper.template.fill('task_panel_menu_draft', params);
					break;
				case 'file_draft':
					params = {
						panel_id: item.panel_id,
						id: item.id,
						name: item.name
					};
					html = App.helper.template.fill('task_panel_file_draft', params);
					html_menu = App.helper.template.fill('task_panel_menu_file_draft', params);
					break;
			}

			return { html, html_menu };
		},

		redraw_one: function(item) {
			if (!item) return;

			const panel_id = +item.panel_id;

			const res = self.get_item_html(item);

			if (res.html) {
				const $old = self.obj.find('[data-panel-id="'+panel_id+'"]');
				if ($old.length) {
					$old.destroyComponents();
					$old.replaceWith(res.html);
				}
			}

			if (res.html_menu) {
				let $oldMenu = self.obj_menu.find('[data-panel-id="'+panel_id+'"]');
				if ($oldMenu.length) {
					$oldMenu.destroyComponents();
					$oldMenu.replaceWith(res.html_menu);
				}
			}

			self.onresize();
		},

		redraw_queues: {},
		redraw_one_debounced: function(item) {
			if (!item || !item.panel_id) return;

			const panel_id = +item.panel_id;

			if (!self.redraw_queues[panel_id]) {
				self.redraw_queues[panel_id] = App.helper.debounce(function(queuedItem) {
					self.redraw_one(queuedItem);
					delete self.redraw_queues[panel_id];
				}, 50);
			}

			self.redraw_queues[panel_id](item);
		},

		update_counter: function() {
			let cnt = $('.taskPanel__item').length;
			$('.taskPanel__counter').toggleClass('taskPanel__counter-active', !!cnt).find('> .in').html(cnt);
		},

		onresize: function() {
			if (!self.obj) return;

			let cnt = $('.taskPanel__item').length;
			$('.taskPanel__counter').toggleClass('taskPanel__counter-active', !!cnt).find('> .in').html(cnt);
			$('body').toggleClass('withTaskPanel', !!cnt && !self.is_collapsed);
			$('.taskPanel').toggleClass('taskPanel--empty', !cnt);

			let o = self.obj.find('.taskPanel__item, > ws-btn');
			if ($(window).width() <= APP_SCREEN_THRESHOLD) {
				o.filter('.taskPanel__item').show();
				o.filter('.more').hide();
			} else {
				let w_items = 0, w_close = 0, w_more = 0, w_act = 0, w = self.obj.width() - 20;
				let gap = 8;
				o.filter('.more').find('span').html(App.object_state.locale.more.replace('%s', cnt)); // max width available
				o.show().each(function () {
					if ($(this).hasClass('more')) {
						w_more = $(this).outerWidth();
					} else if ($(this).hasClass('taskPanel__item-active')) {
						w_act = $(this).outerWidth() + gap;
					} else if ($(this).hasClass('remove')) {
						w_close = $(this).outerWidth() + gap;
					} else {
						w_items += $(this).outerWidth() + gap;
					}
				})
				let cnt_hid = 0;
				if (w_items + w_close + w_act <= w) {
					o.show().filter('.more').hide();
					if (App.menu.is_shown() && App.menu.active_anchor === o.filter('.more').get(0)) {
						App.menu.hide();
					}
				} else {
					w_items = 0;
					$('#taskPanel__menu .menu__item').hide();
					o.each(function () {
						w_items += $(this).outerWidth();
						if ($(this).hasClass('more') || $(this).hasClass('remove') || $(this).hasClass('taskPanel__item-active')) {
							$(this).show();
						} else {
							let o_copy = $('#taskPanel__menu .menu__item[data-panel-id=' + $(this).attr('data-panel-id') + ']')
							let is_shown = w_items + w_more + w_close + w_act <= w;
							$(this).toggle(is_shown);
							if (!is_shown) {
								cnt_hid++;
								o_copy.show();
							}
						}
					});
					o.filter('.more').toggle(!!cnt_hid).find('span').html(App.object_state.locale.more.replace('%s', cnt_hid));
					if (!cnt_hid) {
						if (App.menu.is_shown() && App.menu.active_anchor === o.filter('.more').get(0)) {
							App.menu.hide();
						}
					}
				}
			}
		},

		load: function() {
			$.ajax({
				url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('task_panel:load')),
				dataType: 'json',
				success: function (data) {
					const extract_data = (data) => {
						let config = {
							collapsed: false
						};
						const tabs = [];

						for (const item of data) {
							if (item.type === 'config') {
								delete item.type
								$.extend(config, item);
							} else {
								tabs.push(item);
							}
						}

						return [config, tabs];
					};

					const [{collapsed}, tabs] = extract_data(data || []);

					self.is_collapsed = Boolean(collapsed);
					self.data = tabs;
					$('body').toggleClass('withTaskPanel', !self.is_collapsed);
					for (let i in self.data) {
						self.data[i].panel_id = Math.floor(1000 + Math.random()*8999);
					}
					self.save(true);
					self.draw();
					if (self.click_after_load) {
						$(self.click_after_load).click();
						self.click_after_load = null;
					}
				},
			});
		},

		replaceOrAppend: function(data) {
			for (let i in self.data) if (self.data[i].type === data.type) {
				data.panel_id = self.data[i].panel_id;
				self.data[i] = data;
				self.save();
				self.draw();
				return;
			}
			self.append(data);
		},

		append: function(data) {
			let data_beginning = [];
			data.panel_id = Math.floor(1000 + Math.random() * 8999);
			// timer should be first
			// queue should be second
			if (data.type !== 'timer') while (self.data.length && ['timer', 'queue'].includes(self.data[0].type)) data_beginning.push(self.data.shift());
			self.data.unshift(data);
			while (data_beginning.length) self.data.unshift(data_beginning.pop());
			self.save();
			self.draw();
		},

		_get_state_category: function() {
			return App.device.is_mobile() ? UIStateManager.CATEGORIES.MOBILE : UIStateManager.CATEGORIES.DEFAULT
		},

		_save_state: function(state) {
			App.classes.ui_state_manager.getInstance().setState(
				'task_panel_collapsed',
				Boolean(state),
				self._get_state_category()
			);
		},

		expand: function () {
			self.is_collapsed = false;
			$('body').addClass('withTaskPanel');
			App.sidebar.set_optional_menu();
			self._save_state(false);

			App.bus.window.emit('resize.page');
			self.onresize();
		},
		collapse: function () {
			self.is_collapsed = true;
			$('body').removeClass('withTaskPanel');
			App.sidebar.set_optional_menu();
			self._save_state(true);

			const active_item = self.obj.find('.taskPanel__item-active').first();
			if (active_item.length) self.item.minimize_all(active_item);
			App.bus.window.emit('resize.page');
		},

		redraw_daily: function(min, hour) {
			if (hour === 0 && min === 1) {
				self.load();
				App.timer_view.invalidate_window();
			}
		},

		onload: function() {
			self.obj = $('#taskPanel');
			self.obj.off();
			self.obj_menu = $('<div id="taskPanel__menu" class="menu menu-primary menu-alwaysRemain"></div>').appendTo('body');
			App.ui.onMouse(self.obj, '.taskPanel__item', {
				click: function (e) {
					if ($(e.target).parents().addBack().filter('.close').length) {
						self._remove(e.el);
						self.onresize();
					} else {
						self.click(e.el);
					}
				},
				context: function (e) {
					const { name } = self.item._get_component_by_item($(e.el));
					if (name !== 'timer_view') {
						return;
					}
					const id_task = $(e.el).attr('data-task-id');
					App.menu.show({
						anchor: e.el,
						box: $('#quickTimerMenu'),
						force_dropdown: true,
						onshow: function () {
							const menu = $(this);
							menu.find('[data-key=open]').toggleClass('menu__item-hidden', !id_task);
							menu.off('click.quickTimerMenu').on('click.quickTimerMenu', '[data-key]', function () {
								switch ($(this).attr('data-key')) {
									case 'open':
										App.menu.hide();
										if (id_task) App.core.goto(App.helper.url.task(id_task));
										else throw new Error('No task id');
										break;
									case 'costs':
										App.menu.hide();
										self.click(e.el);
										break;
								}
							});
						}
					})
				}
			})
			self.obj.on('mouseover', '.taskPanel__item', function(e) {
				if (App.scroll_listener.is_scrolling) return;
				$(this).css('max-width', $(this).outerWidth()).addClass('taskPanel__item-hover');
				// if ($(e.target).closest('.close').length) {
				// 	$(this).addClass('taskPanel__item-closeHover')
				// }
			}).on('mouseout', '.taskPanel__item', function(e) {
				if (App.scroll_listener.is_scrolling) return;
				$(this).css('max-width', '').removeClass('taskPanel__item-hover');
				// $(this).css('max-width', '').removeClass('taskPanel__item-hover taskPanel__item-closeHover');
			})
			self.obj_menu.on('click', '.menu__item', function(e) {
				if ($(e.target).parents().addBack().filter('.close').length) {
					self._remove(this);
					self.onresize();
				} else {
					self.click(this);
				}
			});
			$('.taskPanel__counter').on('click', function () {
				self.expand();
			});
			self.obj.on('click', 'ws-btn.remove', function () {
				self.collapse();
			});
			self.obj.on('click', 'ws-btn.more', function() {
				App.menu.show({
					anchor: this,
					box: '#taskPanel__menu',
					type: '',
				});
			});
			App.helper.cron.add('task_panel', (min, hour) => this.redraw_daily(min, hour));
		},
		destructor: function() {
			App.helper.cron.remove('task_panel');
			$('#taskPanel').off().html('').removeClass('taskPanel--empty');
			$('#taskPanel__menu').html('');
			$('#taskPanel__counter').removeWithComponents();
			$('body').removeClass('withTaskPanel');
			self.is_collapsed = null;
			self.obj = null;
			self.obj_menu = null;
			self.data = [];
			self.click_after_load = null;
			self.last_save = '';
			self._layers.destructor();
		},

		item: {
			exists: function (component) {
				const item = self.item.find(typeof component === 'string' ? App.windows.get_component(component) : component);

				return item.panel_item.length > 0 || item.menu_item.length > 0;
			},
			find: function (component) {
				let panel_item, menu_item, wrapper;
				switch (component.obj_wrapper.attr('id')) {
					case 'taskView__wrapper':
						panel_item = self.obj.find('.taskPanel__item[data-href="'+CSS.escape(component.url)+'"]');
						menu_item = self.obj_menu.find('.menu__item[data-href="'+CSS.escape(component.url)+'"]');
						wrapper = component.obj_wrapper;
						break;
					case 'noteBook__wrapper':
						panel_item = self.obj.find('.taskPanel__item-notebook');
						menu_item = self.obj_menu.find('.menu__item-notebook');
						wrapper = component.obj_wrapper;
						break;
					case 'queueView__wrapper':
						panel_item = self.obj.find('.taskPanel__item-queue');
						menu_item = self.obj_menu.find('.menu__item-queue');
						wrapper = component.obj_wrapper;
						break;
					case 'timerView__wrapper':
						panel_item = self.obj.find('.taskPanel__item-timer, .taskPanel__item-costs').first();
						menu_item = self.obj_menu.find('.menu__item-timer, .menu__item-costs').first();
						wrapper = component.obj_wrapper;
						break;
					case 'taskCreate__wrapper':
						panel_item = self.obj.find('.taskPanel__item-draft[data-draft='+CSS.escape(component.id || component.id_tmp)+']');
						menu_item = self.obj_menu.find('.menu__item-draft[data-draft='+CSS.escape(component.id || component.id_tmp)+']');
						wrapper = component.obj_wrapper;
						break;
					case 'fileCreate__wrapper':
						panel_item = self.obj.find('.taskPanel__item-draft[data-file-draft='+(component.id || component.id_tmp)+']');
						menu_item = self.obj_menu.find('.menu__item-draft[data-file-draft='+(component.id || component.id_tmp)+']');
						wrapper = component.obj_wrapper;
						return { wrapper, panel_item, menu_item };
					case 'sidePanel__wrapper':
					case 'dashboardView__wrapper':
					case 'massTaskCreate__wrapper':
					case 'modalContainer':
						panel_item = $();
						menu_item = $();
						wrapper = component.obj_wrapper;
						return { wrapper, panel_item, menu_item };
					default:
						throw new Error('Unknown wrapper #' + component.obj_wrapper.attr('id'));
				}
				return { wrapper, panel_item, menu_item };
			},
			foreground: function (component) {
				const { panel_item, menu_item, wrapper } = self.item.find(component);

				self.obj.add(self.obj_menu)
					.find('.taskPanel__item-active')
					.removeClass('taskPanel__item-active')
					.addClass('taskPanel__item-inactive');
				panel_item.add(menu_item).addClass('taskPanel__item-active');
				self._layers.set_top_layer(wrapper);

				if (component.on_foreground) component.on_foreground();
			},
			minimize: function (component, highlight = false) {
				const { panel_item, menu_item, wrapper } = self.item.find(component);

				panel_item.add(menu_item).removeClass(['taskPanel__item-active', 'taskPanel__item-inactive']);
				if (highlight) {
					if (panel_item.is(':visible')) {
						panel_item.shortblink();
					} else if (menu_item.is(':visible')) {
						menu_item.shortblink();
					} else {
						self.obj.find('.more').shortblink();
					}
				}
				// self._layers.remove_top_layer(wrapper);
				// self._layers.activate_previous();
			},
			remove: function (component) {
				const { panel_item, menu_item, wrapper } = self.item.find(component);

				self.data = self.data.filter((data) => { return +data.panel_id !== +panel_item.attr('data-panel-id')});
				// self._layers.remove_top_layer(wrapper);
				// self._layers.activate_previous();
				panel_item.removeWithComponents();
				menu_item.removeWithComponents();
				self.save();
				self.onresize();
				event?.stopPropagation();
			},
			remove_by_item: function (item) {
				const panel_id = +item.attr('data-panel-id');
				self.data = self.data.filter((data) => { return +data.panel_id !== panel_id});
				self.obj.find('.taskPanel__item[data-panel-id='+panel_id+']')
					.add(self.obj_menu.find('.menu__item[data-panel-id='+panel_id+']'))
					.removeWithComponents();
				self.save();
				self.onresize();
				event?.stopPropagation();
			},
			update_by_item: function (item, callback) {
				const panel_id = +item.attr('data-panel-id');
				callback(self.obj.find('.taskPanel__item[data-panel-id='+panel_id+']'));
				callback(self.obj_menu.find('.menu__item[data-panel-id='+panel_id+']'));
				// self.save(); ?????!
			},
			minimize_all: function (ommit_item) {

				let ommit_name;
				if (ommit_item && ommit_item.length) {
					const { name } = self.item._get_component_by_item(ommit_item);
					ommit_name = name;
				}

				const components = [
					{ name: 'task_view', component: App.task_view },
					{ name: 'chat_view', component: App.chat_view },
					{ name: 'notebook', component: App.notebook },
					{ name: 'task_create', component: App.task_create },
					{ name: 'file_create', component: App.file_create },
					{ name: 'queue', component: App.queue },
					{ name: 'timer_view', component: App.timer_view },
				];

				components.forEach((data) => {
					const { name, component } = data;
					if (name === ommit_name) return;

					if (component.is_shown()) component.minimize();
				});
			},
			_get_component_by_wrapper: function (wrapper) {
				const wrapper_id = wrapper.attr('id');
				switch (wrapper_id) {
					case 'taskView__wrapper':
						return {
							name: 'task_view',
							component: App.task_view
						};
					case 'noteBook__wrapper':
						return {
							name: 'notebook',
							component: App.notebook
						};
					case 'queueView__wrapper':
						return {
							name: 'queue',
							component: App.queue
						};
					case 'timerView__wrapper':
						return {
							name: 'timer_view',
							component: App.timer_view
						};
					case 'taskCreate__wrapper':
						return {
							name: 'task_create',
							component: App.task_create
						};
					case 'fileCreate__wrapper':
						return {
							name: 'file_create',
							component: App.file_create
						};
					case 'sidePanel__wrapper':
						return {
							name: 'mymenu',
							component: App.mymenu
						};
					case 'modalContainer':
						return {
							name: 'modal',
							component: App.modal
						};
					case 'dashboardView__wrapper':
						return {
							name: 'dashboard_view',
							component: App.dashboard_view
						};
					case 'massTaskCreate__wrapper':
						return {
							name: 'massTaskCreate',
							component: document.querySelector('smart-wrapper:has(mass-task-create)')
						};
				}

				throw new Error('Unknown wrapper #' + wrapper_id);
			},
			_get_component_by_item: function (item) {
				if (item.attr('data-href')) {
					return item.hasClass('taskPanel__item-chat') ? {
						name: 'chat_view',
						component: App.chat_view
					} : {
						name: 'task_view',
						component: App.task_view
					};
				} else if (item.hasClass('taskPanel__item-queue')) {
					return {
						name: 'queue',
						component: App.queue
					};
				} else if (item.hasClass('taskPanel__item-timer') || item.hasClass('taskPanel__item-costs')) {
					return {
						name: 'timer_view',
						component: App.timer_view
					};
				} else if (item.hasClass('taskPanel__item-notebook') || item.hasClass('menu__item-notebook')) {
					return {
						name: 'notebook',
						component: App.notebook
					};
				} else if (item.attr('data-draft')) {
					return {
						name: 'task_create',
						component: App.task_create
					};
				} else if (item.attr('data-file-draft')) {
					return {
						name: 'file_create',
						component: App.file_create
					};
				}

				throw new Error('Unknown item ' + JSON.stringify({ className: $(item).attr('class'), data: $(item).data() }, null, 2));
			}
		},

		// simple "layering" with top-layer only
		_layers: {
			selector: '#taskCreate__wrapper, #noteBook__wrapper, #fileCreate__wrapper, #timerView__wrapper, #queueView__wrapper, #taskView__wrapper, #massTaskCreate__wrapper',
			mobile_selector: '#sidePanel__wrapper, #modalContainer, #dashboardView__wrapper',
			get_all_selector: function () {
				return self._layers.selector + ', ' + self._layers.mobile_selector;
			},
			init: function () {
				$(document).on('click.top_layer', self._layers.get_all_selector(), function (event) {
					if (App.windows.has_pending()) return;
					if ($(event.target).closest('.close, .minimize, .top-layer:not(.top-layer--inactive)').length) return;
					if (!App.device.is_mobile() && $(this).is(self._layers.mobile_selector)) return;
					const { component } = self.item._get_component_by_wrapper($(this));

					if (!component.window) {
						self.item.foreground(component);
						return;
					}

					// те саме, але ще й прокинемо подію в додаток, накриклад, для drag&drop App.timer_view
					component.window.alreadyOpened();
				});
			},
			destructor: function () {
				$(document).off('click.top_layer', self._layers.get_all_selector());
				$('.top-layer').removeClass('top-layer');
				$('.top-layer--inactive').removeClass('top-layer--inactive');
				$(self._layers.get_all_selector()).removeAttr('data-layer').css('--layer', '');
			},
			normalize_layers: function () {
				const items = $(self._layers.get_all_selector())
					.filter('[data-layer]')
					.toArray()
					.sort((a, b) => +$(a).attr('data-layer') - +$(b).attr('data-layer'));

				items.forEach((el, index) => {
					$(el).attr('data-layer', index + 1);
					self._layers.update_css_vars($(el));
				});

				return items.length;
			},
			set_top_layer: function (wrapper) {
				if (!wrapper.length) return;
				if (wrapper.hasClass('top-layer') && !wrapper.hasClass('top-layer--inactive')) return;

				$(self._layers.get_all_selector()).not(wrapper).removeClass('top-layer');
				wrapper.addClass('top-layer').removeClass('top-layer--inactive');

				const current_layer = Number(wrapper.attr('data-layer')) || 0;
				let max_layer = self._layers.get_max_layer();
				if (max_layer == current_layer && current_layer > 0) return;

				wrapper.attr('data-layer', max_layer + 1);
				let current_max_layer = max_layer + 1;
				if (max_layer >= 10) {
					current_max_layer = self._layers.normalize_layers();
				} else {
					self._layers.update_css_vars(wrapper);
				}

				if (App.device.is_mobile()) {
					$('#loadingOverlay').css('--layer', current_max_layer || 0);
				}
			},
			remove_top_layer: function (wrapper) {
				wrapper.removeClass('top-layer');
				wrapper.removeClass('top-layer--inactive');
				wrapper.removeAttr('data-layer');
				self._layers.update_css_vars(wrapper);
			},
			update_css_vars: function (wrapper) {
				const current_layer = wrapper.attr('data-layer');
				wrapper.css('--layer', current_layer ?? '');
			},
			get_max_layer: function () {
				let max = 0;

				$(self._layers.get_all_selector()).each(function () {
					const val = $(this).attr('data-layer');
					if (!val) return;
					const num = +val;
					if (num > max) max = num;
				});

				return max;
			},
			get_max_layer_element: function () {
				const max_layer = self._layers.get_max_layer();
				if (!max_layer) return $();
				return $(self._layers.get_all_selector()).filter('[data-layer=' + self._layers.get_max_layer() + ']');
			},
			activate_previous: function () {
				const last_wrapper = self._layers.get_max_layer_element();
				if (last_wrapper && last_wrapper.length) {
					const { component, name } = self.item._get_component_by_wrapper(last_wrapper);
					self.item.foreground(component);
				}
			},
		},

		onLogin: function () {
			$('#taskPanel').after('<div id="taskPanel__counter" class="taskPanel__counter flex_row withRipple"><span class="in">0</span><a id="taskPanel__counter__timer" class="taskPanel__counter__timer"></a></div>');

			App.bus.other_tab.on('ui_state', function ({state}) {

				const current_state = state[self._get_state_category()];
				if (!current_state) return;

				const { task_panel_collapsed } = current_state;
				if (self.is_collapsed === Boolean(task_panel_collapsed)) return;

				self.is_collapsed = Boolean(task_panel_collapsed);
				self.onresize();
			});

			App.bus.msg.on('task_panel', self.update);

			App.bus.app.on('window_signal', function (e) {
				const keys_except_window = App.device.is_mobile() ? [App.window.right_panel.key] : [App.window.left_panel.key, App.window.right_panel.key, App.window.modal.key];

				if (keys_except_window.includes(e.key)) {
					if (e.key === App.window.modal.key) $('.top-layer').addClass('top-layer--inactive');
					return;
				}

				if (e.state === App.windows.states.ALREADY_OPENED) {
					if (!e.payload?.no_foreground) App.task_panel.item.foreground(e.target);
				} else if (e.state === App.windows.states.OPENING) {
					if (e.key === 'task_view') {
						$('.taskPanel__item-task, .taskPanel__item-chat').removeClass('taskPanel__item-inactive')
					}

					if (!e.payload?.no_foreground) {
						self.item.foreground(e.target);

						if (!self.is_shown() && !App.device.is_mobile()) {
							if (e.key === App.window.modal.key) return;
							App.windows.opened.forEach(opened_key => {
								if (opened_key === e.key || keys_except_window.includes(opened_key)) return;

								if (self.item.exists(opened_key)) {
									App.windows.minimize(opened_key);
								} else {
									App.windows.close(opened_key);
								}
							});
						}
					}
				} else if (e.state === App.windows.states.OPENED) {
					//
				} else if (e.state === App.windows.states.CLOSED) {
					if (e.target.obj_wrapper.is('.top-layer')) {
						self._layers.remove_top_layer(e.target.obj_wrapper);
						self._layers.activate_previous();
					}
				} else if (e.state === App.windows.states.MINIMIZING) {
					if (e.key === 'notebook' && !self.item.exists(e.target)) {
						App.task_panel.append({ type: 'notebook' });
					} else if (e.key === 'task_view' && e.target.is_chat && !self.item.exists(e.target)) {
						const cleanup = (html) => {
							const $wrap = $('<div>').html(html);
							$wrap.find('[data-preview]').attr('data-preview', '');
							return $wrap.html().trim();
						};
						App.task_panel.append({
							type: 'chat',
							url: e.target.url,
							id_task: e.target.id,
							name: $('#taskView .taskView__head > .in .name, #taskView .mobile-head--chatView [data-role=title]').first().text().trim(),
							symbol: cleanup($('#taskView .taskView__head > .symbol, #taskView .mobile-head--chatView [data-role=symbol]').first().html().trim()),
							unseen_data: $('#taskView .taskView__head > .unseen, #taskView .mobile-head--chatView [data-role=unseen]').first().find('task-unseen').get(0).tpl_data,
						});
					} else if (e.key === 'task_view' && !e.target.is_chat && !self.item.exists(e.target)) {
						App.task_panel.append({
							type: 'task',
							url: e.target.url,
							id_task: e.target.id,
							name: $('#taskView .taskView__head .in .ht').text().trim(),
							stage_data: $('#taskView .taskView__head .in .symbol').find('task-stage').get(0).tpl_data,
							unseen_data: $('#taskView .taskView__head .in .unseen').find('task-unseen').get(0).tpl_data,
						});
					} else if (e.key === 'queue' && !self.item.exists(e.target)) {
						App.task_panel.append({
							type: 'queue',
							run: App.queue.cnt_run,
							total: App.queue.total,
							progress: App.queue.progress,
						});
					} else if (self.item.exists(e.target)) {
						self.item.minimize(e.target);
					}

				} else if (e.state === App.windows.states.CLOSING) {
					self.item.remove(e.target);
				}
			});

			App.bus.state.on('task_timers', function (payload) {
				if (payload.data.add || payload.data.delete) self.load();
			});

			const update_task_or_chat = function (id, data, redraw = true) {
				self.update_one({
					type: ['task', 'chat'],
					id_task: +id,
				}, data);
			};

			const update_task = function (id, data, redraw = true) {
				self.update_one({
					type: 'task',
					id_task: +id,
				}, data, redraw);
			};

			App.bus.state.on('task_name', function ({ id, data }, context) {
				update_task_or_chat(id, { name: data.name });
			});

			// компоненти вже мають необхідні підписки, тому будемо слухати їх оновлення
			// App.bus.state.on('task_done task_undone', function (payload, context) {
			// 	const status = context.event === 'task_done' ? 1 : 0;
			// 	const { id } = payload;

			// 	update_task(id, {
			// 		stage_data: {
			// 			status
			// 		}
			// 	});
			// });

			// App.bus.state.on('task_status', function (payload, context) {
			// 	const { id, data } = payload;

			// 	if (data.id === undefined) throw new Error('Something wrong with task_status event');

			// 	update_task(id, {
			// 		stage_data: {
			// 			id: +data.id,
			// 		}
			// 	});
			// });

			// слухаємо оновлення компонентів
			App.components.on_update(App.components.task_stage, function ({ id, data }) {
				update_task(id, { stage_data: data }, data.status !== undefined);
			});
			App.components.on_update(App.components.task_unseen, function ({ id, data }) {
				update_task_or_chat(id, { unseen_data: data }, false);
			});

			self.onload();
			self.load();
			self._layers.init();

			App.bus.app.on('sidebar_toggle', self.onresize);
			App.bus.window.on('resize', App.helper.debounce(self.onresize));

			App.helper.nextTick(self.onresize);
		},
		onLogout: () => self.destructor(),
		onLoadPage: function () {
			App.core.process_start_hash(/#(file-)?draft-(\d+)$/, function (m) {
				self.click_after_load = '#taskPanel .taskPanel__item[data-'+(+m[1] || '')+'draft='+m[2]+']';
			});
		}
	};
})();

;var App = App || {};


(function() {
let self = App.task_recent = {
	type: 'tasks_recent',

	show: function (options) {
		const ids = options?.ids || '';
		delete options?.ids;
		App.modal.show({
			url: App.helper.url.add_query('/ajax2/', App.actions.get('task_modal_grid_edit:show')) + '&ids=' + ids,
			type: self.type,
			...options
		})
	},

	is_shown: function () {
		return App.mymenu.is_shown(self.type);
	},

	hide: function () {
		App.mymenu.hide();
	},

	// mark_invalidated: function () {
	// 	App.mymenu.mark_invalidated_window(self.type);
	// },

	update: function () {
		App.mymenu.invalidate_window(self.type);
	},

	// init: function () {
	// },

	onBoot: function () {

		App.bus.state.on('task_add', function (payload, context) {

			const id_task = payload.id;
			const data = payload.data;

			if (!data) return;

			if (data.id_user_from == App.me.id) {
				self.update();
			}
		});

		// App.bus.app.on('left_panel_loaded', function (data) {
		// 	if (data.payload === self.type) self.init();
		// });
	}
};
})();

;var App = App || {};

(function() {
	let task_view_width = App.helper.localStorage.value('task_view_width', 800);
	let task_view_fullscreen = App.helper.localStorage.value('task_view_fullscreen', false);
	let chat_view_width = App.helper.localStorage.value('chat_view_width', 800);
	let chat_view_fullscreen = App.helper.localStorage.value('chat_view_fullscreen', false);

	let self = App.task_view = {
		event: 'task',
		shown: false,
		hiding: false,
		url: '',
		id: 0,
		id_prev: 0,
		hash: '',
		title: '',
		is_chat: false,
		locale: {},
		properties_config: null,
		open_in_fullscreen: false,
		exit_fullscreen_url: null,
		anchor: null,
		width: 800,
		last_closed_view: null,
		window: null,
		context: null,
		need_reload_buttons: false,

		obj_wrapper: null,
		obj_window: null,
		obj_menus: null,

		debug: false,

		minibar: null,

		scroller: {
			observer: null,
			last_top_by_key: new Map(),
			stick_bottom: false,
			stick_bottom_dist: 100,
			bottom_padding: 82,
			obj_content: null,
			remember: function (key) {
				if (self.obj_window == null) return;

				key ||= 'main'
				self.scroller.last_top_by_key.set(key, $(this.obj_content).scrollTop());
			},
			restore: function (key) {
				this.scrollto(key);
				self.scroller.last_top_by_key.delete(key);
			},
			scrollto: function (key) {
				if (self.obj_window == null) return;

				key ||= 'main'
				let last_top = self.scroller.last_top_by_key.get(key);
				if (last_top != null) $(this.obj_content).scrollTop(last_top);
			},
			scrollmove: function (dy) {
				if (self.obj_window == null) return;

				$(this.obj_content).scrollTop(dy + this.scrollTop());
			},
			stick: function () {
				if (this.stick_bottom || self.obj_window == null) return;

				if (this.scrollTop()+this.height() >= this.scrollHeight()) return;

				$(this.obj_content).scrollTop((this.scrollHeight()-this.height()) - self.scroller.bottom_padding);
			},
			calc_is_in_bottom: function () {
				if (self.obj_window == null) return false;
				return this.scrollTop()+this.height() >= this.scrollHeight() - self.scroller.stick_bottom_dist;
			},
			calc_is_close_bottom: function () {
				if (self.obj_window == null) return false;
				return this.scrollTop()+this.height() >= this.scrollHeight() - self.scroller.stick_bottom_dist*2;
			},
			has_scroll: function () {
				if (self.obj_window == null) return false;
				return this.height() < this.scrollHeight();
			},
			scrollTop: function () { return this.obj_content?.scrollTop ?? 0; },
			calcScrollHeight: function () { return this.obj_content.scrollHeight; },
			scrollHeight: App.helper.memoize(function () { return this.calcScrollHeight(); }, 2000),
			height: App.helper.memoize(function () { return this.obj_content.offsetHeight; }, 2000),
			toggle_comment_unseen_popup: App.helper.debounce(function () {
				let is_close_bottom = self.scroller.calc_is_close_bottom();
				if (self.is_chat) {
					App.comments.unseen.popup_toggle(self.scroller.has_scroll() && !is_close_bottom);
				} else {
					App.comments.unseen.popup_toggle(self.scroller.has_scroll());
					App.comments.unseen.reverse_toggle(is_close_bottom);
				}
			}, 500, true),
			onscroll: App.helper.just_throttle(function (e) {
				let dist = self.scroller.last_scroll_top ? e.target.scrollTop - self.scroller.last_scroll_top : 0;

				if (App.device.is_mobile()) self.scroller.onscroll_toggle_head(dist, e.target.scrollTop);

				if (self.is_chat) App.chat_view.scroller.onscroll(e);

				self.scroller.stick_bottom = self.scroller.calc_is_in_bottom();
				self.scroller.toggle_comment_unseen_popup.run();

				if (App.comments.unseen.allow_read()) self.scroller.onscroll_read_comments(dist);

				self.scroller.last_scroll_top = e.target.scrollTop;
				self.scroller.last_dist = dist;
			}),
			onscroll_toggle_head: function (dist, scrollTop) {
				if (self.obj_window.hasClass('taskView-withoutHeadMobile')) return;

				const dir = dist > 0 ? 1 : -1;

				if ((dir > 0 && scrollTop >= 24) || dist <= -30 || (dir < 0 && scrollTop <= 48)) {
					App.task_view.obj_window.toggleClass('taskView-headMobileHidden', dir > 0);
				}
			},
			onscroll_read_comments: function (dist) {
				let reversed = App.config.reverse_comments && !self.is_chat,
					is_dir_changed = self.scroller.last_dist != null && (dist > 0 ? self.scroller.last_dist < 0 : self.scroller.last_dist > 0);

				if (is_dir_changed) self.scroller.comments_reader.reset();

				if (reversed && dist < -1) self.scroller.comments_reader();
				else if (!reversed && dist > 1) self.scroller.comments_reader();
			},
			allow_scroll_to_new_comment: function () {
				if (App.config.reverse_comments && !self.is_chat) return false;

				return self.scroller.stick_bottom;
			},
			_observer_callback: function(entries) {
				entries.forEach(function(entry) {
					const el = $(entry.target);
					const invisible = entry.boundingClientRect.top < entry.rootBounds.top;
					$('#taskView').toggleClass(
						'taskView-' + el.attr('data-observer-class') + 'Invisible',
						invisible
					);
				});
				self.scroller.helper_link_subtask_wrapper();
				self.scroller.helper_link_comment_wrapper();
			},
			observe: function() {
				if (!window.IntersectionObserver) return;
				if (this.observer) return;

				this.observer = new IntersectionObserver(function(entries) {
					self.scroller._observer_callback(entries);
				}, {
					root: self.scroller.obj_content,
					rootMargin: '0px',
					threshold: 1.0
				});

				const observed_items = self.obj_window.find('.taskView__contentScrollOut [data-observer-class]');
				observed_items.each(function() {
					self.scroller.observer.observe(this);
				});
			},
			trigger_observer: function () {
				const observed_items = self.obj_window.find('.taskView__contentScrollOut [data-observer-class]');
				const rootTop = self.scroller.obj_content.getBoundingClientRect().top;
				const fake_entries = [];
				observed_items.each(function() {
					const rect = this.getBoundingClientRect();
					fake_entries.push({
						target: this,
						boundingClientRect: rect,
						rootBounds: { top: rootTop }
					});
				});
				self.scroller._observer_callback(fake_entries);
			},
			unobserve: function() {
				this.stick_bottom = false;
				this.last_top_by_key.clear();
				this.toggle_comment_unseen_popup.reset();
				if (self.obj_window != null && self.scroller.observer != null && "IntersectionObserver" in window) {
					self.obj_window.find('.taskView__contentScrollOut [data-observer-class]').each(function() {
						self.scroller.observer.unobserve(this);
					});
					self.scroller.observer = null;
				}
			},
			helper_link_comment_wrapper: function() {
				let panel = self.obj_window.find('.commentListPanel');
				let is_sticky = panel.parent().hasClass('taskView__contentScrollOut');
				let should_stick = self.obj_window.hasClass('taskView-comment_massInvisible') || self.is_chat;

				if (should_stick) {
					if (!is_sticky) panel.appendTo(self.obj_window.find('.taskView__contentScrollOut'));
				} else {
					if (is_sticky) panel.appendTo(self.obj_window.find('.commentListPanel__wrapper'));
				}
				if (!App.device.is_mobile() && self.obj_window.hasClass('taskView-withCommentSearch')) {
					App.comments.search.focus();
				}
			},
			helper_link_subtask_wrapper: function() {
				let wrapper = self.obj_window.find('.taskView__subtasks__wrapper');
				let head = self.obj_window.find('.taskView__subtasks__head');
				let is_sticky = head.parent().hasClass('taskView__contentScrollOut');
				let is_comment_stick = self.obj_window.hasClass('taskView-comment_massInvisible');

				if (wrapper.hasClass('collapsed') || wrapper.height() < 300 || is_comment_stick) {
					if (is_sticky) head.appendTo(self.obj_window.find('.taskView__group__head__wrapper'));
					return;
				}

				if (self.obj_window.hasClass('taskView-subtask_massInvisible')) {
					if (!is_sticky) head.appendTo(self.obj_window.find('.taskView__contentScrollOut'));
				} else {
					if (is_sticky) head.appendTo(self.obj_window.find('.taskView__group__head__wrapper'));
				}
			},
			init: function() {
				self.scroller.last_scroll_top = null;
				self.scroller.first_comment_unseen_click = false;
				self.scroller.toggle_comment_unseen_popup.reset();
				self.scroller.last_top_by_key.clear();
				self.scroller.stick_bottom = false;
				self.scroller.obj_content = self.obj_window.find('.taskView__content').get(0);
				self.scroller.observe();
			},
			onshow: function () {
				self.scroller.toggle_comment_unseen_popup();
			},
			comments_reader: App.helper.debounce(function () {
				self.scroller
					.helper_filter_visible_comments(App.comments.unseen.ids_comment)
					.forEach(i => App.comments.unseen.save(i));
			}, 250, true),
			helper_filter_visible_comments: function (ids) {
				return ids.filter(function (i) {
					const el = $('#obj-comment'+i), pos = el.position().top + el.height()/2;
					return pos > 0 && pos < self.scroller.height();
				});
			},
			initial_read_comments: App.helper.debounce(function (id_focused) {
				if (!App.comments.unseen.allow_read()) return;

				if (id_focused) return App.comments.unseen.save(id_focused);

				let visible_ids = self.scroller.helper_filter_visible_comments(App.comments.unseen.ids_comment);
				if (visible_ids.length === App.comments.unseen.ids_comment.length) {
					visible_ids.forEach(i => App.comments.unseen.save(i));
				}
			}, 99),
			scroll: {
				update: function () {
					$(self.scroller.obj_content).scrollUpdate();
				},
				preserveStart: function () {
					$(self.scroller.obj_content).scrollPreserveStart();
				},
				preserveEnd: function () {
					$(self.scroller.obj_content).scrollPreserveEnd();
				},

			}
		},

		resizer: {
			min_width: 800,
			max_width: $(window).width(),
			limit_width: $(window).width(),
			enabled: true,
			state: {
				active: false,
				start_x: 0,
				start_w: 0,
				jump_at: 0
			},
			init: function () {
				let body = $('body');
				self.obj_wrapper.append('<div class="taskView__resizeHandler"></div>');
				self.obj_wrapper.find('.taskView__resizeHandler').on('mousedown', function (e) {
					if (!self.resizer.enabled || App.modal.is_shown() || App.menu.is_shown()) return;

					self.resizer.max_width = body.width() - $('#primaryMenu').width();
					self.resizer.limit_width = self.resizer.max_width;
					self.resizer.state.active = true;
					self.resizer.state.start_x = e.clientX;
					self.resizer.state.start_w = self.obj_wrapper.width();
					self.resizer.state.allow_fullscreen = false;

					if (body.hasClass('sidePanelShown')) self.resizer.limit_width-= $('#sidePanel__wrapper').width();
					else if (body.hasClass('withSidebar')) self.resizer.limit_width-= $('#sidebar__wrapper').width();
					else self.resizer.state.allow_fullscreen = true;

					body.addClass('body-dragInProgress');
				})
			},
			mouseup: function () {
				if (!self.resizer.state.active) return;

				self.resizer.state.active = false;
				if (self.is_chat) {
					chat_view_width.set(self.width);
				} else {
					task_view_width.set(self.width);
				}

				$('body').removeClass('body-dragInProgress');
				App.bus.app.emit('task_view_resize_end');
			},
			mousemove: function (e) {
				if (!self.resizer.state.active) return;

				let w = self.resizer.state.start_w + (self.resizer.state.start_x - e.clientX);

				if (w < self.resizer.min_width) w = self.resizer.min_width;
				else if (w > self.resizer.limit_width*0.95) w = self.resizer.limit_width;
				else if (self.resizer.state.allow_fullscreen && !self.open_in_fullscreen && w > self.resizer.max_width*0.8 && w > self.width) return self.resizer.jump_to_fullscreen();

				if (self.open_in_fullscreen && self.resizer.state.jump_at - w < 16) return;
				if (self.open_in_fullscreen) self.fullscreen()

				self.width = w;
				self.wrapper.update_pos(10);
			},
			jump_to_fullscreen: function () {
				self.resizer.state.jump_at = self.width;
				self.width = Math.floor(self.resizer.max_width*0.75);
				if (self.is_chat) {
					chat_view_width.set(self.width);
				} else {
					task_view_width.set(self.width);
				}
				self.fullscreen();
			},
			toggle_enable: function (is_enabled) {
				self.resizer.enabled = is_enabled;
				self.obj_wrapper.find('.taskView__resizeHandler').toggle(is_enabled);
			},
			check_width: function () {
				let body = $('body');
				self.resizer.max_width = body.width() - $('#primaryMenu__wrapper').width();
				self.resizer.limit_width = self.resizer.max_width;

				if (body.hasClass('sidePanelShown') && self.resizer.limit_width > 1100) self.resizer.limit_width-= $('#sidePanel__wrapper').width() || 0;
				else if (body.hasClass('withSidebar') && self.resizer.limit_width > 1000) self.resizer.limit_width-= $('#sidebar__wrapper').width() || 0;

				if (self.width <= self.resizer.limit_width) return;

				self.width = Math.max(self.resizer.limit_width, self.resizer.min_width);
			},
			onresize: function () {
				if (!self.is_shown()) return;

				self.resizer.check_width();
				self.wrapper.update_pos();
			}
		},
		custom_fields: {
			init: function () {
				const trueObjWindow = self.obj_window.get(0);
				trueObjWindow.onHandshake('custom_field_context', () => {
					return {
						external_edit_url: App.helper.url.add_query(
							App.helper.endpoint.task(self.id),
							App.actions.get('task_edit_field:show'),
						)
					}
				});
				trueObjWindow.addDelegatedEventListener('apply', 'custom-field', function ({detail}, el) {
					App.core.async_task.ajax({
						url: App.helper.url.add_query(
							App.helper.endpoint.task(self.id),
							App.actions.get('task_edit_field:apply'),
							App.controls.notify.notify_params('task_edit_field')
						),
						data: detail,
						error(res) {
							if (res.status !== 422){
								return false;
							}
							const {errors: {value}} = res.responseJSON;
							el.setExternalError(value.join('; '))
						},
						success(res) {
							el.clearExternalError()
						}
					});
				});
			}
		},

		is_shown: function () {
			return self.shown && !self.hiding;
		},

		full_url: function () {
			return window.location.origin + self.url;
		},

		check_url: function (url) {
			const parser = new URL(url, window.location.origin);

			return {
				is_task_path:
					App.helper.validate.task_url.test(parser.pathname)
					|| App.helper.validate.task_url_fallback.test(parser.pathname),
				is_task_hash: App.comments.initial_scroll.validate.comment_hash.test(parser.hash),
			};
		},

		show: function(data) {
			if (self.debug) console.trace('TASK_VIEW::show');
			if (App.comment_form.is_submitting()) return;
			if (!App.windows.before_open(self.window, data)) return;
			if (self.edit_inline.is_shown()) return self.edit_inline.end();
			if (self.hiding) return; // TODO: remember and open after hidden!!!

			let id = 0;
			let url = data.url || '';
			let hash = data.hash || '';
			let skip_cache = data.skip_cache || false;
			let is_chat = false;
			let anchor = data.anchor || null;

			let has_pos = url.indexOf('#');
			if (has_pos !== -1) {
				hash = url.substring(has_pos);
				url = url.substring(0, has_pos);
			}

			if (url === self.url && !skip_cache && self.window.is_ready()) {

				if (hash) self.initial_scroll.init(hash);
				self.window.alreadyOpened();
				self.initial_scroll.do();

				return true;
			}

			if (url === self.url && !skip_cache && self.shown) {
				return false;
			}

			let match = url.match(App.helper.validate.chat_url);
			if (match) {
				is_chat = !!match[1] ? -match[2] : true; // id_user || true
				id = 0;
				App.mymenu.set_active_chat(match[2], !!match[1])
			} else {
				App.mymenu.set_active_chat(false);
				match = url.match(App.helper.validate.task_url);
				if (match) {
					id = parseInt(match[1]);
				} else { // old url scheme fallback
					match = url.match(App.helper.validate.task_url_fallback);
					if (match) {
						id = parseInt(match[4] || match[2]);
					} else {
						console.log("%cBad task url%c " + url, "color: white; background:red; padding:2px;", "color: black; background: transparent;");
						return false;
					}
				}
			}

			App.core.async_task.abort('task_view_show');
			self.loaded_html = null;

			if (self.shown && self.has_loaded) self.window.unready();

			console.log("%cTask view%c " + url, "color: white; background:purple; padding:2px;", "color: black; background: transparent;");

			self.id_prev = self.id;
			self.anchor = anchor;

			if ((self.from_left_panel() && App.right_panel.is_shown()) || (self.from_right_panel() && window.innerWidth < 1400)) App.right_panel.hide();
			if (self.from_right_panel() && App.mymenu.is_shown()) App.mymenu.hide();

			self.is_chat = is_chat;
			self.url = url;
			self.id = id;
			self.width = data.width ?? (self.is_chat ? chat_view_width.get() : task_view_width.get());
			self.open_in_fullscreen = self.exit_fullscreen_url ? true : data.fullscreen ?? (self.is_chat ? chat_view_fullscreen.get() : task_view_fullscreen.get());
			self.resizer.check_width();
			self.scroller.unobserve();
			self.from_history = App.task_panel.item.exists(self);
			self.initial_scroll.init(hash);

			let cache_data = !skip_cache ? App.task_view_cache.pop(url) : null;
			self.from_cache = cache_data != null;
			self.need_reload_relations = cache_data?.need_reload_relations || false;
			self.need_reload_buttons = cache_data?.need_reload_buttons || false;

			self.window.opening();

			if (self.has_loaded) self.detach();

			if (cache_data) {
				self.obj_wrapper.removeClass('taskView-skeletonPrev');
				self.obj_wrapper.html('');
				self.obj_wrapper.append(cache_data.obj_window).append(cache_data.obj_menus);
				self.obj_window = cache_data.obj_window;
				self.minibar = cache_data.minibar;
				self.title = cache_data.title;
				self.id = cache_data.id;
				self.is_chat = cache_data.is_chat;
				self.has_loaded = true;
				self.props.init();
				self.init_group_wrapper();
				self.edit_inline.init();
				self.paginal.init(self.anchor);
			} else {
				self.obj_window = $(self.skeleton[self.is_chat?'chat':'task'] || '<div style="text-align: center; padding: 32px">loading</div>');
				self.obj_wrapper.html('');
				self.obj_wrapper.append(self.obj_window);
				self.has_loaded = false;
				self.obj_menus = null;
			}

			const check_ready = function () {
				if ((self.has_loaded && !self.window.is_ready()) || (self.loaded_html && self.window.is_opened())) {
					self.ready();
					self.window.ready();
				}
			};

			self.obj_wrapper.addClass('taskView__wrapper-active');
			self.update_fullscreen_btn();
			self.obj_window.find('.taskView__head .minimize').toggleClass('ws-utility-hidden', self.from_history);
			self.animate_show(self.from_history, self.is_chat, function () {
				self.window.opened();
				check_ready();
			});
			self.shown = true;

			if (self.has_loaded) return true;

			App.core.async_task.ajax({
				id: 'task_view_show',
				url: url,
				headers: {
					'x-load-type': 'modal',
					'x-modal-level': App.modal.layer_level - 1,
					'accept': 'text/html'
				}
			}).then(function (html) {
				self.loaded_html = html;
				App.helper.nextTick(check_ready);
			}).catch(function (err) {
				App.core.error('task_view', err);
				if (!err.is_aborted) {
					$('.taskView.taskView-skeleton').addClass('ws-skeleton-error');
				}
			});
		},

		ready: function () {
			self.obj_wrapper.removeClass('taskView-skeletonPrev');

			if (self.loaded_html) {
				self.render_loaded_content(self.loaded_html);
				self.has_loaded = true;
				self.loaded_html = null;
				App.task_view_cache.push(self.url, self);
			}

			self.scroller.init();
			self.resizer.init();

			self.clear_counter(self.id);
			App.core.history.push(self.url, self.title, true);

			if (self.need_reload_relations) self.relations.reload(); // TODO: CANCEL on close
			if (self.need_reload_buttons) {
				self.reload_fragment('.taskView__head .buts');
				self.need_reload_buttons = false;
			}
			self.initial_scroll.do();
			self.scroller.onshow();

			// TODO: move to mymenu? via bus
			if (self.is_chat && self.is_chat !== true) { // personal chat
				$('.chatList__item[data-user=' + self.is_chat + ']').attr('data-chat', self.id);
			}

			self.update_fullscreen_btn();
			self.obj_window.find('.taskView__head .minimize').toggleClass('ws-utility-hidden', self.from_history);
		},

		render_loaded_content: function (html) {
			const url = self.url;

			self.obj_wrapper.html(html);
			self.obj_menus = self.obj_wrapper.find('.menu[id]').addClass('menu-alwaysRemain').appendTo('#taskView__wrapper');
			self.obj_window = self.obj_wrapper.find('.taskView');

			self.obj_wrapper.removeClass('taskView-skeletonPrev');

			self.name.init();
			self.edit_inline.init();
			self.paginal.init(self.anchor);
			if (self.obj_window.find('.taskView__content').length) {
				const scrollBars = App.controls.js_scrollbars.init(self.obj_window.find('.taskView__content').get(0));
				self.minibar = scrollBars;
				self.obj_window.find('.taskView__content').get(0).scrollBars = scrollBars;
			}
			self.scroller.init();
			self.resizer.init();
			self.relations.init();
			self.like.init();
			self.costs.init();
			self.reminders.init();
			self.meets.init();
			self.subscribers.init();
			self.props.init();
			self.init_group_wrapper();
			self.custom_fields.init();

			self.obj_window.on('click', '.taskView__timer', function(e) {
				App.timer_view.show(true);
			});
			self.obj_window.on('click', '.comment_unseen_popup .floater', function(e) {
				App.task_view.scroll_to_unseen_comments(!self.scroller.first_comment_unseen_click);
				self.scroller.first_comment_unseen_click = true;
				return false;
			});
			self.obj_window.on('click', '.comment_unseen_popup .summarize', function(e) {
				let unseen_popup = $(e.target.closest('.comment_unseen_popup'));
				if (unseen_popup.hasClass('summarize_loading')) return;
				let endpoint = App.helper.url.add_query(url, App.actions.get('task_unseen_summary:show'));
				let func = function(key) {
					unseen_popup.addClass('summarize_loading');
					App.menu.hide_all();
					App.modal.show({
						url: endpoint + '&key=' + key,
						success: function() {
							unseen_popup.removeClass('summarize_loading');
						}
					});
				}

				$('#summarizeMenu a[data-key=unread]').toggleClass('menu__item-disabled', !$(this).closest('.comment_unseen_popup').hasClass('has_unseen'));
				$('#summarizeMenu a[data-key=day]').toggleClass('menu__item-disabled', App.comments.all_matched_filters.count_today == 0);
				$('#summarizeMenu a[data-key=week]').toggleClass('menu__item-disabled', App.comments.all_matched_filters.count_week == 0);
				$('#summarizeMenu a').off().on('click', function(e) {
					switch ($(this).attr('data-key')) {
						case 'select':
							App.comments.show_filter_by_date(this, {
								backup: true,
								type: 'submenu',
								onSelect: function(date_str) {
									func(date_str);
								}
							})
							break;
						default:
							func($(this).attr('data-key'));
					}
				});
				App.menu.show({box: '#summarizeMenu', type: 'bottom2', anchor: this, offset: {top: 48}, width: 196});
				return false;
			});
			self.obj_window.on('click', '.taskView__group__head ws-icon[name*=arrow_drop-down], .taskView__group__head .name, .taskView__group__head .info, .taskView__group__head .stats', function(e) {
				if ($(e.target).closest('a,button').length > 0 && $(e.target).closest('.info').length === 0) return;
				if (self.obj_window.closest('.taskView-descr_expanded').length > 0) return;
				if (self.obj_window.closest('.taskView__editing-descr').length > 0) return;

				const wrapper = $(this).closest('.taskView__group__wrapper');
				wrapper.toggleClass('collapsed');
				if (wrapper.attr('data-state-key')) {
					if (wrapper.hasClass('taskView__subtasks__wrapper') && self.obj_window.hasClass('taskView-no_subtasks')) {
						// no state update
					} else {
						App.classes.ui_state_manager.getInstance().setState(wrapper.attr('data-state-key'), !wrapper.hasClass('collapsed'));
					}
				}
				self.scroller.helper_link_subtask_wrapper();
				self.scroller.helper_link_comment_wrapper();
			});
			self.obj_window.find('.taskView__content').on('scroll', function (e) {
				self.scroller.onscroll(e);
			});

			let scroll_to = App.comments.scroll_to; // TODO: refactor!

			self.obj_window.find('.taskView__head > .in_def').bind('click', function (e) {
				if ($(e.target).closest('button, input, a').length > 0) return;
				scroll_to('.bottomAnchor');
			});
			self.obj_window.find('.taskView__head > .in').bind('click', function (e) {
				if ($(e.target).closest('button, input, a').length > 0) return;
				if (!App.task_view.is_chat) scroll_to('.topAnchor');
			});
			self.obj_window
				.find('.taskView__head > .taskView__header-clickZone')
				.bind('click', function () {
					if (self.obj_window.hasClass('taskView-taskInvisible')) {
						scroll_to('.topAnchor');
					} else {
						scroll_to('.bottomAnchor');
					}
				});
			self.obj_window
				.find('.mobile-head--taskView .mobile-head__title')
				.bind('click', function (e) {
					if ($(e.target).closest('button, input, a:not(.bookmark)').length > 0) return;
					if (self.obj_window.hasClass('taskView-taskInvisible')) {
						scroll_to('.topAnchor');
					} else if ($(e.target).closest('.in_def, .bookmark').length) {
						App.controls.task_menu.show(e.target, App.helper.url.task(self.id),	{request: {full: 1}});
						return false;
					}
				});

			// self.obj_window.on('change', function (e) {
			// 	if ($(e.target).hasClass('commentForm')) self.scroller.toggle_comment_unseen_popup();
			// });
		},

		reload: function(options) {
			options ||= {};
			options.url = self.url;
			options.skip_cache = true;
			self.show(options);
		},

		before_close: function(to_history) {
			App.core.async_task.abort('task_view_show');
			self.loaded_html = null;
			self.hiding = true;

			if ($('body').hasClass('withModalAndTask') ) {
				if (App.modal.is_shown()) App.modal.hide({immediate: true, hide_all: true});
			}
			if (self.obj_wrapper.find('.menu_open').length > 0) App.menu.hide_all();

			if (App.comment_form.is_started()) {
				App.comment_form.stop();
			}

			if (App.subtasks.mass.is_shown() || App.comments.mass.is_shown()) {
				App.subtasks.mass.hide_menu()
				App.comments.mass.hide_menu()
			}

			App.mymenu.set_active_chat(false);
			self.scroller.unobserve();
			if (self.edit_inline.is_shown()) {
				self.edit_inline.cancel();
			}

			if (self.anchor) {
				let container = $(self.anchor).closest('.keyboardZone');
				if (container.length) {
					let sel = container.attr('data-select');
					let anchor = sel ? $(self.anchor).closest(sel) : $(self.anchor);
					if (self.is_task_list_highlight()) {
						container.find('.last_selected').removeClass('last_selected');
						if (anchor.length) anchor.addClass('last_selected').toggleSelected(false);
					} else {
						container.find('.selected').toggleSelected(false);
					}
				}
			}

			$(document).trigger(self.event + '_onunload.once').unbind(self.event + '_onunload.once');
			$(document).trigger(self.event + '_onunload.final').unbind(self.event + '_onunload.final');
			$(document).trigger(self.event + '_onunload.everytime');
			App.task_view_cache.set_state(self.url, to_history ? 'mini' : 'close');
			App.core.history.restore_page();
		},

		hide: function() {
			if (self.debug) console.trace('TASK_VIEW::hide');
			if (self.hiding || App.comment_form.is_submitting()) return;

			if (!self.window.is_ready()) {
				self.window.closing();
				self.fallback_background();
				self.animate_hide(App.task_panel.item.exists(self), function() {
					self.window.closed();
					self.shown = false;
					self.hiding = false;
					self.has_loaded = false;
					self.url = '';
					self.id = '';
				});

				return;
			}

			if (self.edit_inline.is_shown()) return self.edit_inline.end(self.obj_window.find('.taskView__head .close'));

			if ($('body').hasClass('withModalAndTask') ) {
				if (App.modal.is_shown()) App.modal.hide({immediate: true, hide_all: true});
			}
			if (App.task_panel.item.exists(self)) {
				self.minimize();
			} else {
				self.window.closing();
				self.fallback_background();
				self.before_close();
				self.animate_hide(false, function() {
					self.window.closed();
					self.shown = false;
					self.hiding = false;
					self.has_loaded = false;
					self.url = '';
					self.id = '';
					self.detach();
				});
			}
		},

		back: function() {
			App.core.history.safe_back(1, () => {
				self.hide();
			});
		},

		delete: function() {
			if (self.debug) console.trace('TASK_VIEW::delete');
			App.core.async_task.abort('task_view_show');

			self.window.closing();
			self.before_close();
			self.animate_hide(false, function() {
				App.task_view_cache.delete(self.url);
				self.window.closed();
				self.shown = false;
				self.hiding = false;
				self.has_loaded = false;
				self.url = '';
				self.id = '';
				self.detach();
			});
		},

		initial_scroll: {
			hash: '',
			init(hash) {
				if (hash === '#subtasks' || hash === '#comments') {
					self.initial_scroll.hash = hash;
				} else {
					App.comments.initial_scroll.init(hash);
				}
			},
			do() {
				if (self.initial_scroll.hash === '') {
					return App.comments.initial_scroll.do();
				}

				App.anchor.scroll_to(self.initial_scroll.hash);
				self.initial_scroll.hash = '';
				return true;
			}
		},

		remove_from_task_panel: function(el) {
			const url = $(el).attr('data-href');
			App.task_panel.item.remove_by_item($(el));
			if (self.is_shown() && self.url === url) self.hide();
		},

		scroll_to_subtasks: function () {
			if (self.edit_inline.is_shown()) return self.edit_inline.obj.blink();

			App.anchor.scroll_to('#subtasks');
			self.obj_window.find('.taskView__subtasks').closest('.taskView__group__wrapper').removeClass('collapsed');
		},
		scroll_to_unseen_comments: function (is_first_click) {
			if (self.edit_inline.is_shown()) return self.edit_inline.obj.blink();

			let reversed = App.config.reverse_comments && !self.is_chat;

			if (is_first_click && !App.comments.options.filter && App.comments.unseen.ids_comment.length) {
				let el = reversed
					? $('#obj-comment'+App.comments.unseen.ids_comment[App.comments.unseen.ids_comment.length-1])
					: $('#obj-comment'+App.comments.unseen.ids_comment[0]);

				self.scroll_to_top(self.scroller.scrollTop() + el.offset().top - self.scroller.height()/2);
				return;
			}

			if (!App.comments.options.filter && App.comments.unseen.ids_mention.length > 0) {
				let el = reversed
					? $('#obj-comment'+App.comments.unseen.ids_mention.pop())
					: $('#obj-comment'+App.comments.unseen.ids_mention.shift());

				self.scroll_to_top(self.scroller.scrollTop() + el.offset().top - self.scroller.height()/2);
				return;
			}

			if (self.scroller.calc_is_in_bottom() && !self.is_chat) {
				self.scroll_to_top(0);
				return;
			}

			if (reversed) {
				let el = $('.commentListPanel__wrapper');
				if (el.offset().top > self.scroller.scrollTop() + self.scroller.height()) {
					self.scroll_to_top(self.scroller.scrollTop() + el.offset().top - self.scroller.height()/2);
					return;
				}

				if (App.comments.unseen.ids_comment.length) {
					self.scroll_to_top(self.scroller.scrollTop() + el.offset().top - self.scroller.height()/2);
					return;
				}
			}

			self.scroll_to_top(self.scroller.scrollHeight());
		},
		scroll_to_top: function (top) {
			// App.controls.js_scrollbars.waitSmoothScrolling(App.task_view.minibar);
			App.task_view.minibar.scrollTarget.scrollTo({ top: top, behavior: 'smooth' });
		},

		toggle_right_panel_view: function() {
			self.wrapper.update_pos();
		},

		fullscreen: function() {
			self.open_in_fullscreen = !self.open_in_fullscreen;
			if (self.is_chat) {
				chat_view_fullscreen.set(self.open_in_fullscreen);
			} else {
				task_view_fullscreen.set(self.open_in_fullscreen);
			}
			self.wrapper.update_pos();
			self.resizer.toggle_enable(!self.open_in_fullscreen);
			if (App.modal.is_shown()) App.modal.hide({immediate: true, hide_all: true});
			self.update_fullscreen_btn();
			self.fallback_background();
			App.bus.app.emit('task_view_fullscreen', self.open_in_fullscreen);
		},

		show_page: function(data, exit_url) {
			if (self.is_shown()) return;

			self.exit_fullscreen_url = exit_url || '/';
			data.fullscreen = true;
			self.show(data);
		},

		fallback_background: function() {
			if (App.page == null || App.page.fake !== true || self.exit_fullscreen_url == null) return;

			App.helper.nextTick(() => {
				if (!self.exit_fullscreen_url) return;

				App.core.goto(self.exit_fullscreen_url, false, { preserve_task_view: true });
				self.exit_fullscreen_url = null;
			});
		},

		from_left_panel: () => self.anchor != null && $(self.anchor).closest('.sidePanel__wrapper').length === 1,
		from_right_panel: () => self.anchor != null && $(self.anchor).closest('.rightPanel__wrapper').length === 1,
		is_task_list_highlight: () => ['tasks', 'tasks_grid'].includes(App.page.where()),
		update_fullscreen_btn: function () {
			let btn = self.obj_wrapper.find('ws-btn.fullscreen');
			btn.toggleClass('active', self.open_in_fullscreen);
			btn.children('button').attr('data-title', btn.attr(self.open_in_fullscreen ? 'data-title-hide' : 'data-title-show'));
		},

		wrapper: {
			timer: null,
			current_speed: 10,
			is_shown: false,
			update_pos_after: false,
			set_speed: function (ms) {
				self.wrapper.current_speed = Math.max(ms, 10);
				self.obj_wrapper.css(ms > 99 ? { transition: 'all '+ms+'ms ease' } : { transition: 'none' });
				return self.wrapper;
			},
			set_css: function (style) {
				if (style != null) self.obj_wrapper.css(style);
				return self.wrapper;
			},
			reset_css: function (style) {
				self.wrapper.set_speed(0).set_css({
					display: 'none', opacity: '',
					left: '', right: '',
					top: '', bottom: '',
					scale: '', transform: ''
				});
				return self.wrapper.set_css(style);
			},
			run: function (fn, delay, next) {
				clearTimeout(self.wrapper.timer);
				self.wrapper.timer = setTimeout(() => {
					fn();
					if (next) next();
				}, Math.max(delay || 10, 1))
			},
			play: function (fn1, fn2, fn3, fn4, fn5) {
				let finish = () => {
					clearTimeout(self.wrapper.timer);
					self.wrapper.timer = null;
				}

				self.wrapper.run(fn1, 1, () => {
					if (fn2 == null) return finish();
					self.wrapper.run(fn2, self.wrapper.current_speed, () => {
						if (fn3 == null) return finish();
						self.wrapper.run(fn3, self.wrapper.current_speed, () => {
							if (fn4 == null) return finish();
							self.wrapper.run(fn4, self.wrapper.current_speed, () => {
								if (fn5 == null) return finish();
								self.wrapper.run(fn5, self.wrapper.current_speed, () => {
									finish();
								})
							})
						})
					})
				})
			},
			cancel: function () {
				clearTimeout(self.wrapper.timer);
			},
			set_start_pos: function (from_history) {
				let canvas_width = window.innerWidth;
				let body = $('body');
				let with_left_panel = body.hasClass('sidePanelShown');
				let with_right_panel = body.hasClass('rightPanelShown');

				if (App.device.is_mobile() && self.is_chat) return self.wrapper.set_css({ left: '100vw', right: '-'+self.width+'px', zIndex: '' });
				else if (App.device.is_mobile() && !self.is_chat) {
					// z-index для мобіли переніс в css
					self.wrapper.set_css({
						left: 0, right: 0,
						top: 'var(--visualViewport-offsetTop)', bottom: 'var(--visualViewport-offsetBottom)',
						zIndex: '',
						transform: 'translateX(100%)'
					});
					return self.wrapper;
				}
				else if (canvas_width <= 864) return self.wrapper.set_css({ left: '64px', right: '0', top: '100vh', bottom: '-100vh', zIndex: '' });

				if ((with_left_panel && canvas_width < 1024) || (with_right_panel && canvas_width < 1280)) return self.wrapper.set_css({ left: '64px', right: '0', top: '100vh', bottom: '-100vh', zIndex: '' });

				//if (from_history) self.wrapper.set_css({ top: '100vh', bottom: '-100vh' });

				// if (self.from_left_panel()) return self.wrapper.set_css({ left: 'calc(520px + 64px - 800px)', right: 'calc(100vw - 520px - 64px)' });
				if (self.from_right_panel() && canvas_width > 1400) return self.wrapper.set_css({ left: 'calc(100vw - 800px)', right: '0' });
				if (from_history) return self.wrapper.set_css({ top: '100vh', bottom: '-100vh', left: 'calc(100vw - '+self.width+'px)', right: '0' });

				return self.wrapper.set_css({ left: '100vw', right: '-'+self.width+'px' });
			},
			set_final_pos: function () {
				let canvas_width = window.innerWidth;
				if (canvas_width <= APP_SCREEN_THRESHOLD) {
					return self.wrapper.set_css({
						left: 0, right: 0,
						top: 'var(--visualViewport-offsetTop)', bottom: 'var(--visualViewport-offsetBottom)',
						transform: 'translateX(0)'
					});
				}
				if (canvas_width <= 864) return self.wrapper.set_css({ left: '64px', right: 0, top: 0, bottom: 0 });

				let body = $('body');

				let with_sidebar = body.hasClass('withSidebar'),
					with_left_panel = App.mymenu.is_shown(),
					with_right_panel = App.right_panel.is_shown() && App.right_panel.type !== 'hotkey' && App.right_panel.type !== 'plan',
					should_stick_to_chats = self.is_chat && App.mymenu.is_shown('chats') && !with_right_panel;

				let sidePanel__wrapper = $('#sidePanel__wrapper').removeClass('no-shadow'),
					rightPanel__wrapper = $('#rightPanel__wrapper').removeClass('no-shadow');

				body.toggleClass('withTaskView-fullscreen', self.open_in_fullscreen);
				self.obj_wrapper.toggleClass('taskView__wrapper-fullscreen', self.open_in_fullscreen).removeClass('taskView__wrapper-withoutFullscreen');
				let size = { left: self.open_in_fullscreen ? 64 : canvas_width-self.width, right: 0, top: 0, bottom: 0 };

				if (with_left_panel && with_right_panel) {
					sidePanel__wrapper.addClass('no-shadow');
					rightPanel__wrapper.addClass('no-shadow');
					self.obj_wrapper.addClass('taskView__wrapper-withoutFullscreen');
					size.left = 64 + sidePanel__wrapper.width();
					size.right = rightPanel__wrapper.width();
				} else if (with_left_panel) {

					if (canvas_width < 1680 || should_stick_to_chats) {
						sidePanel__wrapper.addClass('no-shadow');
						self.obj_wrapper.addClass('taskView__wrapper-withoutFullscreen');
						size.left = 64 + sidePanel__wrapper.width();
					} else if (self.open_in_fullscreen) {
						sidePanel__wrapper.addClass('no-shadow');
						size.left = 64 + sidePanel__wrapper.width();
					}

				} else if (with_right_panel) {
					rightPanel__wrapper.addClass('no-shadow');

					if (canvas_width < 1400) {}
					else if (canvas_width < 1750) {
						self.obj_wrapper.addClass('taskView__wrapper-withoutFullscreen');
						size.left = 64;
						size.right = rightPanel__wrapper.width();
					} else if (self.open_in_fullscreen) {
						rightPanel__wrapper.addClass('no-shadow');
						size.left = 64;
						size.right = rightPanel__wrapper.width();
					} else {
						size.right = rightPanel__wrapper.width();
						size.left = Math.max(64, canvas_width - size.right - self.width);
						self.obj_wrapper.toggleClass('taskView__wrapper-withoutFullscreen', size.left < 200);
					}

				}

				return self.wrapper.set_css(size);
			},
			update_pos: function (speed) {
				if (!self.wrapper.is_shown) {
					self.wrapper.update_pos_after = true;
					return false;
				}

				self.wrapper.update_pos_after = false;
				self.wrapper.play(
					() => self.wrapper.set_speed(speed || 300).set_final_pos()
				);
			},
			after_show: function () {
				self.wrapper.set_speed(0).set_css({ transform: '' });
				self.obj_wrapper.find('.taskView').css('opacity', '').css('transition', '');

				self.wrapper.is_shown = true;
				if (self.wrapper.update_pos_after) self.wrapper.update_pos(10);
			},
			after_hide: function () {
				self.wrapper.is_shown = false;
				$('#sidePanel__wrapper, #rightPanel__wrapper').removeClass('no-shadow');
				self.wrapper.set_speed(0).set_css({ opacity: '', zIndex: '', display: 'none', top: '0', bottom: '0', transform: '' });
				self.obj_wrapper.removeClass('taskView__wrapper-fullscreen').removeClass('taskView__wrapper-withoutFullscreen').find('.taskView').show();
				if (self.obj_wrapper.hasClass('swype')) {
					self.obj_wrapper
						.css({
							transition: '',
							transform: '',
						})
						.removeClass('swype');
				}
			},
			before_hide: function () {
				$('body').removeClass('withTaskView').removeClass('withTaskView-fullscreen');
			}
		},

		animate_show: function(from_history, is_chat, next) {
			$('body').addClass('withTaskView');
			if (self.shown) {
				self.wrapper.after_show();
				if (next) next();
				// self.wrapper.play(
				// 	() => self.wrapper.set_css({ display: 'block' }),
				// 	() => self.wrapper.set_speed(300).set_final_pos(),
				// 	self.wrapper.after_show, next
				// )
			} else if(window.innerWidth > 864 && self.open_in_fullscreen && !self.from_left_panel() && !self.from_right_panel()) {
				self.wrapper.reset_css().play(
					() => {
						self.wrapper.set_final_pos().set_css({ opacity: 0 });
						self.obj_wrapper.find('.taskView').css('opacity', 0).css('transition', 'opacity 0.1s 0.2s linear');
					},
					() => self.wrapper.set_css({ display: 'block' }),
					() => {
						self.wrapper.set_speed(300).set_css({ opacity: 1 });
						self.obj_wrapper.find('.taskView').css('opacity', 1);
					},
					self.wrapper.after_show, next
				);
			} else if(window.innerWidth <= APP_SCREEN_THRESHOLD) {
				self.wrapper.reset_css().play(
					() => self.wrapper.set_start_pos(from_history),
					() => self.wrapper.set_css({ display: 'block' }),
					() => self.wrapper.set_speed(300).set_final_pos(),
					self.wrapper.after_show, next
				);
			} else {
				self.wrapper.reset_css().play(
					() => self.wrapper.set_start_pos(from_history),
					() => self.wrapper.set_css({ display: 'block' }),
					() => self.wrapper.set_speed(300).set_final_pos(),
					self.wrapper.after_show, next
				);
			}
		},

		animate_hide: function(to_history, callback) {
			self.wrapper.before_hide();

			if ($(window).width() <= APP_SCREEN_THRESHOLD) {
				self.wrapper.play(
					() => self.wrapper.set_speed(300).set_start_pos(),
					self.wrapper.after_hide,
					callback
				);
			} else if (to_history && !self.from_right_panel()) {
				self.wrapper.play(
					() => self.wrapper.set_speed(300).set_css({ top: '100vh', bottom: '-100vh' }),
					() => self.wrapper.reset_css({ top: '', bottom: '' }),
					self.wrapper.after_hide,
					callback
				);
			} else if($(window).width() > 864 && self.open_in_fullscreen && !self.from_left_panel() && !self.from_right_panel()) {
				self.wrapper.play(
					() => {
						self.obj_wrapper.find('.taskView').hide();
						self.wrapper.set_speed(200).set_css({ opacity: 0 });
					},
					self.wrapper.after_hide,
					callback
				);
			} else {
				self.wrapper.play(
					() => self.wrapper.set_speed(300).set_start_pos(),
					self.wrapper.after_hide,
					callback
				);
			}
		},

		minimize: function() {
			if (self.debug) console.trace('TASK_VIEW::minimize');
			if (self.hiding || App.comment_form.is_submitting()) return;
			if (!self.window.is_ready()) return;
			if (self.edit_inline.is_shown()) return self.edit_inline.end(self.obj_window.find('.taskView__head .minimize'));

			self.window.minimizing();
			self.fallback_background();
			self.before_close(true);
			self.animate_hide(true, function () {
				self.window.closed();
				self.shown = false;
				self.hiding = false;
				self.has_loaded = false;
				self.url = '';
				self.id = '';
				self.detach();
			});
		},

		on_foreground: function () {
			App.editor.init(self.obj_window);
		},

		detach: function() {
			if (self.obj_window) self.obj_window.detach();
			if (self.obj_menus) self.obj_menus.detach();
		},

		remove: function() {
			if (self.minibar) self.minibar.destroy();
			if (self.obj_window) self.obj_window.removeWithComponents();
			if (self.obj_menus) self.obj_menus.removeWithComponents();
		},

		relations: {
			last_mouse_event: null,
			get_relations_html: function (param_item_el) {
				return $(param_item_el).find('.relationsListing__item').get().map(function (el) {
					return {
						id_related_task: parseInt(el.getAttribute('data-relation')),
						item_html: el.outerHTML,
						dateadd: parseInt(el.getAttribute('data-dateadd')),
					};
				});
			},
			redraw: function (param_item_el, relations) {
				$(param_item_el).find('.value__wrapper').html(App.helper.template.fill('task_view_relations', {
					has_relations: relations.length > 0,
					prepared_html: relations.sort(function (a, b) {
						return a.dateadd - b.dateadd;
					}).map(i => i.item_html).join(''),
				}));
			},
			send: function (action, id_related_task, type) {
				$.getScript(App.helper.url.add_query(self.url, App.actions.get('task_relations:'+action), {
					id_related_task: id_related_task,
					type: type || ''
				}));
			},
			show_confirm: function (params) {
				App.menu.log_mouse_position(self.relations.last_mouse_event);
				App.controls.confirm.menu(null, {
					backup: true,
					message: params.message,
					ok_label: params.ok_label,
					onconfirm: function () {
						$.getScript(App.helper.url.add_query(self.url, App.actions.get('task_relations:'+params.action), params.data));
					}
				})
			},
			on_add: function () {
				const selected_type = $(this).attr('data-type');

				App.controls.task_select_and_go.show_context(this, App.helper.endpoint.ajax(self.get_id_project()), {
					request: { type: 'relation', relation_type: selected_type, id_skip: self.id  },
					type: 'left',
					replace: false,
					backup: true,
					load_always: true,
					onload: function() {
						let menu = $(this);
						menu.on('click', '.menu__item[data-id]', function(e) {
							self.relations.last_mouse_event = e;
							self.relations.send('add', $(this).attr('data-id'), selected_type)
						});
						menu.find('.menu__group-search input').bind('keyup', function () {
							menu.find('.switch_search_mode b').text(this.value);
							App.context_search.menu.apply(this.value, menu);
						});
					},
				});
			},
			on_edit: function (e) {
				const selected_type = $(this).attr('data-type');
				const relation_id = $(this).attr('data-relation');
				const action = $(this).hasClass('menu__item-delete') ? 'delete' : 'update';

				self.relations.last_mouse_event = e;
				self.relations.send(action, relation_id, selected_type)
			},
			show_menu: function (menu_anchor, endpoint, params) {
				params ||= {};
				App.menu.show({
					anchor: menu_anchor,
					url: endpoint,
					type: 'left',
					width: 410,
					load_always: true,
					onload: params.onload || null,
					replace: params.replace || false,
				});
			},
			init: function() {

				self.obj_window.find('.taskView__params__item[data-key=relations]').off('click')
					.on('click', '.value__wrapper', function(e) {
						if ($(this).closest('.readonly').length === 1 || $(e.target).closest('.relationsListing__item').length === 1) return;

						self.relations.show_menu(
							$(e.target).closest('.value__wrapper').get(0),
							App.helper.url.add_query(self.url, App.actions.get('task_relations:menu')),
							{ onload: function () { $(this).on('click', 'a', self.relations.on_add); } }
						);
					})
					.on('click', '.relationsListing__item .relation_type, .relationsListing__item task-term', function(e) {
						e.stopPropagation();
						if ($(this).closest('.readonly,.locked').length === 1) return e.preventDefault();

						let item_el = $(this).closest('.relationsListing__item');

						self.relations.show_menu(
							item_el.get(0),
							App.helper.url.add_query(self.url, App.actions.get('task_relations:menu'), {
								id_related_task: item_el.attr('data-relation'),
								type: item_el.attr('data-type'),
							}),
							{ onload: function() { $(this).on('click', 'a', self.relations.on_edit); } }
						);
					});
			},
			reload: function () {
				self.reload_fragment('.taskView__params__item[data-key=relations]', function () {
					self.relations.init();
					self.props.init();
				});
			}
		},

		reminders: {
			get_reminders_html: function (param_item_el) {
				return $(param_item_el).find('.reminderListing__item').get().map(function (el) {
					return {
						id: parseInt(el.getAttribute('data-reminder')),
						html: el.outerHTML
					};
				});
			},
			redraw: function (param_item_el, reminders) {
				$(param_item_el).find('.value__wrapper').html(App.helper.template.fill('task_view_reminders', {
					has_reminders: reminders.length > 0,
					prepared_html: reminders.map(i => i.html).join(''),
				}));
			},
			init: function() {
				self.obj_window.find('.taskView__params__item[data-key=reminders]').off('click')
					.on('click', '.value__wrapper', function(e) {
						App.modal.show({
							url: App.helper.url.add_query(self.url, App.actions.get('task_reminder:show')),
						});
						return false;
					})
					.on('click', '.delete', function(e) {
						e.stopPropagation();
						let endpoint = App.helper.url.add_query(self.url, App.actions.get('task_reminder:delete') + '&id=' + $(this).parents('.reminderListing__item').attr('data-reminder'));
						App.controls.confirm.menu(this, {
							ok_label: App.object_state.locale.yes_delete,
							message: App.object_state.locale.ask_delete,
							onconfirm: function () { $.getScript(endpoint); }
						});
						return false;
					})
					.on('click', '.reminderListing__item-editable .reminder_data', function(e) {
						e.stopPropagation();
						App.modal.show({
							url: App.helper.url.add_query(self.url, App.actions.get('task_reminder:show') + '&id=' + $(this).parents('.reminderListing__item').attr('data-reminder')),
						});
						return false;
					});
			},
			append: function(html, id) {
				let o = self.obj_window.find('.reminderListing__item[data-reminder='+id+']');
				if (o.length) o.replaceWith(html); else self.obj_window.find('.reminderListing').append(html);
			},
		},

		meets: {
			get_meets_html: function (param_item_el) {
				return $(param_item_el).find('.meetListing__item').get().map(function (el) {
					return {
						id: parseInt(el.getAttribute('data-meet')),
						html: el.outerHTML
					};
				});
			},
			redraw: function (param_item_el, meets) {
				$(param_item_el).find('.value__wrapper').html(App.helper.template.fill('task_view_meets', {
					has_meets: meets.length > 0,
					prepared_html: meets.map(i => i.html).join(''),
				}));
			},
			init: function() {
				self.obj_window.find('.taskView__params__item[data-key=meets]').off('click')
					.on('click', '.value__wrapper', function(e) {
						if ($(e.target).closest('.meetListing, .meetListing__item:not(.meetListing__item-editable)').length) {
							return false;
						}
						App.modal.show({
							url: App.helper.url.add_query(self.url, App.actions.get('task_meet:show')),
						});
						return false;
					})
					.on('click', '.meetListing__item:not(.meetListing__item-editable)', function(e) {
						e.stopPropagation();
						return false;
					})
					.on('click', '.delete', function(e) {
						e.stopPropagation();
						let endpoint = App.helper.url.add_query(self.url, App.actions.get('task_meet:delete') + '&id=' + $(this).parents('.meetListing__item').attr('data-meet'));
						App.controls.confirm.menu(this, {
							ok_label: App.object_state.locale.yes_delete,
							message: App.object_state.locale.ask_delete,
							onconfirm: function () { $.getScript(endpoint); }
						});
						return false;
					})
					.on('click', '.meetListing__item-editable .meet_data', function(e) {
						e.stopPropagation();
						App.modal.show({
							url: App.helper.url.add_query(self.url, App.actions.get('task_meet:show') + '&id=' + $(this).parents('.meetListing__item').attr('data-meet')),
						});
						return false;
					})
					.on('click', '.meetListing__item a[href]', function(e) {
						e.stopPropagation();
					});
			},
			append: function(html, id) {
				let o = self.obj_window.find('.meetListing__item[data-meet='+id+']');
				if (o.length) o.replaceWith(html); else self.obj_window.find('.meetListing').append(html);
			},
		},

		costs: {
			used_money: false,
			format_info: {
				time: function (real, max) {
					let val = App.format.time(60 * real, 1);
					let percent = max > 0 ? Math.floor(100 * real / max) : null;
					return max > 0
						? ('<b>' + percent + '%</b> ' + App.object_state.locale['s_of_s'].replace('%s', '<i>'+val+'</i>').replace('%s', '<span class="limit">' + App.format.quantity(Math.round(max), App.object_state.locale['hrs'], true) + '</span>'))
						: ('<b>' + val + '</b> ' + App.format.quantity(real, App.object_state.locale['hrs']));
				},
				money: function (real, max) {
					let val = App.format.money(100 * real, 1);
					let percent = max > 0 ? Math.floor(100 * real / max) : null;
					return max > 0
						? ('<b>' + percent + '%</b> ' + App.object_state.locale['s_of_s'].replace('%s', '<i>'+val+'</i>').replace('%s', '<span class="limit">' + Math.round(max) + ' ' + App.object_state.locale['currency'] + '</span>'))
						: ('<b>' + val + '</b> ' + App.object_state.locale['currency']);
				},
			},
			init: function () {
				self.obj_window.find('.taskView__params__item[data-key=costs]').on('click', '.value__wrapper', function () {
					if ($(this).attr('data-costs-url') == null) return;

					App.modal.show({ url: $(this).attr('data-costs-url'), group: 'time' })
				}).on('click', 'ws-icon[name=plus_sm]', function(e) {
					e.stopPropagation();
					const el = $(this).closest('.value__wrapper')
					if (el.attr('data-costs-add-url') == null) return;

					App.modal.show({
						url: el.attr('data-costs-add-url'),
						group: 'time_add'
					})
				}).on('click', '.limit', function(e) {
					const el = $(this).closest('.value__wrapper')
					if (el.attr('data-limits-url') == null) return;

					e.stopPropagation();

					const data_type = $(this).closest('[data-container]').attr('data-container')
					App.modal.show({
						url: App.helper.url.add_query(el.attr('data-limits-url'), '', { focus: data_type }),
						title: el.attr('data-limits-title'),
						group: 'userto',
						width: 450
					})
				});
			},
			update: function(task_window, data, type) {
				const prop_value = task_window.find('.taskView__params__item[data-key=costs] .value__wrapper')

				const calc_state = function (key) {
					const el = prop_value.find('.data .cost[data-container='+key+']');

					const current_state = el.length === 1 ? {show: true, real: parseFloat(el.attr('data-used')), max: parseFloat(el.attr('data-max')), over: el.attr('data-over'), text: App.helper.html.encode(el.find('.in').text())} : {};
					const new_state = {show: false, real: 0, max: 0, over: '', text: '', ...current_state};
					const new_value = data[key];

					new_state.max = type === 'limit' ? (new_value ?? new_state.max) : new_state.max;
					new_state.real+= type === 'costs' ? (new_value ?? 0) : 0;
					new_state.show = new_state.real > 0 || new_state.max > 0;
					new_state.over = new_state.max > 0 && new_state.max < new_state.real ? 'yes' : '';
					new_state.text = self.costs.format_info[key](new_state.real, new_state.max);
					new_state.text = App.helper.template.html_encode_param(new_state.text);

					if (key === 'money' && !self.costs.used_money) new_state.show = false;

					return new_state;
				}

				const time = calc_state('time');
				const money = calc_state('money');

				prop_value.html(App.helper.template.fill('task_view_costs', {
					has_data: time.show || money.show,
					has_plan: time.max > 0 || money.max > 0,
					time: time,
					money: money,
				}));
			},
		},

		paginal: {
			adapter: null,
			i: 0,

			init: function(anchor) {
				self.obj_window.find('.taskView__paginal').addClass('hiddenBlock');

				// при зміні контексту чистимо попереднє
				this.destroy();

				anchor = anchor ?? self.anchor;
				if (!anchor) return;

				if (self.is_task_list_highlight()) {
					let container = $(anchor).closest('.keyboardZone');
					if (container.length) container.find('.last_selected').removeClass('last_selected');
				}

				App.keyboard_selection.select_by_click(anchor);
				anchor = $(anchor);

				// пробуємо створити adapter по data-tasks
				let adapter = this.create_ids_adapter(anchor);

				// fallback на DOM adapter
				if (!adapter) {
					adapter = this.create_dom_adapter(anchor);
				}

				if (!adapter || adapter.length < 2) return;

				this.adapter = adapter;
				this.i = adapter.getIndex(anchor);

				if (this.adapter.setActive) {
					this.adapter.setActive(this.i);
				}

				self.obj_window.find('.taskView__paginal').removeClass('hiddenBlock');
				this.render();
			},

			go: function(step) {
				if (!this.adapter) return;

				this.i += step;

				if (this.i === 0) this.i = this.adapter.length;
				if (this.i === this.adapter.length + 1) this.i = 1;

				this.adapter.go(this.i);
				this.render();
			},

			render: function() {
				self.obj_window.find('.taskView__paginal .in')
					.html('<b>' + this.i + '</b> / ' + this.adapter.length);
			},

			destroy: function() {
				if (!this.adapter) return;

				// прибираємо підсвітку (ids-режим)
				if (this.adapter.cleanup) {
					this.adapter.cleanup();
				}

				this.adapter = null;
				this.i = 0;

				self.obj_window.find('.taskView__paginal')
					.addClass('hiddenBlock')
					.find('.in')
					.html('');
			},

			// =========================
			// ADAPTERS
			// =========================

			create_ids_adapter: function(anchor) {
				let tasks = anchor.attr('data-tasks');
				if (!tasks) return null;

				let ids = tasks.split(',').map(id => +id.trim()).filter(Boolean);
				if (ids.length < 2) return null;

				return {
					length: ids.length,

					getIndex: function(anchor) {
						// let current_id = +anchor.attr('data-task');
						let current_id = +self.id;
						let index = ids.indexOf(current_id);
						return index >= 0 ? index + 1 : 1;
					},

					setActive: function(i) {
						let id = ids[i - 1];
						let href = App.helper.url.task(id);

						anchor.find('[data-href]').removeClass('activeByPaginal');
						anchor.find('[data-href="' + href + '"]').addClass('activeByPaginal');
					},

					go: function(i) {
						let id = ids[i - 1];
						let href = App.helper.url.task(id);

						this.setActive(i);

						App.window.task_view.open({ url: href, anchor });
					},

					cleanup: function() {
						anchor.find('[data-href].activeByPaginal')
							.removeClass('activeByPaginal');
					}
				};
			},

			create_dom_adapter: function(anchor) {
				let container = anchor.closest('.keyboardZone');
				if (!container.length) return null;

				if (!anchor.is(container.attr('data-select'))) {
					anchor = anchor.closest(container.attr('data-select'));
				}
				if (!anchor.length) return null;

				const selector = container.attr('data-task-select') ?? container.attr('data-select');
				let items = container.find(selector);
				if (items.length < 2) return null;

				return {
					length: items.length,

					getIndex: function(anchor) {
						let found = 1;

						items.each(function(i) {
							if (this === anchor.get(0)) {
								found = i + 1;
								return false;
							}
						});

						return found;
					},

					go: function(i) {
						items.eq(i - 1).trigger('click', [{force: true}]);
					},

					cleanup: function() {
						items.removeClass('activeByPaginal');
					}
				};
			}
		},

		like: {
			has_my: function(el) {
				let tpl_data = el.tpl_data;
				if (typeof tpl_data.likes === 'object' && tpl_data.likes !== null && !Array.isArray(tpl_data.likes)) {
					for (const key in tpl_data.likes) {
						if (Array.isArray(tpl_data.likes[key])) {
							if (tpl_data.likes[key].some(value => parseInt(value) !== parseInt(App.me.id) && parseInt(value) in App.team)) {
								return false;
							}
						}
					}
				}
				return true;
			},
			add_like_details: function(el) {

				const tpl_data = el.tpl_data;
				const menu = $('#taskView__reaction_menu');
				const scrollZone = menu.find('.menu__group__wrapper .scrollZone');

				menu.find('.likes').first().before(App.components.task_reactions.template(tpl_data, 'task_view_mobile_my'));
				if (!App.task_view.like.has_my(el)) scrollZone.append(App.components.task_reactions.template(tpl_data, 'task_view_mobile'));
				if (menu.outerHeight() >= $(window).height() * 0.7 && menu.find('.my_likes .menu__item').length > 3) {
					scrollZone.prepend(menu.find('.my_likes'));
				}
			},
			apply: function (url, el, anti) {
				let id_comment = $(el).closest('[data-comment]').attr('data-comment') || 0;
				anti = anti ? 1 : 0;
				$.getScript(App.helper.url.add_query(url, App.actions.get('task_like:apply') + '&' + $.param({
					id_comment,
					like: $(el).attr('data-reaction') || $(el).attr('rel'),
					anti
				})));
				App.menu.hide(true);
			},
			init: function() {
				self.obj_window.find('.taskView__params__item[data-key=reactions]')
					.on('click', '.taskView__likes', function(e) {
						if ($(e.target).closest('.taskView__params__item.readonly').length) return;

						$('#taskView__reaction_menu')
							.attr('data-comment', 0)
							.attr('data-url', self.url)
							.find('.like_details').remove();
						let el = $(this).find('task-reactions').get(0);
						let tpl_data = el.tpl_data;
						if (!$(e.target).parent().addBack().hasClass('add_val')) {
							App.task_view.like.add_like_details(el);
						}
						App.menu.show({
							anchor: this,
							box: '#taskView__reaction_menu',
							type: 'left',
							title: App.object_state.locale['react'],
							onshow: function () {
								$(this).find('.menu__like').each(function () {
									$(this).removeClass('active');
									let reaction = parseInt($(this).attr('data-reaction'));
									if (tpl_data.likes[reaction] && tpl_data.likes[reaction].some(item => parseInt(item) === parseInt(App.me.id))) {
										$(this).addClass('active');
									}
								})
							}
						});
					});
				self.obj_window.on('click', '.commentList__item task-reactions', function(e, data) {
					data ||= {}
					$('#taskView__reaction_menu')
						.attr('data-comment', $(this).closest('.commentList__item').attr('data-id'))
						.attr('data-url', self.url)
						.find('.like_details').remove();
					let el = $(this).get(0);
					let tpl_data = el.tpl_data;
					App.task_view.like.add_like_details(el);
					App.menu.show({
						anchor: data.anchor || $(this).parent(),
						box: '#taskView__reaction_menu',
						type: 'left',
						replace: App.menu.is_shown(),
						title: App.object_state.locale['react'],
						onshow: function () {
							$(this).find('.menu__like').each(function () {
								$(this).removeClass('active');
								let reaction = parseInt($(this).attr('data-reaction'));
								if (tpl_data.likes[reaction] && tpl_data.likes[reaction].some(item => parseInt(item) === parseInt(App.me.id))) {
									$(this).addClass('active');
								}
							})
						}
					});
				});
			}
		},

		subscribers: {
			max_items_show: 6,
			init: function () {
				let more_el = self.obj_window.find('.commentForm__subscribers .more')

				if (more_el.length === 1) {
					more_el.attr('data-title', self.subscribers.get_more_title(self.obj_window))
				}
			},
			get_more_title: function (o) {
				let show_max = 20;
				let titles = o.find('.commentForm__subscribers .commentForm__subscribers__item').get().slice(5).map(el => el.getAttribute('data-title'));
				let label = o.find('.commentForm__subscribers').attr('data-label');

				return '%G' + label + ':G%\n' + (titles.length > show_max ? titles.slice(0, show_max).join(', ') + '\n+ ' + (titles.length - show_max) : titles.join(', '));
			},
			update_html: function(o, ids_user, id) {
				if (App.task_view.is_shown() && App.task_view.id === id && App.task_view.obj_detached) {
					o = App.task_view.obj_detached; // In case of form detached
				} else if (!o.hasClass('commentForm')) {
					o = o.find('.commentForm');
				}

				let silent = o.find('input[name=ids_silent]').val().toIntArray();
				let hidden = o.find('input[name=hidden]').val().toIntArray();

				silent = silent.filter(i => ids_user.includes(i));
				o.find('input[name=ids_silent]').val(silent.join(','));

				let html = [];
				let silent_html = [];
				o.find('.commentForm__subscribers').find('.commentForm__subscribers__item, .more').not('[data-id=4]').remove();
				ids_user.forEach(function(id) {
					(silent.includes(id) ? silent_html : html).push(App.helper.template.fill('task_view_subscriber', {
						name: App.helper.team(id, 'name'),
						avatar: App.helper.team(id, 'avatar'),
						id: id,
					}));
				});
				o.find('.commentForm__subscribers').attr('data-empty', ids_user.length===0?'yes':'no');
				o.find('.commentForm__subscribers .in').append(html.join(''));
				o.find('.commentForm__subscribers .silent').append(silent_html.join(''));
				o.find('.commentForm__subscribers .commentForm__subscribers__item').each(function () {
					$(this).toggleClass('commentForm__subscribers__item-hidden', !!hidden.length && !hidden.includes($(this).attr('data-id').toInt()));
				});
				if (html.length > self.subscribers.max_items_show) {
					o.find('.commentForm__subscribers .in').append(
						$('<span>', { class: 'more', text: '+' + (html.length - (self.subscribers.max_items_show-1)), 'data-title': self.subscribers.get_more_title(o) })
					);
					o.find('.commentForm__subscribers .plus').hide();
				} else {
					o.find('.commentForm__subscribers .plus').show();
				}

				let is_me_on = ids_user.includes(App.me.id);
				o.find('.commentForm__foot').toggleClass('commentForm__foot-subscribed', is_me_on);

				App.comment_form.update_invites(o);
			}
		},

		edit_inline: {
			obj: null,
			button_place: null,
			old_state: null,
			locale: {},
			is_shown: function () {
				return this.obj != null;
			},
			is_empty: function () {
				return !this.has_text() && this.count_files() === 0;
			},
			get_summary_text: function () {
				return self.obj_window.find('.taskView__group-descr .taskView__group__content .descr').attr('data-summary') || '';
			},
			has_text: function () {
				return self.obj_window.find('.taskView__group-descr .taskView__group__content .descr').attr('data-empty') !== 'yes' && this.count_files() === 0;
			},
			count_files: function () {
				return self.obj_window.find('.taskView__group-descr .taskView__group__content .fileItem').length;
			},
			get_file_names: function () {
				return self.obj_window.find('.taskView__group-descr .taskView__group__content .fileItem .name').toArray().map(i => i.innerText);
			},
			blink: function () {
				self.obj_window.find('.taskView__group-descr').blink();
			},
			init: function () {
				let its = self.edit_inline;

				self.obj_window.find('.taskView__group-descr .button_place .add, .taskView__group-descr .button_place .edit').off('click').on('click', function () {
					App.task_view.edit_inline.show('descr', $(this).closest('[data-edit-url]').attr('data-edit-url'));
					return false;
				});

				self.obj_window.find('.taskView__group-descr .taskView__group__content .descr').off('click').on('click', function () {
					if (its.is_empty()) $('.taskView__group-descr .button_place .add').click();
				});

				self.obj_window.find('.taskView__group-descr').toggleClass('empty', its.is_empty());
				// self.obj_window.find('.taskView__group-descr.empty').parent().toggleClass('collapsed', its.is_empty());

				self.obj_window.find('.taskView__group-descr .taskView__group__head .info-text').toggleClass('hiddenBlock', !its.has_text());
				self.obj_window.find('.taskView__group-descr .taskView__group__head .info-files').attr('text', its.count_files()).toggleClass('hiddenBlock', !its.count_files());

				self.obj_window.find('.taskView__group-descr .taskView__group__head .info-text').attr('data-title', its.get_summary_text())
				self.obj_window.find('.taskView__group-descr .taskView__group__head .info-files').attr('data-title', its.get_file_names().join(', '))

			},
			toggle_expand: function () {
				self.edit_inline.obj.closest('.taskView').toggleClass('taskView-descr_expanded');
				let is_expanded = self.edit_inline.obj.closest('.taskView').hasClass('taskView-descr_expanded');

				App.editor.auto_height = is_expanded;

				if (is_expanded) App.helper.nextTick(App.editor.focus);

				let btn = self.edit_inline.obj.find('.input_expand');
				btn.attr('data-title', btn.attr(is_expanded ? 'data-title2' : 'data-title1')).attr('right-icon', is_expanded ? 'arrows/input_collapse' : 'arrows/input_expand');
			},
			saved: function (html) {
				self.obj_window
					.find('.taskView__group-descr .taskView__group__content')
					.html(html);

				self.edit_inline.end();
			},
			show: function(type, endpoint) {
				if (self.edit_inline.is_shown()) return self.edit_inline.end();

				App.core.async_task.ajax({
					id: 'task_view_edit_inline_show',
					url: endpoint,
				}).then(function(html) {
					if (type === 'descr') {
						self.obj_window.addClass('taskView__editing-descr');
						self.obj_window.find('.taskView__group-descr').closest('.taskView__group__wrapper').removeClass('collapsed');
						self.edit_inline.obj = $('<div />').attr('class', 'taskView__group__contentEdit').html(html).insertAfter(self.obj_window.find('.taskView__group-descr').addClass('taskView__group-editing').find('.taskView__group__content').hide());
						App.editor.init(self.edit_inline.obj);
						App.comment_form.detach();
						self.edit_inline.obj.find('.place_button .btn-cancel').click(self.edit_inline.cancel);
						self.edit_inline.obj.find('.place_button .btn-primary').click(self.edit_inline.submit);
						self.edit_inline.button_place = self.obj_window.find('.taskView__group-descr .button_place').clone();
						self.obj_window.find('.taskView__group-descr .button_place').replaceWith(self.edit_inline.obj.find('.place_button'));
						App.editor.focus();

						self.edit_inline.old_state = self.edit_inline.get_state_hash();

						self.edit_inline.obj.find('.scrollZone').not('.ps').each(function() {
							this.scrollBars = App.controls.js_scrollbars.init(this);
						});
						if (!App.device.is_mobile()) self.edit_inline.obj.find('.commentForm__content').on('click', function (e) {
							if ($(e.target).hasClass('commentForm__content')) App.editor.focus();
						});
					}
				})
			},
			cancel: function () {
				self.edit_inline.old_state = null;
				self.edit_inline.end();
			},
			submit: function () {
				self.edit_inline.old_state = null;
				App.core.form_submit(self.edit_inline.obj.find('form').get(0));
			},
			collapse: function () {
				if (!self.edit_inline.obj.closest('.taskView').hasClass('.taskView-descr_expanded')) return;

				self.edit_inline.obj.closest('.taskView').removeClass('taskView-descr_expanded');
			},
			get_state_hash: function () {
				if (self.edit_inline.obj == null) return null;

				return self.edit_inline.obj.find('form').serialize().hashCode();
			},
			is_dirty: function () {
				return self.edit_inline.obj != null
					&& self.edit_inline.old_state !== null
					&& self.edit_inline.old_state !== self.edit_inline.get_state_hash();
			},
			ask_when_not_saved: function (anchor) {
				App.controls.confirm.menu(anchor, {
					...self.edit_inline.locale.alert,
					onconfirm: self.edit_inline.submit,
					oncancel: self.edit_inline.cancel
				});
			},
			end: function(anchor) {
				if (self.edit_inline.obj == null) return;

				if (!self.hiding && self.edit_inline.is_dirty()) {
					self.edit_inline.ask_when_not_saved(
						anchor || self.obj_window.find('.taskView__group-descr .place_button .btn-primary')
					);
					return;
				}

				self.edit_inline.collapse();

				self.edit_inline.obj.find('.scrollZone').each(function() {
					if (self.edit_inline.scrollBars) self.edit_inline.scrollBars.destroy();
				});

				if (self.edit_inline.button_place != null) {
					self.obj_window.find('.taskView__group-descr .place_button').replaceWith(self.edit_inline.button_place);
					self.edit_inline.button_place = null;
				}

				self.obj_window.removeClass('taskView__editing-descr');

				self.edit_inline.obj.prev().show().parents('.taskView__group-editing').removeClass('taskView__group-editing');
				self.edit_inline.obj.remove();
				self.edit_inline.obj = null;
				self.edit_inline.init();

				App.comment_form.restore();
			}
		},

		clear_counter: function(id_task) {
			App.object_state.update('task', id_task, {
				seen: true
			}, MY_DIRECT_ACTION);

			App.core.send_message_to_other_devices({
				command: 'object_state',
				data: {
					obj_type: 'task',
					obj_id: id_task,
					obj_data: {seen: true}
				},
			}, 'task_seen' + id_task);
		},

		reload_fragment: function (selector, next) {
			if (!self.is_shown()) return;
			App.helper.reload_html_fragment(self.url, $(self.obj_window), selector, next);
		},

		get_id_project: function() {
			return self.obj_window?.attr('data-project') || null;
		},

		get_id_parent_top: function() {
			return parseInt(self.obj_window?.attr('data-parent-top'), 10) || 0;
		},

		build_document_title: function() {
			let id_parent_top = self.get_id_parent_top();
			let suffix = self.obj_window.attr('data-title-suffix') || '';
			let name = App.helper.task_name(self.id) || '';
			let project = self.obj_window.attr('data-project-name') || '';

			if (id_parent_top) {
				let parent = App.helper.task_name(id_parent_top) || '';
				return name + ' - ' + parent + ' - ' + project + suffix;
			}
			return name + ' - ' + project + suffix;
		},

		sync_document_title: function(id, id_project, project_name) {
			if (!self.is_shown() || self.is_chat || !self.id || !self.window.is_opened()) return;

			if (id_project != null) {
				if (+self.get_id_project() !== +id_project) return;
				if (project_name) self.obj_window.attr('data-project-name', project_name);
			}
			if (id != null) {
				let id_parent_top = self.get_id_parent_top();
				if (+self.id !== +id && +id_parent_top !== +id) return;
			}

			let title = self.build_document_title();
			if (title === self.title) return;

			self.title = title;
			App.core.set_document_title(title);
		},

		destructor: function() {
			task_view_width.del();
			task_view_fullscreen.del();
			chat_view_width.del();
			chat_view_fullscreen.del();

			App.core.async_task.abort('task_view_show');

			if (self.is_shown()) {
				self.wrapper.after_hide();
				self.edit_inline.end();
				App.comment_form.stop();
			}
			self.scroller.unobserve();
			self.remove();
			self.shown = false;
			self.window.closed();
			self.minibar = null;
			self.obj_wrapper?.html('');
			self.obj_window = null;
			self.obj_menus = null;
			self.anchor = null;
			self.need_reload_buttons = false;
			self.costs.used_money = false;
			self.exit_fullscreen_url = null;
			self.open_in_fullscreen = false;
			self.paginal.adapter = null;
			self.paginal.i = 0;
			self.properties_config = null;
			self.props.config = null;
			self.props.locale = null;
			self.scroller.obj_content = null;
			self.is_chat = false;
			self.title = '';
			self.hash = '';
			self.url = '';
			self.id = '';
			self.id_prev = 0;
			self.locale = {};
			delete self['skeleton'];
		},

		name: {
			init() {
				let name = self.obj_wrapper.find('.taskView__name');

				name.on('apply', function (e) {
					let endpoint = name.attr('data-edit-url');
					if (e.detail.has_error || endpoint == null) return;

					$(e.detail.el).attr('value', e.detail.value);

					App.core.async_task.ajax( // $.getScript?
						App.helper.url.add_query(
							endpoint,
							'name='+encodeURIComponent(e.detail.value),
							self.is_chat ? {} : App.controls.notify.notify_params('task_edit_name')
						)
					)
				});
			}
		},

		init_group_wrapper: function () {
			App.classes.ui_state_manager.getInstance().loadState({
				onLoaded(state) {
					self.obj_wrapper.find('.taskView__group__wrapper[data-state-key]').each(function () {
						const wrapper = $(this);
						if (wrapper.hasClass('taskView__subtasks__wrapper') && self.obj_window.hasClass('taskView-no_subtasks')) {
							wrapper.addClass('collapsed');
							return;
						}
						const key = wrapper.attr('data-state-key');
						const is_collapsed = !Boolean(state[key]);
						wrapper.toggleClass('collapsed', is_collapsed);
					});
				}
			});
		},

		props: {
			config: {
				order_index: [],
				visibility: {}
			},
			locale: null,
			item_template: `
				<div class="taskView__params__item flex_row" data-key="{key}">
					<div class="param flex_row withRipple">
						<span class="text_overflow name">{name:htmlenc}</span>
						{{ if (hint) }} <ws-icon name="hint" data-title="{hint:htmlenc}"></ws-icon> {{ endif }}
					</div>
					<ws-icon name="drag_indicator"></ws-icon>
					<div class="in flex_content hoverZone"></div>
				</div>
			`,
			get_order_index() {
				return self.props.config.order_index;
			},
			get_visibility(key) {
				return self.props.config.visibility[key] || 'show-always';
			},
			set_visibility(key, value) {
				self.props.config.visibility[key] = value;
				self.props.dom_update_visibility();
				self.props.dom_update_drop_places();
				self.props.save();
			},
			set_order(keys) {
				self.props.config.order_index = keys;
				self.props.dom_update_order();
				self.props.dom_update_drop_places();
				self.props.save();
			},
			toggle_hidden(st) {
				if (!self.is_shown()) return;
				if (self.is_chat) return;

				self.obj_wrapper.find('.taskView__params .taskView__params__hide').toggleClass('taskView__params__hide-act', st);
				self.props.dom_update_visibility();
				self.props.dom_update_drop_places();
			},
			save() {
				$.getScript(App.task_view.url + '?conf=' + encodeURI(JSON.stringify(self.props.config)) + '&' + App.actions.get('task_props_config:apply'));
				App.core.send_message_to_other_tabs({ command: 'task_view_props', data: self.props.config });
				App.core.send_message_to_other_devices({command: 'task_view_props', data: self.props.config });
			},
			init() {
				if (self.is_chat) return;

				this.config ||= {};
				this.config.visibility ||= {};
				this.config.order_index ||= [];

				self.obj_wrapper.find('.taskView__params .taskView__params__hide').addClass('taskView__params__hide-act');
				self.props.dom_update_order();
				self.props.dom_update_visibility();
				self.props.dom_update_drop_places();
				self.obj_wrapper.find('.taskView__params__item').each(function () {
					self.props.init_item_draggable($(this))
				});

				self.obj_wrapper.find('.taskView__params .taskView__params__hide > ws-icon, .taskView__params .taskView__params__hide > .in').off('click').on('click', function () {
					self.props.toggle_hidden();
				});

				const props_click_handle = function (e) {
					e.preventDefault();

					const item = $(this).parent(), field = item.data('key'), id_field = +field.replace('field', ''),
						visibility = self.props.get_visibility(field), is_custom = field.startsWith('field');

					App.menu.show({
						anchor: this,
						box: '#paramDispMenu',
						type: 'left',
						force_dropdown: true,
						onshow: function () {
							let menu = $(this);

							menu.find('.menu__item.menu__item-active').removeClass('menu__item-active');
							menu.find('.menu__item[data-visibility='+visibility+']').addClass('menu__item-active');

							menu.find('.menu__group[data-custom]').toggleClass('menu__group-hidden', !is_custom);
							menu.find('.menu__item[data-visibility]').off('click').on('click', function () {
								self.props.set_visibility(field, $(this).attr('data-visibility'));
								App.menu.hide();
							});
							menu.find('.menu__item[data-action]').off('click').on('click', function () {
								let action = $(this).attr('data-action');
								if (action === 'edit') {
									App.controls.custom_fields.show_edit_field_modal({ id_field, form_data: { id_project: self.get_id_project() }, after_submit: App.modal.hide });
									App.menu.hide();
								} else if (action === 'remove') {
									App.controls.custom_fields.show_remove_menu(this, self.get_id_project(), id_field);
								}
							});
						}
					});
				};

				// self.obj_wrapper.find('.taskView__params').off('click').on('click', '.taskView__params__item .param', props_click_handle);
				App.ui.onMouse(self.obj_wrapper.find('.taskView__params'), '.taskView__params__item .param', {
					click: (e) => props_click_handle.call(e.el, e.originalEvent),
					context: (e) => props_click_handle.call(e.el, e.originalEvent),
				});

				self.obj_wrapper.find('.taskView__params__add:not([onclick]) > .in').off('click').on('click', function () {
					App.controls.custom_fields.show_add_menu(this, self.get_id_project(), App.custom_fields.INST_TASK);
				});
			},
			init_item_draggable: function(el) {
				el.dragable({
					clone: true,
					opacity: 1,
					tolerance: 'none',
					target: '.taskView__params__dropPlace',
					moveHandler: "ws-icon[name=drag_indicator]",
					autoscroll: true,
					target_self: false,
					renewTarget: true,
					start: function (o) {
						App.state.drag.start();
						$('body').addClass('body-dragInProgress');
						o.originalElem.addClass('taskView__params__item-dragThis');
					},
					end: function (o) {
						App.state.drag.stop();
						o.elem.removeClass('taskView__params__item-dragThis');
						o.target.removeClass('taskView__params__dropPlace-hover');
						$('body').removeClass('body-dragInProgress');
					},
					drop: function (o) {
						const cur_key = o.elem.data('key'), after_key = $(o.currentTarget.t).attr('data-after');
						const order_index = self.props.config.order_index.filter(i => i !== cur_key);

						if (after_key) {
							let after_i = order_index.indexOf(after_key);
							if (after_i >= 0) order_index.splice(after_i + 1, 0, cur_key)
							else order_index.push(cur_key);
						} else {
							order_index.unshift(cur_key);
						}

						self.props.set_order(order_index);
					},
					move: function (o) {
						let min_distance = 9999;
						let el_height = o.originalElem.outerHeight();
						let oy = o.top + el_height/2;

						o.targetMatrix.forEach((t) => {
							const distance = Math.abs((t.y1 + (t.y2 - t.y1)/2) - oy);
							if (distance > min_distance || distance > el_height) return;

							min_distance = distance;
							o.currentTarget = t;
						})

						o.target.removeClass('taskView__params__dropPlace-hover');
						if (o.currentTarget) $(o.currentTarget.t).addClass('taskView__params__dropPlace-hover');
					}
				});
			},
			dom_update_drop_places: function () {
				const container = self.obj_wrapper.find('.taskView__params');

				container.find('.taskView__params__dropPlace').remove();
				container.prepend($('<div>').attr('data-after', '').attr('class', 'taskView__params__dropPlace'));
				container.find('.taskView__params__item.visible').each(function () {
					$(this).after($('<div>').attr('data-after', $(this).attr('data-key')).attr('class', 'taskView__params__dropPlace'));
				});
			},
			dom_update_order() {
				const container = self.obj_wrapper.find('.taskView__params')
				Array.from(self.props.get_order_index()).reverse().forEach(function (key) {
					container.children('.taskView__params__item[data-key='+key+']').prependTo(container)
				});
			},
			dom_update_visibility() {
				const control = self.obj_wrapper.find('.taskView__params .taskView__params__hide');
				const locale = self.props.locale || {};
				const show_all = !control.hasClass('taskView__params__hide-act');
				let count_hidden = 0;
				self.obj_wrapper.find('.taskView__params .taskView__params__item').each(function () {
					const field_key = $(this).attr('data-key'), is_custom = field_key.startsWith('field');
					const vis = self.props.get_visibility(field_key);
					const is_empty = (!is_custom && $(this).find('.data_place').length > 0) || (is_custom && $(this).find('custom-field').hasClass('custom-field--empty'));
					const should_hide = vis === 'hide-always' || (vis === 'hide-if-empty' && is_empty);

					if (should_hide) count_hidden++;

					$(this).toggleClass('visible', show_all || !should_hide);
					$(this).toggleClass('hiddenBlock', !(show_all || !should_hide));
				})

				control.find('.in').text(
					show_all
						? (locale['hide'] + ' ' + App.format.quantity(count_hidden, locale['props'], true))
						: App.format.quantity(count_hidden, locale['more_props']).replace('%s', count_hidden)
				);
				control.toggle(count_hidden > 0);
				self.obj_wrapper.find('.taskView__params > .taskView__params__add').toggleClass('hiddenBlock', !(show_all || count_hidden === 0));

				const count_visible = self.obj_wrapper.find('.taskView__params > .taskView__params__item.visible').length;

				self.obj_wrapper.find('.taskView__params').toggleClass('collapsed', count_visible === 0);

				if (count_visible === 0) control.find('.in').text(locale['title']);
			},
			require_update: App.helper.debounce(function() {
				self.props.dom_update_visibility();
				self.props.dom_update_drop_places();
			}, 100),

			add_item: function (key, name, hint, in_html) {
				let item_html = App.helper.template.fill(self.props.item_template, { key, name, hint });
				self.obj_window.find('.taskView__params__item').last().after(item_html);
				let el = self.obj_window.find('.taskView__params__item[data-key='+key+']');
				el.find('.in').append(in_html);
				self.props.init_item_draggable(el);
				self.props.dom_update_drop_places();
			},
			remove_item: function (key) {
				self.obj_window.find('.taskView__params__item[data-key='+key+']').remove();
				self.props.dom_update_drop_places();
			},
			add_item_custom: function (field) {
				const in_html = CustomField.create(field, self.id, {
					readonly: self.obj_window.find('.taskView__params').attr('data-can-field') !== '1'
				});

				self.props.add_item('field'+field.id, field.name, field.descr, in_html);
			},
			update_item_custom: function (field) {
				const el = self.obj_window.find('.taskView__params__item[data-key=field'+field.id+']');
				if (el.length === 0) return;

				if (field.is_deleted) {
					el.remove();
					return;
				}

				el.find('.param > span.name').text(field.name);
				el.find('.param > ws-icon[name=hint]').remove();
				if (field.descr) {
					el.find('.param').append(App.helper.template.fill('<ws-icon name="hint" data-title="{hint:htmlenc}"></ws-icon>', { hint: field.descr }));
				}
			}
		},

		print: function (format) {
			App.menu.hide();

			if (format === 'all') {
				App.core.active_window().find('.task, .commentList, .commentList__item, .commentList__log, .commentList__archiveItems').removeClass('noprint');
			} else if (format === 'self_only') {
				App.core.active_window().find('.task, .commentList__item, .commentList__log, .commentList__archiveItems').removeClass('noprint');
				App.core.active_window().find('.commentList').addClass('noprint');
			} else if (format === 'comments_only') {
				App.core.active_window().find('.task').addClass('noprint');
				App.core.active_window().find('.commentList, .commentList__item, .commentList__log, .commentList__archiveItems').removeClass('noprint');
			}

			window.print();
		},

		remember: function () {
			return self.is_shown() ? App.windows.args({ url: self.url, id: self.id, anchor: self.anchor }) : false;
		},

		is_show_by_id: function (id_task) {
			return self.is_shown() && +self.id === +id_task;
		},

		on_task_delete: function (id) {
			if (App.task_view.is_shown() && App.task_view.id === id) {
				App.menu.hide_all();
				App.modal.hide();
				App.task_view.delete();
			} else {
				App.task_view_cache.delete_by_id(id);
			}
		},

		onkeydown: function (key, alt, ctrl, meta, shift, in_input, in_input_strict) {
			if (!self.is_shown()) return false;
			if (App.comments.onkeydown(key, alt, ctrl, meta, shift, in_input, in_input_strict)) return true;
			return false;
		},

		process_ctrlA: function (is_group) {
			let container = App.keyboard_selection.get_active_container() || $();
			let item = container.find('.selected:visible');
			if (!item.length && App.keyboard_selection.hovered_item) item = App.keyboard_selection.hovered_item;
			if (item.length) {
				let mass_all;
				if (item.closest('.commentList').length) {
					mass_all = self.obj_window.find('.commentListPanel').find('input.mass_all').get(0);
				}
				if (!mass_all) {
					mass_all = item.closest('.taskView__group__wrapper').find('input.mass_all').get(0);
				}
				if (mass_all) {
					$(mass_all).trigger('click');
					return true;
				}
			}
		},

		onBoot: function () {
			self.obj_wrapper = $('#taskView__wrapper');
			$('#taskView__overlay').bind('click', () => self.hide());

			self.window = App.window.task_view.bind(self);
			self.context = App.core.context.scoped('task_view');

			App.bus.msg.on('who_see_task', function (data) {
				if (App.comments.helper_i_see_task(data)) {
					App.core.send_message_to_other_tabs({command: 'i_see_task', data: data});
				}
			}).on('task_view_props', function (data) {
				self.props.config = data;
				if (self.is_shown() && !self.is_chat) self.props.require_update();
			});

			App.bus.state.on('task', function (payload) {
				let id_task = payload.id, data = payload.data;

				if (self.is_shown() && !self.is_chat) {
					if (data.priority || data.tag || data.status || data.user_to || data.user_from || data.terms || data.costs || data.relations || data.emoji || data.reminders || data.meets) {
						self.props.require_update();
					}
				}

				if (data.costs) {
					let data_obj = data.costs.add || data.costs.update || data.costs.delete || data.costs.shift || data.costs.user || data.costs.date;
					if (data_obj && data_obj.id_todo) {
						let o = App.task_view_cache.get_all().find('#obj-task-view' + id_task).find('ol.todo li[data-todo='+data_obj.id_todo+']');
						if (o.length) {
							let new_time = 0;
							if (data.costs.add) new_time = data_obj.time;
							else if (data.costs.update) new_time = data_obj.time + data_obj.before.time;
							let o_time = o.find('.time');

							o_time.html(new_time ? App.format.time(60 * new_time, true) : '');

							if (data.costs.add) {
								let date_add = new Date(data.costs.add.dateadd * 1000);
								o.find('.time').attr('data-title',
									App.helper.team(data.costs.add.id_user_from, 'name') + ' ' + '%G' + App.format.date(date_add, DATE_COMPACT) + 'G%'
								);
							}
						}
					}
				}
			});

			App.bus.state.on('task_visibility', function (payload) {
				const data = payload.data, cache_data = App.task_view_cache.pop_by_id(payload.id);

				if (cache_data && cache_data.obj_window.find('.taskView__visibility').length > 0) {
					let container = cache_data.obj_window.find('.taskView__visibility');
					let list = container.find('.list');
					let max_size = list.attr('data-max-size').toInt();


					cache_data.obj_window.toggleClass('taskView--visibilityHidden', data.hidden.length > 0);
					container.toggleClass('taskView__visibility-hidden', data.hidden.length > 0).find('.in').toggleClass('hiddenBlock', data.hidden.length >= 3).text(data.text);
					container.children('ws-icon').first().attr('data-title', data.text);
					container.children('.list').toggleClass('hiddenBlock', data.hidden.length < 3);

					let list_slice_end = data.hidden.length > max_size ? max_size-1:max_size;
					let list_html = data.hidden.length > 2 ? data.hidden.slice(0, list_slice_end).map(function (id) {
						return App.helper.template.fill('task_view_hidden_user', {
							name: App.helper.team(id, 'name'),
							avatar: App.helper.team(id, 'avatar'),
							id: id,
						});
					}).join('') : '';

					list.html(list_html);

					if (data.hidden.length > max_size) {
						list.append(
							$('<span>', {
								class: 'more',
								text: '+' + (data.hidden.length - (max_size - 1)),
								'data-title-config': 'bottom_left arrow',
								'data-title': data.hidden.slice(max_size - 1).map(id => App.helper.team(id, 'name')).join(', ')
							})
						);
					}
				}
			});

			App.bus.state
				.on('custom_field_projects', function (payload) {
					let field = App.state.custom_fields.find(payload.id),
						add_projects = payload.data.add || [],
						remove_projects = payload.data.remove || [];

					if (!field || !App.custom_fields.is_task_inst(field)) return;

					[...add_projects, ...remove_projects].forEach(id_project => App.task_view_cache.invalidate_by_project(id_project, false));
					if (!self.is_shown()) return;

					if (add_projects.includes(+self.get_id_project())) {
						self.props.add_item_custom(field);
					} else if (remove_projects.includes(+self.get_id_project())) {
						self.props.remove_item('field'+payload.id);
					}
				});

			App.state.custom_values.$subscribe(function (changes) {
				if (!self.window.is_ready() || self.is_chat) return;

				const should_invalidate = Array.from(changes.keys())
					.some(key => App.custom_fields.is_task_value_key(key, self.id));

				if (should_invalidate) self.props.require_update();
			});
			App.state.custom_fields.$subscribe(function (changes) {
				if (!self.window.is_ready() || self.is_chat) return;

				let should_invalidate = false;

				for (let id_field of changes.keys()) {
					let field = App.state.custom_fields.find(id_field);
					if (!field || !App.custom_fields.is_task_inst(field)) continue;

					if (self.is_shown()) self.props.update_item_custom(field);
					should_invalidate = true;
				}

				if (should_invalidate) App.task_view_cache.invalidate_all(false);
			});

			App.bus.window.on('resize', App.helper.throttle(App.task_view.resizer.onresize));

			App.bus.app
				.on('sidebar_toggle', App.task_view.resizer.onresize)
				.on('window_signal', function (e) {
					let is_self = e.key === self.window.key;

					if (!is_self && e.state === WIN_ST_CLOSED) {
						self.width = self.is_chat ? chat_view_width.get() : task_view_width.get();
					}
					if (!is_self && (e.state === WIN_ST_OPENED || e.state === WIN_ST_CLOSING || e.state === WIN_ST_CLOSED)) {
						if (self.window.is_opened()) App.task_view.resizer.onresize();
					}
					if (is_self && e.state === WIN_ST_OPENED) {
					}
					if (is_self && e.state === WIN_ST_READY) {

						self.obj_window.find('.taskView__btnTeamTimer task-timers').once_by_criteria('task_view.task_timers.redraw').on('component:redraw', function (e) {
							$(this).closest('.mobile-head').toggleClass('mobile-head--withTeamTimer', this.tpl_data.show);
						}).each(function () {
							// force redraw
							App.components.emit_redraw(this);
						});;


						if (App.subtasks.child_check(self.id_prev)) {
							$('.taskView__tree .child_return').removeClass('hiddenBlock');
							$('.taskView__tree a.child_return').attr('href', '/task/'+self.id_prev+'/');
						} else {
							$('.taskView__tree .child_return').addClass('hiddenBlock');
						}
						if (App.device.is_mobile()) {
							// #8323202 шапка є завжди, там path
							// const is_with_head = self.obj_window.find('.taskView__head--mobile .buts').html()?.trim()
							// 	|| self.obj_window.find('.taskView__head--mobile task-timers').get(0)?.tpl_data?.show;

							// self.obj_window.toggleClass('taskView-withoutHeadMobile', !is_with_head);
							// if (!is_with_head) {
							// 	self.obj_window.addClass('taskView-headMobileHidden');
							// } else if (self.scroller.scrollTop() === 0) {
							// 	self.obj_window.removeClass('taskView-headMobileHidden');
							// }
							if (self.scroller.scrollTop() === 0) {
								self.obj_window.removeClass('taskView-headMobileHidden');
							}
						}
					}
				})
				.on('anchor_scroll_to', function (payload) {
					if (!self.scroller.obj_content) return;
					const { target } = payload;
					if (!self.scroller.obj_content.contains(target)) return;
					self.scroller.trigger_observer();
				});

			App.bus.app.on('task_view_closed', function () {
				self.paginal.destroy();
			});

			App.bus.app.on('left_panel_unready', function () {
				if (App.mymenu?.obj_window?.find(App.task_view?.anchor).length) {
					self.paginal.destroy();
				}
			});

			App.bus.app.on('task_view_subtasks_redrawed', function () {
				App.classes.ui_state_manager.getInstance().loadState({
					onLoaded(state) {
						self.obj_wrapper.find('.taskView__group__wrapper[data-state-key=taskView_subtasks_shown]').each(function () {
							const wrapper = $(this);
							if (wrapper.hasClass('taskView__subtasks__wrapper') && self.obj_window.hasClass('taskView-no_subtasks')) {
								wrapper.addClass('collapsed');
								return;
							}
							const key = wrapper.attr('data-state-key');
							const is_collapsed = !Boolean(state[key]);
							wrapper.toggleClass('collapsed', is_collapsed);
						});
					}
				});
			});

			$(document).on('click', '#headerGeneral', function(e) {
				if ($(e.target).closest('.logo, .project-name, .tree').length) return;
				if (App.window.task_view.is_opened()) App.window.task_view.close();
			});
			$(document).bind('mouseup', (e) => App.task_view.resizer.mouseup(e));
			$(document).bind('mousemove', (e) => App.task_view.resizer.mousemove(e));
		},
		onLogout: () => App.task_view.destructor(),
		onLogin: function () {
			self.skeleton = {};
			$('.taskviewSkeleton').each(function () {
				self.skeleton[$(this).attr('data-type')] = $(this).html();
			});
			$('.taskviewSkeleton').remove();
		}
	};
})();

App.task_view_cache = {
	data: {},

	exists: function(url) {
		return url in this.data
	},

	pop: function(url) {
		if (url in this.data) return this.data[url];
		return null;
	},

	pop_by_id: function(id) {
		for (let url in this.data) {
			if (this.data[url].id === id) return this.data[url];
		}
		return null;
	},

	delete: function(url) {
		this.data[url].minibar?.destroy();
		this.data[url].obj_window.removeWithComponents();
		this.data[url].obj_menus.removeWithComponents();
		App.core.websocket.unregister_task_view(this.data[url].id);
		delete(this.data[url]);
	},

	invalidate_by_id: function(id) {
		if (App.task_view.is_shown() && App.task_view.id === id) {
			App.task_view.reload();
		} else {
			this.delete_by_id(id);
		}
	},

	invalidate_all: function(reload_current) {
		for (let url in this.data) {
			if (App.task_view.is_shown() && App.task_view.id === this.data[url].id) {
				if (reload_current !== false) App.task_view.reload();
			} else {
				this.delete(url);
			}
		}
	},

	invalidate_by_project: function(id_project, reload_current) {
		for (let url in this.data) {
			let id = this.data[url].id;

			if (this.data[url].obj_window.is('[data-project='+id_project+']')) {
				if (App.task_view.is_shown() && App.task_view.id === id) {
					if (reload_current !== false) App.task_view.reload();
				} else {
					this.delete(url);
				}
			}
		}
	},

	invalidate_chat_members_by_id: function(id) {
		if (App.task_view.is_shown() && App.task_view.is_chat && App.task_view.id === id) {
			App.task_view.reload_fragment(['.taskView__intro', '.chatView__users .users.componentTeamAvatars']);
		} else if (this.pop_by_id(id)?.is_chat) {
			this.delete_by_id(id);
		}
	},

	invalidate_relations_by_id: function(id) {
		if (App.task_view.is_shown() && App.task_view.id === id) {
			App.task_view.relations.reload();
		} else {
			for (let url in this.data) {
				if (this.data[url].id === id) {
					this.data[url].need_reload_relations = true;
				}
			}
		}
	},

	helper_invalidate_children_buttons: function(parent_id) {
		let has_open_views = false;
		for (let url in this.data) {
			if (this.data[url].obj_window) {
				has_open_views = true;
				break;
			}
		}
		if (!has_open_views) return;

		let child_ids = new Set();
		for (let url in this.data) {
			let task_data = this.data[url];
			if (!task_data.obj_window || task_data.id === parent_id) continue;

			if (App.page && App.page.data && App.page.data.task && App.page.data.task[task_data.id]) {
				let task_info = App.page.data.task[task_data.id];
				if (task_info.id_parent == parent_id || task_info.id_parent_top == parent_id) {
					child_ids.add(task_data.id);
				}
			}

			if (!child_ids.has(task_data.id) && App.subtasks && App.subtasks.data && App.subtasks.data.task && App.subtasks.data.task[task_data.id]) {
				let task_info = App.subtasks.data.task[task_data.id];
				if (task_info.id_parent == parent_id || task_info.id_parent_top == parent_id) {
					child_ids.add(task_data.id);
				}
			}
		}

		for (let url in this.data) {
			let task_data = this.data[url];
			if (child_ids.has(task_data.id)) {
				if (App.task_view.is_shown() && App.task_view.id === task_data.id) {
					App.task_view.reload_fragment('.taskView__head .buts');
				} else {
					task_data.need_reload_buttons = true;
				}
				if (App.menu && App.menu.invalidate_cache_by_trigger) {
					if (App.menu.is_shown() && App.menu.obj_window && App.menu.obj_window.find('.menu__group-taskButs[data-task=' + task_data.id + ']').length) {
						App.menu.reload();
					} else {
						App.menu.invalidate_cache_by_trigger('task' + task_data.id);
					}
				}
			}
		}
	},

	delete_by_id: function(id) {
		for (let url in this.data) {
			if (this.data[url].id === id) this.delete(url);
		}
	},

	push: function(url, task_view) {
		if (url in this.data) this.delete(url);
		if (App.core.is_cache) this.data[url] = {
			obj_window: task_view.obj_window,
			obj_menus: task_view.obj_menus,
			minibar: task_view.minibar,
			url: task_view.url,
			id: task_view.id,
			is_chat: task_view.is_chat,
			title: task_view.title,
			state: 'open',
			dt_added: new Date(),
			need_reload_buttons: task_view.need_reload_buttons || false
		}
		App.core.websocket.register_task_view(task_view.id, task_view.hash);
		if (Object.keys(this.data).length > 10) {
			let url_delete = url;
			for (let url in this.data) {
				if (this.data[url].dt_added < this.data[url_delete].dt_added) url_delete = url;
			}
			if (this.data.minibar) this.data.minibar.destroy();
			delete(this.data[url_delete]);
		}
	},

	set_state(url, state) {
		if (this.data[url] == null) return;

		this.data[url].state = state;
	},

	get_all: function(state) {
		let o = $();
		for (let url in this.data) {
			o = o.add(this.data[url].obj_window);
		}
		return o;
	},

	get_all_helpers: function(state) {
		let o = $();
		for (let url in this.data) {
			o = o.add(this.data[url].obj_menus);
		}
		return o;
	},

	get_all_ids: function(state) {
		let arr = [];
		for (let url in this.data) {
			arr.push(this.data[url].id);
		}
		return arr;
	},

	destructor: function() {
		for (let url in this.data) {
			this.delete(url);
		}
	},

	onBoot: function () {
		App.bus.state.on('task', function (task) {
			if (task.data.permissions) App.task_view_cache.invalidate_by_id(task.id);
		});
		App.bus.other_tab.on('ui_state', function ({state}) {
			const { default: default_state } = state;
			// const { taskView_params  } = default_state || {};
			// if (taskView_params !== undefined ) {
			// 	App.task_view.props.toggle_hidden(!taskView_params);
			// }
			App.task_view.obj_wrapper?.find('.taskView__group__wrapper[data-state-key]').each(function () {
				const group = $(this);
				const key = group.attr('data-state-key');
				const is_collapsed = !Boolean(default_state[key]);
				group.toggleClass('collapsed', is_collapsed);
			});
		});

	},

	onLogout: () => App.task_view_cache.destructor(),
}

;var App = App || {};
App.team_timers = {
	data: {},
	task_data: {}, // some kind of duplicate (
	ids_user: [],
	add: function (id_task, id_user) {
		id_user = +id_user;
		if (this.ids_user.includes(id_user)) {
			this.data[id_user] = {
				id_task,
				time: 0,
				dt: new Date().getTime()
			};
		}
		App.team_timers.task_data[id_task] ||= [];
		App.team_timers.task_data[id_task].push(+id_user);
		this.draw();
	},
	delete: function (id_task, id_user) {
		id_user = +id_user;
		if (this.ids_user.includes(id_user)) {
			delete this.data[id_user];
		}
		if (App.team_timers.task_data[id_task]) {
			App.team_timers.task_data[id_task] = App.team_timers.task_data[id_task].filter((id_task) => id_task !== +id_user);
			if (!App.team_timers.task_data[id_task].length) delete App.team_timers.task_data[id_task];
		}
		this.draw();
	},
	draw: function () {
		App.components.team_timer.redraw_all();
		return;
		let o = $('#primaryMenu__timer__counter');
		let cnt = Object.keys(App.team_timers.data).length;
		let over = '';
		let dt = new Date().getTime();

		for (let id_user in this.data) {
			if (this.data[id_user].time + Math.floor((dt - this.data[id_user].dt) / 1000) > TIMER_ALERT) {
				over = 'alert';
			} else if (this.data[id_user].time + Math.floor((dt - this.data[id_user].dt) / 1000) > TIMER_WARNING) {
				over ||= 'warning';
			}
		}
		if (o.length) {
			o.html(cnt ? '<span class="cnt_new">' + cnt + '</span>' : '').attr('data-over', over);
			o.closest('.primaryMenu__item').toggleClass('primaryMenu__item-hasTimer', cnt > 0);
		}
	},
	init: function (data, ids_user) {
		let dt = new Date().getTime();
		for (let id_user in data) {
			data[id_user].dt = dt;
		}
		this.data = data;
		this.ids_user = ids_user;
	},
	onLogin: function () {
		App.bus.state.on('task_timers', function (payload) {
			const id_task = payload.id, data = payload.data;

			if (data.delete) {
				App.team_timers.delete(id_task, data.delete.id_user_from);
			}
			if (data.add) {
				App.team_timers.add(id_task, data.add.id_user_from);
			}
		});
	},
}

;var App = App || {};

App.time_interval = {
	type: 1,
	data: 0,
	data_prev: false,
	data_next: false,
	min_date: null,
	min: null,
	max: null,
	selector: 'main [data-container=calendar]',
	picker: null,
	silent: false,
	select: function (date) {
		let menu = App.menu.obj_window || $('.menu.menu-calendar');

		menu.find('ws-btn').show();
		menu.find('.daterow').show();
		menu.find('.r .menu__item-active').removeClass('menu__item-active').filter(':first').addClass('menu__item-active');

		let dt_a = date.split('.');
		this.type = 0;

		if (dt_a.length === 3) {
			menu.find('input[name=datestart]').val(date);
			menu.find('input[name=dateend]').val('');
			this.data = date + '_' + date;
		} else {
			menu.find('input[name=datestart]').val(dt_a[0] + '.' + dt_a[1] + '.' + dt_a[2]);
			menu.find('input[name=dateend]').val(dt_a[3] + '.' + dt_a[4] + '.' + dt_a[5]);
			this.data = dt_a[0] + '.' + dt_a[1] + '.' + dt_a[2] + '_' + dt_a[3] + '.' + dt_a[4] + '.' + dt_a[5];
		}

		menu.find('ws-btn[name*=primary]').focus();
	},

	date_from_input: function() {
		let menu = App.menu.obj_window || $('.menu.menu-calendar');
		menu.find('ws-btn').show();
		let dt_s = App.helper.date.from_input(menu.find('input[name=datestart]').val());
		let dt = App.helper.date.from_input(menu.find('input[name=dateend]').val());
		dt_s = App.controls.datepicker.closest_workday(dt_s);
		dt = App.controls.datepicker.closest_workday(dt);
		$.datepicker._setDateDatepicker(menu.find('[data-container=calendar]').get(0), dt_s, dt);

		if (dt_s) {
			let dt_s_str = App.time_interval.js_date_to_str(dt_s);
			menu.find('input[name=datestart]').val(dt_s_str);
			this.data = dt_s_str;
		}
		if (dt_s && dt) {
			let dt_str = App.time_interval.js_date_to_str(dt);
			menu.find('input[name=dateend]').val(dt_str);
			this.data+= '_' + dt_str;
		}

		menu.find('ws-btn[name*=primary]').focus();
		this.type = 0;
	},

	js_date_to_str: function (d) {
		return d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear();
	},

	save: function(params) {
		// Don't update active class here - it will be updated after server response in update()
		App.controls.views.set_option(params, null, this.silent);
	},

	update_active_class: function(type, data) {
		let menu = $('#pageFilter_range_menu, #panelFilter_range_menu');
		if (!menu.length || type === 0) {
			menu.find('.r .menu__item').removeClass('menu__item-active');
			return;
		}

		// Convert data to string for comparison with data-interval-data attribute
		let dataStr = String(data);
		
		// Remove all active classes first
		menu.find('.r .menu__item').removeClass('menu__item-active');
		
		// Try to find matching element
		let matchingItem = menu.find('.r .menu__item')
			.filter('[data-type="' + type + '"][data-interval-data="' + dataStr + '"]');
		
		// Only add active class if matching element was found
		// If not found, all active classes are already removed above
		if (matchingItem.length > 0) {
			matchingItem.addClass('menu__item-active');
		}
	},

	submit: function() {
		this.save({
			time_interval_type: this.type,
			time_interval_data: this.data
		});
		App.menu.hide();
	},

	month_click: function(y, m) {
		let today = new Date();
		this.save({
			time_interval_type: 5,
			time_interval_data: 12 * (y - today.getFullYear()) + (m + 1 - today.getMonth())
		});
	},

	update(config) {
		config ||= {};
		for (let i in config) this[i] = config[i];
		let menu = $('#pageFilter_range_menu');
		let date_start = new Date(config['datestart_js']);
		let date_end = new Date(config['dateend_js']);
		menu.find('input[name=datestart]').val(App.helper.date.to_input(date_start));
		menu.find('input[name=dateend]').val(App.helper.date.to_input(date_end));
		$.datepicker._setDateDatepicker(this.picker.get(0), date_start, date_end);
		let o = $('.filter ws-btn.date button')
		o.eq(0).toggleClass('btn-disabled', this.data_prev === false).find('ws-icon').attr('name',  this.data_prev === false? 'block' : 'arrows/chevron-left');
		o.eq(1).find('span').html(this.name);
		// Update tooltip for week number display
		this.tooltip ? o.eq(1).attr('data-title', this.tooltip) : o.eq(1).removeAttr('data-title');
		o.eq(2).toggleClass('btn-disabled', this.data_next === false).find('ws-icon').attr('name',  this.data_next === false? 'block' : 'arrows/chevron-right');
		
		// Update active class based on type and data from config
		if (config.type !== undefined) {
			this.type = config.type;
			this.data = config.data ?? 0;
			let data = typeof this.data === 'number' && (this.data === 0 || this.data === -1) ? this.data : 0;
			this.update_active_class(config.type, data);
		}
		
		if (App.page.process_filter_and_search) App.page.process_filter_and_search();
	},

	init: function (config) {
		config ||= {};
		for (let i in config) {
			if (i in this) this[i] = config[i];
		}
		this.picker = $(this.selector);
		this.picker.datepicker({
			rangeSelect: true,
			clickMonth: (y, m) => this.month_click(y, m),
			rangeSeparator: '.',
			numberOfMonths: 2,
			monthNames: App.object_state.locale.month['long'],
			dayNames: App.object_state.locale.day['long'],
			dayNamesMin: App.object_state.locale.day['short'],
			firstDay: App.datepicker_firstDay || 0,
			minDate: config['min_date_js'] ? new Date(config['min_date_js']) : null,
			maxDate: config['max_date_js'] ? new Date(config['max_date_js']) : null,
			onSelect: (date) => this.select(date),
			beforeShowDay: App.controls.datepicker.helper_draw_holidays
		});
		$.datepicker._setDateDatepicker(this.picker.get(0), new Date(config['datestart_js']), new Date(config['dateend_js']));
		
		// Set initial tooltip if present, remove if not
		let o = $('.filter ws-btn.date button');
		config.tooltip ? o.eq(1).attr('data-title', config.tooltip) : o.eq(1).removeAttr('data-title');
	}
}
App.time_interval_right_panel = App.helper.object.clone(App.time_interval, {
	selector: '.rightPanel__wrapper [data-container=calendar]',
	save: function(params) {
		// Don't update active class here - it will be updated after server response in update()
		App.controls.views_right_panel.set_option(params);
	},
});

;var App = App || {};

const NO_TIMER = 0;
const TIMER_PAUSE = 1;
const TIMER_ACTIVE = 2;

const TIMER_ALERT = 36000;
const TIMER_WARNING = 21600;
(function () {
	let self = App.timer = {

		url: null,
		obj: null,
		status: NO_TIMER,
		id_task: 0,

		enabled: false,
		only_work_time: false,
		time_round: 0,

		data: null,
		track_dt: 0,
		skip_update: false,

		segments_key: '',
		segments_cached_other_html: '',
		segments_cached_current_html: '',

		set_data: function (data, initial) {
			self.data = data;
			if (data) {
				self.status = data.timer.active ? TIMER_ACTIVE : TIMER_PAUSE;
				self.id_task = data.timer.active ? data.timer.id_task : 0;

				if (data.timer.active) data.timer.time_formatted = App.format.timer_seconds(data.timer.time);
				data.costs.time_formatted = App.format.time(60 * data.costs.time, true);
				self.obj.html(data.timer.active ? App.helper.template.fill('task_view_timer', data.timer) : '');
				self.update_mobile_head();
				$('#primaryMenu__timer, #taskPanel__counter__timer, #timerStopGoMenu .timer').html(data.timer.active ? App.helper.template.fill('primary_menu_timer', data.timer) : '');

				if (!initial) {
					App.helper.object.append(data, {type: 'timer'});
					App.task_panel.replaceOrAppend(data);
				}
			} else {
				self.status = NO_TIMER;
				self.obj.html('');
				self.update_mobile_head();
				$('#primaryMenu__timer, #taskPanel__counter__timer, #timerStopGoMenu .timer').html('');

				if (!initial) {
					let o = App.task_panel.obj.find('.taskPanel__item-timer, .taskPanel__item-costs');
					if (o.length) {
						App.task_panel.remove(o);
					}
				}
			}

			$('body').toggleClass('withTimer', self.status === TIMER_ACTIVE);

			if (self.status === TIMER_ACTIVE) {
				if (self.track_dt === 0) self.track_dt = Math.floor(new Date().getTime()/1000);
			} else {
				self.track_dt = 0;
			}

			self.attach_to_task();
			self.init();
		},

		is_active: function (id_task) {
			return self.status === TIMER_ACTIVE && +id_task === +self.id_task;
		},

		init: function () {
			self.check_is_available();
			App.helper.cron.add_if_not_exists('timer_tick', self.tick, 1);
			self.tick();
		},

		start: function (page, params) {
			App.menu.log_mouse_position(event, { auto_clear: false });
			let url = App.helper.url.add_query(page, App.actions.get('task_start_timer:do'), params);
			App.core.async_task.ajax(url).finally(() => App.menu.clear_mouse_position());
		},

		stop: function (page) {
			App.menu.hide_all();
			App.timer_view.show(true);
		},

		stop_and_go: function (page) {
			if (!self.data.timer.active) return;

			App.menu.show({
				box: '#timerStopGoMenu',
				type: 'left',
				backup: true,
				force_dropdown: true,
				onshow: function () {

					$(this).find('.timer').parent()
						.attr('href', '/task/' + self.data.timer.id_task + '/')
						.attr('data-title', self.data.timer.task_name)
						.find('span').text(self.data.timer.task_name);

					$(this).find('ws-btn.confirm').off('click').on('click', function () {
						let url = '/ajax/time/?' + App.actions.get('timer_stop:do');
						App.core.async_task.ajax(url).then(() => self.start(page))
						App.timer_view.show(true);
						App.menu.hide();
					});

					$(this).find('ws-btn.cancel').off('click').on('click', function () {
						if (!App.timer_view.is_shown()) App.timer_view.show(true);
						App.menu.hide();
					});
				}
			});
		},

		save: function (element) {
			App.core.async_task.ajax(
				'/ajax/time/?' + App.actions.get('timer_save') + (element?.value ? '&name=' + encodeURIComponent(element.value) : '')
			);
		},

		update: function (element) {
			App.core.async_task.ajax(
				'/ajax/time/?' + App.actions.get('timer_update:do') + (element?.value ? '&name=' + encodeURIComponent(element.value) : '')
			);
		},

		segments_template_html: `
			<div class="timer-segments">
				<div class="timer-seg timer-seg--tracked" style="display:none;"></div>
				<div class="timer-seg timer-seg--current-live" style="display:none;"></div>
				<div class="timer-seg timer-seg--remain" style="display:none;"></div>
			</div>
		`,

		mount_segments: function (o) {
			let seg_container = o.find('.timer-segments');
			if (!seg_container.length) {
				o.prepend(self.segments_template_html);
			}
		},

		calc_segments: function (timer_time) {
			const plan_time = self.data?.timer?.plan_time || 0;
			if (plan_time <= 0) {
				return {
					total_base: 0,
					p_tracked: 0,
					p_live: 0,
					p_remain: 0,
					is_overdue: false
				};
			}

			const manual_time = self.data?.timer?.manual_time || 0;
			const other_time  = self.data?.timer?.other_timers_time || 0;
			const total_spent = manual_time + other_time + timer_time;

			const total_base = plan_time >= total_spent ? plan_time : total_spent;
			const is_overdue = total_spent > plan_time;

			const current_sessions = self.data?.timer?.current_sessions || [];
			const current_past_sec = current_sessions.reduce((acc, v) => acc + (+v.time || 0), 0);
			const live_current_sec = Math.max(0, timer_time - current_past_sec);

			const tracked_sec = manual_time + other_time + current_past_sec;

			const p_tracked = (tracked_sec / total_base) * 100;
			const p_live   = (live_current_sec / total_base) * 100;
			const p_remain = plan_time > total_spent ? ((plan_time - total_spent) / total_base) * 100 : 0;

			return {
				total_base,
				p_tracked,
				p_live,
				p_remain,
				is_overdue
			};
		},

		update_segments: function (o, calc_data) {
			if (!self.data?.timer?.plan_time) {
				o.find('.timer-segments').remove();
				o.removeClass('is-plan-overdue');
				return;
			}

			self.mount_segments(o);

			const { p_tracked, p_live, p_remain, is_overdue } = calc_data;

			o.toggleClass('is-plan-overdue', is_overdue);

			o.find('.timer-seg--tracked')
				.toggle(p_tracked > 0)
				.css('width', p_tracked + '%');

			o.find('.timer-seg--current-live')
				.toggle(p_live > 0)
				.css('width', p_live + '%');

			o.find('.timer-seg--remain')
				.toggle(p_remain > 0)
				.css('width', p_remain + '%');
		},

		current_favicon: 0,
		tick: function () {
			const current_val = self.data?.timer?.time ?? 0,
				delta_t = self.track_dt > 0 ? Math.floor(new Date().getTime()/1000) - self.track_dt : 0,
				timer_time = current_val + delta_t;

			const segments_calc = self.calc_segments(timer_time);

			if (self.status === TIMER_ACTIVE) {
				if (!self.current_favicon) $('body').addClass('withTimer');

				if (segments_calc.is_overdue || timer_time > TIMER_ALERT) {
					if (self.current_favicon !== 3) {
						self.current_favicon = 3;
						App.core.set_favicon('/assets/img/favicon/timer_over2.ico');
					}
				} else if (timer_time > TIMER_WARNING) {
					if (self.current_favicon !== 2) {
						self.current_favicon = 2;
						App.core.set_favicon('/assets/img/favicon/timer_over.ico');
					}
				} else {
					if (self.current_favicon !== 1) {
						self.current_favicon = 1;
						App.core.set_favicon('/assets/img/favicon/timer.ico');
					}
				}
			} else if (self.current_favicon) {
				self.current_favicon = 0;
				App.core.set_favicon('/assets/img/favicon/favicon.ico');
				$('body').removeClass('withTimer');
			}

			const o = self.get_all();
			if (o.length === 0) return App.helper.cron.remove('timer_tick');

			let team_data = new Map();
			let dt = new Date().getTime();

			o.each(function () {
				let o = $(this);

				const update_progress = (this_timer_time) => {
					let p = null;
					if (o.closest('.timerView').attr('data-type') === 'fact') { // timer window button
						p = o.closest('.timerView').find('progress-bar2');
					}
					else if (o.closest('.sidePanel').attr('data-type') === 'fact') { // mymenu window timer
						p = o.closest('.sidePanel__list__item-costs').find('progress-bar2');
					}

					let delta = 0.01;
					// delta = 0; // debug
					if (p && p.length > 0 && this_timer_time / 3600 - p.attr('tmp') > delta) {
						const diff = this_timer_time / 3600 - p.attr('tmp');
						p.attr('tmp', this_timer_time / 3600);

						if (o.closest('.sidePanel').attr('data-type') === 'fact') {

							const team_p = o.closest('.sidePanel').find('.timerView__progress progress-bar2').get(0);
							if (team_p) {
								if (team_data.has(team_p)) {
									// console.log('has', diff);
									team_data.set(team_p, team_data.get(team_p) + diff);
								} else {
									// console.log('new', diff);
									team_data.set(team_p, diff);
								}
							}
						}
					}
				};

				if (o.attr('data-my')) {
					if (timer_time > TIMER_ALERT) {
						o.attr('data-over', 'alert');
					} else if (timer_time > TIMER_WARNING) {
						o.attr('data-over', 'warning');
					}

					o.find('strong').html(App.format.timer_minutes(timer_time / 60));
					o.find('b').html(App.format.timer_seconds(timer_time));

					self.update_segments(o, segments_calc);

					update_progress(timer_time);
				} else {
					let input = o.find('input');
					if (!input.attr('rel')) input.attr('rel', dt);
					if (1 * input.val() + Math.floor((dt - input.attr('rel')) / 1000) > TIMER_ALERT) {
						o.attr('data-over', 'alert');
					} else if (1 * input.val() + Math.floor((dt - input.attr('rel')) / 1000) > TIMER_WARNING) {
						o.attr('data-over', 'warning');
					}
					let local_timer_time = 1 * input.val() + Math.round((dt - input.attr('rel')) / 1000);
					let tm_str = App.format.timer_seconds(local_timer_time);
					o.find('strong').html(App.format.timer_minutes(local_timer_time / 60));
					o.find('b').html(tm_str);

					if (o.hasClass('timer')) update_progress(local_timer_time);
				}
			});

			// update team progress bar
			team_data.forEach((time, progressbar) => {
				// console.log({ progressbar, time });
				$(progressbar).attr('tmp', function (_, val) {
					return +val + time;
				});
			});

			App.team_timers.draw();
		},

		get_all: function () {
			let o = $();
			o = o.add(self.obj.find('.taskView__timer'));

			if (self.data?.timer?.active) {
				o = o.add($('#primaryMenu__timer .in'));
				o = o.add($('#taskPanel__counter__timer .in'));
				o = o.add($('#timerStopGoMenu .timer'));
			}

			if (App.task_panel.obj) o = o.add(App.task_panel.obj.find('.taskPanel__item-timer'));
			if (App.mymenu.cache['costs']) o = o.add(App.mymenu.cache['costs'].obj_window.find('.timer'));
			if (App.timer_view.obj_window) o = o.add(App.timer_view.obj_window.find('.timer, .costs-timer'));
			if (App.timer_view_modal.obj_window) o = o.add(App.timer_view_modal.obj_window.find('.timer, .costs-timer'));
			return o;
		},

		detach_from_task: function () {
			self.obj.detach();
		},

		attach_to_task: function () {
			if (self.id_task && App.task_view.is_shown() && App.task_view.id === self.id_task) {
				const container = $(window).width() <= APP_SCREEN_THRESHOLD
					? App.task_view.obj_window.find('.mobile-head [data-container=timers]')
					: App.task_view.obj_window.find('.taskView__head--desktop [data-container=timers]');

				container.prepend(self.obj);
				self.update_mobile_head();
			}
		},

		reattach_to_task: App.helper.debounce(function () {
			if (self.id_task && App.task_view.is_shown() && App.task_view.id === self.id_task) {
				self.detach_from_task();
				self.attach_to_task();
			}
		}),

		update_mobile_head: function () {
			if (!self.obj) return;
			const has_timer = self.obj.html().trim() !== '';
			self.obj.closest('.mobile-head').toggleClass('mobile-head--withMyTimer', has_timer);
		},

		is_available: function () {
			return self.only_work_time ? self.enabled && App.work_time.state : self.enabled;
		},

		check_is_available: function () {
			$('body').toggleClass('no_timers', !self.is_available());
		},

		onLogin: function () {
			self.obj = $('<div />').attr('class', 'taskView__timerContainer').detach();
			self.init();

			App.core.context.when('timer_config', function (config) {
				self.enabled = config.enabled ?? false;
				self.only_work_time = config.only_work_time ?? false;
				self.time_round = config.time_round ?? 0;
				self.set_data(config.data, true);
			})

			App.bus.app
				.on('task_view_ready', self.attach_to_task)
				.on('task_view_unready', self.detach_from_task)
				.on('left_panel_ready right_panel_ready', function () {
					if (self.get_all().length) {
						App.helper.cron.add_if_not_exists('timer_tick', self.tick, 1);
						self.tick();
					}
				});

			App.bus.window.on('resize_width', self.reattach_to_task);

			App.bus.state.on('account_update', function (payload) {
				if (!payload.data.timer) return;

				const timer = payload.data.timer || null;
				self.only_work_time = timer.is_timer_autostop ?? self.only_work_time;
				self.time_round = timer.time_round ?? self.time_round;
				self.check_is_available();
			});
			App.bus.app.on('work_time', self.check_is_available);

			App.bus.state.on('timer_update', function (payload, ctx) {
				const data = payload.data;

				App.timer.skip_update = true;
				setTimeout(function() { App.timer.skip_update = false; }, 50); // to prevent costs update events
				App.timer.set_data(data);

				if (ctx.active_tab) App.core.send_message_to_other_devices({
					command: 'object_state',
					data: { obj_type: 'timer', obj_id: 0, obj_data: data },
				}, 'events_seen');
			});

			App.bus.state.on('task_timers', function (payload) {
				const id_task = payload.id, data = payload.data;

				if (data.delete) {
					if (+data.delete.id_user_from === App.me.id) {
						App.timer.data.timer = {active: false};
						App.timer.set_data(App.timer.data);
						App.timer.detach_from_task();
					}
				}
			});

			const sync_data = App.helper.debounce(self.set_data);

			App.bus.state.on('task_costs', function (payload) {
				const id_task = payload.id, data = payload.data;

				if (App.timer.skip_update) return;

				let data_obj = data.add || data.update || data.delete || data.shift || data.user || data.date;
				let impact = 0, impact_time = data_obj.time;

				if (data.add && data_obj.id_user_from === App.me.id && data_obj.dateadd === App.timer.data?.costs.dt && impact_time) {
					impact++;
				}
				if (data.delete && data_obj.id_user_from === App.me.id && data_obj.dateadd === App.timer.data?.costs.dt && impact_time) {
					impact--;
				}
				if (data.update) {
					if ('id_user_from' in data_obj.before && data_obj.dateadd === App.timer.data?.costs.dt) {
						if (data_obj.id_user_from === App.me.id) impact++;
						if (data_obj.before.id_user_from === App.me.id) impact--;
					}
					if ('dateadd' in data_obj.before && data_obj.id_user_from === App.me.id) {
						if (data_obj.dateadd === App.timer.data?.costs.dt) impact++;
						if (data_obj.before.dateadd === App.timer.data?.costs.dt) impact--;
					}
					if ('time' in data_obj.before && data_obj.dateadd === App.timer.data?.costs.dt && data_obj.id_user_from === App.me.id) {
						impact = 1;
						// impact_time -= data_obj.before.time;
					}
				}

				if (impact === 0) return;

				self.data.costs.time += impact_time;
				sync_data(App.timer.data);
			});

			App.bus.state.on('task_costs', function (payload) {
				const id_task = payload.id;
				const data = payload.data;

				if (!self.data?.timer || +self.data.timer.id_task !== +id_task) return;

				const data_obj = data.add || data.update || data.delete || data.shift || data.user || data.date;
				if (!data_obj) return;

				const cost_id = +data_obj.id;
				const timer_dt = self.data.timer.dt;
				const my_id = +App.me.id;

				let removed_other_sec = 0;
				let removed_current_sec = 0;

				if (Array.isArray(self.data.timer.other_sessions)) {
					self.data.timer.other_sessions = self.data.timer.other_sessions.filter(s => {
						if (+s.id === cost_id) {
							removed_other_sec += s.time;
							return false;
						}
						return true;
					});
				}

				if (Array.isArray(self.data.timer.current_sessions)) {
					self.data.timer.current_sessions = self.data.timer.current_sessions.filter(s => {
						if (+s.id === cost_id) {
							removed_current_sec += s.time;
							return false;
						}
						return true;
					});
				}

				const was_timer_sec = removed_other_sec + removed_current_sec;

				if (was_timer_sec > 0) {
					if (removed_other_sec > 0) {
						self.data.timer.other_timers_time = Math.max(0, (self.data.timer.other_timers_time || 0) - removed_other_sec);
					}

					if (removed_current_sec > 0) {
						self.data.timer.time = Math.max(0, (self.data.timer.time || 0) - removed_current_sec);
						if (+self.data.timer.id_costs === cost_id) {
							self.data.timer.id_costs = 0;
						}
					}

					// Якщо це збереження сесії як ручного запису за день таймера
					if (data.update && data_obj.dateadd === timer_dt && +data_obj.id_user_from === my_id) {
						self.data.timer.manual_time = (self.data.timer.manual_time || 0) + ((+data_obj.time || 0) * 3600);
					}
				} else {
					// 3. Звичайний ручний запис (додавання, видалення, редагування часу/дати/юзера)
					let m_diff = 0;

					if (data.add) {
						if (+data_obj.id_user_from === my_id && data_obj.dateadd === timer_dt) {
							m_diff = (+data_obj.time || 0) * 3600;
						}
					} else if (data.delete) {
						if (+data_obj.id_user_from === my_id && data_obj.dateadd === timer_dt) {
							m_diff = -((+data_obj.time || 0) * 3600);
						}
					} else if (data.update || data.date || data.user || data.shift) {
						const before = data_obj.before || {};
						const cur_is_my = +data_obj.id_user_from === my_id;
						const before_is_my = 'id_user_from' in before ? (+before.id_user_from === my_id) : cur_is_my;

						const cur_dt_match = data_obj.dateadd === timer_dt;
						const before_dt_match = 'dateadd' in before ? (before.dateadd === timer_dt) : cur_dt_match;

						const cur_time = (+data_obj.time || 0) * 3600;
						const before_time = (('time' in before ? +before.time : +data_obj.time) || 0) * 3600;

						// Віднімаємо попередній стан, якщо він належав поточному таймеру
						if (before_is_my && before_dt_match) {
							m_diff -= before_time;
						}
						// Додаємо новий стан, якщо він належить поточному таймеру
						if (cur_is_my && cur_dt_match) {
							m_diff += cur_time;
						}
					}

					if (m_diff !== 0) {
						self.data.timer.manual_time = Math.max(0, (self.data.timer.manual_time || 0) + m_diff);
					}
				}

				sync_data(App.timer.data);
			});

			App.bus.state.on('task_schedule_update', function (payload) {
				const id_task = payload.id, data_obj = payload.data;
				if (id_task !== self.data.timer.id_task) return;
				if (!data_obj || !Array.isArray(data_obj)) return;
				data_obj.forEach(_data_obj => {
					if (App.timer.data.timer.dt !== _data_obj.dt) return;
					if (App.me.id !== _data_obj.id_user_to) return;
					if (!self?.data?.timer) return;
					self.data.timer.plan_time = Math.max(0, (self.data.timer.plan_time || 0) + _data_obj.diff);
					self.set_data(App.timer.data);
				});
			});
		},

		onLogout: function () {
			self.enabled = self.only_work_time = self.skip_update = false;
			self.time_round = 0;
			self.data = null;
			self.status = NO_TIMER;
			self.id_task = 0;
			self.url = null;
			if (self.obj) self.obj.remove();
			self.obj = null;
			App.team_timers.data = {};
			App.team_timers.task_data = {};
			App.team_timers.ids_user = [];
			App.helper.cron.remove('timer_tick');
		}
	};
})();

;var App = App || {};

class TimerViewDrag {
	constructor(root) {
		this.root = root; // root = посилання на головний компонент (App.timer_view|App.timer_view_modal)
	}

	init(o) {
		const self = this.root;

		const is_plan = self.obj_window.attr('data-type') === 'plan';
		const options = {
			clone: true,
			opacity: 1,
			target: is_plan ? '.timerList__dropPlace' : '.timerView__wrapper',
			tolerance: is_plan ? 'none' : 'pointer',
			start: this.onstart.bind(this),
			end: this.onend.bind(this),
			move: is_plan ? this.find_nearest_target.bind(this) : null,
			drop: this.ondrop.bind(this),
			over: function (o, t) {
				t.addClass('drag_over');
			},
			out: function (o, t) {
				t.removeClass('drag_over');
			},
			before_start: this.before_start.bind(this),
			autoscroll: true,
			target_self: false,
			renewTarget: is_plan,
			force: true
		}
		this.init_drop_places();
		o.dragable(options);
		this.enable(self.is_shown() && self.obj_wrapper.hasClass('top-layer'));
	}

	enable(is_enabled) {
		const self = this.root;

		is_enabled = Boolean(is_enabled && self.obj_window.data('allow-edit'));
		$('body').toggleClass('withTimerView__drag-enabled', is_enabled);
	}

	init_drop_places () {
		const self = this.root;

		if (self.obj_window.attr('data-type') !== 'plan') return;
		self.obj_window.find('.timerList__dropPlace').remove();
		let max_mo = 0;
		let o = self.obj_window.find('.timerList__item').each(function () {
			$(this).before('<div class="timerList__dropPlace" data-order="' + $(this).attr('data-order') + '"></div>');
			max_mo = 1 * $(this).attr('data-order');
		});
		if (o.length) o.last().after('<div class="timerList__dropPlace" data-order="' + (max_mo + 1) + '"></div>');
		else self.obj_window.find('.timerList__itemAdd').before('<div class="timerList__dropPlace" data-order="' + (max_mo + 1) + '"></div>');
	}

	before_start (o, e) {
		const self = this.root;

		return self.is_shown() && $('body').hasClass('withTimerView__drag-enabled') && $(e.target).closest('ws-btn, a').length === 0;
	}

	ondrop (o, target) {
		const self = this.root;

		App.state.drag.stop();
		o.elem.removeClass('sidePanel__list__item-dragThis');

		const taskView_item = self.obj_window.find('.sidePanel__list__item-task[data-task=' + o.elem.attr('data-task') + ']').not('.drag_clone'); // prevent drag removed element
		// якщо це не сортування в timer_view, то заборона на дроп дубля
		if (taskView_item.length && !self.obj_window.find(o.elem).length) {
			self.obj_window.setActiveEl(taskView_item, 'timerList__item-primary');
			self.rememberHeight();
			taskView_item.scrollIntoViewIfNeeded({ offset_block: 24 }).animate_css('head-shake');
			return;
		}

		if (self.obj_window.attr('data-type') !== 'plan') {
			target.removeClass('drag_over');
			App.modal.show({
				url: App.helper.url.add_query(App.helper.url.task(o.elem.attr('data-task')), self.obj_window.attr('data-fact-action')),
				title: '',
				group: 'time_add'
			});
		} else if (o.elem.hasClass('timerList__item')) {
			o.elem.insertAfter(target);
			$.ajax({url: App.helper.url.add_query(App.helper.endpoint.primary(), self.obj_window.attr('data-drag-action') + '&id=' + o.elem.attr('data-id') + '&order=' + target.attr('data-order'))});
			this.init_drop_places();
		} else {
			$.getScript(App.helper.url.add_query(App.helper.url.task(o.elem.attr('data-task')), self.obj_window.attr('data-plan-action') + '&is_on=1&order=' + target.attr('data-order')), () => self.reload())
		}
	}

	onstart (o, event) {
		const self = this.root;

		App.state.drag.start();
		o.originalElem.addClass('sidePanel__list__item-dragThis');
		let is_exists = self.obj_window.find('.sidePanel__list__item-task[data-task=' + o.elem.attr('data-task') + ']').not('.drag_clone').length; // prevent drag removed element
		let attr = !is_exists ? 'data-drag-text' : 'data-drag-exists-text';
		let btn_classname = !is_exists ? 'btn btn-24 btn-b btn-fill' : 'btn btn-24 btn-w btn-fill';
		o.elem.toggleClass('drag_not_allowed', Boolean(is_exists));
		o.elem.find('.r').replaceWith('<ws-btn name="'+btn_classname+'" text="' + App.helper.html.encode(self.obj_window.attr(attr)) + '" right-icon="arrows/arrow-right"></ws-btn>');
		this.find_nearest_target(o, event);
	}

	onend (o, event) {
		const self = this.root;

		$('.drag_over').removeClass('drag_over');
		o.elem.removeClass('sidePanel__list__item-dragThis');
		App.state.drag.stop();
		o.target.removeClass('timerList__dropPlace-hover');
	}

	find_nearest_target (o, event) {
		const self = this.root;

		if (self.obj_window.attr('data-type') !== 'plan') return;

		o.target.removeClass('timerList__dropPlace-hover');

		let i_min = -1;
		let min_distance = 9999;
		let oy = event?.clientY ?? o.top + o.originalElem.outerHeight()/2;

		for (let i = 0; i < o.targetMatrix.length; i++) {
			const t = o.targetMatrix[i];

			if (o.left < t.x1 - 360 || o.left > t.x2 + 100) continue;

			const distance = Math.abs((t.y1 + (t.y2 - t.y1)/2) - oy);
			if (distance > min_distance) continue;

			min_distance = distance;
			i_min = i;
		}

		if (i_min !== -1) {
			o.currentTarget = $(o.targetMatrix[i_min].t);
			o.currentTarget.addClass('timerList__dropPlace-hover');
		} else {
			o.currentTarget = null;
		}
	}
}

class TimerViewModalDrag extends TimerViewDrag {
	enable(is_enabled) {
		// skip for modal
	}

	before_start(o, e) {
		const self = this.root;
		return self.is_shown() && $(e.target).closest('ws-btn, a').length === 0;
	}
}

class TimerView {
	constructor() {
		this.shown = false;
		this.url = '';
		this.obj_wrapper = null;
		this.obj_window = null;
		this.obj_listing = null;
		this.obj_menus = null;
		this.window = null;
		this.type = 'panel';
		this.debug = false;
		this.allow_empty_comment = true; // for future purposes
		this.load_request = null;
		this.max_height = null;

		this.timepicker_settings = {
			forceRoundTime: true,
			minTime: '00:15',
			maxTime: '08:00',
			minWorkTime: '00:15',
			maxWorkTime: '08:00',
			step: '15',
			timeFormat: 'H:i',
			orientation: 'c',
		};

		this.state_snapshot = null;
		this._hold_timer = null;

		this.drag = new TimerViewDrag(this);
	}

	shouldFixHeight() {
		return !App.device.is_mobile();
	}

	rememberHeight() {
		if (!this.shouldFixHeight()) return;
		const height = this.obj_window.height();
		this.max_height = Math.max(this.max_height || 0, height);
		this.obj_window.css('min-height', this.max_height);
	}

	resetHeight() {
		if (!this.shouldFixHeight()) return;
		this.max_height = null;
		this.obj_window?.css('min-height', '');
	}

	is_shown() {
		const self = this;
		return self.shown;
	}

	show(skip_cache, params) {
		const self = this;
		if (self.debug) console.trace('timer_view', 'show', { skip_cache, params: {...params} });
		if (!App.windows.before_open(self.window, {skip_cache, params})) return;

		params ||= {};
		params['type'] = self.type;
		if (App.device.is_mobile()) {
			App.timer_view_modal.show(skip_cache, params);
			return;
		}
		if (!skip_cache && self.is_shown()) {
			self.window?.alreadyOpened();
			return false;
		}

		const {
			start_loading,
			stop_loading,
			...queryParams
		} = params;

		self.window?.opening();
		let url = App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('menu_timer:show') + '&' + $.param(queryParams));
		skip_cache ||= (url !== self.url);
		self.url = url;
		let cache_data = App.timer_view_cache.pop();
		if (cache_data && !skip_cache) {
			self.shown = true;
			self.obj_wrapper.html('').append(cache_data.obj_window).append(cache_data.obj_menus);
			self.rememberHeight();
			self.animate_show();
			self.window?.opened();

			// "swap" buttons v2
			self.obj_window.find('.timerView__head .minimize').toggleClass('ws-utility-hidden', App.task_panel.item.exists(self));
		} else {
			self.window?.loading();
			self.load_request.ajax({
				url,
				before_start: function () {
					if (typeof start_loading === 'function') start_loading();
					else if (self.obj_window) self.obj_window.addClass('timerView--loading');
				}
			}).then(html => {
				if (params.invalid) self.save_state_snapshot();
				if (cache_data) App.timer_view_cache.delete();

				self.shown = true;
				self.obj_wrapper.html(html);
				self.animate_show();
				self.obj_menus = self.obj_wrapper.find('.menu').not('.menu-level2').appendTo('#timerView__wrapper');
				self.obj_window = self.obj_wrapper.find('.timerView');
				self.obj_listing = self.obj_window.find('.timerView__content');
				if (params.invalid) self.restore_state_snapshot();
				self.rememberHeight();
				self.init();
				App.timer_view_cache.push(self);
				App.timer.init();
				self.window?.opened();

				// "swap" buttons v2
				self.obj_window.find('.timerView__head .minimize').toggleClass('ws-utility-hidden', App.task_panel.item.exists(self));
			}).finally(function () {
				if (typeof stop_loading === 'function') stop_loading();
				if (self.load_request.is_idle()) {
					if (self.obj_window) self.obj_window.removeClass('timerView--loading');
				}
			});
		}
	}

	save_state_snapshot() {
		const self = this;
		if (!self.is_shown()) return;

		const snapshot = {};

		const primary = self.obj_window.find('.timerList__item-primary');
		if (primary.length) {
			const id = primary.attr('data-uniq-id');
			if (id) snapshot.id_primary = id;

			const focused = document.activeElement;
			if (focused && self.obj_window.has(focused).length) {
				snapshot.focus = true;
			}

			const textarea = primary.find('textarea');
			if (textarea.length) {
				snapshot.value = textarea.val();

				const domTextarea = textarea[0];
				snapshot.selectionStart = domTextarea.selectionStart;
				snapshot.selectionEnd = domTextarea.selectionEnd;
				snapshot.selectionDirection = domTextarea.selectionDirection;
			}
		}

		snapshot.scroll_position = self.obj_window.find('.scrollZone').first().scrollTop();
		self.state_snapshot = snapshot;
	}

	restore_state_snapshot() {
		const self = this;
		try {
			if (!self.is_shown()) return;
			if (!self.state_snapshot) return;

			const s = self.state_snapshot;

			if (s.id_primary) {
				const item = self.obj_window
					.find('.timerList__item[data-uniq-id="' + s.id_primary + '"]');

				if (item.length) {
					self.obj_window.setActiveEl(item, 'timerList__item-primary');

					const textarea = item.find('textarea');
					if (textarea.length) {
						if (s.focus) {
							textarea.focus();

							if (textarea.val() !== s.value) {
								textarea.val(s.value).attr('data-dirty', '1');
							}

							const domTextarea = textarea[0];
							if (typeof s.selectionStart === 'number' && typeof s.selectionEnd === 'number') {
								domTextarea.setSelectionRange(
									s.selectionStart,
									s.selectionEnd,
									s.selectionDirection || 'none'
								);
							}
						}
					}
				}
			}

			if (typeof s.scroll_position === 'number') {
				self.obj_window.find('.scrollZone').first().scrollTop(s.scroll_position);
			}
		} finally {
			self.state_snapshot = null;
		}
	}

	reload() {
		const self = this;
		self.show(true, {
			dt: self.obj_window.attr('data-day'),
			id_user_to: self.obj_window.attr('data-user'),
			plan: self.obj_window.attr('data-type') === 'plan' ? 1 : 0
		});
	}

	hide() {
		const self = this;
		if (App.timer.status === TIMER_ACTIVE || App.timer.data.costs.norm || App.task_panel.item.exists(self)) {
			self.minimize();
		} else {
			self.delete();
			App.object_state.update('timer', 0, {update: null}, MY_DIRECT_ACTION);
		}
	}

	delete() {
		const self = this;
		self.window?.closing();
		self.load_request.abort();
		App.timer_view_cache.delete();
		self.window?.closed();
		self.shown = false;
		self.resetHeight();
		self.remove();
	}

	animate_show() {
		const self = this;
		$('body').addClass('withTimerView');
		if (App.device.is_mobile()) {
			$('body').addClass('mobileTimerView');
		} else {
			self.obj_wrapper.addClass('timerView__wrapper-active');
		}
	}

	animate_hide(callback) {
		const self = this;
		$('body').removeClass('withTimerView');
		if (App.device.is_mobile()) {
			$('body').removeClass('mobileTimerView');
			callback();
		} else {
			self.obj_wrapper.removeClass('timerView__wrapper-active');
			setTimeout(function () {
				callback.call(self);
			}, 300);
		}
	}

	minimize() {
		const self = this;
		self.shown = false;
		self.window?.minimizing();
		if (self.obj_window) self.obj_window.find('.'+$.datepicker.markerClassName).datepicker('hide');
		self.load_request.abort();
		self.animate_hide(function () {
			self.resetHeight();
			self.window?.closed();
			self.detach();
		});
	}

	detach() {
		const self = this;
		self.obj_window.detach();
		self.obj_menus.detach();
	}

	remove() {
		const self = this;
		$('body').removeClass('withTimerView');
		$('body').removeClass('mobileTimerView');
		self.obj_wrapper.removeClass('timerView__wrapper-active');
		self.destroy_scroll_zones();
		self.obj_window.removeWithComponents();
		self.obj_menus.removeWithComponents();
	}

	init() {
		const self = this;

		// self.obj_window.find('.timerList__item').each(function(){
		//  let id_item = $(this).attr('data-task');
		//  if (self.obj_window.find('.timerList__item[data-task='+id_item+']').length === 1) {
		//      $(this).find('.costs-fromTimer').css({'display': 'flex'});
		//  } else {
		//      $(this).find('.costs-fromTimer').css({'display': 'none'});
		//  }
		// });

		App.ui.onMouse(self.obj_window, '.timerList__item', {
			onBefore(e) {
				e.data.id_task = $(e.el).attr('data-task').toInt();
				e.data.id_user = self.obj_window.attr('data-user');
				if (e.closest('label')) e.cancel = true;
			},
			open: (e) => App.core.new_window(App.helper.url.task(e.data.id_task)),
			click: (e) => {
				if ($(e.target).closest('.link').length) {
					App.controls.task_schedule_menu.show(e.target, e.data.id_task, {
						id_user: e.data.id_user,
					});
				} else if($(e.target).closest('[onclick], ws-btn, a, .timepicker').length === 0) {
					self.obj_window.setActiveEl(e.el, 'timerList__item-primary');
					$(e.el).scrollIntoViewIfNeeded({ offset_top: 12, offset_bottom: 24 });
					self.rememberHeight();
				}
			},
			context: (e) => App.controls.task_menu.show(e.target, App.helper.url.task(e.data.id_task)),
		});

		const save_textarea = App.helper.debounce(function (el, url) {
			if (self.shown) $(el).prev().showAndHide(333);
			App.core.async_task.ajax(url);
		}, 150);

		self.obj_window.on('blur', 'textarea', function () {
			let el = this;
			if ($(this).attr('data-dirty') !== '1') return;

			$(el).attr('data-dirty', null);
			save_textarea(el, $(el).attr('data-endpoint') + '&field=name&value=' + encodeURIComponent($(el).val()));
		});
		self.obj_window.on('keydown', 'textarea', function () {
			$(this).attr('data-dirty', '1');
		});

		App.ui.onMouse(self.obj_window, '.timer_buttons', {
			onBefore(e) {
				e.data.textarea = $(e.el).closest('.timerList__item').find('textarea');
				e.data.pause = e.closest('.pause');
				e.data.timer = e.closest('.timer');
				e.data.stop = e.closest('ws-btn[data-action=stop_delete]');
			},
			click: (e) => {
				save_textarea.clear();
				if (e.data.pause) {
					App.timer.start($(e.data.pause).attr('data-url'), { name: $(e.data.textarea).val() });
				} else if (e.data.timer && !self.allow_empty_comment && !$(e.data.textarea).val()) {
					$(e.data.timer).shakeRight(2, 3, 300);
					$(e.data.textarea).shortblink();
				} else if (e.data.timer) {
					$.getScript($(e.data.timer).attr('data-endpoint') + '&name=' + encodeURIComponent(e.data.textarea.val()));
				} else if (e.data.stop) {
					$.getScript($(e.data.stop).attr('data-endpoint'), () => self.reload());
				}
			},
		});

		/** Repeat plan */
		let repeat_plan_loading = false;
		self.obj_wrapper.find('[data-action=repeat_plan]').click(function() {
			const start_loading = () => {
				self.obj_window.removeClass('timerView--loading');
				if ($(this).hasClass('timerList__itemGoto')) $(this).find('button').first().ws_loading('start');
				else $(this).ws_loading('start');
			};
			const stop_loading = () => {
				if ($(this).hasClass('timerList__itemGoto')) $(this).find('button').first().ws_loading('stop');
				else $(this).ws_loading('stop');
			};

			if (repeat_plan_loading) return;
			start_loading();
			repeat_plan_loading = true;
			$.getScript($(this).attr('data-endpoint'), () => {
				stop_loading();
				self.reload();
			});
		});

		/** Day select */
		self.obj_wrapper.find('button[data-action=date], .timerList__itemGoto[data-action=date]').click(function() {
			self.show(true, {
				dt: $(this).attr('data-day'),
				id_user_to: self.obj_window.attr('data-user'),
				plan: self.obj_window.attr('data-type') === 'plan' ? 1 : 0,
				start_loading: () => {
					self.obj_window.removeClass('timerView--loading');
					if ($(this).hasClass('timerList__itemGoto')) $(this).find('button').first().ws_loading('start');
					else $(this).ws_loading('start');
				},
				stop_loading: () => {
					if ($(this).hasClass('timerList__itemGoto')) $(this).find('button').first().ws_loading('stop');
					else $(this).ws_loading('stop');
				}
			});
		});

		const dates = new Set(self.obj_window.data('dates'));

		self.obj_wrapper.find('input[data-container=date]').datepicker({
			rangeSelect: false,
			hideUnselectableDays: true,
			numberOfMonths: 1,
			monthPicker: true,
			maxDate: self.obj_window.attr('data-max-date') ? new Date(self.obj_window.attr('data-max-date')) : null,
			firstDay: App.datepicker_firstDay,
			onSelect: function (dateText, inst) {
				self.show(true, {
					dt: dateText,
					id_user_to: self.obj_window.attr('data-user'),
					plan: self.obj_window.attr('data-type') === 'plan' ? 1 : 0
				});
			},
			beforeShowDay: function (date) {
				const ts = date.getTime();
				if (dates.size && ts < self.obj_window.data('today-dt') && !dates.has(date.getTime())) {
					let override_class = '';
					let override_title = '';
					let override_weekend = '';
					let override_available = false;
					return [override_available, override_class, override_title, override_weekend];
				}
				if (App.controls.datepicker.config.disable_holidays) {
					return App.controls.datepicker.helper_disable_holidays(date);
				}
				return App.controls.datepicker.helper_draw_holidays(date);
			}
		});

		/** Choose task and add costs or schedule */
		self.obj_window.find('.timerList__itemAdd, [data-action="add_fact"], [data-action="add_plan"]').click(function() {
			let anchor = $(this);
			App.controls.task_select_and_go.show_context(this, $(this).attr('data-endpoint'), {
				request: {
					type: anchor.attr('data-action') === 'add_fact' ? 'costs' : 'schedule',
				},
				onload: function () {
					let menu = $(this);
					menu.on('click', '.menu__item[data-id]', function () {
						if (anchor.attr('data-action') === 'add_fact') App.modal.show({
							url: App.helper.url.add_query($(this).attr('data-url'), self.obj_window.attr('data-fact-action')),
							backup: true,
							title: '',
							group: 'time_add'
						});
						else $.getScript(App.helper.url.add_query($(this).attr('data-url'), self.obj_window.attr('data-plan-action') + '&is_on=1&'))
						App.menu.hide();
					});
				},
				onshow: function () {
					let menu = $(this);
					App.context_search.menu.apply('', menu, {callback: App.controls.task_select_and_go.draw_tree.bind(menu)});
				},
				on_project_change: function () {
				},
				on_server_search: function () {
				}
			});
		});

		/** Plan - fact switch (by tabs) */
		self.init_tabs();

		/** Plan - fact switch */
		self.obj_window.find('.timerList__buttons ws-slider').on('mousedown', 'a', function() {
			if (!$(this).hasClass('act')) self.show(true, {
				dt: self.obj_window.attr('data-day'),
				id_user_to: self.obj_window.attr('data-user'),
				plan: $(this).attr('data-value')
			})
		});
		self.obj_window.find('.timerList__buttons ws-btn').on('click', function() {
			self.show(true, {
				dt: $(this).attr('data-day') || self.obj_window.attr('data-day'),
				id_user_to: self.obj_window.attr('data-user'),
				plan: 0
			})
		});

		/** Plus-minus-delete buttons switch */
		const stopHold = () => {
			if (self._hold_timer) {
				clearInterval(self._hold_timer);
				self._hold_timer = null;
			}
		};

		self.obj_window.find('.timerList__item ws-btn')
			.on('mousedown touchstart', function (e) {
				let o = $(this).closest('.timerList__item');
				let action = $(this).attr('data-action');

				if (action === 'minus' || action === 'plus') {
					let is_shift = e.shiftKey;
					let inc_value = action === 'minus' ? (is_shift ? -1 : -0.25) : (is_shift ? 1 : 0.25);

					self.task_plan_time_inc(o, inc_value);
					let tick = 1;

					stopHold();
					self._hold_timer = setInterval(() => {
						tick++;
						// Мікро-пауза після першого кліку, далі "біжимо"
						if (tick > 1 && tick < 7) return;
						self.task_plan_time_inc(o, inc_value);
					}, 100);
				}
			})
			.on('mouseup mouseleave touchend', stopHold)
			.on('click', function (e) {
				let o = $(this).closest('.timerList__item');

				if ($(this).attr('data-action') === 'delete') {
					if (o.is('[data-task]')) {
						const update = () => {
							o.remove();
							self.update_schedule();
						};

						if ($(this).attr('data-endpoint')) {
							$.getScript($(this).attr('data-endpoint'), () => update());
						} else {
							$.getScript(App.helper.url.add_query(App.helper.url.task(o.attr('data-task')), self.obj_window.attr('data-plan-action') + '&is_on=0'), () => update());
						}

						o.animate_css('breathe', { infinite: true });
					}
				}
			});

		if (self.obj_window.hasClass('timerView-withDrag')) self.drag.init(self.obj_window.find('.timerList__item'));
		if (App.mymenu.is_shown()) self.drag.init(App.mymenu.obj_window.find('.sidePanel__list__item[data-task]'));
		if (App.current_page.where.indexOf('dashboard') !== -1) self.drag.init($('.dashboard__block').find('.sidePanel__list__item[data-task]'));

		self.obj_window.find('.timerList__item .time span.timepicker').each(function () {
			$(this).timepicker(self.timepicker_settings).bind('change', () => self.onChangeTime($(this).prev(), $(this).data('ui-timepicker-value')))
		}); // init

		self.obj_window.find('.timerList__item .time span.timepicker').each(function(){
			$(this).bind('click', function(){
				$(this).timepicker(self.timepicker_settings);
			});
		});

		/** Choose task and add costs or schedule */
		self.obj_wrapper.find('.other_task').click(function() {
			let anchor = $(this);
			App.controls.task_select_and_go.show_context(this, $(this).attr('data-endpoint'), {
				request: {
					type: 'schedule',
				},
				onload: function () {
					let menu = $(this);
					menu.on('click', '.menu__item[data-id]', function () {
						App.modal.show({
							url: App.helper.url.add_query($(this).attr('data-url'), self.obj_window.attr('data-action')),
							replace: true,
						});
						App.menu.hide();
					});
				},
				onshow: function () {
					let menu = $(this);
					App.context_search.menu.apply('', menu, {callback: App.controls.task_select_and_go.draw_tree.bind(menu)});
				},
				on_project_change: function () {
				},
				on_server_search: function () {
				}
			});
		});

		App.fatforms.init({obj: self.obj_window});
		self.init_scroll_zones();
	}

	init_tabs() {
		const self = this;
		self.obj_window.find('.timerView__tabs li[data-type]').on('click', function() {
			self.obj_window.find('.timerView__tabs').find('li[data-type].active').removeClass('active');
			$(this).addClass('active');

			if (self.obj_window.attr('data-type') === $(this).attr('data-type') && !self.obj_window.data('dirty')) {
				self.load_request.abort();
				return false;
			}

			self.show(true, {
				dt: $(this).attr('data-day') ?? self.obj_window.attr('data-day'),
				id_user_to: self.obj_window.attr('data-user'),
				plan: $(this).attr('data-type') === 'plan' ? 1 : 0,
			});
		});
	}

	init_scroll_zones() {
		const self = this;
		self.obj_window.find('.scrollZone').not('.ps').each(function() {
			this.scrollBars = App.controls.js_scrollbars.init(this);
		});
	}

	destroy_scroll_zones() {
		const self = this;
		self.obj_window.find('.scrollZone').each(function() {
			if (this.scrollBars) this.scrollBars.destroy();
		});
	}

	onChangeTime(inp, val) {
		if (val.includes(':')) {
			let timeparts = val.split(':');
			let h = parseInt(timeparts[0]);
			let m = parseInt(timeparts[1]);
			if (m > 0) m = m / 60;

			inp.val(h + m + 0.25);

			this.task_plan_time_inc(inp.closest('.timerList__item'), -0.25);
		}
	}

	task_plan_time_inc(o, value) {
		const self = this;
		let min_time = 0.25, max_time = 24;

		self.obj_wrapper.find('.timerList__item').each(function() {
			if (this !== o.get(0)) max_time -= +$(this).find('input').val();
		});
		if (!self.obj_window.is("[data-day]")) min_time = 0;
		if (max_time < min_time) max_time = min_time;

		let val = (1 * o.find('input').val()) + value;
		if (val < min_time) val = min_time;
		if (val > max_time) val = max_time;

		o.find('.time input').val(val)
		o.find('.time span').html(App.format.time(60 * val));

		o.closest('.listing__card').trigger('internal.counter');

		self.update_schedule();

		if (o.is('[data-task]')) {
			App.core.call_queue.add('update_schedule' + o.attr('data-task'), function() {
				let action = o.closest('.timerView').attr('data-plan-action');
				$.getScript(App.helper.url.add_query(App.helper.url.task(o.attr('data-task')), action + '&is_on=1&time=' + val))
			}, this, null, 1);
		} else if (o.is('[data-dt]')) {
			App.core.call_queue.add('update_schedule' + o.attr('data-dt'), function() {
				let action = o.closest('.timerView').attr('data-action');
				$.getScript(App.helper.url.add_query(App.helper.url.task(o.closest('.timerView').attr('data-task')), action + '&dt='+o.attr('data-dt')+'&is_on=1&time=' + val))
			}, this, null, 1);
			o.find('progress-pie').attr('real', val + +o.attr('data-time-other'));
		}
	}

	update_schedule() {
		const self = this;
		let total_time = 0;
		self.obj_wrapper.find('.timerList__item').each(function() {
			total_time += +$(this).find('input').val();
		});
		self.obj_wrapper.find('progress-bar2').attr('real', total_time);
		self.obj_wrapper.find('.sum span').html(App.format.time(60 * total_time, true));
	}

	invalidate_window(payload = null) {
		const self = this;
		if (!self.is_shown()) {
			App.timer_view_cache.delete();
			return;
		}

		const current_data = {
			user: self.obj_window.data('user'),
			type: self.obj_window.data('type'),
			dt: self.obj_window.data('dt'),
			day: self.obj_window.data('day'),
		};

		payload = {
			...current_data,
			...payload,
		};

		if (
			current_data.user == payload.user
			&& current_data.type == payload.type
			&& current_data.dt == payload.dt
			&& current_data.day == payload.day
		) {
			self.obj_window.data('dirty', true);
			const params = {
				dt: current_data.day,
				id_user_to: current_data.user,
				plan: current_data.type === 'plan' ? 1 : 0,
				invalid: true,
			};
			self.show(true, params);
		}
	}

	helper_schedule_add(id_task, data) {
		if (data.id_user_to === App.me.id) {
			// TODO може треба намалювати баджик навіть якщо відкрите вікно, але за інший день?
			let btn = $('#taskPanel').find('.taskPanel__item-costs, .taskPanel__item-timer');
			if (btn.length) {
				let badge = btn.find('.badge');
				let dataIds = badge.attr('data-ids') || '';

				let ids = dataIds ? dataIds.split(',') : [];
				if (!ids.includes(id_task)) ids.push(id_task);
				ids = [...new Set(ids.filter(id => id))];

				if (ids.length>0) badge.attr('data-ids', ids.join(',')).html('+' + ids.length);
			}
		}
	}

	onload() {
		const self = this;
		self.obj_wrapper = $('#timerView__wrapper');
		self.obj_listing = $('<div />').detach();
	}

	destructor() {
		const self = this;
		self.load_request.abort();
		if (self._hold_timer) {
			clearInterval(self._hold_timer);
			self._hold_timer = null;
		}
		self.resetHeight();
		if (self.is_shown()) {
			self.remove();
		}
		self.obj_wrapper?.removeWithComponents();
		self.shown = false;
		self.window?.closed();
		self.obj_window = null;
		self.obj_wrapper = null;
		self.obj_menus = null;
		self.obj_listing = null;
		self.state_snapshot = null;
		self.url = '';
	}

	onStateTask() {
		const self = this;
		App.bus.state.on('task_done', function ({ id: id_task }) {
			if (!self.obj_window) return;
			const items = self.obj_window.find(`.timerList__item[data-task="${id_task}"]`);
			items.addClass('completed');
		}).on('task_undone', function ({ id: id_task }) {
			if (!self.obj_window) return;
			const items = self.obj_window.find(`.timerList__item[data-task="${id_task}"]`);
			items.removeClass('completed');
		}).on('task_delete', function ({ id: id_task }) {
			if (!self.obj_window) return;
			const items = self.obj_window.find(`.timerList__item[data-task="${id_task}"]`);
			items.remove();
			self.update_schedule();
		});
	}

	onBoot() {
		const self = this;
		self.window = App.window.timer_view.bind(self);
		self.load_request = App.core.async_task.context('timer_view_load');

		App.bus.app.on('left_panel_ready mymenu_onsearch', function() {
			if (self.obj_window && App.mymenu.is_shown()) {
				self.drag.init(App.mymenu.obj_window.find('.sidePanel__list__item[data-task]'));
			}
		});

		App.bus.app.on('block_mounted', function (event, data) {
			if (self.obj_window) {
				self.drag.init($(data.block).find('.sidePanel__list__item[data-task]'));
			}
		});

		App.bus.app.on('window_signal', function (event) {
			// наступний тік, бо спочатку має оновитися стан top-layer
			App.helper.nextTick(() => {
				self.drag.enable(self.is_shown() && self.obj_wrapper.hasClass('top-layer'));
			});
		});

		const invalidate_all_windows = function (list, id_user, dt) {
			list.forEach(({ type, windows }) => {
				self.helper_invalidate_windows(type, id_user, dt, windows);
			});
		};

		App.bus.state.on('task_costs', function (payload) {
			let data = payload.data;
			let data_obj = data.add || data.update || data.delete || data.shift || data.user || data.date;

			if (data_obj && !data.shift) {
				invalidate_all_windows([
					{ type: 'fact' },
					{ type: 'plan', windows: { mymenu: false } },
				], data_obj.id_user_from, data_obj.dateadd);
			}
		}).on('task_timers', function (payload) {
			let data = payload.data;
			let data_obj = data.add || data.delete;

			if (data_obj) {
				invalidate_all_windows([
					{ type: 'fact' },
					{ type: 'plan', windows: { mymenu: false } },
				], data_obj.id_user_from, App.timer.data.costs.dt);
			}
		}).on('timer_update', function (payload) {
			let data = payload.data;
			invalidate_all_windows([
				{ type: 'fact' },
				{ type: 'plan', windows: { mymenu: false } },
			], App.me.id, data?.costs.dt);
		}).on('task_schedule_update', function (payload, context) {
			let data_obj = payload.data;
			if (!data_obj || !Array.isArray(data_obj)) return;
			data_obj.forEach(_data_obj => {
				invalidate_all_windows([
					{ type: 'fact', windows: { mymenu: false } },
					{ type: 'plan' },
				], _data_obj.id_user_to, _data_obj.dt);
				if (!context.active_tab) {
					self.helper_schedule_add(payload.id, _data_obj);
				}
			});
		}).on('user_work_hrs', function (payload, context) {
			let id_user = payload.id;
			let data_obj = payload.data;
			invalidate_all_windows([
				{ type: 'fact' },
				{ type: 'plan' },
			], id_user);
		});

		self.onStateTask();
	}

	onLogin() {
		const self = this;
		self.onload();
	}

	onLogout() {
		const self = this;
		self.destructor();
	}

	// ! не треба дебаунсити, це вбиває інвалідацію вікон
	helper_invalidate_windows(type, id_user, dt, windows) {
		const self = this;
		windows = {
			timer_view: true,
			timer_view_modal: true,
			mymenu: true,
			...windows,
		};

		if (windows.timer_view) {
			App.timer_view.invalidate_window({
				type,
				user: id_user,
				...(dt !== undefined ? { dt } : {}),
			});
		}

		if (windows.timer_view_modal) {
			App.timer_view_modal.invalidate_window({
				type,
				dt,
				user: id_user,
				...(dt !== undefined ? { dt } : {}),
			});
		}

		// компоненти самі мають знати як і коли оновлювати кеш
		// треба лише вказати, що саме намагаємось оновити
		// але тимчасово залишаємо стару логіку, не хочу влазити в mymenu зараз
		if (
			windows.mymenu
			&& App.mymenu.is_shown('costs')
			&& App.mymenu.obj_window.data('type') === type
			&& (dt === undefined || dt == App.mymenu.obj_window.data('dt'))
		) {
			App.core.call_once(function() {
				App.mymenu.invalidate_window('costs');
			});
		}
	}
}

class TimerViewModal extends TimerView {
	constructor() {
		super();
		this.type = 'modal';
		this.debug = false;
		this.drag = new TimerViewModalDrag(this);
	}

	shouldFixHeight() {
		return true;
	}

	is_shown() {
		return App.modal.is_shown() && $('.modal .timerView').length;
	}

	fetch_html(params = {}) {
		params['type'] = this.type;

		const url = App.helper.url.add_query(
			App.helper.endpoint.primary(),
			App.actions.get('menu_timer:show') + '&' + $.param(params)
		);

		return this.load_request.ajax({ url });
	}

	show(skip_cache, params) {
		const self = this;
		params ||= {};

		if (App.menu.is_shown()) App.menu.hide();
		if (params.id_user_to === App.me.id && !App.device.is_mobile()) {
			App.timer_view.show(skip_cache, params);
			return;
		}

		App.modal.show({
			group: 'timerView',
			reload: self.is_shown(),
			load: () => self.fetch_html(params),
			abort: () => self.load_request.abort(),
			onload: () => {
				self.onload();
				self.rememberHeight();
			},
			onhide: () => {
				self.destructor();
			}
		});
	}

	fetch_html_old(params, onsuccess) {
		const self = this;
		params ||= {};
		params['type'] = this.type;

		const {
			start_loading,
			stop_loading,
			...queryParams
		} = params;

		const url = App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('menu_timer:show') + '&' + $.param(queryParams));

		self.load_request.ajax({
			url,
			before_start: function () {
				if (typeof start_loading === 'function') start_loading();
				else if (self.obj_wrapper) self.obj_wrapper.addClass('modal--timerViewLoading');
			}
		}).then(function (html) {
			if (onsuccess && typeof onsuccess === 'function') onsuccess(html);
		}).finally(function () {
			if (typeof stop_loading === 'function') stop_loading();
			if (self.load_request.is_idle()) {
				if (self.obj_wrapper) self.obj_window.removeClass('modal--timerViewLoading');
			}
		});
	}

	show_old(skip_cache, params) {
		const self = this;
		if (self.debug) console.trace('timer_view_modal', 'show', { skip_cache, params: {...params} });

		params ||= {};
		params['type'] = self.type;

		if (App.menu.is_shown()) App.menu.hide();
		if (params.id_user_to === App.me.id && !App.device.is_mobile()) {
			App.timer_view.show(skip_cache, params);
			return;
		}

		self.fetch_html(params, function (html) {
			App.modal.show({
				html: html,
				reload: true,
				group: 'timerView',
				onload: () => {
					self.onload();
					self.rememberHeight();
				},
				onhide: () => {
					self.destructor();
				}
			});
		});
	}

	init_tabs() {
		const self = this;
		self.obj_wrapper.find('.modal__header__tabs a[data-type]').on('click', function() {
			self.obj_wrapper.find('.modal__header__tabs').find('a[data-type].act').removeClass('act');
			$(this).addClass('act');

			if (self.obj_window.attr('data-type') === $(this).attr('data-type') && !self.obj_window.data('dirty')) {
				self.load_request.abort();
				return false;
			}

			self.show(true, {
				dt: $(this).attr('data-day') ?? self.obj_window.attr('data-day'),
				id_user_to: self.obj_window.attr('data-user'),
				plan: $(this).attr('data-type') === 'plan' ? 1 : 0,
			});
		});
	}

	invalidate_window(payload = null) {
		const self = this;
		if (!self.is_shown()) return;

		const current_data = {
			user: self.obj_window.data('user'),
			type: self.obj_window.data('type'),
			dt: self.obj_window.data('dt'),
			day: self.obj_window.data('day'),
		};

		payload = {
			...current_data,
			...payload,
		};

		if (
			current_data.user == payload.user
			&& current_data.type == payload.type
			&& current_data.dt == payload.dt
			&& current_data.day == payload.day
		) {
			self.obj_window.data('dirty', true);
			const params = {
				dt: current_data.day,
				id_user_to: current_data.user,
				plan: current_data.type === 'plan' ? 1 : 0,
			};
			self.fetch_html(params, function (html) {
				const modal_level = App.timer_view_modal.obj_wrapper.attr('data-num')
				App.modal.history_data[modal_level].data.html = html;
				App.modal.invalidate_history_dom_by_group('timerView');
			});
		}
	}

	onload() {
		const self = this;
		self.obj_wrapper = App.modal.obj_window;
		self.obj_window = App.modal.obj_window.find('.timerView');
		self.obj_listing = $('<div />').detach();
		self.init();
		App.timer.init();
	}

	destructor() {
		const self = this;
		self.obj_window?.find('.'+$.datepicker.markerClassName)?.datepicker('hide');
		self.obj_window?.find('.'+$.datepicker.markerClassName)?.datepicker('destroy');
		self.load_request.abort();
		if (self._hold_timer) {
			clearInterval(self._hold_timer);
			self._hold_timer = null;
		}
		self.resetHeight();
		self.shown = false;
		self.window?.closed();
		self.obj_window = null;
		self.obj_wrapper = null;
		self.obj_menus = null;
		self.obj_listing = null;
		self.url = '';
	}

	onBoot() {
		const self = this;
		self.load_request = App.core.async_task.context('timer_view_modal_load');
		self.onStateTask();
	}
	onLogin() {
		// skip for modal
	}
}

App.timer_view = new TimerView();
App.timer_view_modal = new TimerViewModal();

App.timer_view_cache = {
	data: null,

	exists: function() {
		return !!this.data
	},

	pop: function() {
		return this.data;
	},

	delete: function() {
		if (this.data) {
			this.data.obj_window.find('.'+$.datepicker.markerClassName).datepicker('hide');
			this.data.obj_window.find('.'+$.datepicker.markerClassName).datepicker('destroy');
			this.data.obj_window.removeWithComponents();
			this.data.obj_menus.removeWithComponents();
			this.data = null;
		}
	},

	push: function(self) {
		this.data = {
			obj_window: self.obj_window,
			obj_menus: self.obj_menus,
			id: self.id,
			title: self.title,
			state: 'open',
			dt_added: new Date()
		}
	},

	destructor: function() {
		if (this.exists()) this.delete();
	}
}

;var App = App || {};

App.upload = {
	enabled: false,
	droppable: false,
	init: function (o) {
		o.once_by_criteria('drop_events').each(function () {
			if (typeof (window.FileReader) == 'undefined') {
				o.find('span.droplink').remove();
				return false;
			}
			$(this).unbind('drop').bind('dragenter', function (e) {
			}).bind('dragover', function (e) {
				$(this).addClass('drop-hover');
				return false;
			}).bind('dragleave', function (e) {
				$(this).removeClass('drop-hover');
			}).bind('drop', function (e) {
				event = e.originalEvent;
				event.preventDefault();
				let file = event.dataTransfer.files;
				if (this.id == 'dz-logo') {
					if (file.length > 0) {
						for (let i = 0; i < file.length; i++) App.upload.logo.xhr(file[i], this);
					}
				} else {
					App.upload.attach.await_upload_zone_and_run(function() {
						for (let i = 0; i < file.length; i++) App.upload.attach.xhr(file[i]);
					});
				}
				$(this).removeClass('drop-hover');
				$('.drop-zone').removeClass('drop-zhover');
				$('body').removeClass('withFileDrag');
				return false;
			});
			$('.drop_zone').bind('click', function () {
				$('.drop-hover').removeClass('drop-hover');
				$('body').removeClass('withFileDrag');
			});
		});
	},

	attach: {
		target: null,
		count: 0,

		set_active_window: function (target) {
			this.target = target;
		},

		prepare_html: function (target_window, options) {
			options ||= {};
			this.set_active_window(target_window);

			$('[data-virtualattach]').remove(); // clear old
			const $input = $('<input type="file" multiple="true" style="display: none;" data-virtualattach />');

			$('body').append($input); // append to body (trying to fix IOS issue #8323658)

			$input.one('change', function () {
				App.upload.attach.start.call(this, options.onstart);
				App.helper.nextTick(() => $input.remove());
			});
			$input.trigger('click');
		},

		toggle_inline_view: function (id, on) {
			let url = '';
			$('.fileItem').filter('[data-id=' + id + ']').find('.sw_pre').toggleClass('sw_act', on).each(function () {
				url = $(this).attr('data-url');
			});
			$('.inline_clip').filter('[data-id=' + id + ']').find('.sw_pre').toggleClass('sw_act', on);
			if (url) {

				let show_loader = true;
				let loader_timer = setTimeout(function () {
					if (show_loader) {
						$('.fileItem').filter('[data-id=' + id + ']').find('.sw_pre').addClass('sw_loading');
						$('.inline_clip').filter('[data-id=' + id + ']').find('.sw_pre').addClass('sw_loading');
					}
				}, 100);

				$.ajax({
					'url': url + '&is_on=' + (on ? 1 : 0),
					error: App.core.create_jq_ajax_error(function(xhr) {
						$('.fileItem').filter('[data-id=' + id + ']').find('.sw_pre').toggleClass('sw_act', !on);
						$('.inline_clip').filter('[data-id=' + id + ']').find('.sw_pre').toggleClass('sw_act', !on);
					}),
					complete: function () {

						show_loader = false;
						clearTimeout(loader_timer);

						$('.fileItem').filter('[data-id=' + id + ']').find('.sw_pre').removeClass('sw_loading');
						$('.inline_clip').filter('[data-id=' + id + ']').find('.sw_pre').removeClass('sw_loading');
					},
				});
			} else {
				setTimeout(function () {
					$('.fileItem').filter('[data-id=' + id + ']').toggleClass('inline_hid', on).parent().parent().each(function () {
						$(this).toggleClass('inline_hid', $(this).find('.fileItem').not('.inline_hid').length === 0);
					});
					$('.inline_clip').filter('[data-id=' + id + ']').toggleClass('inline_vis', on).find('.img_html').each(function () {
						$(this).replaceWith('<img src="' + $(this).attr('data-src') + '" width="' + $(this).attr('data-width') + '" height="' + $(this).attr('data-height') + '" style="' + $(this).attr('data-style') + '">');
					});
				}, 500);
			}
		},

		toggle_inline_figma_preview: function ($self, is_on) {
			const url = $self.data('url');
			const $preview = $self.closest('.figma-preview');
			const id_task_data = $preview.data('id-task-data');
			const id_task = $preview.data('id-task');
			const figma_hash = $preview.data('figma-hash');
			const id_comment = $preview.data('id-comment');

			if (is_on) {
				$self.addClass('sw_act');
			} else {
				$self.removeClass('sw_act').closest('.figma-preview').addClass('inline_hid');
			}

			$.ajax({
				url: url,
				type: 'POST',
				data: {id_task_data, id_task, figma_hash, id_comment, is_on: (is_on ? 1 : 0)},
				dataType: 'json',
				success: function (response) {
					if (response.success) {
						if (is_on) {
							$self.closest('.figma-preview').addClass('inline_hid');
							const $iframePreview = $self.closest('.text, .taskView__group__content ').find('.figma-preview.figma-preview__inline').filter('[data-figma-hash=' + figma_hash + ']')
							const figma_link = 'https://www.figma.com/embed?embed_host=astra&url=' + $iframePreview.data('figma-link');
							$iframePreview.removeClass('inline_hid').addClass('inline_vis').find('.iframe-place').html('<iframe style="width: 100%" height="400" src="' + figma_link + '" frameborder="0" allowfullscreen></iframe>');
							$iframePreview.find('.sw_pre').addClass('sw_act');
						} else {
							$self.closest('.figma-preview').addClass('inline_hid').removeClass('inline_vis').find('.iframe-place').html('');
							const $inlinePreview = $self.closest('.text, .taskView__group__content ').find('.figma-preview.figma-preview__closed').filter('[data-figma-hash=' + figma_hash + ']');
							$inlinePreview.removeClass('inline_hid').removeClass('inline_vis').find('.sw_pre').removeClass('sw_act');
						}

						const $listContainer = $self.closest('.text, .taskView__group__content ').find('#files_new');
						if ($listContainer.find('.fileItem').not('.inline_hid').length > 0) {
							$listContainer.removeClass('inline_hid')
						} else {
							$listContainer.addClass('inline_hid')
						}
					}
				}
			})
		},

		delete: function(el, id_tmp) {
			let o = $(el).parents('form');
			$(el).parents('.fileItem__wrapper, .fileItem').remove();
			App.upload.attach.update_counter();
			o.trigger('update');
			if (id_tmp) $.ajax(App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('file_draft:delete_file') + '&id=' + id_tmp));
		},

		delete_before_save: function (el) {
			App.draft.show_draft_exists(true);
			let o = $(el).parents('.fileItem__wrapper, .fileItem');
			o.toggleClass('fileItem-preDeleted');
			o.find('input[name*=delete]').val(o.hasClass('fileItem-preDeleted') ? 1 : 0);
		},

		pin: function (el) {
			let el_icon = $(el).find('ws-icon') ?? $(el);
			let on = el_icon.is('[name=thumbnail-on]') ? 0 : 1;

			if (on) {
				el_icon.attr('name', 'thumbnail-on');
			} else {
				el_icon.attr('name', 'thumbnail');
			}

			$.getScript($(el).attr('data-url') + '&id_file=' + $(el).attr('data-id') + '&is_on=' + (on ? 1 : 0));
		},

		pin_before_save: function (el) {
			let on = $(el).hasClass('pin_act') ? 0 : 1;
			let p = App.upload.attach.get_zone();
			p.find('.pin_act').removeClass('pin_act').closest('.fileItem').find('input[name*=pin]').val(0)
			$(el).toggleClass('pin_act', !!on).closest('.fileItem').find('input[name*=pin]').val(on);
			$.getScript($(el).attr('data-url') + '&id_file=' + $(el).attr('data-id') + '&is_on=' + (on ? 1 : 0));
		},

		edit_before_save: function (el) {

			if (App.upload.file_edit_upgrade) {
				App.modal.show(App.upload.file_edit_upgrade);
				return;
			}

			let on = $(el).hasClass('sw_act') ? 0 : 1;
			$(el).toggleClass('sw_act', !!on).closest('.fileItem').find('input[name*=edit]').val(on);
		},

		update_counter: function (skip_resize) {
			if (App.comment_form?.is_shown()) App.comment_form.update_file_counter(skip_resize);
			if (App.editor) App.editor.onresize();
		},

		waiting_upload_zone: false,
		await_upload_zone_and_run(callback, context) {
			let obj = this;
			if (obj.waiting_upload_zone) {
				setTimeout(function() {
					obj.await_upload_zone_and_run(callback, context);
				}, 50);
				return false;
			}

			let win = obj.target || App.core.active_window();
			if (win.is('main')) {
				obj.target = null;
				obj.waiting_upload_zone = true;
				App.file_create.new('id_project=' + App.current_page.project, function() {
					obj.waiting_upload_zone = false;
					callback.call(context);
				});
				return false;
			}
			obj.waiting_upload_zone = false;
			callback.call(context);
		},

		start: function (callback) {
			App.upload.attach.await_upload_zone_and_run(function() {
				if (typeof callback === 'function') callback();
				if (typeof (window.FileReader) != 'undefined' && this.files) {
					for (let i = 0; i < this.files.length; i++) App.upload.attach.xhr(this.files[i]);
					$(this).toggleDisabled(true);
					return false;
				}
			}, this);
		},

		xhr: function (file, zone) {
			let ext_arr = file.name.split('.');
			let p = App.upload.attach.get_zone();

			if (file.size > (file.slice ? App.config.upload_max_size : App.config.upload_max_default)) {
				let template_params = {
					id: App.upload.attach.count,
					name: file.name,
					ext: ext_arr[ext_arr.length - 1].toLowerCase()
				};
				p.append(App.helper.template.fill('file_item_error', template_params));
				return false;
			}
			if (!App.modal.is_shown()) App.anchor.scroll_to('#edit_comment');
			App.upload.queue.add(++App.upload.attach.count, file);
			let template_params = {
				id: App.upload.attach.count,
				name: file.name,
				ext: ext_arr[ext_arr.length - 1].toLowerCase()
			};
			p.append(App.helper.template.fill('file_item', template_params));
			// p.parents('form').trigger('update');
			App.upload.attach.update_counter();
			App.upload.queue.start();
		},

		get_zone: function(skip_modal) {
			return App.core.active_window({skip_modal, skip_modal_preview: true}).find('.attachWrapper');
		},

		helper_file_create(txt) {
			App.upload.attach.await_upload_zone_and_run(function() {
				App.upload.attach.get_zone().append(txt);
				$('.do_focus').removeClass('do_focus').focus();
				App.upload.attach.update_counter();
			});
		}
	},

	google_drive: {
		upload: function(data, token, share) {
			App.menu.hide(true);
			data.forEach(function (file) {
				let ext_arr = file.name.split('.');
				let p = App.upload.attach.get_zone();
				file.google_drive = {token, share};
				App.upload.queue.add(++App.upload.attach.count, file);
				let template_params = {
					id: App.upload.attach.count,
					name: file.name,
					ext: ext_arr[ext_arr.length - 1].toLowerCase()
				};
				p.append(App.helper.template.fill('file_item', template_params));
				// p.parents('form').trigger('update');
				App.upload.attach.update_counter();
				App.upload.queue.start();
			});
		}
	},

	queue: {
		data: [],
		current: null, // one of data
		current_formdata: null,
		active: false,
		retry: false,
		count: 0,

		add: function (num, file) {
			if (file.google_drive) {
				App.upload.queue.data.push({
					action: 'google_drive',
					num,
					file
				});
				App.upload.queue.count++;
			}	else if (file.slice && file.size > 2 * App.config['upload_chunk_size']) {
				let rand = 10000 + Math.floor(90000 * Math.random());
				for (let start = 0; start < file.size; start += App.config['upload_chunk_size']) {
					App.upload.queue.data.push({
						action: 'chunk',
						num,
						rand,
						start,
						file
					});
					App.upload.queue.count++;
				}
			} else {
				App.upload.queue.data.push({
					action: 'upload',
					num,
					file
				});
				App.upload.queue.count++;
			}
			$('body').addClass('mouse_v2');
		},

		process: function () {
			let xhr = new XMLHttpRequest();
			// xhr.upload.addEventListener('loadstart',function() {});
			xhr.upload.addEventListener("progress", function (e) {
				let pc;
				if (App.upload.queue.current.action == 'chunk') {
					pc = parseInt((App.upload.queue.current.start + e.loaded) / App.upload.queue.current.file.size * 100);
				} else {
					pc = parseInt(e.loaded / e.total * 100);
				}
				$('#attach' + App.upload.queue.current.num + ' .ext i').html(pc + "%");
				$('#attach' + App.upload.queue.current.num + ' .sm_prog').css({width: (100 - pc) + "%"});
			}, false);
			xhr.onreadystatechange = function () {
				if (xhr.readyState !== 4) return;
				let p = $('#attach' + App.upload.queue.current.num);
				let form = p.parents('form');
				if (xhr.status !== 200) {
					if (App.upload.queue.retry == 0) {
						App.upload.queue.retry = 1;
						App.upload.queue.process();
					} else {
						p.remove();
					}
				} else if (xhr.responseText) {
					p.replaceWith(App.core.asset_rewrite_path_in_body(xhr.responseText)).trigger('change');
				}
				form.trigger('update');
				App.upload.queue.count--;
				if (App.upload.queue.count < 1) $('body').removeClass('mouse_v2');
				App.upload.queue.active = false;
				App.upload.queue.start();
			};
			xhr.open('POST', App.core.base() + App.helper.endpoint.primary(), true);
			App.helper.xhr.set_headers(xhr);
			xhr.send(App.upload.queue.current_formdata);
		},

		start: function () {
			if (App.upload.queue.active) return false;
			if (App.upload.queue.data.length === 0) return false;
			App.upload.queue.active = true;
			App.upload.queue.current = App.upload.queue.data.shift();
			if (!$('#attach' + App.upload.queue.current.num).length) {
				App.upload.queue.count--;
				App.upload.queue.start();
				return false;
			}
			let form_data = new FormData;
			if (App.upload.queue.current.action === 'google_drive') {
				form_data.append('action', 'file_upload_googledrive:show');
				form_data.append('file', JSON.stringify(App.upload.queue.current.file));
			} else if (App.upload.queue.current.action === 'chunk') {
				form_data.append('action', 'file_upload_chunk:show');
				form_data.append('file_name', App.upload.queue.current.file.fileName || App.upload.queue.current.file.name);
				form_data.append('file_type', App.upload.queue.current.file.type);
				form_data.append('file_size', App.upload.queue.current.file.size);
				form_data.append('rand', App.upload.queue.current.rand);
				form_data.append('chunk_size', App.config['upload_chunk_size']);
				form_data.append('chunk_start', App.upload.queue.current.start);
				form_data.append("chunk", App.upload.queue.current.file.slice(App.upload.queue.current.start, App.upload.queue.current.start + App.config['upload_chunk_size']));
			} else {
				form_data.append('action', 'file_upload_temp:show');
				form_data.append("ufile[]", App.upload.queue.current.file);
			}
			form_data.append('mda', App.actions.default_hash);
			App.upload.queue.retry = 0;
			App.upload.queue.current_formdata = form_data;
			App.upload.queue.process();
		},

	},

	clipboard: {
		start: function (file, file_name) {
			App.draft.show_draft_exists(true);
			App.upload.attach.count++;
			let form_data = new FormData;
			form_data.append('action', 'file_upload_temp:show');
			form_data.append('mda', App.actions.default_hash);
			form_data.append("ufile[]", file);
			form_data.append("ufile_name[]", file_name);
			let xhr = new XMLHttpRequest();
			xhr.number = App.upload.attach.count;
			xhr.upload.addEventListener('loadstart', function () {
				let ext_arr = file_name.split('.');
				let p = App.upload.attach.get_zone();
				let template_params = {
					id: App.upload.attach.count,
					name: file_name,
					ext: ext_arr[ext_arr.length - 1].toLowerCase()
				};
				p.append(App.helper.template.fill('file_item', template_params));
				p.parents('form').trigger('update');
				App.upload.attach.update_counter()
			});
			xhr.onreadystatechange = function () {
				if (xhr.readyState !== 4) return
				$('#attach' + xhr.number).replaceWith(App.core.asset_rewrite_path_in_body(xhr.responseText));
				App.upload.queue.count--;
				if (App.upload.queue.count < 1) $('body').removeClass('mouse_v2');
			};
			App.upload.queue.count++;
			$('body').addClass('mouse_v2');
			xhr.open('POST', App.core.base() + App.helper.endpoint.primary(), true);
			App.helper.xhr.set_headers(xhr);
			xhr.send(form_data);
		}
	},

	logo: {
		start: function (input) {
			if (typeof (window.FileReader) != 'undefined' && input.files && input.files.length && /image/i.test(input.files[0].type)) {
				App.upload.logo.xhr(input.form);
				$('#logo_reset').show();
				$('.logo_vis').addClass('loaded');
				return false;
			}
		},

		xhr: function (form) {
			let fd = new FormData(form);
			let xhr = new XMLHttpRequest();
			xhr.upload.addEventListener('loadstart', function () {
				$('#dz-logo .logo_vis .inputBlock__logo-image').html(App.config.loader_html);
			});
			xhr.onreadystatechange = function () {
				if (xhr.readyState !== 4) return;
				$('#dz-logo .logo_vis .inputBlock__logo-image').html(App.core.asset_rewrite_path_in_body(xhr.responseText));
				if ($('#dz-logo .logo_vis .in .sizealert').length) $('#logosize').blink();
			};
			xhr.open('POST', App.core.base() + $(form).attr('action'), true);
			App.helper.xhr.set_headers(xhr);
			xhr.send(fd);
		},
	},

	company_logo: {
		start: function (input) {
			if (typeof (window.FileReader) != 'undefined' && input.files && input.files.length && /image/i.test(input.files[0].type)) {
				App.upload.company_logo.xhr(input.form);
				$(input).toggleDisabled(true);
				return false;
			}
		},

		xhr: function (form) {
			let fd = new FormData(form);
			let xhr = new XMLHttpRequest();
			xhr.upload.addEventListener('loadstart', function () {
				$('.logo_pre').find('.logo_vis .in').html('<span class=loader_sm></span>');
			});
			xhr.onreadystatechange = function () {
				if (xhr.readyState !== 4) return;
				$('.logo_pre .logo_vis .in').html(App.core.asset_rewrite_path_in_body(xhr.responseText));
				$('#companyLogoForm .logo_input').val('');
				$(form).next().addClass('form_active').find('.button_dis').removeClass('button_dis').toggleDisabled(false);
			};
			xhr.open('POST', App.core.base() + $(form).attr('action'), true);
			App.helper.xhr.set_headers(xhr);
			xhr.send(fd);
		},
	},

	avatar: {
		start: function (input) {
			if (typeof (window.FileReader) != 'undefined' && input.files && input.files.length && /image/i.test(input.files[0].type)) {
				$(input).toggleDisabled(true);
				App.upload.avatar.xhr(input.form);
				$(input).toggleDisabled(false);
				return false;
			}
		},

		xhr: function (form) {
			let fd = new FormData(form);
			if (!fd.has('photo') && $(form).find('input[type=file]').prop('files').length) fd.append('photo', $(form).find('input[type=file]').prop('files')[0]);
			let xhr = new XMLHttpRequest();
			xhr.upload.addEventListener('loadstart', function () {
			});
			xhr.onreadystatechange = function () {
				if (xhr.readyState !== 4) return;
				let ct = xhr.getResponseHeader("Content-type") || '';
				if (ct === 'application/json') return;
				if (ct.includes('javascript')) { App.helper.eval_string(xhr.responseText); App.bus.app.emit('avatar_apply'); return; }
				$('#userpic').html(App.core.asset_rewrite_path_in_body(xhr.responseText));
			};
			xhr.open('POST', App.core.base() + $(form).attr('action'), true);
			App.helper.xhr.set_headers(xhr);
			xhr.send(fd);
		},
	},

	vcard: {
		start: function (input) {
			if (typeof (window.FileReader) != 'undefined' && input.files && input.files.length) {
				App.upload.vcard.xhr(input.form);
				return false;
			}
		},

		xhr: function (form) {
			let fd = new FormData(form);
			let xhr = new XMLHttpRequest();
			xhr.upload.addEventListener('loadstart', function () {
				$('#af_vcard').remove();
			});
			xhr.onreadystatechange = function () {
				if (xhr.readyState !== 4) return;
				if ($(form).find('input[name=vcard2]').length) {
					App.invite.contacts.add_html(App.core.asset_rewrite_path_in_body(xhr.responseText));
					$('.loadingimg').remove();
				} else {
					App.invite.emails.add_html(App.core.asset_rewrite_path_in_body(xhr.responseText));
					$('.loadingimg').remove();
					// App.invite.init(); // ніби не треба, бо тоді дублюються обробники, адже ініціалізація є при завантаженні модалки
					App.invite.update_counter();
				}
			};
			xhr.open('POST', App.core.base() + $(form).attr('action'), true);
			App.helper.xhr.set_headers(xhr);
			xhr.send(fd);
		},
	},

	import_tasks: {
		start: function() {
			let btnDiv = $('.import_btn'),
				error = $('.error_sm');
			if (App.forms.validate_form(document.modfrm, validation)) {
				let datastring = new FormData(document.modfrm);
				btnDiv.attr('data-html', btnDiv.html());
				btnDiv.html(App.config.loader_html);

				$.ajax({
					type: "POST",
					url: $(document.modfrm).attr('action'),
					data: datastring,
					dataType: 'html',
					cache: false,
					contentType: false,
					processData: false,
					success: function (response) {
						try {
							let json = JSON.parse(response);
							btnDiv.html(btnDiv.attr('data-html'));
							$('#ufile').val('');
							error.show();
							error.html('<span class="ico ico_r ico_alert_sm"></span>' + json.message);
						} catch (e) {
							App.modal.obj_window.find('.modal__content').html(response);
							App.modal.init();
							App.modal.width = 1100;
							App.modal.height = 550;
						}
					}
				});
			}
			return false;
		}
	},

	init_items: function () {
		$('.fileItem input[type=file]').bind('change', App.upload.attach.start);
	},

	timeout: null,
	init_drop: function () {
		const self = this;

		if (!self.enabled) return;

		if ($('#fixed_container_common .drop_zone_body').length === 0) {
			$('#fixed_container_common').append(App.helper.template.fill('drop_zone'));
		}

		self.init($('.drop_zone_body'));

		if (typeof (window.FileReader) != 'undefined') $(document).bind('dragstart', function () {
			window.skip_dragupload = 1;
		}).bind('dragend', function () {
			window.skip_dragupload = 0;
		}).bind('dragenter', function (e) {
			if (window.skip_dragupload) return false;

			const is_main_window = App.core.active_window().is('main');
			const drop_zone = App.upload.attach.get_zone();

			if (is_main_window && !self.droppable) {
				return false;
			} else if (!is_main_window && drop_zone.length === 0) {
				return false;
			}

			$('.drop-zone').addClass('drop-zhover');
			$('body').addClass('withFileDrag');
			setTimeout(function () {
				if (App.upload.timeout) clearTimeout(App.upload.timeout);
			}, 1);
			return false;
		}).bind('dragleave', function (e) {
			if (App.upload.timeout) clearTimeout(App.upload.timeout);
			App.upload.timeout = setTimeout(function () {
				$('.drop-zone').removeClass('drop-zhover');
				$('body').removeClass('withFileDrag');
			}, 20);
			return false;
		}).bind('dragover', function (e) {
			let dt = e.originalEvent.dataTransfer;
			dt.dropEffect = 'none';
			return false;
		});
		$('.drop_zone').bind('click', function () {
			$('.drop-hover').removeClass('drop-hover');
			$('body').removeClass('withFileDrag');
		});
	},

	onload: function () {
		this.init_items();
		this.init_drop();
		if (!App.device.is_mobile()) {
			this.init($('#dz-logo'));
		}
		this.attach.update_counter();
	},

	onBoot: function () {

		const get_scope_toggle_inline_view = function (id_task) {
			const task_view_cache = App.task_view.is_show_by_id(id_task) ? null : App.task_view_cache.pop_by_id(id_task);
			const task_view_obj_window = task_view_cache?.obj_window ?? $();
			const $scope = $('body').add(task_view_obj_window);

			return $scope;
		};

		const toggle_inline_view = function (id_task, id, on) {

			const $scope = get_scope_toggle_inline_view(id_task);

			$scope.find('.fileItem').filter('[data-id=' + id + ']').find('.sw_pre').toggleClass('sw_act', on);
			$scope.find('.inline_clip').filter('[data-id=' + id + ']').find('.sw_pre').toggleClass('sw_act', on);

			if (App.task_view.is_show_by_id(id_task)) {
				App.task_view.scroller.scroll.preserveStart();
			}

			$scope.find('.fileItem').filter('[data-id=' + id + ']').toggleClass('inline_hid', on).parent().parent().each(function () {
				$(this).toggleClass('inline_hid', $(this).find('.fileItem').not('.inline_hid').length === 0);
			});
			$scope.find('.inline_clip').filter('[data-id=' + id + ']').toggleClass('inline_vis', on).find('.img_html').each(function () {
				$(this).replaceWith('<img src="' + $(this).attr('data-src') + '" width="' + $(this).attr('data-width') + '" height="' + $(this).attr('data-height') + '" style="' + $(this).attr('data-style') + '">');
			});
			if (App.task_view.is_show_by_id(id_task)) {
				App.task_view.scroller.scroll.update();
				App.task_view.scroller.scroll.preserveEnd();
			}
		};

		const ask_toggle_inline_view = function (id_task, id, on) {

			const $scope = get_scope_toggle_inline_view(id_task);
			const fileItem = $scope.find('.fileItem').filter('[data-id=' + id + ']');
			const inlineClip = $scope.find('.inline_clip').filter('[data-id=' + id + ']');
			const container = on ? fileItem : inlineClip;

			App.controls.loader.ask_reload.hide($().add(fileItem).add(inlineClip));

			if (on && inlineClip.hasClass('inline_vis')) return; // already shown
			if (!on && !fileItem.hasClass('inline_hid')) return; // already hidden

			App.controls.loader.ask_reload.show(container, {
				onclick: () => {
					toggle_inline_view(id_task, id, on);
				},
			});
		};

		App.bus.iframe.on('gd.file', function (data, ctx) {
			App.upload.google_drive.upload(data, ctx.token, ctx.share);
		});
		App.bus.app.on('modal_load', function () {
			if (App.modal.obj_window.find('.modal__content #dz-left').length) App.upload.init(App.modal.obj_window);
		}).on('task_view_ready', function () {
			if (App.task_view.obj_window.find('.drop_zone_body').length) App.upload.init(App.task_view.obj_window);
		});
		App.bus.state.on('file_pin', function (payload, context) {
			const id_file = payload.id;
			const data_obj = payload.data;
			if (!data_obj) return;
			const aPins = $(`.fileItem a.pin[data-id=${id_file}]`);
			aPins.toggleClass('pin_act', data_obj.is_pin);
		});
		App.bus.state.on('file_preview', function (payload, context) {
			// if (context.active_tab) return;
			const id_file = payload.id;
			const data_obj = payload.data;
			if (!data_obj) return;
			const { is_preview } = data_obj;

			const id_task = data_obj.id_subtask || data_obj.id_task;
			if (!id_task) throw new Error('Expected `id_task`');

			if (context.active_tab || !App.task_view.is_show_by_id(id_task)) {
				toggle_inline_view(id_task, id_file, is_preview);
			} else {
				// якщо задача відкрита, то не міняємо вид, щоб не смикався скрол
				ask_toggle_inline_view(id_task, id_file, is_preview);
			}
		});
		App.bus.app.on('task_view_ready', function ({ target }, context) {
			App.controls.loader.ask_reload.exec(target.obj_window.find('[data-ask-reload]'));
		});
	},
	onLogin: () => App.upload.onload(),
	onLoadPage: () => App.upload.onload(),
};

;var App = App || {};

(function () {
    let next_id = 1;
    let self = App.windows = {
        debug: false,
        states: {
            OPENING: WIN_ST_OPENING,
            LOADING: WIN_ST_LOADING, // deprecated,
            LOADED: WIN_ST_LOADED, // deprecated,
            LOAD_FAILED: WIN_ST_LOAD_FAILED, // deprecated,
            OPENED: WIN_ST_OPENED,
            CLOSING: WIN_ST_CLOSING,
            MINIMIZING: WIN_ST_MINIMIZING,
            CLOSED: WIN_ST_CLOSED,
            ALREADY_OPENED: WIN_ST_ALREADY_OPENED, // deprecated, use READY instead
			READY: WIN_ST_READY,
			UNREADY: WIN_ST_UNREADY,
        },
        state: new Map(),
        pending: [],
        opened: [],
        ready: [],
        last_opened: null,
        last_closed: null,
        last_replace: null,
        listeners: [],
        init: function () {},
        listen: function (handler) {
            if (typeof handler !== 'function') return;

            self.listeners.push(handler);
            return () => {
                self.listeners = self.listeners.filter(i => i !== handler);
            }
        },
        get: function (window_key) { return self.state.get(window_key); },
        get_component: function (window_key) { return self.get(window_key)?.target; },
        is_opened: function (window_key) { return self.opened.includes(window_key); },
        is_ready: function (window_key) { return self.ready.includes(window_key); },
        is_last_opened: function (window_key) { return self.is_opened(window_key) && self.opened[0] === window_key; },
        last_state: function (window_key) {
            let el = self.get(window_key);
            return el?.last_event?.state;
        },
        has_opened: function () { return self.opened.length > 0; },
        has_pending: function () { return self.pending.length > 0; },
        open: function (window_key, ...params) {
            let el = self.get(window_key);
            if (el == null || el.target.show == null) return false;
            if (el.last_event?.state === self.states.CLOSING || el.last_event?.state === self.states.OPENING || el.last_event?.state === self.states.LOADING) return false;

            return el.target.show.apply(el.target, params || []) !== false;
        },
        remember: function (window_key) {
            let el = self.get(window_key);
            if (el == null || el.target.remember == null || !self.is_opened(window_key)) return false;

            return el.target.remember();
        },
        replace: function (window_key, ...params) {
            let el = self.get(window_key);
            if (el == null || el.target.show == null) return false;

            if (self.is_opened(window_key) && self.last_replace == null) {
                self.last_replace = { key: window_key, params: self.remember(window_key) };
            }

            return self.open(window_key, ...params);
        },
        reopen_last: function (allowed_age_seconds) {
            allowed_age_seconds ||= 5;
            if (self.last_closed == null || self.last_closed.params === false || self.is_opened(self.last_closed.key)) return false;
            if (self.last_closed.ts + allowed_age_seconds*1000 < Date.now()) return false;

            self.open(self.last_closed.key, ...self.last_closed.params);

            return true;
        },
        minimize: function (window_key, ...params) {
            window_key = window_key || self.opened[0]
            if (window_key == null) return false;

            let el = self.get(window_key);
            if (el == null || el.target.minimize == null || !self.is_opened(window_key)) return false;

            return el.target.minimize.apply(el.target, params || []) !== false;
        },
        reset: function (window_key, reason) {
            let el = self.get(window_key);
            if (el == null) return false;
            if (el.last_event !== self.states.LOADING) return false;

            el.last_event = null;

            return true;
        },
        close: function (window_key, ...params) {
            window_key = window_key || self.opened[0]
            if (window_key == null) return false;

            let el = self.get(window_key);
            if (el == null || el.target.hide == null || !self.is_opened(window_key)) return false;

            return el.target.hide.apply(el.target, params || []) !== false;
        },
        emit: function (window_key, state, payload) {
            let window = self.get(window_key);
            if (window == null) return false;

			if (self.debug) console.log('emit', window_key, state, payload);

            window.last_event = { state: state, payload: payload };

            if (state === self.states.CLOSING) {
                self.last_closed = { key: window_key, params: self.remember(window_key), ts: Date.now() };
            }

            if (state === self.states.OPENED) {
				self.opened = self.opened.filter(i => i !== window_key);
                self.opened.unshift(window_key);
            } else if (state === self.states.CLOSED) {
                self.opened = self.opened.filter(i => i !== window_key);
            }

            if (state === self.states.READY) {
                self.ready.unshift(window_key);
            } else if (state === self.states.UNREADY) {
                self.ready = self.ready.filter(i => i !== window_key);
            }

			// deprecated:
            if (state === self.states.OPENING || state === self.states.LOADING) {
                self.pending.unshift(window_key);
            } else {
                self.pending = self.pending.filter(i => i !== window_key);
            }

            for (let el of self.state.values()) {
                if (el.id === window.id) continue;

                if (typeof el.listener === 'function' && self.is_opened(el.key)) {
                    el.listener({ state: state, key: window_key, target: window.target, payload: payload });
                }
            }

            App.bus.app.emit('window_signal', { state: state, key: window_key, target: window.target, payload: payload });
            let event = null;
            switch (state) {
                case self.states.OPENING: event = 'opening'; break;
                case self.states.OPENED: event = 'opened'; break;
                case self.states.READY: event = 'ready'; break;
                case self.states.UNREADY: event = 'unready'; break;
                case self.states.CLOSED: event = 'closed'; break;
                case self.states.LOADED: event = 'loaded'; break; // deprecated
            }
            if (event) App.bus.app.emit(window_key+'_'+event, { target: window.target, payload: payload });

            self.listeners.forEach(function (listener) {
                listener({ state: state, key: window_key, target: window.target, payload: payload });
            });
        },
        bind: function (window_key, controller) {
            if (self.state.has(window_key)) throw new Error('already registered');
            self.state.set(window_key, { target: controller, last_event: null, key: window_key, id: next_id++ })
        },
        createEmitter: function (window_key) {
            return {
                key: window_key,
                opening: (payload) => {
					if (self.is_ready(window_key)) self.emit(window_key, self.states.UNREADY);
					self.emit(window_key, self.states.OPENING, payload);
				},
				ready: (payload) => self.emit(window_key, self.states.READY, payload),
                unready: (payload) => self.emit(window_key, self.states.UNREADY, payload),
                opened: (payload) => {

                    if (self.last_state(window_key) === self.states.LOADING) { // TODO: remove it!
                        self.emit(window_key, self.states.LOADED, payload);
                    }

					self.emit(window_key, self.states.OPENED, payload);
                },
                closing: (payload) => {
					if (self.is_ready(window_key)) self.emit(window_key, self.states.UNREADY);

					self.emit(window_key, self.states.CLOSING, payload);
				},
                minimizing: (payload) => {
					if (self.is_ready(window_key)) self.emit(window_key, self.states.UNREADY);

					self.emit(window_key, self.states.MINIMIZING, payload)
				},
                closed: (payload) => self.emit(window_key, self.states.CLOSED, payload),

				// DEPRECATED:
				loading: (payload) => self.emit(window_key, self.states.LOADING, payload),
				loadFailed: (reason) => self.emit(window_key, self.states.LOAD_FAILED, reason),
				failed: (payload) => self.emit(window_key, self.states.CLOSING, payload),
				alreadyOpened: (payload) => self.emit(window_key, self.states.ALREADY_OPENED, payload),
            };
        },
        createController: function (window_key) {
            return {
                key: window_key,
                open: (...params) => self.open(window_key, ...params),
                close: (...params) => self.close(window_key, ...params),
                minimize: (...params) => self.minimize(window_key, ...params),
                remember: () => self.remember(window_key),
                replace: (...params) => self.replace(window_key, ...params),
                is_opened: () => self.is_opened(window_key),
                is_ready: () => self.is_ready(window_key),
                is_last_opened: () => self.is_last_opened(window_key),
                state: () => self.get(window_key),
                bind: (target) => {
                    self.bind(window_key, target);

                    let instance = {
                        listen: (handler) => {
                            self.get(window_key).listener = handler;
                            return instance;
                        },
                        is_opened: () => self.is_opened(window_key),
						is_ready: () => self.is_ready(window_key),
                        ...self.createEmitter(window_key),
                    };

                    return instance;
                },
            }
        },
        args: function (...params) {
            return params || [];
        },
        onLogout: function () {
            self.last_opened = self.last_closed = self.last_replace = null;
        },
        onBoot: function () {
            window.addEventListener('mouseup', function (event) {

                let focus_window_key = null;
                Object.keys(App.window).forEach((window_key) => {
                    if (focus_window_key != null || App.window[window_key] == null || !App.window[window_key].is_opened()) return;

                    const state = self.get(window_key);
                    if (state.target?.obj_window == null) return;

                    if ($(state.target.obj_window).get(0).contains(event.target)) {
                        focus_window_key = window_key;
                    }
                });

                if (focus_window_key) self.helper_set_focus(focus_window_key);

            }, true);

            App.bus.app.on('window_signal', function (e) {
                if (e.state === App.windows.states.ALREADY_OPENED) {
                    self.helper_set_focus(e.key);
                }
            });
        },
        helper_set_focus: function (window_key) {
            if (self.is_opened(window_key) && self.opened[0] !== window_key) {
                self.opened = [window_key, ...self.opened.filter(i => i !== window_key)];
                App.bus.app.emit('window_focus', { key: window_key, target: self.get(window_key).target });
            }
        },

		before_open: function(window, params) {
			if (self.debug) console.trace('before_open', window, params);

			return !App.offline_mode.is_on();
		}
    };

    App.window = {};
    App.window.task_view = self.createController('task_view');
    App.window.chat_view = self.createController('chat_view');
    App.window.timer_view = self.createController('timer_view');
    App.window.task_create = self.createController('task_create');
    App.window.file_create = self.createController('file_create');
    App.window.notebook = self.createController('notebook');
    App.window.left_panel = self.createController('left_panel');
    App.window.right_panel = self.createController('right_panel');
    App.window.queue = self.createController('queue');
	App.window.modal = self.createController('modal');
	App.window.dashboard_view = self.createController('dashboard_view');

})();

;var App = App || {};

(function () {
	let self = App.work_time = {
		state: false,
		set_state: function (state) {
			if (self.state === state) return;
			self.state = state;
			App.bus.app.emit('work_time', self.state);
		}
	};
})();

;var App = App || {}

App.workspace = {

	detached_dom: {},
	is_dom_detached: false,
	logged_in: false,
	tm_blocking_state: null,

	clear_state: function() {
		if (App.hybrid_app) App.hybrid_app.clear_all();

		App.actions.default_hash = '';
		App.actions.unregister('workspace');
		App.core.theme.custom = false;
		App.core.theme.dark = false;
		App.workspace.logged_in = false;
		App.helper.template.clear_cache();

		App.core.theme.hybrid_app();
		$('meta[name="theme-color"]').attr('content', '#ffffff');

		App.workspace.detached_dom = {};
	},

	restore_auth_form: function() {
		let main = $('main').html('');

		if (App.workspace.is_dom_detached) {
			App.workspace.is_dom_detached = false;
			$('#fixed_container').html('').append(App.workspace.detached_dom['fixed_container']);
			$('#sidebar__wrapper').html('').append(App.workspace.detached_dom['sidebar__wrapper']);
			$('#adminMenu__wrapper').html('');
			$('#primaryMenu__wrapper').html('').append(App.workspace.detached_dom['primaryMenu__wrapper']);
			$('#mobileMenu__wrapper').html('').append(App.workspace.detached_dom['mobileMenu__wrapper']);
			if (App.workspace.detached_dom['auth']) main.append(App.workspace.detached_dom['auth']);
		}
	},

	logout: function(start_tab, callback) {
		App.core.lifecycle.logout();

		App.workspace.restore_auth_form();
		App.workspace.clear_state();
		App.workspace.show_auth_form(start_tab || 'login', null, callback);
	},

	fake_logout: function(start_tab, callback) {
		App.core.lifecycle.logout();

		App.workspace.logged_in = false;
		App.workspace.restore_auth_form();
		App.workspace.show_auth_form(start_tab || 'login', null, callback);
	},

	login: function() {
		App.workspace.logged_in = true;

		$.ajax({
			url: '/ajax/?' + App.actions.get('workspace_config:show'),
			success: function(html) {
				if (App.hybrid_app) {
					$('#auth form').find('input[type=password], input[type=text]').val('');
					$('#blockingState').remove();
				} else {
					$('#auth, #blockingState').remove();
				}

				App.workspace.is_dom_detached = true;
				if (App.hybrid_app) App.workspace.detached_dom['auth'] = $('#auth').detach();
				App.workspace.detached_dom['fixed_container'] = $('#fixed_container').children().detach();
				App.workspace.detached_dom['sidebar__wrapper'] = $('#sidebar__wrapper').children().detach();
				App.workspace.detached_dom['primaryMenu__wrapper'] = $('#primaryMenu__wrapper').children().detach();
				App.workspace.detached_dom['mobileMenu__wrapper'] = $('#mobileMenu__wrapper').children().detach();

				$('#fixed_container').html(html);

				App.core.lifecycle.login();
			}
		});
	},

	init: function () {
		if (App.workspace.logged_in) return;

		if (App.hybrid_app && !App.hybrid_app.token) {
			App.core.lifecycle.logout();
			return;
		}

		let url = App.hybrid_app
			? '/api/user/?action=check_session'
			: App.helper.endpoint.auth() + '?' + App.actions.get('login:session');

		$.ajax({
			url: url,
			dataType: 'json',
			success: function(json) {
				if (json.status === 'ok') {
					App.actions.register({'workspace_config:show': json.action}, 'auth');
					App.workspace.login();
				} else if (App.hybrid_app && (json.status === 'secure1' || json.status === 'secure2')) {
					App.workspace.logged_in = false;
					App.core.lifecycle.logout();
					App.auth.set_tab(json.status);
				} else if (App.hybrid_app) {
					App.workspace.logged_in = false;
					App.core.lifecycle.logout();
				} else {
					App.core.lifecycle.logout();
					App.workspace.show_auth_form(App.workspace.parse_start_link() || json.status);
				}
			}
		});
	},

	parse_start_link: function() {
		if (/\/login\//.test(document.location.pathname)) {
			let params = App.helper.url.parse_query(document.location.search);

			if (params['page'] === 'invite' && App.helper.validate.md5.test(params['hash'])) {
				App.auth.register_token = params['hash'];
				App.core.history.replace('/', 'Worksection');
				return 'register_final';
			}

			if (params['page'] === 'mass_invite' && App.helper.validate.md5.test(params['hash'])) {
				App.auth.register_mass_token = params['hash'];
				App.core.history.replace('/', 'Worksection');
				return 'register';
			}

			if ((params['page'] === 'password_reset' || params['page'] === 'forgot') && App.helper.validate.md5.test(params['hash'])) {
				App.auth.forgot_token = params['hash'];
				App.core.history.replace('/', 'Worksection');
				return 'forgot_final';
			}
		}
		return '';
	},

	show_auth_form: function(status, lang, callback) {

		if (App.hybrid_app) {
			App.auth.set_tab(status || 'login');
			if (App.auth.forgot_token) {
				$('#auth .forgot_final input[name=hash]').val(App.auth.forgot_token);
				App.auth.forgot_token = '';
			}
			if (callback) setTimeout(callback, 33);
			return;
		}

		$.ajax({
			url: App.helper.endpoint.auth() + '?' + App.actions.get('login:show') + (lang ? '&lang=' + lang : ''),
			success: function(html) {
				$('main').html(html);
				App.auth.init();
				App.auth.set_tab(status || 'login');
				if (App.auth.forgot_token) {
					$('#auth .forgot_final input[name=hash]').val(App.auth.forgot_token);
					App.auth.forgot_token = '';
				}
				callback && callback();
				// додаємо загальні переклади (тільки якщо ще не встановлено)
				App.core.context.when('locale_general', function (locale_general) {
					if (!App.object_state || !$.isEmptyObject(App.object_state.locale)) return;
					App.object_state.locale = locale_general;
				});
			}
		});
	},

	secure_state: function(status) {
		if (status === 'secure2') App.message.warning(App.object_state.locale['security_login_required']);

		App.workspace.fake_logout(status);
	},

	blocking_state: function(show_action, recheck_action) {
		App.workspace.fake_logout('login', function() {
			$('#blockingState').remove();
			let blockingStateEl = $('<div id="blockingState" class="blockingState-shown"></div>');
			$('#auth').after(blockingStateEl);
			blockingStateEl.load(App.helper.url.add_query(App.helper.endpoint.auth() + '', show_action), function() {
				if (!recheck_action) return;

				App.workspace.tm_blocking_state = setInterval(function () {
					$.ajax({
						url: App.helper.url.add_query(App.helper.endpoint.auth() + '', recheck_action),
						dataType: 'json',
						success: function (data) {
							if (data.status === 'ok') {
								clearInterval(App.workspace.tm_blocking_state);
								App.workspace.tm_blocking_state = null;
								App.workspace.login();
							}
						}
					});
				}, 10000);
			});
		});
	},

	switch_to: function(url) {
		if (App.hybrid_app) {
			$.getScript(App.me.logout_url);
		} else {
			location.href = url;
		}
	},

	onBoot: function () {
		if (!App.hybrid_app) App.workspace.init();
		App.bus.msg.on('logout', () => App.workspace.logout());
	},
}
